import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** Either a number or email value */
  AppPeopleSelectionKey: { input: any; output: any }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: any; output: any }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any }
}

/** Result of updating a completion via API */
export type ApiCompletionUpdate = {
  __typename?: "APICompletionUpdate"
  completion_id?: Maybe<Scalars["Int"]["output"]>
  /** Reason, if any, for why the update was ignored. */
  ignored_reason?: Maybe<ApiCompletionUpdateIgnoredReason>
  new_path_progress?: Maybe<Scalars["Float"]["output"]>
  new_points_assigned?: Maybe<Scalars["Float"]["output"]>
  new_step_progress?: Maybe<Scalars["Float"]["output"]>
  prev_path_progress?: Maybe<Scalars["Float"]["output"]>
  prev_points_assigned?: Maybe<Scalars["Float"]["output"]>
  prev_step_progress?: Maybe<Scalars["Float"]["output"]>
  success?: Maybe<Scalars["Boolean"]["output"]>
}

export enum ApiCompletionUpdateAction {
  Complete = "complete",
  Reset = "reset",
  Skip = "skip"
}

export enum ApiCompletionUpdateIgnoredReason {
  /** Completion has already been completed and no there was points change. */
  AlreadyCompleted = "already_completed",
  /** Completion has already been reset. */
  AlreadyReset = "already_reset",
  /** Completion has already been skipped. */
  AlreadySkipped = "already_skipped"
}

/** The context of a Pathwright 'session' in a school. */
export type AccountContext = {
  __typename?: "AccountContext"
  membership?: Maybe<Membership>
  permissions: ContextPermissions
  school: School
  theme?: Maybe<Theme>
  translation?: Maybe<Translation>
  user?: Maybe<User>
}

export enum ActionType {
  CanceledPausedSubscription = "canceled_paused_subscription",
  CanceledSubscription = "canceled_subscription",
  CompleteCourse = "complete_course",
  CompleteStep = "complete_step",
  CreateDiscussion = "create_discussion",
  CreateGroup = "create_group",
  CreateMembership = "create_membership",
  CreateRegistration = "create_registration",
  CreateResponse = "create_response",
  CreateSubscription = "create_subscription",
  PausedSubscription = "paused_subscription",
  SkipStep = "skip_step",
  SubscriptionCanceledImmediately = "subscription_canceled_immediately",
  SubscriptionEnded = "subscription_ended",
  UnpausedSubscription = "unpaused_subscription"
}

export type ActionTypeFilter = {
  eq?: InputMaybe<ActionType>
  gt?: InputMaybe<ActionType>
  gte?: InputMaybe<ActionType>
  in?: InputMaybe<Array<InputMaybe<ActionType>>>
  lt?: InputMaybe<ActionType>
  lte?: InputMaybe<ActionType>
  neq?: InputMaybe<ActionType>
  nin?: InputMaybe<Array<InputMaybe<ActionType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright Activity */
export type Activity = {
  __typename?: "Activity"
  action?: Maybe<ActionType>
  action_dtime?: Maybe<Scalars["DateTime"]["output"]>
  action_type?: Maybe<Scalars["Int"]["output"]>
  discussion?: Maybe<Discussion>
  discussion_response?: Maybe<Response>
  group?: Maybe<Group>
  id?: Maybe<Scalars["Int"]["output"]>
  interest_level?: Maybe<Scalars["Int"]["output"]>
  offering_id?: Maybe<Scalars["Int"]["output"]>
  registration?: Maybe<Registration>
  resource?: Maybe<Resource>
  step?: Maybe<PathItem>
  triggered_by?: Maybe<User>
  user?: Maybe<User>
}

/** A connection to a list of items. */
export type ActivityConnection = {
  __typename?: "ActivityConnection"
  /** A list of edges. */
  edges: Array<ActivityEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ActivityEdge = {
  __typename?: "ActivityEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Activity
}

export type ActivityStats = {
  __typename?: "ActivityStats"
  discussion_responses?: Maybe<Scalars["Int"]["output"]>
  discussions?: Maybe<Scalars["Int"]["output"]>
  registrations?: Maybe<Scalars["Int"]["output"]>
  steps_completed?: Maybe<Scalars["Int"]["output"]>
  /** @deprecated `total` no longer provided. Insteaed, query the `total` on activity. */
  total?: Maybe<Scalars["Int"]["output"]>
}

export type AddPeopleSelection = {
  add_to: Array<InputMaybe<AddPeopleSelectionTo>>
  key: Scalars["AppPeopleSelectionKey"]["input"]
  type: AddPeopleSelectionType
}

export type AddPeopleSelectionTo = {
  key: Scalars["String"]["input"]
  role: AddPeopleSelectionToRole
  type: AddPeopleSelectionToType
}

export enum AddPeopleSelectionToRole {
  CohortCourseEditor = "cohort_course_editor",
  CohortLearner = "cohort_learner",
  CohortModerator = "cohort_moderator",
  CohortObserver = "cohort_observer",
  CohortTeacher = "cohort_teacher",
  GroupAdmin = "group_admin",
  GroupMember = "group_member",
  GroupModerator = "group_moderator",
  SchoolAdmin = "school_admin",
  SchoolMember = "school_member",
  SchoolStaff = "school_staff"
}

export enum AddPeopleSelectionToType {
  Cohort = "cohort",
  Group = "group"
}

export enum AddPeopleSelectionType {
  Cohort = "cohort",
  Email = "email",
  Group = "group",
  User = "user"
}

export type AssignConfig = {
  target_role?: InputMaybe<RegistrationRoleEnum>
}

/** Methods for authenticating a user in a space */
export type AuthMethod = {
  __typename?: "AuthMethod"
  /** Whether this auth method is enabled for the Space */
  enabled: Scalars["Boolean"]["output"]
  id: Scalars["String"]["output"]
  meta: NodeMeta
}

/** A request made by the user to authenticate by some other means than username/password. */
export type AuthRequest = {
  __typename?: "AuthRequest"
  /** How many times this request has attempted confirmation, for preventing brute-force attacks. */
  confirmation_attempts: Scalars["Int"]["output"]
  /** When the authentication request was confirmed and an auth token was issued. */
  confirmed_dtime?: Maybe<Scalars["DateTime"]["output"]>
  /** A place for storing extra information about the request. May include information such as the user's IP address, invite tokens, etc. */
  context?: Maybe<Scalars["JSON"]["output"]>
  /** If set, after this time, the authentication request will be considered invalid. */
  expiration_dtime?: Maybe<Scalars["DateTime"]["output"]>
  /** If this authentication request was successful, this is the auth token that was issued. */
  issued_auth_token?: Maybe<JsonWebToken>
  /** When the authentication request was initially started. */
  request_dtime: Scalars["DateTime"]["output"]
  /** A 'secret key' that must be provided by the client in order to confirm the request. Always null as this key cannot be exposed. */
  request_key?: Maybe<Scalars["String"]["output"]>
  /** The authentication method being used, such as an Email-based OTP (magic link). */
  request_method: AuthRequestMethod
  school?: Maybe<School>
  truncated_email?: Maybe<Scalars["String"]["output"]>
  /** A customer-viewable ID for the authentication request. Must be used for all API calls to prevent sequentially enumerating auth requests. */
  uuid: Scalars["UUID"]["output"]
}

export enum AuthRequestMethod {
  EmailOtp = "email_otp"
}

/** A Pathwright Author */
export type Author = {
  __typename?: "Author"
  avatar?: Maybe<Scalars["String"]["output"]>
  bio?: Maybe<Scalars["String"]["output"]>
  display_name: Scalars["String"]["output"]
  first_name: Scalars["String"]["output"]
  full_name: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  image?: Maybe<Scalars["String"]["output"]>
  last_name: Scalars["String"]["output"]
  meta: NodeMeta
  /** The global order for this author in the school. This is not affected by the `positioningContext` arg, and is designed for school-wide UIs. Use `position` for context-specific ordering, such as for a Cover Page. */
  order: Scalars["Int"]["output"]
  /** The contextual position for this item based on the parent connection `positioningContext` arg. */
  position: Scalars["String"]["output"]
  salutation?: Maybe<Scalars["String"]["output"]>
  slug: Scalars["String"]["output"]
  title?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright Author */
export type AuthorImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Author */
export type AuthorPositionArgs = {
  positioningContext?: InputMaybe<PositioningContextInput>
}

/** A connection to a list of items. */
export type AuthorConnection = {
  __typename?: "AuthorConnection"
  /** A list of edges. */
  edges: Array<AuthorEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type AuthorEdge = {
  __typename?: "AuthorEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Author
}

/** Input for ordering the list. */
export type AuthorOrderByInput = {
  /** Order by id. */
  id?: InputMaybe<OrderByDir>
  /** Order by order. */
  order?: InputMaybe<OrderByDir>
  /** Order by position. */
  position?: InputMaybe<OrderByDir>
}

/** A background task. */
export type BackgroundTask = {
  __typename?: "BackgroundTask"
  id: Scalars["UUID"]["output"]
  result?: Maybe<Scalars["JSON"]["output"]>
  status: BackgroundTaskStatus
}

export enum BackgroundTaskStatus {
  Failure = "failure",
  Pending = "pending",
  Retry = "retry",
  Revoked = "revoked",
  Started = "started",
  Success = "success"
}

/** A Pathwright Banner */
export type Banner = {
  __typename?: "Banner"
  background_image?: Maybe<Scalars["String"]["output"]>
  background_image_raw?: Maybe<Scalars["String"]["output"]>
  background_overlay?: Maybe<Scalars["String"]["output"]>
  background_type?: Maybe<Scalars["Int"]["output"]>
  button_func?: Maybe<Scalars["String"]["output"]>
  button_text?: Maybe<Scalars["String"]["output"]>
  button_url?: Maybe<Scalars["String"]["output"]>
  font_color?: Maybe<Scalars["String"]["output"]>
  heading?: Maybe<Scalars["String"]["output"]>
  hide_for_products?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  hide_for_subscription_plans?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  id?: Maybe<Scalars["Int"]["output"]>
  is_visible?: Maybe<Scalars["Boolean"]["output"]>
  order?: Maybe<Scalars["Int"]["output"]>
  readability?: Maybe<Scalars["Boolean"]["output"]>
  show_for_products?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  show_for_subscription_plans?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  subhead?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright Banner */
export type BannerBackground_ImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type BannerConnection = {
  __typename?: "BannerConnection"
  /** A list of edges. */
  edges: Array<BannerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type BannerEdge = {
  __typename?: "BannerEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Banner
}

export type BatchMentorGroupMembershipResult = {
  __typename?: "BatchMentorGroupMembershipResult"
  group_memberships_created_count?: Maybe<Scalars["Int"]["output"]>
  success?: Maybe<Scalars["Boolean"]["output"]>
}

export type BlocksContent = {
  __typename?: "BlocksContent"
  content_last_modified?: Maybe<Scalars["DateTime"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  created_by_id?: Maybe<Scalars["Int"]["output"]>
  data?: Maybe<Scalars["JSON"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  last_published?: Maybe<Scalars["DateTime"]["output"]>
  method?: Maybe<Scalars["String"]["output"]>
  modified?: Maybe<Scalars["DateTime"]["output"]>
  modified_by_id?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

export type Calendar = {
  __typename?: "Calendar"
  events?: Maybe<Array<Maybe<CalendarEvent>>>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  timezone?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export type CalendarEvent = {
  __typename?: "CalendarEvent"
  completion_status?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end?: Maybe<Scalars["DateTime"]["output"]>
  ical_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  relative_url?: Maybe<Scalars["String"]["output"]>
  start?: Maybe<Scalars["DateTime"]["output"]>
  summary?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export type CalendarStats = {
  __typename?: "CalendarStats"
  due?: Maybe<Scalars["Int"]["output"]>
  late?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
  upcoming?: Maybe<Scalars["Int"]["output"]>
}

/** A Course Category */
export type Category = {
  __typename?: "Category"
  description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  /** The contextual position for this item based on the parent connection `positioningContext` arg. */
  position: Scalars["String"]["output"]
  slug: Scalars["String"]["output"]
}

/** A Course Category */
export type CategoryPositionArgs = {
  positioningContext?: InputMaybe<PositioningContextInput>
}

/** A connection to a list of items. */
export type CategoryConnection = {
  __typename?: "CategoryConnection"
  /** A list of edges. */
  edges: Array<CategoryEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: "CategoryEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Category
}

/** Input for ordering the list. */
export type CategoryOrderByInput = {
  /** Order by id. */
  id?: InputMaybe<OrderByDir>
  /** Order by order. */
  order?: InputMaybe<OrderByDir>
  /** Order by position. */
  position?: InputMaybe<OrderByDir>
}

export type Certificate = {
  __typename?: "Certificate"
  created_time?: Maybe<Scalars["DateTime"]["output"]>
  /** Generated download url based on optionally provided path_id. */
  download_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  /** Whether the certificate is currently active. */
  is_active?: Maybe<Scalars["Boolean"]["output"]>
  /** Name of certificate for visual identification. */
  name?: Maybe<Scalars["String"]["output"]>
  school?: Maybe<School>
  /** The PDF template URL. */
  template?: Maybe<Scalars["String"]["output"]>
  /** List of text objects to be merged with PDF template. */
  text_objects?: Maybe<Scalars["JSON"]["output"]>
}

export type CertificateDownload_UrlArgs = {
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  variables?: InputMaybe<Scalars["JSON"]["input"]>
}

/** A connection to a list of items. */
export type CertificateConnection = {
  __typename?: "CertificateConnection"
  /** A list of edges. */
  edges: Array<CertificateEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type CertificateEdge = {
  __typename?: "CertificateEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Certificate
}

export type CertificateVariables = {
  __typename?: "CertificateVariables"
  id?: Maybe<Scalars["Int"]["output"]>
  /** Key/value pairs of variable paths and the number of times they are used by all courses. */
  stats?: Maybe<Scalars["JSON"]["output"]>
  /** Key/value pairs of variable paths and their values. Only applicable when scoping to a resource. */
  variables?: Maybe<Scalars["JSON"]["output"]>
}

export type CertificateVariablesContextInput = {
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type CertificateVariablesMergeInput = {
  /** Old name of a key that should be transitioned to new_key. */
  current_key?: InputMaybe<Scalars["String"]["input"]>
  /** New name of a key that should be transitioned from current_key. Omitting this arg will result in deleting current_key. */
  new_key?: InputMaybe<Scalars["String"]["input"]>
  /** New value of the new_key. Omitting this arg will result in the current value of current_key to be used by default. */
  new_value?: InputMaybe<Scalars["String"]["input"]>
}

export type Codex = {
  __typename?: "Codex"
  config?: Maybe<CodexConfig>
  space?: Maybe<CodexSpace>
}

export type CodexSpaceArgs = {
  join?: InputMaybe<Scalars["Boolean"]["input"]>
  key: Scalars["String"]["input"]
}

export type CodexAccount = {
  __typename?: "CodexAccount"
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
}

export type CodexConfig = {
  __typename?: "CodexConfig"
  account?: Maybe<CodexAccount>
  firebase?: Maybe<FirebaseConfig>
  user?: Maybe<CodexUser>
}

export type CodexNode = {
  __typename?: "CodexNode"
  created?: Maybe<Scalars["DateTime"]["output"]>
  data: Scalars["JSON"]["output"]
  fromId?: Maybe<Scalars["ID"]["output"]>
  graphId?: Maybe<Scalars["ID"]["output"]>
  id: Scalars["ID"]["output"]
  key?: Maybe<Scalars["String"]["output"]>
  parentId?: Maybe<Scalars["ID"]["output"]>
  rootId?: Maybe<Scalars["ID"]["output"]>
  toId?: Maybe<Scalars["ID"]["output"]>
  type: Scalars["String"]["output"]
  updated?: Maybe<Scalars["DateTime"]["output"]>
  userId?: Maybe<Scalars["ID"]["output"]>
}

/** A publish to Paths (codex data structure) */
export type CodexPathPublish = {
  __typename?: "CodexPathPublish"
  node?: Maybe<PathsCodexNode>
}

export type CodexSpace = {
  __typename?: "CodexSpace"
  id: Scalars["ID"]["output"]
  membership?: Maybe<CodexNode>
  nodes?: Maybe<Array<Maybe<CodexNode>>>
}

export type CodexSpaceNodesArgs = {
  last_x_days?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
}

export type CodexUser = {
  __typename?: "CodexUser"
  authToken: Scalars["String"]["output"]
  displayName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  image?: Maybe<Scalars["String"]["output"]>
}

/** Whether user can use Cohort share UI. */
export type CohortShareAccess = {
  __typename?: "CohortShareAccess"
  /** A user's access level to share UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareAccessGatedReasonType>
}

export enum CohortShareAccessGatedReasonType {
  CohortCompleted = "COHORT_COMPLETED",
  CohortEnded = "COHORT_ENDED",
  CohortLicensedSeatsFilled = "COHORT_LICENSED_SEATS_FILLED",
  CohortRegistrationEnded = "COHORT_REGISTRATION_ENDED",
  CohortSeatsFilled = "COHORT_SEATS_FILLED"
}

/** Whether user can use Cohort share > add UI. */
export type CohortShareAddAccess = {
  __typename?: "CohortShareAddAccess"
  /** A user's access level to share > add UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > add UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareAddAccessGatedReasonType>
}

export enum CohortShareAddAccessGatedReasonType {
  SchoolInactive = "SCHOOL_INACTIVE"
}

export enum CohortShareInviteRoleGatedReasonType {
  CohortLicensedSeatsFilled = "COHORT_LICENSED_SEATS_FILLED",
  CohortSeatsFilled = "COHORT_SEATS_FILLED"
}

/** Whether user can use Cohort share > link UI. */
export type CohortShareLinkAccess = {
  __typename?: "CohortShareLinkAccess"
  /** A user's access level to share > link UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > link UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareLinkAccessGatedReasonType>
}

export enum CohortShareLinkAccessGatedReasonType {
  SchoolInactive = "SCHOOL_INACTIVE"
}

/** Whether user can use Cohort share > track UI. */
export type CohortShareTrackAccess = {
  __typename?: "CohortShareTrackAccess"
  /** A user's access level to share > track UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > track UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareTrackAccessGatedReasonType>
}

export enum CohortShareTrackAccessGatedReasonType {
  Placeholder = "PLACEHOLDER"
}

export type CohortsStatusMeta = {
  __typename?: "CohortsStatusMeta"
  completed?: Maybe<Scalars["Int"]["output"]>
  in_progress?: Maybe<Scalars["Int"]["output"]>
}

/** Computed fields on path item */
export type Completion = {
  __typename?: "Completion"
  checked_by?: Maybe<User>
  checked_by_id?: Maybe<Scalars["Int"]["output"]>
  checked_date?: Maybe<Scalars["DateTime"]["output"]>
  completion_attempts?: Maybe<Scalars["Int"]["output"]>
  completion_comment?: Maybe<Scalars["String"]["output"]>
  completion_date?: Maybe<Scalars["DateTime"]["output"]>
  completion_due?: Maybe<Scalars["DateTime"]["output"]>
  feedback_discussion_context?: Maybe<CompletionFeedbackDiscussionContext>
  grading_type?: Maybe<Scalars["String"]["output"]>
  has_failed_passing_attempt?: Maybe<Scalars["Boolean"]["output"]>
  has_points?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  is_auto_graded?: Maybe<Scalars["Boolean"]["output"]>
  is_complete?: Maybe<Scalars["Boolean"]["output"]>
  is_forced_completion?: Maybe<Scalars["Boolean"]["output"]>
  is_graded?: Maybe<Scalars["Boolean"]["output"]>
  is_late?: Maybe<Scalars["Boolean"]["output"]>
  is_skipped?: Maybe<Scalars["Boolean"]["output"]>
  last_completion_attempt_date?: Maybe<Scalars["DateTime"]["output"]>
  minimum_passing_score?: Maybe<Scalars["Int"]["output"]>
  needs_grading?: Maybe<Scalars["Boolean"]["output"]>
  overridden_by?: Maybe<User>
  overridden_by_api?: Maybe<Scalars["Boolean"]["output"]>
  requires_api_completion?: Maybe<Scalars["Boolean"]["output"]>
  /** Legacy content (only applicable to Path Items using legacy content, pre-dating Blocks). */
  submission?: Maybe<UserSubmission>
  user?: Maybe<User>
  userpoints_earned?: Maybe<Scalars["Int"]["output"]>
  userpoints_explanation?: Maybe<Scalars["String"]["output"]>
  userpoints_value?: Maybe<Scalars["Int"]["output"]>
}

/** Link to the feedback discussion context for a completion */
export type CompletionFeedbackDiscussionContext = {
  __typename?: "CompletionFeedbackDiscussionContext"
  discussion_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  num_responses?: Maybe<Scalars["Int"]["output"]>
}

export enum CompletionStateFilter {
  Completed = "completed",
  InProgress = "in_progress",
  Unstarted = "unstarted"
}

/** Computed discount values for an enrollment */
export type ComputedDiscount = {
  __typename?: "ComputedDiscount"
  discount_amount?: Maybe<Scalars["Float"]["output"]>
  discount_percent?: Maybe<Scalars["Float"]["output"]>
  discounted_total?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  max_seat_discount?: Maybe<Scalars["Int"]["output"]>
}

export type ContextModelInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  path_item_id?: InputMaybe<Scalars["Int"]["input"]>
  path_item_source_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type ContextPermissions = {
  __typename?: "ContextPermissions"
  can_administrate?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_library?: Maybe<Scalars["Boolean"]["output"]>
  has_member_access?: Maybe<Scalars["Boolean"]["output"]>
  has_pathwright_staff_access?: Maybe<Scalars["Boolean"]["output"]>
  is_school_owner?: Maybe<Scalars["Boolean"]["output"]>
}

/** Contextual permissions for a PathwrightFeature */
export type ContextualFeaturePermission = {
  __typename?: "ContextualFeaturePermission"
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  feature_action: FeatureAction
  feature_key: FeatureKey
  id?: Maybe<Scalars["Int"]["output"]>
  permission_in_context: FeaturePermission
  resource_id?: Maybe<Scalars["Int"]["output"]>
  school_id?: Maybe<Scalars["Int"]["output"]>
  user_id?: Maybe<Scalars["Int"]["output"]>
}

/** A Coupon applicable to Paths or */
export type Coupon = {
  __typename?: "Coupon"
  /** If True, this coupon applies to all courses. */
  allCourses: Scalars["Boolean"]["output"]
  /** The unique code used to redeem this coupon. */
  code: Scalars["String"]["output"]
  /** Percent in the range of 0...1. */
  discountPercent: Scalars["Int"]["output"]
  /** Subscriptions plans billing cycles can have varying intervals (weeks, months, years, etc). This determines how many cycles are being discounted. */
  discountedSubscriptionCycles?: Maybe<Scalars["Int"]["output"]>
  /** Coupon can't be used after this date. */
  endDtime?: Maybe<Scalars["DateTime"]["output"]>
  /** The ID of the Coupon. */
  id: Scalars["Int"]["output"]
  /** If True, this can only be redeemed once per user. */
  isOnePerUser: Scalars["Boolean"]["output"]
  /** The max # of times this coupon can be used. */
  maxNumRedemptions?: Maybe<Scalars["Int"]["output"]>
  /** Maximum number of seats that the discount percent can be applied to. */
  maxSeatDiscount: Scalars["Int"]["output"]
  /** Coupon can't be used before this date. */
  startDtime?: Maybe<Scalars["DateTime"]["output"]>
}

/** A coupon discount applicable to a course or school subscription plan */
export type CouponDiscount = {
  __typename?: "CouponDiscount"
  /** The total before discount */
  amount?: Maybe<Scalars["Float"]["output"]>
  code?: Maybe<Scalars["String"]["output"]>
  /** How much the user will save */
  discount_amount?: Maybe<Scalars["Float"]["output"]>
  discount_percent?: Maybe<Scalars["Float"]["output"]>
  discounted_subscription_cycles?: Maybe<Scalars["Int"]["output"]>
  /** How much the user will pay */
  discounted_total?: Maybe<Scalars["Float"]["output"]>
  end_date?: Maybe<Scalars["DateTime"]["output"]>
  has_ended?: Maybe<Scalars["Boolean"]["output"]>
  has_started?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  is_one_per_user?: Maybe<Scalars["Boolean"]["output"]>
  max_num_redemptions?: Maybe<Scalars["Int"]["output"]>
  max_seat_discount?: Maybe<Scalars["Int"]["output"]>
  num_redemptions?: Maybe<Scalars["Int"]["output"]>
  start_date?: Maybe<Scalars["DateTime"]["output"]>
  user_can_redeem?: Maybe<Scalars["Boolean"]["output"]>
  user_redeemed?: Maybe<Scalars["Boolean"]["output"]>
}

export type CouponExistsInput = {
  /** Scope coupons to paths. */
  path?: InputMaybe<CouponForPathExistsInput>
  /** Scope coupons to subscription plans. */
  plan?: InputMaybe<CouponForPlanExistsInput>
}

export type CouponForPathExistsInput = {
  /** A minimum number of seats required. Anything over 0 signifies the coupon must be used for member-created Cohorts. */
  minSeats?: InputMaybe<Scalars["Int"]["input"]>
  /** ID of the resource to scope coupons to. */
  resourceId: Scalars["Int"]["input"]
}

export type CouponForPlanExistsInput = {
  /** ID of the school subscription plan to scope coupons to. */
  schoolSubscriptionPlanId: Scalars["Int"]["input"]
}

/** The record of a Coupon redemption. */
export type CouponRedemption = {
  __typename?: "CouponRedemption"
  /** The Coupon that was redeemed. */
  coupon: Coupon
  /** The ID of the CouponRedemption. */
  id: Scalars["Int"]["output"]
  /** The time at which the coupon was redeemed. */
  redeemedDtime: Scalars["DateTime"]["output"]
}

export type CreateInvitationsSuccess = {
  __typename?: "CreateInvitationsSuccess"
  invitations_attempted_count?: Maybe<Scalars["Int"]["output"]>
  invitations_sent_count?: Maybe<Scalars["Int"]["output"]>
  /** An array of unsuccessful invitations containing email, role, type, and error. */
  unsuccessful_invitations?: Maybe<Scalars["JSON"]["output"]>
}

/** Curriculum license order data */
export type CurriculumLicenseOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licensor_school_id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

/** A school licensing school curriculum subscription */
export type CurriculumSubscription = {
  __typename?: "CurriculumSubscription"
  curriculum_plan?: Maybe<SchoolCurriculumPlan>
  id: Scalars["Int"]["output"]
  licensee: School
  licensor: School
  subscription?: Maybe<Subscription>
}

/** A connection to a list of items. */
export type CurriculumSubscriptionConnection = {
  __typename?: "CurriculumSubscriptionConnection"
  /** A list of edges. */
  edges: Array<CurriculumSubscriptionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type CurriculumSubscriptionEdge = {
  __typename?: "CurriculumSubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: CurriculumSubscription
}

/** Curriculum subscription order data */
export type CurriculumSubscriptionOrderData = {
  curriculum_plan_id: Scalars["Int"]["input"]
  licensee_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export enum CurriculumType {
  /** The source curriculum for this group (what the teacher edits) */
  Source = "source",
  /** The current logged in user's curriculum */
  User = "user"
}

export type DateFilter = {
  eq?: InputMaybe<Scalars["DateTime"]["input"]>
  gt?: InputMaybe<Scalars["DateTime"]["input"]>
  gte?: InputMaybe<Scalars["DateTime"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>
  lt?: InputMaybe<Scalars["DateTime"]["input"]>
  lte?: InputMaybe<Scalars["DateTime"]["input"]>
  neq?: InputMaybe<Scalars["DateTime"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type DeferOrExecuteResourceCopyConfigResult = {
  __typename?: "DeferOrExecuteResourceCopyConfigResult"
  defer: Scalars["JSON"]["output"]
  execute: Scalars["JSON"]["output"]
}

/** Pathwright discussion */
export type Discussion = {
  __typename?: "Discussion"
  allow_replies: Scalars["Boolean"]["output"]
  body?: Maybe<Scalars["String"]["output"]>
  cohort?: Maybe<Group>
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  context_id?: Maybe<Scalars["Int"]["output"]>
  created_time: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  is_discussion_question: Scalars["Boolean"]["output"]
  last_activity_time?: Maybe<Scalars["DateTime"]["output"]>
  likes: Scalars["Int"]["output"]
  modified_time: Scalars["DateTime"]["output"]
  order: Scalars["Int"]["output"]
  /** @deprecated Use step. */
  path_item?: Maybe<PathItem>
  /** @deprecated No longer used. */
  path_item_name?: Maybe<Scalars["String"]["output"]>
  resource?: Maybe<Resource>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  response?: Maybe<Response>
  responses?: Maybe<ResponseConnection>
  step?: Maybe<DiscussionPathItem>
  step_id?: Maybe<Scalars["Int"]["output"]>
  tagLinks?: Maybe<TagLinkConnection>
  title: Scalars["String"]["output"]
  total_responses: Scalars["Int"]["output"]
  type: Scalars["Int"]["output"]
  user?: Maybe<User>
  user_has_viewed_recent: Scalars["Boolean"]["output"]
  user_is_subscribed?: Maybe<Scalars["Boolean"]["output"]>
  user_last_responded_time?: Maybe<Scalars["DateTime"]["output"]>
  user_last_viewed_time?: Maybe<Scalars["DateTime"]["output"]>
  user_liked?: Maybe<Scalars["Boolean"]["output"]>
}

/** Pathwright discussion */
export type DiscussionResponseArgs = {
  response_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright discussion */
export type DiscussionResponsesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<ResponseOrderBy>>>
}

/** Pathwright discussion */
export type DiscussionTagLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  discussion_context_id?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  tag_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type DiscussionConnection = {
  __typename?: "DiscussionConnection"
  /** A list of edges. */
  edges: Array<DiscussionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type DiscussionContextInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  completion_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type DiscussionEdge = {
  __typename?: "DiscussionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Discussion
}

/** Pathwright user discussion history */
export type DiscussionParticipant = {
  __typename?: "DiscussionParticipant"
  display_name?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  external_account_link?: Maybe<ExternalAccountLink>
  first_name: Scalars["String"]["output"]
  full_name: Scalars["String"]["output"]
  gravatar?: Maybe<Gravatar>
  group_role_stats?: Maybe<Array<Maybe<GroupRoleStats>>>
  id: Scalars["Int"]["output"]
  is_active: Scalars["Boolean"]["output"]
  /** A user account setup is onl considered 'finalized' when the `first_name` and `last_name` fields have been set. */
  is_finalized?: Maybe<Scalars["Boolean"]["output"]>
  is_staff: Scalars["Boolean"]["output"]
  is_superuser: Scalars["Boolean"]["output"]
  last_name: Scalars["String"]["output"]
  membership?: Maybe<Membership>
  memberships?: Maybe<MembershipConnection>
  mentorGroupMemberships?: Maybe<MentorGroupMembershipConnection>
  no_password_set?: Maybe<Scalars["Boolean"]["output"]>
  /** The user's payment history */
  payment_history: PaymentHistory
  permissions?: Maybe<ContextPermissions>
  profile?: Maybe<Profile>
  registrations?: Maybe<RegistrationConnection>
  school_group_subscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  school_subscription?: Maybe<SchoolSubscription>
  token?: Maybe<Token>
  username?: Maybe<Scalars["String"]["output"]>
}

/** Pathwright user discussion history */
export type DiscussionParticipantMembershipsArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  after?: InputMaybe<Scalars["String"]["input"]>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright user discussion history */
export type DiscussionParticipantMentorGroupMembershipsArgs = {
  _or?: InputMaybe<MentorGroupMembershipOr>
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright user discussion history */
export type DiscussionParticipantRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  cohort_filter?: InputMaybe<IntFilter>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  id_filter?: InputMaybe<IntFilter>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** Pathwright user discussion history */
export type DiscussionParticipantSchool_Group_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type DiscussionParticipantConnection = {
  __typename?: "DiscussionParticipantConnection"
  /** A list of edges. */
  edges: Array<DiscussionParticipantEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type DiscussionParticipantEdge = {
  __typename?: "DiscussionParticipantEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: DiscussionParticipant
}

/** The path item a discussion belongs to */
export type DiscussionPathItem = {
  __typename?: "DiscussionPathItem"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  verb?: Maybe<Scalars["String"]["output"]>
}

export type DiscussionPostInput = {
  body?: InputMaybe<Scalars["String"]["input"]>
  is_discussion_question?: InputMaybe<Scalars["Boolean"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["Int"]["input"]>
}

export type DiscussionResponseContextInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  completion_id?: InputMaybe<Scalars["Int"]["input"]>
  discussion_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type DiscussionResponseInput = {
  attachments?: InputMaybe<Scalars["JSON"]["input"]>
  body: Scalars["String"]["input"]
  depth?: InputMaybe<Scalars["Int"]["input"]>
  discussion_id?: InputMaybe<Scalars["Int"]["input"]>
  reply_parent_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum DiscussionTypeInput {
  Faq = "faq",
  Feedback = "feedback",
  Post = "post",
  Question = "question",
  Review = "review"
}

export enum EmailDeliveryStatus {
  Bounced = "bounced",
  Clicked = "clicked",
  Complained = "complained",
  Deferred = "deferred",
  Opened = "opened",
  Queued = "queued",
  Rejected = "rejected",
  Sent = "sent",
  Unsubscribed = "unsubscribed"
}

/** Related data regarding an email */
export type EmailMessageData = {
  __typename?: "EmailMessageData"
  created_dtime?: Maybe<Scalars["DateTime"]["output"]>
  delivery_status?: Maybe<EmailDeliveryStatus>
  delivery_status_updated?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  message_id?: Maybe<Scalars["Int"]["output"]>
  recipient?: Maybe<Scalars["String"]["output"]>
  reject_reason?: Maybe<Scalars["String"]["output"]>
}

export type EquivalenceIdFilter = {
  eq?: InputMaybe<Scalars["ID"]["input"]>
  neq?: InputMaybe<Scalars["ID"]["input"]>
}

/** An SSO ExternalAccountLink */
export type ExternalAccountLink = {
  __typename?: "ExternalAccountLink"
  external_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  last_external_update?: Maybe<Scalars["DateTime"]["output"]>
  link_type?: Maybe<ExternalAccountType>
  linked_oidc_idp_id?: Maybe<Scalars["Int"]["output"]>
  linked_saml2_idp_id?: Maybe<Scalars["Int"]["output"]>
  user?: Maybe<User>
}

export enum ExternalAccountType {
  Generic = "generic",
  Oidc = "oidc",
  Saml2 = "saml2"
}

export enum FeatureAction {
  AuthLogin = "auth__login",
  BlocksDbCreation = "blocks__db_creation",
  BlocksMigration = "blocks__migration",
  CoverPagesView = "cover_pages__view",
  HomeScreenView = "home_screen__view",
  UpdateVisibility = "update__visibility",
  View = "view"
}

export type FeatureContextInput = {
  /** The ID of the cohort to contextually scope the ContextualFeaturePermission. */
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  /** The ID of the resource to contextually scope the ContextualFeaturePermission. */
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  /** The ID of the user to contextually scope the ContextualFeaturePermission. */
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum FeatureKey {
  AuthLoginOptionEmailLink = "auth__login_option__email_link",
  AuthLoginOptionGlobalSsoApple = "auth__login_option__global_sso__apple",
  AuthLoginOptionGlobalSsoGoogle = "auth__login_option__global_sso__google",
  AuthLoginOptionPassword = "auth__login_option__password",
  AuthPlatform = "auth__platform",
  BlocksRollout = "blocks__rollout",
  CohortActivityFeed = "cohort__activity_feed",
  CohortMemberDirectory = "cohort__member_directory",
  HomeScreenPreview = "home_screen__preview",
  HomeScreenUnified = "home_screen__unified",
  LibraryCoverPages = "library__cover_pages",
  MediaDownloadableVideos = "media__downloadable_videos",
  PathsAppPublish = "paths_app__publish"
}

export type FeatureKeyFilter = {
  eq?: InputMaybe<FeatureKey>
  gt?: InputMaybe<FeatureKey>
  gte?: InputMaybe<FeatureKey>
  in?: InputMaybe<Array<InputMaybe<FeatureKey>>>
  lt?: InputMaybe<FeatureKey>
  lte?: InputMaybe<FeatureKey>
  neq?: InputMaybe<FeatureKey>
  nin?: InputMaybe<Array<InputMaybe<FeatureKey>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export enum FeaturePermission {
  AdminOnly = "admin_only",
  Disabled = "disabled",
  Everyone = "everyone",
  SchoolStaffOnly = "school_staff_only",
  StaffOnly = "staff_only",
  SuperuserOnly = "superuser_only"
}

/** List of reviewers that have left a discussion, ordered by earliest response. */
export type FeedbackReviewers = {
  __typename?: "FeedbackReviewers"
  id?: Maybe<Scalars["Int"]["output"]>
  reviewers?: Maybe<Array<Maybe<Scalars["JSON"]["output"]>>>
}

/** Filestack keys */
export type FilestackInfo = {
  __typename?: "FilestackInfo"
  api_key?: Maybe<Scalars["String"]["output"]>
  policy?: Maybe<Scalars["String"]["output"]>
  signature?: Maybe<Scalars["String"]["output"]>
}

export type FirebaseConfig = {
  __typename?: "FirebaseConfig"
  apiKey: Scalars["String"]["output"]
  databaseURL: Scalars["String"]["output"]
  projectId: Scalars["String"]["output"]
  userToken?: Maybe<Scalars["String"]["output"]>
}

export type FirebaseIntegration = {
  __typename?: "FirebaseIntegration"
  auth_token?: Maybe<Scalars["String"]["output"]>
  client_api_key?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

/** Gift subscription order data */
export type GiftSubscriptionOrderData = {
  gift_message?: InputMaybe<Scalars["String"]["input"]>
  num_cycles: Scalars["Int"]["input"]
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  recipient_first_name: Scalars["String"]["input"]
  recipient_last_name: Scalars["String"]["input"]
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

/** A Gravatar profile. See https://en.gravatar.com/site/implement/profiles/ */
export type Gravatar = {
  __typename?: "Gravatar"
  /** The user's Gravatar Profile first name */
  first_name: Scalars["String"]["output"]
  /** The user's Gravatar Profile last name */
  last_name: Scalars["String"]["output"]
  meta: NodeMeta
}

/** A Pathwright Group */
export type Group = {
  __typename?: "Group"
  access_ended?: Maybe<Scalars["Boolean"]["output"]>
  access_ends?: Maybe<Scalars["DateTime"]["output"]>
  access_started?: Maybe<Scalars["Boolean"]["output"]>
  access_starts?: Maybe<Scalars["DateTime"]["output"]>
  analytics_disabled?: Maybe<Scalars["Boolean"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  created_by_id?: Maybe<Scalars["Int"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  discussion_enabled?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  include_in_plans?: Maybe<SchoolSubscriptionPlanConnection>
  include_with_products?: Maybe<StripeProductConnection>
  invite_urls?: Maybe<GroupInviteUrls>
  is_collection_linked?: Maybe<Scalars["Boolean"]["output"]>
  is_master?: Maybe<Scalars["Boolean"]["output"]>
  is_source_cohort?: Maybe<Scalars["Boolean"]["output"]>
  is_subscription_only?: Maybe<Scalars["Boolean"]["output"]>
  member_stats?: Maybe<GroupMemberStats>
  meta: NodeMeta
  name: Scalars["String"]["output"]
  parent?: Maybe<Group>
  parent_section_id?: Maybe<Scalars["Int"]["output"]>
  path: Path
  permissions?: Maybe<GroupPermissions>
  price?: Maybe<Scalars["Float"]["output"]>
  registration?: Maybe<Registration>
  registration_ended?: Maybe<Scalars["Boolean"]["output"]>
  registration_ends?: Maybe<Scalars["DateTime"]["output"]>
  registration_started?: Maybe<Scalars["Boolean"]["output"]>
  registration_starts?: Maybe<Scalars["DateTime"]["output"]>
  registrations?: Maybe<RegistrationConnection>
  resource?: Maybe<Resource>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  resource_license?: Maybe<ResourceLicense>
  seats?: Maybe<Scalars["Int"]["output"]>
  seats_available?: Maybe<Scalars["Int"]["output"]>
  seats_filled?: Maybe<Scalars["Int"]["output"]>
  source?: Maybe<Group>
  source_cohort_id?: Maybe<Scalars["Int"]["output"]>
  stats?: Maybe<GroupStats>
  status: GroupStatus
  /** The current user's (or queried user's) registration in the parent cohort. */
  user_parent_registration?: Maybe<Registration>
  /** The current user (or queried user) registration in the cohort. */
  user_registration?: Maybe<Registration>
  /** The current user's (or queried user's) registration in the source cohort. */
  user_source_registration?: Maybe<Registration>
  visibility?: Maybe<Scalars["Int"]["output"]>
}

/** A Pathwright Group */
export type GroupInclude_In_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright Group */
export type GroupInclude_With_ProductsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright Group */
export type GroupPathArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<CurriculumType>
}

/** A Pathwright Group */
export type GroupRegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Group */
export type GroupRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  cohort_filter?: InputMaybe<IntFilter>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  id_filter?: InputMaybe<IntFilter>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** A Pathwright Group */
export type GroupUser_Parent_RegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Group */
export type GroupUser_RegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Group */
export type GroupUser_Source_RegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type GroupConnection = {
  __typename?: "GroupConnection"
  /** A list of edges. */
  edges: Array<GroupEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type GroupEdge = {
  __typename?: "GroupEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Group
}

export type GroupInviteUrls = {
  __typename?: "GroupInviteUrls"
  editor?: Maybe<Scalars["String"]["output"]>
  moderator?: Maybe<Scalars["String"]["output"]>
  observer?: Maybe<Scalars["String"]["output"]>
  student?: Maybe<Scalars["String"]["output"]>
  teacher?: Maybe<Scalars["String"]["output"]>
  viewer?: Maybe<Scalars["String"]["output"]>
}

/** Group license order data */
export type GroupLicenseOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type GroupMemberStats = {
  __typename?: "GroupMemberStats"
  send_discussion_notifications?: Maybe<Scalars["Int"]["output"]>
  staff?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export type GroupPermissions = {
  __typename?: "GroupPermissions"
  can_invite_editor?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_moderator?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_observer?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_student?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_teacher?: Maybe<Scalars["Boolean"]["output"]>
  can_make_public?: Maybe<Scalars["Boolean"]["output"]>
  can_publish?: Maybe<Scalars["Boolean"]["output"]>
}

export type GroupRoleStats = {
  __typename?: "GroupRoleStats"
  role?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

/** Whether user can use Group share UI. */
export type GroupShareAccess = {
  __typename?: "GroupShareAccess"
  /** A user's access level to share UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareAccessGatedReasonType>
}

export enum GroupShareAccessGatedReasonType {
  Placeholder = "PLACEHOLDER"
}

/** Whether user can use Group share > add UI. */
export type GroupShareAddAccess = {
  __typename?: "GroupShareAddAccess"
  /** A user's access level to share > add UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > add UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareAddAccessGatedReasonType>
}

export enum GroupShareAddAccessGatedReasonType {
  GroupSeatsFilled = "GROUP_SEATS_FILLED",
  GroupSubscriptionInactive = "GROUP_SUBSCRIPTION_INACTIVE"
}

export enum GroupShareInviteRoleGatedReasonType {
  Placeholder = "PLACEHOLDER"
}

/** Whether user can use Group share > link UI. */
export type GroupShareLinkAccess = {
  __typename?: "GroupShareLinkAccess"
  /** A user's access level to share > link UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > link UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareLinkAccessGatedReasonType>
}

export enum GroupShareLinkAccessGatedReasonType {
  GroupSeatsFilled = "GROUP_SEATS_FILLED",
  GroupSubscriptionInactive = "GROUP_SUBSCRIPTION_INACTIVE"
}

/** Whether user can use Group share > track UI. */
export type GroupShareTrackAccess = {
  __typename?: "GroupShareTrackAccess"
  /** A user's access level to share > track UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > track UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareTrackAccessGatedReasonType>
}

export enum GroupShareTrackAccessGatedReasonType {
  Placeholder = "PLACEHOLDER"
}

export enum GroupSort {
  /** Sort active cohorts before completed cohorts. */
  ActiveThenCompleted = "active_then_completed"
}

export type GroupStats = {
  __typename?: "GroupStats"
  completion?: Maybe<Scalars["Float"]["output"]>
  points?: Maybe<Scalars["Int"]["output"]>
  total_points?: Maybe<Scalars["Int"]["output"]>
}

export enum GroupStatus {
  /** The cohort has been completed */
  Completed = "completed",
  /** The cohort is in progress */
  InProgress = "in_progress"
}

/** Group subscription order data */
export type GroupSubscriptionOrderData = {
  group_name: Scalars["String"]["input"]
  price_id: Scalars["Int"]["input"]
  quantity: Scalars["Int"]["input"]
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export enum GroupType {
  /** The curriculum group */
  Curriculum = "curriculum"
}

export enum GroupVisibility {
  MembersOnly = "members_only",
  Private = "private",
  Public = "public"
}

export type GroupVisibilityFilter = {
  eq?: InputMaybe<GroupVisibility>
  gt?: InputMaybe<GroupVisibility>
  gte?: InputMaybe<GroupVisibility>
  in?: InputMaybe<Array<InputMaybe<GroupVisibility>>>
  lt?: InputMaybe<GroupVisibility>
  lte?: InputMaybe<GroupVisibility>
  neq?: InputMaybe<GroupVisibility>
  nin?: InputMaybe<Array<InputMaybe<GroupVisibility>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type Heartbeat = {
  __typename?: "Heartbeat"
  /** A list of the user's action subscription IDs. */
  active_subscription_ids: Array<Scalars["Int"]["output"]>
  deploy?: Maybe<HeartbeatDeploy>
  membership?: Maybe<HeartbeatMembership>
  success?: Maybe<Scalars["Boolean"]["output"]>
}

/** The active client deployment. Null when that deployment has no build metadata. */
export type HeartbeatDeploy = {
  __typename?: "HeartbeatDeploy"
  build_id: Scalars["String"]["output"]
  built_at?: Maybe<Scalars["String"]["output"]>
  commit_hash?: Maybe<Scalars["String"]["output"]>
  /** When this deployment became active. */
  created: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  /** Null disables notifications; an empty list targets all stale builds; otherwise only the listed build IDs are targeted. */
  notify?: Maybe<Array<Scalars["String"]["output"]>>
}

/** The user's membership status. */
export type HeartbeatMembership = {
  __typename?: "HeartbeatMembership"
  access_revoked_time?: Maybe<Scalars["String"]["output"]>
  archived_time?: Maybe<Scalars["String"]["output"]>
}

export type IdFilter = {
  eq?: InputMaybe<Scalars["ID"]["input"]>
  gt?: InputMaybe<Scalars["ID"]["input"]>
  gte?: InputMaybe<Scalars["ID"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
  lt?: InputMaybe<Scalars["ID"]["input"]>
  lte?: InputMaybe<Scalars["ID"]["input"]>
  neq?: InputMaybe<Scalars["ID"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type ImageInput = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** Provides context data for the inbox. A group, cohort, or user. */
export type InboxContext = {
  __typename?: "InboxContext"
  /** A cohort of students */
  cohort?: Maybe<Group>
  /** A group of students */
  group?: Maybe<MentorGroup>
  id?: Maybe<Scalars["String"]["output"]>
}

/** A combo query of inbox groups */
export type InboxGroupConnection = {
  __typename?: "InboxGroupConnection"
  cohort?: Maybe<Group>
  mentor_group?: Maybe<MentorGroup>
}

/** A connection to a list of items. */
export type InboxGroupConnectionConnection = {
  __typename?: "InboxGroupConnectionConnection"
  /** A list of edges. */
  edges: Array<InboxGroupConnectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxGroupConnectionEdge = {
  __typename?: "InboxGroupConnectionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: InboxGroupConnection
}

/** A mentor group with reviewable items */
export type InboxMentorGroupConnection = {
  __typename?: "InboxMentorGroupConnection"
  group?: Maybe<MentorGroup>
  id?: Maybe<Scalars["Int"]["output"]>
  pending_review_count?: Maybe<Scalars["Int"]["output"]>
}

/** A path with reviewable items (pending_review_count) */
export type InboxPath = {
  __typename?: "InboxPath"
  group?: Maybe<Group>
  id?: Maybe<Scalars["Int"]["output"]>
  pending_review_count?: Maybe<Scalars["Int"]["output"]>
  registration?: Maybe<Registration>
  resource?: Maybe<Resource>
}

/** A connection to a list of items. */
export type InboxPathConnection = {
  __typename?: "InboxPathConnection"
  /** A list of edges. */
  edges: Array<InboxPathEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxPathEdge = {
  __typename?: "InboxPathEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: InboxPath
}

/** A pending review count of reviewable items for target (InboxPendingReviewTarget) */
export type InboxPendingReview = {
  __typename?: "InboxPendingReview"
  count?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type InboxPendingReviewConnection = {
  __typename?: "InboxPendingReviewConnection"
  /** A list of edges. */
  edges: Array<InboxPendingReviewEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxPendingReviewEdge = {
  __typename?: "InboxPendingReviewEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: InboxPendingReview
}

export enum InboxPendingReviewTarget {
  Group = "group",
  Path = "path"
}

/** A count of completion items for people within a cohort or mentor group */
export type InboxPeopleCompletionCounts = {
  __typename?: "InboxPeopleCompletionCounts"
  count?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  user?: Maybe<User>
}

/** A connection to a list of items. */
export type InboxPeopleCompletionCountsConnection = {
  __typename?: "InboxPeopleCompletionCountsConnection"
  /** A list of edges. */
  edges: Array<InboxPeopleCompletionCountsEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxPeopleCompletionCountsEdge = {
  __typename?: "InboxPeopleCompletionCountsEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: InboxPeopleCompletionCounts
}

export enum InboxPeopleCompletionCountsTarget {
  Cohort = "cohort",
  Group = "group"
}

/** A reviewer of a reviewable path item */
export type InboxReviewer = {
  __typename?: "InboxReviewer"
  can_review: Scalars["Boolean"]["output"]
  cohort_role?: Maybe<RegistrationRoleEnum>
  group_or_cohort_id: Scalars["Int"]["output"]
  group_role?: Maybe<MentorGroupMembershipRole>
  id: Scalars["Int"]["output"]
  user: User
}

/** A connection to a list of items. */
export type InboxReviewerConnection = {
  __typename?: "InboxReviewerConnection"
  /** A list of edges. */
  edges: Array<InboxReviewerEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxReviewerEdge = {
  __typename?: "InboxReviewerEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: InboxReviewer
}

export type IntFilter = {
  eq?: InputMaybe<Scalars["Int"]["input"]>
  gt?: InputMaybe<Scalars["Int"]["input"]>
  gte?: InputMaybe<Scalars["Int"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  lt?: InputMaybe<Scalars["Int"]["input"]>
  lte?: InputMaybe<Scalars["Int"]["input"]>
  neq?: InputMaybe<Scalars["Int"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type Integrations = {
  __typename?: "Integrations"
  firebase?: Maybe<FirebaseIntegration>
  intercom?: Maybe<IntercomIntegration>
}

export type IntercomIntegration = {
  __typename?: "IntercomIntegration"
  /** The Intercom app ID that will be used by the client. */
  app_id?: Maybe<Scalars["String"]["output"]>
  /** Pathwright's Intercom app ID. */
  pathwright_app_id?: Maybe<Scalars["String"]["output"]>
  /** Intercom access token, used for tracking events, only exposed to school admin. */
  school_access_token?: Maybe<Scalars["String"]["output"]>
  /** The school's Intercom app ID. */
  school_app_id?: Maybe<Scalars["String"]["output"]>
  /** Intercom secret key, used for Identification Verification, only exposed to school admin. */
  school_secret_key?: Maybe<Scalars["String"]["output"]>
  team?: Maybe<Array<IntercomTeamMember>>
  /** If an Intercom secret key is available, a user_hash will be generated for the current user which will be passed to Intercom for Identification Verification. */
  user_hash?: Maybe<Scalars["String"]["output"]>
}

export type IntercomTeamMember = {
  __typename?: "IntercomTeamMember"
  avatar?: Maybe<Scalars["String"]["output"]>
  email: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  job_title: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export enum InterestLevel {
  High = "high",
  Low = "low",
  Medium = "medium"
}

/** An invitation for a user to join a school, an offering, or a community group as a given role. */
export type Invitation = {
  __typename?: "Invitation"
  community_group?: Maybe<MentorGroup>
  community_group_membership?: Maybe<MentorGroupMembership>
  created_dtime: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  invitation_accepted_dtime?: Maybe<Scalars["DateTime"]["output"]>
  invitation_email?: Maybe<EmailMessageData>
  invitation_hash?: Maybe<Scalars["String"]["output"]>
  invitation_message?: Maybe<Scalars["String"]["output"]>
  /** Specific to which type of invitation this is (see invitation_type) */
  invitation_role: Scalars["Int"]["output"]
  invitation_status: InvitationStatus
  invitation_subject?: Maybe<Scalars["String"]["output"]>
  /** Invitation to offering, school, or community group */
  invitation_type: InvitationType
  invitation_url: Scalars["String"]["output"]
  offering?: Maybe<Group>
  offering_registration?: Maybe<Registration>
  school: School
  school_membership?: Maybe<Membership>
  to_email: Scalars["String"]["output"]
  to_first_name?: Maybe<Scalars["String"]["output"]>
  to_last_name?: Maybe<Scalars["String"]["output"]>
  to_user?: Maybe<User>
}

/** A connection to a list of items. */
export type InvitationConnection = {
  __typename?: "InvitationConnection"
  /** A list of edges. */
  edges: Array<InvitationEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type InvitationContext = {
  /** Scope invitations to cohort */
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  /** Scope invitations to community group */
  community_group_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type InvitationEdge = {
  __typename?: "InvitationEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Invitation
}

export enum InvitationStatus {
  Accepted = "accepted",
  NotAccepted = "not_accepted"
}

/** The data embedded in an invitation token. */
export type InvitationToken = {
  __typename?: "InvitationToken"
  cohort?: Maybe<Group>
  group?: Maybe<MentorGroup>
  id: Scalars["String"]["output"]
  invite_type: InvitationType
  role: Scalars["Int"]["output"]
  sender?: Maybe<User>
}

export enum InvitationType {
  Cohort = "cohort",
  CommunityGroup = "community_group",
  School = "school"
}

/** Analytics data for a path or path item */
export type ItemAnalytics = {
  __typename?: "ItemAnalytics"
  avg_score?: Maybe<Scalars["Float"]["output"]>
  /** The number of users who have completed the whole path */
  complete?: Maybe<Scalars["Int"]["output"]>
  completion_rate?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  /** The number of users who still are working on this path */
  incomplete?: Maybe<Scalars["Int"]["output"]>
  item?: Maybe<PathItem>
  items?: Maybe<Scalars["JSON"]["output"]>
  /** The number of step completions in the path that need grading */
  need_feedback?: Maybe<Scalars["Int"]["output"]>
  next_count?: Maybe<Scalars["Int"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** This is a list of up to 10 users who have completed this path (used to render avatar stacks). */
  students_here?: Maybe<Scalars["JSON"]["output"]>
  /** The number of earned points across all steps in this path (Note: this excludes steps that aren't due if due dates are in use) */
  total_points?: Maybe<Scalars["Int"]["output"]>
  /** The number of available points across all completed and past due student steps in this path */
  total_points_available?: Maybe<Scalars["Int"]["output"]>
  total_users?: Maybe<Scalars["Int"]["output"]>
}

/** A JSONWebToken. */
export type JsonWebToken = {
  __typename?: "JSONWebToken"
  token: Scalars["String"]["output"]
}

/** A resource license offering */
export type LicenseOffering = {
  __typename?: "LicenseOffering"
  /** @deprecated Deprecated in favor of `licensing_mode`. */
  allow_private_group_licensing?: Maybe<Scalars["Boolean"]["output"]>
  /** @deprecated Deprecated in favor of `licensing_mode`. */
  allow_school_licensing?: Maybe<Scalars["Boolean"]["output"]>
  cost_per_seat?: Maybe<Scalars["Float"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  include_creator_seat?: Maybe<Scalars["Boolean"]["output"]>
  include_in_curriculum_plans?: Maybe<SchoolCurriculumPlanConnection>
  include_in_school_curriculum_subscriptions?: Maybe<CurriculumSubscriptionConnection>
  include_in_subscription_plans?: Maybe<SchoolSubscriptionPlanConnection>
  include_with_products?: Maybe<StripeProductConnection>
  included_in_user_subscription?: Maybe<Scalars["Boolean"]["output"]>
  licensing_mode?: Maybe<LicenseOfferingLicensingMode>
  licensor?: Maybe<School>
  minimum_license_duration?: Maybe<Scalars["Int"]["output"]>
  minimum_seat_count?: Maybe<Scalars["Int"]["output"]>
  minimum_seat_count_for_private_group_licensing?: Maybe<
    Scalars["Int"]["output"]
  >
  minimum_seat_count_for_school_licensing?: Maybe<Scalars["Int"]["output"]>
  register_creator_as?: Maybe<RegistrationRoleEnum>
  resource?: Maybe<Resource>
  school_license?: Maybe<ResourceLicense>
}

/** A resource license offering */
export type LicenseOfferingInclude_In_Curriculum_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A resource license offering */
export type LicenseOfferingInclude_In_School_Curriculum_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensee_id?: InputMaybe<IdFilter>
  licensor_id?: InputMaybe<IdFilter>
}

/** A resource license offering */
export type LicenseOfferingInclude_In_Subscription_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A resource license offering */
export type LicenseOfferingInclude_With_ProductsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A resource license offering */
export type LicenseOfferingSchool_LicenseArgs = {
  licensee_school_id: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type LicenseOfferingConnection = {
  __typename?: "LicenseOfferingConnection"
  /** A list of edges. */
  edges: Array<LicenseOfferingEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type LicenseOfferingEdge = {
  __typename?: "LicenseOfferingEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: LicenseOffering
}

export enum LicenseOfferingFor {
  /** This license is for private groups */
  PrivateGroup = "private_group",
  /** This license is for other schools */
  School = "school"
}

export enum LicenseOfferingLicensingMode {
  /** Resource: Group subscriptions */
  GroupSubscription = "group_subscription",
  /** Resource: Private cohorts */
  PrivateCohorts = "private_cohorts",
  /** Resource: School licensing */
  SchoolLicensing = "school_licensing"
}

export enum LicenseRoleEnum {
  Moderator = "moderator",
  Student = "student",
  Teacher = "teacher"
}

/** A Licensee School */
export type LicenseeSchool = {
  __typename?: "LicenseeSchool"
  about?: Maybe<Scalars["String"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  currency_code?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  ietf_language_tag?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  subdomain?: Maybe<Scalars["String"]["output"]>
  website?: Maybe<Scalars["String"]["output"]>
}

/** Lifetime school subscription order data */
export type LifetimeSchoolSubscriptionOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type ListOrderInput = {
  id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
}

/** Info about a user's login options */
export type LoginInfo = {
  __typename?: "LoginInfo"
  auth_url?: Maybe<Scalars["String"]["output"]>
  is_external?: Maybe<Scalars["Boolean"]["output"]>
  primary_color?: Maybe<Scalars["String"]["output"]>
  prompt?: Maybe<Scalars["String"]["output"]>
}

/** Not-CSS Media Queries */
export type Media = {
  __typename?: "Media"
  filestack?: Maybe<FilestackInfo>
  image?: Maybe<Scalars["String"]["output"]>
}

/** Not-CSS Media Queries */
export type MediaImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  url: Scalars["String"]["input"]
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** Contextual data needed for the Media Manager */
export type MediaContext = {
  __typename?: "MediaContext"
  accountID?: Maybe<Scalars["String"]["output"]>
  mediaStoragePath?: Maybe<Scalars["String"]["output"]>
  user?: Maybe<User>
}

/** A Pathwright User's Membership to a School */
export type Membership = {
  __typename?: "Membership"
  access_revoked_time?: Maybe<Scalars["DateTime"]["output"]>
  archived_time?: Maybe<Scalars["DateTime"]["output"]>
  consent_dtime?: Maybe<Scalars["DateTime"]["output"]>
  consent_snapshot?: Maybe<Scalars["String"]["output"]>
  created: Scalars["DateTime"]["output"]
  has_access: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  last_active?: Maybe<Scalars["DateTime"]["output"]>
  last_seen?: Maybe<Scalars["DateTime"]["output"]>
  role: Scalars["Int"]["output"]
  school: School
  school_id: Scalars["Int"]["output"]
  user: User
}

/** A connection to a list of items. */
export type MembershipConnection = {
  __typename?: "MembershipConnection"
  /** A list of edges. */
  edges: Array<MembershipEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type MembershipEdge = {
  __typename?: "MembershipEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Membership
}

export type MembershipMeta = {
  __typename?: "MembershipMeta"
  editor?: Maybe<Scalars["Int"]["output"]>
  lead_mentor?: Maybe<Scalars["Int"]["output"]>
  learner?: Maybe<Scalars["Int"]["output"]>
  mentor?: Maybe<Scalars["Int"]["output"]>
  moderator?: Maybe<Scalars["Int"]["output"]>
  observer?: Maybe<Scalars["Int"]["output"]>
  teacher?: Maybe<Scalars["Int"]["output"]>
}

export enum MembershipRole {
  Administrator = "administrator",
  Editor = "editor",
  Facilitator = "facilitator",
  Student = "student"
}

export type MembershipRoleFilter = {
  eq?: InputMaybe<MembershipRole>
  gt?: InputMaybe<MembershipRole>
  gte?: InputMaybe<MembershipRole>
  in?: InputMaybe<Array<InputMaybe<MembershipRole>>>
  lt?: InputMaybe<MembershipRole>
  lte?: InputMaybe<MembershipRole>
  neq?: InputMaybe<MembershipRole>
  nin?: InputMaybe<Array<InputMaybe<MembershipRole>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type MembershipStats = {
  __typename?: "MembershipStats"
  /** Active within the last 30 days */
  active?: Maybe<Scalars["Int"]["output"]>
  has_access?: Maybe<Scalars["Int"]["output"]>
  /** Inactive for over 60 days */
  inactive?: Maybe<Scalars["Int"]["output"]>
  no_access?: Maybe<Scalars["Int"]["output"]>
  /** Inactive within the last 60 days */
  slipping?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export enum MembershipStatus {
  AccessRevoked = "access_revoked",
  Archived = "archived"
}

export type MentorGroup = {
  __typename?: "MentorGroup"
  child_groups?: Maybe<MentorGroupConnection>
  created: Scalars["DateTime"]["output"]
  description?: Maybe<Scalars["String"]["output"]>
  flattened_child_groups?: Maybe<MentorGroupConnection>
  group_subscription?: Maybe<SchoolGroupSubscription>
  group_subscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  has_child_groups?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  invitations?: Maybe<InvitationConnection>
  memberships?: Maybe<MentorGroupMembershipConnection>
  modified?: Maybe<Scalars["DateTime"]["output"]>
  name: Scalars["String"]["output"]
  owner?: Maybe<User>
  parent?: Maybe<MentorGroup>
  parent_id?: Maybe<Scalars["Int"]["output"]>
  permissions?: Maybe<MentorGroupPermissions>
  school?: Maybe<School>
  seat_limit?: Maybe<Scalars["Int"]["output"]>
  seats_available?: Maybe<Scalars["Int"]["output"]>
  seats_filled: Scalars["Int"]["output"]
  slug: Scalars["String"]["output"]
  type: Scalars["Int"]["output"]
  user_membership?: Maybe<MentorGroupMembership>
}

export type MentorGroupChild_GroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  descendant_of_parent_id?: InputMaybe<EquivalenceIdFilter>
  first: Scalars["Int"]["input"]
  id?: InputMaybe<IdFilter>
  parent_id?: InputMaybe<IdFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  seat_limit_filter?: InputMaybe<IntFilter>
  top_level_only?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MentorGroupFlattened_Child_GroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  descendant_of_parent_id?: InputMaybe<EquivalenceIdFilter>
  first: Scalars["Int"]["input"]
  id?: InputMaybe<IdFilter>
  parent_id?: InputMaybe<IdFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  seat_limit_filter?: InputMaybe<IntFilter>
  top_level_only?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MentorGroupGroup_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

export type MentorGroupInvitationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<InvitationContext>
  delivery_status?: InputMaybe<EmailDeliveryStatus>
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<InvitationStatus>
  type?: InputMaybe<InvitationType>
}

export type MentorGroupMembershipsArgs = {
  _or?: InputMaybe<MentorGroupMembershipOr>
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A connection to a list of items. */
export type MentorGroupConnection = {
  __typename?: "MentorGroupConnection"
  /** A list of edges. */
  edges: Array<MentorGroupEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type MentorGroupEdge = {
  __typename?: "MentorGroupEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: MentorGroup
}

export type MentorGroupMembership = {
  __typename?: "MentorGroupMembership"
  access_revoked_time?: Maybe<Scalars["DateTime"]["output"]>
  can_review: Scalars["Boolean"]["output"]
  created: Scalars["DateTime"]["output"]
  group: MentorGroup
  group_id: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  role: Scalars["Int"]["output"]
  school: School
  send_mentor_digest?: Maybe<Scalars["Boolean"]["output"]>
  user: User
}

/** A connection to a list of items. */
export type MentorGroupMembershipConnection = {
  __typename?: "MentorGroupMembershipConnection"
  /** A list of edges. */
  edges: Array<MentorGroupMembershipEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type MentorGroupMembershipEdge = {
  __typename?: "MentorGroupMembershipEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: MentorGroupMembership
}

export type MentorGroupMembershipOr = {
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

export enum MentorGroupMembershipRole {
  Admin = "admin",
  Member = "member",
  Moderator = "moderator"
}

export type MentorGroupMembershipRoleFilter = {
  eq?: InputMaybe<MentorGroupMembershipRole>
  gt?: InputMaybe<MentorGroupMembershipRole>
  gte?: InputMaybe<MentorGroupMembershipRole>
  in?: InputMaybe<Array<InputMaybe<MentorGroupMembershipRole>>>
  lt?: InputMaybe<MentorGroupMembershipRole>
  lte?: InputMaybe<MentorGroupMembershipRole>
  neq?: InputMaybe<MentorGroupMembershipRole>
  nin?: InputMaybe<Array<InputMaybe<MentorGroupMembershipRole>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type MentorGroupPermissions = {
  __typename?: "MentorGroupPermissions"
  can_add_admin?: Maybe<Scalars["Boolean"]["output"]>
  can_add_group?: Maybe<Scalars["Boolean"]["output"]>
  can_add_member?: Maybe<Scalars["Boolean"]["output"]>
  can_add_moderator?: Maybe<Scalars["Boolean"]["output"]>
  can_change_parent?: Maybe<Scalars["Boolean"]["output"]>
  can_delete_group?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_group?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_subscription?: Maybe<Scalars["Boolean"]["output"]>
  can_update_admin_review_permission?: Maybe<Scalars["Boolean"]["output"]>
  can_update_member_review_permission?: Maybe<Scalars["Boolean"]["output"]>
  can_update_moderator_review_permission?: Maybe<Scalars["Boolean"]["output"]>
}

export type MentorGroupStats = {
  __typename?: "MentorGroupStats"
  community?: Maybe<Scalars["Int"]["output"]>
  group_subscription?: Maybe<Scalars["Int"]["output"]>
  personal?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export enum MentorGroupType {
  Community = "community",
  GroupSubscription = "group_subscription",
  Personal = "personal"
}

export type MentorGroupTypeFilter = {
  eq?: InputMaybe<MentorGroupType>
  gt?: InputMaybe<MentorGroupType>
  gte?: InputMaybe<MentorGroupType>
  in?: InputMaybe<Array<InputMaybe<MentorGroupType>>>
  lt?: InputMaybe<MentorGroupType>
  lte?: InputMaybe<MentorGroupType>
  neq?: InputMaybe<MentorGroupType>
  nin?: InputMaybe<Array<InputMaybe<MentorGroupType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

/** A scheduled message */
export type Message = {
  __typename?: "Message"
  based_on_step_date?: Maybe<MessageStepDateField>
  body?: Maybe<Scalars["String"]["output"]>
  channels: Array<MessageChannel>
  id: Scalars["Int"]["output"]
  is_active: Scalars["Boolean"]["output"]
  path_id?: Maybe<Scalars["Int"]["output"]>
  recipient_filter?: Maybe<MessageRecipientFilter>
  send_date?: Maybe<Scalars["DateTime"]["output"]>
  sent_date?: Maybe<Scalars["DateTime"]["output"]>
  step_source_id?: Maybe<Scalars["Int"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  threshold_minutes: Scalars["Int"]["output"]
  type: MessageType
}

export enum MessageChannel {
  Email = "email",
  Notification = "notification"
}

/** A connection to a list of items. */
export type MessageConnection = {
  __typename?: "MessageConnection"
  /** A list of edges. */
  edges: Array<MessageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type MessageContext = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id: Scalars["Int"]["input"]
}

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: "MessageEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Message
}

export type MessageInput = {
  based_on_step_date?: InputMaybe<MessageStepDateField>
  body: Scalars["String"]["input"]
  channels: Array<InputMaybe<MessageChannel>>
  recipient_filter?: InputMaybe<MessageRecipientFilter>
  subject: Scalars["String"]["input"]
  threshold_minutes: Scalars["Int"]["input"]
  type: MessageType
}

export enum MessageRecipientFilter {
  /** All learners */
  All = "all",
  /** Learners with completed steps */
  StepComplete = "step_complete",
  /** Learners with incomplete steps */
  StepIncomplete = "step_incomplete"
}

export enum MessageStepDateField {
  Due = "due",
  Starts = "starts"
}

export enum MessageType {
  Reminder = "reminder"
}

export type MessageTypeFilter = {
  eq?: InputMaybe<MessageType>
  gt?: InputMaybe<MessageType>
  gte?: InputMaybe<MessageType>
  in?: InputMaybe<Array<InputMaybe<MessageType>>>
  lt?: InputMaybe<MessageType>
  lte?: InputMaybe<MessageType>
  neq?: InputMaybe<MessageType>
  nin?: InputMaybe<Array<InputMaybe<MessageType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type Mutations = {
  __typename?: "Mutations"
  /** Accepts a community group invitation */
  acceptCommunityGroupInvitation?: Maybe<Scalars["Boolean"]["output"]>
  /** Add people to group or cohort */
  addPeopleTo?: Maybe<BackgroundTask>
  apiCompletionUpdate?: Maybe<ApiCompletionUpdate>
  /** Creates a registration for the user */
  assign?: Maybe<Scalars["JSON"]["output"]>
  /** Creates multiple new mentor group memberships */
  batchCreateMentorGroupMembership?: Maybe<BatchMentorGroupMembershipResult>
  /** bulk updates one or more path items */
  bulkUpdatePathItems: Array<PathItemBulkUpdateResult>
  /** Cancels a new subscription for the user. */
  cancelSchoolSubscription?: Maybe<SchoolSubscription>
  /** Changes a user's password */
  changePassword?: Maybe<Scalars["Boolean"]["output"]>
  /** Marks a path item as completed */
  completePathItem?: Maybe<PathItem>
  /** Allows a user to attempt to confirm an AuthRequest */
  confirmAuthRequest?: Maybe<AuthRequest>
  /** Copies an existing resource */
  copyResource?: Maybe<Resource>
  /** Creates a new author */
  createAuthor?: Maybe<Author>
  /** Creat a banner */
  createBanner?: Maybe<Banner>
  /** Creates Blocks (DB) content */
  createBlocksContent?: Maybe<BlocksContent>
  /** Creates a new category */
  createCategory?: Maybe<Category>
  /** Creates a certificate for a school */
  createCertificate?: Maybe<Certificate>
  /** Creates a contextualFeaturePermission for a given context */
  createContextualFeaturePermission?: Maybe<ContextualFeaturePermission>
  /** Create a curriculum license order */
  createCurriculumLicenseOrder?: Maybe<Order>
  /** Create a curriculum subscription order */
  createCurriculumSubscriptionOrder?: Maybe<Order>
  createDiscussion?: Maybe<Discussion>
  createDiscussionLike?: Maybe<Discussion>
  createDiscussionResponse?: Maybe<Response>
  createDiscussionResponseLike?: Maybe<Response>
  createDiscussionSubscription?: Maybe<Discussion>
  /** Creates an external account link for a user in a school, associating them with an external ID. */
  createExternalAccountLink?: Maybe<ExternalAccountLink>
  /** Create a gift subscription order */
  createGiftSubscriptionOrder?: Maybe<Order>
  /** Creates a new cohort for a resource */
  createGroup?: Maybe<Group>
  /** Create a group license order */
  createGroupLicenseOrder?: Maybe<Order>
  /** Create a group subscription order */
  createGroupSubscriptionOrder?: Maybe<Order>
  /** Creates invitations for the given invite emails */
  createInvitations?: Maybe<CreateInvitationsSuccess>
  /** Create a lifetime school subscription order */
  createLifetimeSchoolSubscriptionOrder?: Maybe<Order>
  /** Creates a school membership for a user who already has an account on Pathwright, but is not yet a member of the school. Allowed only for schools who have API access enabled. */
  createMembershipForExistingUser?: Maybe<Membership>
  /** Creates a new mentor group */
  createMentorGroup?: Maybe<MentorGroup>
  /** Creates a new mentor group membership */
  createMentorGroupMembership?: Maybe<MentorGroupMembership>
  /** Creates a message. */
  createMessage?: Maybe<Message>
  createNote?: Maybe<Note>
  createNotification: Scalars["Boolean"]["output"]
  createOffer?: Maybe<Offer>
  /** Create an order. Only one order may be created at a time. */
  createOrder?: Maybe<Order>
  /** Create a page. */
  createPage?: Maybe<Page>
  /** Creates a user's password, only in cases where a user does not already have a password. */
  createPassword?: Maybe<Scalars["Boolean"]["output"]>
  /** creates a path divider, lesson, step, or resource. */
  createPathItem?: Maybe<PathItem>
  /** Create a platform subscription order */
  createPlatformSubscriptionOrder?: Maybe<Order>
  /** Create a registration order */
  createRegistrationOrder?: Maybe<Order>
  /** Potentially creates a new cohort within a Collection (if a cohort does not already exist for the for the provided resource_id). Optionally registers the user to that cohort. */
  createRegistrationUpsertGroup?: Maybe<Group>
  /** Creates a new resource */
  createResource?: Maybe<Resource>
  /** Create a school with a name and domain. Returns the school if successful. */
  createSchool?: Maybe<School>
  /** Create a school subscription order */
  createSchoolSubscriptionOrder?: Maybe<Order>
  /** Create a school theme. */
  createSchoolTheme?: Maybe<Theme>
  /** Creates a store link for a school. */
  createStoreLink?: Maybe<StoreLink>
  /** Create a storefront */
  createStorefront?: Maybe<Storefront>
  /** Creates a new, unattached tag. */
  createTag?: Maybe<Tag>
  /** Creates a new tagAttachment. */
  createTagAttachment?: Maybe<TagAttachment>
  /** Creates a new tagAttachment. */
  createTagLink?: Maybe<TagLink>
  /** Creates a new translation */
  createTranslation?: Maybe<Translation>
  /** Either defer or execute a copy config. */
  deferOrExecuteResourceCopyConfig?: Maybe<DeferOrExecuteResourceCopyConfigResult>
  /** Creat a banner */
  deleteBanner?: Maybe<Scalars["Boolean"]["output"]>
  /** Archives a certificate */
  deleteCertificate?: Maybe<Scalars["Boolean"]["output"]>
  /** Permanently deletes a contextualFeaturePermission */
  deleteContextualFeaturePermission?: Maybe<Scalars["Boolean"]["output"]>
  deleteDiscussion?: Maybe<Scalars["Boolean"]["output"]>
  deleteDiscussionLike?: Maybe<Discussion>
  deleteDiscussionResponse?: Maybe<Response>
  deleteDiscussionResponseLike?: Maybe<Response>
  deleteDiscussionSubscription?: Maybe<Discussion>
  /** Deletes an invitation */
  deleteInvitation?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes a mentor group */
  deleteMentorGroup?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes a mentor group membership */
  deleteMentorGroupMembership?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes a message. */
  deleteMessage?: Maybe<Scalars["Boolean"]["output"]>
  deleteNote?: Maybe<Scalars["Boolean"]["output"]>
  deleteOffer: Scalars["Boolean"]["output"]
  /** deletes a path item */
  deletePathItem?: Maybe<PathItem>
  /** Deletes a positioning context and all related positioning objects. */
  deletePositioningContext?: Maybe<Scalars["Boolean"]["output"]>
  /** (Currently) permanently deletes a user's registration and all child registrations (in the case of Collections). */
  deleteRegistration?: Maybe<Scalars["Boolean"]["output"]>
  /** Delete a given copy config link. This performs a HARD delete, and will not be recoverable. Only available to superusers. */
  deleteResourceCopyConfigLink?: Maybe<Scalars["String"]["output"]>
  /** Deletes an existing tag. */
  deleteTag?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes an existing tagAttachment, permanently. */
  deleteTagAttachment?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes an existing tagAttachment, permanently. */
  deleteTagLink?: Maybe<Scalars["Boolean"]["output"]>
  /** Delete a preference owned by the current user in this school. */
  deleteUserPreference: Scalars["Boolean"]["output"]
  /** Hard delete a WebhookEvent. */
  deleteWebhookEvent?: Maybe<Scalars["Boolean"]["output"]>
  /** Complete a deferred copy config by executing a copy config link. */
  executeDeferredResourceCopyConfig?: Maybe<DeferOrExecuteResourceCopyConfigResult>
  executePathSyncPlan?: Maybe<Scalars["Boolean"]["output"]>
  /** Updates user with require first_name and last_name fields, plus creates school membership and fulfills any pending orders. */
  finalizeAccount?: Maybe<User>
  /** Finalizes an external account link for a user in a school, associating them with an external ID after they complete the account linking process. */
  finalizeExternalAccountLink?: Maybe<ExternalAccountLink>
  /** Get a token with a username/email and password. Returns an auth token if successful. */
  getToken?: Maybe<Token>
  /** Get a token with a sso token. Returns an auth token if successful. */
  getTokenViaSSO?: Maybe<Token>
  /** Update the last time this user was active */
  heartbeat: Heartbeat
  /** Handles recording consent for a user-space membership, and creating that membership */
  joinSpace?: Maybe<Membership>
  /** Creates a new license for a resource */
  licenseResource?: Maybe<ResourceLicense>
  /** Pastes a path step or lesson from to the given path and location. */
  pastePathItem?: Maybe<PathItem>
  /** Issues an auth token for another user without replacing the caller's session. Superusers only. */
  proxyAuthToken?: Maybe<Scalars["String"]["output"]>
  publishPath?: Maybe<Path>
  /** Allows for updating the Space's Pathwright authentication settings. */
  publishPathToCodex?: Maybe<CodexPathPublish>
  /** Rdeems a subscription for the user. */
  redeemSchoolGiftSubscription?: Maybe<SchoolSubscription>
  /** Issues a new token to the current user */
  refreshToken?: Maybe<Scalars["String"]["output"]>
  /** Register a push token for user. */
  registerPushToken?: Maybe<Scalars["Boolean"]["output"]>
  /** Revokes access for all members inactive for the the last x days */
  removeAccessForInactiveMembers?: Maybe<Scalars["Boolean"]["output"]>
  /** Remove a push token for user. */
  removePushToken?: Maybe<Scalars["Boolean"]["output"]>
  reorderOffers?: Maybe<Scalars["Boolean"]["output"]>
  /** reorders two or more path items */
  reorderPathItems?: Maybe<Scalars["Boolean"]["output"]>
  /** Requests a password reset for a user (admin only) */
  requestPasswordReset?: Maybe<Scalars["Boolean"]["output"]>
  /** Resend an invitation email */
  resendInvitation?: Maybe<Invitation>
  resetCompletionFeedback?: Maybe<Completion>
  /** Resets a user's password based on a valid reset hash token (sent as part of a password reset email link) */
  resetPassword?: Maybe<Scalars["Boolean"]["output"]>
  /** Resets a previously completed or skipped path item */
  resetPathItem?: Maybe<PathItem>
  /** Resets a path item for a user */
  resetPathItemForUser?: Maybe<PathItem>
  saveCompletionFeedback?: Maybe<Completion>
  /** Schedules path item. */
  scheduleItem?: Maybe<PathItem>
  /** Sends email with gifted subscription details to gift recipient. */
  sendGiftSubscriptionEmail?: Maybe<Scalars["Boolean"]["output"]>
  /** Sets the member's access to the school */
  setMemberAccess?: Maybe<Membership>
  /** Archives/unarchives the user's membership to the school */
  setMemberArchived?: Maybe<Membership>
  /** Sets the member's role within the school */
  setMemberRole?: Maybe<Membership>
  /** Show/hide a given copy config link. */
  showHideResourceCopyConfigLink?: Maybe<ResourceCopyConfigLink>
  /** Sign out the current user */
  signOut?: Maybe<Scalars["Boolean"]["output"]>
  /** Sign up with an email and password. Returns the user if successful. */
  signUp?: Maybe<Token>
  /** Skips a path item for a user */
  skipPathItemForUser?: Maybe<PathItem>
  /** Soft archives a registration. */
  softArchiveRegistration?: Maybe<Registration>
  /** Allows a user to start a request to authenticate to their account outside normal username/password authentication. */
  startAuthRequest?: Maybe<AuthRequest>
  /** Sends a password reset email for a user */
  startPasswordRetrieval?: Maybe<Scalars["Boolean"]["output"]>
  syncPath?: Maybe<Path>
  /** Unarchives a path item and any related archived data. */
  unarchivePathItem?: Maybe<PathItem>
  /** Unlockss a path item with a password lock */
  unlockPathItem?: Maybe<PathItem>
  /** Updates an existing author */
  updateAuthor?: Maybe<Author>
  /** Update a banner */
  updateBanner?: Maybe<Banner>
  /** Update a banner's order */
  updateBannerOrder?: Maybe<Scalars["Boolean"]["output"]>
  /** Updates Blocks (DB) content with published metadata */
  updateBlocksContent?: Maybe<BlocksContent>
  /** Updates an existing category */
  updateCategory?: Maybe<Category>
  /** Updates a certificate */
  updateCertificate?: Maybe<Certificate>
  /** Updates the certificate_json keys of all resources */
  updateCertificateVariables?: Maybe<CertificateVariables>
  /** Creates a new contextualFeaturePermission */
  updateContextualFeaturePermission?: Maybe<ContextualFeaturePermission>
  updateDiscussion?: Maybe<Discussion>
  updateDiscussionResponse?: Maybe<Response>
  /** Creates a new cohort for a resource */
  updateGroup?: Maybe<Group>
  updateGroupDiscussionEnabled?: Maybe<Group>
  updateGroupStatus?: Maybe<Group>
  /** Updates an local translation files, used only in development of the Pathwright platform. */
  updateLocalTranslation?: Maybe<Scalars["JSON"]["output"]>
  /** Sets the member's profile data */
  updateMemberConsent?: Maybe<Membership>
  /** Updates an existing mentor group */
  updateMentorGroup?: Maybe<MentorGroup>
  /** Updates a mentor group membership */
  updateMentorGroupMembership?: Maybe<MentorGroupMembership>
  /** Updates a message. */
  updateMessage?: Maybe<Message>
  updateNote?: Maybe<Note>
  /** Update a user's notifciation digest interval. */
  updateNotificationDigestInterval?: Maybe<Profile>
  updateOffer?: Maybe<Offer>
  /** Update a page. */
  updatePage?: Maybe<Page>
  /** Update page orders. */
  updatePageOrders?: Maybe<Scalars["Boolean"]["output"]>
  /** updates a path item */
  updatePathItem?: Maybe<PathItem>
  /** Allows for updating the Space's Pathwright authentication settings. */
  updatePathwrightAuth?: Maybe<Space>
  /** Creates or updates the existing positioning objects for a given context. */
  updatePositionedObjects?: Maybe<Scalars["JSON"]["output"]>
  /** Updates the referral code for the current user */
  updateReferral?: Maybe<Referral>
  /** Updates a registration */
  updateRegistration?: Maybe<Registration>
  /** Updates an existing resource */
  updateResource?: Maybe<Resource>
  /** Update fields on the school */
  updateSchool?: Maybe<School>
  /** Processes and updates the custom CSS for a school */
  updateSchoolCustomCSS?: Maybe<Theme>
  /** Create a school with a name and domain. Returns the school if successful. */
  updateSchoolProfile?: Maybe<SchoolProfile>
  /** Create a school theme. */
  updateSchoolTheme?: Maybe<Theme>
  /** Updates an existing tag. */
  updateTag?: Maybe<Tag>
  /** Updates a new tagAttachment. Currently only updates the position of the tagAttachment. */
  updateTagAttachment?: Maybe<TagAttachment>
  /** Updates an existing translation */
  updateTranslation?: Maybe<Translation>
  /** Update user and user profile settings. */
  updateUser?: Maybe<User>
  updateUserDiscussionHistory?: Maybe<Discussion>
  /** Create or replace the entire JSON value for a key and scope owned by the current user in this school. */
  upsertUserPreference: UserPreference
}

export type MutationsAcceptCommunityGroupInvitationArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsAddPeopleToArgs = {
  notification_message?: InputMaybe<Scalars["String"]["input"]>
  selection: Array<InputMaybe<AddPeopleSelection>>
  send_from_school?: InputMaybe<Scalars["Boolean"]["input"]>
  send_notification?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsApiCompletionUpdateArgs = {
  action: ApiCompletionUpdateAction
  assign_points?: InputMaybe<Scalars["Float"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  step_source_id: Scalars["Int"]["input"]
  user_email?: InputMaybe<Scalars["String"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsAssignArgs = {
  assign_to_user: Scalars["Int"]["input"]
  assignment_message?: InputMaybe<Scalars["String"]["input"]>
  offerings: Array<InputMaybe<Scalars["Int"]["input"]>>
  role: RegistrationRoleEnum
  send_from_school?: InputMaybe<Scalars["Boolean"]["input"]>
  send_notification?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsBatchCreateMentorGroupMembershipArgs = {
  group: Scalars["Int"]["input"]
  role: MentorGroupMembershipRole
  user_ids?: InputMaybe<Array<Scalars["Int"]["input"]>>
}

export type MutationsBulkUpdatePathItemsArgs = {
  items: Array<PathItemBulkUpdateInput>
  path_id: Scalars["Int"]["input"]
}

export type MutationsCancelSchoolSubscriptionArgs = {
  cancel_immediately?: InputMaybe<Scalars["Boolean"]["input"]>
  for_user?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsChangePasswordArgs = {
  current_password: Scalars["String"]["input"]
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
}

export type MutationsCompletePathItemArgs = {
  completion_data?: InputMaybe<Scalars["JSON"]["input"]>
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  skip?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsConfirmAuthRequestArgs = {
  key: Scalars["String"]["input"]
  uuid: Scalars["UUID"]["input"]
}

export type MutationsCopyResourceArgs = {
  create_offering?: InputMaybe<Scalars["Boolean"]["input"]>
  create_registration_with_role?: InputMaybe<RegistrationRoleEnum>
  id: Scalars["Int"]["input"]
  to_school?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateAuthorArgs = {
  avatar?: InputMaybe<Scalars["String"]["input"]>
  bio: Scalars["String"]["input"]
  first_name: Scalars["String"]["input"]
  last_name: Scalars["String"]["input"]
  order: Scalars["Int"]["input"]
  salutation: Scalars["String"]["input"]
  title: Scalars["String"]["input"]
}

export type MutationsCreateBannerArgs = {
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_image_raw?: InputMaybe<Scalars["String"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  heading?: InputMaybe<Scalars["String"]["input"]>
  hide_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  hide_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  show_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  show_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  subhead?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreateBlocksContentArgs = {
  content_last_modified?: InputMaybe<Scalars["DateTime"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateCategoryArgs = {
  description: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  order: Scalars["Int"]["input"]
}

export type MutationsCreateCertificateArgs = {
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  template: Scalars["String"]["input"]
  text_objects?: InputMaybe<Array<InputMaybe<TextObject>>>
}

export type MutationsCreateContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
  permission_in_context: FeaturePermission
}

export type MutationsCreateCurriculumLicenseOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licensor_school_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateCurriculumSubscriptionOrderArgs = {
  curriculum_plan_id: Scalars["Int"]["input"]
  licensee_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateDiscussionArgs = {
  context: DiscussionContextInput
  initialResponse?: InputMaybe<DiscussionResponseInput>
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
  post: DiscussionPostInput
}

export type MutationsCreateDiscussionLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsCreateDiscussionResponseArgs = {
  context: DiscussionContextInput
  response: DiscussionResponseInput
}

export type MutationsCreateDiscussionResponseLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}

export type MutationsCreateDiscussionSubscriptionArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsCreateExternalAccountLinkArgs = {
  external_id: Scalars["String"]["input"]
  link_type?: InputMaybe<ExternalAccountType>
  linked_oidc_idp_id?: InputMaybe<Scalars["Int"]["input"]>
  linked_saml2_idp_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id: Scalars["Int"]["input"]
}

export type MutationsCreateGiftSubscriptionOrderArgs = {
  gift_message?: InputMaybe<Scalars["String"]["input"]>
  num_cycles: Scalars["Int"]["input"]
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  recipient_first_name: Scalars["String"]["input"]
  recipient_last_name: Scalars["String"]["input"]
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateGroupArgs = {
  base_resource_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  parent_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RegistrationRoleEnum>
  visibility: Scalars["Int"]["input"]
}

export type MutationsCreateGroupLicenseOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateGroupSubscriptionOrderArgs = {
  group_name: Scalars["String"]["input"]
  price_id: Scalars["Int"]["input"]
  quantity: Scalars["Int"]["input"]
  reactivate_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateInvitationsArgs = {
  context?: InputMaybe<InvitationContext>
  invitation_message?: InputMaybe<Scalars["String"]["input"]>
  invitation_subject?: InputMaybe<Scalars["String"]["input"]>
  invite_emails: Array<InputMaybe<Scalars["String"]["input"]>>
  invite_to_cohort_role?: InputMaybe<RegistrationRoleEnum>
  invite_to_community_group_role?: InputMaybe<MentorGroupMembershipRole>
  invite_to_school_role?: InputMaybe<MembershipRole>
  send_from_school?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<InvitationType>
}

export type MutationsCreateLifetimeSchoolSubscriptionOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateMembershipForExistingUserArgs = {
  role?: InputMaybe<MembershipRole>
  user_email: Scalars["String"]["input"]
}

export type MutationsCreateMentorGroupArgs = {
  name: Scalars["String"]["input"]
  parent?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MutationsCreateMentorGroupMembershipArgs = {
  group: Scalars["Int"]["input"]
  role: MentorGroupMembershipRole
  user: Scalars["Int"]["input"]
}

export type MutationsCreateMessageArgs = {
  message: MessageInput
  message_context: MessageContext
}

export type MutationsCreateNoteArgs = {
  context: ContextModelInput
  note: NoteInput
}

export type MutationsCreateNotificationArgs = {
  input: NotificationInput
}

export type MutationsCreateOfferArgs = {
  offer: StoreOfferInput
  resource_id: Scalars["Int"]["input"]
}

export type MutationsCreateOrderArgs = {
  curriculum_license?: InputMaybe<CurriculumLicenseOrderData>
  curriculum_subscription?: InputMaybe<CurriculumSubscriptionOrderData>
  gift_subscription?: InputMaybe<GiftSubscriptionOrderData>
  group_license?: InputMaybe<GroupLicenseOrderData>
  group_subscription?: InputMaybe<GroupSubscriptionOrderData>
  lifetime_school_subscription?: InputMaybe<LifetimeSchoolSubscriptionOrderData>
  platform_subscription?: InputMaybe<PlatformSubscriptionOrderData>
  registration?: InputMaybe<RegistrationOrderData>
  school_subscription?: InputMaybe<SchoolSubscriptionOrderData>
}

export type MutationsCreatePageArgs = {
  mode?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreatePasswordArgs = {
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
}

export type MutationsCreatePathItemArgs = {
  assignment_type?: InputMaybe<PathItemAssignmentType>
  content_resource?: InputMaybe<Scalars["Int"]["input"]>
  content_type?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
  order: Scalars["Int"]["input"]
  parent?: InputMaybe<Scalars["Int"]["input"]>
  path_id: Scalars["Int"]["input"]
  type: PathItemType
}

export type MutationsCreatePlatformSubscriptionOrderArgs = {
  billing_plan_id: Scalars["Int"]["input"]
  interval: Scalars["Int"]["input"]
  school_id?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateRegistrationOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  invitation_code?: InputMaybe<Scalars["String"]["input"]>
  offering_id: Scalars["Int"]["input"]
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  use_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateRegistrationUpsertGroupArgs = {
  create_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_offering_id: Scalars["Int"]["input"]
  resource_id: Scalars["Int"]["input"]
  step_source_id: Scalars["Int"]["input"]
}

export type MutationsCreateResourceArgs = {
  cover_image: Scalars["String"]["input"]
  group_name?: InputMaybe<Scalars["String"]["input"]>
  group_role?: InputMaybe<RegistrationRoleEnum>
  name: Scalars["String"]["input"]
  resource_type?: InputMaybe<ResourceType>
}

export type MutationsCreateSchoolArgs = {
  copy?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  head_markup?: InputMaybe<Scalars["String"]["input"]>
  licensor_id?: InputMaybe<Scalars["Int"]["input"]>
  name: Scalars["String"]["input"]
  rewardful_referral_id?: InputMaybe<Scalars["String"]["input"]>
  script_markup?: InputMaybe<Scalars["String"]["input"]>
  signup_config_key?: InputMaybe<Scalars["String"]["input"]>
  subdomain: Scalars["String"]["input"]
  theme?: InputMaybe<ThemeInput>
  utm_campaign?: InputMaybe<Scalars["String"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_source?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreateSchoolSubscriptionOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  start_free_trial?: InputMaybe<Scalars["Boolean"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type MutationsCreateSchoolThemeArgs = {
  theme: ThemeInput
}

export type MutationsCreateStoreLinkArgs = {
  copy?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  school_id: Scalars["Int"]["input"]
}

export type MutationsCreateStorefrontArgs = {
  autoAddPublicResources?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsCreateTagArgs = {
  tag: TagCreateInput
}

export type MutationsCreateTagAttachmentArgs = {
  context: TagAttachmentContextInput
  position?: InputMaybe<Scalars["String"]["input"]>
  tag_id: Scalars["Int"]["input"]
}

export type MutationsCreateTagLinkArgs = {
  context: TagLinkContextInput
  tag_id: Scalars["Int"]["input"]
}

export type MutationsCreateTranslationArgs = {
  translation: Scalars["JSON"]["input"]
}

export type MutationsDeferOrExecuteResourceCopyConfigArgs = {
  copy_code: Scalars["String"]["input"]
  target_school_id: Scalars["Int"]["input"]
}

export type MutationsDeleteBannerArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteCertificateArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
}

export type MutationsDeleteDiscussionArgs = {
  context: DiscussionContextInput
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionResponseArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionResponseLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionSubscriptionArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsDeleteInvitationArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteMentorGroupArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteMentorGroupMembershipArgs = {
  group: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteMessageArgs = {
  id: Scalars["Int"]["input"]
  message_context: MessageContext
}

export type MutationsDeleteNoteArgs = {
  context: ContextModelInput
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteOfferArgs = {
  id: Scalars["Int"]["input"]
  resource_id: Scalars["Int"]["input"]
}

export type MutationsDeletePathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsDeletePositioningContextArgs = {
  context: PositioningContextInput
}

export type MutationsDeleteRegistrationArgs = {
  group_id: Scalars["Int"]["input"]
  registration_id: Scalars["Int"]["input"]
}

export type MutationsDeleteResourceCopyConfigLinkArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteTagArgs = {
  tag: TagDeleteInput
}

export type MutationsDeleteTagAttachmentArgs = {
  context: TagAttachmentContextInput
  tag_id: Scalars["Int"]["input"]
}

export type MutationsDeleteTagLinkArgs = {
  context: TagLinkContextInput
  tag_id: Scalars["Int"]["input"]
}

export type MutationsDeleteUserPreferenceArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteWebhookEventArgs = {
  uuid: Scalars["UUID"]["input"]
}

export type MutationsExecuteDeferredResourceCopyConfigArgs = {
  link_id: Scalars["Int"]["input"]
}

export type MutationsExecutePathSyncPlanArgs = {
  sync_plan?: InputMaybe<PathSyncPlanInput>
}

export type MutationsFinalizeAccountArgs = {
  avatar?: InputMaybe<Scalars["String"]["input"]>
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  first_name: Scalars["String"]["input"]
  last_name: Scalars["String"]["input"]
  password1?: InputMaybe<Scalars["String"]["input"]>
  password2?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsFinalizeExternalAccountLinkArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsGetTokenArgs = {
  invite_token?: InputMaybe<Scalars["String"]["input"]>
  password: Scalars["String"]["input"]
  username: Scalars["String"]["input"]
}

export type MutationsGetTokenViaSsoArgs = {
  sso_token: Scalars["String"]["input"]
}

export type MutationsJoinSpaceArgs = {
  consent: Scalars["Boolean"]["input"]
  invite_token?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsLicenseResourceArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  payment_token?: InputMaybe<Scalars["String"]["input"]>
  resource_id: Scalars["Int"]["input"]
  role?: InputMaybe<LicenseRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsPastePathItemArgs = {
  item_id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
  parent_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id: Scalars["Int"]["input"]
}

export type MutationsProxyAuthTokenArgs = {
  school_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id: Scalars["Int"]["input"]
}

export type MutationsPublishPathArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsPublishPathToCodexArgs = {
  override_id?: InputMaybe<Scalars["String"]["input"]>
  path_id: Scalars["Int"]["input"]
  suffix?: InputMaybe<Scalars["String"]["input"]>
  upsert?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsRedeemSchoolGiftSubscriptionArgs = {
  code?: InputMaybe<Scalars["String"]["input"]>
  school_subscription_plan_id: Scalars["Int"]["input"]
}

export type MutationsRefreshTokenArgs = {
  school_id?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationsRegisterPushTokenArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsRemoveAccessForInactiveMembersArgs = {
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsRemovePushTokenArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsReorderOffersArgs = {
  input: StoreOfferReorderInput
  resource_id: Scalars["Int"]["input"]
}

export type MutationsReorderPathItemsArgs = {
  items: Array<InputMaybe<PathItemOrder>>
  path_id: Scalars["Int"]["input"]
}

export type MutationsRequestPasswordResetArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsResendInvitationArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsResetCompletionFeedbackArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsResetPasswordArgs = {
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
  reset_hash: Scalars["String"]["input"]
}

export type MutationsResetPathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsResetPathItemForUserArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsSaveCompletionFeedbackArgs = {
  id: Scalars["Int"]["input"]
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
  path_id: Scalars["Int"]["input"]
  userpoints_earned: Scalars["Int"]["input"]
  userpoints_explanation?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsScheduleItemArgs = {
  due?: InputMaybe<Scalars["DateTime"]["input"]>
  passive_due?: InputMaybe<Scalars["Boolean"]["input"]>
  passive_starts?: InputMaybe<Scalars["Boolean"]["input"]>
  schedule_context: ScheduleItemContext
  starts?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type MutationsSendGiftSubscriptionEmailArgs = {
  gift_id: Scalars["Int"]["input"]
  recipient_email: Scalars["String"]["input"]
}

export type MutationsSetMemberAccessArgs = {
  has_access: Scalars["Boolean"]["input"]
  id: Scalars["Int"]["input"]
}

export type MutationsSetMemberArchivedArgs = {
  id: Scalars["Int"]["input"]
  is_archived: Scalars["Boolean"]["input"]
}

export type MutationsSetMemberRoleArgs = {
  id: Scalars["Int"]["input"]
  role: MembershipRole
}

export type MutationsShowHideResourceCopyConfigLinkArgs = {
  hide?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
  id: Scalars["Int"]["input"]
  show?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
}

export type MutationsSignUpArgs = {
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  create_membership?: InputMaybe<Scalars["Boolean"]["input"]>
  email: Scalars["String"]["input"]
  first_name: Scalars["String"]["input"]
  invite_token?: InputMaybe<Scalars["String"]["input"]>
  last_name: Scalars["String"]["input"]
  password?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsSkipPathItemForUserArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsSoftArchiveRegistrationArgs = {
  id: Scalars["Int"]["input"]
  softArchive?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsStartAuthRequestArgs = {
  email?: InputMaybe<Scalars["EmailAddress"]["input"]>
  method: AuthRequestMethod
  next_url?: InputMaybe<Scalars["String"]["input"]>
  username?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsStartPasswordRetrievalArgs = {
  email: Scalars["String"]["input"]
  next_url?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsSyncPathArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsUnarchivePathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsUnlockPathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  step_lock_password: Scalars["String"]["input"]
}

export type MutationsUpdateAuthorArgs = {
  avatar?: InputMaybe<Scalars["String"]["input"]>
  bio?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  last_name?: InputMaybe<Scalars["String"]["input"]>
  salutation?: InputMaybe<Scalars["String"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdateBannerArgs = {
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_image_raw?: InputMaybe<Scalars["String"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  heading?: InputMaybe<Scalars["String"]["input"]>
  hide_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  hide_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  id: Scalars["Int"]["input"]
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  show_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  show_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  subhead?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdateBannerOrderArgs = {
  banner_orders: Array<InputMaybe<ListOrderInput>>
}

export type MutationsUpdateBlocksContentArgs = {
  content_last_modified?: InputMaybe<Scalars["DateTime"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  last_published?: InputMaybe<Scalars["DateTime"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsUpdateCategoryArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdateCertificateArgs = {
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  template?: InputMaybe<Scalars["String"]["input"]>
  text_objects?: InputMaybe<Array<InputMaybe<TextObject>>>
}

export type MutationsUpdateCertificateVariablesArgs = {
  context?: InputMaybe<CertificateVariablesContextInput>
  merge: Array<InputMaybe<CertificateVariablesMergeInput>>
}

export type MutationsUpdateContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
  permission_in_context: FeaturePermission
}

export type MutationsUpdateDiscussionArgs = {
  context: DiscussionContextInput
  id: Scalars["Int"]["input"]
  post: DiscussionPostInput
}

export type MutationsUpdateDiscussionResponseArgs = {
  context: DiscussionContextInput
  response: DiscussionResponseInput
  response_id: Scalars["Int"]["input"]
}

export type MutationsUpdateGroupArgs = {
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  group_id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  visibility?: InputMaybe<GroupVisibility>
}

export type MutationsUpdateGroupDiscussionEnabledArgs = {
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
}

export type MutationsUpdateGroupStatusArgs = {
  id: Scalars["Int"]["input"]
  status?: InputMaybe<GroupStatus>
}

export type MutationsUpdateLocalTranslationArgs = {
  translation: Scalars["JSON"]["input"]
}

export type MutationsUpdateMemberConsentArgs = {
  consents?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateMentorGroupArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  parent?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MutationsUpdateMentorGroupMembershipArgs = {
  can_review?: InputMaybe<Scalars["Boolean"]["input"]>
  group: Scalars["Int"]["input"]
  has_access?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  role?: InputMaybe<MentorGroupMembershipRole>
  send_mentor_digest?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateMessageArgs = {
  id: Scalars["Int"]["input"]
  message: MessageInput
  message_context: MessageContext
}

export type MutationsUpdateNoteArgs = {
  context: ContextModelInput
  id: Scalars["Int"]["input"]
  note: NoteInput
}

export type MutationsUpdateNotificationDigestIntervalArgs = {
  interval?: InputMaybe<NotificationDigestInterval>
}

export type MutationsUpdateOfferArgs = {
  id: Scalars["Int"]["input"]
  offer: StoreOfferPatchInput
  resource_id: Scalars["Int"]["input"]
}

export type MutationsUpdatePageArgs = {
  content_type?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  external_url?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  iframe_url?: InputMaybe<Scalars["String"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  mode?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  order?: InputMaybe<Scalars["Int"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  scripts?: InputMaybe<Scalars["String"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
  template_content?: InputMaybe<Scalars["String"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdatePageOrdersArgs = {
  page_orders?: InputMaybe<Array<InputMaybe<ListOrderInput>>>
}

export type MutationsUpdatePathItemArgs = {
  allow_resets?: InputMaybe<Scalars["Int"]["input"]>
  assignment_type?: InputMaybe<PathItemAssignmentType>
  completion_comment_required_status?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  grading_type?: InputMaybe<Scalars["String"]["input"]>
  is_previewable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  lock_password?: InputMaybe<Scalars["String"]["input"]>
  minimum_passing_score?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  order: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  points?: InputMaybe<Scalars["Int"]["input"]>
  requires_api_completion?: InputMaybe<Scalars["Boolean"]["input"]>
  show_grading_feedback?: InputMaybe<Scalars["Int"]["input"]>
  source_id: Scalars["Int"]["input"]
  time_to_complete?: InputMaybe<Scalars["Int"]["input"]>
  type: PathItemType
}

export type MutationsUpdatePathwrightAuthArgs = {
  allow_public_signup: Scalars["Boolean"]["input"]
  always_prompt_for_password: Scalars["Boolean"]["input"]
  pathwright_login_enabled: Scalars["Boolean"]["input"]
}

export type MutationsUpdatePositionedObjectsArgs = {
  context: PositioningContextInput
  positions: Array<InputMaybe<PositionedObjectPositionInput>>
}

export type MutationsUpdateReferralArgs = {
  referral: Scalars["String"]["input"]
}

export type MutationsUpdateRegistrationArgs = {
  completion_state?: InputMaybe<CompletionStateFilter>
  expiration_dtime?: InputMaybe<Scalars["DateTime"]["input"]>
  id: Scalars["Int"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateResourceArgs = {
  authors?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  categories?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  certificate_generator_class?: InputMaybe<Scalars["String"]["input"]>
  certificate_json?: InputMaybe<Scalars["JSON"]["input"]>
  cover_image?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  short_description?: InputMaybe<Scalars["String"]["input"]>
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsUpdateSchoolArgs = {
  analytics_account_id?: InputMaybe<Scalars["String"]["input"]>
  consent_description?: InputMaybe<Scalars["String"]["input"]>
  grant_access_upon_authentication?: InputMaybe<Scalars["Boolean"]["input"]>
  has_certificate?: InputMaybe<Scalars["Boolean"]["input"]>
  head_markup?: InputMaybe<Scalars["String"]["input"]>
  image?: InputMaybe<Scalars["String"]["input"]>
  intercom_access_token?: InputMaybe<Scalars["String"]["input"]>
  intercom_app_id?: InputMaybe<Scalars["String"]["input"]>
  intercom_secret_key?: InputMaybe<Scalars["String"]["input"]>
  logo_image?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  pathwright_login_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  script_markup?: InputMaybe<Scalars["String"]["input"]>
  short_description?: InputMaybe<Scalars["String"]["input"]>
  stripe_access_token?: InputMaybe<Scalars["String"]["input"]>
  subdomain?: InputMaybe<Scalars["String"]["input"]>
  support_email?: InputMaybe<Scalars["String"]["input"]>
  support_phone?: InputMaybe<Scalars["String"]["input"]>
  support_policy?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdateSchoolCustomCssArgs = {
  custom_css: Scalars["String"]["input"]
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}

export type MutationsUpdateSchoolProfileArgs = {
  coach_or_tutor?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  other?: InputMaybe<Scalars["String"]["input"]>
  plan_to_sell?: InputMaybe<Scalars["Boolean"]["input"]>
  publish_multiple_courses?: InputMaybe<Scalars["Boolean"]["input"]>
  publish_one_course?: InputMaybe<Scalars["Boolean"]["input"]>
  school_type?: InputMaybe<SchoolType>
  teach_formal_classes?: InputMaybe<Scalars["Boolean"]["input"]>
  train_team_customers?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateSchoolThemeArgs = {
  id: Scalars["Int"]["input"]
  theme: ThemeInput
}

export type MutationsUpdateTagArgs = {
  tag: TagUpdateInput
}

export type MutationsUpdateTagAttachmentArgs = {
  context: TagAttachmentContextInput
  position?: InputMaybe<Scalars["String"]["input"]>
  tag_id: Scalars["Int"]["input"]
}

export type MutationsUpdateTranslationArgs = {
  id: Scalars["Int"]["input"]
  translation: Scalars["JSON"]["input"]
}

export type MutationsUpdateUserArgs = {
  profile: UserProfileInput
  user: UserInput
}

export type MutationsUpdateUserDiscussionHistoryArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsUpsertUserPreferenceArgs = {
  data: Scalars["JSON"]["input"]
  key: Scalars["String"]["input"]
  scope?: InputMaybe<Scalars["String"]["input"]>
}

export enum NodeColorMode {
  Dark = "dark",
  Light = "light"
}

export enum NodeColorTone {
  Muted = "muted",
  Vibrant = "vibrant"
}

export type NodeImage = {
  __typename?: "NodeImage"
  color?: Maybe<Scalars["String"]["output"]>
  height?: Maybe<Scalars["Int"]["output"]>
  raw_src?: Maybe<Scalars["String"]["output"]>
  src?: Maybe<Scalars["String"]["output"]>
  width?: Maybe<Scalars["Int"]["output"]>
}

export type NodeImageColorArgs = {
  alpah?: InputMaybe<Scalars["Int"]["input"]>
  mode?: InputMaybe<NodeColorMode>
  tone?: InputMaybe<NodeColorTone>
}

export enum NodeImageFit {
  Clamp = "clamp",
  Clip = "clip",
  Crop = "crop",
  Facearea = "facearea",
  Fill = "fill"
}

export enum NodeImageFormat {
  Blurhash = "blurhash",
  Default = "default",
  Gif = "gif",
  Jpg = "jpg",
  Png = "png",
  Webp = "webp"
}

export enum NodeImageMask {
  BannerCover = "banner_cover"
}

export enum NodeImageSize {
  Lg = "lg",
  Md = "md",
  Sm = "sm",
  Xl = "xl"
}

export type NodeMeta = {
  __typename?: "NodeMeta"
  _search?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  icon?: Maybe<Scalars["String"]["output"]>
  id: Scalars["String"]["output"]
  image?: Maybe<NodeImage>
  key: Scalars["String"]["output"]
  keywords?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  subtitle?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  type: Scalars["String"]["output"]
  url?: Maybe<Scalars["String"]["output"]>
}

export type NodeMetaImageArgs = {
  ar?: InputMaybe<Scalars["String"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  brightness?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<NodeImageFit>
  format?: InputMaybe<NodeImageFormat>
  height?: InputMaybe<Scalars["Int"]["input"]>
  mask?: InputMaybe<NodeImageMask>
  size?: InputMaybe<NodeImageSize>
  vibrance?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type NodeTheme = {
  __typename?: "NodeTheme"
  background?: Maybe<NodeThemeBackground>
  color: Scalars["String"]["output"]
  color_palette?: Maybe<NodeThemeColorPalette>
  fonts?: Maybe<NodeThemeFonts>
}

export type NodeThemeBackground = {
  __typename?: "NodeThemeBackground"
  color?: Maybe<Scalars["String"]["output"]>
  contrast_color?: Maybe<Scalars["String"]["output"]>
  image?: Maybe<NodeImage>
  luminence?: Maybe<Scalars["Float"]["output"]>
}

export type NodeThemeBackgroundImageArgs = {
  ar?: InputMaybe<Scalars["String"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  brightness?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<NodeImageFit>
  format?: InputMaybe<NodeImageFormat>
  height?: InputMaybe<Scalars["Int"]["input"]>
  mask?: InputMaybe<NodeImageMask>
  size?: InputMaybe<NodeImageSize>
  vibrance?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type NodeThemeColorPalette = {
  __typename?: "NodeThemeColorPalette"
  _50?: Maybe<Scalars["String"]["output"]>
  _100?: Maybe<Scalars["String"]["output"]>
  _200?: Maybe<Scalars["String"]["output"]>
  _300?: Maybe<Scalars["String"]["output"]>
  _400?: Maybe<Scalars["String"]["output"]>
  _500?: Maybe<Scalars["String"]["output"]>
  _600?: Maybe<Scalars["String"]["output"]>
  _700?: Maybe<Scalars["String"]["output"]>
  _800?: Maybe<Scalars["String"]["output"]>
  _900?: Maybe<Scalars["String"]["output"]>
  _950?: Maybe<Scalars["String"]["output"]>
}

export type NodeThemeFonts = {
  __typename?: "NodeThemeFonts"
  body?: Maybe<Scalars["String"]["output"]>
  subtitle?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
}

/** Pathwright note */
export type Note = {
  __typename?: "Note"
  body: Scalars["String"]["output"]
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  context_id: Scalars["Int"]["output"]
  created_from_cohort_id?: Maybe<Scalars["Int"]["output"]>
  created_time: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  modified_time: Scalars["DateTime"]["output"]
  resource_id?: Maybe<Scalars["Int"]["output"]>
  step_id?: Maybe<Scalars["Int"]["output"]>
  title: Scalars["String"]["output"]
  user: User
  visibility: NoteVisibility
}

/** A connection to a list of items. */
export type NoteConnection = {
  __typename?: "NoteConnection"
  /** A list of edges. */
  edges: Array<NoteEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type NoteEdge = {
  __typename?: "NoteEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Note
}

export type NoteInput = {
  body: Scalars["String"]["input"]
  title: Scalars["String"]["input"]
  visibility: NoteVisibility
}

export enum NoteVisibility {
  Author = "author",
  Everyone = "everyone",
  Staff = "staff"
}

/** The action of the notification */
export enum NotificationAction {
  /** The user has been asked to answer a discussion */
  DiscussionAskToAnswer = "DISCUSSION_ASK_TO_ANSWER",
  /** The user has been asked to reply to a discussion response */
  ResponseAskToReply = "RESPONSE_ASK_TO_REPLY"
}

export type NotificationContextModelInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  /** Required for using discussion and response actions. */
  discussion_context_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  path_item_id?: InputMaybe<Scalars["Int"]["input"]>
  path_item_source_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum NotificationDigestInterval {
  Daily = "daily",
  Never = "never",
  Weekly = "weekly"
}

export type NotificationInput = {
  /** NotificationAction enum value representing the action type */
  action: NotificationAction
  /** Context for contextualizing the notification */
  context: NotificationContextModelInput
  /** Optional custom message for the notification */
  message?: InputMaybe<Scalars["String"]["input"]>
  /** Whether to send accompanying email notification, limited to certain actions */
  send_email?: InputMaybe<Scalars["Boolean"]["input"]>
  /** Target resource */
  target: NotificationTarget
  /** ID of the target resource */
  target_id: Scalars["Int"]["input"]
  /** List of user IDs to send notification to */
  to_users: Array<Scalars["Int"]["input"]>
}

/** The target resource of the notification */
export enum NotificationTarget {
  /** A discussion */
  Discussion = "DISCUSSION",
  /** A discussion response */
  Response = "RESPONSE"
}

/** An Offer, a way of offering a Path. */
export type Offer = {
  __typename?: "Offer"
  /** Offer access state and description. */
  access: OfferAccess
  /** The date when the source associated with the Offer stops being available. */
  availability_ends?: Maybe<Scalars["DateTime"]["output"]>
  /** The date when the source associated with the Offer becomes available. */
  availability_starts?: Maybe<Scalars["DateTime"]["output"]>
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  /** The title of the Cohort associated with the Offer. */
  cohort_name?: Maybe<Scalars["String"]["output"]>
  cover_page_id: Scalars["Int"]["output"]
  created: Scalars["DateTime"]["output"]
  cta_label?: Maybe<Scalars["String"]["output"]>
  /** The description of the Offer, as configured on the store Offer. */
  description?: Maybe<Scalars["String"]["output"]>
  external_url?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  /** The kind of the Offer. */
  kind: OfferKind
  modified: Scalars["DateTime"]["output"]
  position?: Maybe<Scalars["String"]["output"]>
  price_options: Array<OfferPriceOption>
  published_time?: Maybe<Scalars["DateTime"]["output"]>
  resource_license_offering_id?: Maybe<Scalars["Int"]["output"]>
  /** The ID of the school offering the Offer. */
  school_id: Scalars["Int"]["output"]
  /** The scope of the Offer. */
  scope: OfferScope
  /** The title of the Offer, as configured on the store Offer. */
  title: Scalars["String"]["output"]
  /** The visibility of the source associated with the Offer. */
  visibility?: Maybe<Scalars["Int"]["output"]>
}

export type OfferAccess = {
  __typename?: "OfferAccess"
  /** The date the user converted the offer. */
  conversion_date?: Maybe<Scalars["DateTime"]["output"]>
  /** A description of the access limits of the Offer (seats, duration, etc.). */
  meta: Array<Maybe<Scalars["String"]["output"]>>
  /** The state of the access associated with the Offer. */
  state: OfferAccessState
}

/** The various states an Offer access can be in. */
export enum OfferAccessState {
  /** User is registered with active access to the Cohort. */
  Active = "ACTIVE",
  /** User has opportunity to access the Cohort. */
  Available = "AVAILABLE",
  /** User has no access to the Cohort. This could be due to expired registration or Cohort access limits (seats, duration, etc.), or lack of invite token for Private offers or lack of membership for Members-only offers. */
  Unavailable = "UNAVAILABLE"
}

/** A connection to a list of items. */
export type OfferConnection = {
  __typename?: "OfferConnection"
  /** A list of edges. */
  edges: Array<OfferEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type OfferContext = {
  /** Optional cohort invite JWT (?ic=) to include a hidden offer. */
  invite_token?: InputMaybe<Scalars["String"]["input"]>
  /** Optionally scope offers to a specific licensor school. */
  licensor_school_id?: InputMaybe<Scalars["Int"]["input"]>
  /** Offers for the given Resource. */
  resource_id: Scalars["Int"]["input"]
}

/** An edge in a connection. */
export type OfferEdge = {
  __typename?: "OfferEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Offer
}

/** The kind of the Offer. */
export enum OfferKind {
  CreateCohort = "CREATE_COHORT",
  External = "EXTERNAL",
  JoinCohort = "JOIN_COHORT",
  LicenseToSpace = "LICENSE_TO_SPACE"
}

/** The type of payment required for the Offer. */
export enum OfferPaymentType {
  /** Offer requires no payment. */
  Free = "FREE",
  /** Offer requires a one-off payment. */
  OneOff = "ONE_OFF",
  /** Offer requires a subscription payment. */
  Subscription = "SUBSCRIPTION"
}

export type OfferPriceOption = {
  __typename?: "OfferPriceOption"
  /** The label for the button associated with the Offer. */
  button_label: Scalars["String"]["output"]
  /** The label for the option associated with the Offer. */
  option_label: Scalars["String"]["output"]
  /** The type of the option associated with the Offer. */
  payment_type?: Maybe<OfferPaymentType>
  /** A description of the price for the Offer, providing details about the cost or payment options. */
  price_description: Scalars["String"]["output"]
}

/** The scope of the Offer to an individual ranging from becoming a member of a Cohort to licensing the entire Path for their Learning Space. */
export enum OfferScope {
  /** Offer is for user to create their own Cohort. */
  Cohort = "COHORT",
  /** Offer is for user to become a member of a Cohort. */
  Member = "MEMBER",
  /** Offer is for user to add the Path to their Learning Space. */
  Path = "PATH"
}

/** A Pathwright Order */
export type Order = {
  __typename?: "Order"
  checkout_session_id?: Maybe<Scalars["String"]["output"]>
  fulfilled_object_id?: Maybe<Scalars["Int"]["output"]>
  id: Scalars["Int"]["output"]
  order_data?: Maybe<Scalars["JSON"]["output"]>
  order_status: OrderStatus
  order_type: OrderType
  processor_id?: Maybe<Scalars["Int"]["output"]>
  school_id: Scalars["Int"]["output"]
  /** Publishable key for the Stripe account that created this order's Checkout Session. Used with checkout_session_id to redirect to Stripe Checkout. Prefers the processor (Connect / licensor) school, then the order school. */
  stripe_publishable_api_key?: Maybe<Scalars["String"]["output"]>
  user_id: Scalars["Int"]["output"]
}

/** Order query results by 'asc' or 'desc'. */
export enum OrderByDir {
  Asc = "ASC",
  Desc = "DESC"
}

/** A connection to a list of items. */
export type OrderConnection = {
  __typename?: "OrderConnection"
  /** A list of edges. */
  edges: Array<OrderEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: "OrderEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Order
}

export enum OrderStatus {
  AwaitingPayment = "awaiting_payment",
  Fulfilled = "fulfilled",
  FulfillmentFailed = "fulfillment_failed",
  FulfillmentInProgress = "fulfillment_in_progress",
  FulfillmentPending = "fulfillment_pending",
  PaymentFailed = "payment_failed",
  PaymentPending = "payment_pending",
  Voided = "voided"
}

/** The URLs to redirect to after the Stripe Checkout session is completed or cancelled. */
export type OrderStripeCheckoutRedirects = {
  cancel_url?: InputMaybe<Scalars["String"]["input"]>
  success_url?: InputMaybe<Scalars["String"]["input"]>
}

export enum OrderType {
  CurriculumLicense = "curriculum_license",
  CurriculumSubscription = "curriculum_subscription",
  GiftSubscription = "gift_subscription",
  GroupLicense = "group_license",
  GroupSubscription = "group_subscription",
  LifetimeSchoolSubscription = "lifetime_school_subscription",
  PlatformSubscription = "platform_subscription",
  Registration = "registration",
  SchoolSubscription = "school_subscription"
}

/** A signup configuration package for a Learning Space. */
export type Package = {
  __typename?: "Package"
  assignment_rules?: Maybe<Array<Maybe<PackageAssignmentRule>>>
  billing_plan_set_id?: Maybe<Scalars["Int"]["output"]>
  color?: Maybe<Scalars["String"]["output"]>
  /** Stripe coupon percent off for this package, from payment_stripecoupon joined on signup_schoolsignupconfig.coupon_id = payment_stripecoupon.id */
  coupon_discount?: Maybe<Scalars["Float"]["output"]>
  coupon_id?: Maybe<Scalars["Int"]["output"]>
  default_billing_plan_id?: Maybe<Scalars["Int"]["output"]>
  default_school_theme?: Maybe<Scalars["JSON"]["output"]>
  default_school_type?: Maybe<Scalars["String"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  internal_notes?: Maybe<Scalars["String"]["output"]>
  is_active?: Maybe<Scalars["Boolean"]["output"]>
  key?: Maybe<Scalars["String"]["output"]>
  metadata?: Maybe<Scalars["JSON"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  partner_school_id?: Maybe<Scalars["Int"]["output"]>
  pathicon?: Maybe<Scalars["String"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  public_description?: Maybe<Scalars["String"]["output"]>
  school_id?: Maybe<Scalars["Int"]["output"]>
  trial_behavior?: Maybe<Scalars["String"]["output"]>
  trial_days_override?: Maybe<Scalars["Int"]["output"]>
}

/** A resolved package assignment recorded for a school. */
export type PackageAssignment = {
  __typename?: "PackageAssignment"
  assignment_rule?: Maybe<PackageAssignmentRule>
  assignment_rule_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  package?: Maybe<Package>
  rewardful_referral_id?: Maybe<Scalars["String"]["output"]>
  school_id?: Maybe<Scalars["Int"]["output"]>
  school_signup_config_id?: Maybe<Scalars["Int"]["output"]>
  selected_by_user?: Maybe<Scalars["Int"]["output"]>
  utm_campaign?: Maybe<Scalars["String"]["output"]>
  utm_medium?: Maybe<Scalars["String"]["output"]>
  utm_source?: Maybe<Scalars["String"]["output"]>
}

/** An assignment rule used to resolve a package during signup. */
export type PackageAssignmentRule = {
  __typename?: "PackageAssignmentRule"
  assignment_type?: Maybe<Scalars["String"]["output"]>
  explicit_key?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  is_active?: Maybe<Scalars["Boolean"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  rewardful_referral_id?: Maybe<Scalars["String"]["output"]>
  school_signup_config_id?: Maybe<Scalars["Int"]["output"]>
  store_id?: Maybe<Scalars["Int"]["output"]>
  utm_campaign?: Maybe<Scalars["String"]["output"]>
  utm_medium?: Maybe<Scalars["String"]["output"]>
  utm_source?: Maybe<Scalars["String"]["output"]>
}

/** A Page */
export type Page = {
  __typename?: "Page"
  content_type?: Maybe<Scalars["Int"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  external_url?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  iframe_url: Scalars["String"]["output"]
  is_live: Scalars["Boolean"]["output"]
  mode: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  page_type: Scalars["Int"]["output"]
  scripts?: Maybe<Scalars["String"]["output"]>
  show_in_nav: Scalars["Boolean"]["output"]
  slug: Scalars["String"]["output"]
  template_content?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  url: Scalars["String"]["output"]
}

/** A connection to a list of items. */
export type PageConnection = {
  __typename?: "PageConnection"
  /** A list of edges. */
  edges: Array<PageEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PageEdge = {
  __typename?: "PageEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Page
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo"
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"]
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"]
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>
}

/** A path */
export type Path = {
  __typename?: "Path"
  analytics?: Maybe<PathAnalytics>
  cohort?: Maybe<Group>
  completion_date?: Maybe<Scalars["DateTime"]["output"]>
  created_date?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  /** Whether the path is a source path, whose changes sync to child paths. */
  is_source_path: Scalars["Boolean"]["output"]
  items?: Maybe<PathItemConnection>
  /** @deprecated Deprecated in favor of sync.last_synced_date */
  last_synced_dtime?: Maybe<Scalars["DateTime"]["output"]>
  meta: NodeMeta
  next_step_id?: Maybe<Scalars["Int"]["output"]>
  performance?: Maybe<PathPerformance>
  points?: Maybe<Points>
  previewable_steps?: Maybe<PathItemConnection>
  progress?: Maybe<Scalars["Float"]["output"]>
  publish?: Maybe<PathPublish>
  published_changes?: Maybe<PathChangePublishConnection>
  schedule?: Maybe<PathNodeSchedule>
  sync?: Maybe<PathSync>
  theme: NodeTheme
  user?: Maybe<User>
}

/** A path */
export type PathItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  first: Scalars["Int"]["input"]
  flatten?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<PathItemType>
}

/** A path */
export type PathPreviewable_StepsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A path */
export type PathPublished_ChangesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Analytics data for a path or path item */
export type PathAnalytics = {
  __typename?: "PathAnalytics"
  avg_score?: Maybe<Scalars["Float"]["output"]>
  /** The number of users who have completed the whole path */
  complete?: Maybe<Scalars["Int"]["output"]>
  completion_rate?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  /** The number of users who still are working on this path */
  incomplete?: Maybe<Scalars["Int"]["output"]>
  item?: Maybe<PathItem>
  items?: Maybe<Scalars["JSON"]["output"]>
  /** The number of step completions in the path that need grading */
  need_feedback?: Maybe<Scalars["Int"]["output"]>
  next_count?: Maybe<Scalars["Int"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** This is a list of up to 10 users who have completed this path (used to render avatar stacks). */
  students_here?: Maybe<Scalars["JSON"]["output"]>
  /** The number of earned points across all steps in this path (Note: this excludes steps that aren't due if due dates are in use) */
  total_points?: Maybe<Scalars["Int"]["output"]>
  /** The number of available points across all completed and past due student steps in this path */
  total_points_available?: Maybe<Scalars["Int"]["output"]>
  total_users?: Maybe<Scalars["Int"]["output"]>
}

/** A published set of changes made to a path */
export type PathChangePublish = {
  __typename?: "PathChangePublish"
  id?: Maybe<Scalars["Int"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  published_by_id?: Maybe<Scalars["Int"]["output"]>
  published_dtime?: Maybe<Scalars["DateTime"]["output"]>
}

/** A connection to a list of items. */
export type PathChangePublishConnection = {
  __typename?: "PathChangePublishConnection"
  /** A list of edges. */
  edges: Array<PathChangePublishEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PathChangePublishEdge = {
  __typename?: "PathChangePublishEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: PathChangePublish
}

/** An item in a path (Lesson, Topic, Step) */
export type PathItem = {
  __typename?: "PathItem"
  allow_resets?: Maybe<Scalars["Int"]["output"]>
  analytics?: Maybe<ItemAnalytics>
  archived_time?: Maybe<Scalars["DateTime"]["output"]>
  assignment_type?: Maybe<PathItemAssignmentType>
  blocks?: Maybe<BlocksContent>
  /** This dynamically calcuates progress for lessons. Avoid for long result sets as it's an N+1 query! */
  calculated_progress?: Maybe<Scalars["Float"]["output"]>
  cohort?: Maybe<Group>
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  cohort_name?: Maybe<Scalars["String"]["output"]>
  completion: Completion
  completion_comment_required_status?: Maybe<Scalars["String"]["output"]>
  /** @deprecated It's inefficient to load content for steps in a loop (N+2). Instead, check the content_id and item_content_type_id and load on demand */
  content?: Maybe<StepContent>
  content_id?: Maybe<Scalars["Int"]["output"]>
  content_type?: Maybe<Scalars["String"]["output"]>
  context?: Maybe<StepContext>
  copied_from_id?: Maybe<Scalars["Int"]["output"]>
  curriculum_sync_opt_out_dtime?: Maybe<Scalars["DateTime"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  due?: Maybe<Scalars["DateTime"]["output"]>
  grading_type?: Maybe<Scalars["String"]["output"]>
  has_started?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  is_locked?: Maybe<Scalars["Boolean"]["output"]>
  is_previewable?: Maybe<Scalars["Boolean"]["output"]>
  is_required?: Maybe<Scalars["Boolean"]["output"]>
  item_content_type_id?: Maybe<Scalars["Int"]["output"]>
  item_needs_grading?: Maybe<Scalars["Boolean"]["output"]>
  items?: Maybe<PathItemConnection>
  last_published_dtime?: Maybe<Scalars["DateTime"]["output"]>
  linked_cohort?: Maybe<Group>
  linked_registration?: Maybe<Registration>
  linked_resource?: Maybe<Resource>
  lock_password?: Maybe<Scalars["String"]["output"]>
  lock_unlocked_time?: Maybe<Scalars["DateTime"]["output"]>
  meta: NodeMeta
  minimum_passing_score?: Maybe<Scalars["Int"]["output"]>
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  parent?: Maybe<PathItem>
  parent_id?: Maybe<Scalars["Int"]["output"]>
  parent_name?: Maybe<Scalars["String"]["output"]>
  parent_source_id?: Maybe<Scalars["Int"]["output"]>
  passive_due?: Maybe<Scalars["Boolean"]["output"]>
  passive_starts?: Maybe<Scalars["Boolean"]["output"]>
  path?: Maybe<Path>
  path_id: Scalars["Int"]["output"]
  permissions?: Maybe<PathItemPermissions>
  points?: Maybe<Scalars["Int"]["output"]>
  progress: Scalars["Float"]["output"]
  reminders?: Maybe<MessageConnection>
  resource?: Maybe<Resource>
  resource_name?: Maybe<Scalars["String"]["output"]>
  show_grading_feedback?: Maybe<Scalars["Int"]["output"]>
  source_id: Scalars["Int"]["output"]
  starts?: Maybe<Scalars["DateTime"]["output"]>
  time_to_complete?: Maybe<Scalars["Int"]["output"]>
  type: PathItemType
  url?: Maybe<Scalars["String"]["output"]>
  verb?: Maybe<Scalars["String"]["output"]>
}

/** An item in a path (Lesson, Topic, Step) */
export type PathItemItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** An item in a path (Lesson, Topic, Step) */
export type PathItemRemindersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

export enum PathItemAssignmentType {
  Assessment = "assessment",
  Audio = "audio",
  Completion = "completion",
  Event = "event",
  Reading = "reading",
  Submission = "submission",
  Video = "video"
}

export type PathItemBulkUpdateInput = {
  assignment_type?: InputMaybe<Scalars["String"]["input"]>
  is_previewable?: InputMaybe<Scalars["Boolean"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  order?: InputMaybe<Scalars["Int"]["input"]>
  source_id: Scalars["Int"]["input"]
}

export type PathItemBulkUpdateResult = {
  __typename?: "PathItemBulkUpdateResult"
  error?: Maybe<Scalars["String"]["output"]>
  previous_values?: Maybe<Scalars["JSON"]["output"]>
  source_id?: Maybe<Scalars["Int"]["output"]>
  success: Scalars["Boolean"]["output"]
}

/** A connection to a list of items. */
export type PathItemConnection = {
  __typename?: "PathItemConnection"
  /** A list of edges. */
  edges: Array<PathItemEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PathItemEdge = {
  __typename?: "PathItemEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: PathItem
}

export type PathItemOrder = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  order: Scalars["Int"]["input"]
  parent_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id: Scalars["Int"]["input"]
}

export type PathItemPermissions = {
  __typename?: "PathItemPermissions"
  can_complete?: Maybe<Scalars["Boolean"]["output"]>
  can_discuss?: Maybe<Scalars["Boolean"]["output"]>
  can_edit?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_content?: Maybe<Scalars["Boolean"]["output"]>
  can_note?: Maybe<Scalars["Boolean"]["output"]>
  can_review?: Maybe<Scalars["Boolean"]["output"]>
  can_view?: Maybe<Scalars["Boolean"]["output"]>
  can_view_content?: Maybe<Scalars["Boolean"]["output"]>
}

/** Status for path items */
export type PathItemStats = {
  __typename?: "PathItemStats"
  path_items_needing_review?: Maybe<Scalars["Int"]["output"]>
}

export enum PathItemType {
  Divider = "divider",
  Lesson = "lesson",
  Resource = "resource",
  Step = "step"
}

export enum PathItemTypes {
  Divider = "divider",
  Lesson = "lesson",
  Resource = "resource",
  Step = "step"
}

export type PathNodeSchedule = {
  __typename?: "PathNodeSchedule"
  end?: Maybe<ScheduleDate>
  start?: Maybe<ScheduleDate>
}

/** A path's performance data */
export type PathPerformance = {
  __typename?: "PathPerformance"
  id?: Maybe<Scalars["Int"]["output"]>
  points?: Maybe<PathPerformancePoints>
  progress?: Maybe<PathPerformanceProgress>
}

export type PathPerformancePoints = {
  __typename?: "PathPerformancePoints"
  applicable_score?: Maybe<Scalars["JSON"]["output"]>
  applicable_score_percentage?: Maybe<Scalars["Float"]["output"]>
  earned?: Maybe<Scalars["Int"]["output"]>
  percentage?: Maybe<Scalars["Float"]["output"]>
  possible?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export type PathPerformanceProgress = {
  __typename?: "PathPerformanceProgress"
  percentage?: Maybe<Scalars["Float"]["output"]>
  required_steps_completed?: Maybe<Scalars["Int"]["output"]>
  steps_completed?: Maybe<Scalars["Int"]["output"]>
  total_required_steps?: Maybe<Scalars["Int"]["output"]>
  total_steps?: Maybe<Scalars["Int"]["output"]>
}

/** A Path's publish status. */
export type PathPublish = {
  __typename?: "PathPublish"
  /** The date when the target path was last published. */
  last_published_date?: Maybe<Scalars["DateTime"]["output"]>
  /** The target path. */
  path_id: Scalars["Int"]["output"]
  /** The target path is considered published if it has no unpublished changes (and has been published in the past). */
  published: Scalars["Boolean"]["output"]
}

/** Status of whether a path needs to be synced with its source path */
export type PathSync = {
  __typename?: "PathSync"
  /** The date when the target path was last synced. */
  last_synced_date?: Maybe<Scalars["DateTime"]["output"]>
  /** The target path. */
  path_id: Scalars["Int"]["output"]
  /** Always points to the path from which the target path syncs, (which may be itself when Path is the source path). */
  sync_source_path_id?: Maybe<Scalars["Int"]["output"]>
  /** Whether the target path has been synced with the latest changes from the source path. */
  synced: Scalars["Boolean"]["output"]
  /** The target path user (if present). */
  user_id?: Maybe<Scalars["Int"]["output"]>
}

/** Sync plan for a path */
export type PathSyncPlan = {
  __typename?: "PathSyncPlan"
  excluded_changes: Array<Maybe<PathSyncPlanChange>>
  from_path_id?: Maybe<Scalars["Int"]["output"]>
  hash: Scalars["String"]["output"]
  included_changes: Array<Maybe<PathSyncPlanChange>>
  to_path_id?: Maybe<Scalars["Int"]["output"]>
}

/** A single change of a PathSyncPlan */
export type PathSyncPlanChange = {
  __typename?: "PathSyncPlanChange"
  assignment_type?: Maybe<PathItemAssignmentType>
  change_details?: Maybe<Scalars["JSON"]["output"]>
  forced?: Maybe<PathSyncPlanForceType>
  forced_reasons?: Maybe<Array<Maybe<PathSyncPlanForceReasonType>>>
  item_name: Scalars["String"]["output"]
  item_source_id: Scalars["Int"]["output"]
  item_type: PathItemType
  last_changed?: Maybe<Scalars["DateTime"]["output"]>
  parent_name?: Maybe<Scalars["String"]["output"]>
  parent_source_id?: Maybe<Scalars["Int"]["output"]>
}

export enum PathSyncPlanForceReasonType {
  /** Excluded due to lesson not containing any steps with content */
  ExcludeLessonEmpty = "exclude_lesson_empty",
  /** Excluded due to step having no content */
  ExcludeStepNoContent = "exclude_step_no_content",
  /** Excluded upon user request */
  ExcludeUserRequest = "exclude_user_request",
  /** Included upon user request */
  IncludeUserRequest = "include_user_request"
}

export enum PathSyncPlanForceType {
  /** The path item change is force included and force excluded requiring a conflict to be resolved */
  Conflict = "conflict",
  /** The path item change cannot be included in sync */
  Exclude = "exclude",
  /** The path item change cannot be excluded from sync */
  Include = "include"
}

export type PathSyncPlanInput = {
  /** The source IDs of the path items to exclude from the sync plan. */
  exclude_source_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  /** The ID of the path from which to generate the sync plan. */
  from_path_id: Scalars["Int"]["input"]
  /** When executing a sync plan, the generated sync plan hash is required to ensure no changes have occurred between generating and executing the sync plan. */
  hash?: InputMaybe<Scalars["String"]["input"]>
  /** The source IDs of the path items to include from the sync plan. */
  include_source_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  /** The ID of the path against which to generate the sync plan. If not provided, the sync plan for the path will be derived from the diff of its current state and unpublished changes. */
  to_path_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A node in the Paths codex data structure */
export type PathsCodexNode = {
  __typename?: "PathsCodexNode"
  key?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** A Pathwright Payment */
export type Payment = {
  __typename?: "Payment"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** A user's payment history. */
export type PaymentHistory = {
  __typename?: "PaymentHistory"
  /** ID of the user. */
  download_url: Scalars["String"]["output"]
  /** ID of the user. */
  payments: Array<PaymentHistoryItem>
}

/** A user's payment history. */
export type PaymentHistoryItem = {
  __typename?: "PaymentHistoryItem"
  /** The total amount in the currency in which the payment was made. */
  currency_display: Scalars["String"]["output"]
  /** The date the payment was made. */
  date: Scalars["DateTime"]["output"]
  /** Whether the payment failed. */
  is_failed: Scalars["String"]["output"]
  /** The name of the item purchased or paid for. */
  item: Scalars["String"]["output"]
  /** The total amount paid. */
  total: Scalars["Float"]["output"]
}

export type PeopleAndGroupConnection = {
  __typename?: "PeopleAndGroupConnection"
  id?: Maybe<Scalars["Int"]["output"]>
  /** School membership status for 'user' items. Null when the user has active school membership or for non-user types. */
  membership_status?: Maybe<MembershipStatus>
  /** The meta data for this 'type'. */
  meta: NodeMeta
  /** The number of people attached to this 'type' */
  people_count?: Maybe<Scalars["Int"]["output"]>
  /** The role of the 'user' type in the queried context. Will be null for all other types. */
  role?: Maybe<Role>
  role_in?: Maybe<Role>
  /** The type of the people source. */
  type?: Maybe<PeopleAndGroupConnectionType>
}

/** A connection to a list of items. */
export type PeopleAndGroupConnectionConnection = {
  __typename?: "PeopleAndGroupConnectionConnection"
  /** A list of edges. */
  edges: Array<PeopleAndGroupConnectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type PeopleAndGroupConnectionContext = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type PeopleAndGroupConnectionEdge = {
  __typename?: "PeopleAndGroupConnectionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: PeopleAndGroupConnection
}

export enum PeopleAndGroupConnectionType {
  Cohort = "cohort",
  Group = "group",
  User = "user"
}

/** Platform Config */
export type PlatformConfig = {
  __typename?: "PlatformConfig"
  id?: Maybe<Scalars["Int"]["output"]>
  payments_maintenance_mode?: Maybe<Scalars["Boolean"]["output"]>
}

/** Platform subscription order data */
export type PlatformSubscriptionOrderData = {
  billing_plan_id: Scalars["Int"]["input"]
  interval: Scalars["Int"]["input"]
  /** Optionally provide the school ID of the school creating the order. */
  school_id?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

export type Points = {
  __typename?: "Points"
  /** Sum of the `userpoints_earned` for each "scoreable" path item completion */
  earned?: Maybe<Scalars["Int"]["output"]>
  /** Whether any path item on the path has `userpoints_available` */
  has_points?: Maybe<Scalars["Boolean"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** Percentage of earned / total */
  percentage?: Maybe<Scalars["Float"]["output"]>
  /** Sum of the `userpoints_available` for each "scoreable" path item completion */
  total?: Maybe<Scalars["Int"]["output"]>
  /** Sum of `userpoints_available` for each path item */
  total_points_possible?: Maybe<Scalars["Int"]["output"]>
}

/** Assign a lexicographical position to a positioned object */
export type PositionedObjectPositionInput = {
  /** A unique key for this object within the context. For example, registration:1234 for a specific registration on a user's home screen. */
  objKey: Scalars["NonEmptyString"]["input"]
  /** The lexicographical position used for fractional indexing. */
  objPosition: Scalars["NonEmptyString"]["input"]
}

/** A context within which objects can be positioned. */
export type PositioningContext = {
  __typename?: "PositioningContext"
  /** A unique key for this context within the school. For example, user:1234 for a user's home screen. */
  context_key: Scalars["NonEmptyString"]["output"]
  /** The type of context this is. For example, 'home_screen' for a user's home screen. */
  context_type: PositioningContextTypeInput
  /** The ID of this context. */
  id: Scalars["Int"]["output"]
  /** The ID of the school for this context. */
  school_id: Scalars["Int"]["output"]
}

/** Assign the context for positioning an object. */
export type PositioningContextInput = {
  /** A unique key for this context within the school. For example, user:1234 for a user's home screen. */
  contextKey: Scalars["NonEmptyString"]["input"]
  /** The type of context to position the object within. For example, 'home_screen' for a user's home screen. */
  contextType: PositioningContextTypeInput
}

/** The positioning context type. */
export enum PositioningContextTypeInput {
  /** Positioning objects on a user's homescreen. */
  HomeScreen = "HOME_SCREEN",
  /** Positioning resource authors for Cover Pages. */
  ResourceAuthors = "RESOURCE_AUTHORS",
  /** Positioning resource categories for Cover Pages. */
  ResourceCategories = "RESOURCE_CATEGORIES",
  /** Positioning objects in the Subscribe flow. */
  SubscribeFlow = "SUBSCRIBE_FLOW"
}

/** A Pathwright User Profile */
export type Profile = {
  __typename?: "Profile"
  bio?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  imageRaw?: Maybe<Scalars["String"]["output"]>
  last_activity?: Maybe<Scalars["DateTime"]["output"]>
  location?: Maybe<Scalars["String"]["output"]>
  notification_digest_interval?: Maybe<NotificationDigestInterval>
  rewardful_referral_id?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright User Profile */
export type ProfileImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type ProgressFilter = {
  eq?: InputMaybe<Scalars["Float"]["input"]>
  gt?: InputMaybe<Scalars["Float"]["input"]>
  gte?: InputMaybe<Scalars["Float"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>
  lt?: InputMaybe<Scalars["Float"]["input"]>
  lte?: InputMaybe<Scalars["Float"]["input"]>
  neq?: InputMaybe<Scalars["Float"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School Publisher */
export type Publisher = {
  __typename?: "Publisher"
  about?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  logo?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  theme?: Maybe<Theme>
  website?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright School Publisher */
export type PublisherImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School Publisher */
export type PublisherLogoArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type PublisherConnection = {
  __typename?: "PublisherConnection"
  /** A list of edges. */
  edges: Array<PublisherEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PublisherEdge = {
  __typename?: "PublisherEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Publisher
}

/** Pathwright GraphQL Endpoint */
export type Query = {
  __typename?: "Query"
  account?: Maybe<SchoolAcount>
  activity?: Maybe<ActivityConnection>
  activityStats?: Maybe<ActivityStats>
  admin?: Maybe<SchoolConnection>
  assignRoles: Array<Maybe<RegistrationRoleEnum>>
  authRequest?: Maybe<AuthRequest>
  /** The auth token resulting from a confirmed auth request made by the user to authenticate by some other means than username/password. */
  authRequestToken?: Maybe<Scalars["JWT"]["output"]>
  author?: Maybe<Author>
  authors?: Maybe<AuthorConnection>
  backgroundTask?: Maybe<BackgroundTask>
  backgroundTasks?: Maybe<Array<Maybe<BackgroundTask>>>
  calendar?: Maybe<Calendar>
  calendarStats?: Maybe<CalendarStats>
  canReview?: Maybe<Scalars["Boolean"]["output"]>
  categories?: Maybe<CategoryConnection>
  category?: Maybe<Category>
  certificate?: Maybe<Certificate>
  certificatePreview?: Maybe<Scalars["String"]["output"]>
  certificateVariables?: Maybe<CertificateVariables>
  certificates?: Maybe<CertificateConnection>
  codex?: Maybe<Codex>
  completions?: Maybe<PathItemConnection>
  computedDiscount?: Maybe<ComputedDiscount>
  context?: Maybe<AccountContext>
  contextualFeaturePermission?: Maybe<ContextualFeaturePermission>
  contextualFeaturePermissions: Array<ContextualFeaturePermission>
  couponExists?: Maybe<Scalars["Boolean"]["output"]>
  curriculumSubscription?: Maybe<CurriculumSubscription>
  discussion?: Maybe<Discussion>
  discussionParticipants?: Maybe<DiscussionParticipantConnection>
  discussions?: Maybe<DiscussionConnection>
  feedbackReviewers?: Maybe<FeedbackReviewers>
  gravatar?: Maybe<Gravatar>
  group?: Maybe<Group>
  groups?: Maybe<GroupConnection>
  inboxContext?: Maybe<InboxContext>
  inboxGroupConnections?: Maybe<InboxGroupConnectionConnection>
  inboxGroups?: Maybe<InboxMentorGroupConnection>
  inboxPaths?: Maybe<InboxPathConnection>
  inboxPendingReview?: Maybe<InboxPendingReview>
  inboxPendingReviewConnections?: Maybe<InboxPendingReviewConnection>
  inboxPeopleCompletionCounts?: Maybe<InboxPeopleCompletionCountsConnection>
  inboxReviewers?: Maybe<InboxReviewerConnection>
  integrations?: Maybe<Integrations>
  invitationToken?: Maybe<InvitationToken>
  invitations?: Maybe<InvitationConnection>
  license_offering?: Maybe<LicenseOffering>
  loginMethod?: Maybe<LoginInfo>
  loginMethods?: Maybe<Array<LoginInfo>>
  me?: Maybe<User>
  media?: Maybe<Media>
  mediaContext?: Maybe<MediaContext>
  membership?: Maybe<Membership>
  membership_meta?: Maybe<MembershipMeta>
  mentorGroupMembership?: Maybe<MentorGroupMembership>
  message?: Maybe<Message>
  messages?: Maybe<MessageConnection>
  note?: Maybe<Note>
  notes?: Maybe<NoteConnection>
  offerConnections?: Maybe<OfferConnection>
  order?: Maybe<Order>
  orders?: Maybe<OrderConnection>
  package?: Maybe<Package>
  packageAssignment?: Maybe<PackageAssignment>
  packages?: Maybe<Array<Maybe<Package>>>
  path?: Maybe<Path>
  pathItem?: Maybe<PathItem>
  pathItemStats?: Maybe<PathItemStats>
  pathItems?: Maybe<PathItemConnection>
  pathSyncPlan?: Maybe<PathSyncPlan>
  peopleAndGroupConnection?: Maybe<PeopleAndGroupConnection>
  peopleAndGroupConnections?: Maybe<PeopleAndGroupConnectionConnection>
  platformConfig?: Maybe<PlatformConfig>
  positioningContext?: Maybe<PositioningContext>
  report?: Maybe<Scalars["JSON"]["output"]>
  resource?: Maybe<Resource>
  resourceCopyConfig?: Maybe<ResourceCopyConfig>
  resourceCopyConfigConnections?: Maybe<ResourceCopyConfigConnection>
  resourceCopyConfigLink?: Maybe<ResourceCopyConfigLink>
  resourceCopyConfigLinkConnections?: Maybe<ResourceCopyConfigLinkConnection>
  resourceImage: Array<Maybe<Scalars["URL"]["output"]>>
  resource_license?: Maybe<ResourceLicense>
  resource_licenses?: Maybe<ResourceLicenseConnection>
  resources?: Maybe<ResourceConnection>
  responses?: Maybe<ResponseConnection>
  restAPIGet?: Maybe<Scalars["JSON"]["output"]>
  school?: Maybe<School>
  schoolGroupSubscription?: Maybe<SchoolGroupSubscription>
  schoolGroupSubscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  schoolSubscriptionDiscount?: Maybe<SchoolSubscriptionDiscount>
  sharePermissions?: Maybe<SharePermissions>
  /** Returns the current space (from request header */
  space: Space
  /** A list of spaces the user has access to */
  spaceConnections?: Maybe<SpaceConnectionConnection>
  store?: Maybe<Store>
  storeBanners?: Maybe<Array<Maybe<StoreBanner>>>
  storeCollection?: Maybe<StoreCollection>
  storeCollections?: Maybe<Array<Maybe<StoreCollection>>>
  storeItem?: Maybe<StoreItem>
  storeLink?: Maybe<StoreLink>
  storeLinks?: Maybe<StoreLinkConnection>
  stripeProduct?: Maybe<StripeProduct>
  stripeProducts?: Maybe<StripeProductConnection>
  subdomain?: Maybe<Subdomain>
  subscription?: Maybe<Subscription>
  subscriptions?: Maybe<SubscriptionConnection>
  tag?: Maybe<Tag>
  tagAttachment?: Maybe<TagAttachment>
  tagAttachments?: Maybe<TagAttachmentConnection>
  tags?: Maybe<TagConnection>
  theme?: Maybe<Theme>
  translation?: Maybe<Translation>
  user?: Maybe<User>
  /** Find a preference by key and scope for the current user and school. Returns null when absent. */
  userPreference?: Maybe<UserPreference>
  /** List the current user's preferences in this school. Omit scope for all scopes; use an empty string for school-wide preferences. */
  userPreferences: Array<UserPreference>
  userStatus?: Maybe<UserStatus>
  webhookEventConnections?: Maybe<WebhookEventConnection>
}

/** Pathwright GraphQL Endpoint */
export type QueryActivityArgs = {
  action_type?: InputMaybe<ActionTypeFilter>
  after?: InputMaybe<Scalars["String"]["input"]>
  date?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  interest_level?: InputMaybe<InterestLevel>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryAdminArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  is_activated?: InputMaybe<Scalars["Boolean"]["input"]>
  licensing_from?: InputMaybe<Scalars["Int"]["input"]>
  school_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthRequestArgs = {
  uuid: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthRequestTokenArgs = {
  uuid: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthorArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Array<InputMaybe<AuthorOrderByInput>>>
  positioningContext?: InputMaybe<PositioningContextInput>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryBackgroundTaskArgs = {
  id: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryBackgroundTasksArgs = {
  ids: Array<InputMaybe<Scalars["String"]["input"]>>
}

/** Pathwright GraphQL Endpoint */
export type QueryCalendarArgs = {
  path_id?: InputMaybe<Scalars["ID"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCalendarStatsArgs = {
  path_id?: InputMaybe<Scalars["ID"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCanReviewArgs = {
  for_user_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Array<InputMaybe<CategoryOrderByInput>>>
  positioningContext?: InputMaybe<PositioningContextInput>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificateArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificatePreviewArgs = {
  template: Scalars["String"]["input"]
  text_objects: Array<InputMaybe<TextObject>>
  variables?: InputMaybe<Scalars["JSON"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificateVariablesArgs = {
  context?: InputMaybe<CertificateVariablesContextInput>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryCompletionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  is_reviewed?: InputMaybe<Scalars["Boolean"]["input"]>
  lesson_source_id?: InputMaybe<Scalars["Int"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryComputedDiscountArgs = {
  discount_code: Scalars["String"]["input"]
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  offering_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id: Scalars["Int"]["input"]
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryContextArgs = {
  auth_token_id?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
}

/** Pathwright GraphQL Endpoint */
export type QueryContextualFeaturePermissionsArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action?: InputMaybe<FeatureAction>
  feature_key?: InputMaybe<FeatureKey>
  feature_keys?: InputMaybe<FeatureKeyFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryCouponExistsArgs = {
  input?: InputMaybe<CouponExistsInput>
}

/** Pathwright GraphQL Endpoint */
export type QueryCurriculumSubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryDiscussionArgs = {
  context: DiscussionContextInput
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryDiscussionParticipantsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryDiscussionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<DiscussionContextInput>
  first: Scalars["Int"]["input"]
  is_discussion_question?: InputMaybe<Scalars["Boolean"]["input"]>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  tag_id_filter?: InputMaybe<IntFilter>
  total_responses?: InputMaybe<IntFilter>
  type?: InputMaybe<DiscussionTypeInput>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryFeedbackReviewersArgs = {
  completion_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryGravatarArgs = {
  email: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryGroupArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  first: Scalars["Int"]["input"]
  include_curriculum?: InputMaybe<Scalars["Boolean"]["input"]>
  is_master?: InputMaybe<Scalars["Boolean"]["input"]>
  is_offerable?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_group_id?: InputMaybe<IdFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  sort?: InputMaybe<GroupSort>
  status?: InputMaybe<GroupStatus>
  visibility?: InputMaybe<GroupVisibility>
  visibility_filter?: InputMaybe<GroupVisibilityFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxContextArgs = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxGroupConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  status?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPathsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPendingReviewArgs = {
  target_id: Scalars["Int"]["input"]
  target_type: InboxPendingReviewTarget
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPendingReviewConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  target_ids: IntFilter
  target_type: InboxPendingReviewTarget
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPeopleCompletionCountsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  first: Scalars["Int"]["input"]
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_source_id?: InputMaybe<Scalars["Int"]["input"]>
  step_source_id?: InputMaybe<Scalars["Int"]["input"]>
  target_id: Scalars["Int"]["input"]
  target_type: InboxPeopleCompletionCountsTarget
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxReviewersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInvitationTokenArgs = {
  token: Scalars["NonEmptyString"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryInvitationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<InvitationContext>
  delivery_status?: InputMaybe<EmailDeliveryStatus>
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<InvitationStatus>
  type?: InputMaybe<InvitationType>
}

/** Pathwright GraphQL Endpoint */
export type QueryLicense_OfferingArgs = {
  id: Scalars["Int"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}

/** Pathwright GraphQL Endpoint */
export type QueryLoginMethodArgs = {
  email: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryLoginMethodsArgs = {
  email: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryMembershipArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryMembership_MetaArgs = {
  user_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryMentorGroupMembershipArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryMessageArgs = {
  id: Scalars["Int"]["input"]
  message_context: MessageContext
}

/** Pathwright GraphQL Endpoint */
export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  message_context: MessageContext
  type?: InputMaybe<MessageTypeFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryNoteArgs = {
  context: ContextModelInput
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryNotesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context: ContextModelInput
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  visibility?: InputMaybe<NoteVisibility>
}

/** Pathwright GraphQL Endpoint */
export type QueryOfferConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context: OfferContext
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryOrderArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryPackageArgs = {
  rewardful_referral_id?: InputMaybe<Scalars["String"]["input"]>
  signup_config_key?: InputMaybe<Scalars["String"]["input"]>
  utm_campaign?: InputMaybe<Scalars["String"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_source?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPathArgs = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPathItemArgs = {
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPathItemStatsArgs = {
  user_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryPathItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  due?: InputMaybe<DateFilter>
  exclude_default?: InputMaybe<Scalars["Boolean"]["input"]>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  is_reviewed?: InputMaybe<Scalars["Boolean"]["input"]>
  is_skipped?: InputMaybe<Scalars["Boolean"]["input"]>
  lesson_source_id?: InputMaybe<Scalars["Int"]["input"]>
  needs_attention?: InputMaybe<Scalars["Boolean"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  next?: InputMaybe<Scalars["Boolean"]["input"]>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  registration_role_filter?: InputMaybe<RoleFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  reviewable?: InputMaybe<Scalars["Boolean"]["input"]>
  root_level?: InputMaybe<Scalars["Boolean"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  starts?: InputMaybe<DateFilter>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<PathItemTypes>
  upcoming?: InputMaybe<Scalars["Boolean"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  with_dates?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPathSyncPlanArgs = {
  sync_plan?: InputMaybe<PathSyncPlanInput>
}

/** Pathwright GraphQL Endpoint */
export type QueryPeopleAndGroupConnectionArgs = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  role_in_context?: InputMaybe<RoleInContext>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPeopleAndGroupConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<PeopleAndGroupConnectionContext>
  first: Scalars["Int"]["input"]
  people_count_filter?: InputMaybe<IntFilter>
  role_in_context?: InputMaybe<RoleInContext>
  search_term?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  type?: InputMaybe<PeopleAndGroupConnectionType>
}

/** Pathwright GraphQL Endpoint */
export type QueryPositioningContextArgs = {
  input: PositioningContextInput
}

/** Pathwright GraphQL Endpoint */
export type QueryReportArgs = {
  community_groups?: InputMaybe<Array<InputMaybe<ReportInput>>>
  community_memberships?: InputMaybe<Array<InputMaybe<ReportInput>>>
  group_performance_completion?: InputMaybe<Array<InputMaybe<ReportInput>>>
  group_performance_points?: InputMaybe<Array<InputMaybe<ReportInput>>>
  group_registrations?: InputMaybe<Array<InputMaybe<ReportInput>>>
  licensing_member_created_cohorts?: InputMaybe<Array<InputMaybe<ReportInput>>>
  licensing_store_connected_accounts?: InputMaybe<
    Array<InputMaybe<ReportInput>>
  >
  licensing_store_member_progress?: InputMaybe<Array<InputMaybe<ReportInput>>>
  licensing_store_resource_usage?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_cohorts?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_coupon_redemptions?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_coupon_summary?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_external_ids?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_member_progress?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_members?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_registrations?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_resources?: InputMaybe<Array<InputMaybe<ReportInput>>>
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigArgs = {
  fromSpaceId?: InputMaybe<Scalars["Int"]["input"]>
  key: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  fromSpaceId?: InputMaybe<Scalars["Int"]["input"]>
  keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigLinkArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigLinkConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  copiedTimeDateFilter?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  hideFromLocationsFilter?: InputMaybe<
    Array<InputMaybe<ResourceCopyConfigLinkLocationFilter>>
  >
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceImageArgs = {
  image?: InputMaybe<Array<InputMaybe<ImageInput>>>
  theme_type?: InputMaybe<ThemeType>
}

/** Pathwright GraphQL Endpoint */
export type QueryResource_LicenseArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryResource_LicensesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryResourcesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  author_names?: InputMaybe<StringFilter>
  author_search?: InputMaybe<Scalars["String"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  category_ids?: InputMaybe<IdFilter>
  category_names?: InputMaybe<StringFilter>
  category_search?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  has_certificate?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<IdFilter>
  license_offering_licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
  licensed_from_school?: InputMaybe<IdFilter>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  publisher_id?: InputMaybe<Scalars["Int"]["input"]>
  publisher_ids?: InputMaybe<IdFilter>
  resource_types?: InputMaybe<ResourceTypeFilter>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  user_registered?: InputMaybe<IdFilter>
  visibility?: InputMaybe<ResourceVisibility>
}

/** Pathwright GraphQL Endpoint */
export type QueryResponsesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archived_time?: InputMaybe<DateFilter>
  context: DiscussionResponseContextInput
  first: Scalars["Int"]["input"]
  modified_time?: InputMaybe<DateFilter>
  order_by?: InputMaybe<Array<InputMaybe<ResponseOrderBy>>>
  root_response_id?: InputMaybe<IntFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryRestApiGetArgs = {
  endpoint: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QuerySchoolGroupSubscriptionArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySchoolGroupSubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySchoolSubscriptionDiscountArgs = {
  discount_code: Scalars["String"]["input"]
  school_plan_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QuerySharePermissionsArgs = {
  context?: InputMaybe<ShareContext>
}

/** Pathwright GraphQL Endpoint */
export type QuerySpaceConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreCollectionArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreCollectionsArgs = {
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  author_search?: InputMaybe<Scalars["String"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  category_ids?: InputMaybe<IdFilter>
  category_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreItemArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreLinkArgs = {
  licensor_id?: InputMaybe<IntFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensor_id?: InputMaybe<IdFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryStripeProductArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryStripeProductsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  include_inactive?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySubdomainArgs = {
  subdomain?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  payment_intent_needing_action_id?: InputMaybe<IdFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagAttachmentArgs = {
  context?: InputMaybe<TagAttachmentContextInput>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<TagAttachmentContextInput>
  first: Scalars["Int"]["input"]
  tag_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<TagAttachmentContextInput>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryTranslationArgs = {
  is_default?: InputMaybe<Scalars["Boolean"]["input"]>
  language?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryUserArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryUserPreferenceArgs = {
  key: Scalars["String"]["input"]
  scope?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryUserPreferencesArgs = {
  key?: InputMaybe<Scalars["String"]["input"]>
  scope?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryUserStatusArgs = {
  input?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryWebhookEventConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  event?: InputMaybe<WebhookEventType>
  first: Scalars["Int"]["input"]
  last_attempt_dtime_filter?: InputMaybe<DateFilter>
  order_by?: InputMaybe<WebhookEventOrderBy>
  status?: InputMaybe<WebhookEventStatus>
}

export type Referral = {
  __typename?: "Referral"
  referral?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright Registration */
export type Registration = {
  __typename?: "Registration"
  /**
   * The download URL for the course certificate
   * @deprecated Optimization. `certificate_download_url` field has been moved to its own schema that can be queried separately, `RegistrationCertificate`
   */
  certificate_download_url?: Maybe<Scalars["String"]["output"]>
  completion_state?: Maybe<Scalars["Int"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  expiration_dtime?: Maybe<Scalars["DateTime"]["output"]>
  group: Group
  group_sub_community_membership?: Maybe<MentorGroupMembership>
  group_sub_used?: Maybe<SchoolGroupSubscription>
  id: Scalars["Int"]["output"]
  last_activity_time?: Maybe<Scalars["DateTime"]["output"]>
  meta: NodeMeta
  path?: Maybe<Path>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** The contextual position for this item based on the parent connection `positioningContext` arg. */
  position: Scalars["String"]["output"]
  registration_payment?: Maybe<RegistrationPayment>
  resource: Resource
  role: Scalars["Int"]["output"]
  school_sub_used?: Maybe<SchoolSubscription>
  send_discussion_notifications?: Maybe<Scalars["Boolean"]["output"]>
  send_due_notifications?: Maybe<Scalars["Boolean"]["output"]>
  /** A soft-archived registration will be hidden or demphasized in some UIs. */
  softArchivedTime?: Maybe<Scalars["DateTime"]["output"]>
  user: User
  user_id?: Maybe<Scalars["Int"]["output"]>
}

/** A Pathwright Registration */
export type RegistrationPositionArgs = {
  positioningContext?: InputMaybe<PositioningContextInput>
}

/** A connection to a list of items. */
export type RegistrationConnection = {
  __typename?: "RegistrationConnection"
  /** A list of edges. */
  edges: Array<RegistrationEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type RegistrationEdge = {
  __typename?: "RegistrationEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Registration
}

export type RegistrationMeta = {
  __typename?: "RegistrationMeta"
  editor_registration_count?: Maybe<Scalars["Int"]["output"]>
  facilitator_registration_count?: Maybe<Scalars["Int"]["output"]>
  student_registration_count?: Maybe<Scalars["Int"]["output"]>
  teacher_registration_count?: Maybe<Scalars["Int"]["output"]>
  total_registration_count?: Maybe<Scalars["Int"]["output"]>
}

/** Input for ordering the list. */
export type RegistrationOrderByInput = {
  /** Order by created. */
  created?: InputMaybe<OrderByDir>
  /** Order by last_activity_time. */
  last_activity_time?: InputMaybe<OrderByDir>
  /** Order by position. */
  position?: InputMaybe<OrderByDir>
  /** Order by role. */
  role?: InputMaybe<OrderByDir>
}

/** Registration order data */
export type RegistrationOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  invitation_code?: InputMaybe<Scalars["String"]["input"]>
  offering_id: Scalars["Int"]["input"]
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  use_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Registration Payment */
export type RegistrationPayment = {
  __typename?: "RegistrationPayment"
  /** The Coupon that was redeemed (if any). */
  couponRedemption?: Maybe<CouponRedemption>
  group_sub_used?: Maybe<SchoolGroupSubscription>
  id?: Maybe<Scalars["Int"]["output"]>
  payment?: Maybe<Payment>
  school_sub_used?: Maybe<SchoolSubscription>
}

export enum RegistrationRoleEnum {
  Editor = "editor",
  Moderator = "moderator",
  Observer = "observer",
  Student = "student",
  Teacher = "teacher"
}

export type RelativeTime = {
  days?: InputMaybe<Scalars["Float"]["input"]>
  hours?: InputMaybe<Scalars["Float"]["input"]>
  minutes?: InputMaybe<Scalars["Float"]["input"]>
}

export type ReportInput = {
  /** Issue a non-default expiry report link. Pass null for non-expiring. By default a report link is set to expire 1 day from date issued. NOTE: only available to Pathwright admin. */
  exp?: InputMaybe<RelativeTime>
  id_type?: InputMaybe<Scalars["Int"]["input"]>
  offering_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  schedule_id?: InputMaybe<Scalars["Int"]["input"]>
  store_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Resource */
export type Resource = {
  __typename?: "Resource"
  authors?: Maybe<AuthorConnection>
  background_image?: Maybe<Scalars["String"]["output"]>
  background_image_raw?: Maybe<Scalars["String"]["output"]>
  background_luminance?: Maybe<Scalars["Float"]["output"]>
  background_overlay?: Maybe<Scalars["String"]["output"]>
  background_type: ResourceBackgroundType
  categories?: Maybe<CategoryConnection>
  certificate_generator_class?: Maybe<Scalars["String"]["output"]>
  certificate_json?: Maybe<Scalars["JSON"]["output"]>
  cohorts_status_meta?: Maybe<CohortsStatusMeta>
  /** If set, this is the ID of the ResourceCopyConfig used to copy this resource. */
  copied_with_copy_config_id?: Maybe<Scalars["Int"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  created_by_id?: Maybe<Scalars["Int"]["output"]>
  curriculum_group?: Maybe<Group>
  description?: Maybe<Scalars["String"]["output"]>
  discussion_enabled?: Maybe<Scalars["Boolean"]["output"]>
  group?: Maybe<Group>
  groups?: Maybe<GroupConnection>
  has_certificate?: Maybe<Scalars["Boolean"]["output"]>
  highest_public_offering_price?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  image: Scalars["String"]["output"]
  image_raw?: Maybe<Scalars["String"]["output"]>
  is_ambient_background?: Maybe<Scalars["Boolean"]["output"]>
  last_published_dtime?: Maybe<Scalars["DateTime"]["output"]>
  license_offerings?: Maybe<LicenseOfferingConnection>
  licensed_from_resource_id?: Maybe<Scalars["Int"]["output"]>
  licensed_from_school_id?: Maybe<Scalars["Int"]["output"]>
  licensing_enabled?: Maybe<Scalars["Boolean"]["output"]>
  lowest_public_offering_price?: Maybe<Scalars["Float"]["output"]>
  /** In the future, ResourceMeta will simply be NodeMeta, only consisting of NodeMeta fields. */
  meta?: Maybe<ResourceMeta>
  name: Scalars["String"]["output"]
  preview_group?: Maybe<Group>
  pristine_background_image?: Maybe<Scalars["String"]["output"]>
  publisher?: Maybe<Publisher>
  registration_meta?: Maybe<RegistrationMeta>
  /** Registrations across this Resource's Cohorts. Search matches people by name or email. */
  registrations?: Maybe<RegistrationConnection>
  resource_type: Scalars["Int"]["output"]
  school?: Maybe<School>
  school_licenses?: Maybe<ResourceLicenseConnection>
  short_description?: Maybe<Scalars["String"]["output"]>
  slug: Scalars["String"]["output"]
  trailer_embed_code?: Maybe<Scalars["String"]["output"]>
  visibility?: Maybe<Scalars["Int"]["output"]>
  visibility_level_override?: Maybe<Scalars["Int"]["output"]>
}

/** A Pathwright Resource */
export type ResourceAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  positioningContext?: InputMaybe<PositioningContextInput>
}

/** A Pathwright Resource */
export type ResourceBackground_ImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Resource */
export type ResourceCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  positioningContext?: InputMaybe<PositioningContextInput>
}

/** A Pathwright Resource */
export type ResourceGroupArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  is_source?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_group_id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<GroupType>
}

/** A Pathwright Resource */
export type ResourceGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  first: Scalars["Int"]["input"]
  include_curriculum?: InputMaybe<Scalars["Boolean"]["input"]>
  is_master?: InputMaybe<Scalars["Boolean"]["input"]>
  is_offerable?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_group_id?: InputMaybe<IdFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  sort?: InputMaybe<GroupSort>
  status?: InputMaybe<GroupStatus>
  visibility?: InputMaybe<GroupVisibility>
  visibility_filter?: InputMaybe<GroupVisibilityFilter>
}

/** A Pathwright Resource */
export type ResourceImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Resource */
export type ResourceLicense_OfferingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}

/** A Pathwright Resource */
export type ResourcePristine_Background_ImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Resource */
export type ResourceRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  cohort_filter?: InputMaybe<IntFilter>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  id_filter?: InputMaybe<IntFilter>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** A Pathwright Resource */
export type ResourceSchool_LicensesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
}

export enum ResourceBackgroundType {
  /** Blur */
  Blur = "BLUR",
  /** Pristine */
  Pristine = "PRISTINE"
}

/** A connection to a list of items. */
export type ResourceConnection = {
  __typename?: "ResourceConnection"
  /** A list of edges. */
  edges: Array<ResourceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type ResourceCopyConfig = {
  __typename?: "ResourceCopyConfig"
  /** If set, linking an account to this Store will result in this copy config being executed. NOTE: For now, only applies to new school sign-ups to the store. */
  allow_copy_via_link: Scalars["Boolean"]["output"]
  /** If creating a cohort and this is set, assign the copier this role. Can be editor for source path, or other roles for non-source paths. */
  assign_copier_role?: Maybe<RegistrationRoleEnum>
  /** All direct child resource copy configs. */
  children?: Maybe<Array<Maybe<ResourceCopyConfig>>>
  cohort?: Maybe<ResourceCopyConfigCohort>
  /** Should authors be copied to the target school if they don't exist? */
  copy_authors: Scalars["Boolean"]["output"]
  /** How/when should the resource be copied by default? This may be overridden by a parent config. */
  copy_behavior: ResourceCopyConfigCopyBehavior
  /** Should categories be copied to the target school if they don't exist? */
  copy_categories: Scalars["Boolean"]["output"]
  /** Create a cohort for the copied resource? */
  create_cohort: Scalars["Boolean"]["output"]
  /** If creating a cohort, this is the name to give to the new cohort. */
  create_cohort_name?: Maybe<Scalars["String"]["output"]>
  /** All recursive child resource copy configs. */
  flat_children?: Maybe<Array<Maybe<ResourceCopyConfig>>>
  id: Scalars["Int"]["output"]
  /** The unique code for this resource copy config. */
  lookup_key: Scalars["String"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  /** The parent resource copy config. If the parent is copied, all child resource copy configs will be copied regardless of how the child resource copy config is configured to run. */
  parent?: Maybe<ResourceCopyConfig>
  resource?: Maybe<ResourceCopyConfigResource>
  school: ResourceCopyConfigSchool
}

export type ResourceCopyConfigCohort = {
  __typename?: "ResourceCopyConfigCohort"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

/** A connection to a list of items. */
export type ResourceCopyConfigConnection = {
  __typename?: "ResourceCopyConfigConnection"
  /** A list of edges. */
  edges: Array<ResourceCopyConfigEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** How/when should the resource be copied by default? This may be overridden by a parent config. */
export enum ResourceCopyConfigCopyBehavior {
  /** Defer copying the resource until later (user action triggered). Will create a ResourceCopyConfigLink. */
  Deferred = "DEFERRED",
  /** Immediately copy the resource when processing the config. */
  Instant = "INSTANT"
}

/** An edge in a connection. */
export type ResourceCopyConfigEdge = {
  __typename?: "ResourceCopyConfigEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: ResourceCopyConfig
}

export type ResourceCopyConfigLink = {
  __typename?: "ResourceCopyConfigLink"
  cohort?: Maybe<ResourceCopyConfigLinkCohort>
  cohortId?: Maybe<Scalars["Int"]["output"]>
  /** When the related ResourceCopyConfig was copied. */
  copiedTime?: Maybe<Scalars["DateTime"]["output"]>
  /** The related Registration, if the ResourceCopyConfig assigned a role. */
  copierRegistration?: Maybe<Registration>
  copierRegistrationId?: Maybe<Scalars["Int"]["output"]>
  /** When the ResourceCopyConfigLink was created. */
  createdTime: Scalars["DateTime"]["output"]
  hideFromLocations?: Maybe<Scalars["JSON"]["output"]>
  id: Scalars["Int"]["output"]
  resource?: Maybe<ResourceCopyConfigLinkResource>
  /** The related ResourceCopyConfig. */
  resourceCopyConfig: ResourceCopyConfig
  resourceId?: Maybe<Scalars["Int"]["output"]>
}

export type ResourceCopyConfigLinkCohort = {
  __typename?: "ResourceCopyConfigLinkCohort"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

/** A connection to a list of items. */
export type ResourceCopyConfigLinkConnection = {
  __typename?: "ResourceCopyConfigLinkConnection"
  /** A list of edges. */
  edges: Array<ResourceCopyConfigLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ResourceCopyConfigLinkEdge = {
  __typename?: "ResourceCopyConfigLinkEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: ResourceCopyConfigLink
}

/** UI location where a link may be shown or hidden from. */
export enum ResourceCopyConfigLinkLocation {
  HomeScreen = "HOME_SCREEN",
  Library = "LIBRARY"
}

export type ResourceCopyConfigLinkLocationFilter = {
  eq?: InputMaybe<ResourceCopyConfigLinkLocation>
  gt?: InputMaybe<ResourceCopyConfigLinkLocation>
  gte?: InputMaybe<ResourceCopyConfigLinkLocation>
  in?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
  lt?: InputMaybe<ResourceCopyConfigLinkLocation>
  lte?: InputMaybe<ResourceCopyConfigLinkLocation>
  neq?: InputMaybe<ResourceCopyConfigLinkLocation>
  nin?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type ResourceCopyConfigLinkResource = {
  __typename?: "ResourceCopyConfigLinkResource"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

export type ResourceCopyConfigResource = {
  __typename?: "ResourceCopyConfigResource"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

export type ResourceCopyConfigSchool = {
  __typename?: "ResourceCopyConfigSchool"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

/** An edge in a connection. */
export type ResourceEdge = {
  __typename?: "ResourceEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Resource
}

/** A resource license */
export type ResourceLicense = {
  __typename?: "ResourceLicense"
  expiration_dtime?: Maybe<Scalars["DateTime"]["output"]>
  group?: Maybe<Group>
  id?: Maybe<Scalars["Int"]["output"]>
  license_offering?: Maybe<LicenseOffering>
  school?: Maybe<LicenseeSchool>
  seat_count?: Maybe<Scalars["Int"]["output"]>
  seats_available?: Maybe<Scalars["Int"]["output"]>
  seats_filled?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type ResourceLicenseConnection = {
  __typename?: "ResourceLicenseConnection"
  /** A list of edges. */
  edges: Array<ResourceLicenseEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ResourceLicenseEdge = {
  __typename?: "ResourceLicenseEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: ResourceLicense
}

export type ResourceMeta = {
  __typename?: "ResourceMeta"
  description?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  editor_registration_count?: Maybe<Scalars["Int"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  facilitator_registration_count?: Maybe<Scalars["Int"]["output"]>
  icon?: Maybe<Scalars["String"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  key: Scalars["String"]["output"]
  /** @deprecated Use Resource.registration_meta instead! */
  student_registration_count?: Maybe<Scalars["Int"]["output"]>
  subtitle?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  teacher_registration_count?: Maybe<Scalars["Int"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  total_registration_count?: Maybe<Scalars["Int"]["output"]>
  type: Scalars["String"]["output"]
  url?: Maybe<Scalars["String"]["output"]>
}

export type ResourceStats = {
  __typename?: "ResourceStats"
  active?: Maybe<Scalars["Int"]["output"]>
  never_active?: Maybe<Scalars["Int"]["output"]>
  private?: Maybe<Scalars["Int"]["output"]>
  public?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export enum ResourceType {
  Collection = "collection",
  Course = "course",
  Lesson = "lesson"
}

export type ResourceTypeFilter = {
  eq?: InputMaybe<ResourceType>
  gt?: InputMaybe<ResourceType>
  gte?: InputMaybe<ResourceType>
  in?: InputMaybe<Array<InputMaybe<ResourceType>>>
  lt?: InputMaybe<ResourceType>
  lte?: InputMaybe<ResourceType>
  neq?: InputMaybe<ResourceType>
  nin?: InputMaybe<Array<InputMaybe<ResourceType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type ResourceVisibility = {
  eq?: InputMaybe<ResourceVisibilityEnum>
  gt?: InputMaybe<ResourceVisibilityEnum>
  gte?: InputMaybe<ResourceVisibilityEnum>
  in?: InputMaybe<Array<InputMaybe<ResourceVisibilityEnum>>>
  lt?: InputMaybe<ResourceVisibilityEnum>
  lte?: InputMaybe<ResourceVisibilityEnum>
  neq?: InputMaybe<ResourceVisibilityEnum>
  nin?: InputMaybe<Array<InputMaybe<ResourceVisibilityEnum>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export enum ResourceVisibilityEnum {
  Inactive = "inactive",
  /** Resources visible to members */
  Members = "members",
  Private = "private",
  /** Resources visible to anyone */
  Public = "public"
}

/** Pathwright discussion response */
export type Response = {
  __typename?: "Response"
  archived_time?: Maybe<Scalars["DateTime"]["output"]>
  attachments?: Maybe<Scalars["JSON"]["output"]>
  body: Scalars["String"]["output"]
  created_time: Scalars["DateTime"]["output"]
  depth: Scalars["Int"]["output"]
  discussion: Discussion
  discussion_id: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  likes: Scalars["Int"]["output"]
  modified_time: Scalars["DateTime"]["output"]
  parent_id?: Maybe<Scalars["Int"]["output"]>
  parent_response?: Maybe<Response>
  responses?: Maybe<ResponseConnection>
  user?: Maybe<User>
  user_liked: Scalars["Boolean"]["output"]
}

/** Pathwright discussion response */
export type ResponseResponsesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type ResponseConnection = {
  __typename?: "ResponseConnection"
  /** A list of edges. */
  edges: Array<ResponseEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ResponseEdge = {
  __typename?: "ResponseEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Response
}

/** Sort order for discussion responses */
export enum ResponseOrderBy {
  /** Sort by most recent activity (like creation, but considers child responses) */
  Activity = "ACTIVITY",
  /** Sort by most recent activity (like creation, but considers child responses) (descending) */
  ActivityDesc = "ACTIVITY_DESC",
  /** Sort by creation time */
  Creation = "CREATION",
  /** Sort by creation time (descending) */
  CreationDesc = "CREATION_DESC",
  /** Sort by number of likes */
  Likes = "LIKES",
  /** Sort by number of likes (descending) */
  LikesDesc = "LIKES_DESC"
}

export enum Role {
  CohortCourseEditor = "cohort_course_editor",
  CohortLearner = "cohort_learner",
  CohortModerator = "cohort_moderator",
  CohortObserver = "cohort_observer",
  CohortTeacher = "cohort_teacher",
  GroupAdmin = "group_admin",
  GroupMember = "group_member",
  GroupModerator = "group_moderator",
  SchoolAdmin = "school_admin",
  SchoolLibraryEditor = "school_library_editor",
  SchoolMember = "school_member",
  SchoolStaff = "school_staff"
}

export type RoleFilter = {
  eq?: InputMaybe<RegistrationRoleEnum>
  gt?: InputMaybe<RegistrationRoleEnum>
  gte?: InputMaybe<RegistrationRoleEnum>
  in?: InputMaybe<Array<InputMaybe<RegistrationRoleEnum>>>
  lt?: InputMaybe<RegistrationRoleEnum>
  lte?: InputMaybe<RegistrationRoleEnum>
  neq?: InputMaybe<RegistrationRoleEnum>
  nin?: InputMaybe<Array<InputMaybe<RegistrationRoleEnum>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type RoleInContext = {
  /** Whether an item with this type of role should be excluded from results. */
  exclude?: InputMaybe<Scalars["Boolean"]["input"]>
  /** The type of the context in which the user has this role (defaults to school). */
  type: RoleInType
  /** The id of the type. */
  type_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum RoleInType {
  Cohort = "cohort",
  Group = "group",
  School = "school"
}

export type ScheduleDate = {
  __typename?: "ScheduleDate"
  behavior: ScheduleDateBehavior
  date?: Maybe<Scalars["DateTime"]["output"]>
}

export enum ScheduleDateBehavior {
  Lock = "lock",
  Passthrough = "passthrough"
}

export type ScheduleItemContext = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  /** The id source ID of the path item to be scheduled. */
  source_id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type School = {
  __typename?: "School"
  about?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Activity should be queried through root for performance reasons */
  activity?: Maybe<ActivityConnection>
  /** @deprecated Activity stats should be queried through root for performance reasons */
  activity_stats?: Maybe<ActivityStats>
  /** Wheter to prompt users to enter a password when signing up. */
  always_prompt_for_password?: Maybe<Scalars["Boolean"]["output"]>
  author?: Maybe<Author>
  authors?: Maybe<AuthorConnection>
  banner?: Maybe<Banner>
  banners?: Maybe<BannerConnection>
  billing_model?: Maybe<Scalars["Int"]["output"]>
  billing_subscription?: Maybe<SchoolBillingSubscription>
  categories?: Maybe<CategoryConnection>
  category?: Maybe<Category>
  consent_description?: Maybe<Scalars["String"]["output"]>
  couponDiscount?: Maybe<CouponDiscount>
  created?: Maybe<Scalars["DateTime"]["output"]>
  currency_code?: Maybe<Scalars["String"]["output"]>
  curriculum_plans?: Maybe<SchoolCurriculumPlanConnection>
  curriculum_subscription?: Maybe<CurriculumSubscription>
  curriculum_subscriptions?: Maybe<CurriculumSubscriptionConnection>
  email?: Maybe<Scalars["String"]["output"]>
  features: SchoolFeatures
  gift_subscription?: Maybe<SchoolGiftSubscription>
  grant_access_upon_authentication?: Maybe<Scalars["Boolean"]["output"]>
  has_certificate?: Maybe<Scalars["Boolean"]["output"]>
  head_markup?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  ietf_language_tag?: Maybe<Scalars["String"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  /** Whether the school's image is the default image. */
  image_is_default: Scalars["Boolean"]["output"]
  is_activated?: Maybe<Scalars["Boolean"]["output"]>
  is_curriculum_enabled?: Maybe<Scalars["Boolean"]["output"]>
  is_curriculum_subscriber?: Maybe<Scalars["Boolean"]["output"]>
  license_offering?: Maybe<LicenseOffering>
  logo?: Maybe<Scalars["String"]["output"]>
  members?: Maybe<MembershipConnection>
  membership_stats?: Maybe<MembershipStats>
  mentor_group?: Maybe<MentorGroup>
  mentor_group_stats?: Maybe<MentorGroupStats>
  mentor_groups?: Maybe<MentorGroupConnection>
  name: Scalars["String"]["output"]
  owner?: Maybe<User>
  owner_id?: Maybe<Scalars["Int"]["output"]>
  page?: Maybe<Page>
  pages?: Maybe<PageConnection>
  pathItems?: Maybe<PathItemConnection>
  pathwright_login_enabled?: Maybe<Scalars["Boolean"]["output"]>
  payment_requires_zip_code?: Maybe<Scalars["Boolean"]["output"]>
  platform_version?: Maybe<Scalars["Float"]["output"]>
  primary_domain?: Maybe<Scalars["String"]["output"]>
  profile?: Maybe<SchoolProfile>
  publishers?: Maybe<PublisherConnection>
  registrations?: Maybe<RegistrationConnection>
  resource?: Maybe<Resource>
  resource_license?: Maybe<ResourceLicense>
  resource_licensing_enabled?: Maybe<Scalars["Boolean"]["output"]>
  resource_stats?: Maybe<ResourceStats>
  resources?: Maybe<ResourceConnection>
  school_billing_invoice?: Maybe<SchoolBillingInvoice>
  school_billing_invoices?: Maybe<SchoolBillingInvoiceConnection>
  script_markup?: Maybe<Scalars["String"]["output"]>
  show_stripe_reconnect?: Maybe<Scalars["Boolean"]["output"]>
  /** @deprecated Use /auth/switch-space/<space_id>/ endpoint instead */
  sso_link?: Maybe<Scalars["String"]["output"]>
  storeLinks?: Maybe<StoreLinkConnection>
  stripe_access_token?: Maybe<Scalars["String"]["output"]>
  stripe_account_id?: Maybe<Scalars["String"]["output"]>
  stripe_publishable_api_key?: Maybe<Scalars["String"]["output"]>
  subdomain: Scalars["String"]["output"]
  subscription?: Maybe<Subscription>
  subscription_plans?: Maybe<SchoolSubscriptionPlanConnection>
  subscriptions?: Maybe<SubscriptionConnection>
  theme?: Maybe<Theme>
  /** Fakes a school invoice create. */
  upcoming_school_billing_invoice?: Maybe<SchoolBillingInvoice>
  url: Scalars["String"]["output"]
  website?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright School */
export type SchoolActivityArgs = {
  action_type?: InputMaybe<ActionTypeFilter>
  after?: InputMaybe<Scalars["String"]["input"]>
  date?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  interest_level?: InputMaybe<InterestLevel>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolAuthorArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Array<InputMaybe<AuthorOrderByInput>>>
  positioningContext?: InputMaybe<PositioningContextInput>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolBannerArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolBannersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A Pathwright School */
export type SchoolCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Array<InputMaybe<CategoryOrderByInput>>>
  positioningContext?: InputMaybe<PositioningContextInput>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolCategoryArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolCouponDiscountArgs = {
  code: Scalars["String"]["input"]
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  school_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolCurriculum_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  visibility_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_code_filter?: InputMaybe<StringFilter>
}

/** A Pathwright School */
export type SchoolCurriculum_SubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolCurriculum_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensee_id?: InputMaybe<IdFilter>
  licensor_id?: InputMaybe<IdFilter>
}

/** A Pathwright School */
export type SchoolGift_SubscriptionArgs = {
  code?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolLicense_OfferingArgs = {
  id: Scalars["Int"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}

/** A Pathwright School */
export type SchoolLogoArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolMembersArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  after?: InputMaybe<Scalars["String"]["input"]>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolMentor_GroupArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolMentor_GroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  descendant_of_parent_id?: InputMaybe<EquivalenceIdFilter>
  first: Scalars["Int"]["input"]
  id?: InputMaybe<IdFilter>
  parent_id?: InputMaybe<IdFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  seat_limit_filter?: InputMaybe<IntFilter>
  top_level_only?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

/** A Pathwright School */
export type SchoolPageArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolPagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A Pathwright School */
export type SchoolPathItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  due?: InputMaybe<DateFilter>
  exclude_default?: InputMaybe<Scalars["Boolean"]["input"]>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  is_reviewed?: InputMaybe<Scalars["Boolean"]["input"]>
  is_skipped?: InputMaybe<Scalars["Boolean"]["input"]>
  lesson_source_id?: InputMaybe<Scalars["Int"]["input"]>
  needs_attention?: InputMaybe<Scalars["Boolean"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  next?: InputMaybe<Scalars["Boolean"]["input"]>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  registration_role_filter?: InputMaybe<RoleFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  reviewable?: InputMaybe<Scalars["Boolean"]["input"]>
  root_level?: InputMaybe<Scalars["Boolean"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  starts?: InputMaybe<DateFilter>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<PathItemTypes>
  upcoming?: InputMaybe<Scalars["Boolean"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  with_dates?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A Pathwright School */
export type SchoolPublishersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  cohort_filter?: InputMaybe<IntFilter>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  id_filter?: InputMaybe<IntFilter>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** A Pathwright School */
export type SchoolResourceArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolResource_LicenseArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolResourcesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  author_names?: InputMaybe<StringFilter>
  author_search?: InputMaybe<Scalars["String"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  category_ids?: InputMaybe<IdFilter>
  category_names?: InputMaybe<StringFilter>
  category_search?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  has_certificate?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<IdFilter>
  license_offering_licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
  licensed_from_school?: InputMaybe<IdFilter>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  publisher_id?: InputMaybe<Scalars["Int"]["input"]>
  publisher_ids?: InputMaybe<IdFilter>
  resource_types?: InputMaybe<ResourceTypeFilter>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  user_registered?: InputMaybe<IdFilter>
  visibility?: InputMaybe<ResourceVisibility>
}

/** A Pathwright School */
export type SchoolSchool_Billing_InvoiceArgs = {
  id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolSchool_Billing_InvoicesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolSso_LinkArgs = {
  pathname?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolStoreLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensor_id?: InputMaybe<IdFilter>
}

/** A Pathwright School */
export type SchoolSubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolSubscription_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  giftable?: InputMaybe<Scalars["Boolean"]["input"]>
  ids?: InputMaybe<IdFilter>
  ignore_visibility?: InputMaybe<Scalars["Boolean"]["input"]>
  interval?: InputMaybe<SubscriptionInterval>
  interval_filter?: InputMaybe<SubscriptionIntervalFilter>
  orderBy?: InputMaybe<Array<InputMaybe<SchoolSubscriptionPlanOrderByInput>>>
  positioningContext?: InputMaybe<PositioningContextInput>
  visibility_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_code_filter?: InputMaybe<StringFilter>
}

/** A Pathwright School */
export type SchoolSubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  payment_intent_needing_action_id?: InputMaybe<IdFilter>
}

/** A Pathwright School */
export type SchoolUrlArgs = {
  pathname?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright School Account data */
export type SchoolAcount = {
  __typename?: "SchoolAcount"
  billing_model?: Maybe<Scalars["Int"]["output"]>
  billing_plan_set?: Maybe<SchoolBillingPlanSet>
  billing_subscription?: Maybe<SchoolBillingSubscription>
  curriculum_subscription?: Maybe<CurriculumSubscription>
  id?: Maybe<Scalars["Int"]["output"]>
  is_activated?: Maybe<Scalars["Boolean"]["output"]>
  is_activated_via_override?: Maybe<Scalars["Boolean"]["output"]>
  is_on_legacy_plan?: Maybe<Scalars["Boolean"]["output"]>
  scholarship?: Maybe<SchoolBillingScholarship>
}

/** Pathwright School Account data */
export type SchoolAcountBilling_Plan_SetArgs = {
  default?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** School Billing Block used for invoicing */
export type SchoolBillingBlock = {
  __typename?: "SchoolBillingBlock"
  block_size?: Maybe<Scalars["Int"]["output"]>
  block_type?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  price?: Maybe<Scalars["Float"]["output"]>
}

/** A connection to a list of items. */
export type SchoolBillingBlockConnection = {
  __typename?: "SchoolBillingBlockConnection"
  /** A list of edges. */
  edges: Array<SchoolBillingBlockEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolBillingBlockEdge = {
  __typename?: "SchoolBillingBlockEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: SchoolBillingBlock
}

/** Pathwright School Billing Invoice */
export type SchoolBillingInvoice = {
  __typename?: "SchoolBillingInvoice"
  child_subscriptions?: Maybe<Scalars["JSON"]["output"]>
  cycle_end?: Maybe<Scalars["DateTime"]["output"]>
  cycle_start?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  invoice_json?: Maybe<Scalars["JSON"]["output"]>
  invoiced_date?: Maybe<Scalars["DateTime"]["output"]>
  is_initial_prepaid_invoice?: Maybe<Scalars["Boolean"]["output"]>
  is_overdue?: Maybe<Scalars["Boolean"]["output"]>
  parent_subscription?: Maybe<Scalars["JSON"]["output"]>
  payment?: Maybe<Scalars["JSON"]["output"]>
  stripe_invoice_id?: Maybe<Scalars["String"]["output"]>
  stripe_invoice_status?: Maybe<Scalars["String"]["output"]>
  stripe_next_payment_attempt?: Maybe<Scalars["DateTime"]["output"]>
  total_amount_billed?: Maybe<Scalars["Float"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

/** A connection to a list of items. */
export type SchoolBillingInvoiceConnection = {
  __typename?: "SchoolBillingInvoiceConnection"
  /** A list of edges. */
  edges: Array<SchoolBillingInvoiceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolBillingInvoiceEdge = {
  __typename?: "SchoolBillingInvoiceEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: SchoolBillingInvoice
}

/** Pathwright School Subscription Plans Data */
export type SchoolBillingPlan = {
  __typename?: "SchoolBillingPlan"
  amount: Scalars["Float"]["output"]
  billing_blocks?: Maybe<SchoolBillingBlockConnection>
  cohorts_included: Scalars["Int"]["output"]
  color: Scalars["String"]["output"]
  description: Scalars["String"]["output"]
  features: Array<SchoolBillingPlanFeature>
  fee_per_additional_learner: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  image: Scalars["String"]["output"]
  learner_counting_method: Scalars["Int"]["output"]
  learners_included: Scalars["Int"]["output"]
  mentor_groups_included: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  plan_derived_from?: Maybe<SchoolBillingPlan>
  scholarships_available: Scalars["Boolean"]["output"]
  should_contact_for_pricing: Scalars["Boolean"]["output"]
  staff_included: Scalars["Int"]["output"]
  visibility: Visibility
}

/** Pathwright School Subscription Plans Data */
export type SchoolBillingPlanBilling_BlocksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  block_type?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
}

/** School Billing Plan Feature Data */
export type SchoolBillingPlanFeature = {
  __typename?: "SchoolBillingPlanFeature"
  description: Scalars["String"]["output"]
  feature_type: Scalars["Int"]["output"]
  icon: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  key: Scalars["String"]["output"]
  link: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  platform_version: Scalars["Float"]["output"]
}

/** School Billing Plan Set Data */
export type SchoolBillingPlanSet = {
  __typename?: "SchoolBillingPlanSet"
  id?: Maybe<Scalars["Int"]["output"]>
  is_default?: Maybe<Scalars["Boolean"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  plans?: Maybe<Array<Maybe<SchoolBillingPlan>>>
}

/** Pathwright School Billing Scholarship */
export type SchoolBillingScholarship = {
  __typename?: "SchoolBillingScholarship"
  coupon?: Maybe<StripeCoupon>
  ends?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  interval?: Maybe<Interval>
  iterations?: Maybe<Scalars["Int"]["output"]>
  order?: Maybe<Scalars["Int"]["output"]>
  plan_id?: Maybe<Scalars["Int"]["output"]>
  starts?: Maybe<Scalars["DateTime"]["output"]>
}

/** Pathwright School Subscription Data */
export type SchoolBillingSubscription = {
  __typename?: "SchoolBillingSubscription"
  charge_type?: Maybe<SubscriptionChargeType>
  child_subscriptions?: Maybe<SchoolBillingSubscriptionConnection>
  extra_cohorts?: Maybe<Scalars["Int"]["output"]>
  extra_mentor_groups?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  interval?: Maybe<SubscriptionInterval>
  parent_subscription_id?: Maybe<Scalars["Int"]["output"]>
  plan?: Maybe<SchoolBillingPlan>
  school?: Maybe<School>
  school_id?: Maybe<Scalars["Int"]["output"]>
  subscription?: Maybe<Subscription>
}

/** Pathwright School Subscription Data */
export type SchoolBillingSubscriptionChild_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type SchoolBillingSubscriptionConnection = {
  __typename?: "SchoolBillingSubscriptionConnection"
  /** A list of edges. */
  edges: Array<SchoolBillingSubscriptionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolBillingSubscriptionEdge = {
  __typename?: "SchoolBillingSubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: SchoolBillingSubscription
}

/** A connection to a list of items. */
export type SchoolConnection = {
  __typename?: "SchoolConnection"
  /** A list of edges. */
  edges: Array<SchoolEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** A school licensing school curriculum subscription plan */
export type SchoolCurriculumPlan = {
  __typename?: "SchoolCurriculumPlan"
  amount?: Maybe<Scalars["Float"]["output"]>
  fee_boundary?: Maybe<Scalars["Int"]["output"]>
  fee_per_user?: Maybe<Scalars["Int"]["output"]>
  id: Scalars["Int"]["output"]
  is_visible?: Maybe<Scalars["Boolean"]["output"]>
  licensor: School
  lower_boundary?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  plan_id?: Maybe<Scalars["Int"]["output"]>
  transaction_fee_percent?: Maybe<Scalars["Int"]["output"]>
  upper_boundary?: Maybe<Scalars["Int"]["output"]>
  visibility_code?: Maybe<Scalars["String"]["output"]>
}

/** A connection to a list of items. */
export type SchoolCurriculumPlanConnection = {
  __typename?: "SchoolCurriculumPlanConnection"
  /** A list of edges. */
  edges: Array<SchoolCurriculumPlanEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolCurriculumPlanEdge = {
  __typename?: "SchoolCurriculumPlanEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: SchoolCurriculumPlan
}

/** An edge in a connection. */
export type SchoolEdge = {
  __typename?: "SchoolEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: School
}

/** A list of all features that the school may or may not have access to, with a value indicating whether or not the school has access */
export type SchoolFeatures = {
  __typename?: "SchoolFeatures"
  /** Allows users of a Space to use the Auth Request (via email) feature. */
  auth__login_option__email_link: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Apple SSO feature. */
  auth__login_option__global_sso__apple: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Google SSO feature. */
  auth__login_option__global_sso__google: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Password login feature. */
  auth__login_option__password: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Paths Auth feature. */
  auth__platform: Scalars["Boolean"]["output"]
  /** Allows a Space to enable the Blocks rollout (migration and DB creation). Scoped to school and optionally to a resource. */
  blocks__rollout: Scalars["Boolean"]["output"]
  /** Allows cohort members to view activity of other members. */
  cohort__activity_feed: Scalars["Boolean"]["output"]
  /** Allows cohort members to view other members in the cohort community. */
  cohort__member_directory: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Community Groups feature. */
  community__groups: Scalars["Boolean"]["output"]
  /** Allows a Space to enable the Previewing the New Home Screen for a specific group. */
  home_screen__preview: Scalars["Boolean"]["output"]
  /** Allows a Space to use the new (unified) Home Screen. */
  home_screen__unified: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Add to Path feature. */
  library__add_to_path: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Collections feature. */
  library__collections: Scalars["Boolean"]["output"]
  /** Allows a Space to enable cover pages for their library. */
  library__cover_pages: Scalars["Boolean"]["output"]
  /** Allows a Space to enable downloadable/offline videos for their users. */
  media__downloadable_videos: Scalars["Boolean"]["output"]
  /** Allows a Space to use sync a Path to paths.app. */
  paths_app__publish: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Share Card feature. */
  school__share_card: Scalars["Boolean"]["output"]
}

export type SchoolGiftSubscription = {
  __typename?: "SchoolGiftSubscription"
  gift_code?: Maybe<Scalars["String"]["output"]>
  gift_message?: Maybe<Scalars["String"]["output"]>
  gifted_subscription_cycles?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  recipient_email?: Maybe<Scalars["String"]["output"]>
  recipient_email_sent_time?: Maybe<Scalars["DateTime"]["output"]>
  recipient_first_name?: Maybe<Scalars["String"]["output"]>
  recipient_last_name?: Maybe<Scalars["String"]["output"]>
  redeemed?: Maybe<Scalars["Boolean"]["output"]>
  redemption_link?: Maybe<Scalars["String"]["output"]>
  school_subscription_plan?: Maybe<SchoolSubscriptionPlan>
  sender?: Maybe<User>
}

/** A School Group Subscription */
export type SchoolGroupSubscription = {
  __typename?: "SchoolGroupSubscription"
  community_group: MentorGroup
  id: Scalars["Int"]["output"]
  price: StripePrice
  school: School
  subscription: Subscription
  user: User
}

/** A connection to a list of items. */
export type SchoolGroupSubscriptionConnection = {
  __typename?: "SchoolGroupSubscriptionConnection"
  /** A list of edges. */
  edges: Array<SchoolGroupSubscriptionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolGroupSubscriptionEdge = {
  __typename?: "SchoolGroupSubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: SchoolGroupSubscription
}

export type SchoolProfile = {
  __typename?: "SchoolProfile"
  id?: Maybe<Scalars["Int"]["output"]>
  plan_to_sell?: Maybe<Scalars["Boolean"]["output"]>
  school_type?: Maybe<SchoolType>
}

/** A School Subscription */
export type SchoolSubscription = {
  __typename?: "SchoolSubscription"
  id: Scalars["Int"]["output"]
  school_subscription_plan: SchoolSubscriptionPlan
  subscription: Subscription
  subscription_plan: SubscriptionPlan
  user: User
}

export type SchoolSubscriptionDiscount = {
  __typename?: "SchoolSubscriptionDiscount"
  currency_display_discount_amount?: Maybe<Scalars["String"]["output"]>
  currency_display_discount_price?: Maybe<Scalars["String"]["output"]>
  discount_percent?: Maybe<Scalars["Float"]["output"]>
  discounted_price?: Maybe<Scalars["Float"]["output"]>
  discounted_subscription_cycles?: Maybe<Scalars["Int"]["output"]>
}

/** School subscription order data */
export type SchoolSubscriptionOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  start_free_trial?: InputMaybe<Scalars["Boolean"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}

/** A School Subscription Plan */
export type SchoolSubscriptionPlan = {
  __typename?: "SchoolSubscriptionPlan"
  catalog_header?: Maybe<Scalars["String"]["output"]>
  details_html?: Maybe<Scalars["String"]["output"]>
  giftable_cycles?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  id: Scalars["Int"]["output"]
  image?: Maybe<Scalars["String"]["output"]>
  is_visible?: Maybe<Scalars["Boolean"]["output"]>
  /** The contextual position for this object based on the `positioningContext` arg. */
  position: Scalars["String"]["output"]
  subscribe_complete_html?: Maybe<Scalars["String"]["output"]>
  subscription_plan: SubscriptionPlan
}

/** A connection to a list of items. */
export type SchoolSubscriptionPlanConnection = {
  __typename?: "SchoolSubscriptionPlanConnection"
  /** A list of edges. */
  edges: Array<SchoolSubscriptionPlanEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolSubscriptionPlanEdge = {
  __typename?: "SchoolSubscriptionPlanEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: SchoolSubscriptionPlan
}

/** Input for ordering the list. */
export type SchoolSubscriptionPlanOrderByInput = {
  /** Order by id. */
  id?: InputMaybe<OrderByDir>
  /** Order by position. */
  position?: InputMaybe<OrderByDir>
}

export enum SchoolType {
  CoachTutor = "coach_tutor",
  CurriculumPublisher = "curriculum_publisher",
  CustomerTraining = "customer_training",
  HigherEd = "higher_ed",
  K12 = "k12",
  Ministry = "ministry",
  NonProfit = "non_profit",
  Other = "other",
  ProfessionalDevelopment = "professional_development",
  Training = "training",
  Unspecified = "unspecified"
}

export enum ShareAccessPermission {
  Full = "FULL",
  Gated = "GATED",
  None = "NONE"
}

/** The current user's share permissions pertaining to provided context. */
export type ShareCohortPermissions = {
  __typename?: "ShareCohortPermissions"
  /** The email of the user to contact for activating school on a Pathwright plan. */
  activate_contact_email?: Maybe<Scalars["EmailAddress"]["output"]>
  /** The maximum number, if any, of users that may be added. */
  add_limit?: Maybe<Scalars["Int"]["output"]>
  /** Whether user can activate school on a Pathwright plan. */
  allow_activate?: Maybe<Scalars["Boolean"]["output"]>
  /** Whether user can manage settings for the [type/type_id] item. */
  allow_manage?: Maybe<Scalars["Boolean"]["output"]>
  invite_roles?: Maybe<ShareCohortPermissionsInviteRoles>
  invite_to_roles?: Maybe<ShareCohortPermissionsInviteToRoles>
  /** The settings URL for the [type/type_id] item. */
  manage_url?: Maybe<Scalars["String"]["output"]>
  /** Whether user can use share UI. */
  share_access?: Maybe<CohortShareAccess>
  /** Whether user can use share > add UI. */
  share_add_access?: Maybe<CohortShareAddAccess>
  /** Whether user can use share > link UI. */
  share_link_access?: Maybe<CohortShareLinkAccess>
  /** Whether user can use share > track UI. */
  share_track_access?: Maybe<CohortShareTrackAccess>
  type?: Maybe<ShareContextType>
  type_id?: Maybe<Scalars["Int"]["output"]>
}

export type ShareCohortPermissionsInviteRole = {
  __typename?: "ShareCohortPermissionsInviteRole"
  gate_reason?: Maybe<CohortShareInviteRoleGatedReasonType>
  role?: Maybe<Scalars["Int"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export type ShareCohortPermissionsInviteRoles = {
  __typename?: "ShareCohortPermissionsInviteRoles"
  course_editor?: Maybe<ShareCohortPermissionsInviteRole>
  learner?: Maybe<ShareCohortPermissionsInviteRole>
  moderator?: Maybe<ShareCohortPermissionsInviteRole>
  observer?: Maybe<ShareCohortPermissionsInviteRole>
  teacher?: Maybe<ShareCohortPermissionsInviteRole>
  viewer?: Maybe<ShareCohortPermissionsInviteRole>
}

/** Legacy invite URLs per role. Use invite_roles for gate_reason support. */
export type ShareCohortPermissionsInviteToRoles = {
  __typename?: "ShareCohortPermissionsInviteToRoles"
  course_editor?: Maybe<Scalars["String"]["output"]>
  learner?: Maybe<Scalars["String"]["output"]>
  moderator?: Maybe<Scalars["String"]["output"]>
  observer?: Maybe<Scalars["String"]["output"]>
  teacher?: Maybe<Scalars["String"]["output"]>
  viewer?: Maybe<Scalars["String"]["output"]>
}

export type ShareContext = {
  /** The type of the context in which the user has the permission (defaults to school). */
  type: ShareContextType
  /** The id of the type. */
  type_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum ShareContextType {
  Cohort = "cohort",
  Group = "group",
  School = "school"
}

/** The current user's share permissions pertaining to provided context. */
export type ShareGroupPermissions = {
  __typename?: "ShareGroupPermissions"
  /** The email of the user to contact for activating school on a Pathwright plan. */
  activate_contact_email?: Maybe<Scalars["EmailAddress"]["output"]>
  /** The maximum number, if any, of users that may be added. */
  add_limit?: Maybe<Scalars["Int"]["output"]>
  /** Whether user can activate school on a Pathwright plan. */
  allow_activate?: Maybe<Scalars["Boolean"]["output"]>
  /** Whether user can manage settings for the [type/type_id] item. */
  allow_manage?: Maybe<Scalars["Boolean"]["output"]>
  invite_roles?: Maybe<ShareGroupPermissionsInviteRoles>
  /** The settings URL for the [type/type_id] item. */
  manage_url?: Maybe<Scalars["String"]["output"]>
  /** Whether user can use share UI. */
  share_access?: Maybe<GroupShareAccess>
  /** Whether user can use share > add UI. */
  share_add_access?: Maybe<GroupShareAddAccess>
  /** Whether user can use share > link UI. */
  share_link_access?: Maybe<GroupShareLinkAccess>
  /** Whether user can use share > track UI. */
  share_track_access?: Maybe<GroupShareTrackAccess>
  type?: Maybe<ShareContextType>
  type_id?: Maybe<Scalars["Int"]["output"]>
}

export type ShareGroupPermissionsInviteRole = {
  __typename?: "ShareGroupPermissionsInviteRole"
  gate_reason?: Maybe<GroupShareInviteRoleGatedReasonType>
  role?: Maybe<Scalars["Int"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export type ShareGroupPermissionsInviteRoles = {
  __typename?: "ShareGroupPermissionsInviteRoles"
  admin?: Maybe<ShareGroupPermissionsInviteRole>
  member?: Maybe<ShareGroupPermissionsInviteRole>
  moderator?: Maybe<ShareGroupPermissionsInviteRole>
}

/** The current user's share permissions pertaining to provided context. */
export type SharePermissions = ShareCohortPermissions | ShareGroupPermissions

export type Space = {
  __typename?: "Space"
  /** Whether new users can sign up without an invitation. */
  allow_public_signup?: Maybe<Scalars["Boolean"]["output"]>
  /** Signifies whether a Space allows a user to join as a member */
  allow_signup: Scalars["Boolean"]["output"]
  /** Whether to prompt users to enter a password when signing up. */
  always_prompt_for_password?: Maybe<Scalars["Boolean"]["output"]>
  authMethods: Array<AuthMethod>
  /** Description of consent from user for space to do xy and z. */
  consent_description?: Maybe<Scalars["String"]["output"]>
  created: Scalars["String"]["output"]
  features: SpaceFeatures
  id: Scalars["Int"]["output"]
  ietf_language_tag?: Maybe<Scalars["String"]["output"]>
  image: Scalars["String"]["output"]
  is_activated: Scalars["Boolean"]["output"]
  is_owner: Scalars["Boolean"]["output"]
  logo_image?: Maybe<Scalars["String"]["output"]>
  media?: Maybe<Array<Maybe<SpaceMedia>>>
  meta: NodeMeta
  name: Scalars["String"]["output"]
  /** Whether Pathwright Sign-in options (currently Password and Magic Link) are available. */
  pathwright_login_enabled?: Maybe<Scalars["Boolean"]["output"]>
  primary_domain?: Maybe<Scalars["String"]["output"]>
  subdomain: Scalars["String"]["output"]
  theme: NodeTheme
}

export type SpaceAllow_SignupArgs = {
  invite_token?: InputMaybe<Scalars["String"]["input"]>
}

export type SpaceImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type SpaceConnection = {
  __typename?: "SpaceConnection"
  last_activity_date?: Maybe<Scalars["DateTime"]["output"]>
  role: Scalars["Int"]["output"]
  space: Space
}

/** A connection to a list of items. */
export type SpaceConnectionConnection = {
  __typename?: "SpaceConnectionConnection"
  /** A list of edges. */
  edges: Array<SpaceConnectionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SpaceConnectionEdge = {
  __typename?: "SpaceConnectionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: SpaceConnection
}

/** A list of all features that the space may or may not have access to, with a value indicating whether or not the space has access */
export type SpaceFeatures = {
  __typename?: "SpaceFeatures"
  /** Allows users of a Space to use the Auth Request (via email) feature. */
  auth__login_option__email_link: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Apple SSO feature. */
  auth__login_option__global_sso__apple: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Google SSO feature. */
  auth__login_option__global_sso__google: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Password login feature. */
  auth__login_option__password: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Paths Auth feature. */
  auth__platform: Scalars["Boolean"]["output"]
  /** Allows a Space to enable the Blocks rollout (migration and DB creation). Scoped to school and optionally to a resource. */
  blocks__rollout: Scalars["Boolean"]["output"]
  /** Allows cohort members to view activity of other members. */
  cohort__activity_feed: Scalars["Boolean"]["output"]
  /** Allows cohort members to view other members in the cohort community. */
  cohort__member_directory: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Community Groups feature. */
  community__groups: Scalars["Boolean"]["output"]
  /** Allows a Space to enable the Previewing the New Home Screen for a specific group. */
  home_screen__preview: Scalars["Boolean"]["output"]
  /** Allows a Space to use the new (unified) Home Screen. */
  home_screen__unified: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Add to Path feature. */
  library__add_to_path: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Collections feature. */
  library__collections: Scalars["Boolean"]["output"]
  /** Allows a Space to enable cover pages for their library. */
  library__cover_pages: Scalars["Boolean"]["output"]
  /** Allows a Space to enable downloadable/offline videos for their users. */
  media__downloadable_videos: Scalars["Boolean"]["output"]
  /** Allows a Space to use sync a Path to paths.app. */
  paths_app__publish: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Share Card feature. */
  school__share_card: Scalars["Boolean"]["output"]
}

export type SpaceMedia = {
  __typename?: "SpaceMedia"
  meta: NodeMeta
}

export type StepContent = {
  __typename?: "StepContent"
  data?: Maybe<Scalars["JSON"]["output"]>
  id?: Maybe<Scalars["String"]["output"]>
  method?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

/** The context this step belongs to (resource and cohort) */
export type StepContext = {
  __typename?: "StepContext"
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  school_id?: Maybe<Scalars["Int"]["output"]>
}

export type Store = {
  __typename?: "Store"
  id: Scalars["Int"]["output"]
  /** The school providing the curriculum */
  licensor: School
}

export type StoreBanner = {
  __typename?: "StoreBanner"
  button_text?: Maybe<Scalars["String"]["output"]>
  button_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  meta: NodeMeta
  theme: NodeTheme
}

export type StoreCollection = {
  __typename?: "StoreCollection"
  id?: Maybe<Scalars["Int"]["output"]>
  items?: Maybe<StoreItemConnection>
  meta: NodeMeta
  theme: NodeTheme
}

export type StoreCollectionItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
}

export type StoreItem = {
  __typename?: "StoreItem"
  authors?: Maybe<AuthorConnection>
  category_ids: Array<Maybe<Scalars["Int"]["output"]>>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  meta: NodeMeta
  options: Array<Maybe<StoreItemOption>>
  short_description?: Maybe<Scalars["String"]["output"]>
  theme: NodeTheme
}

export type StoreItemAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type StoreItemConnection = {
  __typename?: "StoreItemConnection"
  /** A list of edges. */
  edges: Array<StoreItemEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StoreItemEdge = {
  __typename?: "StoreItemEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: StoreItem
}

export type StoreItemOption = {
  __typename?: "StoreItemOption"
  id?: Maybe<Scalars["Int"]["output"]>
  meta: NodeMeta
  path_id?: Maybe<Scalars["Int"]["output"]>
  price?: Maybe<Scalars["Int"]["output"]>
}

export type StoreLink = {
  __typename?: "StoreLink"
  id: Scalars["Int"]["output"]
  /** The school licensing the curriculum */
  licensee: School
  /** The store through which curriculum can be licensed */
  store: Store
}

/** A connection to a list of items. */
export type StoreLinkConnection = {
  __typename?: "StoreLinkConnection"
  /** A list of edges. */
  edges: Array<StoreLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StoreLinkEdge = {
  __typename?: "StoreLinkEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: StoreLink
}

export type StoreOfferInput = {
  access_ends?: InputMaybe<Scalars["DateTime"]["input"]>
  access_starts?: InputMaybe<Scalars["DateTime"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  color?: InputMaybe<Scalars["String"]["input"]>
  cta_label?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  enrollment_ends?: InputMaybe<Scalars["DateTime"]["input"]>
  enrollment_starts?: InputMaybe<Scalars["DateTime"]["input"]>
  external_url?: InputMaybe<Scalars["String"]["input"]>
  image?: InputMaybe<Scalars["String"]["input"]>
  kind: OfferKind
  position?: InputMaybe<Scalars["String"]["input"]>
  price?: InputMaybe<Scalars["Float"]["input"]>
  resource_license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  seats?: InputMaybe<Scalars["Int"]["input"]>
  title: Scalars["String"]["input"]
  visibility?: InputMaybe<Scalars["Int"]["input"]>
}

export type StoreOfferPatchInput = {
  access_ends?: InputMaybe<Scalars["DateTime"]["input"]>
  access_starts?: InputMaybe<Scalars["DateTime"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  color?: InputMaybe<Scalars["String"]["input"]>
  cta_label?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  enrollment_ends?: InputMaybe<Scalars["DateTime"]["input"]>
  enrollment_starts?: InputMaybe<Scalars["DateTime"]["input"]>
  external_url?: InputMaybe<Scalars["String"]["input"]>
  image?: InputMaybe<Scalars["String"]["input"]>
  kind?: InputMaybe<OfferKind>
  position?: InputMaybe<Scalars["String"]["input"]>
  price?: InputMaybe<Scalars["Float"]["input"]>
  resource_license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  seats?: InputMaybe<Scalars["Int"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  visibility?: InputMaybe<Scalars["Int"]["input"]>
}

export type StoreOfferReorderInput = {
  order: Array<StoreOfferReorderItemInput>
}

export type StoreOfferReorderItemInput = {
  id: Scalars["Int"]["input"]
  position: Scalars["String"]["input"]
}

export type Storefront = {
  __typename?: "Storefront"
  id: Scalars["String"]["output"]
  meta: NodeMeta
}

export type StringFilter = {
  eq?: InputMaybe<Scalars["String"]["input"]>
  gt?: InputMaybe<Scalars["String"]["input"]>
  gte?: InputMaybe<Scalars["String"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  lt?: InputMaybe<Scalars["String"]["input"]>
  lte?: InputMaybe<Scalars["String"]["input"]>
  neq?: InputMaybe<Scalars["String"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export enum StripeBillingScheme {
  PerUnit = "per_unit",
  Tiered = "tiered"
}

/** Represents a Coupon for a Subscription on Stripe. Used for Scholarships. */
export type StripeCoupon = {
  __typename?: "StripeCoupon"
  id?: Maybe<Scalars["Int"]["output"]>
  percent_off?: Maybe<Scalars["Float"]["output"]>
}

/** Represents a Price for a Product on Stripe that specifies pricing configuration. */
export type StripePrice = {
  __typename?: "StripePrice"
  active?: Maybe<Scalars["Boolean"]["output"]>
  billing_scheme?: Maybe<StripeBillingScheme>
  currency?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  nickname?: Maybe<Scalars["String"]["output"]>
  product?: Maybe<StripeProduct>
  recurring_interval?: Maybe<StripeRecurringInterval>
  recurring_interval_count?: Maybe<Scalars["Int"]["output"]>
  /** The URL to the connected Stripe dashboard for this price. */
  stripe_connected_account_url?: Maybe<Scalars["String"]["output"]>
  stripe_price_id?: Maybe<Scalars["String"]["output"]>
  tiers?: Maybe<Array<Maybe<StripeTier>>>
  tiers_mode?: Maybe<StripeTiersMode>
  unit_amount_decimal?: Maybe<Scalars["Float"]["output"]>
}

/** A connection to a list of items. */
export type StripePriceConnection = {
  __typename?: "StripePriceConnection"
  /** A list of edges. */
  edges: Array<StripePriceEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StripePriceEdge = {
  __typename?: "StripePriceEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: StripePrice
}

/** Represents a Product on Stripe that can be sold. */
export type StripeProduct = {
  __typename?: "StripeProduct"
  active?: Maybe<Scalars["Boolean"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  images?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  max_quantity?: Maybe<Scalars["Int"]["output"]>
  min_quantity?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  processor?: Maybe<School>
  /** The URL to the connected Stripe dashboard for this product. */
  stripe_connected_account_url?: Maybe<Scalars["String"]["output"]>
  stripe_prices?: Maybe<StripePriceConnection>
  stripe_product_id?: Maybe<Scalars["String"]["output"]>
  unit_label?: Maybe<Scalars["String"]["output"]>
}

/** Represents a Product on Stripe that can be sold. */
export type StripeProductStripe_PricesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type StripeProductConnection = {
  __typename?: "StripeProductConnection"
  /** A list of edges. */
  edges: Array<StripeProductEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StripeProductEdge = {
  __typename?: "StripeProductEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: StripeProduct
}

export enum StripeRecurringInterval {
  Day = "day",
  Month = "month",
  Week = "week",
  Year = "year"
}

export type StripeTier = {
  __typename?: "StripeTier"
  flat_amount?: Maybe<Scalars["Int"]["output"]>
  flat_amount_decimal?: Maybe<Scalars["String"]["output"]>
  unit_amount?: Maybe<Scalars["Int"]["output"]>
  unit_amount_decimal?: Maybe<Scalars["String"]["output"]>
  up_to?: Maybe<Scalars["Int"]["output"]>
}

export enum StripeTiersMode {
  Graduated = "graduated",
  Volume = "volume"
}

export type Subdomain = {
  __typename?: "Subdomain"
  id?: Maybe<Scalars["Int"]["output"]>
  subdomain?: Maybe<Scalars["String"]["output"]>
}

/** Subscription Data */
export type Subscription = {
  __typename?: "Subscription"
  canceled_dtime?: Maybe<Scalars["DateTime"]["output"]>
  cancellation_reason?: Maybe<Scalars["Int"]["output"]>
  card_last_4?: Maybe<Scalars["String"]["output"]>
  customer?: Maybe<User>
  cycle_end_dtime?: Maybe<Scalars["DateTime"]["output"]>
  cycle_start_dtime?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  is_canceled_at_cycle_end?: Maybe<Scalars["Boolean"]["output"]>
  is_delinquent?: Maybe<Scalars["Boolean"]["output"]>
  paused_until_dtime?: Maybe<Scalars["DateTime"]["output"]>
  /** The client_secret set on the payment intent associated with this subscription (if subscription.payment_intent_needing_action_id is not null). */
  payment_intent_client_secret?: Maybe<Scalars["String"]["output"]>
  payment_intent_needing_action_id?: Maybe<Scalars["String"]["output"]>
  quantity?: Maybe<Scalars["Int"]["output"]>
  /** Used in conjunction with the payment_intent_client_secret to execute the handleCardAction via Stripe.js. */
  stripe_publishable_api_key?: Maybe<Scalars["String"]["output"]>
  subscription_plan?: Maybe<SubscriptionPlan>
  trial_end_dtime?: Maybe<Scalars["DateTime"]["output"]>
  trial_type?: Maybe<Scalars["Int"]["output"]>
}

export enum SubscriptionChargeType {
  Invoice = "invoice",
  NoCharge = "no_charge",
  PathwrightTeam = "pathwright_team",
  Stripe = "stripe"
}

/** A connection to a list of items. */
export type SubscriptionConnection = {
  __typename?: "SubscriptionConnection"
  /** A list of edges. */
  edges: Array<SubscriptionEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SubscriptionEdge = {
  __typename?: "SubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Subscription
}

export enum SubscriptionInterval {
  Biannually = "biannually",
  Lifetime = "lifetime",
  Monthly = "monthly",
  Yearly = "yearly"
}

export type SubscriptionIntervalFilter = {
  eq?: InputMaybe<SubscriptionInterval>
  gt?: InputMaybe<SubscriptionInterval>
  gte?: InputMaybe<SubscriptionInterval>
  in?: InputMaybe<Array<InputMaybe<SubscriptionInterval>>>
  lt?: InputMaybe<SubscriptionInterval>
  lte?: InputMaybe<SubscriptionInterval>
  neq?: InputMaybe<SubscriptionInterval>
  nin?: InputMaybe<Array<InputMaybe<SubscriptionInterval>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

/** Payment Subscription Plan Data */
export type SubscriptionPlan = {
  __typename?: "SubscriptionPlan"
  amount?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  interval: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  plan_type?: Maybe<Scalars["String"]["output"]>
  /** The URL to the connected Stripe dashboard for this plan. */
  stripe_connected_account_url?: Maybe<Scalars["String"]["output"]>
  trial_period_days: Scalars["Int"]["output"]
  trial_type: SubscriptionTrialType
}

export enum SubscriptionTrialType {
  GiftSubscription = "gift_subscription",
  None = "none",
  WithCard = "with_card",
  WithoutCard = "without_card",
  WithoutCardStripe = "without_card_stripe"
}

/** A generic tag */
export type Tag = {
  __typename?: "Tag"
  color?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  school: School
  slug: Scalars["String"]["output"]
  tagAttachment?: Maybe<TagAttachment>
  tagAttachments?: Maybe<TagAttachmentConnection>
}

/** A generic tag */
export type TagTagAttachmentArgs = {
  context?: InputMaybe<TagAttachmentContextInput>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A generic tag */
export type TagTagAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<TagAttachmentContextInput>
  first: Scalars["Int"]["input"]
  tag_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A tag attachment provides a means of attaching a tag to a context. */
export type TagAttachment = {
  __typename?: "TagAttachment"
  id?: Maybe<Scalars["Int"]["output"]>
  position?: Maybe<Scalars["String"]["output"]>
  resource?: Maybe<Resource>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  school?: Maybe<School>
  school_id?: Maybe<Scalars["Int"]["output"]>
  tag?: Maybe<Tag>
  tag_id?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type TagAttachmentConnection = {
  __typename?: "TagAttachmentConnection"
  /** A list of edges. */
  edges: Array<TagAttachmentEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type TagAttachmentContextInput = {
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type TagAttachmentEdge = {
  __typename?: "TagAttachmentEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: TagAttachment
}

/** A connection to a list of items. */
export type TagConnection = {
  __typename?: "TagConnection"
  /** A list of edges. */
  edges: Array<TagEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type TagCreateInput = {
  color?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
}

export type TagDeleteInput = {
  id: Scalars["Int"]["input"]
}

/** An edge in a connection. */
export type TagEdge = {
  __typename?: "TagEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: Tag
}

/** A tagLink that links tags to other models within a tagAttachment context, currently only to a discussion context. */
export type TagLink = {
  __typename?: "TagLink"
  discussion_context_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  tag?: Maybe<Tag>
  tag_id?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type TagLinkConnection = {
  __typename?: "TagLinkConnection"
  /** A list of edges. */
  edges: Array<TagLinkEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type TagLinkContextInput = {
  discussion_context_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type TagLinkEdge = {
  __typename?: "TagLinkEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: TagLink
}

export type TagUpdateInput = {
  color?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type TextObject = {
  alignment: TextObjectAlignment
  dimensions: TextObjectDimensions
  font_color: Scalars["String"]["input"]
  font_name: Scalars["String"]["input"]
  font_size: Scalars["Float"]["input"]
  gutter?: InputMaybe<Scalars["Float"]["input"]>
  letter_spacing?: InputMaybe<Scalars["Float"]["input"]>
  line_height?: InputMaybe<Scalars["Float"]["input"]>
  position: TextObjectPosition
  text: Scalars["String"]["input"]
}

export enum TextObjectAlignment {
  Center = "center",
  Left = "left",
  Right = "right"
}

export type TextObjectDimensions = {
  height: Scalars["Float"]["input"]
  width: Scalars["Float"]["input"]
}

export type TextObjectPosition = {
  left: Scalars["Float"]["input"]
  top: Scalars["Float"]["input"]
}

/** A School Theme */
export type Theme = {
  __typename?: "Theme"
  background_image?: Maybe<Scalars["String"]["output"]>
  background_overlay?: Maybe<Scalars["String"]["output"]>
  background_type?: Maybe<Scalars["Int"]["output"]>
  color_palette?: Maybe<NodeThemeColorPalette>
  custom_css?: Maybe<Scalars["String"]["output"]>
  heading_font?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  primary_color?: Maybe<Scalars["String"]["output"]>
  processed_custom_css?: Maybe<Scalars["String"]["output"]>
  theme_type?: Maybe<ThemeType>
  typekit_id?: Maybe<Scalars["String"]["output"]>
}

/** A School Theme */
export type ThemeBackground_ImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** Theme attributes */
export type ThemeInput = {
  background_image?: InputMaybe<Scalars["URL"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  custom_css?: InputMaybe<Scalars["String"]["input"]>
  heading_font?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  primary_color?: InputMaybe<Scalars["String"]["input"]>
  theme_type?: InputMaybe<ThemeType>
}

export enum ThemeType {
  Classic = "CLASSIC",
  Creative = "CREATIVE",
  Default = "DEFAULT",
  Legacy = "LEGACY",
  Modern = "MODERN"
}

/** Auth token */
export type Token = {
  __typename?: "Token"
  created?: Maybe<Scalars["DateTime"]["output"]>
  token?: Maybe<Scalars["String"]["output"]>
  user_id?: Maybe<Scalars["Int"]["output"]>
}

/** The context of a Pathwright 'session' in a school. */
export type Translation = {
  __typename?: "Translation"
  id: Scalars["Int"]["output"]
  is_default: Scalars["Boolean"]["output"]
  language: Scalars["String"]["output"]
  /** Returning the default english translation when the school has a custom translation. */
  master_translation?: Maybe<Scalars["JSON"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  school_translation?: Maybe<Scalars["JSON"]["output"]>
  source_translation?: Maybe<Scalars["JSON"]["output"]>
  translation: Scalars["JSON"]["output"]
}

/** A Pathwright User */
export type User = {
  __typename?: "User"
  display_name?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  external_account_link?: Maybe<ExternalAccountLink>
  first_name: Scalars["String"]["output"]
  full_name: Scalars["String"]["output"]
  gravatar?: Maybe<Gravatar>
  group_role_stats?: Maybe<Array<Maybe<GroupRoleStats>>>
  id: Scalars["Int"]["output"]
  is_active: Scalars["Boolean"]["output"]
  /** A user account setup is onl considered 'finalized' when the `first_name` and `last_name` fields have been set. */
  is_finalized?: Maybe<Scalars["Boolean"]["output"]>
  is_staff: Scalars["Boolean"]["output"]
  is_superuser: Scalars["Boolean"]["output"]
  last_name: Scalars["String"]["output"]
  membership?: Maybe<Membership>
  memberships?: Maybe<MembershipConnection>
  mentorGroupMemberships?: Maybe<MentorGroupMembershipConnection>
  no_password_set?: Maybe<Scalars["Boolean"]["output"]>
  /** The user's payment history */
  payment_history: PaymentHistory
  permissions?: Maybe<ContextPermissions>
  profile?: Maybe<Profile>
  registrations?: Maybe<RegistrationConnection>
  school_group_subscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  school_subscription?: Maybe<SchoolSubscription>
  token?: Maybe<Token>
  username?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright User */
export type UserMembershipsArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  after?: InputMaybe<Scalars["String"]["input"]>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright User */
export type UserMentorGroupMembershipsArgs = {
  _or?: InputMaybe<MentorGroupMembershipOr>
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright User */
export type UserRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  cohort_filter?: InputMaybe<IntFilter>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  id_filter?: InputMaybe<IntFilter>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** A Pathwright User */
export type UserSchool_Group_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Input type for User. */
export type UserInput = {
  /** Email of the user. */
  email: Scalars["String"]["input"]
  /** First name of the user. */
  firstName: Scalars["String"]["input"]
  /** ID of the user. */
  id: Scalars["Int"]["input"]
  /** Last name of the user. */
  lastName: Scalars["String"]["input"]
}

/** JSON preferences owned by the current user in the current school. */
export type UserPreference = {
  __typename?: "UserPreference"
  created: Scalars["DateTime"]["output"]
  data: Scalars["JSON"]["output"]
  id: Scalars["Int"]["output"]
  key: Scalars["String"]["output"]
  modified: Scalars["DateTime"]["output"]
  school_id: Scalars["Int"]["output"]
  scope: Scalars["String"]["output"]
  user_id: Scalars["Int"]["output"]
}

/** Input type for User Profile. */
export type UserProfileInput = {
  /** Avatar URL of the user. */
  avatar?: InputMaybe<Scalars["String"]["input"]>
  /** Bio of the user. */
  bio: Scalars["String"]["input"]
  /** ID of the user profile. */
  id: Scalars["Int"]["input"]
  /** Location of the user. */
  location: Scalars["String"]["input"]
}

/** Check on the existence and verification status of any email/username. */
export type UserStatus = {
  __typename?: "UserStatus"
  /** Whether a user's email has been verified. */
  email_verified: Scalars["Boolean"]["output"]
  /** Whether a user has a membership for the Space. */
  has_membership: Scalars["Boolean"]["output"]
  /** Indicates the type of input received. */
  input_type: UserStatusInputType
  /** Whether a user has a password set. */
  no_password_set: Scalars["Boolean"]["output"]
  /** Whether the email or username exists. */
  user_exists: Scalars["Boolean"]["output"]
}

export enum UserStatusInputType {
  Email = "email",
  Proxy = "proxy",
  Username = "username"
}

/** Legacy content (only applicable to Path Items using legacy content, pre-dating Blocks). */
export type UserSubmission = {
  __typename?: "UserSubmission"
  file_image?: Maybe<Scalars["String"]["output"]>
  file_name?: Maybe<Scalars["String"]["output"]>
  file_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  text?: Maybe<Scalars["String"]["output"]>
}

/** An event from a webhook subscription. Currently these will only be faild webhook events. */
export type WebhookEvent = {
  __typename?: "WebhookEvent"
  /** The event types to being subscribed to. */
  event: WebhookEventType
  event_data: Scalars["JSON"]["output"]
  last_attempt_dtime: Scalars["DateTime"]["output"]
  status: WebhookEventStatus
  uuid: Scalars["UUID"]["output"]
  webhook_subscription: WebhookSubscription
}

/** A connection to a list of items. */
export type WebhookEventConnection = {
  __typename?: "WebhookEventConnection"
  /** A list of edges. */
  edges: Array<WebhookEventEdge>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type WebhookEventEdge = {
  __typename?: "WebhookEventEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node: WebhookEvent
}

/** Input for ordering the list. */
export type WebhookEventOrderBy = {
  /** Order by last_attempt_dtime. */
  last_attempt_dtime?: InputMaybe<OrderByDir>
}

export enum WebhookEventStatus {
  Failed = "FAILED"
}

export enum WebhookEventType {
  All = "ALL",
  CohortCreated = "COHORT_CREATED",
  NewLearningActivity = "NEW_LEARNING_ACTIVITY",
  RegistrationSucceeded = "REGISTRATION_SUCCEEDED",
  StepCompletionReviewed = "STEP_COMPLETION_REVIEWED",
  StudentCourseCompleted = "STUDENT_COURSE_COMPLETED",
  StudentMembershipCreated = "STUDENT_MEMBERSHIP_CREATED",
  StudentMembershipUpdated = "STUDENT_MEMBERSHIP_UPDATED",
  StudentRegistrationSucceeded = "STUDENT_REGISTRATION_SUCCEEDED",
  StudentSubscriptionCanceled = "STUDENT_SUBSCRIPTION_CANCELED",
  StudentSubscriptionSucceeded = "STUDENT_SUBSCRIPTION_SUCCEEDED",
  UserEmailUpdated = "USER_EMAIL_UPDATED"
}

/** An event from a webhook subscription. Currently these will only be faild webhook events. */
export type WebhookSubscription = {
  __typename?: "WebhookSubscription"
  /** When the credentials were archived. */
  archived_time?: Maybe<Scalars["DateTime"]["output"]>
  /** The time the credentials were created. */
  created_time: Scalars["DateTime"]["output"]
  /** The event types to being subscribed to. */
  event: WebhookEventType
  id: Scalars["Int"]["output"]
  /** The school this subscription belongs to. */
  school: School
  /** The receiver URL. */
  target_url: Scalars["URL"]["output"]
}

export enum Crop {
  Bottom = "bottom",
  Edges = "edges",
  Entropy = "entropy",
  Faces = "faces",
  Focalpoint = "focalpoint",
  Left = "left",
  Right = "right",
  Top = "top"
}

export enum Fit {
  Clamp = "clamp",
  Clip = "clip",
  Crop = "crop",
  Facearea = "facearea",
  Fill = "fill",
  Fillmax = "fillmax",
  Max = "max",
  Min = "min",
  Scale = "scale"
}

export enum Interval {
  Annually = "annually",
  Monthly = "monthly"
}

export enum Visibility {
  Pathwright_1 = "pathwright_1",
  Pathwright_2 = "pathwright_2",
  PrivateCustom = "private_custom"
}

export type AccountQueryVariables = Exact<{
  default_billing_plan_set?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type AccountQuery = {
  __typename?: "Query"
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    is_activated?: boolean | null
    is_activated_via_override?: boolean | null
    is_on_legacy_plan?: boolean | null
    billing_model?: number | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      interval?: SubscriptionInterval | null
      charge_type?: SubscriptionChargeType | null
      parent_subscription_id?: number | null
      subscription?: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
        visibility: Visibility
        amount: number
        description: string
        learner_counting_method: number
        fee_per_additional_learner: number
        learners_included: number
        staff_included: number
        color: string
        order: number
        should_contact_for_pricing: boolean
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          name: string
          description: string
          link: string
          key: string
          icon: string
          feature_type: number
          order: number
          platform_version: number
        }>
        billing_blocks?: {
          __typename?: "SchoolBillingBlockConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "SchoolBillingBlockEdge"
            node: {
              __typename?: "SchoolBillingBlock"
              id?: number | null
              block_type?: number | null
              block_size?: number | null
              price?: number | null
            }
          }>
        } | null
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
          name: string
          description: string
          amount: number
          order: number
        } | null
      } | null
      school?: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      } | null
    } | null
    curriculum_subscription?: {
      __typename?: "CurriculumSubscription"
      id: number
      licensor: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      }
      licensee: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      }
      curriculum_plan?: {
        __typename?: "SchoolCurriculumPlan"
        id: number
        name?: string | null
        amount?: number | null
        fee_boundary?: number | null
        fee_per_user?: number | null
        is_visible?: boolean | null
        lower_boundary?: number | null
        plan_id?: number | null
        transaction_fee_percent?: number | null
        upper_boundary?: number | null
        visibility_code?: string | null
      } | null
      subscription?: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
    } | null
    billing_plan_set?: {
      __typename?: "SchoolBillingPlanSet"
      id?: number | null
      name?: string | null
      is_default?: boolean | null
      plans?: Array<{
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
        visibility: Visibility
        amount: number
        description: string
        learner_counting_method: number
        fee_per_additional_learner: number
        learners_included: number
        staff_included: number
        color: string
        order: number
        should_contact_for_pricing: boolean
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          name: string
          description: string
          link: string
          key: string
          icon: string
          feature_type: number
          order: number
          platform_version: number
        }>
        billing_blocks?: {
          __typename?: "SchoolBillingBlockConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "SchoolBillingBlockEdge"
            node: {
              __typename?: "SchoolBillingBlock"
              id?: number | null
              block_type?: number | null
              block_size?: number | null
              price?: number | null
            }
          }>
        } | null
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
          name: string
          description: string
          amount: number
          order: number
        } | null
      } | null> | null
    } | null
    scholarship?: {
      __typename?: "SchoolBillingScholarship"
      id?: number | null
      ends?: any | null
      iterations?: number | null
      order?: number | null
      plan_id?: number | null
      starts?: any | null
      coupon?: {
        __typename?: "StripeCoupon"
        id?: number | null
        percent_off?: number | null
      } | null
    } | null
  } | null
}

export type CreatePageMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  title?: InputMaybe<Scalars["String"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  mode?: InputMaybe<Scalars["String"]["input"]>
}>

export type CreatePageMutation = {
  __typename?: "Mutations"
  createPage?: {
    __typename?: "Page"
    id: number
    name: string
    order: number
    page_type: number
    title?: string | null
    description?: string | null
    url: string
    external_url?: string | null
    iframe_url: string
    template_content?: string | null
    scripts?: string | null
    slug: string
    show_in_nav: boolean
    mode: string
    is_live: boolean
    content_type?: number | null
  } | null
}

export type PageFragment = {
  __typename?: "Page"
  id: number
  name: string
  order: number
  page_type: number
  title?: string | null
  description?: string | null
  url: string
  external_url?: string | null
  iframe_url: string
  template_content?: string | null
  scripts?: string | null
  slug: string
  show_in_nav: boolean
  mode: string
  is_live: boolean
  content_type?: number | null
}

export type PageQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type PageQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    page?: {
      __typename?: "Page"
      id: number
      name: string
      order: number
      page_type: number
      title?: string | null
      description?: string | null
      url: string
      external_url?: string | null
      iframe_url: string
      template_content?: string | null
      scripts?: string | null
      slug: string
      show_in_nav: boolean
      mode: string
      is_live: boolean
      content_type?: number | null
    } | null
  } | null
}

export type PagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  isLive?: InputMaybe<Scalars["Boolean"]["input"]>
  showInNav?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type PagesQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    pages?: {
      __typename?: "PageConnection"
      edges: Array<{
        __typename?: "PageEdge"
        node: {
          __typename?: "Page"
          id: number
          name: string
          order: number
          page_type: number
          title?: string | null
          description?: string | null
          url: string
          external_url?: string | null
          iframe_url: string
          template_content?: string | null
          scripts?: string | null
          slug: string
          show_in_nav: boolean
          mode: string
          is_live: boolean
          content_type?: number | null
        }
      }>
    } | null
  } | null
}

export type UpdatePageMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  external_url?: InputMaybe<Scalars["String"]["input"]>
  iframe_url?: InputMaybe<Scalars["String"]["input"]>
  template_content?: InputMaybe<Scalars["String"]["input"]>
  scripts?: InputMaybe<Scalars["String"]["input"]>
  mode?: InputMaybe<Scalars["String"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  content_type?: InputMaybe<Scalars["Int"]["input"]>
}>

export type UpdatePageMutation = {
  __typename?: "Mutations"
  updatePage?: {
    __typename?: "Page"
    id: number
    name: string
    order: number
    page_type: number
    title?: string | null
    description?: string | null
    url: string
    external_url?: string | null
    iframe_url: string
    template_content?: string | null
    scripts?: string | null
    slug: string
    show_in_nav: boolean
    mode: string
    is_live: boolean
    content_type?: number | null
  } | null
}

export type UpdatePageOrdersMutationVariables = Exact<{
  page_orders: Array<ListOrderInput> | ListOrderInput
}>

export type UpdatePageOrdersMutation = {
  __typename?: "Mutations"
  updatePageOrders?: boolean | null
}

export type CreateSchoolThemeMutationVariables = Exact<{
  theme: ThemeInput
}>

export type CreateSchoolThemeMutation = {
  __typename?: "Mutations"
  createSchoolTheme?: {
    __typename?: "Theme"
    id?: number | null
    name?: string | null
    theme_type?: ThemeType | null
    background_image?: string | null
    background_overlay?: string | null
    background_type?: number | null
    heading_font?: string | null
    primary_color?: string | null
    typekit_id?: string | null
    custom_css?: string | null
    processed_custom_css?: string | null
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
      _950?: string | null
    } | null
  } | null
}

export type UpdateSchoolThemeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  theme: ThemeInput
}>

export type UpdateSchoolThemeMutation = {
  __typename?: "Mutations"
  updateSchoolTheme?: {
    __typename?: "Theme"
    id?: number | null
    name?: string | null
    theme_type?: ThemeType | null
    background_image?: string | null
    background_overlay?: string | null
    background_type?: number | null
    heading_font?: string | null
    primary_color?: string | null
    typekit_id?: string | null
    custom_css?: string | null
    processed_custom_css?: string | null
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
      _950?: string | null
    } | null
  } | null
}

export type UpdateTranslationMutationMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  translation: Scalars["JSON"]["input"]
}>

export type UpdateTranslationMutationMutation = {
  __typename?: "Mutations"
  updateTranslation?: {
    __typename?: "Translation"
    id: number
    school_translation?: any | null
  } | null
}

export type ActivityQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  action_type?: InputMaybe<ActionTypeFilter>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  include_user: Scalars["Boolean"]["input"]
}>

export type ActivityQuery = {
  __typename?: "Query"
  activity_user?: { __typename?: "User"; id: number; first_name: string } | null
  activity?: {
    __typename?: "ActivityConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "ActivityEdge"
      node: {
        __typename?: "Activity"
        id?: number | null
        action_type?: number | null
        action_dtime?: any | null
        resource?: {
          __typename?: "Resource"
          name: string
          slug: string
          image: string
        } | null
        group?: {
          __typename?: "Group"
          id: number
          name: string
          seats?: number | null
        } | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        triggered_by?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        step?: {
          __typename?: "PathItem"
          id: number
          source_id: number
          name: string
          verb?: string | null
          completion: {
            __typename?: "Completion"
            id: number
            user?: { __typename?: "User"; id: number } | null
          }
        } | null
        discussion?: {
          __typename?: "Discussion"
          id: number
          title: string
          body?: string | null
          type: number
          is_discussion_question: boolean
          user?: {
            __typename?: "User"
            id: number
            display_name?: string | null
          } | null
        } | null
        discussion_response?: {
          __typename?: "Response"
          id: number
          parent_id?: number | null
          discussion_id: number
          body: string
          depth: number
          attachments?: any | null
          likes: number
          user_liked: boolean
          created_time: any
          archived_time?: any | null
          parent_response?: {
            __typename?: "Response"
            id: number
            parent_id?: number | null
            discussion_id: number
            body: string
            depth: number
            attachments?: any | null
            likes: number
            user_liked: boolean
            created_time: any
            archived_time?: any | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
      }
    }>
  } | null
}

export type ActivityStatsQueryVariables = Exact<{ [key: string]: never }>

export type ActivityStatsQuery = {
  __typename?: "Query"
  activityStats?: {
    __typename?: "ActivityStats"
    discussions?: number | null
    discussion_responses?: number | null
    registrations?: number | null
    steps_completed?: number | null
  } | null
}

export type ResourceThumbnailFragment = {
  __typename?: "Resource"
  name: string
  slug: string
  image: string
}

export type AssignMutationVariables = Exact<{
  offerings:
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  assign_to_user: Scalars["Int"]["input"]
  role: RegistrationRoleEnum
  send_notification?: InputMaybe<Scalars["Boolean"]["input"]>
  assignment_message?: InputMaybe<Scalars["String"]["input"]>
}>

export type AssignMutation = { __typename?: "Mutations"; assign?: any | null }

export type AssignResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  assignConfig?: InputMaybe<AssignConfig>
  search?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type AssignResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    cohorts?: {
      __typename?: "GroupConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "GroupEdge"
        node: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
        }
      }>
    } | null
  } | null
}

export type AssignRolesQueryQueryVariables = Exact<{ [key: string]: never }>

export type AssignRolesQueryQuery = {
  __typename?: "Query"
  assignRoles: Array<RegistrationRoleEnum | null>
}

export type AuthMethodFragment = {
  __typename?: "AuthMethod"
  id: string
  enabled: boolean
  meta: {
    __typename?: "NodeMeta"
    id: string
    key: string
    type: string
    url?: string | null
    title?: string | null
    icon?: string | null
  }
}

export type GetTokenViaSsoMutationVariables = Exact<{
  ssoToken: Scalars["String"]["input"]
}>

export type GetTokenViaSsoMutation = {
  __typename?: "Mutations"
  getTokenViaSSO?: { __typename?: "Token"; token?: string | null } | null
}

export type HeartbeatFragment = {
  __typename?: "Heartbeat"
  success?: boolean | null
  active_subscription_ids: Array<number>
  membership?: {
    __typename?: "HeartbeatMembership"
    archived_time?: string | null
    access_revoked_time?: string | null
  } | null
  deploy?: {
    __typename?: "HeartbeatDeploy"
    id: string
    created: string
    build_id: string
    commit_hash?: string | null
    built_at?: string | null
    label?: string | null
    notify?: Array<string> | null
  } | null
}

export type HeartbeatMutationVariables = Exact<{ [key: string]: never }>

export type HeartbeatMutation = {
  __typename?: "Mutations"
  heartbeat: {
    __typename?: "Heartbeat"
    success?: boolean | null
    active_subscription_ids: Array<number>
    membership?: {
      __typename?: "HeartbeatMembership"
      archived_time?: string | null
      access_revoked_time?: string | null
    } | null
    deploy?: {
      __typename?: "HeartbeatDeploy"
      id: string
      created: string
      build_id: string
      commit_hash?: string | null
      built_at?: string | null
      label?: string | null
      notify?: Array<string> | null
    } | null
  }
}

export type ProxyAuthTokenMutationVariables = Exact<{
  user_id: Scalars["Int"]["input"]
  school_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ProxyAuthTokenMutation = {
  __typename?: "Mutations"
  proxyAuthToken?: string | null
}

export type RefreshTokenMutationVariables = Exact<{
  school_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type RefreshTokenMutation = {
  __typename?: "Mutations"
  refreshToken?: string | null
}

export type AuthorFragment = {
  __typename?: "Author"
  id: number
  order: number
  display_name: string
  full_name: string
  first_name: string
  last_name: string
  title?: string | null
  image?: string | null
  bio?: string | null
  avatar?: string | null
  salutation?: string | null
  slug: string
}

export type AuthorQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}>

export type AuthorQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    author?: {
      __typename?: "Author"
      id: number
      order: number
      display_name: string
      full_name: string
      first_name: string
      last_name: string
      title?: string | null
      image?: string | null
      bio?: string | null
      avatar?: string | null
      salutation?: string | null
      slug: string
    } | null
  } | null
}

export type AuthorsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  positioningContext?: InputMaybe<PositioningContextInput>
  orderBy?: InputMaybe<
    Array<InputMaybe<AuthorOrderByInput>> | InputMaybe<AuthorOrderByInput>
  >
}>

export type AuthorsQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      authors?: {
        __typename?: "AuthorConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "AuthorEdge"
          node: {
            __typename?: "Author"
            position: string
            id: number
            order: number
            display_name: string
            full_name: string
            first_name: string
            last_name: string
            title?: string | null
            image?: string | null
            bio?: string | null
            avatar?: string | null
            salutation?: string | null
            slug: string
          }
        }>
      } | null
    }
  } | null
}

export type CreateCoverPageAuthorMutationVariables = Exact<{
  avatar?: InputMaybe<Scalars["String"]["input"]>
  bio: Scalars["String"]["input"]
  contributorPositioningContext?: InputMaybe<PositioningContextInput>
  first_name: Scalars["String"]["input"]
  last_name: Scalars["String"]["input"]
  order: Scalars["Int"]["input"]
  salutation: Scalars["String"]["input"]
  title: Scalars["String"]["input"]
}>

export type CreateCoverPageAuthorMutation = {
  __typename?: "Mutations"
  createAuthor?: {
    __typename?: "Author"
    position: string
    id: number
    order: number
    display_name: string
    full_name: string
    first_name: string
    last_name: string
    title?: string | null
    image?: string | null
    bio?: string | null
    avatar?: string | null
    salutation?: string | null
    slug: string
  } | null
}

export type PositionedAuthorFragment = {
  __typename?: "Author"
  position: string
  id: number
  order: number
  display_name: string
  full_name: string
  first_name: string
  last_name: string
  title?: string | null
  image?: string | null
  bio?: string | null
  avatar?: string | null
  salutation?: string | null
  slug: string
}

export type UpdateCoverPageAuthorMutationVariables = Exact<{
  avatar?: InputMaybe<Scalars["String"]["input"]>
  bio?: InputMaybe<Scalars["String"]["input"]>
  contributorPositioningContext?: InputMaybe<PositioningContextInput>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  last_name?: InputMaybe<Scalars["String"]["input"]>
  salutation?: InputMaybe<Scalars["String"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateCoverPageAuthorMutation = {
  __typename?: "Mutations"
  updateAuthor?: {
    __typename?: "Author"
    position: string
    id: number
    order: number
    display_name: string
    full_name: string
    first_name: string
    last_name: string
    title?: string | null
    image?: string | null
    bio?: string | null
    avatar?: string | null
    salutation?: string | null
    slug: string
  } | null
}

export type BannerFragment = {
  __typename?: "Banner"
  id?: number | null
  order?: number | null
  heading?: string | null
  subhead?: string | null
  font_color?: string | null
  background_image_raw?: string | null
  background_image?: string | null
  background_type?: number | null
  background_overlay?: string | null
  button_func?: string | null
  button_url?: string | null
  button_text?: string | null
  is_visible?: boolean | null
  hide_for_subscription_plans?: Array<number | null> | null
  show_for_subscription_plans?: Array<number | null> | null
  hide_for_products?: Array<number | null> | null
  show_for_products?: Array<number | null> | null
}

export type BannerQueryVariables = Exact<{
  school_id: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
}>

export type BannerQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      banner?: {
        __typename?: "Banner"
        id?: number | null
        order?: number | null
        heading?: string | null
        subhead?: string | null
        font_color?: string | null
        background_image_raw?: string | null
        background_image?: string | null
        background_type?: number | null
        background_overlay?: string | null
        button_func?: string | null
        button_url?: string | null
        button_text?: string | null
        is_visible?: boolean | null
        hide_for_subscription_plans?: Array<number | null> | null
        show_for_subscription_plans?: Array<number | null> | null
        hide_for_products?: Array<number | null> | null
        show_for_products?: Array<number | null> | null
      } | null
    }
  } | null
}

export type BannersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  first: Scalars["Int"]["input"]
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type BannersQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      banners?: {
        __typename?: "BannerConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "BannerEdge"
          node: {
            __typename?: "Banner"
            id?: number | null
            order?: number | null
            heading?: string | null
            subhead?: string | null
            font_color?: string | null
            background_image_raw?: string | null
            background_image?: string | null
            background_type?: number | null
            background_overlay?: string | null
            button_func?: string | null
            button_url?: string | null
            button_text?: string | null
            is_visible?: boolean | null
            hide_for_subscription_plans?: Array<number | null> | null
            show_for_subscription_plans?: Array<number | null> | null
            hide_for_products?: Array<number | null> | null
            show_for_products?: Array<number | null> | null
          }
        }>
      } | null
    }
  } | null
}

export type CreateBannerMutationVariables = Exact<{
  heading?: InputMaybe<Scalars["String"]["input"]>
  subhead?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  hide_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  hide_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
}>

export type CreateBannerMutation = {
  __typename?: "Mutations"
  createBanner?: {
    __typename?: "Banner"
    id?: number | null
    order?: number | null
    heading?: string | null
    subhead?: string | null
    font_color?: string | null
    background_image_raw?: string | null
    background_image?: string | null
    background_type?: number | null
    background_overlay?: string | null
    button_func?: string | null
    button_url?: string | null
    button_text?: string | null
    is_visible?: boolean | null
    hide_for_subscription_plans?: Array<number | null> | null
    show_for_subscription_plans?: Array<number | null> | null
    hide_for_products?: Array<number | null> | null
    show_for_products?: Array<number | null> | null
  } | null
}

export type DeleteBannerMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteBannerMutation = {
  __typename?: "Mutations"
  deleteBanner?: boolean | null
}

export type UpdateBannerMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  heading?: InputMaybe<Scalars["String"]["input"]>
  subhead?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  hide_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  hide_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
}>

export type UpdateBannerMutation = {
  __typename?: "Mutations"
  updateBanner?: {
    __typename?: "Banner"
    id?: number | null
    order?: number | null
    heading?: string | null
    subhead?: string | null
    font_color?: string | null
    background_image_raw?: string | null
    background_image?: string | null
    background_type?: number | null
    background_overlay?: string | null
    button_func?: string | null
    button_url?: string | null
    button_text?: string | null
    is_visible?: boolean | null
    hide_for_subscription_plans?: Array<number | null> | null
    show_for_subscription_plans?: Array<number | null> | null
    hide_for_products?: Array<number | null> | null
    show_for_products?: Array<number | null> | null
  } | null
}

export type UpdateBannerOrderMutationVariables = Exact<{
  banner_orders: Array<InputMaybe<ListOrderInput>> | InputMaybe<ListOrderInput>
}>

export type UpdateBannerOrderMutation = {
  __typename?: "Mutations"
  updateBannerOrder?: boolean | null
}

export type BackgroundTaskQueryVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type BackgroundTaskQuery = {
  __typename?: "Query"
  backgroundTask?: {
    __typename?: "BackgroundTask"
    id: any
    status: BackgroundTaskStatus
    result?: any | null
  } | null
}

export type BackgroundTaskFragment = {
  __typename?: "BackgroundTask"
  id: any
  status: BackgroundTaskStatus
  result?: any | null
}

export type BackgroundTasksQueryVariables = Exact<{
  ids:
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
}>

export type BackgroundTasksQuery = {
  __typename?: "Query"
  backgroundTasks?: Array<{
    __typename?: "BackgroundTask"
    id: any
    status: BackgroundTaskStatus
    result?: any | null
  } | null> | null
}

export type ChildSubscriptionsQueryVariables = Exact<{ [key: string]: never }>

export type ChildSubscriptionsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      interval?: SubscriptionInterval | null
      charge_type?: SubscriptionChargeType | null
      parent_subscription_id?: number | null
      child_subscriptions?: {
        __typename?: "SchoolBillingSubscriptionConnection"
        edges: Array<{
          __typename?: "SchoolBillingSubscriptionEdge"
          node: {
            __typename?: "SchoolBillingSubscription"
            id?: number | null
            interval?: SubscriptionInterval | null
            charge_type?: SubscriptionChargeType | null
            parent_subscription_id?: number | null
            subscription?: {
              __typename?: "Subscription"
              id: number
              quantity?: number | null
              canceled_dtime?: any | null
              cancellation_reason?: number | null
              card_last_4?: string | null
              cycle_end_dtime?: any | null
              cycle_start_dtime?: any | null
              is_canceled_at_cycle_end?: boolean | null
              is_delinquent?: boolean | null
              paused_until_dtime?: any | null
              trial_type?: number | null
              trial_end_dtime?: any | null
              payment_intent_needing_action_id?: string | null
              subscription_plan?: {
                __typename?: "SubscriptionPlan"
                id: number
                name: string
                amount?: number | null
                interval: number
                trial_period_days: number
                trial_type: SubscriptionTrialType
                plan_type?: string | null
                stripe_connected_account_url?: string | null
              } | null
              customer?: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              } | null
            } | null
            plan?: {
              __typename?: "SchoolBillingPlan"
              id: number
              name: string
              visibility: Visibility
              amount: number
              description: string
              learner_counting_method: number
              fee_per_additional_learner: number
              learners_included: number
              staff_included: number
              color: string
              order: number
              should_contact_for_pricing: boolean
              features: Array<{
                __typename?: "SchoolBillingPlanFeature"
                id: number
                name: string
                description: string
                link: string
                key: string
                icon: string
                feature_type: number
                order: number
                platform_version: number
              }>
              billing_blocks?: {
                __typename?: "SchoolBillingBlockConnection"
                total: number
                pageInfo: {
                  __typename?: "PageInfo"
                  endCursor?: string | null
                  hasNextPage: boolean
                }
                edges: Array<{
                  __typename?: "SchoolBillingBlockEdge"
                  node: {
                    __typename?: "SchoolBillingBlock"
                    id?: number | null
                    block_type?: number | null
                    block_size?: number | null
                    price?: number | null
                  }
                }>
              } | null
              plan_derived_from?: {
                __typename?: "SchoolBillingPlan"
                id: number
                name: string
                description: string
                amount: number
                order: number
              } | null
            } | null
            school?: {
              __typename?: "School"
              id: number
              url: string
              name: string
              about?: string | null
              email?: string | null
              website?: string | null
              subdomain: string
              created?: any | null
              billing_model?: number | null
              platform_version?: number | null
              currency_code?: string | null
              ietf_language_tag?: string | null
              has_certificate?: boolean | null
              is_activated?: boolean | null
              is_curriculum_enabled?: boolean | null
              is_curriculum_subscriber?: boolean | null
              stripe_access_token?: string | null
              stripe_publishable_api_key?: string | null
              show_stripe_reconnect?: boolean | null
              payment_requires_zip_code?: boolean | null
              consent_description?: string | null
              image?: string | null
              image_is_default: boolean
              grant_access_upon_authentication?: boolean | null
              pathwright_login_enabled?: boolean | null
              resource_licensing_enabled?: boolean | null
            } | null
          }
        }>
      } | null
      subscription?: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
        visibility: Visibility
        amount: number
        description: string
        learner_counting_method: number
        fee_per_additional_learner: number
        learners_included: number
        staff_included: number
        color: string
        order: number
        should_contact_for_pricing: boolean
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          name: string
          description: string
          link: string
          key: string
          icon: string
          feature_type: number
          order: number
          platform_version: number
        }>
        billing_blocks?: {
          __typename?: "SchoolBillingBlockConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "SchoolBillingBlockEdge"
            node: {
              __typename?: "SchoolBillingBlock"
              id?: number | null
              block_type?: number | null
              block_size?: number | null
              price?: number | null
            }
          }>
        } | null
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
          name: string
          description: string
          amount: number
          order: number
        } | null
      } | null
      school?: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      } | null
    } | null
  } | null
}

export type SchoolBillingBlockFragment = {
  __typename?: "SchoolBillingBlock"
  id?: number | null
  block_type?: number | null
  block_size?: number | null
  price?: number | null
}

export type SchoolBillingInvoiceFragment = {
  __typename?: "SchoolBillingInvoice"
  cycle_end?: any | null
  cycle_start?: any | null
  id?: number | null
  invoice_json?: any | null
  invoiced_date?: any | null
  stripe_invoice_id?: string | null
  stripe_invoice_status?: string | null
  stripe_next_payment_attempt?: any | null
  total_amount_billed?: number | null
  url?: string | null
}

export type SchoolBillingInvoiceQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SchoolBillingInvoiceQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    school_billing_invoice?: {
      __typename?: "SchoolBillingInvoice"
      payment?: any | null
      cycle_end?: any | null
      cycle_start?: any | null
      id?: number | null
      invoice_json?: any | null
      invoiced_date?: any | null
      stripe_invoice_id?: string | null
      stripe_invoice_status?: string | null
      stripe_next_payment_attempt?: any | null
      total_amount_billed?: number | null
      url?: string | null
    } | null
  } | null
}

export type SchoolBillingInvoicesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type SchoolBillingInvoicesQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    school_billing_invoices?: {
      __typename?: "SchoolBillingInvoiceConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "SchoolBillingInvoiceEdge"
        node: {
          __typename?: "SchoolBillingInvoice"
          cycle_end?: any | null
          cycle_start?: any | null
          id?: number | null
          invoice_json?: any | null
          invoiced_date?: any | null
          stripe_invoice_id?: string | null
          stripe_invoice_status?: string | null
          stripe_next_payment_attempt?: any | null
          total_amount_billed?: number | null
          url?: string | null
        }
      }>
    } | null
  } | null
}

export type SchoolBillingPlanFeatureFragment = {
  __typename?: "SchoolBillingPlanFeature"
  id: number
  name: string
  description: string
  link: string
  key: string
  icon: string
  feature_type: number
  order: number
  platform_version: number
}

export type SchoolBillingPlanFragment = {
  __typename?: "SchoolBillingPlan"
  id: number
  name: string
  visibility: Visibility
  amount: number
  description: string
  learner_counting_method: number
  fee_per_additional_learner: number
  learners_included: number
  staff_included: number
  color: string
  order: number
  should_contact_for_pricing: boolean
  features: Array<{
    __typename?: "SchoolBillingPlanFeature"
    id: number
    name: string
    description: string
    link: string
    key: string
    icon: string
    feature_type: number
    order: number
    platform_version: number
  }>
  billing_blocks?: {
    __typename?: "SchoolBillingBlockConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "SchoolBillingBlockEdge"
      node: {
        __typename?: "SchoolBillingBlock"
        id?: number | null
        block_type?: number | null
        block_size?: number | null
        price?: number | null
      }
    }>
  } | null
  plan_derived_from?: {
    __typename?: "SchoolBillingPlan"
    id: number
    name: string
    description: string
    amount: number
    order: number
  } | null
}

export type SchoolBillingPlanSetFragment = {
  __typename?: "SchoolBillingPlanSet"
  id?: number | null
  name?: string | null
  is_default?: boolean | null
  plans?: Array<{
    __typename?: "SchoolBillingPlan"
    id: number
    name: string
    visibility: Visibility
    amount: number
    description: string
    learner_counting_method: number
    fee_per_additional_learner: number
    learners_included: number
    staff_included: number
    color: string
    order: number
    should_contact_for_pricing: boolean
    features: Array<{
      __typename?: "SchoolBillingPlanFeature"
      id: number
      name: string
      description: string
      link: string
      key: string
      icon: string
      feature_type: number
      order: number
      platform_version: number
    }>
    billing_blocks?: {
      __typename?: "SchoolBillingBlockConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "SchoolBillingBlockEdge"
        node: {
          __typename?: "SchoolBillingBlock"
          id?: number | null
          block_type?: number | null
          block_size?: number | null
          price?: number | null
        }
      }>
    } | null
    plan_derived_from?: {
      __typename?: "SchoolBillingPlan"
      id: number
      name: string
      description: string
      amount: number
      order: number
    } | null
  } | null> | null
}

export type SchoolBillingSubscriptionFragment = {
  __typename?: "SchoolBillingSubscription"
  id?: number | null
  interval?: SubscriptionInterval | null
  charge_type?: SubscriptionChargeType | null
  parent_subscription_id?: number | null
  subscription?: {
    __typename?: "Subscription"
    id: number
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
  plan?: {
    __typename?: "SchoolBillingPlan"
    id: number
    name: string
    visibility: Visibility
    amount: number
    description: string
    learner_counting_method: number
    fee_per_additional_learner: number
    learners_included: number
    staff_included: number
    color: string
    order: number
    should_contact_for_pricing: boolean
    features: Array<{
      __typename?: "SchoolBillingPlanFeature"
      id: number
      name: string
      description: string
      link: string
      key: string
      icon: string
      feature_type: number
      order: number
      platform_version: number
    }>
    billing_blocks?: {
      __typename?: "SchoolBillingBlockConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "SchoolBillingBlockEdge"
        node: {
          __typename?: "SchoolBillingBlock"
          id?: number | null
          block_type?: number | null
          block_size?: number | null
          price?: number | null
        }
      }>
    } | null
    plan_derived_from?: {
      __typename?: "SchoolBillingPlan"
      id: number
      name: string
      description: string
      amount: number
      order: number
    } | null
  } | null
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
  } | null
}

export type SchoolBillingSubscriptionQueryVariables = Exact<{
  [key: string]: never
}>

export type SchoolBillingSubscriptionQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      interval?: SubscriptionInterval | null
      charge_type?: SubscriptionChargeType | null
      parent_subscription_id?: number | null
      subscription?: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
        visibility: Visibility
        amount: number
        description: string
        learner_counting_method: number
        fee_per_additional_learner: number
        learners_included: number
        staff_included: number
        color: string
        order: number
        should_contact_for_pricing: boolean
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          name: string
          description: string
          link: string
          key: string
          icon: string
          feature_type: number
          order: number
          platform_version: number
        }>
        billing_blocks?: {
          __typename?: "SchoolBillingBlockConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "SchoolBillingBlockEdge"
            node: {
              __typename?: "SchoolBillingBlock"
              id?: number | null
              block_type?: number | null
              block_size?: number | null
              price?: number | null
            }
          }>
        } | null
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
          name: string
          description: string
          amount: number
          order: number
        } | null
      } | null
      school?: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      } | null
    } | null
  } | null
}

export type UpcomingSchoolBillingInvoiceQueryVariables = Exact<{
  [key: string]: never
}>

export type UpcomingSchoolBillingInvoiceQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    upcoming_school_billing_invoice?: {
      __typename?: "SchoolBillingInvoice"
      parent_subscription?: any | null
      child_subscriptions?: any | null
      cycle_end?: any | null
      cycle_start?: any | null
      id?: number | null
      invoice_json?: any | null
      invoiced_date?: any | null
      stripe_invoice_id?: string | null
      stripe_invoice_status?: string | null
      stripe_next_payment_attempt?: any | null
      total_amount_billed?: number | null
      url?: string | null
    } | null
  } | null
}

export type BlocksContainerContextQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
  isLearner: Scalars["Boolean"]["input"]
}>

export type BlocksContainerContextQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    status: GroupStatus
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      softArchivedTime?: any | null
    } | null
  } | null
}

export type BlocksResponseExportCohortsQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  after?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<RoleFilter>
}>

export type BlocksResponseExportCohortsQuery = {
  __typename?: "Query"
  cohorts?: {
    __typename?: "GroupConnection"
    edges: Array<{
      __typename?: "GroupEdge"
      node: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        access_ends?: any | null
        access_starts?: any | null
        seats_filled?: number | null
        status: GroupStatus
        path: { __typename?: "Path"; id: number }
      }
    }>
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
  } | null
}

export type BlocksResponseExportLearnersQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
  searchTerm?: InputMaybe<Scalars["String"]["input"]>
  after?: InputMaybe<Scalars["String"]["input"]>
}>

export type BlocksResponseExportLearnersQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    registrations?: {
      __typename?: "RegistrationConnection"
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            email?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        }
      }>
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
    } | null
  } | null
}

export type BlocksResponseExportPeopleSearchQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  searchTerm: Scalars["String"]["input"]
  after?: InputMaybe<Scalars["String"]["input"]>
}>

export type BlocksResponseExportPeopleSearchQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    registrations?: {
      __typename?: "RegistrationConnection"
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            email?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            access_ends?: any | null
            access_starts?: any | null
            seats_filled?: number | null
            status: GroupStatus
            is_source_cohort?: boolean | null
            path: { __typename?: "Path"; id: number }
          }
        }
      }>
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
    } | null
  } | null
}

export type CreateBlocksContentMutationVariables = Exact<{
  stepId?: InputMaybe<Scalars["Int"]["input"]>
  contentLastModified?: InputMaybe<Scalars["DateTime"]["input"]>
}>

export type CreateBlocksContentMutation = {
  __typename?: "Mutations"
  createBlocksContent?: {
    __typename?: "BlocksContent"
    id?: number | null
    method?: string | null
    type?: string | null
    data?: any | null
    content_last_modified?: any | null
    last_published?: any | null
  } | null
}

export type UpdateBlocksContentMutationVariables = Exact<{
  stepId?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  contentLastModified?: InputMaybe<Scalars["DateTime"]["input"]>
  lastPublished?: InputMaybe<Scalars["DateTime"]["input"]>
}>

export type UpdateBlocksContentMutation = {
  __typename?: "Mutations"
  updateBlocksContent?: {
    __typename?: "BlocksContent"
    id?: number | null
    method?: string | null
    type?: string | null
    data?: any | null
    content_last_modified?: any | null
    last_published?: any | null
  } | null
}

export type CalQueryVariables = Exact<{ [key: string]: never }>

export type CalQuery = {
  __typename?: "Query"
  calendar?: {
    __typename?: "Calendar"
    id?: string | null
    name?: string | null
    url?: string | null
    events?: Array<{
      __typename?: "CalendarEvent"
      id?: string | null
      type?: string | null
      description?: string | null
      completion_status?: string | null
      url?: string | null
      relative_url?: string | null
      summary?: string | null
      start?: any | null
      end?: any | null
    } | null> | null
  } | null
}

export type CalStatsQueryVariables = Exact<{
  path_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type CalStatsQuery = {
  __typename?: "Query"
  calendarStats?: {
    __typename?: "CalendarStats"
    total?: number | null
    upcoming?: number | null
    due?: number | null
    late?: number | null
  } | null
}

export type CategoriesQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  positioningContext?: InputMaybe<PositioningContextInput>
  orderBy?: InputMaybe<
    Array<InputMaybe<CategoryOrderByInput>> | InputMaybe<CategoryOrderByInput>
  >
}>

export type CategoriesQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      categories?: {
        __typename?: "CategoryConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "CategoryEdge"
          node: {
            __typename?: "Category"
            position: string
            id: number
            name: string
            slug: string
            order: number
            description?: string | null
          }
        }>
      } | null
    }
  } | null
}

export type CategoryFragment = {
  __typename?: "Category"
  id: number
  name: string
  slug: string
  order: number
  description?: string | null
}

export type CategoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}>

export type CategoryQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    category?: {
      __typename?: "Category"
      id: number
      name: string
      slug: string
      order: number
      description?: string | null
    } | null
  } | null
}

export type CreateCoverPageCategoryMutationVariables = Exact<{
  categoryPositioningContext?: InputMaybe<PositioningContextInput>
  description: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  order: Scalars["Int"]["input"]
}>

export type CreateCoverPageCategoryMutation = {
  __typename?: "Mutations"
  createCategory?: {
    __typename?: "Category"
    id: number
    name: string
    slug: string
    order: number
    position: string
    description?: string | null
  } | null
}

export type PositionedCategoryFragment = {
  __typename?: "Category"
  position: string
  id: number
  name: string
  slug: string
  order: number
  description?: string | null
}

export type UpdateCoverPageCategoryMutationVariables = Exact<{
  categoryPositioningContext?: InputMaybe<PositioningContextInput>
  description?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateCoverPageCategoryMutation = {
  __typename?: "Mutations"
  updateCategory?: {
    __typename?: "Category"
    id: number
    name: string
    slug: string
    order: number
    position: string
    description?: string | null
  } | null
}

export type CertificateFragment = {
  __typename?: "Certificate"
  id?: number | null
  name?: string | null
  template?: string | null
  text_objects?: any | null
}

export type CertificatePreviewQueryVariables = Exact<{
  template: Scalars["String"]["input"]
  textObjects: Array<InputMaybe<TextObject>> | InputMaybe<TextObject>
  variables?: InputMaybe<Scalars["JSON"]["input"]>
}>

export type CertificatePreviewQuery = {
  __typename?: "Query"
  certificatePreview?: string | null
}

export type CertificateQueryVariables = Exact<{ [key: string]: never }>

export type CertificateQuery = {
  __typename?: "Query"
  certificate?: {
    __typename?: "Certificate"
    id?: number | null
    name?: string | null
    template?: string | null
    text_objects?: any | null
  } | null
}

export type CertificateResourcesQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  hasCertificate?: InputMaybe<Scalars["Boolean"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type CertificateResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        trailer_embed_code?: string | null
        visibility_level_override?: number | null
        certificate_generator_class?: string | null
        certificate_json?: any | null
        licensed_from_resource_id?: number | null
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
        registration_meta?: {
          __typename?: "RegistrationMeta"
          editor_registration_count?: number | null
        } | null
        authors?: {
          __typename?: "AuthorConnection"
          total: number
          edges: Array<{
            __typename?: "AuthorEdge"
            node: {
              __typename?: "Author"
              id: number
              order: number
              display_name: string
              full_name: string
              first_name: string
              last_name: string
              title?: string | null
              image?: string | null
              bio?: string | null
              avatar?: string | null
              salutation?: string | null
              slug: string
            }
          }>
        } | null
        categories?: {
          __typename?: "CategoryConnection"
          total: number
          edges: Array<{
            __typename?: "CategoryEdge"
            node: {
              __typename?: "Category"
              id: number
              name: string
              slug: string
              order: number
              description?: string | null
            }
          }>
        } | null
        groups?: {
          __typename?: "GroupConnection"
          total: number
          edges: Array<{
            __typename?: "GroupEdge"
            node: {
              __typename?: "Group"
              id: number
              seats_filled?: number | null
            }
          }>
        } | null
      }
    }>
  } | null
}

export type CertificateVariablesQueryVariables = Exact<{
  context?: InputMaybe<CertificateVariablesContextInput>
}>

export type CertificateVariablesQuery = {
  __typename?: "Query"
  certificateVariables?: {
    __typename?: "CertificateVariables"
    id?: number | null
    stats?: any | null
    variables?: any | null
  } | null
}

export type CreateCertificateMutationVariables = Exact<{
  name?: InputMaybe<Scalars["String"]["input"]>
  template: Scalars["String"]["input"]
  textObjects?: InputMaybe<
    Array<InputMaybe<TextObject>> | InputMaybe<TextObject>
  >
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CreateCertificateMutation = {
  __typename?: "Mutations"
  createCertificate?: {
    __typename?: "Certificate"
    id?: number | null
    name?: string | null
    template?: string | null
    text_objects?: any | null
  } | null
}

export type DeleteCertificateMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteCertificateMutation = {
  __typename?: "Mutations"
  deleteCertificate?: boolean | null
}

export type ResourceCertificateContextQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type ResourceCertificateContextQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          description?: string | null
        }
      }>
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: { __typename?: "Group"; id: number; seats_filled?: number | null }
      }>
    } | null
  } | null
}

export type UpdateCertificateMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  template?: InputMaybe<Scalars["String"]["input"]>
  textObjects?: InputMaybe<
    Array<InputMaybe<TextObject>> | InputMaybe<TextObject>
  >
}>

export type UpdateCertificateMutation = {
  __typename?: "Mutations"
  updateCertificate?: {
    __typename?: "Certificate"
    id?: number | null
    name?: string | null
    template?: string | null
    text_objects?: any | null
  } | null
}

export type UpdateCertificateVariablesMutationVariables = Exact<{
  merge:
    | Array<InputMaybe<CertificateVariablesMergeInput>>
    | InputMaybe<CertificateVariablesMergeInput>
  context?: InputMaybe<CertificateVariablesContextInput>
}>

export type UpdateCertificateVariablesMutation = {
  __typename?: "Mutations"
  updateCertificateVariables?: {
    __typename?: "CertificateVariables"
    id?: number | null
    stats?: any | null
    variables?: any | null
  } | null
}

export type CohortFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  created_by_id?: number | null
  status: GroupStatus
  is_collection_linked?: boolean | null
  is_master?: boolean | null
  access_starts?: any | null
  parent_section_id?: number | null
  access_ends?: any | null
  registration?: {
    __typename?: "Registration"
    id: number
    role: number
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
  } | null
  path: { __typename?: "Path"; id: number }
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    image: string
    slug: string
    background_image?: string | null
    background_overlay?: string | null
    resource_type: number
  } | null
  resource_license?: {
    __typename?: "ResourceLicense"
    id?: number | null
    expiration_dtime?: any | null
  } | null
}

export type CohortMembersQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  orderBy?: InputMaybe<
    | Array<InputMaybe<RegistrationOrderByInput>>
    | InputMaybe<RegistrationOrderByInput>
  >
}>

export type CohortMembersQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            email?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type CohortMembersStatsQueryQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type CohortMembersStatsQueryQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    member_stats?: {
      __typename?: "GroupMemberStats"
      total?: number | null
      send_discussion_notifications?: number | null
    } | null
  } | null
}

export type CohortPermissionsCohortFragment = {
  __typename?: "Group"
  id: number
  is_source_cohort?: boolean | null
  status: GroupStatus
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    softArchivedTime?: any | null
  } | null
}

export type CohortPermissionsFragment = {
  __typename?: "Group"
  id: number
  is_source_cohort?: boolean | null
  status: GroupStatus
  source?: {
    __typename?: "Group"
    id: number
    is_source_cohort?: boolean | null
    status: GroupStatus
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      softArchivedTime?: any | null
    } | null
  } | null
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    softArchivedTime?: any | null
  } | null
}

export type CohortPermissionsQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type CohortPermissionsQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    is_source_cohort?: boolean | null
    status: GroupStatus
    source?: {
      __typename?: "Group"
      id: number
      is_source_cohort?: boolean | null
      status: GroupStatus
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        softArchivedTime?: any | null
      } | null
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      softArchivedTime?: any | null
    } | null
  } | null
}

export type CohortQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type CohortQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    created_by_id?: number | null
    status: GroupStatus
    is_collection_linked?: boolean | null
    is_master?: boolean | null
    access_starts?: any | null
    parent_section_id?: number | null
    access_ends?: any | null
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
    } | null
    path: { __typename?: "Path"; id: number }
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      image: string
      slug: string
      background_image?: string | null
      background_overlay?: string | null
      resource_type: number
    } | null
    resource_license?: {
      __typename?: "ResourceLicense"
      id?: number | null
      expiration_dtime?: any | null
    } | null
  } | null
}

export type CohortSwitcherCohortsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
  resourceId: Scalars["Int"]["input"]
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type CohortSwitcherCohortsQuery = {
  __typename?: "Query"
  cohorts?: {
    __typename?: "GroupConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "GroupEdge"
      node: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        created_by_id?: number | null
        status: GroupStatus
        is_collection_linked?: boolean | null
        is_master?: boolean | null
        access_starts?: any | null
        parent_section_id?: number | null
        access_ends?: any | null
        registration?: {
          __typename?: "Registration"
          id: number
          role: number
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
        } | null
        path: { __typename?: "Path"; id: number }
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          image: string
          slug: string
          background_image?: string | null
          background_overlay?: string | null
          resource_type: number
        } | null
        resource_license?: {
          __typename?: "ResourceLicense"
          id?: number | null
          expiration_dtime?: any | null
        } | null
      }
    }>
  } | null
}

export type CohortsIncludedProductsQueryQueryVariables = Exact<{
  resourceId?: InputMaybe<Scalars["Int"]["input"]>
  visibilityFilter?: InputMaybe<GroupVisibilityFilter>
}>

export type CohortsIncludedProductsQueryQuery = {
  __typename?: "Query"
  groups?: {
    __typename?: "GroupConnection"
    edges: Array<{
      __typename?: "GroupEdge"
      node: {
        __typename?: "Group"
        id: number
        include_with_products?: {
          __typename?: "StripeProductConnection"
          edges: Array<{
            __typename?: "StripeProductEdge"
            node: {
              __typename?: "StripeProduct"
              id: number
              active?: boolean | null
              name?: string | null
              description?: string | null
              images?: Array<string | null> | null
              unit_label?: string | null
              stripe_product_id?: string | null
              stripe_connected_account_url?: string | null
              min_quantity?: number | null
              max_quantity?: number | null
              stripe_prices?: {
                __typename?: "StripePriceConnection"
                edges: Array<{
                  __typename?: "StripePriceEdge"
                  node: {
                    __typename?: "StripePrice"
                    id: number
                    active?: boolean | null
                    billing_scheme?: StripeBillingScheme | null
                    currency?: string | null
                    nickname?: string | null
                    recurring_interval?: StripeRecurringInterval | null
                    recurring_interval_count?: number | null
                    stripe_price_id?: string | null
                    stripe_connected_account_url?: string | null
                    tiers_mode?: StripeTiersMode | null
                    unit_amount_decimal?: number | null
                    tiers?: Array<{
                      __typename?: "StripeTier"
                      up_to?: number | null
                      flat_amount?: number | null
                      flat_amount_decimal?: string | null
                      unit_amount?: number | null
                      unit_amount_decimal?: string | null
                    } | null> | null
                    product?: {
                      __typename?: "StripeProduct"
                      id: number
                      min_quantity?: number | null
                      max_quantity?: number | null
                    } | null
                  }
                }>
              } | null
            }
          }>
        } | null
      }
    }>
  } | null
}

export type CohortsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CohortsQuery = {
  __typename?: "Query"
  groups?: {
    __typename?: "GroupConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "GroupEdge"
      node: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        created_by_id?: number | null
        status: GroupStatus
        is_collection_linked?: boolean | null
        is_master?: boolean | null
        access_starts?: any | null
        parent_section_id?: number | null
        access_ends?: any | null
        registration?: {
          __typename?: "Registration"
          id: number
          role: number
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
        } | null
        path: { __typename?: "Path"; id: number }
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          image: string
          slug: string
          background_image?: string | null
          background_overlay?: string | null
          resource_type: number
        } | null
        resource_license?: {
          __typename?: "ResourceLicense"
          id?: number | null
          expiration_dtime?: any | null
        } | null
      }
    }>
  } | null
}

export type CohortsStatusQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
}>

export type CohortsStatusQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    licensed_from_school_id?: number | null
    cohorts_status_meta?: {
      __typename?: "CohortsStatusMeta"
      in_progress?: number | null
    } | null
  } | null
}

export type CreateCohortResourceQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type CreateCohortResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    resource_type: number
    image: string
    background_overlay?: string | null
    background_image?: string | null
    source_cohort?: {
      __typename?: "Group"
      id: number
      path: { __typename?: "Path"; id: number; last_synced_dtime?: any | null }
    } | null
    cohorts?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: {
          __typename?: "Group"
          id: number
          path: {
            __typename?: "Path"
            id: number
            last_synced_dtime?: any | null
          }
        }
      }>
    } | null
  } | null
}

export type ResourcesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  resourceTypes?: InputMaybe<ResourceTypeFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type ResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
      }
    }>
  } | null
}

export type UpdateCohortStatusMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  status: GroupStatus
}>

export type UpdateCohortStatusMutation = {
  __typename?: "Mutations"
  updateGroupStatus?: {
    __typename?: "Group"
    id: number
    status: GroupStatus
  } | null
}

export type CohortSwitcherCohortQueryQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type CohortSwitcherCohortQueryQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    is_source_cohort?: boolean | null
    resource?: {
      __typename?: "Resource"
      id: number
      slug: string
      licensed_from_school_id?: number | null
      licensed_from_resource_id?: number | null
      background_overlay?: string | null
      background_image?: string | null
      name: string
      resource_type: number
      blurred_background?: string | null
      source_cohort?: { __typename?: "Group"; id: number } | null
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    user_source_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  } | null
}

export type CompletionFragment = {
  __typename?: "Completion"
  id: number
  checked_date?: any | null
  completion_attempts?: number | null
  completion_comment?: string | null
  completion_date?: any | null
  completion_due?: any | null
  last_completion_attempt_date?: any | null
  has_failed_passing_attempt?: boolean | null
  has_points?: boolean | null
  is_late?: boolean | null
  is_graded?: boolean | null
  is_skipped?: boolean | null
  is_complete?: boolean | null
  is_auto_graded?: boolean | null
  is_forced_completion?: boolean | null
  needs_grading?: boolean | null
  userpoints_earned?: number | null
  userpoints_explanation?: string | null
  userpoints_value?: number | null
  minimum_passing_score?: number | null
  grading_type?: string | null
  requires_api_completion?: boolean | null
  overridden_by_api?: boolean | null
  overridden_by?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  checked_by?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  submission?: {
    __typename?: "UserSubmission"
    id?: number | null
    text?: string | null
    file_url?: string | null
    file_name?: string | null
    file_image?: string | null
  } | null
  feedback_discussion_context?: {
    __typename?: "CompletionFeedbackDiscussionContext"
    id?: number | null
    discussion_id?: number | null
    num_responses?: number | null
  } | null
}

export type CompletionQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CompletionQuery = {
  __typename?: "Query"
  pathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    parent?: { __typename?: "PathItem"; id: number; name: string } | null
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      points?: {
        __typename?: "Points"
        path_id?: number | null
        total?: number | null
        earned?: number | null
        percentage?: number | null
        total_points_possible?: number | null
        has_points?: boolean | null
      } | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      image: string
    } | null
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type CompletionsItemFragment = {
  __typename?: "PathItem"
  id: number
  order: number
  verb?: string | null
  name: string
  type: PathItemType
  path_id: number
  source_id: number
  parent_id?: number | null
  parent_source_id?: number | null
  description?: string | null
  curriculum_sync_opt_out_dtime?: any | null
  assignment_type?: PathItemAssignmentType | null
  content_id?: number | null
  content_type?: string | null
  item_content_type_id?: number | null
  is_required?: boolean | null
  is_previewable?: boolean | null
  due?: any | null
  passive_due?: boolean | null
  starts?: any | null
  passive_starts?: boolean | null
  has_started?: boolean | null
  points?: number | null
  item_needs_grading?: boolean | null
  minimum_passing_score?: number | null
  grading_type?: string | null
  time_to_complete?: number | null
  lock_password?: string | null
  is_locked?: boolean | null
  lock_unlocked_time?: any | null
  allow_resets?: number | null
  show_grading_feedback?: number | null
  completion_comment_required_status?: string | null
  last_published_dtime?: any | null
  copied_from_id?: number | null
  archived_time?: any | null
  progress: number
  cohort?: { __typename?: "Group"; id: number; name: string } | null
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    image: string
    background_overlay?: string | null
    background_image?: string | null
    image_raw?: string | null
    blurred_background?: string | null
  } | null
  parent?: {
    __typename?: "PathItem"
    id: number
    source_id: number
    order: number
    name: string
  } | null
  analytics?: {
    __typename?: "ItemAnalytics"
    need_feedback?: number | null
    total_users?: number | null
  } | null
  context?: {
    __typename?: "StepContext"
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null
  blocks?: {
    __typename?: "BlocksContent"
    content_last_modified?: any | null
    last_published?: any | null
  } | null
  permissions?: {
    __typename?: "PathItemPermissions"
    can_complete?: boolean | null
    can_discuss?: boolean | null
    can_edit?: boolean | null
    can_edit_content?: boolean | null
    can_note?: boolean | null
    can_view?: boolean | null
    can_review?: boolean | null
    can_view_content?: boolean | null
  } | null
  completion: {
    __typename?: "Completion"
    id: number
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  }
  linked_resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
  } | null
  linked_cohort?: {
    __typename?: "Group"
    id: number
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
  linked_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    path?: { __typename?: "Path"; id: number } | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type CompletionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  lesson_source_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  is_reviewed?: InputMaybe<Scalars["Boolean"]["input"]>
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
  order_by?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CompletionsQuery = {
  __typename?: "Query"
  completions?: {
    __typename?: "PathItemConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "PathItemEdge"
      node: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        copied_from_id?: number | null
        archived_time?: any | null
        progress: number
        cohort?: { __typename?: "Group"; id: number; name: string } | null
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          image: string
          background_overlay?: string | null
          background_image?: string | null
          image_raw?: string | null
          blurred_background?: string | null
        } | null
        parent?: {
          __typename?: "PathItem"
          id: number
          source_id: number
          order: number
          name: string
        } | null
        analytics?: {
          __typename?: "ItemAnalytics"
          need_feedback?: number | null
          total_users?: number | null
        } | null
        context?: {
          __typename?: "StepContext"
          school_id?: number | null
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id: number
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      }
    }>
  } | null
}

export type ResetCompletionFeedbackMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  pathId: Scalars["Int"]["input"]
}>

export type ResetCompletionFeedbackMutation = {
  __typename?: "Mutations"
  resetCompletionFeedback?: {
    __typename?: "Completion"
    id: number
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  } | null
}

export type SaveCompletionFeedbackMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  pathId: Scalars["Int"]["input"]
  userpointsEarned: Scalars["Int"]["input"]
  userpointsExplanation?: InputMaybe<Scalars["String"]["input"]>
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type SaveCompletionFeedbackMutation = {
  __typename?: "Mutations"
  saveCompletionFeedback?: {
    __typename?: "Completion"
    id: number
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  } | null
}

export type UserCompletionsNeedingReviewQueryVariables = Exact<{
  user_id: Scalars["Int"]["input"]
}>

export type UserCompletionsNeedingReviewQuery = {
  __typename?: "Query"
  pathItemStats?: {
    __typename?: "PathItemStats"
    path_items_needing_review?: number | null
  } | null
}

export type CouponFragment = {
  __typename?: "CouponDiscount"
  id?: number | null
  code?: string | null
  amount?: number | null
  discount_percent?: number | null
  discount_amount?: number | null
  discounted_total?: number | null
  num_redemptions?: number | null
  max_num_redemptions?: number | null
  max_seat_discount?: number | null
  discounted_subscription_cycles?: number | null
  start_date?: any | null
  end_date?: any | null
  has_started?: boolean | null
  has_ended?: boolean | null
  is_one_per_user?: boolean | null
  user_redeemed?: boolean | null
  user_can_redeem?: boolean | null
}

export type CouponQueryQueryVariables = Exact<{
  code: Scalars["String"]["input"]
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  school_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CouponQueryQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    coupon?: {
      __typename?: "CouponDiscount"
      id?: number | null
      code?: string | null
      amount?: number | null
      discount_percent?: number | null
      discount_amount?: number | null
      discounted_total?: number | null
      num_redemptions?: number | null
      max_num_redemptions?: number | null
      max_seat_discount?: number | null
      discounted_subscription_cycles?: number | null
      start_date?: any | null
      end_date?: any | null
      has_started?: boolean | null
      has_ended?: boolean | null
      is_one_per_user?: boolean | null
      user_redeemed?: boolean | null
      user_can_redeem?: boolean | null
    } | null
  } | null
}

export type CoverPageCategoryFragment = {
  __typename?: "Category"
  id: number
  name: string
  slug: string
  order: number
  position: string
  description?: string | null
}

export type CoverPageContributorFragment = {
  __typename?: "Author"
  position: string
  id: number
  order: number
  display_name: string
  full_name: string
  first_name: string
  last_name: string
  title?: string | null
  image?: string | null
  bio?: string | null
  avatar?: string | null
  salutation?: string | null
  slug: string
}

export type CoverPageLicensorRelatedResourcesQueryVariables = Exact<{
  licensorSchoolId: Scalars["Int"]["input"]
  idFilter?: InputMaybe<IdFilter>
  categoryIdFilter?: InputMaybe<IdFilter>
  resourceTypeFilter?: InputMaybe<ResourceTypeFilter>
  first: Scalars["Int"]["input"]
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CoverPageLicensorRelatedResourcesQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      resources?: {
        __typename?: "ResourceConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "ResourceEdge"
          node: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensing_enabled?: boolean | null
            image: string
            contributors?: {
              __typename?: "AuthorConnection"
              total: number
              edges: Array<{
                __typename?: "AuthorEdge"
                node: { __typename?: "Author"; id: number; full_name: string }
              }>
            } | null
            publisher?: {
              __typename?: "Publisher"
              name?: string | null
            } | null
          }
        }>
      } | null
    }
  } | null
}

export type CoverPageLicensorResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  licensorSchoolId: Scalars["Int"]["input"]
  contributorPositioningContext: PositioningContextInput
  categoryPositioningContext: PositioningContextInput
}>

export type CoverPageLicensorResourceQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      resource?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        resource_type: number
        is_ambient_background?: boolean | null
        created?: any | null
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_type: ResourceBackgroundType
        background_image_raw?: string | null
        background_image?: string | null
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        trailer_embed_code?: string | null
        pristine_background?: string | null
        blurred_background?: string | null
        cover_image: string
        image: string
        curriculum_group?: { __typename?: "Group"; id: number } | null
        contributors?: {
          __typename?: "AuthorConnection"
          total: number
          edges: Array<{
            __typename?: "AuthorEdge"
            node: {
              __typename?: "Author"
              position: string
              id: number
              order: number
              display_name: string
              full_name: string
              first_name: string
              last_name: string
              title?: string | null
              image?: string | null
              bio?: string | null
              avatar?: string | null
              salutation?: string | null
              slug: string
            }
          }>
        } | null
        categories?: {
          __typename?: "CategoryConnection"
          total: number
          edges: Array<{
            __typename?: "CategoryEdge"
            node: {
              __typename?: "Category"
              id: number
              name: string
              slug: string
              order: number
              position: string
              description?: string | null
            }
          }>
        } | null
        preview_group?: {
          __typename?: "Group"
          id: number
          path: {
            __typename?: "Path"
            id: number
            items?: {
              __typename?: "PathItemConnection"
              total: number
              edges: Array<{
                __typename?: "PathItemEdge"
                node: {
                  __typename?: "PathItem"
                  id: number
                  order: number
                  name: string
                  type: PathItemType
                  path_id: number
                  source_id: number
                  parent_id?: number | null
                  description?: string | null
                  content_id?: number | null
                  assignment_type?: PathItemAssignmentType | null
                  is_previewable?: boolean | null
                  item_content_type_id?: number | null
                  verb?: string | null
                  points?: number | null
                  is_required?: boolean | null
                  time_to_complete?: number | null
                  step_verb?: string | null
                  userpoints_value?: number | null
                  context?: {
                    __typename?: "StepContext"
                    school_id?: number | null
                    resource_id?: number | null
                    cohort_id?: number | null
                  } | null
                }
              }>
            } | null
          }
        } | null
      } | null
    }
  } | null
}

export type CoverPageOfferFragment = {
  __typename?: "Offer"
  id: number
  school_id: number
  cover_page_id: number
  kind: OfferKind
  cohort_id?: number | null
  cohort_name?: string | null
  resource_license_offering_id?: number | null
  scope: OfferScope
  visibility?: number | null
  availability_starts?: any | null
  availability_ends?: any | null
  title: string
  description?: string | null
  cta_label?: string | null
  external_url?: string | null
  position?: string | null
  access: {
    __typename?: "OfferAccess"
    meta: Array<string | null>
    state: OfferAccessState
    conversion_date?: any | null
  }
  price_options: Array<{
    __typename?: "OfferPriceOption"
    option_label: string
    button_label: string
    price_description: string
    payment_type?: OfferPaymentType | null
  }>
}

export type CoverPageOfferableCohortFragment = {
  __typename?: "Group"
  id: number
  name: string
  visibility?: number | null
  registration_starts?: any | null
  registration_ends?: any | null
  access_starts?: any | null
  access_ends?: any | null
  price?: number | null
  is_subscription_only?: boolean | null
}

export type CoverPageOfferableCohortsQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CoverPageOfferableCohortsQuery = {
  __typename?: "Query"
  groups?: {
    __typename?: "GroupConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "GroupEdge"
      node: {
        __typename?: "Group"
        id: number
        name: string
        visibility?: number | null
        registration_starts?: any | null
        registration_ends?: any | null
        access_starts?: any | null
        access_ends?: any | null
        price?: number | null
        is_subscription_only?: boolean | null
      }
    }>
  } | null
}

export type CoverPageOffersQueryVariables = Exact<{
  context: OfferContext
  first?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CoverPageOffersQuery = {
  __typename?: "Query"
  offerConnections?: {
    __typename?: "OfferConnection"
    edges: Array<{
      __typename?: "OfferEdge"
      node: {
        __typename?: "Offer"
        id: number
        school_id: number
        cover_page_id: number
        kind: OfferKind
        cohort_id?: number | null
        cohort_name?: string | null
        resource_license_offering_id?: number | null
        scope: OfferScope
        visibility?: number | null
        availability_starts?: any | null
        availability_ends?: any | null
        title: string
        description?: string | null
        cta_label?: string | null
        external_url?: string | null
        position?: string | null
        access: {
          __typename?: "OfferAccess"
          meta: Array<string | null>
          state: OfferAccessState
          conversion_date?: any | null
        }
        price_options: Array<{
          __typename?: "OfferPriceOption"
          option_label: string
          button_label: string
          price_description: string
          payment_type?: OfferPaymentType | null
        }>
      }
    }>
  } | null
}

export type CoverPagePathItemFragment = {
  __typename?: "PathItem"
  id: number
  order: number
  name: string
  type: PathItemType
  path_id: number
  source_id: number
  parent_id?: number | null
  description?: string | null
  content_id?: number | null
  assignment_type?: PathItemAssignmentType | null
  is_previewable?: boolean | null
  item_content_type_id?: number | null
  verb?: string | null
  points?: number | null
  is_required?: boolean | null
  time_to_complete?: number | null
  step_verb?: string | null
  userpoints_value?: number | null
  context?: {
    __typename?: "StepContext"
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null
}

export type CoverPagePrivateLicenseOfferingQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
}>

export type CoverPagePrivateLicenseOfferingQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    license_offerings?: {
      __typename?: "LicenseOfferingConnection"
      edges: Array<{
        __typename?: "LicenseOfferingEdge"
        node: { __typename?: "LicenseOffering"; id?: number | null }
      }>
    } | null
  } | null
}

export type CoverPageRelatedResourcesQueryVariables = Exact<{
  idFilter?: InputMaybe<IdFilter>
  categoryIdFilter?: InputMaybe<IdFilter>
  resourceTypeFilter?: InputMaybe<ResourceTypeFilter>
  first: Scalars["Int"]["input"]
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CoverPageRelatedResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensing_enabled?: boolean | null
        image: string
        contributors?: {
          __typename?: "AuthorConnection"
          total: number
          edges: Array<{
            __typename?: "AuthorEdge"
            node: { __typename?: "Author"; id: number; full_name: string }
          }>
        } | null
        publisher?: { __typename?: "Publisher"; name?: string | null } | null
      }
    }>
  } | null
}

export type CoverPageResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  resource_type: number
  is_ambient_background?: boolean | null
  created?: any | null
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_type: ResourceBackgroundType
  background_image_raw?: string | null
  background_image?: string | null
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  trailer_embed_code?: string | null
  pristine_background?: string | null
  blurred_background?: string | null
  cover_image: string
  image: string
  curriculum_group?: { __typename?: "Group"; id: number } | null
  contributors?: {
    __typename?: "AuthorConnection"
    total: number
    edges: Array<{
      __typename?: "AuthorEdge"
      node: {
        __typename?: "Author"
        position: string
        id: number
        order: number
        display_name: string
        full_name: string
        first_name: string
        last_name: string
        title?: string | null
        image?: string | null
        bio?: string | null
        avatar?: string | null
        salutation?: string | null
        slug: string
      }
    }>
  } | null
  categories?: {
    __typename?: "CategoryConnection"
    total: number
    edges: Array<{
      __typename?: "CategoryEdge"
      node: {
        __typename?: "Category"
        id: number
        name: string
        slug: string
        order: number
        position: string
        description?: string | null
      }
    }>
  } | null
  preview_group?: {
    __typename?: "Group"
    id: number
    path: {
      __typename?: "Path"
      id: number
      items?: {
        __typename?: "PathItemConnection"
        total: number
        edges: Array<{
          __typename?: "PathItemEdge"
          node: {
            __typename?: "PathItem"
            id: number
            order: number
            name: string
            type: PathItemType
            path_id: number
            source_id: number
            parent_id?: number | null
            description?: string | null
            content_id?: number | null
            assignment_type?: PathItemAssignmentType | null
            is_previewable?: boolean | null
            item_content_type_id?: number | null
            verb?: string | null
            points?: number | null
            is_required?: boolean | null
            time_to_complete?: number | null
            step_verb?: string | null
            userpoints_value?: number | null
            context?: {
              __typename?: "StepContext"
              school_id?: number | null
              resource_id?: number | null
              cohort_id?: number | null
            } | null
          }
        }>
      } | null
    }
  } | null
}

export type CoverPageResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  contributorPositioningContext: PositioningContextInput
  categoryPositioningContext: PositioningContextInput
}>

export type CoverPageResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    resource_type: number
    is_ambient_background?: boolean | null
    created?: any | null
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_type: ResourceBackgroundType
    background_image_raw?: string | null
    background_image?: string | null
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    trailer_embed_code?: string | null
    pristine_background?: string | null
    blurred_background?: string | null
    cover_image: string
    image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
    contributors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          position: string
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          position: string
          description?: string | null
        }
      }>
    } | null
    preview_group?: {
      __typename?: "Group"
      id: number
      path: {
        __typename?: "Path"
        id: number
        items?: {
          __typename?: "PathItemConnection"
          total: number
          edges: Array<{
            __typename?: "PathItemEdge"
            node: {
              __typename?: "PathItem"
              id: number
              order: number
              name: string
              type: PathItemType
              path_id: number
              source_id: number
              parent_id?: number | null
              description?: string | null
              content_id?: number | null
              assignment_type?: PathItemAssignmentType | null
              is_previewable?: boolean | null
              item_content_type_id?: number | null
              verb?: string | null
              points?: number | null
              is_required?: boolean | null
              time_to_complete?: number | null
              step_verb?: string | null
              userpoints_value?: number | null
              context?: {
                __typename?: "StepContext"
                school_id?: number | null
                resource_id?: number | null
                cohort_id?: number | null
              } | null
            }
          }>
        } | null
      }
    } | null
  } | null
}

export type CreateOfferMutationVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  offer: StoreOfferInput
}>

export type CreateOfferMutation = {
  __typename?: "Mutations"
  createOffer?: {
    __typename?: "Offer"
    id: number
    school_id: number
    cover_page_id: number
    kind: OfferKind
    cohort_id?: number | null
    cohort_name?: string | null
    resource_license_offering_id?: number | null
    scope: OfferScope
    visibility?: number | null
    availability_starts?: any | null
    availability_ends?: any | null
    title: string
    description?: string | null
    cta_label?: string | null
    external_url?: string | null
    position?: string | null
    access: {
      __typename?: "OfferAccess"
      meta: Array<string | null>
      state: OfferAccessState
      conversion_date?: any | null
    }
    price_options: Array<{
      __typename?: "OfferPriceOption"
      option_label: string
      button_label: string
      price_description: string
      payment_type?: OfferPaymentType | null
    }>
  } | null
}

export type DeleteOfferMutationVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
}>

export type DeleteOfferMutation = {
  __typename?: "Mutations"
  deleteOffer: boolean
}

export type ReorderOffersMutationVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  input: StoreOfferReorderInput
}>

export type ReorderOffersMutation = {
  __typename?: "Mutations"
  reorderOffers?: boolean | null
}

export type UpdateCoverPageContributorBioMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  bio?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateCoverPageContributorBioMutation = {
  __typename?: "Mutations"
  updateAuthor?: {
    __typename?: "Author"
    id: number
    bio?: string | null
  } | null
}

export type UpdateOfferMutationVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
  offer: StoreOfferPatchInput
}>

export type UpdateOfferMutation = {
  __typename?: "Mutations"
  updateOffer?: {
    __typename?: "Offer"
    id: number
    school_id: number
    cover_page_id: number
    kind: OfferKind
    cohort_id?: number | null
    cohort_name?: string | null
    resource_license_offering_id?: number | null
    scope: OfferScope
    visibility?: number | null
    availability_starts?: any | null
    availability_ends?: any | null
    title: string
    description?: string | null
    cta_label?: string | null
    external_url?: string | null
    position?: string | null
    access: {
      __typename?: "OfferAccess"
      meta: Array<string | null>
      state: OfferAccessState
      conversion_date?: any | null
    }
    price_options: Array<{
      __typename?: "OfferPriceOption"
      option_label: string
      button_label: string
      price_description: string
      payment_type?: OfferPaymentType | null
    }>
  } | null
}

export type UpdateCoverPagePathPreviewItemsMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  items: Array<PathItemBulkUpdateInput> | PathItemBulkUpdateInput
}>

export type UpdateCoverPagePathPreviewItemsMutation = {
  __typename?: "Mutations"
  bulkUpdatePathItems: Array<{
    __typename?: "PathItemBulkUpdateResult"
    source_id?: number | null
    success: boolean
    previous_values?: any | null
    error?: string | null
  }>
}

export type UpdateCoverPageResourceMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  cover_image?: InputMaybe<Scalars["String"]["input"]>
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  short_description?: InputMaybe<Scalars["String"]["input"]>
  authors?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  categories?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
  contributorPositioningContext: PositioningContextInput
  categoryPositioningContext: PositioningContextInput
}>

export type UpdateCoverPageResourceMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    resource_type: number
    is_ambient_background?: boolean | null
    created?: any | null
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_type: ResourceBackgroundType
    background_image_raw?: string | null
    background_image?: string | null
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    trailer_embed_code?: string | null
    pristine_background?: string | null
    blurred_background?: string | null
    cover_image: string
    image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
    contributors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          position: string
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          position: string
          description?: string | null
        }
      }>
    } | null
    preview_group?: {
      __typename?: "Group"
      id: number
      path: {
        __typename?: "Path"
        id: number
        items?: {
          __typename?: "PathItemConnection"
          total: number
          edges: Array<{
            __typename?: "PathItemEdge"
            node: {
              __typename?: "PathItem"
              id: number
              order: number
              name: string
              type: PathItemType
              path_id: number
              source_id: number
              parent_id?: number | null
              description?: string | null
              content_id?: number | null
              assignment_type?: PathItemAssignmentType | null
              is_previewable?: boolean | null
              item_content_type_id?: number | null
              verb?: string | null
              points?: number | null
              is_required?: boolean | null
              time_to_complete?: number | null
              step_verb?: string | null
              userpoints_value?: number | null
              context?: {
                __typename?: "StepContext"
                school_id?: number | null
                resource_id?: number | null
                cohort_id?: number | null
              } | null
            }
          }>
        } | null
      }
    } | null
  } | null
}

export type MembershipStatsFragment = {
  __typename?: "School"
  membershipStats?: {
    __typename?: "MembershipStats"
    total?: number | null
    active?: number | null
  } | null
}

export type MentorGroupsFragment = {
  __typename?: "School"
  mentorGroups?: { __typename?: "MentorGroupConnection"; total: number } | null
}

export type PlacesQueryQueryVariables = Exact<{ [key: string]: never }>

export type PlacesQueryQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    first_name: string
    last_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      image?: string | null
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          group: {
            __typename?: "Group"
            id: number
            name: string
            seats_filled?: number | null
            resource?: {
              __typename?: "Resource"
              id: number
              slug: string
            } | null
            path: { __typename?: "Path"; id: number }
          }
        }
      }>
    } | null
  } | null
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    resourceStats?: {
      __typename?: "ResourceStats"
      private?: number | null
      public?: number | null
    } | null
    recentMembers?: {
      __typename?: "MembershipConnection"
      total: number
      edges: Array<{
        __typename?: "MembershipEdge"
        node: {
          __typename?: "Membership"
          id: number
          user: {
            __typename?: "User"
            id: number
            display_name?: string | null
            first_name: string
            last_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
              bio?: string | null
              location?: string | null
            } | null
            membership?: {
              __typename?: "Membership"
              id: number
              role: number
            } | null
          }
        }
      }>
    } | null
    membershipStats?: {
      __typename?: "MembershipStats"
      total?: number | null
      active?: number | null
    } | null
    mentorGroups?: {
      __typename?: "MentorGroupConnection"
      total: number
    } | null
  } | null
  visibleResources?: {
    __typename?: "ResourceConnection"
    total: number
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        image: string
      }
    }>
  } | null
  privateResources?: {
    __typename?: "ResourceConnection"
    total: number
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        image: string
      }
    }>
  } | null
}

export type PrivateResourcesFragment = {
  __typename?: "Query"
  privateResources?: {
    __typename?: "ResourceConnection"
    total: number
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        image: string
      }
    }>
  } | null
}

export type RecentMembersFragment = {
  __typename?: "School"
  recentMembers?: {
    __typename?: "MembershipConnection"
    total: number
    edges: Array<{
      __typename?: "MembershipEdge"
      node: {
        __typename?: "Membership"
        id: number
        user: {
          __typename?: "User"
          id: number
          display_name?: string | null
          first_name: string
          last_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
            bio?: string | null
            location?: string | null
          } | null
          membership?: {
            __typename?: "Membership"
            id: number
            role: number
          } | null
        }
      }
    }>
  } | null
}

export type ResourceStatsFragment = {
  __typename?: "School"
  resourceStats?: {
    __typename?: "ResourceStats"
    private?: number | null
    public?: number | null
  } | null
}

export type TeacherRegistrationsFragment = {
  __typename?: "User"
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges: Array<{
      __typename?: "RegistrationEdge"
      node: {
        __typename?: "Registration"
        group: {
          __typename?: "Group"
          id: number
          name: string
          seats_filled?: number | null
          resource?: {
            __typename?: "Resource"
            id: number
            slug: string
          } | null
          path: { __typename?: "Path"; id: number }
        }
      }
    }>
  } | null
}

export type UserDisplayFragment = {
  __typename?: "User"
  id: number
  first_name: string
  last_name: string
  display_name?: string | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    image?: string | null
  } | null
}

export type VisibleResourcesFragment = {
  __typename?: "Query"
  visibleResources?: {
    __typename?: "ResourceConnection"
    total: number
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        image: string
      }
    }>
  } | null
}

export type PathItemPublishedQueryQueryVariables = Exact<{
  sourceId: Scalars["Int"]["input"]
  cohortId: Scalars["Int"]["input"]
}>

export type PathItemPublishedQueryQuery = {
  __typename?: "Query"
  pathItem?: {
    __typename?: "PathItem"
    id: number
    source_id: number
    last_published_dtime?: any | null
  } | null
}

export type CreateDiscussionLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type CreateDiscussionLikeMutation = {
  __typename?: "Mutations"
  createDiscussionLike?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type CreateDiscussionMutationVariables = Exact<{
  context: DiscussionContextInput
  post: DiscussionPostInput
  initialResponse?: InputMaybe<DiscussionResponseInput>
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CreateDiscussionMutation = {
  __typename?: "Mutations"
  createDiscussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type CreateDiscussionResponseLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}>

export type CreateDiscussionResponseLikeMutation = {
  __typename?: "Mutations"
  createDiscussionResponseLike?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    discussion_id: number
    body: string
    depth: number
    attachments?: any | null
    likes: number
    user_liked: boolean
    created_time: any
    archived_time?: any | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type CreateDiscussionResponseMutationVariables = Exact<{
  context: DiscussionContextInput
  response: DiscussionResponseInput
}>

export type CreateDiscussionResponseMutation = {
  __typename?: "Mutations"
  createDiscussionResponse?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    discussion_id: number
    body: string
    depth: number
    attachments?: any | null
    likes: number
    user_liked: boolean
    created_time: any
    archived_time?: any | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type CreateDiscussionSubscriptionMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type CreateDiscussionSubscriptionMutation = {
  __typename?: "Mutations"
  createDiscussionSubscription?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type DeleteDiscussionLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionLikeMutation = {
  __typename?: "Mutations"
  deleteDiscussionLike?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type DeleteDiscussionMutationVariables = Exact<{
  context: DiscussionContextInput
  id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionMutation = {
  __typename?: "Mutations"
  deleteDiscussion?: boolean | null
}

export type DeleteDiscussionResponseLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionResponseLikeMutation = {
  __typename?: "Mutations"
  deleteDiscussionResponseLike?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    discussion_id: number
    body: string
    depth: number
    attachments?: any | null
    likes: number
    user_liked: boolean
    created_time: any
    archived_time?: any | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type DeleteDiscussionResponseMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionResponseMutation = {
  __typename?: "Mutations"
  deleteDiscussionResponse?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    discussion_id: number
    body: string
    depth: number
    attachments?: any | null
    likes: number
    user_liked: boolean
    created_time: any
    archived_time?: any | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type DeleteDiscussionSubscriptionMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionSubscriptionMutation = {
  __typename?: "Mutations"
  deleteDiscussionSubscription?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type DiscussionParticipantFragment = {
  __typename?: "DiscussionParticipant"
  id: number
  email?: string | null
  first_name: string
  last_name: string
  full_name: string
  display_name?: string | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    bio?: string | null
    image?: string | null
    location?: string | null
    last_activity?: any | null
    rewardful_referral_id?: string | null
  } | null
}

export type DiscussionParticipantsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type DiscussionParticipantsQuery = {
  __typename?: "Query"
  discussionParticipants?: {
    __typename?: "DiscussionParticipantConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "DiscussionParticipantEdge"
      node: {
        __typename?: "DiscussionParticipant"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    }>
  } | null
}

export type DiscussionPostFragment = {
  __typename?: "Discussion"
  id: number
  title: string
  body?: string | null
  type: number
  likes: number
  total_responses: number
  created_time: any
  is_discussion_question: boolean
  allow_replies: boolean
  last_activity_time?: any | null
  user_last_viewed_time?: any | null
  user_last_responded_time?: any | null
  user_has_viewed_recent: boolean
  user_is_subscribed?: boolean | null
  user_liked?: boolean | null
  context_id?: number | null
  resource_id?: number | null
  cohort_id?: number | null
  step_id?: number | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
  } | null
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
  } | null
  step?: {
    __typename?: "DiscussionPathItem"
    id: number
    name: string
    verb?: string | null
  } | null
  tagLinks?: {
    __typename?: "TagLinkConnection"
    edges: Array<{
      __typename?: "TagLinkEdge"
      node: {
        __typename?: "TagLink"
        id?: number | null
        tag_id?: number | null
        discussion_context_id?: number | null
        tag?: {
          __typename?: "Tag"
          id: number
          name: string
          slug: string
          description?: string | null
          color?: string | null
        } | null
      }
    }>
  } | null
}

export type DiscussionPostQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
}>

export type DiscussionPostQuery = {
  __typename?: "Query"
  discussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type DiscussionQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
}>

export type DiscussionQuery = {
  __typename?: "Query"
  discussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type DiscussionResponseFragment = {
  __typename?: "Response"
  id: number
  parent_id?: number | null
  discussion_id: number
  body: string
  depth: number
  attachments?: any | null
  likes: number
  user_liked: boolean
  created_time: any
  archived_time?: any | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type DiscussionResponseQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
  response_id: Scalars["Int"]["input"]
}>

export type DiscussionResponseQuery = {
  __typename?: "Query"
  discussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    response?: {
      __typename?: "Response"
      id: number
      parent_id?: number | null
      discussion_id: number
      body: string
      depth: number
      attachments?: any | null
      likes: number
      user_liked: boolean
      created_time: any
      archived_time?: any | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type DiscussionsQueryVariables = Exact<{
  context: DiscussionContextInput
  type?: InputMaybe<DiscussionTypeInput>
  is_discussion_question?: InputMaybe<Scalars["Boolean"]["input"]>
  total_responses?: InputMaybe<IntFilter>
  tagIdFilter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type DiscussionsQuery = {
  __typename?: "Query"
  discussions?: {
    __typename?: "DiscussionConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "DiscussionEdge"
      node: {
        __typename?: "Discussion"
        id: number
        title: string
        body?: string | null
        type: number
        likes: number
        total_responses: number
        created_time: any
        is_discussion_question: boolean
        allow_replies: boolean
        last_activity_time?: any | null
        user_last_viewed_time?: any | null
        user_last_responded_time?: any | null
        user_has_viewed_recent: boolean
        user_is_subscribed?: boolean | null
        user_liked?: boolean | null
        context_id?: number | null
        resource_id?: number | null
        cohort_id?: number | null
        step_id?: number | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        cohort?: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
        } | null
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
        } | null
        step?: {
          __typename?: "DiscussionPathItem"
          id: number
          name: string
          verb?: string | null
        } | null
        tagLinks?: {
          __typename?: "TagLinkConnection"
          edges: Array<{
            __typename?: "TagLinkEdge"
            node: {
              __typename?: "TagLink"
              id?: number | null
              tag_id?: number | null
              discussion_context_id?: number | null
              tag?: {
                __typename?: "Tag"
                id: number
                name: string
                slug: string
                description?: string | null
                color?: string | null
              } | null
            }
          }>
        } | null
      }
    }>
  } | null
}

export type ResponsesQueryVariables = Exact<{
  context: DiscussionResponseContextInput
  rootResponseId?: InputMaybe<IntFilter>
  archivedTime?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<
    Array<InputMaybe<ResponseOrderBy>> | InputMaybe<ResponseOrderBy>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ResponsesQuery = {
  __typename?: "Query"
  responses?: {
    __typename?: "ResponseConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      endCursor?: string | null
    }
    edges: Array<{
      __typename?: "ResponseEdge"
      node: {
        __typename?: "Response"
        id: number
        parent_id?: number | null
        discussion_id: number
        body: string
        depth: number
        attachments?: any | null
        likes: number
        user_liked: boolean
        created_time: any
        archived_time?: any | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      }
    }>
  } | null
}

export type UpdateDiscussionMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  context: DiscussionContextInput
  post: DiscussionPostInput
}>

export type UpdateDiscussionMutation = {
  __typename?: "Mutations"
  updateDiscussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type UpdateDiscussionResponseMutationVariables = Exact<{
  context: DiscussionContextInput
  response: DiscussionResponseInput
  response_id: Scalars["Int"]["input"]
}>

export type UpdateDiscussionResponseMutation = {
  __typename?: "Mutations"
  updateDiscussionResponse?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    discussion_id: number
    body: string
    depth: number
    attachments?: any | null
    likes: number
    user_liked: boolean
    created_time: any
    archived_time?: any | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type UpdateUserDiscussionHistoryMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type UpdateUserDiscussionHistoryMutation = {
  __typename?: "Mutations"
  updateUserDiscussionHistory?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    step?: {
      __typename?: "DiscussionPathItem"
      id: number
      name: string
      verb?: string | null
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges: Array<{
        __typename?: "TagLinkEdge"
        node: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id: number
            name: string
            slug: string
            description?: string | null
            color?: string | null
          } | null
        }
      }>
    } | null
  } | null
}

export type CommunityEnableMutationVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
  communityEnabled: Scalars["Boolean"]["input"]
}>

export type CommunityEnableMutation = {
  __typename?: "Mutations"
  updateGroupDiscussionEnabled?: {
    __typename?: "Group"
    id: number
    discussion_enabled?: boolean | null
  } | null
}

export type ContextualFeaturePermissionFragment = {
  __typename?: "ContextualFeaturePermission"
  id?: number | null
  feature_key: FeatureKey
  feature_action: FeatureAction
  permission_in_context: FeaturePermission
  school_id?: number | null
  resource_id?: number | null
  cohort_id?: number | null
  user_id?: number | null
}

export type ContextualFeaturePermissionQueryVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  context?: InputMaybe<FeatureContextInput>
}>

export type ContextualFeaturePermissionQuery = {
  __typename?: "Query"
  contextualFeaturePermission?: {
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    user_id?: number | null
  } | null
}

export type ContextualFeaturePermissionsQueryVariables = Exact<{
  featureKeys?: InputMaybe<FeatureKeyFilter>
  featureAction?: InputMaybe<FeatureAction>
  context?: InputMaybe<FeatureContextInput>
}>

export type ContextualFeaturePermissionsQuery = {
  __typename?: "Query"
  contextualFeaturePermissions: Array<{
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    user_id?: number | null
  }>
}

export type CreateContextualFeaturePermissionMutationVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  permissionInContext: FeaturePermission
  context?: InputMaybe<FeatureContextInput>
}>

export type CreateContextualFeaturePermissionMutation = {
  __typename?: "Mutations"
  createContextualFeaturePermission?: {
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    user_id?: number | null
  } | null
}

export type DeleteContextualFeaturePermissionMutationMutationVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  context?: InputMaybe<FeatureContextInput>
}>

export type DeleteContextualFeaturePermissionMutationMutation = {
  __typename?: "Mutations"
  deleteContextualFeaturePermission?: boolean | null
}

export type FeatureContextQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type FeatureContextQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    discussion_enabled?: boolean | null
    resource?: {
      __typename?: "Resource"
      id: number
      discussion_enabled?: boolean | null
    } | null
  } | null
}

export type SpaceAuthSettingsQueryVariables = Exact<{ [key: string]: never }>

export type SpaceAuthSettingsQuery = {
  __typename?: "Query"
  space: {
    __typename?: "Space"
    id: number
    pathwright_login_enabled?: boolean | null
    allow_public_signup?: boolean | null
    always_prompt_for_password?: boolean | null
    authMethods: Array<{
      __typename?: "AuthMethod"
      id: string
      enabled: boolean
      meta: {
        __typename?: "NodeMeta"
        id: string
        key: string
        type: string
        url?: string | null
        title?: string | null
        icon?: string | null
      }
    }>
  }
}

export type UpdateContextualFeaturePermissionMutationVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  permissionInContext: FeaturePermission
  context?: InputMaybe<FeatureContextInput>
}>

export type UpdateContextualFeaturePermissionMutation = {
  __typename?: "Mutations"
  updateContextualFeaturePermission?: {
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    user_id?: number | null
  } | null
}

export type UpdateSpaceAuthSettingsMutationVariables = Exact<{
  pathwrightLoginEnabled: Scalars["Boolean"]["input"]
  allowPublicSignup: Scalars["Boolean"]["input"]
  alwaysPromptForPassword: Scalars["Boolean"]["input"]
}>

export type UpdateSpaceAuthSettingsMutation = {
  __typename?: "Mutations"
  updatePathwrightAuth?: {
    __typename?: "Space"
    id: number
    pathwright_login_enabled?: boolean | null
    allow_public_signup?: boolean | null
    always_prompt_for_password?: boolean | null
  } | null
}

export type CreateGroupMutationVariables = Exact<{
  base_resource_id: Scalars["Int"]["input"]
  parent_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  visibility: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
}>

export type CreateGroupMutation = {
  __typename?: "Mutations"
  createGroup?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      blurred_background?: string | null
      cover_image: string
    } | null
  } | null
}

export type GroupContextFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  description?: string | null
  price?: number | null
  seats?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  registration_ends?: any | null
  registration_starts?: any | null
  registration_started?: boolean | null
  registration_ended?: boolean | null
  access_ends?: any | null
  access_starts?: any | null
  is_master?: boolean | null
  is_source_cohort?: boolean | null
  source_cohort_id?: number | null
  parent_section_id?: number | null
  resource_id?: number | null
  visibility?: number | null
  is_collection_linked?: boolean | null
  is_subscription_only?: boolean | null
  status: GroupStatus
  analytics_disabled?: boolean | null
  created_by_id?: number | null
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    blurred_background?: string | null
    cover_image: string
  } | null
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
  user_source_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
}

export type GroupFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  description?: string | null
  price?: number | null
  seats?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  registration_ends?: any | null
  registration_starts?: any | null
  registration_started?: boolean | null
  registration_ended?: boolean | null
  access_ends?: any | null
  access_starts?: any | null
  is_master?: boolean | null
  is_source_cohort?: boolean | null
  source_cohort_id?: number | null
  parent_section_id?: number | null
  resource_id?: number | null
  visibility?: number | null
  is_collection_linked?: boolean | null
  is_subscription_only?: boolean | null
  status: GroupStatus
  analytics_disabled?: boolean | null
  created_by_id?: number | null
}

export type GroupQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type GroupQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      blurred_background?: string | null
      cover_image: string
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    user_source_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  } | null
}

export type GroupQueryResourcePathQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type GroupQueryResourcePathQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    path: {
      __typename?: "Path"
      id: number
      points?: {
        __typename?: "Points"
        path_id?: number | null
        has_points?: boolean | null
      } | null
    }
  } | null
}

export type GroupsQueryQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  resource_id: Scalars["Int"]["input"]
  include_curriculum?: InputMaybe<Scalars["Boolean"]["input"]>
  parentGroupIdFilter?: InputMaybe<IdFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type GroupsQueryQuery = {
  __typename?: "Query"
  groups?: {
    __typename?: "GroupConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "GroupEdge"
      node: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        description?: string | null
        price?: number | null
        seats?: number | null
        seats_filled?: number | null
        seats_available?: number | null
        registration_ends?: any | null
        registration_starts?: any | null
        registration_started?: boolean | null
        registration_ended?: boolean | null
        access_ends?: any | null
        access_starts?: any | null
        is_master?: boolean | null
        is_source_cohort?: boolean | null
        source_cohort_id?: number | null
        parent_section_id?: number | null
        resource_id?: number | null
        visibility?: number | null
        is_collection_linked?: boolean | null
        is_subscription_only?: boolean | null
        status: GroupStatus
        analytics_disabled?: boolean | null
        created_by_id?: number | null
      }
    }>
  } | null
}

export type CreateResourceMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  cover_image: Scalars["String"]["input"]
  resource_type?: InputMaybe<ResourceType>
  group_name?: InputMaybe<Scalars["String"]["input"]>
  group_role?: InputMaybe<RegistrationRoleEnum>
}>

export type CreateResourceMutation = {
  __typename?: "Mutations"
  createResource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    blurred_background?: string | null
    cover_image: string
    curriculum?: { __typename?: "Group"; id: number } | null
    cohort?: {
      __typename?: "Group"
      id: number
      source_cohort_id?: number | null
    } | null
  } | null
}

export type CreatedResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  blurred_background?: string | null
  cover_image: string
  curriculum?: { __typename?: "Group"; id: number } | null
  cohort?: {
    __typename?: "Group"
    id: number
    source_cohort_id?: number | null
  } | null
}

export type ManageMentorGroupMembershipsQueryVariables = Exact<{
  [key: string]: never
}>

export type ManageMentorGroupMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          group_id: number
        }
      }>
    } | null
  } | null
}

export type UserRegistrationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type UserRegistrationsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
          } | null
          school_sub_used?: {
            __typename?: "SchoolSubscription"
            id: number
            subscription: {
              __typename?: "Subscription"
              id: number
              is_delinquent?: boolean | null
              canceled_dtime?: any | null
            }
          } | null
          group_sub_used?: {
            __typename?: "SchoolGroupSubscription"
            id: number
          } | null
          group_sub_community_membership?: {
            __typename?: "MentorGroupMembership"
            id: number
            access_revoked_time?: any | null
          } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type RandomResourceImageQueryVariables = Exact<{
  themeType?: InputMaybe<ThemeType>
}>

export type RandomResourceImageQuery = {
  __typename?: "Query"
  resourceImage: Array<any | null>
}

export type FeedbackReviewersQueryVariables = Exact<{
  completionId: Scalars["Int"]["input"]
}>

export type FeedbackReviewersQuery = {
  __typename?: "Query"
  feedbackReviewers?: {
    __typename?: "FeedbackReviewers"
    id?: number | null
    reviewers?: Array<any | null> | null
  } | null
}

export type InboxContextQueryVariables = Exact<{
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type InboxContextQuery = {
  __typename?: "Query"
  inboxContext?: {
    __typename?: "InboxContext"
    id?: string | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      resource?: { __typename?: "Resource"; id: number; name: string } | null
    } | null
    group?: { __typename?: "MentorGroup"; id: number; name: string } | null
  } | null
}

export type InboxGroupConnectionFragment = {
  __typename?: "InboxGroupConnection"
  mentor_group?: {
    __typename?: "MentorGroup"
    id: number
    name: string
    memberships?: {
      __typename?: "MentorGroupMembershipConnection"
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    resource?: { __typename?: "Resource"; id: number; name: string } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type InboxGroupConnectionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type InboxGroupConnectionsQuery = {
  __typename?: "Query"
  inboxGroupConnections?: {
    __typename?: "InboxGroupConnectionConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "InboxGroupConnectionEdge"
      node: {
        __typename?: "InboxGroupConnection"
        mentor_group?: {
          __typename?: "MentorGroup"
          id: number
          name: string
          memberships?: {
            __typename?: "MentorGroupMembershipConnection"
            edges: Array<{
              __typename?: "MentorGroupMembershipEdge"
              node: {
                __typename?: "MentorGroupMembership"
                id: number
                role: number
                user: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                }
              }
            }>
          } | null
        } | null
        cohort?: {
          __typename?: "Group"
          id: number
          name: string
          resource?: {
            __typename?: "Resource"
            id: number
            name: string
          } | null
          registrations?: {
            __typename?: "RegistrationConnection"
            edges: Array<{
              __typename?: "RegistrationEdge"
              node: {
                __typename?: "Registration"
                id: number
                role: number
                user: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                }
              }
            }>
          } | null
        } | null
      }
    }>
  } | null
}

export type InboxPendingReviewCountQueryVariables = Exact<{
  targetId: Scalars["Int"]["input"]
  targetType: InboxPendingReviewTarget
}>

export type InboxPendingReviewCountQuery = {
  __typename?: "Query"
  inboxPendingReview?: {
    __typename?: "InboxPendingReview"
    id?: number | null
    count?: number | null
  } | null
}

export type InboxPeopleCompletionCountsFragment = {
  __typename?: "InboxPeopleCompletionCounts"
  id?: number | null
  count?: number | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type InboxPeopleCompletionCountsQueryVariables = Exact<{
  targetType: InboxPeopleCompletionCountsTarget
  targetId: Scalars["Int"]["input"]
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  isComplete?: InputMaybe<Scalars["Boolean"]["input"]>
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>
  stepSourceId?: InputMaybe<Scalars["Int"]["input"]>
  parentSourceId?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
}>

export type InboxPeopleCompletionCountsQuery = {
  __typename?: "Query"
  inboxPeopleCompletionCounts?: {
    __typename?: "InboxPeopleCompletionCountsConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: string | null
      endCursor?: string | null
    }
    edges: Array<{
      __typename?: "InboxPeopleCompletionCountsEdge"
      node: {
        __typename?: "InboxPeopleCompletionCounts"
        id?: number | null
        count?: number | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      }
    }>
  } | null
}

export type InboxReviewerFragment = {
  __typename?: "InboxReviewer"
  id: number
  group_or_cohort_id: number
  group_role?: MentorGroupMembershipRole | null
  cohort_role?: RegistrationRoleEnum | null
  can_review: boolean
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type InboxReviewersQueryVariables = Exact<{
  pathId: Scalars["Int"]["input"]
}>

export type InboxReviewersQuery = {
  __typename?: "Query"
  inboxReviewers?: {
    __typename?: "InboxReviewerConnection"
    edges: Array<{
      __typename?: "InboxReviewerEdge"
      node: {
        __typename?: "InboxReviewer"
        id: number
        group_or_cohort_id: number
        group_role?: MentorGroupMembershipRole | null
        cohort_role?: RegistrationRoleEnum | null
        can_review: boolean
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      }
    }>
  } | null
}

export type UserCanReviewForUserQueryVariables = Exact<{
  forUserId: Scalars["Int"]["input"]
}>

export type UserCanReviewForUserQuery = {
  __typename?: "Query"
  canReview?: boolean | null
}

export type IntercomIntegrationQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type IntercomIntegrationQueryQuery = {
  __typename?: "Query"
  integrations?: {
    __typename?: "Integrations"
    intercom?: {
      __typename?: "IntercomIntegration"
      school_app_id?: string | null
      school_secret_key?: string | null
      school_access_token?: string | null
    } | null
  } | null
}

export type AcceptCommunityGroupInvitationMutationVariables = Exact<{
  token: Scalars["String"]["input"]
}>

export type AcceptCommunityGroupInvitationMutation = {
  __typename?: "Mutations"
  acceptCommunityGroupInvitation?: boolean | null
}

export type CreateInvitationsMutationVariables = Exact<{
  context?: InputMaybe<InvitationContext>
  type?: InputMaybe<InvitationType>
  invite_emails:
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  invite_to_community_group_role: MentorGroupMembershipRole
}>

export type CreateInvitationsMutation = {
  __typename?: "Mutations"
  createInvitations?: {
    __typename?: "CreateInvitationsSuccess"
    invitations_attempted_count?: number | null
    invitations_sent_count?: number | null
    unsuccessful_invitations?: any | null
  } | null
}

export type DeleteInvitationMutationVariables = Exact<{
  deleteInvitationId: Scalars["Int"]["input"]
}>

export type DeleteInvitationMutation = {
  __typename?: "Mutations"
  deleteInvitation?: boolean | null
}

export type InvitationFragment = {
  __typename?: "Invitation"
  id: number
  created_dtime: any
  invitation_role: number
  invitation_type: InvitationType
  invitation_subject?: string | null
  invitation_status: InvitationStatus
  invitation_url: string
  invitation_message?: string | null
  invitation_accepted_dtime?: any | null
  invitation_hash?: string | null
  to_email: string
  to_first_name?: string | null
  to_last_name?: string | null
  invitation_email?: {
    __typename?: "EmailMessageData"
    id?: number | null
    created_dtime?: any | null
    delivery_status?: EmailDeliveryStatus | null
    delivery_status_updated?: any | null
  } | null
}

export type InvitationsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<InvitationContext>
  deliveryStatus?: InputMaybe<EmailDeliveryStatus>
  status?: InputMaybe<InvitationStatus>
  orderBy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
}>

export type InvitationsQuery = {
  __typename?: "Query"
  invitations?: {
    __typename?: "InvitationConnection"
    edges: Array<{
      __typename?: "InvitationEdge"
      node: {
        __typename?: "Invitation"
        id: number
        created_dtime: any
        invitation_role: number
        invitation_type: InvitationType
        invitation_subject?: string | null
        invitation_status: InvitationStatus
        invitation_url: string
        invitation_message?: string | null
        invitation_accepted_dtime?: any | null
        invitation_hash?: string | null
        to_email: string
        to_first_name?: string | null
        to_last_name?: string | null
        invitation_email?: {
          __typename?: "EmailMessageData"
          id?: number | null
          created_dtime?: any | null
          delivery_status?: EmailDeliveryStatus | null
          delivery_status_updated?: any | null
        } | null
      }
    }>
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
  } | null
}

export type ResendInvitationMutationVariables = Exact<{
  resendInvitationId: Scalars["Int"]["input"]
}>

export type ResendInvitationMutation = {
  __typename?: "Mutations"
  resendInvitation?: {
    __typename?: "Invitation"
    id: number
    created_dtime: any
    invitation_role: number
    invitation_type: InvitationType
    invitation_subject?: string | null
    invitation_status: InvitationStatus
    invitation_url: string
    invitation_message?: string | null
    invitation_accepted_dtime?: any | null
    invitation_hash?: string | null
    to_email: string
    to_first_name?: string | null
    to_last_name?: string | null
    invitation_email?: {
      __typename?: "EmailMessageData"
      id?: number | null
      created_dtime?: any | null
      delivery_status?: EmailDeliveryStatus | null
      delivery_status_updated?: any | null
    } | null
  } | null
}

export type FeatureLockQueryVariables = Exact<{
  default_billing_plan_set?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type FeatureLockQuery = {
  __typename?: "Query"
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    is_activated?: boolean | null
    is_activated_via_override?: boolean | null
    is_on_legacy_plan?: boolean | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        order: number
        name: string
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          key: string
        }>
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
        } | null
      } | null
    } | null
    billing_plan_set?: {
      __typename?: "SchoolBillingPlanSet"
      id?: number | null
      plans?: Array<{
        __typename?: "SchoolBillingPlan"
        id: number
        order: number
        name: string
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          key: string
        }>
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
        } | null
      } | null> | null
    } | null
  } | null
}

export type FeatureLockSchoolBillingPlanFragment = {
  __typename?: "SchoolBillingPlan"
  id: number
  order: number
  name: string
  features: Array<{
    __typename?: "SchoolBillingPlanFeature"
    id: number
    key: string
  }>
  plan_derived_from?: { __typename?: "SchoolBillingPlan"; id: number } | null
}

export type MediaQueryVariables = Exact<{
  url: Scalars["String"]["input"]
  width?: InputMaybe<Scalars["Int"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  crop?: InputMaybe<Crop>
  fit?: InputMaybe<Fit>
}>

export type MediaQuery = {
  __typename?: "Query"
  media?: {
    __typename?: "Media"
    image?: string | null
    filestack?: {
      __typename?: "FilestackInfo"
      api_key?: string | null
      policy?: string | null
      signature?: string | null
    } | null
  } | null
}

export type LibraryAuthorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  resourceSearch?: InputMaybe<Scalars["String"]["input"]>
  resourceAuthorNameFilter?: InputMaybe<StringFilter>
  resourceCategoryNameFilter?: InputMaybe<StringFilter>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type LibraryAuthorsQuery = {
  __typename?: "Query"
  authors?: {
    __typename?: "AuthorConnection"
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      endCursor?: string | null
    }
    edges: Array<{
      __typename?: "AuthorEdge"
      node: {
        __typename?: "Author"
        id: number
        order: number
        display_name: string
        full_name: string
        first_name: string
        last_name: string
        title?: string | null
        image?: string | null
        bio?: string | null
        avatar?: string | null
        salutation?: string | null
        slug: string
      }
    }>
  } | null
}

export type LibraryCategoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  resourceSearch?: InputMaybe<Scalars["String"]["input"]>
  resourceCategoryNameFilter?: InputMaybe<StringFilter>
  resourceAuthorNameFilter?: InputMaybe<StringFilter>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type LibraryCategoriesQuery = {
  __typename?: "Query"
  categories?: {
    __typename?: "CategoryConnection"
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      endCursor?: string | null
    }
    edges: Array<{
      __typename?: "CategoryEdge"
      node: {
        __typename?: "Category"
        id: number
        name: string
        slug: string
        order: number
        description?: string | null
      }
    }>
  } | null
}

export type LibraryResourcesQueryVariables = Exact<{
  idFilter?: InputMaybe<IdFilter>
  categoryIdFilter?: InputMaybe<IdFilter>
  authorIdFilter?: InputMaybe<IdFilter>
  categoryNameFilter?: InputMaybe<StringFilter>
  authorNameFilter?: InputMaybe<StringFilter>
  resourceTypeFilter?: InputMaybe<ResourceTypeFilter>
  licensedFromSchoolIdFilter?: InputMaybe<IdFilter>
  roleFilter?: InputMaybe<RoleFilter>
  assignConfig?: InputMaybe<AssignConfig>
  search?: InputMaybe<Scalars["String"]["input"]>
  categorySearch?: InputMaybe<Scalars["String"]["input"]>
  authorSearch?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
}>

export type LibraryResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
        authors?: {
          __typename?: "AuthorConnection"
          edges: Array<{
            __typename?: "AuthorEdge"
            node: {
              __typename?: "Author"
              id: number
              order: number
              display_name: string
              full_name: string
              first_name: string
              last_name: string
              title?: string | null
              image?: string | null
              bio?: string | null
              avatar?: string | null
              salutation?: string | null
              slug: string
            }
          }>
        } | null
        groups?: { __typename?: "GroupConnection"; total: number } | null
        curriculum?: { __typename?: "Group"; id: number } | null
        license_offerings?: {
          __typename?: "LicenseOfferingConnection"
          edges: Array<{
            __typename?: "LicenseOfferingEdge"
            node: {
              __typename?: "LicenseOffering"
              id?: number | null
              cost_per_seat?: number | null
            }
          }>
        } | null
      }
    }>
  } | null
}

export type ResourceLicensesQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type ResourceLicensesQuery = {
  __typename?: "Query"
  resource_licenses?: {
    __typename?: "ResourceLicenseConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "ResourceLicenseEdge"
      node: {
        __typename?: "ResourceLicense"
        id?: number | null
        seat_count?: number | null
        seats_filled?: number | null
        expiration_dtime?: any | null
        group?: {
          __typename?: "Group"
          id: number
          name: string
          resource?: {
            __typename?: "Resource"
            id: number
            name: string
            image: string
          } | null
        } | null
      }
    }>
  } | null
}

export type UpdateLocalTranslationMutationVariables = Exact<{
  translation: Scalars["JSON"]["input"]
}>

export type UpdateLocalTranslationMutation = {
  __typename?: "Mutations"
  updateLocalTranslation?: any | null
}

export type TranslationQueryVariables = Exact<{
  language?: InputMaybe<Scalars["String"]["input"]>
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type TranslationQuery = {
  __typename?: "Query"
  translation?: {
    __typename?: "Translation"
    id: number
    name?: string | null
    language: string
    translation: any
    master_translation?: any | null
    is_default: boolean
  } | null
}

export type MediaContextQueryQueryVariables = Exact<{ [key: string]: never }>

export type MediaContextQueryQuery = {
  __typename?: "Query"
  mediaContext?: {
    __typename?: "MediaContext"
    accountID?: string | null
    mediaStoragePath?: string | null
    user?: { __typename?: "User"; id: number; is_superuser: boolean } | null
  } | null
}

export type MembershipFragment = {
  __typename?: "Membership"
  id: number
  created: any
  last_seen?: any | null
  last_active?: any | null
  has_access: boolean
  access_revoked_time?: any | null
  archived_time?: any | null
  role: number
  consent_dtime?: any | null
  consent_snapshot?: string | null
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    school_subscription?: {
      __typename?: "SchoolSubscription"
      id: number
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
      subscription: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      }
      subscription_plan: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      }
      school_subscription_plan: {
        __typename?: "SchoolSubscriptionPlan"
        id: number
        image?: string | null
        details_html?: string | null
        subscribe_complete_html?: string | null
        catalog_header?: string | null
        is_visible?: boolean | null
        giftable_cycles?: Array<number | null> | null
        subscription_plan: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        }
      }
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type MembershipMetaFragment = {
  __typename?: "MembershipMeta"
  editor?: number | null
  teacher?: number | null
  moderator?: number | null
  learner?: number | null
  observer?: number | null
  lead_mentor?: number | null
  mentor?: number | null
}

export type RemoveAccessForInactiveMembersMutationVariables = Exact<{
  daysInactive: Scalars["Int"]["input"]
}>

export type RemoveAccessForInactiveMembersMutation = {
  __typename?: "Mutations"
  removeAccessForInactiveMembers?: boolean | null
}

export type RequestPasswordResetMutationVariables = Exact<{
  user_id: Scalars["Int"]["input"]
}>

export type RequestPasswordResetMutation = {
  __typename?: "Mutations"
  requestPasswordReset?: boolean | null
}

export type SetMemberAccessMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  has_access: Scalars["Boolean"]["input"]
}>

export type SetMemberAccessMutation = {
  __typename?: "Mutations"
  setMemberAccess?: {
    __typename?: "Membership"
    id: number
    access_revoked_time?: any | null
    has_access: boolean
  } | null
}

export type SetMemberArchivedMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  is_archived: Scalars["Boolean"]["input"]
}>

export type SetMemberArchivedMutation = {
  __typename?: "Mutations"
  setMemberArchived?: {
    __typename?: "Membership"
    id: number
    archived_time?: any | null
    has_access: boolean
  } | null
}

export type SetMemberRoleMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  role: MembershipRole
}>

export type SetMemberRoleMutation = {
  __typename?: "Mutations"
  setMemberRole?: { __typename?: "Membership"; id: number; role: number } | null
}

export type TotalMembersWithFiltersQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<
    Array<InputMaybe<MembershipRoleFilter>> | InputMaybe<MembershipRoleFilter>
  >
  archived_date_filter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type TotalMembersWithFiltersQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    members?: { __typename?: "MembershipConnection"; total: number } | null
  } | null
}

export type BatchCreateMentorGroupMembershipMutationVariables = Exact<{
  user_ids?: InputMaybe<
    Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >
  group: Scalars["Int"]["input"]
  role: MentorGroupMembershipRole
}>

export type BatchCreateMentorGroupMembershipMutation = {
  __typename?: "Mutations"
  batchCreateMentorGroupMembership?: {
    __typename?: "BatchMentorGroupMembershipResult"
    success?: boolean | null
    group_memberships_created_count?: number | null
  } | null
}

export type CreateMentorGroupMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  parent?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<MentorGroupType>
}>

export type CreateMentorGroupMutation = {
  __typename?: "Mutations"
  createMentorGroup?: {
    __typename?: "MentorGroup"
    id: number
    type: number
    slug: string
    name: string
    description?: string | null
    created: any
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled: number
    seats_available?: number | null
    memberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  } | null
}

export type DeleteMentorGroupMembershipMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  group: Scalars["Int"]["input"]
}>

export type DeleteMentorGroupMembershipMutation = {
  __typename?: "Mutations"
  deleteMentorGroupMembership?: boolean | null
}

export type DeleteMentorGroupMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteMentorGroupMutation = {
  __typename?: "Mutations"
  deleteMentorGroup?: boolean | null
}

export type MentorGroupFragment = {
  __typename?: "MentorGroup"
  id: number
  type: number
  slug: string
  name: string
  description?: string | null
  created: any
  modified?: any | null
  parent_id?: number | null
  has_child_groups?: boolean | null
  seat_limit?: number | null
  seats_filled: number
  seats_available?: number | null
  owner?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  permissions?: {
    __typename?: "MentorGroupPermissions"
    can_add_member?: boolean | null
    can_add_moderator?: boolean | null
    can_add_admin?: boolean | null
    can_add_group?: boolean | null
    can_edit_group?: boolean | null
    can_change_parent?: boolean | null
    can_edit_subscription?: boolean | null
    can_delete_group?: boolean | null
    can_update_member_review_permission?: boolean | null
    can_update_moderator_review_permission?: boolean | null
    can_update_admin_review_permission?: boolean | null
  } | null
}

export type MentorGroupInvitationsQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type MentorGroupInvitationsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    mentor_group?: {
      __typename?: "MentorGroup"
      id: number
      invitations?: {
        __typename?: "InvitationConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "InvitationEdge"
          node: {
            __typename?: "Invitation"
            id: number
            created_dtime: any
            invitation_role: number
            invitation_type: InvitationType
            invitation_subject?: string | null
            invitation_status: InvitationStatus
            invitation_url: string
            invitation_message?: string | null
            invitation_accepted_dtime?: any | null
            invitation_hash?: string | null
            to_email: string
            to_first_name?: string | null
            to_last_name?: string | null
            invitation_email?: {
              __typename?: "EmailMessageData"
              id?: number | null
              created_dtime?: any | null
              delivery_status?: EmailDeliveryStatus | null
              delivery_status_updated?: any | null
            } | null
          }
        }>
      } | null
    } | null
  } | null
}

export type MentorGroupMembershipFragment = {
  __typename?: "MentorGroupMembership"
  id: number
  role: number
  created: any
  access_revoked_time?: any | null
  group_id: number
  send_mentor_digest?: boolean | null
  can_review: boolean
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type MentorGroupMembershipQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type MentorGroupMembershipQuery = {
  __typename?: "Query"
  mentorGroupMembership?: {
    __typename?: "MentorGroupMembership"
    id: number
    role: number
    created: any
    access_revoked_time?: any | null
    group_id: number
    send_mentor_digest?: boolean | null
    can_review: boolean
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type MentorGroupMembershipsQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
}>

export type MentorGroupMembershipsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    mentor_group?: {
      __typename?: "MentorGroup"
      id: number
      memberships?: {
        __typename?: "MentorGroupMembershipConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "MentorGroupMembershipEdge"
          node: {
            __typename?: "MentorGroupMembership"
            id: number
            role: number
            created: any
            access_revoked_time?: any | null
            group_id: number
            send_mentor_digest?: boolean | null
            can_review: boolean
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          }
        }>
      } | null
    } | null
  } | null
}

export type MentorGroupQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type MentorGroupQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    mentor_group?: {
      __typename?: "MentorGroup"
      id: number
      type: number
      slug: string
      name: string
      description?: string | null
      created: any
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled: number
      seats_available?: number | null
      user_membership?: {
        __typename?: "MentorGroupMembership"
        id: number
        role: number
        created: any
        access_revoked_time?: any | null
        group_id: number
        send_mentor_digest?: boolean | null
        can_review: boolean
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
      parent?: {
        __typename?: "MentorGroup"
        id: number
        type: number
        slug: string
        name: string
        description?: string | null
        created: any
        modified?: any | null
        parent_id?: number | null
        has_child_groups?: boolean | null
        seat_limit?: number | null
        seats_filled: number
        seats_available?: number | null
        owner?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        permissions?: {
          __typename?: "MentorGroupPermissions"
          can_add_member?: boolean | null
          can_add_moderator?: boolean | null
          can_add_admin?: boolean | null
          can_add_group?: boolean | null
          can_edit_group?: boolean | null
          can_change_parent?: boolean | null
          can_edit_subscription?: boolean | null
          can_delete_group?: boolean | null
          can_update_member_review_permission?: boolean | null
          can_update_moderator_review_permission?: boolean | null
          can_update_admin_review_permission?: boolean | null
        } | null
      } | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    } | null
  } | null
}

export type MentorGroupStaffMembershipsQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
}>

export type MentorGroupStaffMembershipsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    mentor_group?: {
      __typename?: "MentorGroup"
      id: number
      memberships?: {
        __typename?: "MentorGroupMembershipConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "MentorGroupMembershipEdge"
          node: {
            __typename?: "MentorGroupMembership"
            id: number
            role: number
            created: any
            access_revoked_time?: any | null
            group_id: number
            send_mentor_digest?: boolean | null
            can_review: boolean
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          }
        }>
      } | null
    } | null
  } | null
}

export type MentorGroupSubscriptionFragment = {
  __typename?: "MentorGroup"
  id: number
  type: number
  slug: string
  name: string
  description?: string | null
  created: any
  modified?: any | null
  parent_id?: number | null
  has_child_groups?: boolean | null
  seat_limit?: number | null
  seats_filled: number
  seats_available?: number | null
  memberships?: {
    __typename?: "MentorGroupMembershipConnection"
    total: number
    edges: Array<{
      __typename?: "MentorGroupMembershipEdge"
      node: {
        __typename?: "MentorGroupMembership"
        id: number
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      }
    }>
  } | null
  group_subscription?: {
    __typename?: "SchoolGroupSubscription"
    id: number
    price: {
      __typename?: "StripePrice"
      id: number
      active?: boolean | null
      billing_scheme?: StripeBillingScheme | null
      currency?: string | null
      nickname?: string | null
      recurring_interval?: StripeRecurringInterval | null
      recurring_interval_count?: number | null
      stripe_price_id?: string | null
      stripe_connected_account_url?: string | null
      tiers_mode?: StripeTiersMode | null
      unit_amount_decimal?: number | null
      product?: {
        __typename?: "StripeProduct"
        id: number
        min_quantity?: number | null
        max_quantity?: number | null
        active?: boolean | null
        name?: string | null
        description?: string | null
        images?: Array<string | null> | null
        unit_label?: string | null
        stripe_product_id?: string | null
        stripe_connected_account_url?: string | null
      } | null
      tiers?: Array<{
        __typename?: "StripeTier"
        up_to?: number | null
        flat_amount?: number | null
        flat_amount_decimal?: string | null
        unit_amount?: number | null
        unit_amount_decimal?: string | null
      } | null> | null
    }
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
    subscription: {
      __typename?: "Subscription"
      id: number
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    }
    community_group: {
      __typename?: "MentorGroup"
      id: number
      type: number
      slug: string
      name: string
      description?: string | null
      created: any
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled: number
      seats_available?: number | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    }
  } | null
  owner?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  permissions?: {
    __typename?: "MentorGroupPermissions"
    can_add_member?: boolean | null
    can_add_moderator?: boolean | null
    can_add_admin?: boolean | null
    can_add_group?: boolean | null
    can_edit_group?: boolean | null
    can_change_parent?: boolean | null
    can_edit_subscription?: boolean | null
    can_delete_group?: boolean | null
    can_update_member_review_permission?: boolean | null
    can_update_moderator_review_permission?: boolean | null
    can_update_admin_review_permission?: boolean | null
  } | null
}

export type MentorGroupSubscriptionQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
}>

export type MentorGroupSubscriptionQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    mentor_group?: {
      __typename?: "MentorGroup"
      id: number
      type: number
      slug: string
      name: string
      description?: string | null
      created: any
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled: number
      seats_available?: number | null
      memberships?: {
        __typename?: "MentorGroupMembershipConnection"
        total: number
        edges: Array<{
          __typename?: "MentorGroupMembershipEdge"
          node: {
            __typename?: "MentorGroupMembership"
            id: number
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          }
        }>
      } | null
      group_subscription?: {
        __typename?: "SchoolGroupSubscription"
        id: number
        price: {
          __typename?: "StripePrice"
          id: number
          active?: boolean | null
          billing_scheme?: StripeBillingScheme | null
          currency?: string | null
          nickname?: string | null
          recurring_interval?: StripeRecurringInterval | null
          recurring_interval_count?: number | null
          stripe_price_id?: string | null
          stripe_connected_account_url?: string | null
          tiers_mode?: StripeTiersMode | null
          unit_amount_decimal?: number | null
          product?: {
            __typename?: "StripeProduct"
            id: number
            min_quantity?: number | null
            max_quantity?: number | null
            active?: boolean | null
            name?: string | null
            description?: string | null
            images?: Array<string | null> | null
            unit_label?: string | null
            stripe_product_id?: string | null
            stripe_connected_account_url?: string | null
          } | null
          tiers?: Array<{
            __typename?: "StripeTier"
            up_to?: number | null
            flat_amount?: number | null
            flat_amount_decimal?: string | null
            unit_amount?: number | null
            unit_amount_decimal?: string | null
          } | null> | null
        }
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
        subscription: {
          __typename?: "Subscription"
          id: number
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id: number
            name: string
            amount?: number | null
            interval: number
            trial_period_days: number
            trial_type: SubscriptionTrialType
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        }
        community_group: {
          __typename?: "MentorGroup"
          id: number
          type: number
          slug: string
          name: string
          description?: string | null
          created: any
          modified?: any | null
          parent_id?: number | null
          has_child_groups?: boolean | null
          seat_limit?: number | null
          seats_filled: number
          seats_available?: number | null
          owner?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          permissions?: {
            __typename?: "MentorGroupPermissions"
            can_add_member?: boolean | null
            can_add_moderator?: boolean | null
            can_add_admin?: boolean | null
            can_add_group?: boolean | null
            can_edit_group?: boolean | null
            can_change_parent?: boolean | null
            can_edit_subscription?: boolean | null
            can_delete_group?: boolean | null
            can_update_member_review_permission?: boolean | null
            can_update_moderator_review_permission?: boolean | null
            can_update_admin_review_permission?: boolean | null
          } | null
        }
      } | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    } | null
  } | null
}

export type MentorGroupsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<IdFilter>
  topLevelOnly?: InputMaybe<Scalars["Boolean"]["input"]>
  parentId?: InputMaybe<IdFilter>
  descendentOfParentId?: InputMaybe<EquivalenceIdFilter>
  seatLimitFilter?: InputMaybe<IntFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type MentorGroupsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    mentor_groups?: {
      __typename?: "MentorGroupConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "MentorGroupEdge"
        node: {
          __typename?: "MentorGroup"
          id: number
          type: number
          slug: string
          name: string
          description?: string | null
          created: any
          modified?: any | null
          parent_id?: number | null
          has_child_groups?: boolean | null
          seat_limit?: number | null
          seats_filled: number
          seats_available?: number | null
          memberships?: {
            __typename?: "MentorGroupMembershipConnection"
            total: number
            edges: Array<{
              __typename?: "MentorGroupMembershipEdge"
              node: {
                __typename?: "MentorGroupMembership"
                id: number
                user: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                }
              }
            }>
          } | null
          owner?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          permissions?: {
            __typename?: "MentorGroupPermissions"
            can_add_member?: boolean | null
            can_add_moderator?: boolean | null
            can_add_admin?: boolean | null
            can_add_group?: boolean | null
            can_edit_group?: boolean | null
            can_change_parent?: boolean | null
            can_edit_subscription?: boolean | null
            can_delete_group?: boolean | null
            can_update_member_review_permission?: boolean | null
            can_update_moderator_review_permission?: boolean | null
            can_update_admin_review_permission?: boolean | null
          } | null
        }
      }>
    } | null
  } | null
}

export type UpdateMentorGroupMembershipMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  group: Scalars["Int"]["input"]
  role?: InputMaybe<MentorGroupMembershipRole>
  canReview?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  sendMentorDigest?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateMentorGroupMembershipMutation = {
  __typename?: "Mutations"
  updateMentorGroupMembership?: {
    __typename?: "MentorGroupMembership"
    id: number
    role: number
    created: any
    access_revoked_time?: any | null
    group_id: number
    send_mentor_digest?: boolean | null
    can_review: boolean
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type UpdateMentorGroupMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  parent?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<MentorGroupType>
}>

export type UpdateMentorGroupMutation = {
  __typename?: "Mutations"
  updateMentorGroup?: {
    __typename?: "MentorGroup"
    id: number
    type: number
    slug: string
    name: string
    description?: string | null
    created: any
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled: number
    seats_available?: number | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  } | null
}

export type MentorGroupsStatsQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type MentorGroupsStatsQueryQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    mentor_group_stats?: {
      __typename?: "MentorGroupStats"
      community?: number | null
      personal?: number | null
    } | null
  } | null
}

export type CreateNoteMutationVariables = Exact<{
  context: ContextModelInput
  note: NoteInput
}>

export type CreateNoteMutation = {
  __typename?: "Mutations"
  createNote?: {
    __typename?: "Note"
    id: number
    title: string
    body: string
    visibility: NoteVisibility
    created_time: any
    modified_time: any
    context_id: number
    resource_id?: number | null
    cohort_id?: number | null
    created_from_cohort_id?: number | null
    step_id?: number | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type DeleteNoteMutationVariables = Exact<{
  context: ContextModelInput
  id: Scalars["Int"]["input"]
}>

export type DeleteNoteMutation = {
  __typename?: "Mutations"
  deleteNote?: boolean | null
}

export type NoteFragment = {
  __typename?: "Note"
  id: number
  title: string
  body: string
  visibility: NoteVisibility
  created_time: any
  modified_time: any
  context_id: number
  resource_id?: number | null
  cohort_id?: number | null
  created_from_cohort_id?: number | null
  step_id?: number | null
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type NotePermissionsQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type NotePermissionsQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    is_source_cohort?: boolean | null
    status: GroupStatus
    resource_license?: {
      __typename?: "ResourceLicense"
      id?: number | null
    } | null
    source?: {
      __typename?: "Group"
      id: number
      is_source_cohort?: boolean | null
      status: GroupStatus
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        softArchivedTime?: any | null
      } | null
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      softArchivedTime?: any | null
    } | null
  } | null
}

export type NotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
  context: ContextModelInput
  visibility?: InputMaybe<NoteVisibility>
}>

export type NotesQuery = {
  __typename?: "Query"
  notes?: {
    __typename?: "NoteConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "NoteEdge"
      node: {
        __typename?: "Note"
        id: number
        title: string
        body: string
        visibility: NoteVisibility
        created_time: any
        modified_time: any
        context_id: number
        resource_id?: number | null
        cohort_id?: number | null
        created_from_cohort_id?: number | null
        step_id?: number | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      }
    }>
  } | null
}

export type UpdateNoteMutationVariables = Exact<{
  context: ContextModelInput
  id: Scalars["Int"]["input"]
  note: NoteInput
}>

export type UpdateNoteMutation = {
  __typename?: "Mutations"
  updateNote?: {
    __typename?: "Note"
    id: number
    title: string
    body: string
    visibility: NoteVisibility
    created_time: any
    modified_time: any
    context_id: number
    resource_id?: number | null
    cohort_id?: number | null
    created_from_cohort_id?: number | null
    step_id?: number | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type CreateNotificationMutationVariables = Exact<{
  input: NotificationInput
}>

export type CreateNotificationMutation = {
  __typename?: "Mutations"
  createNotification: boolean
}

export type UpdateNotificationDigestIntervalMutationVariables = Exact<{
  interval?: InputMaybe<NotificationDigestInterval>
}>

export type UpdateNotificationDigestIntervalMutation = {
  __typename?: "Mutations"
  updateNotificationDigestInterval?: {
    __typename?: "Profile"
    id?: number | null
    notification_digest_interval?: NotificationDigestInterval | null
  } | null
}

export type CouponExistsQueryVariables = Exact<{
  input?: InputMaybe<CouponExistsInput>
}>

export type CouponExistsQuery = {
  __typename?: "Query"
  couponExists?: boolean | null
}

export type CreateCurriculumLicenseOrderMutationVariables = Exact<{
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licensor_school_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RegistrationRoleEnum>
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateCurriculumLicenseOrderMutation = {
  __typename?: "Mutations"
  createCurriculumLicenseOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreateCurriculumSubscriptionOrderMutationVariables = Exact<{
  curriculum_plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  licensee_id: Scalars["Int"]["input"]
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateCurriculumSubscriptionOrderMutation = {
  __typename?: "Mutations"
  createCurriculumSubscriptionOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreateGiftSubscriptionOrderMutationVariables = Exact<{
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  num_cycles: Scalars["Int"]["input"]
  recipient_first_name: Scalars["String"]["input"]
  recipient_last_name: Scalars["String"]["input"]
  gift_message?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateGiftSubscriptionOrderMutation = {
  __typename?: "Mutations"
  createGiftSubscriptionOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreateGroupLicenseOrderMutationVariables = Exact<{
  license_offering_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RegistrationRoleEnum>
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateGroupLicenseOrderMutation = {
  __typename?: "Mutations"
  createGroupLicenseOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreateGroupSubscriptionOrderMutationVariables = Exact<{
  price_id: Scalars["Int"]["input"]
  quantity: Scalars["Int"]["input"]
  group_name: Scalars["String"]["input"]
  reactivate_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateGroupSubscriptionOrderMutation = {
  __typename?: "Mutations"
  createGroupSubscriptionOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreateLifetimeSchoolSubscriptionOrderMutationVariables = Exact<{
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateLifetimeSchoolSubscriptionOrderMutation = {
  __typename?: "Mutations"
  createLifetimeSchoolSubscriptionOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreatePlatformSubscriptionOrderMutationVariables = Exact<{
  billing_plan_id: Scalars["Int"]["input"]
  interval: Scalars["Int"]["input"]
  schoolId?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreatePlatformSubscriptionOrderMutation = {
  __typename?: "Mutations"
  createPlatformSubscriptionOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreateRegistrationOrderMutationVariables = Exact<{
  offering_id: Scalars["Int"]["input"]
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  invitation_code?: InputMaybe<Scalars["String"]["input"]>
  use_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateRegistrationOrderMutation = {
  __typename?: "Mutations"
  createRegistrationOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type CreateSchoolSubscriptionOrderMutationVariables = Exact<{
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  start_free_trial?: InputMaybe<Scalars["Boolean"]["input"]>
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  stripe_checkout_redirects?: InputMaybe<OrderStripeCheckoutRedirects>
}>

export type CreateSchoolSubscriptionOrderMutation = {
  __typename?: "Mutations"
  createSchoolSubscriptionOrder?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type OrderFragment = {
  __typename?: "Order"
  id: number
  order_type: OrderType
  order_status: OrderStatus
  order_data?: any | null
  checkout_session_id?: string | null
  stripe_publishable_api_key?: string | null
  fulfilled_object_id?: number | null
  school_id: number
  processor_id?: number | null
  user_id: number
}

export type OrderQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type OrderQuery = {
  __typename?: "Query"
  order?: {
    __typename?: "Order"
    id: number
    order_type: OrderType
    order_status: OrderStatus
    order_data?: any | null
    checkout_session_id?: string | null
    stripe_publishable_api_key?: string | null
    fulfilled_object_id?: number | null
    school_id: number
    processor_id?: number | null
    user_id: number
  } | null
}

export type PackageAssignmentQueryVariables = Exact<{ [key: string]: never }>

export type PackageAssignmentQuery = {
  __typename?: "Query"
  packageAssignment?: {
    __typename?: "PackageAssignment"
    id?: number | null
    school_id?: number | null
    school_signup_config_id?: number | null
    selected_by_user?: number | null
    rewardful_referral_id?: string | null
    utm_source?: string | null
    utm_medium?: string | null
    utm_campaign?: string | null
    assignment_rule?: {
      __typename?: "PackageAssignmentRule"
      id?: number | null
      assignment_type?: string | null
      explicit_key?: string | null
      store_id?: number | null
      rewardful_referral_id?: string | null
      utm_source?: string | null
      utm_medium?: string | null
      utm_campaign?: string | null
    } | null
    package?: {
      __typename?: "Package"
      id?: number | null
      school_id?: number | null
      key?: string | null
      name?: string | null
      display_name?: string | null
      public_description?: string | null
      pathicon?: string | null
      color?: string | null
      image?: string | null
      is_active?: boolean | null
      priority?: number | null
      default_school_type?: string | null
      default_school_theme?: any | null
      billing_plan_set_id?: number | null
      default_billing_plan_id?: number | null
      coupon_id?: number | null
      coupon_discount?: number | null
      trial_behavior?: string | null
      trial_days_override?: number | null
      partner_school_id?: number | null
      metadata?: any | null
    } | null
  } | null
}

export type PackageFragment = {
  __typename?: "Package"
  id?: number | null
  school_id?: number | null
  key?: string | null
  name?: string | null
  display_name?: string | null
  public_description?: string | null
  pathicon?: string | null
  color?: string | null
  image?: string | null
  is_active?: boolean | null
  priority?: number | null
  default_school_type?: string | null
  default_school_theme?: any | null
  billing_plan_set_id?: number | null
  default_billing_plan_id?: number | null
  coupon_id?: number | null
  coupon_discount?: number | null
  trial_behavior?: string | null
  trial_days_override?: number | null
  partner_school_id?: number | null
  metadata?: any | null
}

export type PackageQueryVariables = Exact<{
  signup_config_key?: InputMaybe<Scalars["String"]["input"]>
  utm_source?: InputMaybe<Scalars["String"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_campaign?: InputMaybe<Scalars["String"]["input"]>
  rewardful_referral_id?: InputMaybe<Scalars["String"]["input"]>
}>

export type PackageQuery = {
  __typename?: "Query"
  package?: {
    __typename?: "Package"
    id?: number | null
    school_id?: number | null
    key?: string | null
    name?: string | null
    display_name?: string | null
    public_description?: string | null
    pathicon?: string | null
    color?: string | null
    image?: string | null
    is_active?: boolean | null
    priority?: number | null
    default_school_type?: string | null
    default_school_theme?: any | null
    billing_plan_set_id?: number | null
    default_billing_plan_id?: number | null
    coupon_id?: number | null
    coupon_discount?: number | null
    trial_behavior?: string | null
    trial_days_override?: number | null
    partner_school_id?: number | null
    metadata?: any | null
  } | null
}

export type PackagesForAdminQueryVariables = Exact<{ [key: string]: never }>

export type PackagesForAdminQuery = {
  __typename?: "Query"
  packages?: Array<{
    __typename?: "Package"
    id?: number | null
    key?: string | null
    name?: string | null
    display_name?: string | null
    assignment_rules?: Array<{
      __typename?: "PackageAssignmentRule"
      id?: number | null
      assignment_type?: string | null
      explicit_key?: string | null
      store_id?: number | null
      rewardful_referral_id?: string | null
      utm_source?: string | null
      utm_medium?: string | null
      utm_campaign?: string | null
    } | null> | null
  } | null> | null
}

export type LicensorFragment = {
  __typename?: "School"
  id: number
  url: string
  name: string
  about?: string | null
  email?: string | null
  website?: string | null
  subdomain: string
  created?: any | null
  billing_model?: number | null
  platform_version?: number | null
  currency_code?: string | null
  ietf_language_tag?: string | null
  has_certificate?: boolean | null
  is_activated?: boolean | null
  is_curriculum_enabled?: boolean | null
  is_curriculum_subscriber?: boolean | null
  stripe_access_token?: string | null
  stripe_publishable_api_key?: string | null
  show_stripe_reconnect?: boolean | null
  payment_requires_zip_code?: boolean | null
  consent_description?: string | null
  image?: string | null
  image_is_default: boolean
  grant_access_upon_authentication?: boolean | null
  pathwright_login_enabled?: boolean | null
  resource_licensing_enabled?: boolean | null
  theme?: {
    __typename?: "Theme"
    id?: number | null
    name?: string | null
    theme_type?: ThemeType | null
    background_image?: string | null
    background_overlay?: string | null
    background_type?: number | null
    heading_font?: string | null
    primary_color?: string | null
    typekit_id?: string | null
    custom_css?: string | null
    processed_custom_css?: string | null
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
      _950?: string | null
    } | null
  } | null
}

export type LicensorsQueryVariables = Exact<{ [key: string]: never }>

export type LicensorsQuery = {
  __typename?: "Query"
  storeLinks?: {
    __typename?: "StoreLinkConnection"
    edges: Array<{
      __typename?: "StoreLinkEdge"
      node: {
        __typename?: "StoreLink"
        id: number
        store: {
          __typename?: "Store"
          id: number
          licensor: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
            theme?: {
              __typename?: "Theme"
              id?: number | null
              name?: string | null
              theme_type?: ThemeType | null
              background_image?: string | null
              background_overlay?: string | null
              background_type?: number | null
              heading_font?: string | null
              primary_color?: string | null
              typekit_id?: string | null
              custom_css?: string | null
              processed_custom_css?: string | null
              color_palette?: {
                __typename?: "NodeThemeColorPalette"
                _50?: string | null
                _100?: string | null
                _200?: string | null
                _300?: string | null
                _400?: string | null
                _500?: string | null
                _600?: string | null
                _700?: string | null
                _800?: string | null
                _900?: string | null
                _950?: string | null
              } | null
            } | null
          }
        }
        licensee: {
          __typename?: "School"
          id: number
          url: string
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          image_is_default: boolean
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
          resource_licensing_enabled?: boolean | null
        }
      }
    }>
  } | null
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    curriculum_subscriptions?: {
      __typename?: "CurriculumSubscriptionConnection"
      edges: Array<{
        __typename?: "CurriculumSubscriptionEdge"
        node: {
          __typename?: "CurriculumSubscription"
          id: number
          licensor: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
            theme?: {
              __typename?: "Theme"
              id?: number | null
              name?: string | null
              theme_type?: ThemeType | null
              background_image?: string | null
              background_overlay?: string | null
              background_type?: number | null
              heading_font?: string | null
              primary_color?: string | null
              typekit_id?: string | null
              custom_css?: string | null
              processed_custom_css?: string | null
              color_palette?: {
                __typename?: "NodeThemeColorPalette"
                _50?: string | null
                _100?: string | null
                _200?: string | null
                _300?: string | null
                _400?: string | null
                _500?: string | null
                _600?: string | null
                _700?: string | null
                _800?: string | null
                _900?: string | null
                _950?: string | null
              } | null
            } | null
          }
          licensee: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
          }
          curriculum_plan?: {
            __typename?: "SchoolCurriculumPlan"
            id: number
            name?: string | null
            amount?: number | null
            fee_boundary?: number | null
            fee_per_user?: number | null
            is_visible?: boolean | null
            lower_boundary?: number | null
            plan_id?: number | null
            transaction_fee_percent?: number | null
            upper_boundary?: number | null
            visibility_code?: string | null
          } | null
          subscription?: {
            __typename?: "Subscription"
            id: number
            quantity?: number | null
            canceled_dtime?: any | null
            cancellation_reason?: number | null
            card_last_4?: string | null
            cycle_end_dtime?: any | null
            cycle_start_dtime?: any | null
            is_canceled_at_cycle_end?: boolean | null
            is_delinquent?: boolean | null
            paused_until_dtime?: any | null
            trial_type?: number | null
            trial_end_dtime?: any | null
            payment_intent_needing_action_id?: string | null
            subscription_plan?: {
              __typename?: "SubscriptionPlan"
              id: number
              name: string
              amount?: number | null
              interval: number
              trial_period_days: number
              trial_type: SubscriptionTrialType
              plan_type?: string | null
              stripe_connected_account_url?: string | null
            } | null
            customer?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
          } | null
        }
      }>
    } | null
  } | null
}

export type PathCreatorCohortFragment = {
  __typename?: "Group"
  id: number
  name: string
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges: Array<{
      __typename?: "RegistrationEdge"
      node: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      }
    }>
  } | null
}

export type PathCreatorCreatePathFragment = {
  __typename?: "Resource"
  id: number
  name: string
  background_image?: string | null
  image: string
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
  source_cohort?: {
    __typename?: "Group"
    id: number
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  } | null
}

export type PathCreatorResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  background_image?: string | null
  image: string
  source_cohort?: {
    __typename?: "Group"
    id: number
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  } | null
}

export type PathCreatorAssignRoleMutationVariables = Exact<{
  cohorts:
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  user: Scalars["Int"]["input"]
  role: RegistrationRoleEnum
  sendNotification?: InputMaybe<Scalars["Boolean"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
}>

export type PathCreatorAssignRoleMutation = {
  __typename?: "Mutations"
  assign?: any | null
}

export type PathCreatorCohortsQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  targetUserId: Scalars["Int"]["input"]
}>

export type PathCreatorCohortsQuery = {
  __typename?: "Query"
  cohorts?: {
    __typename?: "GroupConnection"
    edges: Array<{
      __typename?: "GroupEdge"
      node: {
        __typename?: "Group"
        id: number
        name: string
        user_registration?: {
          __typename?: "Registration"
          id: number
          role: number
        } | null
        registrations?: {
          __typename?: "RegistrationConnection"
          total: number
          edges: Array<{
            __typename?: "RegistrationEdge"
            node: {
              __typename?: "Registration"
              id: number
              user: {
                __typename?: "User"
                id: number
                first_name: string
                last_name: string
                full_name: string
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  image?: string | null
                } | null
              }
            }
          }>
        } | null
      }
    }>
  } | null
}

export type PathCreatorCohortWithRegistrationFragment = {
  __typename?: "Group"
  id: number
  name: string
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges: Array<{
      __typename?: "RegistrationEdge"
      node: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      }
    }>
  } | null
}

export type PathCreatorCreateCohortMutationVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}>

export type PathCreatorCreateCohortMutation = {
  __typename?: "Mutations"
  createCohort?: {
    __typename?: "Group"
    id: number
    name: string
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type PathCreatorCreatePathMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  image: Scalars["String"]["input"]
  resourceType?: InputMaybe<ResourceType>
  cohortName?: InputMaybe<Scalars["String"]["input"]>
}>

export type PathCreatorCreatePathMutation = {
  __typename?: "Mutations"
  createResource?: {
    __typename?: "Resource"
    id: number
    name: string
    background_image?: string | null
    image: string
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      registrations?: {
        __typename?: "RegistrationConnection"
        total: number
        edges: Array<{
          __typename?: "RegistrationEdge"
          node: {
            __typename?: "Registration"
            id: number
            user: {
              __typename?: "User"
              id: number
              first_name: string
              last_name: string
              full_name: string
              profile?: {
                __typename?: "Profile"
                id?: number | null
                image?: string | null
              } | null
            }
          }
        }>
      } | null
    } | null
    source_cohort?: {
      __typename?: "Group"
      id: number
      registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
    } | null
  } | null
}

export type PathCreatorRandomResourceImageQueryVariables = Exact<{
  themeType?: InputMaybe<ThemeType>
}>

export type PathCreatorRandomResourceImageQuery = {
  __typename?: "Query"
  resourceImage: Array<any | null>
}

export type PathCreatorResourcesQueryVariables = Exact<{ [key: string]: never }>

export type PathCreatorResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    edges: Array<{
      __typename?: "ResourceEdge"
      node: {
        __typename?: "Resource"
        id: number
        name: string
        background_image?: string | null
        image: string
        source_cohort?: {
          __typename?: "Group"
          id: number
          registration?: {
            __typename?: "Registration"
            id: number
            role: number
          } | null
        } | null
      }
    }>
  } | null
}

export type AddedPathItemFragment = {
  __typename?: "PathItem"
  id: number
  order: number
  verb?: string | null
  name: string
  type: PathItemType
  path_id: number
  source_id: number
  parent_id?: number | null
  parent_source_id?: number | null
  description?: string | null
  curriculum_sync_opt_out_dtime?: any | null
  assignment_type?: PathItemAssignmentType | null
  content_id?: number | null
  content_type?: string | null
  item_content_type_id?: number | null
  is_required?: boolean | null
  is_previewable?: boolean | null
  due?: any | null
  passive_due?: boolean | null
  starts?: any | null
  passive_starts?: boolean | null
  has_started?: boolean | null
  points?: number | null
  item_needs_grading?: boolean | null
  minimum_passing_score?: number | null
  grading_type?: string | null
  time_to_complete?: number | null
  lock_password?: string | null
  is_locked?: boolean | null
  lock_unlocked_time?: any | null
  allow_resets?: number | null
  show_grading_feedback?: number | null
  completion_comment_required_status?: string | null
  last_published_dtime?: any | null
  copied_from_id?: number | null
  archived_time?: any | null
  progress: number
  items?: {
    __typename?: "PathItemConnection"
    edges: Array<{
      __typename?: "PathItemEdge"
      node: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        copied_from_id?: number | null
        archived_time?: any | null
        progress: number
        context?: {
          __typename?: "StepContext"
          school_id?: number | null
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id: number
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      }
    }>
  } | null
  context?: {
    __typename?: "StepContext"
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null
  blocks?: {
    __typename?: "BlocksContent"
    content_last_modified?: any | null
    last_published?: any | null
  } | null
  permissions?: {
    __typename?: "PathItemPermissions"
    can_complete?: boolean | null
    can_discuss?: boolean | null
    can_edit?: boolean | null
    can_edit_content?: boolean | null
    can_note?: boolean | null
    can_view?: boolean | null
    can_review?: boolean | null
    can_view_content?: boolean | null
  } | null
  completion: {
    __typename?: "Completion"
    id: number
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  }
  linked_resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
  } | null
  linked_cohort?: {
    __typename?: "Group"
    id: number
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
  linked_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    path?: { __typename?: "Path"; id: number } | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type CohortSyncPathQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type CohortSyncPathQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    is_master?: boolean | null
    visibility?: number | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    path: { __typename?: "Path"; id: number }
    source?: {
      __typename?: "Group"
      id: number
      name: string
      is_master?: boolean | null
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
      path: { __typename?: "Path"; id: number }
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      slug: string
      background_overlay?: string | null
      background_image?: string | null
      description?: string | null
      short_description?: string | null
      name: string
      licensing_enabled?: boolean | null
      resource_type: number
      blurred_background?: string | null
      cohorts?: {
        __typename?: "GroupConnection"
        total: number
        edges: Array<{
          __typename?: "GroupEdge"
          node: {
            __typename?: "Group"
            id: number
            name: string
            is_master?: boolean | null
            path: { __typename?: "Path"; id: number }
          }
        }>
      } | null
      license_offerings?: {
        __typename?: "LicenseOfferingConnection"
        total: number
      } | null
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: { __typename?: "Registration"; id: number; role: number }
      }>
    } | null
  } | null
}

export type CohortSyncPathCohortFragment = {
  __typename?: "Group"
  id: number
  name: string
  is_master?: boolean | null
  visibility?: number | null
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
  path: { __typename?: "Path"; id: number }
  source?: {
    __typename?: "Group"
    id: number
    name: string
    is_master?: boolean | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    path: { __typename?: "Path"; id: number }
  } | null
  resource?: {
    __typename?: "Resource"
    id: number
    slug: string
    background_overlay?: string | null
    background_image?: string | null
    description?: string | null
    short_description?: string | null
    name: string
    licensing_enabled?: boolean | null
    resource_type: number
    blurred_background?: string | null
    cohorts?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: {
          __typename?: "Group"
          id: number
          name: string
          is_master?: boolean | null
          path: { __typename?: "Path"; id: number }
        }
      }>
    } | null
    license_offerings?: {
      __typename?: "LicenseOfferingConnection"
      total: number
    } | null
  } | null
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges: Array<{
      __typename?: "RegistrationEdge"
      node: { __typename?: "Registration"; id: number; role: number }
    }>
  } | null
}

export type CompletePathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  skip?: InputMaybe<Scalars["Boolean"]["input"]>
  completion_data?: InputMaybe<Scalars["JSON"]["input"]>
}>

export type CompletePathItemMutation = {
  __typename?: "Mutations"
  completePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      next_step_id?: number | null
      completion_date?: any | null
      points?: {
        __typename?: "Points"
        path_id?: number | null
        total?: number | null
        earned?: number | null
        total_points_possible?: number | null
        percentage?: number | null
        has_points?: boolean | null
      } | null
    } | null
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type CreatePathItemMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  type: PathItemType
  assignment_type?: InputMaybe<PathItemAssignmentType>
  parent?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  content_type?: InputMaybe<Scalars["String"]["input"]>
  content_resource?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CreatePathItemMutation = {
  __typename?: "Mutations"
  createPathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    items?: {
      __typename?: "PathItemConnection"
      edges: Array<{
        __typename?: "PathItemEdge"
        node: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          copied_from_id?: number | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            school_id?: number | null
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id: number
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        }
      }>
    } | null
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type CreateRegistrationUpsertGroupMutationVariables = Exact<{
  resource_id: Scalars["Int"]["input"]
  parent_offering_id: Scalars["Int"]["input"]
  step_source_id: Scalars["Int"]["input"]
  createrRegistration?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CreateRegistrationUpsertGroupMutation = {
  __typename?: "Mutations"
  createRegistrationUpsertGroup?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type DeletePathItemMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
}>

export type DeletePathItemMutation = {
  __typename?: "Mutations"
  deletePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type ExecuteSyncPlanMutationVariables = Exact<{
  sync_plan: PathSyncPlanInput
}>

export type ExecuteSyncPlanMutation = {
  __typename?: "Mutations"
  executePathSyncPlan?: boolean | null
}

export type PastePathItemMutationVariables = Exact<{
  pathId: Scalars["Int"]["input"]
  itemId: Scalars["Int"]["input"]
  parentId?: InputMaybe<Scalars["Int"]["input"]>
  order: Scalars["Int"]["input"]
}>

export type PastePathItemMutation = {
  __typename?: "Mutations"
  pastePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    items?: {
      __typename?: "PathItemConnection"
      edges: Array<{
        __typename?: "PathItemEdge"
        node: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          copied_from_id?: number | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            school_id?: number | null
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id: number
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        }
      }>
    } | null
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type PathFragment = {
  __typename?: "Path"
  id: number
  progress?: number | null
  next_step_id?: number | null
  completion_date?: any | null
  created_date?: any | null
  is_source_path: boolean
  points?: {
    __typename?: "Points"
    path_id?: number | null
    total?: number | null
    earned?: number | null
    total_points_possible?: number | null
    percentage?: number | null
    has_points?: boolean | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type PathSyncFragment = {
  __typename?: "PathSync"
  path_id: number
  synced: boolean
  last_synced_date?: any | null
  sync_source_path_id?: number | null
  user_id?: number | null
}

export type PathPublishFragment = {
  __typename?: "PathPublish"
  path_id: number
  published: boolean
  last_published_date?: any | null
}

export type PathSyncPublishFragment = {
  __typename?: "Path"
  id: number
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type PathItemContextFragment = {
  __typename?: "StepContext"
  school_id?: number | null
  resource_id?: number | null
  cohort_id?: number | null
}

export type PathItemFragment = {
  __typename?: "PathItem"
  id: number
  order: number
  verb?: string | null
  name: string
  type: PathItemType
  path_id: number
  source_id: number
  parent_id?: number | null
  parent_source_id?: number | null
  description?: string | null
  curriculum_sync_opt_out_dtime?: any | null
  assignment_type?: PathItemAssignmentType | null
  content_id?: number | null
  content_type?: string | null
  item_content_type_id?: number | null
  is_required?: boolean | null
  is_previewable?: boolean | null
  due?: any | null
  passive_due?: boolean | null
  starts?: any | null
  passive_starts?: boolean | null
  has_started?: boolean | null
  points?: number | null
  item_needs_grading?: boolean | null
  minimum_passing_score?: number | null
  grading_type?: string | null
  time_to_complete?: number | null
  lock_password?: string | null
  is_locked?: boolean | null
  lock_unlocked_time?: any | null
  allow_resets?: number | null
  show_grading_feedback?: number | null
  completion_comment_required_status?: string | null
  last_published_dtime?: any | null
  copied_from_id?: number | null
  archived_time?: any | null
  progress: number
  context?: {
    __typename?: "StepContext"
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null
  blocks?: {
    __typename?: "BlocksContent"
    content_last_modified?: any | null
    last_published?: any | null
  } | null
  permissions?: {
    __typename?: "PathItemPermissions"
    can_complete?: boolean | null
    can_discuss?: boolean | null
    can_edit?: boolean | null
    can_edit_content?: boolean | null
    can_note?: boolean | null
    can_view?: boolean | null
    can_review?: boolean | null
    can_view_content?: boolean | null
  } | null
  completion: {
    __typename?: "Completion"
    id: number
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  }
  linked_resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
  } | null
  linked_cohort?: {
    __typename?: "Group"
    id: number
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
  linked_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    path?: { __typename?: "Path"; id: number } | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type PathItemLinkedResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  cover_image: string
  curriculum_group?: { __typename?: "Group"; id: number } | null
}

export type PathItemQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
}>

export type PathItemQuery = {
  __typename?: "Query"
  pathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type PathItemsFragment = {
  __typename?: "Path"
  id: number
  progress?: number | null
  next_step_id?: number | null
  completion_date?: any | null
  created_date?: any | null
  is_source_path: boolean
  items?: {
    __typename?: "PathItemConnection"
    edges: Array<{
      __typename?: "PathItemEdge"
      node: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        copied_from_id?: number | null
        archived_time?: any | null
        progress: number
        context?: {
          __typename?: "StepContext"
          school_id?: number | null
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id: number
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      }
    }>
  } | null
  points?: {
    __typename?: "Points"
    path_id?: number | null
    total?: number | null
    earned?: number | null
    total_points_possible?: number | null
    percentage?: number | null
    has_points?: boolean | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type PathItemsQueryVariables = Exact<{
  pathId?: InputMaybe<Scalars["Int"]["input"]>
  cohortId?: InputMaybe<Scalars["Int"]["input"]>
  sourceId?: InputMaybe<Scalars["Int"]["input"]>
  lessonSourceId?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type PathItemsQuery = {
  __typename?: "Query"
  pathItems?: {
    __typename?: "PathItemConnection"
    edges: Array<{
      __typename?: "PathItemEdge"
      node: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        copied_from_id?: number | null
        archived_time?: any | null
        progress: number
        context?: {
          __typename?: "StepContext"
          school_id?: number | null
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id: number
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      }
    }>
  } | null
}

export type PathPerformanceFragment = {
  __typename?: "PathPerformance"
  id?: number | null
  points?: {
    __typename?: "PathPerformancePoints"
    total?: number | null
    earned?: number | null
    possible?: number | null
    percentage?: number | null
    applicable_score?: any | null
    applicable_score_percentage?: number | null
  } | null
  progress?: {
    __typename?: "PathPerformanceProgress"
    steps_completed?: number | null
    required_steps_completed?: number | null
    total_steps?: number | null
    total_required_steps?: number | null
    percentage?: number | null
  } | null
}

export type PathPerformanceQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type PathPerformanceQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    performance?: {
      __typename?: "PathPerformance"
      id?: number | null
      points?: {
        __typename?: "PathPerformancePoints"
        total?: number | null
        earned?: number | null
        possible?: number | null
        percentage?: number | null
        applicable_score?: any | null
        applicable_score_percentage?: number | null
      } | null
      progress?: {
        __typename?: "PathPerformanceProgress"
        steps_completed?: number | null
        required_steps_completed?: number | null
        total_steps?: number | null
        total_required_steps?: number | null
        percentage?: number | null
      } | null
    } | null
  } | null
}

export type PathPublishQueryVariables = Exact<{
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type PathPublishQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type PathQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
}>

export type PathQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    next_step_id?: number | null
    completion_date?: any | null
    created_date?: any | null
    is_source_path: boolean
    items?: {
      __typename?: "PathItemConnection"
      edges: Array<{
        __typename?: "PathItemEdge"
        node: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          copied_from_id?: number | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            school_id?: number | null
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id: number
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        }
      }>
    } | null
    schedule?: {
      __typename?: "PathNodeSchedule"
      start?: {
        __typename?: "ScheduleDate"
        behavior: ScheduleDateBehavior
        date?: any | null
      } | null
      end?: {
        __typename?: "ScheduleDate"
        behavior: ScheduleDateBehavior
        date?: any | null
      } | null
    } | null
    points?: {
      __typename?: "Points"
      path_id?: number | null
      total?: number | null
      earned?: number | null
      total_points_possible?: number | null
      percentage?: number | null
      has_points?: boolean | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    sync?: {
      __typename?: "PathSync"
      path_id: number
      synced: boolean
      last_synced_date?: any | null
      sync_source_path_id?: number | null
      user_id?: number | null
    } | null
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type SyncPathMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SyncPathMutation = {
  __typename?: "Mutations"
  syncPath?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    next_step_id?: number | null
    completion_date?: any | null
    created_date?: any | null
    is_source_path: boolean
    items?: {
      __typename?: "PathItemConnection"
      edges: Array<{
        __typename?: "PathItemEdge"
        node: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          copied_from_id?: number | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            school_id?: number | null
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id: number
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        }
      }>
    } | null
    points?: {
      __typename?: "Points"
      path_id?: number | null
      total?: number | null
      earned?: number | null
      total_points_possible?: number | null
      percentage?: number | null
      has_points?: boolean | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    sync?: {
      __typename?: "PathSync"
      path_id: number
      synced: boolean
      last_synced_date?: any | null
      sync_source_path_id?: number | null
      user_id?: number | null
    } | null
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type PathSyncPlanChangeFragment = {
  __typename?: "PathSyncPlanChange"
  item_source_id: number
  parent_source_id?: number | null
  item_name: string
  parent_name?: string | null
  item_type: PathItemType
  assignment_type?: PathItemAssignmentType | null
  forced?: PathSyncPlanForceType | null
  forced_reasons?: Array<PathSyncPlanForceReasonType | null> | null
  change_details?: any | null
  last_changed?: any | null
}

export type PathSyncPlanQueryVariables = Exact<{
  sync_plan: PathSyncPlanInput
}>

export type PathSyncPlanQuery = {
  __typename?: "Query"
  pathSyncPlan?: {
    __typename?: "PathSyncPlan"
    from_path_id?: number | null
    to_path_id?: number | null
    hash: string
    included_changes: Array<{
      __typename?: "PathSyncPlanChange"
      item_source_id: number
      parent_source_id?: number | null
      item_name: string
      parent_name?: string | null
      item_type: PathItemType
      assignment_type?: PathItemAssignmentType | null
      forced?: PathSyncPlanForceType | null
      forced_reasons?: Array<PathSyncPlanForceReasonType | null> | null
      change_details?: any | null
      last_changed?: any | null
    } | null>
    excluded_changes: Array<{
      __typename?: "PathSyncPlanChange"
      item_source_id: number
      parent_source_id?: number | null
      item_name: string
      parent_name?: string | null
      item_type: PathItemType
      assignment_type?: PathItemAssignmentType | null
      forced?: PathSyncPlanForceType | null
      forced_reasons?: Array<PathSyncPlanForceReasonType | null> | null
      change_details?: any | null
      last_changed?: any | null
    } | null>
  } | null
}

export type ReorderPathItemsMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  items: Array<InputMaybe<PathItemOrder>> | InputMaybe<PathItemOrder>
}>

export type ReorderPathItemsMutation = {
  __typename?: "Mutations"
  reorderPathItems?: boolean | null
}

export type ResetPathItemForUserMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}>

export type ResetPathItemForUserMutation = {
  __typename?: "Mutations"
  resetPathItemForUser?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type ResetPathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}>

export type ResetPathItemMutation = {
  __typename?: "Mutations"
  resetPathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      next_step_id?: number | null
      completion_date?: any | null
      points?: {
        __typename?: "Points"
        path_id?: number | null
        total?: number | null
        earned?: number | null
        total_points_possible?: number | null
        percentage?: number | null
        has_points?: boolean | null
      } | null
    } | null
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type SingleCohortPathQueryVariables = Exact<{
  cohort_id: Scalars["Int"]["input"]
}>

export type SingleCohortPathQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    items?: {
      __typename?: "PathItemConnection"
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "PathItemEdge"
        node: {
          __typename?: "PathItem"
          id: number
          type: PathItemType
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
        }
      }>
    } | null
  } | null
}

export type SingleCohortPathFragment = {
  __typename?: "Path"
  id: number
  items?: {
    __typename?: "PathItemConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "PathItemEdge"
      node: {
        __typename?: "PathItem"
        id: number
        type: PathItemType
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
      }
    }>
  } | null
}

export type SkipPathItemForUserMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}>

export type SkipPathItemForUserMutation = {
  __typename?: "Mutations"
  skipPathItemForUser?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UnarchivePathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  pathId: Scalars["Int"]["input"]
}>

export type UnarchivePathItemMutation = {
  __typename?: "Mutations"
  unarchivePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UnlockPathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  step_lock_password: Scalars["String"]["input"]
}>

export type UnlockPathItemMutation = {
  __typename?: "Mutations"
  unlockPathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UpdatePathItemMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  source_id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
  type: PathItemType
  name: Scalars["String"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  assignment_type?: InputMaybe<PathItemAssignmentType>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  allow_resets?: InputMaybe<Scalars["Int"]["input"]>
  show_grading_feedback?: InputMaybe<Scalars["Int"]["input"]>
  completion_comment_required_status?: InputMaybe<Scalars["String"]["input"]>
  points?: InputMaybe<Scalars["Int"]["input"]>
  minimum_passing_score?: InputMaybe<Scalars["Int"]["input"]>
  grading_type?: InputMaybe<Scalars["String"]["input"]>
  is_previewable?: InputMaybe<Scalars["Boolean"]["input"]>
  lock_password?: InputMaybe<Scalars["String"]["input"]>
  time_to_complete?: InputMaybe<Scalars["Int"]["input"]>
  requires_api_completion?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdatePathItemMutation = {
  __typename?: "Mutations"
  updatePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UserPathReportCardFragment = {
  __typename?: "Path"
  id: number
  progress?: number | null
  next_step_id?: number | null
  completion_date?: any | null
  created_date?: any | null
  is_source_path: boolean
  performance?: {
    __typename?: "PathPerformance"
    id?: number | null
    points?: {
      __typename?: "PathPerformancePoints"
      total?: number | null
      earned?: number | null
      possible?: number | null
      percentage?: number | null
      applicable_score?: any | null
      applicable_score_percentage?: number | null
    } | null
    progress?: {
      __typename?: "PathPerformanceProgress"
      steps_completed?: number | null
      required_steps_completed?: number | null
      total_steps?: number | null
      total_required_steps?: number | null
      percentage?: number | null
    } | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  cohort?: { __typename?: "Group"; id: number; name: string } | null
  items?: {
    __typename?: "PathItemConnection"
    edges: Array<{
      __typename?: "PathItemEdge"
      node: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        copied_from_id?: number | null
        archived_time?: any | null
        progress: number
        context?: {
          __typename?: "StepContext"
          school_id?: number | null
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id: number
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      }
    }>
  } | null
  points?: {
    __typename?: "Points"
    path_id?: number | null
    total?: number | null
    earned?: number | null
    total_points_possible?: number | null
    percentage?: number | null
    has_points?: boolean | null
  } | null
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type UserPathReportCardQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type UserPathReportCardQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    next_step_id?: number | null
    completion_date?: any | null
    created_date?: any | null
    is_source_path: boolean
    performance?: {
      __typename?: "PathPerformance"
      id?: number | null
      points?: {
        __typename?: "PathPerformancePoints"
        total?: number | null
        earned?: number | null
        possible?: number | null
        percentage?: number | null
        applicable_score?: any | null
        applicable_score_percentage?: number | null
      } | null
      progress?: {
        __typename?: "PathPerformanceProgress"
        steps_completed?: number | null
        required_steps_completed?: number | null
        total_steps?: number | null
        total_required_steps?: number | null
        percentage?: number | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: { __typename?: "Group"; id: number; name: string } | null
    items?: {
      __typename?: "PathItemConnection"
      edges: Array<{
        __typename?: "PathItemEdge"
        node: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          copied_from_id?: number | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            school_id?: number | null
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id: number
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        }
      }>
    } | null
    points?: {
      __typename?: "Points"
      path_id?: number | null
      total?: number | null
      earned?: number | null
      total_points_possible?: number | null
      percentage?: number | null
      has_points?: boolean | null
    } | null
    sync?: {
      __typename?: "PathSync"
      path_id: number
      synced: boolean
      last_synced_date?: any | null
      sync_source_path_id?: number | null
      user_id?: number | null
    } | null
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type PathItemsQueryQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  school_id: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type PathItemsQueryQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      pathItems?: {
        __typename?: "PathItemConnection"
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "PathItemEdge"
          node: {
            __typename?: "PathItem"
            id: number
            order: number
            name: string
            type: PathItemType
            path_id: number
            source_id: number
            parent_id?: number | null
            description?: string | null
            content_id?: number | null
            assignment_type?: PathItemAssignmentType | null
            item_content_type_id?: number | null
            verb?: string | null
            points?: number | null
            is_previewable?: boolean | null
            is_required?: boolean | null
            time_to_complete?: number | null
            step_verb?: string | null
            userpoints_value?: number | null
            context?: {
              __typename?: "StepContext"
              school_id?: number | null
            } | null
          }
        }>
      } | null
    }
  } | null
}

export type StepFragment = {
  __typename?: "PathItem"
  id: number
  name: string
  verb?: string | null
  source_id: number
  description?: string | null
  content_id?: number | null
  assignment_type?: PathItemAssignmentType | null
  item_content_type_id?: number | null
}

export type MissingPathItemFragment = {
  __typename?: "PathItem"
  id: number
  source_id: number
  name: string
  type: PathItemType
  archived_time?: any | null
}

export type MissingPathItemQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  pathId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type MissingPathItemQuery = {
  __typename?: "Query"
  missingPathItem?: {
    __typename?: "PathItem"
    id: number
    source_id: number
    name: string
    type: PathItemType
    archived_time?: any | null
  } | null
  missingSourcePathItem?: {
    __typename?: "PathItem"
    id: number
    source_id: number
    name: string
    type: PathItemType
    archived_time?: any | null
  } | null
}

export type ContextQueryVariables = Exact<{ [key: string]: never }>

export type ContextQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    theme?: {
      __typename?: "Theme"
      id?: number | null
      name?: string | null
      theme_type?: ThemeType | null
      background_image?: string | null
      background_overlay?: string | null
      background_type?: number | null
      heading_font?: string | null
      primary_color?: string | null
      typekit_id?: string | null
      custom_css?: string | null
      processed_custom_css?: string | null
      color_palette?: {
        __typename?: "NodeThemeColorPalette"
        _50?: string | null
        _100?: string | null
        _200?: string | null
        _300?: string | null
        _400?: string | null
        _500?: string | null
        _600?: string | null
        _700?: string | null
        _800?: string | null
        _900?: string | null
        _950?: string | null
      } | null
    } | null
    features: {
      __typename?: "SchoolFeatures"
      auth__platform: boolean
      media__downloadable_videos: boolean
      library__cover_pages: boolean
    }
  } | null
  me?: {
    __typename?: "User"
    username?: string | null
    no_password_set?: boolean | null
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    group_role_stats?: Array<{
      __typename?: "GroupRoleStats"
      type?: string | null
      total?: number | null
      role?: number | null
    } | null> | null
    permissions?: {
      __typename?: "ContextPermissions"
      is_school_owner?: boolean | null
      can_administrate?: boolean | null
      can_edit_library?: boolean | null
      has_member_access?: boolean | null
      has_pathwright_staff_access?: boolean | null
    } | null
    membership?: {
      __typename?: "Membership"
      id: number
      created: any
      last_seen?: any | null
      last_active?: any | null
      has_access: boolean
      role: number
      consent_snapshot?: string | null
      consent_dtime?: any | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      notification_digest_interval?: NotificationDigestInterval | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  translation?: {
    __typename?: "Translation"
    id: number
    name?: string | null
    language: string
    translation: any
    master_translation?: any | null
    is_default: boolean
  } | null
  platformConfig?: {
    __typename?: "PlatformConfig"
    id?: number | null
    payments_maintenance_mode?: boolean | null
  } | null
  integrations?: {
    __typename?: "Integrations"
    firebase?: {
      __typename?: "FirebaseIntegration"
      auth_token?: string | null
      url?: string | null
      client_api_key?: string | null
    } | null
    intercom?: {
      __typename?: "IntercomIntegration"
      app_id?: string | null
      pathwright_app_id?: string | null
      school_app_id?: string | null
      user_hash?: string | null
    } | null
  } | null
}

export type ContextFragment = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    theme?: {
      __typename?: "Theme"
      id?: number | null
      name?: string | null
      theme_type?: ThemeType | null
      background_image?: string | null
      background_overlay?: string | null
      background_type?: number | null
      heading_font?: string | null
      primary_color?: string | null
      typekit_id?: string | null
      custom_css?: string | null
      processed_custom_css?: string | null
      color_palette?: {
        __typename?: "NodeThemeColorPalette"
        _50?: string | null
        _100?: string | null
        _200?: string | null
        _300?: string | null
        _400?: string | null
        _500?: string | null
        _600?: string | null
        _700?: string | null
        _800?: string | null
        _900?: string | null
        _950?: string | null
      } | null
    } | null
    features: {
      __typename?: "SchoolFeatures"
      auth__platform: boolean
      media__downloadable_videos: boolean
      library__cover_pages: boolean
    }
  } | null
  me?: {
    __typename?: "User"
    username?: string | null
    no_password_set?: boolean | null
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    group_role_stats?: Array<{
      __typename?: "GroupRoleStats"
      type?: string | null
      total?: number | null
      role?: number | null
    } | null> | null
    permissions?: {
      __typename?: "ContextPermissions"
      is_school_owner?: boolean | null
      can_administrate?: boolean | null
      can_edit_library?: boolean | null
      has_member_access?: boolean | null
      has_pathwright_staff_access?: boolean | null
    } | null
    membership?: {
      __typename?: "Membership"
      id: number
      created: any
      last_seen?: any | null
      last_active?: any | null
      has_access: boolean
      role: number
      consent_snapshot?: string | null
      consent_dtime?: any | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      notification_digest_interval?: NotificationDigestInterval | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  translation?: {
    __typename?: "Translation"
    id: number
    name?: string | null
    language: string
    translation: any
    master_translation?: any | null
    is_default: boolean
  } | null
  platformConfig?: {
    __typename?: "PlatformConfig"
    id?: number | null
    payments_maintenance_mode?: boolean | null
  } | null
  integrations?: {
    __typename?: "Integrations"
    firebase?: {
      __typename?: "FirebaseIntegration"
      auth_token?: string | null
      url?: string | null
      client_api_key?: string | null
    } | null
    intercom?: {
      __typename?: "IntercomIntegration"
      app_id?: string | null
      pathwright_app_id?: string | null
      school_app_id?: string | null
      user_hash?: string | null
    } | null
  } | null
}

export type MeFragment = {
  __typename?: "User"
  username?: string | null
  no_password_set?: boolean | null
  id: number
  email?: string | null
  first_name: string
  last_name: string
  full_name: string
  display_name?: string | null
  group_role_stats?: Array<{
    __typename?: "GroupRoleStats"
    type?: string | null
    total?: number | null
    role?: number | null
  } | null> | null
  permissions?: {
    __typename?: "ContextPermissions"
    is_school_owner?: boolean | null
    can_administrate?: boolean | null
    can_edit_library?: boolean | null
    has_member_access?: boolean | null
    has_pathwright_staff_access?: boolean | null
  } | null
  membership?: {
    __typename?: "Membership"
    id: number
    created: any
    last_seen?: any | null
    last_active?: any | null
    has_access: boolean
    role: number
    consent_snapshot?: string | null
    consent_dtime?: any | null
  } | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    notification_digest_interval?: NotificationDigestInterval | null
    bio?: string | null
    image?: string | null
    imageRaw?: string | null
    location?: string | null
    last_activity?: any | null
    rewardful_referral_id?: string | null
  } | null
}

export type PlatformConfigQueryVariables = Exact<{ [key: string]: never }>

export type PlatformConfigQuery = {
  __typename?: "Query"
  platformConfig?: {
    __typename?: "PlatformConfig"
    id?: number | null
    payments_maintenance_mode?: boolean | null
  } | null
}

export type ThemeQueryQueryVariables = Exact<{
  school_id: Scalars["Int"]["input"]
}>

export type ThemeQueryQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    theme?: {
      __typename?: "Theme"
      id?: number | null
      name?: string | null
      theme_type?: ThemeType | null
      background_image?: string | null
      background_overlay?: string | null
      background_type?: number | null
      heading_font?: string | null
      primary_color?: string | null
      typekit_id?: string | null
      custom_css?: string | null
      processed_custom_css?: string | null
      color_palette?: {
        __typename?: "NodeThemeColorPalette"
        _50?: string | null
        _100?: string | null
        _200?: string | null
        _300?: string | null
        _400?: string | null
        _500?: string | null
        _600?: string | null
        _700?: string | null
        _800?: string | null
        _900?: string | null
        _950?: string | null
      } | null
    } | null
  } | null
}

export type DeletePositioningContextMutationVariables = Exact<{
  context: PositioningContextInput
}>

export type DeletePositioningContextMutation = {
  __typename?: "Mutations"
  deletePositioningContext?: boolean | null
}

export type PositioningContextFragment = {
  __typename?: "PositioningContext"
  id: number
  context_key: any
  context_type: PositioningContextTypeInput
}

export type PositioningContextQueryVariables = Exact<{
  input: PositioningContextInput
}>

export type PositioningContextQuery = {
  __typename?: "Query"
  positioningContext?: {
    __typename?: "PositioningContext"
    id: number
    context_key: any
    context_type: PositioningContextTypeInput
  } | null
}

export type UpdatePositionedObjectsMutationVariables = Exact<{
  context: PositioningContextInput
  positions:
    | Array<InputMaybe<PositionedObjectPositionInput>>
    | InputMaybe<PositionedObjectPositionInput>
}>

export type UpdatePositionedObjectsMutation = {
  __typename?: "Mutations"
  updatePositionedObjects?: any | null
}

export type __TestRegistrationPositioningQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  positioningContext?: InputMaybe<PositioningContextInput>
}>

export type __TestRegistrationPositioningQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    registrations?: {
      __typename?: "RegistrationConnection"
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: { __typename?: "Registration"; id: number; position: string }
      }>
    } | null
  } | null
}

export type __TestRegistrationFragment = {
  __typename?: "Registration"
  id: number
  position: string
}

export type PricingQueryVariables = Exact<{ [key: string]: never }>

export type PricingQuery = {
  __typename?: "Query"
  packageAssignment?: {
    __typename?: "PackageAssignment"
    package?: { __typename?: "Package"; coupon_discount?: number | null } | null
  } | null
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    scholarship?: {
      __typename?: "SchoolBillingScholarship"
      id?: number | null
      ends?: any | null
      iterations?: number | null
      order?: number | null
      plan_id?: number | null
      starts?: any | null
      interval?: Interval | null
      coupon?: {
        __typename?: "StripeCoupon"
        id?: number | null
        percent_off?: number | null
      } | null
    } | null
    billing_plan_set?: {
      __typename?: "SchoolBillingPlanSet"
      plans?: Array<{
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
        visibility: Visibility
        amount: number
        description: string
        learner_counting_method: number
        fee_per_additional_learner: number
        learners_included: number
        staff_included: number
        color: string
        order: number
        should_contact_for_pricing: boolean
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          name: string
          description: string
          link: string
          key: string
          icon: string
          feature_type: number
          order: number
          platform_version: number
        }>
        billing_blocks?: {
          __typename?: "SchoolBillingBlockConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "SchoolBillingBlockEdge"
            node: {
              __typename?: "SchoolBillingBlock"
              id?: number | null
              block_type?: number | null
              block_size?: number | null
              price?: number | null
            }
          }>
        } | null
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
          name: string
          description: string
          amount: number
          order: number
        } | null
      } | null> | null
    } | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      interval?: SubscriptionInterval | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
        description: string
        amount: number
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
          name: string
          description: string
          amount: number
        } | null
      } | null
    } | null
  } | null
}

export type ActiveCertificateQueryVariables = Exact<{ [key: string]: never }>

export type ActiveCertificateQuery = {
  __typename?: "Query"
  certificate?: { __typename?: "Certificate"; id?: number | null } | null
}

export type CertificateDownloadUrlQueryVariables = Exact<{
  pathId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CertificateDownloadUrlQuery = {
  __typename?: "Query"
  certificate?: {
    __typename?: "Certificate"
    id?: number | null
    download_url?: string | null
  } | null
}

export type UpdateUserMembershipMutationVariables = Exact<{
  consents?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateUserMembershipMutation = {
  __typename?: "Mutations"
  updateMemberConsent?: {
    __typename?: "Membership"
    id: number
    consent_snapshot?: string | null
    consent_dtime?: any | null
  } | null
}

export type UserProfileQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type UserProfileQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    membership?: {
      __typename?: "Membership"
      id: number
      role: number
      last_active?: any | null
      last_seen?: any | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type PublisherFragment = {
  __typename?: "Publisher"
  id?: number | null
  name?: string | null
  about?: string | null
  website?: string | null
  image?: string | null
}

export type PublishersQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
}>

export type PublishersQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      publishers?: {
        __typename?: "PublisherConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "PublisherEdge"
          node: {
            __typename?: "Publisher"
            id?: number | null
            name?: string | null
            about?: string | null
            website?: string | null
            image?: string | null
          }
        }>
      } | null
    }
  } | null
}

export type UpdateReferralMutationVariables = Exact<{
  referral: Scalars["String"]["input"]
}>

export type UpdateReferralMutation = {
  __typename?: "Mutations"
  updateReferral?: { __typename?: "Referral"; referral?: string | null } | null
}

export type DeleteRegistrationMutationVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  registration_id: Scalars["Int"]["input"]
}>

export type DeleteRegistrationMutation = {
  __typename?: "Mutations"
  deleteRegistration?: boolean | null
}

export type RegistrationExpirationQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type RegistrationExpirationQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    price?: number | null
    is_subscription_only?: boolean | null
    access_starts?: any | null
    access_ends?: any | null
    resource?: { __typename?: "Resource"; id: number; name: string } | null
    resource_license?: {
      __typename?: "ResourceLicense"
      id?: number | null
    } | null
    include_in_plans?: {
      __typename?: "SchoolSubscriptionPlanConnection"
      total: number
      edges: Array<{
        __typename?: "SchoolSubscriptionPlanEdge"
        node: { __typename?: "SchoolSubscriptionPlan"; id: number }
      }>
    } | null
    include_with_products?: {
      __typename?: "StripeProductConnection"
      total: number
      edges: Array<{
        __typename?: "StripeProductEdge"
        node: { __typename?: "StripeProduct"; id: number }
      }>
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      expiration_dtime?: any | null
      school_sub_used?: {
        __typename?: "SchoolSubscription"
        id: number
        school_subscription_plan: {
          __typename?: "SchoolSubscriptionPlan"
          id: number
        }
        subscription_plan: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
        }
        subscription: {
          __typename?: "Subscription"
          id: number
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id: number
            name: string
            amount?: number | null
            interval: number
            trial_period_days: number
            trial_type: SubscriptionTrialType
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        }
      } | null
      group_sub_used?: {
        __typename?: "SchoolGroupSubscription"
        id: number
        price: {
          __typename?: "StripePrice"
          id: number
          product?: {
            __typename?: "StripeProduct"
            id: number
            name?: string | null
          } | null
        }
        community_group: {
          __typename?: "MentorGroup"
          id: number
          name: string
          seat_limit?: number | null
        }
        subscription: {
          __typename?: "Subscription"
          id: number
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id: number
            name: string
            amount?: number | null
            interval: number
            trial_period_days: number
            trial_type: SubscriptionTrialType
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        }
      } | null
      group_sub_community_membership?: {
        __typename?: "MentorGroupMembership"
        id: number
        access_revoked_time?: any | null
      } | null
    } | null
  } | null
}

export type RegistrationFragment = {
  __typename?: "Registration"
  id: number
  role: number
  completion_state?: number | null
  send_due_notifications?: boolean | null
  send_discussion_notifications?: boolean | null
  last_activity_time?: any | null
  expiration_dtime?: any | null
  created?: any | null
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type RegistrationQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  registration_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type RegistrationQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    permissions?: {
      __typename?: "GroupPermissions"
      can_invite_observer?: boolean | null
      can_invite_student?: boolean | null
      can_invite_moderator?: boolean | null
      can_invite_teacher?: boolean | null
      can_invite_editor?: boolean | null
    } | null
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type RegistrationsQueryVariables = Exact<{
  groupId: Scalars["Int"]["input"]
  roleFilter?: InputMaybe<RoleFilter>
  dateLastActive?: InputMaybe<DateFilter>
  dateJoined?: InputMaybe<DateFilter>
  softArchived?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<
    | Array<InputMaybe<RegistrationOrderByInput>>
    | InputMaybe<RegistrationOrderByInput>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type RegistrationsQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type UpdateRegistrationMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateRegistrationMutation = {
  __typename?: "Mutations"
  updateRegistration?: {
    __typename?: "Registration"
    id: number
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
  } | null
}

export type UpdateUserRegistrationMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  expiration_dtime?: InputMaybe<Scalars["DateTime"]["input"]>
}>

export type UpdateUserRegistrationMutation = {
  __typename?: "Mutations"
  updateRegistration?: {
    __typename?: "Registration"
    id: number
    role: number
    expiration_dtime?: any | null
  } | null
}

export type UserProfileRegistrationFragment = {
  __typename?: "Registration"
  id: number
  role: number
  completion_state?: number | null
  send_due_notifications?: boolean | null
  send_discussion_notifications?: boolean | null
  last_activity_time?: any | null
  expiration_dtime?: any | null
  created?: any | null
  resource: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
  }
  group: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
  }
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    completion_date?: any | null
  } | null
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type UserProfileRegistrationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  role_filter?: InputMaybe<RoleFilter>
  progress_filter?: InputMaybe<ProgressFilter>
  id_filter?: InputMaybe<IntFilter>
  parent_cohort_filter?: InputMaybe<IdFilter>
  hasParentRegistration?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<
    | Array<InputMaybe<RegistrationOrderByInput>>
    | InputMaybe<RegistrationOrderByInput>
  >
}>

export type UserProfileRegistrationsQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
          } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type ReportQueryQueryVariables = Exact<{
  community_groups?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  community_memberships?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  group_registrations?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  group_performance_points?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  group_performance_completion?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  school_resources?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  school_cohorts?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  school_members?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  school_member_progress?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  school_registrations?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  school_coupon_summary?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  school_coupon_redemptions?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  licensing_store_connected_accounts?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  licensing_store_resource_usage?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  licensing_store_member_progress?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
  licensing_member_created_cohorts?: InputMaybe<
    Array<InputMaybe<ReportInput>> | InputMaybe<ReportInput>
  >
}>

export type ReportQueryQuery = { __typename?: "Query"; report?: any | null }

export type DeferOrExecuteResourceCopyConfigMutationVariables = Exact<{
  copyCode: Scalars["String"]["input"]
  targetSchoolId: Scalars["Int"]["input"]
}>

export type DeferOrExecuteResourceCopyConfigMutation = {
  __typename?: "Mutations"
  deferOrExecuteResourceCopyConfig?: {
    __typename?: "DeferOrExecuteResourceCopyConfigResult"
    defer: any
    execute: any
  } | null
}

export type DeleteResourceCopyConfigLinkMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteResourceCopyConfigLinkMutation = {
  __typename?: "Mutations"
  deleteResourceCopyConfigLink?: string | null
}

export type ExecuteDeferredResourceCopyConfigMutationVariables = Exact<{
  linkId: Scalars["Int"]["input"]
}>

export type ExecuteDeferredResourceCopyConfigMutation = {
  __typename?: "Mutations"
  executeDeferredResourceCopyConfig?: {
    __typename?: "DeferOrExecuteResourceCopyConfigResult"
    defer: any
    execute: any
  } | null
}

export type ResourceCopyConfigQueryVariables = Exact<{
  key: Scalars["String"]["input"]
}>

export type ResourceCopyConfigQuery = {
  __typename?: "Query"
  resourceCopyConfig?: {
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  } | null
}

export type ResourceCopyConfigConnectionsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  keys?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  fromSpaceId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ResourceCopyConfigConnectionsQuery = {
  __typename?: "Query"
  resourceCopyConfigConnections?: {
    __typename?: "ResourceCopyConfigConnection"
    edges: Array<{
      __typename?: "ResourceCopyConfigEdge"
      node: {
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            children?: Array<{
              __typename?: "ResourceCopyConfig"
              id: number
              name?: string | null
              lookup_key: string
              copy_behavior: ResourceCopyConfigCopyBehavior
              allow_copy_via_link: boolean
              resource?: {
                __typename?: "ResourceCopyConfigResource"
                id: number
                meta: {
                  __typename?: "NodeMeta"
                  id: string
                  type: string
                  key: string
                  title?: string | null
                  image?: {
                    __typename?: "NodeImage"
                    src?: string | null
                  } | null
                }
              } | null
            } | null> | null
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      }
    }>
  } | null
}

export type ResourceCopyConfigFragment = {
  __typename?: "ResourceCopyConfig"
  id: number
  name?: string | null
  lookup_key: string
  copy_behavior: ResourceCopyConfigCopyBehavior
  allow_copy_via_link: boolean
  children?: Array<{
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  } | null> | null
  resource?: {
    __typename?: "ResourceCopyConfigResource"
    id: number
    meta: {
      __typename?: "NodeMeta"
      id: string
      type: string
      key: string
      title?: string | null
      image?: { __typename?: "NodeImage"; src?: string | null } | null
    }
  } | null
}

export type ResourceCopyConfigPartialFragment = {
  __typename?: "ResourceCopyConfig"
  id: number
  name?: string | null
  lookup_key: string
  copy_behavior: ResourceCopyConfigCopyBehavior
  allow_copy_via_link: boolean
  resource?: {
    __typename?: "ResourceCopyConfigResource"
    id: number
    meta: {
      __typename?: "NodeMeta"
      id: string
      type: string
      key: string
      title?: string | null
      image?: { __typename?: "NodeImage"; src?: string | null } | null
    }
  } | null
}

export type ResourceCopyConfigLinkConnectionsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  copiedTimeDateFilter?: InputMaybe<DateFilter>
  hideFromLocationsFilter?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocationFilter>>
    | InputMaybe<ResourceCopyConfigLinkLocationFilter>
  >
}>

export type ResourceCopyConfigLinkConnectionsQuery = {
  __typename?: "Query"
  resourceCopyConfigLinkConnections?: {
    __typename?: "ResourceCopyConfigLinkConnection"
    edges: Array<{
      __typename?: "ResourceCopyConfigLinkEdge"
      node: {
        __typename?: "ResourceCopyConfigLink"
        id: number
        createdTime: any
        copiedTime?: any | null
        resourceId?: number | null
        cohortId?: number | null
        copierRegistrationId?: number | null
        hideFromLocations?: any | null
        resourceCopyConfig: {
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            children?: Array<{
              __typename?: "ResourceCopyConfig"
              id: number
              name?: string | null
              lookup_key: string
              copy_behavior: ResourceCopyConfigCopyBehavior
              allow_copy_via_link: boolean
              children?: Array<{
                __typename?: "ResourceCopyConfig"
                id: number
                name?: string | null
                lookup_key: string
                copy_behavior: ResourceCopyConfigCopyBehavior
                allow_copy_via_link: boolean
                resource?: {
                  __typename?: "ResourceCopyConfigResource"
                  id: number
                  meta: {
                    __typename?: "NodeMeta"
                    id: string
                    type: string
                    key: string
                    title?: string | null
                    image?: {
                      __typename?: "NodeImage"
                      src?: string | null
                    } | null
                  }
                } | null
              } | null> | null
              resource?: {
                __typename?: "ResourceCopyConfigResource"
                id: number
                meta: {
                  __typename?: "NodeMeta"
                  id: string
                  type: string
                  key: string
                  title?: string | null
                  image?: {
                    __typename?: "NodeImage"
                    src?: string | null
                  } | null
                }
              } | null
            } | null> | null
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        }
      }
    }>
  } | null
}

export type ResourceCopyConfigLinkFragment = {
  __typename?: "ResourceCopyConfigLink"
  id: number
  createdTime: any
  copiedTime?: any | null
  resourceId?: number | null
  cohortId?: number | null
  copierRegistrationId?: number | null
  hideFromLocations?: any | null
  resourceCopyConfig: {
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  }
}

export type ResourceCopyConfigLinkQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type ResourceCopyConfigLinkQuery = {
  __typename?: "Query"
  resourceCopyConfigLink?: {
    __typename?: "ResourceCopyConfigLink"
    id: number
    createdTime: any
    copiedTime?: any | null
    resourceId?: number | null
    cohortId?: number | null
    copierRegistrationId?: number | null
    hideFromLocations?: any | null
    resourceCopyConfig: {
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    }
  } | null
}

export type ResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  cover_image: string
}

export type ResourcePublisherQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ResourcePublisherQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    publisher?: {
      __typename?: "Publisher"
      id?: number | null
      name?: string | null
      about?: string | null
      website?: string | null
      image?: string | null
    } | null
  } | null
}

export type ResourceQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type ResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
  } | null
}

export type ShowHideResourceCopyConfigLinkMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  show?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocation>>
    | InputMaybe<ResourceCopyConfigLinkLocation>
  >
  hide?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocation>>
    | InputMaybe<ResourceCopyConfigLinkLocation>
  >
}>

export type ShowHideResourceCopyConfigLinkMutation = {
  __typename?: "Mutations"
  showHideResourceCopyConfigLink?: {
    __typename?: "ResourceCopyConfigLink"
    id: number
    createdTime: any
    copiedTime?: any | null
    resourceId?: number | null
    cohortId?: number | null
    copierRegistrationId?: number | null
    hideFromLocations?: any | null
    resourceCopyConfig: {
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    }
  } | null
}

export type ComputedDiscountQueryQueryVariables = Exact<{
  discount_code: Scalars["String"]["input"]
  resource_id: Scalars["Int"]["input"]
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  offering_id?: InputMaybe<Scalars["Int"]["input"]>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ComputedDiscountQueryQuery = {
  __typename?: "Query"
  computedDiscount?: {
    __typename?: "ComputedDiscount"
    id?: number | null
    max_seat_discount?: number | null
    discount_percent?: number | null
    discount_amount?: number | null
    discounted_total?: number | null
  } | null
}

export type LicenseOfferingFragment = {
  __typename?: "LicenseOffering"
  id?: number | null
  description?: string | null
  cost_per_seat?: number | null
  include_creator_seat?: boolean | null
  register_creator_as?: RegistrationRoleEnum | null
  minimum_seat_count?: number | null
  minimum_license_duration?: number | null
  licensing_mode?: LicenseOfferingLicensingMode | null
  included_in_user_subscription?: boolean | null
  include_in_curriculum_plans?: {
    __typename?: "SchoolCurriculumPlanConnection"
    total: number
    edges: Array<{
      __typename?: "SchoolCurriculumPlanEdge"
      node: {
        __typename?: "SchoolCurriculumPlan"
        id: number
        plan_id?: number | null
      }
    }>
  } | null
  include_in_subscription_plans?: {
    __typename?: "SchoolSubscriptionPlanConnection"
    total: number
    edges: Array<{
      __typename?: "SchoolSubscriptionPlanEdge"
      node: { __typename?: "SchoolSubscriptionPlan"; id: number }
    }>
  } | null
  include_with_products?: {
    __typename?: "StripeProductConnection"
    total: number
    edges: Array<{
      __typename?: "StripeProductEdge"
      node: { __typename?: "StripeProduct"; id: number }
    }>
  } | null
  licensor?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
  } | null
}

export type LicenseOfferingQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  school_id: Scalars["Int"]["input"]
}>

export type LicenseOfferingQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      license_offering?: {
        __typename?: "LicenseOffering"
        id?: number | null
        description?: string | null
        cost_per_seat?: number | null
        include_creator_seat?: boolean | null
        register_creator_as?: RegistrationRoleEnum | null
        minimum_seat_count?: number | null
        minimum_license_duration?: number | null
        licensing_mode?: LicenseOfferingLicensingMode | null
        included_in_user_subscription?: boolean | null
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
        } | null
        include_in_curriculum_plans?: {
          __typename?: "SchoolCurriculumPlanConnection"
          total: number
          edges: Array<{
            __typename?: "SchoolCurriculumPlanEdge"
            node: {
              __typename?: "SchoolCurriculumPlan"
              id: number
              plan_id?: number | null
            }
          }>
        } | null
        include_in_subscription_plans?: {
          __typename?: "SchoolSubscriptionPlanConnection"
          total: number
          edges: Array<{
            __typename?: "SchoolSubscriptionPlanEdge"
            node: { __typename?: "SchoolSubscriptionPlan"; id: number }
          }>
        } | null
        include_with_products?: {
          __typename?: "StripeProductConnection"
          total: number
          edges: Array<{
            __typename?: "StripeProductEdge"
            node: { __typename?: "StripeProduct"; id: number }
          }>
        } | null
        licensor?: {
          __typename?: "School"
          id: number
          url: string
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          image_is_default: boolean
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
          resource_licensing_enabled?: boolean | null
        } | null
      } | null
    }
  } | null
}

export type LicenseResourceMutationVariables = Exact<{
  resource_id: Scalars["Int"]["input"]
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id?: InputMaybe<Scalars["Int"]["input"]>
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<LicenseRoleEnum>
  payment_token?: InputMaybe<Scalars["String"]["input"]>
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
}>

export type LicenseResourceMutation = {
  __typename?: "Mutations"
  licenseResource?: {
    __typename?: "ResourceLicense"
    id?: number | null
    seat_count?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    expiration_dtime?: any | null
    school?: {
      __typename?: "LicenseeSchool"
      id?: number | null
      name?: string | null
    } | null
    license_offering?: {
      __typename?: "LicenseOffering"
      id?: number | null
      description?: string | null
      cost_per_seat?: number | null
      include_creator_seat?: boolean | null
      register_creator_as?: RegistrationRoleEnum | null
      minimum_seat_count?: number | null
      minimum_license_duration?: number | null
      licensing_mode?: LicenseOfferingLicensingMode | null
      included_in_user_subscription?: boolean | null
      include_in_curriculum_plans?: {
        __typename?: "SchoolCurriculumPlanConnection"
        total: number
        edges: Array<{
          __typename?: "SchoolCurriculumPlanEdge"
          node: {
            __typename?: "SchoolCurriculumPlan"
            id: number
            plan_id?: number | null
          }
        }>
      } | null
      include_in_subscription_plans?: {
        __typename?: "SchoolSubscriptionPlanConnection"
        total: number
        edges: Array<{
          __typename?: "SchoolSubscriptionPlanEdge"
          node: { __typename?: "SchoolSubscriptionPlan"; id: number }
        }>
      } | null
      include_with_products?: {
        __typename?: "StripeProductConnection"
        total: number
        edges: Array<{
          __typename?: "StripeProductEdge"
          node: { __typename?: "StripeProduct"; id: number }
        }>
      } | null
      licensor?: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      } | null
    } | null
    group?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      resource?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
      } | null
    } | null
  } | null
}

export type ResourceLicenseFragment = {
  __typename?: "ResourceLicense"
  id?: number | null
  seat_count?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  expiration_dtime?: any | null
  school?: {
    __typename?: "LicenseeSchool"
    id?: number | null
    name?: string | null
  } | null
  license_offering?: {
    __typename?: "LicenseOffering"
    id?: number | null
    description?: string | null
    cost_per_seat?: number | null
    include_creator_seat?: boolean | null
    register_creator_as?: RegistrationRoleEnum | null
    minimum_seat_count?: number | null
    minimum_license_duration?: number | null
    licensing_mode?: LicenseOfferingLicensingMode | null
    included_in_user_subscription?: boolean | null
    include_in_curriculum_plans?: {
      __typename?: "SchoolCurriculumPlanConnection"
      total: number
      edges: Array<{
        __typename?: "SchoolCurriculumPlanEdge"
        node: {
          __typename?: "SchoolCurriculumPlan"
          id: number
          plan_id?: number | null
        }
      }>
    } | null
    include_in_subscription_plans?: {
      __typename?: "SchoolSubscriptionPlanConnection"
      total: number
      edges: Array<{
        __typename?: "SchoolSubscriptionPlanEdge"
        node: { __typename?: "SchoolSubscriptionPlan"; id: number }
      }>
    } | null
    include_with_products?: {
      __typename?: "StripeProductConnection"
      total: number
      edges: Array<{
        __typename?: "StripeProductEdge"
        node: { __typename?: "StripeProduct"; id: number }
      }>
    } | null
    licensor?: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
    } | null
  } | null
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
  } | null
}

export type ResourceLicenseQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ResourceLicenseQuery = {
  __typename?: "Query"
  resource_license?: {
    __typename?: "ResourceLicense"
    id?: number | null
    seat_count?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    expiration_dtime?: any | null
    school?: {
      __typename?: "LicenseeSchool"
      id?: number | null
      name?: string | null
    } | null
    license_offering?: {
      __typename?: "LicenseOffering"
      id?: number | null
      description?: string | null
      cost_per_seat?: number | null
      include_creator_seat?: boolean | null
      register_creator_as?: RegistrationRoleEnum | null
      minimum_seat_count?: number | null
      minimum_license_duration?: number | null
      licensing_mode?: LicenseOfferingLicensingMode | null
      included_in_user_subscription?: boolean | null
      include_in_curriculum_plans?: {
        __typename?: "SchoolCurriculumPlanConnection"
        total: number
        edges: Array<{
          __typename?: "SchoolCurriculumPlanEdge"
          node: {
            __typename?: "SchoolCurriculumPlan"
            id: number
            plan_id?: number | null
          }
        }>
      } | null
      include_in_subscription_plans?: {
        __typename?: "SchoolSubscriptionPlanConnection"
        total: number
        edges: Array<{
          __typename?: "SchoolSubscriptionPlanEdge"
          node: { __typename?: "SchoolSubscriptionPlan"; id: number }
        }>
      } | null
      include_with_products?: {
        __typename?: "StripeProductConnection"
        total: number
        edges: Array<{
          __typename?: "StripeProductEdge"
          node: { __typename?: "StripeProduct"; id: number }
        }>
      } | null
      licensor?: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      } | null
    } | null
    group?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      resource?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
      } | null
    } | null
  } | null
}

export type ScopedResourceLicenseQueryVariables = Exact<{
  schoolId: Scalars["Int"]["input"]
  resourceLicenseId: Scalars["Int"]["input"]
}>

export type ScopedResourceLicenseQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      resource_license?: {
        __typename?: "ResourceLicense"
        id?: number | null
        seat_count?: number | null
        seats_filled?: number | null
        seats_available?: number | null
        expiration_dtime?: any | null
        school?: {
          __typename?: "LicenseeSchool"
          id?: number | null
          name?: string | null
        } | null
        license_offering?: {
          __typename?: "LicenseOffering"
          id?: number | null
          description?: string | null
          cost_per_seat?: number | null
          include_creator_seat?: boolean | null
          register_creator_as?: RegistrationRoleEnum | null
          minimum_seat_count?: number | null
          minimum_license_duration?: number | null
          licensing_mode?: LicenseOfferingLicensingMode | null
          included_in_user_subscription?: boolean | null
          include_in_curriculum_plans?: {
            __typename?: "SchoolCurriculumPlanConnection"
            total: number
            edges: Array<{
              __typename?: "SchoolCurriculumPlanEdge"
              node: {
                __typename?: "SchoolCurriculumPlan"
                id: number
                plan_id?: number | null
              }
            }>
          } | null
          include_in_subscription_plans?: {
            __typename?: "SchoolSubscriptionPlanConnection"
            total: number
            edges: Array<{
              __typename?: "SchoolSubscriptionPlanEdge"
              node: { __typename?: "SchoolSubscriptionPlan"; id: number }
            }>
          } | null
          include_with_products?: {
            __typename?: "StripeProductConnection"
            total: number
            edges: Array<{
              __typename?: "StripeProductEdge"
              node: { __typename?: "StripeProduct"; id: number }
            }>
          } | null
          licensor?: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
          } | null
        } | null
        group?: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
          resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
          } | null
        } | null
      } | null
    }
  } | null
}

export type CopyResourceMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  to_school?: InputMaybe<Scalars["Int"]["input"]>
  create_offering?: InputMaybe<Scalars["Boolean"]["input"]>
  create_registration_with_role?: InputMaybe<RegistrationRoleEnum>
}>

export type CopyResourceMutation = {
  __typename?: "Mutations"
  copyResource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    source_cohort?: { __typename?: "Group"; id: number } | null
  } | null
}

export type ManageResourceFragment = {
  __typename?: "Resource"
  trailer_embed_code?: string | null
  visibility_level_override?: number | null
  certificate_generator_class?: string | null
  certificate_json?: any | null
  licensed_from_resource_id?: number | null
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  cover_image: string
  registration_meta?: {
    __typename?: "RegistrationMeta"
    editor_registration_count?: number | null
  } | null
  authors?: {
    __typename?: "AuthorConnection"
    total: number
    edges: Array<{
      __typename?: "AuthorEdge"
      node: {
        __typename?: "Author"
        id: number
        order: number
        display_name: string
        full_name: string
        first_name: string
        last_name: string
        title?: string | null
        image?: string | null
        bio?: string | null
        avatar?: string | null
        salutation?: string | null
        slug: string
      }
    }>
  } | null
  categories?: {
    __typename?: "CategoryConnection"
    total: number
    edges: Array<{
      __typename?: "CategoryEdge"
      node: {
        __typename?: "Category"
        id: number
        name: string
        slug: string
        order: number
        description?: string | null
      }
    }>
  } | null
  groups?: {
    __typename?: "GroupConnection"
    total: number
    edges: Array<{
      __typename?: "GroupEdge"
      node: { __typename?: "Group"; id: number; seats_filled?: number | null }
    }>
  } | null
}

export type ManageResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ManageResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          description?: string | null
        }
      }>
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: { __typename?: "Group"; id: number; seats_filled?: number | null }
      }>
    } | null
  } | null
}

export type ResourceEditorsQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type ResourceEditorsQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    group?: {
      __typename?: "Group"
      id: number
      registrations?: {
        __typename?: "RegistrationConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "RegistrationEdge"
          node: {
            __typename?: "Registration"
            id: number
            role: number
            softArchivedTime?: any | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          }
        }>
      } | null
    } | null
  } | null
}

export type ResourceQueryQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type ResourceQueryQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    resource_type: number
  } | null
}

export type UpdateResourceAdvancedMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
  certificate_generator_class?: InputMaybe<Scalars["String"]["input"]>
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateResourceAdvancedMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          description?: string | null
        }
      }>
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: { __typename?: "Group"; id: number; seats_filled?: number | null }
      }>
    } | null
  } | null
}

export type UpdateResourceDetailsMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  description?: InputMaybe<Scalars["String"]["input"]>
  short_description?: InputMaybe<Scalars["String"]["input"]>
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  authors?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  categories?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
  cover_image?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateResourceDetailsMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          description?: string | null
        }
      }>
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: { __typename?: "Group"; id: number; seats_filled?: number | null }
      }>
    } | null
  } | null
}

export type UpdateResourceMenuMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  cover_image?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateResourceMenuMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          description?: string | null
        }
      }>
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: { __typename?: "Group"; id: number; seats_filled?: number | null }
      }>
    } | null
  } | null
}

export type UpdateResourceMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  cover_image?: InputMaybe<Scalars["String"]["input"]>
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  short_description?: InputMaybe<Scalars["String"]["input"]>
  authors?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  categories?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
  certificate_generator_class?: InputMaybe<Scalars["String"]["input"]>
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  certificateJSON?: InputMaybe<Scalars["JSON"]["input"]>
}>

export type UpdateResourceMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges: Array<{
        __typename?: "AuthorEdge"
        node: {
          __typename?: "Author"
          id: number
          order: number
          display_name: string
          full_name: string
          first_name: string
          last_name: string
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug: string
        }
      }>
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges: Array<{
        __typename?: "CategoryEdge"
        node: {
          __typename?: "Category"
          id: number
          name: string
          slug: string
          order: number
          description?: string | null
        }
      }>
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        node: { __typename?: "Group"; id: number; seats_filled?: number | null }
      }>
    } | null
  } | null
}

export type RestApiGetQueryVariables = Exact<{
  endpoint: Scalars["String"]["input"]
}>

export type RestApiGetQuery = { __typename?: "Query"; restAPIGet?: any | null }

export type CurriculumSubscriptionFragment = {
  __typename?: "CurriculumSubscription"
  id: number
  licensor: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
  }
  licensee: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
  }
  curriculum_plan?: {
    __typename?: "SchoolCurriculumPlan"
    id: number
    name?: string | null
    amount?: number | null
    fee_boundary?: number | null
    fee_per_user?: number | null
    is_visible?: boolean | null
    lower_boundary?: number | null
    plan_id?: number | null
    transaction_fee_percent?: number | null
    upper_boundary?: number | null
    visibility_code?: string | null
  } | null
  subscription?: {
    __typename?: "Subscription"
    id: number
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type CurriculumSubscriptionPlansQueryVariables = Exact<{
  visibilityCode?: InputMaybe<Scalars["String"]["input"]>
  visibilityCodeFilter?: InputMaybe<StringFilter>
}>

export type CurriculumSubscriptionPlansQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    curriculum_plans?: {
      __typename?: "SchoolCurriculumPlanConnection"
      edges: Array<{
        __typename?: "SchoolCurriculumPlanEdge"
        node: {
          __typename?: "SchoolCurriculumPlan"
          id: number
          name?: string | null
          amount?: number | null
          fee_boundary?: number | null
          fee_per_user?: number | null
          is_visible?: boolean | null
          lower_boundary?: number | null
          plan_id?: number | null
          transaction_fee_percent?: number | null
          upper_boundary?: number | null
          visibility_code?: string | null
        }
      }>
    } | null
  } | null
}

export type CurriculumSubscriptionQueryVariables = Exact<{
  schoolId: Scalars["Int"]["input"]
  curriculumSubscriptionId: Scalars["Int"]["input"]
}>

export type CurriculumSubscriptionQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      curriculum_subscription?: {
        __typename?: "CurriculumSubscription"
        id: number
        licensor: {
          __typename?: "School"
          id: number
          url: string
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          image_is_default: boolean
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
          resource_licensing_enabled?: boolean | null
        }
        licensee: {
          __typename?: "School"
          id: number
          url: string
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          image_is_default: boolean
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
          resource_licensing_enabled?: boolean | null
        }
        curriculum_plan?: {
          __typename?: "SchoolCurriculumPlan"
          id: number
          name?: string | null
          amount?: number | null
          fee_boundary?: number | null
          fee_per_user?: number | null
          is_visible?: boolean | null
          lower_boundary?: number | null
          plan_id?: number | null
          transaction_fee_percent?: number | null
          upper_boundary?: number | null
          visibility_code?: string | null
        } | null
        subscription?: {
          __typename?: "Subscription"
          id: number
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id: number
            name: string
            amount?: number | null
            interval: number
            trial_period_days: number
            trial_type: SubscriptionTrialType
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
      } | null
    }
  } | null
}

export type CurriculumSubscriptionsQueryVariables = Exact<{
  [key: string]: never
}>

export type CurriculumSubscriptionsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    curriculum_subscriptions?: {
      __typename?: "CurriculumSubscriptionConnection"
      edges: Array<{
        __typename?: "CurriculumSubscriptionEdge"
        node: {
          __typename?: "CurriculumSubscription"
          id: number
          licensor: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
          }
          licensee: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
          }
          curriculum_plan?: {
            __typename?: "SchoolCurriculumPlan"
            id: number
            name?: string | null
            amount?: number | null
            fee_boundary?: number | null
            fee_per_user?: number | null
            is_visible?: boolean | null
            lower_boundary?: number | null
            plan_id?: number | null
            transaction_fee_percent?: number | null
            upper_boundary?: number | null
            visibility_code?: string | null
          } | null
          subscription?: {
            __typename?: "Subscription"
            id: number
            quantity?: number | null
            canceled_dtime?: any | null
            cancellation_reason?: number | null
            card_last_4?: string | null
            cycle_end_dtime?: any | null
            cycle_start_dtime?: any | null
            is_canceled_at_cycle_end?: boolean | null
            is_delinquent?: boolean | null
            paused_until_dtime?: any | null
            trial_type?: number | null
            trial_end_dtime?: any | null
            payment_intent_needing_action_id?: string | null
            subscription_plan?: {
              __typename?: "SubscriptionPlan"
              id: number
              name: string
              amount?: number | null
              interval: number
              trial_period_days: number
              trial_type: SubscriptionTrialType
              plan_type?: string | null
              stripe_connected_account_url?: string | null
            } | null
            customer?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
          } | null
        }
      }>
    } | null
  } | null
}

export type SchoolCurriculumPlanFragment = {
  __typename?: "SchoolCurriculumPlan"
  id: number
  name?: string | null
  amount?: number | null
  fee_boundary?: number | null
  fee_per_user?: number | null
  is_visible?: boolean | null
  lower_boundary?: number | null
  plan_id?: number | null
  transaction_fee_percent?: number | null
  upper_boundary?: number | null
  visibility_code?: string | null
}

export type SchoolFragment = {
  __typename?: "School"
  id: number
  url: string
  name: string
  about?: string | null
  email?: string | null
  website?: string | null
  subdomain: string
  created?: any | null
  billing_model?: number | null
  platform_version?: number | null
  currency_code?: string | null
  ietf_language_tag?: string | null
  has_certificate?: boolean | null
  is_activated?: boolean | null
  is_curriculum_enabled?: boolean | null
  is_curriculum_subscriber?: boolean | null
  stripe_access_token?: string | null
  stripe_publishable_api_key?: string | null
  show_stripe_reconnect?: boolean | null
  payment_requires_zip_code?: boolean | null
  consent_description?: string | null
  image?: string | null
  image_is_default: boolean
  grant_access_upon_authentication?: boolean | null
  pathwright_login_enabled?: boolean | null
  resource_licensing_enabled?: boolean | null
}

export type SchoolQueryQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SchoolQueryQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      theme?: {
        __typename?: "Theme"
        id?: number | null
        name?: string | null
        theme_type?: ThemeType | null
        background_image?: string | null
        background_overlay?: string | null
        background_type?: number | null
        heading_font?: string | null
        primary_color?: string | null
        typekit_id?: string | null
        custom_css?: string | null
        processed_custom_css?: string | null
        color_palette?: {
          __typename?: "NodeThemeColorPalette"
          _50?: string | null
          _100?: string | null
          _200?: string | null
          _300?: string | null
          _400?: string | null
          _500?: string | null
          _600?: string | null
          _700?: string | null
          _800?: string | null
          _900?: string | null
          _950?: string | null
        } | null
      } | null
    }
  } | null
}

export type ThemeFragment = {
  __typename?: "Theme"
  id?: number | null
  name?: string | null
  theme_type?: ThemeType | null
  background_image?: string | null
  background_overlay?: string | null
  background_type?: number | null
  heading_font?: string | null
  primary_color?: string | null
  typekit_id?: string | null
  custom_css?: string | null
  processed_custom_css?: string | null
  color_palette?: {
    __typename?: "NodeThemeColorPalette"
    _50?: string | null
    _100?: string | null
    _200?: string | null
    _300?: string | null
    _400?: string | null
    _500?: string | null
    _600?: string | null
    _700?: string | null
    _800?: string | null
    _900?: string | null
    _950?: string | null
  } | null
}

export type UpdateSchoolCustomCssMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  customCss: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
}>

export type UpdateSchoolCustomCssMutation = {
  __typename?: "Mutations"
  updateSchoolCustomCSS?: {
    __typename?: "Theme"
    id?: number | null
    name?: string | null
    theme_type?: ThemeType | null
    background_image?: string | null
    background_overlay?: string | null
    background_type?: number | null
    heading_font?: string | null
    primary_color?: string | null
    typekit_id?: string | null
    custom_css?: string | null
    processed_custom_css?: string | null
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
      _950?: string | null
    } | null
  } | null
}

export type AddPeopleToMutationMutationVariables = Exact<{
  selection:
    | Array<InputMaybe<AddPeopleSelection>>
    | InputMaybe<AddPeopleSelection>
  notificationMessage?: InputMaybe<Scalars["String"]["input"]>
  sendFromSchool?: InputMaybe<Scalars["Boolean"]["input"]>
  sendNotification?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type AddPeopleToMutationMutation = {
  __typename?: "Mutations"
  addPeopleTo?: {
    __typename?: "BackgroundTask"
    id: any
    result?: any | null
  } | null
}

export type CohortShareContextQueryQueryVariables = Exact<{
  type: ShareContextType
  typeId: Scalars["Int"]["input"]
}>

export type CohortShareContextQueryQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    visibility?: number | null
    access_ends?: any | null
    registration_ends?: any | null
    status: GroupStatus
    seats_available?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      short_description?: string | null
      image_raw?: string | null
    } | null
  } | null
  sharePermissions?:
    | {
        __typename: "ShareCohortPermissions"
        type?: ShareContextType | null
        type_id?: number | null
        add_limit?: number | null
        allow_manage?: boolean | null
        manage_url?: string | null
        allow_activate?: boolean | null
        activate_contact_email?: any | null
        share_access?: {
          __typename?: "CohortShareAccess"
          access?: ShareAccessPermission | null
          gated_reason?: CohortShareAccessGatedReasonType | null
        } | null
        share_link_access?: {
          __typename?: "CohortShareLinkAccess"
          access?: ShareAccessPermission | null
          gated_reason?: CohortShareLinkAccessGatedReasonType | null
        } | null
        share_add_access?: {
          __typename?: "CohortShareAddAccess"
          access?: ShareAccessPermission | null
          gated_reason?: CohortShareAddAccessGatedReasonType | null
        } | null
        share_track_access?: {
          __typename?: "CohortShareTrackAccess"
          access?: ShareAccessPermission | null
          gated_reason?: CohortShareTrackAccessGatedReasonType | null
        } | null
        invite_roles?: {
          __typename?: "ShareCohortPermissionsInviteRoles"
          cohort_viewer?: {
            __typename?: "ShareCohortPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: CohortShareInviteRoleGatedReasonType | null
          } | null
          cohort_observer?: {
            __typename?: "ShareCohortPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: CohortShareInviteRoleGatedReasonType | null
          } | null
          cohort_learner?: {
            __typename?: "ShareCohortPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: CohortShareInviteRoleGatedReasonType | null
          } | null
          cohort_moderator?: {
            __typename?: "ShareCohortPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: CohortShareInviteRoleGatedReasonType | null
          } | null
          cohort_teacher?: {
            __typename?: "ShareCohortPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: CohortShareInviteRoleGatedReasonType | null
          } | null
          cohort_course_editor?: {
            __typename?: "ShareCohortPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: CohortShareInviteRoleGatedReasonType | null
          } | null
        } | null
      }
    | { __typename?: "ShareGroupPermissions" }
    | null
}

export type GroupShareContextQueryQueryVariables = Exact<{
  type: ShareContextType
  typeId: Scalars["Int"]["input"]
}>

export type GroupShareContextQueryQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    group?: {
      __typename?: "MentorGroup"
      id: number
      name: string
      description?: string | null
      type: number
      seat_limit?: number | null
      seats_available?: number | null
      seats_filled: number
      group_subscription?: {
        __typename?: "SchoolGroupSubscription"
        id: number
        subscription: {
          __typename?: "Subscription"
          id: number
          canceled_dtime?: any | null
        }
      } | null
    } | null
  } | null
  sharePermissions?:
    | { __typename?: "ShareCohortPermissions" }
    | {
        __typename: "ShareGroupPermissions"
        type?: ShareContextType | null
        type_id?: number | null
        add_limit?: number | null
        allow_manage?: boolean | null
        manage_url?: string | null
        allow_activate?: boolean | null
        activate_contact_email?: any | null
        share_access?: {
          __typename?: "GroupShareAccess"
          access?: ShareAccessPermission | null
          gated_reason?: GroupShareAccessGatedReasonType | null
        } | null
        share_link_access?: {
          __typename?: "GroupShareLinkAccess"
          access?: ShareAccessPermission | null
          gated_reason?: GroupShareLinkAccessGatedReasonType | null
        } | null
        share_add_access?: {
          __typename?: "GroupShareAddAccess"
          access?: ShareAccessPermission | null
          gated_reason?: GroupShareAddAccessGatedReasonType | null
        } | null
        share_track_access?: {
          __typename?: "GroupShareTrackAccess"
          access?: ShareAccessPermission | null
          gated_reason?: GroupShareTrackAccessGatedReasonType | null
        } | null
        invite_roles?: {
          __typename?: "ShareGroupPermissionsInviteRoles"
          group_member?: {
            __typename?: "ShareGroupPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: GroupShareInviteRoleGatedReasonType | null
          } | null
          group_moderator?: {
            __typename?: "ShareGroupPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: GroupShareInviteRoleGatedReasonType | null
          } | null
          group_admin?: {
            __typename?: "ShareGroupPermissionsInviteRole"
            url?: string | null
            role?: number | null
            gate_reason?: GroupShareInviteRoleGatedReasonType | null
          } | null
        } | null
      }
    | null
}

export type PeopleAndGroupConnectionFragment = {
  __typename?: "PeopleAndGroupConnection"
  id?: number | null
  type?: PeopleAndGroupConnectionType | null
  role?: Role | null
  role_in?: Role | null
  membership_status?: MembershipStatus | null
  people_count?: number | null
  meta: {
    __typename?: "NodeMeta"
    key: string
    type: string
    title?: string | null
    subtitle?: string | null
    _search?: string | null
    image?: { __typename?: "NodeImage"; src?: string | null } | null
  }
}

export type PeopleAndGroupConnectionQueryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["Int"]["input"]>
  groupId?: InputMaybe<Scalars["Int"]["input"]>
  cohortId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type PeopleAndGroupConnectionQueryQuery = {
  __typename?: "Query"
  peopleAndGroupConnection?: {
    __typename?: "PeopleAndGroupConnection"
    id?: number | null
    type?: PeopleAndGroupConnectionType | null
    role?: Role | null
    role_in?: Role | null
    membership_status?: MembershipStatus | null
    people_count?: number | null
    meta: {
      __typename?: "NodeMeta"
      key: string
      type: string
      title?: string | null
      subtitle?: string | null
      _search?: string | null
      image?: { __typename?: "NodeImage"; src?: string | null } | null
    }
  } | null
}

export type PeopleAndGroupConnectionsQueryQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<PeopleAndGroupConnectionContext>
  roleInContext?: InputMaybe<RoleInContext>
  type?: InputMaybe<PeopleAndGroupConnectionType>
  searchTerm?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
}>

export type PeopleAndGroupConnectionsQueryQuery = {
  __typename?: "Query"
  peopleAndGroupConnections?: {
    __typename?: "PeopleAndGroupConnectionConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "PeopleAndGroupConnectionEdge"
      node: {
        __typename?: "PeopleAndGroupConnection"
        id?: number | null
        type?: PeopleAndGroupConnectionType | null
        role?: Role | null
        role_in?: Role | null
        membership_status?: MembershipStatus | null
        people_count?: number | null
        meta: {
          __typename?: "NodeMeta"
          key: string
          type: string
          title?: string | null
          subtitle?: string | null
          _search?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      }
    }>
  } | null
}

export type CohortShareLimitQueryQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type CohortShareLimitQueryQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    resource_license?: {
      __typename?: "ResourceLicense"
      id?: number | null
    } | null
  } | null
}

export type CreateSchoolMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  subdomain: Scalars["String"]["input"]
  licensor_id?: InputMaybe<Scalars["Int"]["input"]>
  copy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  utm_source?: InputMaybe<Scalars["String"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_campaign?: InputMaybe<Scalars["String"]["input"]>
}>

export type CreateSchoolMutation = {
  __typename?: "Mutations"
  createSchool?: {
    __typename?: "School"
    id: number
    name: string
    profile?: { __typename?: "SchoolProfile"; id?: number | null } | null
  } | null
}

export type UpdateSchoolProfileMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  school_type?: InputMaybe<SchoolType>
  plan_to_sell?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateSchoolProfileMutation = {
  __typename?: "Mutations"
  updateSchoolProfile?: {
    __typename?: "SchoolProfile"
    id?: number | null
    school_type?: SchoolType | null
    plan_to_sell?: boolean | null
  } | null
}

export type UserSchoolLicenseQueryQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  licensorId?: InputMaybe<IdFilter>
}>

export type UserSchoolLicenseQueryQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    memberships?: {
      __typename?: "MembershipConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "MembershipEdge"
        node: {
          __typename?: "Membership"
          id: number
          role: number
          school: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
            storeLinks?: {
              __typename?: "StoreLinkConnection"
              total: number
              pageInfo: {
                __typename?: "PageInfo"
                endCursor?: string | null
                hasNextPage: boolean
              }
              edges: Array<{
                __typename?: "StoreLinkEdge"
                node: {
                  __typename?: "StoreLink"
                  id: number
                  licensee: {
                    __typename?: "School"
                    id: number
                    url: string
                    name: string
                    about?: string | null
                    email?: string | null
                    website?: string | null
                    subdomain: string
                    created?: any | null
                    billing_model?: number | null
                    platform_version?: number | null
                    currency_code?: string | null
                    ietf_language_tag?: string | null
                    has_certificate?: boolean | null
                    is_activated?: boolean | null
                    is_curriculum_enabled?: boolean | null
                    is_curriculum_subscriber?: boolean | null
                    stripe_access_token?: string | null
                    stripe_publishable_api_key?: string | null
                    show_stripe_reconnect?: boolean | null
                    payment_requires_zip_code?: boolean | null
                    consent_description?: string | null
                    image?: string | null
                    image_is_default: boolean
                    grant_access_upon_authentication?: boolean | null
                    pathwright_login_enabled?: boolean | null
                    resource_licensing_enabled?: boolean | null
                  }
                  store: {
                    __typename?: "Store"
                    id: number
                    licensor: {
                      __typename?: "School"
                      id: number
                      url: string
                      name: string
                      about?: string | null
                      email?: string | null
                      website?: string | null
                      subdomain: string
                      created?: any | null
                      billing_model?: number | null
                      platform_version?: number | null
                      currency_code?: string | null
                      ietf_language_tag?: string | null
                      has_certificate?: boolean | null
                      is_activated?: boolean | null
                      is_curriculum_enabled?: boolean | null
                      is_curriculum_subscriber?: boolean | null
                      stripe_access_token?: string | null
                      stripe_publishable_api_key?: string | null
                      show_stripe_reconnect?: boolean | null
                      payment_requires_zip_code?: boolean | null
                      consent_description?: string | null
                      image?: string | null
                      image_is_default: boolean
                      grant_access_upon_authentication?: boolean | null
                      pathwright_login_enabled?: boolean | null
                      resource_licensing_enabled?: boolean | null
                    }
                  }
                }
              }>
            } | null
            curriculum_subscriptions?: {
              __typename?: "CurriculumSubscriptionConnection"
              total: number
              pageInfo: {
                __typename?: "PageInfo"
                endCursor?: string | null
                hasNextPage: boolean
              }
              edges: Array<{
                __typename?: "CurriculumSubscriptionEdge"
                node: {
                  __typename?: "CurriculumSubscription"
                  id: number
                  licensor: {
                    __typename?: "School"
                    id: number
                    url: string
                    name: string
                    about?: string | null
                    email?: string | null
                    website?: string | null
                    subdomain: string
                    created?: any | null
                    billing_model?: number | null
                    platform_version?: number | null
                    currency_code?: string | null
                    ietf_language_tag?: string | null
                    has_certificate?: boolean | null
                    is_activated?: boolean | null
                    is_curriculum_enabled?: boolean | null
                    is_curriculum_subscriber?: boolean | null
                    stripe_access_token?: string | null
                    stripe_publishable_api_key?: string | null
                    show_stripe_reconnect?: boolean | null
                    payment_requires_zip_code?: boolean | null
                    consent_description?: string | null
                    image?: string | null
                    image_is_default: boolean
                    grant_access_upon_authentication?: boolean | null
                    pathwright_login_enabled?: boolean | null
                    resource_licensing_enabled?: boolean | null
                  }
                  curriculum_plan?: {
                    __typename?: "SchoolCurriculumPlan"
                    id: number
                    plan_id?: number | null
                  } | null
                }
              }>
            } | null
          }
        }
      }>
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type BlurredThemeBackgroundImageQueryVariables = Exact<{
  url: Scalars["String"]["input"]
  width?: InputMaybe<Scalars["Int"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  balph?: InputMaybe<Scalars["Int"]["input"]>
  fm?: InputMaybe<Scalars["String"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
}>

export type BlurredThemeBackgroundImageQuery = {
  __typename?: "Query"
  media?: { __typename?: "Media"; image?: string | null } | null
}

export type CreatedSpaceFragment = {
  __typename?: "School"
  id: number
  name: string
  profile?: { __typename?: "SchoolProfile"; id?: number | null } | null
}

export type CreateSpaceMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  subdomain: Scalars["String"]["input"]
  copy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  utm_source?: InputMaybe<Scalars["String"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_campaign?: InputMaybe<Scalars["String"]["input"]>
  signup_config_key?: InputMaybe<Scalars["String"]["input"]>
  rewardful_referral_id?: InputMaybe<Scalars["String"]["input"]>
  theme?: InputMaybe<ThemeInput>
}>

export type CreateSpaceMutation = {
  __typename?: "Mutations"
  createSchool?: {
    __typename?: "School"
    id: number
    name: string
    profile?: { __typename?: "SchoolProfile"; id?: number | null } | null
  } | null
}

export type SpaceBillingPlanSetQueryVariables = Exact<{ [key: string]: never }>

export type SpaceBillingPlanSetQuery = {
  __typename?: "Query"
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    billing_plan_set?: {
      __typename?: "SchoolBillingPlanSet"
      id?: number | null
      name?: string | null
      is_default?: boolean | null
      plans?: Array<{
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
      } | null> | null
    } | null
  } | null
}

export type SpaceBillingPlanSetPlanFragment = {
  __typename?: "SchoolBillingPlan"
  id: number
  name: string
}

export type SpaceIdentityFragment = {
  __typename?: "School"
  id: number
  name: string
  image?: string | null
  image_is_default: boolean
  url: string
  theme?: {
    __typename?: "Theme"
    id?: number | null
    name?: string | null
    theme_type?: ThemeType | null
    background_image?: string | null
    background_overlay?: string | null
    background_type?: number | null
    heading_font?: string | null
    primary_color?: string | null
    typekit_id?: string | null
    custom_css?: string | null
    processed_custom_css?: string | null
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
      _950?: string | null
    } | null
  } | null
}

export type SubdomainQueryVariables = Exact<{
  subdomain?: InputMaybe<Scalars["String"]["input"]>
}>

export type SubdomainQuery = {
  __typename?: "Query"
  subdomain?: {
    __typename?: "Subdomain"
    id?: number | null
    subdomain?: string | null
  } | null
}

export type UpdateSpaceProfileMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  school_type?: InputMaybe<SchoolType>
  plan_to_sell?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateSpaceProfileMutation = {
  __typename?: "Mutations"
  updateSchoolProfile?: {
    __typename?: "SchoolProfile"
    id?: number | null
    school_type?: SchoolType | null
    plan_to_sell?: boolean | null
  } | null
}

export type UserCreatedSpaceMembershipsQueryVariables = Exact<{
  [key: string]: never
}>

export type UserCreatedSpaceMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    memberships?: {
      __typename?: "MembershipConnection"
      edges: Array<{
        __typename?: "MembershipEdge"
        node: {
          __typename?: "Membership"
          id: number
          school: {
            __typename?: "School"
            subdomain: string
            id: number
            name: string
            profile?: {
              __typename?: "SchoolProfile"
              id?: number | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type UserSpaceMembershipFragment = {
  __typename?: "Membership"
  id: number
  role: number
  last_seen?: any | null
  school: {
    __typename?: "School"
    id: number
    name: string
    image?: string | null
    image_is_default: boolean
    url: string
    theme?: {
      __typename?: "Theme"
      id?: number | null
      name?: string | null
      theme_type?: ThemeType | null
      background_image?: string | null
      background_overlay?: string | null
      background_type?: number | null
      heading_font?: string | null
      primary_color?: string | null
      typekit_id?: string | null
      custom_css?: string | null
      processed_custom_css?: string | null
      color_palette?: {
        __typename?: "NodeThemeColorPalette"
        _50?: string | null
        _100?: string | null
        _200?: string | null
        _300?: string | null
        _400?: string | null
        _500?: string | null
        _600?: string | null
        _700?: string | null
        _800?: string | null
        _900?: string | null
        _950?: string | null
      } | null
    } | null
  }
}

export type UserSpaceMembershipsQueryVariables = Exact<{ [key: string]: never }>

export type UserSpaceMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    memberships?: {
      __typename?: "MembershipConnection"
      edges: Array<{
        __typename?: "MembershipEdge"
        node: {
          __typename?: "Membership"
          id: number
          role: number
          last_seen?: any | null
          school: {
            __typename?: "School"
            id: number
            name: string
            image?: string | null
            image_is_default: boolean
            url: string
            theme?: {
              __typename?: "Theme"
              id?: number | null
              name?: string | null
              theme_type?: ThemeType | null
              background_image?: string | null
              background_overlay?: string | null
              background_type?: number | null
              heading_font?: string | null
              primary_color?: string | null
              typekit_id?: string | null
              custom_css?: string | null
              processed_custom_css?: string | null
              color_palette?: {
                __typename?: "NodeThemeColorPalette"
                _50?: string | null
                _100?: string | null
                _200?: string | null
                _300?: string | null
                _400?: string | null
                _500?: string | null
                _600?: string | null
                _700?: string | null
                _800?: string | null
                _900?: string | null
                _950?: string | null
              } | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type CreateMessageMutationVariables = Exact<{
  message_context: MessageContext
  message: MessageInput
}>

export type CreateMessageMutation = {
  __typename?: "Mutations"
  createMessage?: {
    __typename?: "Message"
    id: number
    subject?: string | null
    body?: string | null
    threshold_minutes: number
    type: MessageType
    channels: Array<MessageChannel>
    is_active: boolean
    send_date?: any | null
    sent_date?: any | null
    based_on_step_date?: MessageStepDateField | null
    recipient_filter?: MessageRecipientFilter | null
  } | null
}

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  message_context: MessageContext
}>

export type DeleteMessageMutation = {
  __typename?: "Mutations"
  deleteMessage?: boolean | null
}

export type MessageFragment = {
  __typename?: "Message"
  id: number
  subject?: string | null
  body?: string | null
  threshold_minutes: number
  type: MessageType
  channels: Array<MessageChannel>
  is_active: boolean
  send_date?: any | null
  sent_date?: any | null
  based_on_step_date?: MessageStepDateField | null
  recipient_filter?: MessageRecipientFilter | null
}

export type MessageQueryVariables = Exact<{
  message_context: MessageContext
  id: Scalars["Int"]["input"]
}>

export type MessageQuery = {
  __typename?: "Query"
  message?: {
    __typename?: "Message"
    id: number
    subject?: string | null
    body?: string | null
    threshold_minutes: number
    type: MessageType
    channels: Array<MessageChannel>
    is_active: boolean
    send_date?: any | null
    sent_date?: any | null
    based_on_step_date?: MessageStepDateField | null
    recipient_filter?: MessageRecipientFilter | null
  } | null
}

export type MessagesQueryVariables = Exact<{
  message_context: MessageContext
  type?: InputMaybe<MessageTypeFilter>
}>

export type MessagesQuery = {
  __typename?: "Query"
  messages?: {
    __typename?: "MessageConnection"
    edges: Array<{
      __typename?: "MessageEdge"
      node: {
        __typename?: "Message"
        id: number
        subject?: string | null
        body?: string | null
        threshold_minutes: number
        type: MessageType
        channels: Array<MessageChannel>
        is_active: boolean
        send_date?: any | null
        sent_date?: any | null
        based_on_step_date?: MessageStepDateField | null
        recipient_filter?: MessageRecipientFilter | null
      }
    }>
  } | null
}

export type PathItemRemindersQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type PathItemRemindersQuery = {
  __typename?: "Query"
  pathItem?: {
    __typename?: "PathItem"
    id: number
    reminders?: {
      __typename?: "MessageConnection"
      edges: Array<{
        __typename?: "MessageEdge"
        node: {
          __typename?: "Message"
          id: number
          subject?: string | null
          body?: string | null
          threshold_minutes: number
          type: MessageType
          channels: Array<MessageChannel>
          is_active: boolean
          send_date?: any | null
          sent_date?: any | null
          based_on_step_date?: MessageStepDateField | null
          recipient_filter?: MessageRecipientFilter | null
        }
      }>
    } | null
  } | null
}

export type ScheduleItemMutationVariables = Exact<{
  schedule_context: ScheduleItemContext
  starts?: InputMaybe<Scalars["DateTime"]["input"]>
  due?: InputMaybe<Scalars["DateTime"]["input"]>
  passive_starts?: InputMaybe<Scalars["Boolean"]["input"]>
  passive_due?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type ScheduleItemMutation = {
  __typename?: "Mutations"
  scheduleItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    copied_from_id?: number | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      school_id?: number | null
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id: number
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UpdateMessageMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  message_context: MessageContext
  message: MessageInput
}>

export type UpdateMessageMutation = {
  __typename?: "Mutations"
  updateMessage?: {
    __typename?: "Message"
    id: number
    subject?: string | null
    body?: string | null
    threshold_minutes: number
    type: MessageType
    channels: Array<MessageChannel>
    is_active: boolean
    send_date?: any | null
    sent_date?: any | null
    based_on_step_date?: MessageStepDateField | null
    recipient_filter?: MessageRecipientFilter | null
  } | null
}

export type CreateStoreLinkMutationVariables = Exact<{
  schoolId: Scalars["Int"]["input"]
  copy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
}>

export type CreateStoreLinkMutation = {
  __typename?: "Mutations"
  createStoreLink?: {
    __typename?: "StoreLink"
    id: number
    licensee: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
    }
    store: {
      __typename?: "Store"
      id: number
      licensor: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      }
    }
  } | null
}

export type ResourceOfferingsQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licenseeIdFilter?: InputMaybe<IdFilter>
  include_school_license: Scalars["Boolean"]["input"]
  skip_group_offerings: Scalars["Boolean"]["input"]
  skip_license_offerings: Scalars["Boolean"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}>

export type ResourceOfferingsQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      resource?: {
        __typename?: "Resource"
        id: number
        license_offerings?: {
          __typename?: "LicenseOfferingConnection"
          total: number
          edges: Array<{
            __typename?: "LicenseOfferingEdge"
            node: {
              __typename?: "LicenseOffering"
              id?: number | null
              description?: string | null
              cost_per_seat?: number | null
              include_creator_seat?: boolean | null
              register_creator_as?: RegistrationRoleEnum | null
              minimum_seat_count?: number | null
              minimum_license_duration?: number | null
              licensing_mode?: LicenseOfferingLicensingMode | null
              included_in_user_subscription?: boolean | null
              school_license?: {
                __typename?: "ResourceLicense"
                id?: number | null
              } | null
              include_in_school_curriculum_subscriptions?: {
                __typename?: "CurriculumSubscriptionConnection"
                total: number
              } | null
              include_in_curriculum_plans?: {
                __typename?: "SchoolCurriculumPlanConnection"
                total: number
                edges: Array<{
                  __typename?: "SchoolCurriculumPlanEdge"
                  node: {
                    __typename?: "SchoolCurriculumPlan"
                    id: number
                    plan_id?: number | null
                  }
                }>
              } | null
              include_in_subscription_plans?: {
                __typename?: "SchoolSubscriptionPlanConnection"
                total: number
                edges: Array<{
                  __typename?: "SchoolSubscriptionPlanEdge"
                  node: { __typename?: "SchoolSubscriptionPlan"; id: number }
                }>
              } | null
              include_with_products?: {
                __typename?: "StripeProductConnection"
                total: number
                edges: Array<{
                  __typename?: "StripeProductEdge"
                  node: { __typename?: "StripeProduct"; id: number }
                }>
              } | null
              licensor?: {
                __typename?: "School"
                id: number
                url: string
                name: string
                about?: string | null
                email?: string | null
                website?: string | null
                subdomain: string
                created?: any | null
                billing_model?: number | null
                platform_version?: number | null
                currency_code?: string | null
                ietf_language_tag?: string | null
                has_certificate?: boolean | null
                is_activated?: boolean | null
                is_curriculum_enabled?: boolean | null
                is_curriculum_subscriber?: boolean | null
                stripe_access_token?: string | null
                stripe_publishable_api_key?: string | null
                show_stripe_reconnect?: boolean | null
                payment_requires_zip_code?: boolean | null
                consent_description?: string | null
                image?: string | null
                image_is_default: boolean
                grant_access_upon_authentication?: boolean | null
                pathwright_login_enabled?: boolean | null
                resource_licensing_enabled?: boolean | null
              } | null
            }
          }>
        } | null
        group_offerings?: {
          __typename?: "GroupConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "GroupEdge"
            node: {
              __typename?: "Group"
              id: number
              name: string
              created?: any | null
              description?: string | null
              price?: number | null
              seats?: number | null
              seats_filled?: number | null
              seats_available?: number | null
              registration_ends?: any | null
              registration_starts?: any | null
              registration_started?: boolean | null
              registration_ended?: boolean | null
              access_ends?: any | null
              access_starts?: any | null
              is_master?: boolean | null
              is_source_cohort?: boolean | null
              source_cohort_id?: number | null
              parent_section_id?: number | null
              resource_id?: number | null
              visibility?: number | null
              is_collection_linked?: boolean | null
              is_subscription_only?: boolean | null
              status: GroupStatus
              analytics_disabled?: boolean | null
              created_by_id?: number | null
              include_in_plans?: {
                __typename?: "SchoolSubscriptionPlanConnection"
                edges: Array<{
                  __typename?: "SchoolSubscriptionPlanEdge"
                  node: {
                    __typename?: "SchoolSubscriptionPlan"
                    id: number
                    image?: string | null
                    details_html?: string | null
                    subscribe_complete_html?: string | null
                    catalog_header?: string | null
                    is_visible?: boolean | null
                    giftable_cycles?: Array<number | null> | null
                    subscription_plan: {
                      __typename?: "SubscriptionPlan"
                      id: number
                      name: string
                      amount?: number | null
                      interval: number
                      trial_period_days: number
                      trial_type: SubscriptionTrialType
                      plan_type?: string | null
                      stripe_connected_account_url?: string | null
                    }
                  }
                }>
              } | null
            }
          }>
        } | null
      } | null
    }
  } | null
}

export type StoreFragment = {
  __typename?: "Store"
  id: number
  licensor: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
  }
}

export type StoreLinkFragment = {
  __typename?: "StoreLink"
  id: number
  licensee: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
  }
  store: {
    __typename?: "Store"
    id: number
    licensor: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
    }
  }
}

export type StoreLinkQueryVariables = Exact<{
  licensorId?: InputMaybe<IntFilter>
}>

export type StoreLinkQuery = {
  __typename?: "Query"
  storeLink?: {
    __typename?: "StoreLink"
    id: number
    licensee: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
    }
    store: {
      __typename?: "Store"
      id: number
      licensor: {
        __typename?: "School"
        id: number
        url: string
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        image_is_default: boolean
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
        resource_licensing_enabled?: boolean | null
      }
    }
  } | null
}

export type StoreLinksQueryVariables = Exact<{
  licensorId?: InputMaybe<IdFilter>
}>

export type StoreLinksQuery = {
  __typename?: "Query"
  storeLinks?: {
    __typename?: "StoreLinkConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "StoreLinkEdge"
      node: {
        __typename?: "StoreLink"
        id: number
        licensee: {
          __typename?: "School"
          id: number
          url: string
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          image_is_default: boolean
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
          resource_licensing_enabled?: boolean | null
        }
        store: {
          __typename?: "Store"
          id: number
          licensor: {
            __typename?: "School"
            id: number
            url: string
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            image_is_default: boolean
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
            resource_licensing_enabled?: boolean | null
          }
        }
      }
    }>
  } | null
}

export type StoreQueryVariables = Exact<{ [key: string]: never }>

export type StoreQuery = {
  __typename?: "Query"
  store?: {
    __typename?: "Store"
    id: number
    licensor: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
    }
  } | null
}

export type StoreResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  school_id: Scalars["Int"]["input"]
  include_publisher: Scalars["Boolean"]["input"]
  include_school_license: Scalars["Boolean"]["input"]
  include_license_offerings: Scalars["Boolean"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licenseeIdFilter?: InputMaybe<IdFilter>
}>

export type StoreResourceQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      resource?: {
        __typename?: "Resource"
        trailer_embed_code?: string | null
        visibility_level_override?: number | null
        certificate_generator_class?: string | null
        licensed_from_resource_id?: number | null
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        blurred_background?: string | null
        cover_image: string
        school?: {
          __typename?: "School"
          id: number
          url: string
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          image_is_default: boolean
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
          resource_licensing_enabled?: boolean | null
        } | null
        publisher?: {
          __typename?: "Publisher"
          id?: number | null
          name?: string | null
          about?: string | null
          website?: string | null
          image?: string | null
          theme?: {
            __typename?: "Theme"
            id?: number | null
            name?: string | null
            theme_type?: ThemeType | null
            background_image?: string | null
            background_overlay?: string | null
            background_type?: number | null
            heading_font?: string | null
            primary_color?: string | null
            typekit_id?: string | null
            custom_css?: string | null
            processed_custom_css?: string | null
            color_palette?: {
              __typename?: "NodeThemeColorPalette"
              _50?: string | null
              _100?: string | null
              _200?: string | null
              _300?: string | null
              _400?: string | null
              _500?: string | null
              _600?: string | null
              _700?: string | null
              _800?: string | null
              _900?: string | null
              _950?: string | null
            } | null
          } | null
        } | null
        registration_meta?: {
          __typename?: "RegistrationMeta"
          editor_registration_count?: number | null
        } | null
        school_licenses?: {
          __typename?: "ResourceLicenseConnection"
          edges: Array<{
            __typename?: "ResourceLicenseEdge"
            node: {
              __typename?: "ResourceLicense"
              id?: number | null
              group?: {
                __typename?: "Group"
                id: number
                resource_id?: number | null
              } | null
            }
          }>
        } | null
        authors?: {
          __typename?: "AuthorConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "AuthorEdge"
            node: {
              __typename?: "Author"
              id: number
              order: number
              display_name: string
              full_name: string
              first_name: string
              last_name: string
              title?: string | null
              image?: string | null
              bio?: string | null
              avatar?: string | null
              salutation?: string | null
              slug: string
            }
          }>
        } | null
        categories?: {
          __typename?: "CategoryConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "CategoryEdge"
            node: {
              __typename?: "Category"
              id: number
              name: string
              slug: string
              order: number
              description?: string | null
            }
          }>
        } | null
        groups?: {
          __typename?: "GroupConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges: Array<{
            __typename?: "GroupEdge"
            node: {
              __typename?: "Group"
              id: number
              name: string
              created?: any | null
              description?: string | null
              price?: number | null
              seats?: number | null
              seats_filled?: number | null
              seats_available?: number | null
              registration_ends?: any | null
              registration_starts?: any | null
              registration_started?: boolean | null
              registration_ended?: boolean | null
              access_ends?: any | null
              access_starts?: any | null
              is_master?: boolean | null
              is_source_cohort?: boolean | null
              source_cohort_id?: number | null
              parent_section_id?: number | null
              resource_id?: number | null
              visibility?: number | null
              is_collection_linked?: boolean | null
              is_subscription_only?: boolean | null
              status: GroupStatus
              analytics_disabled?: boolean | null
              created_by_id?: number | null
              path: {
                __typename?: "Path"
                id: number
                items?: {
                  __typename?: "PathItemConnection"
                  total: number
                } | null
              }
            }
          }>
        } | null
        license_offerings?: {
          __typename?: "LicenseOfferingConnection"
          total: number
          edges: Array<{
            __typename?: "LicenseOfferingEdge"
            node: {
              __typename?: "LicenseOffering"
              id?: number | null
              description?: string | null
              cost_per_seat?: number | null
              include_creator_seat?: boolean | null
              register_creator_as?: RegistrationRoleEnum | null
              minimum_seat_count?: number | null
              minimum_license_duration?: number | null
              licensing_mode?: LicenseOfferingLicensingMode | null
              included_in_user_subscription?: boolean | null
              include_in_school_curriculum_subscriptions?: {
                __typename?: "CurriculumSubscriptionConnection"
                total: number
              } | null
              include_in_curriculum_plans?: {
                __typename?: "SchoolCurriculumPlanConnection"
                total: number
                edges: Array<{
                  __typename?: "SchoolCurriculumPlanEdge"
                  node: {
                    __typename?: "SchoolCurriculumPlan"
                    id: number
                    plan_id?: number | null
                  }
                }>
              } | null
              include_in_subscription_plans?: {
                __typename?: "SchoolSubscriptionPlanConnection"
                total: number
                edges: Array<{
                  __typename?: "SchoolSubscriptionPlanEdge"
                  node: { __typename?: "SchoolSubscriptionPlan"; id: number }
                }>
              } | null
              include_with_products?: {
                __typename?: "StripeProductConnection"
                total: number
                edges: Array<{
                  __typename?: "StripeProductEdge"
                  node: { __typename?: "StripeProduct"; id: number }
                }>
              } | null
              licensor?: {
                __typename?: "School"
                id: number
                url: string
                name: string
                about?: string | null
                email?: string | null
                website?: string | null
                subdomain: string
                created?: any | null
                billing_model?: number | null
                platform_version?: number | null
                currency_code?: string | null
                ietf_language_tag?: string | null
                has_certificate?: boolean | null
                is_activated?: boolean | null
                is_curriculum_enabled?: boolean | null
                is_curriculum_subscriber?: boolean | null
                stripe_access_token?: string | null
                stripe_publishable_api_key?: string | null
                show_stripe_reconnect?: boolean | null
                payment_requires_zip_code?: boolean | null
                consent_description?: string | null
                image?: string | null
                image_is_default: boolean
                grant_access_upon_authentication?: boolean | null
                pathwright_login_enabled?: boolean | null
                resource_licensing_enabled?: boolean | null
              } | null
            }
          }>
        } | null
        group?: {
          __typename?: "Group"
          id: number
          path: {
            __typename?: "Path"
            id: number
            items?: { __typename?: "PathItemConnection"; total: number } | null
            previewable_steps?: {
              __typename?: "PathItemConnection"
              edges: Array<{
                __typename?: "PathItemEdge"
                node: {
                  __typename?: "PathItem"
                  id: number
                  source_id: number
                  name: string
                  assignment_type?: PathItemAssignmentType | null
                }
              }>
            } | null
          }
        } | null
      } | null
    }
  } | null
}

export type StoreResourcesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  category_ids?: InputMaybe<IdFilter>
  publisher_ids?: InputMaybe<IdFilter>
  resource_types?: InputMaybe<ResourceTypeFilter>
  visibility?: InputMaybe<ResourceVisibility>
  school_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  include_school_license: Scalars["Boolean"]["input"]
  user_registered?: InputMaybe<IdFilter>
}>

export type StoreResourcesQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      resources?: {
        __typename?: "ResourceConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges: Array<{
          __typename?: "ResourceEdge"
          node: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum?: { __typename?: "Group"; id: number } | null
            publisher?: {
              __typename?: "Publisher"
              id?: number | null
              name?: string | null
              about?: string | null
              website?: string | null
              image?: string | null
            } | null
            authors?: {
              __typename?: "AuthorConnection"
              total: number
              edges: Array<{
                __typename?: "AuthorEdge"
                node: {
                  __typename?: "Author"
                  id: number
                  order: number
                  display_name: string
                  full_name: string
                  first_name: string
                  last_name: string
                  title?: string | null
                  image?: string | null
                  bio?: string | null
                  avatar?: string | null
                  salutation?: string | null
                  slug: string
                }
              }>
            } | null
            school_licenses?: {
              __typename?: "ResourceLicenseConnection"
              edges: Array<{
                __typename?: "ResourceLicenseEdge"
                node: { __typename?: "ResourceLicense"; id?: number | null }
              }>
            } | null
            license_offerings?: {
              __typename?: "LicenseOfferingConnection"
              total: number
            } | null
          }
        }>
      } | null
    }
  } | null
}

export type ResourceTrailerQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  school_id: Scalars["Int"]["input"]
}>

export type ResourceTrailerQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url: string
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      image_is_default: boolean
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource_licensing_enabled?: boolean | null
      resource?: {
        __typename?: "Resource"
        id: number
        trailer_embed_code?: string | null
      } | null
    }
  } | null
}

export type StripePriceFragment = {
  __typename?: "StripePrice"
  id: number
  active?: boolean | null
  billing_scheme?: StripeBillingScheme | null
  currency?: string | null
  nickname?: string | null
  recurring_interval?: StripeRecurringInterval | null
  recurring_interval_count?: number | null
  stripe_price_id?: string | null
  stripe_connected_account_url?: string | null
  tiers_mode?: StripeTiersMode | null
  unit_amount_decimal?: number | null
  tiers?: Array<{
    __typename?: "StripeTier"
    up_to?: number | null
    flat_amount?: number | null
    flat_amount_decimal?: string | null
    unit_amount?: number | null
    unit_amount_decimal?: string | null
  } | null> | null
  product?: {
    __typename?: "StripeProduct"
    id: number
    min_quantity?: number | null
    max_quantity?: number | null
  } | null
}

export type StripeProductFragment = {
  __typename?: "StripeProduct"
  id: number
  active?: boolean | null
  name?: string | null
  description?: string | null
  images?: Array<string | null> | null
  unit_label?: string | null
  stripe_product_id?: string | null
  stripe_connected_account_url?: string | null
  min_quantity?: number | null
  max_quantity?: number | null
}

export type StripeProductsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  after?: InputMaybe<Scalars["String"]["input"]>
  ids?: InputMaybe<IdFilter>
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type StripeProductsQuery = {
  __typename?: "Query"
  stripeProducts?: {
    __typename?: "StripeProductConnection"
    edges: Array<{
      __typename?: "StripeProductEdge"
      node: {
        __typename?: "StripeProduct"
        id: number
        active?: boolean | null
        name?: string | null
        description?: string | null
        images?: Array<string | null> | null
        unit_label?: string | null
        stripe_product_id?: string | null
        stripe_connected_account_url?: string | null
        min_quantity?: number | null
        max_quantity?: number | null
        stripe_prices?: {
          __typename?: "StripePriceConnection"
          edges: Array<{
            __typename?: "StripePriceEdge"
            node: {
              __typename?: "StripePrice"
              id: number
              active?: boolean | null
              billing_scheme?: StripeBillingScheme | null
              currency?: string | null
              nickname?: string | null
              recurring_interval?: StripeRecurringInterval | null
              recurring_interval_count?: number | null
              stripe_price_id?: string | null
              stripe_connected_account_url?: string | null
              tiers_mode?: StripeTiersMode | null
              unit_amount_decimal?: number | null
              tiers?: Array<{
                __typename?: "StripeTier"
                up_to?: number | null
                flat_amount?: number | null
                flat_amount_decimal?: string | null
                unit_amount?: number | null
                unit_amount_decimal?: string | null
              } | null> | null
              product?: {
                __typename?: "StripeProduct"
                id: number
                min_quantity?: number | null
                max_quantity?: number | null
              } | null
            }
          }>
        } | null
      }
    }>
  } | null
}

export type CancelSchoolSubscriptionMutationVariables = Exact<{
  for_user?: InputMaybe<Scalars["Int"]["input"]>
  cancel_immediately?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CancelSchoolSubscriptionMutation = {
  __typename?: "Mutations"
  cancelSchoolSubscription?: {
    __typename?: "SchoolSubscription"
    id: number
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
    subscription: {
      __typename?: "Subscription"
      id: number
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    }
    subscription_plan: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    }
    school_subscription_plan: {
      __typename?: "SchoolSubscriptionPlan"
      id: number
      image?: string | null
      details_html?: string | null
      subscribe_complete_html?: string | null
      catalog_header?: string | null
      is_visible?: boolean | null
      giftable_cycles?: Array<number | null> | null
      subscription_plan: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      }
    }
  } | null
}

export type FeatureIncludedCountQueryVariables = Exact<{ [key: string]: never }>

export type FeatureIncludedCountQuery = {
  __typename?: "Query"
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    billing_model?: number | null
    is_activated?: boolean | null
    is_activated_via_override?: boolean | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      extra_cohorts?: number | null
      extra_mentor_groups?: number | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        cohorts_included: number
        mentor_groups_included: number
      } | null
    } | null
  } | null
}

export type FeatureIncludedCountFragment = {
  __typename?: "SchoolAcount"
  id?: number | null
  billing_model?: number | null
  is_activated?: boolean | null
  is_activated_via_override?: boolean | null
  billing_subscription?: {
    __typename?: "SchoolBillingSubscription"
    id?: number | null
    extra_cohorts?: number | null
    extra_mentor_groups?: number | null
    plan?: {
      __typename?: "SchoolBillingPlan"
      id: number
      cohorts_included: number
      mentor_groups_included: number
    } | null
  } | null
}

export type RedeemSchoolGiftSubscriptionMutationVariables = Exact<{
  school_subscription_plan_id: Scalars["Int"]["input"]
  code: Scalars["String"]["input"]
}>

export type RedeemSchoolGiftSubscriptionMutation = {
  __typename?: "Mutations"
  redeemSchoolGiftSubscription?: {
    __typename?: "SchoolSubscription"
    id: number
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
    subscription: {
      __typename?: "Subscription"
      id: number
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    }
    subscription_plan: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    }
    school_subscription_plan: {
      __typename?: "SchoolSubscriptionPlan"
      id: number
      image?: string | null
      details_html?: string | null
      subscribe_complete_html?: string | null
      catalog_header?: string | null
      is_visible?: boolean | null
      giftable_cycles?: Array<number | null> | null
      subscription_plan: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      }
    }
  } | null
}

export type SchoolGiftSubscriptionFragment = {
  __typename?: "SchoolGiftSubscription"
  id?: number | null
  redeemed?: boolean | null
  recipient_email?: string | null
  recipient_email_sent_time?: any | null
  recipient_first_name?: string | null
  recipient_last_name?: string | null
  gifted_subscription_cycles?: number | null
  gift_message?: string | null
  gift_code?: string | null
  redemption_link?: string | null
  sender?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  school_subscription_plan?: {
    __typename?: "SchoolSubscriptionPlan"
    id: number
    image?: string | null
    details_html?: string | null
    subscribe_complete_html?: string | null
    catalog_header?: string | null
    is_visible?: boolean | null
    giftable_cycles?: Array<number | null> | null
    subscription_plan: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    }
  } | null
}

export type SchoolGiftSubscriptionQueryVariables = Exact<{
  code?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SchoolGiftSubscriptionQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    gift_subscription?: {
      __typename?: "SchoolGiftSubscription"
      id?: number | null
      redeemed?: boolean | null
      recipient_email?: string | null
      recipient_email_sent_time?: any | null
      recipient_first_name?: string | null
      recipient_last_name?: string | null
      gifted_subscription_cycles?: number | null
      gift_message?: string | null
      gift_code?: string | null
      redemption_link?: string | null
      sender?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      school_subscription_plan?: {
        __typename?: "SchoolSubscriptionPlan"
        id: number
        image?: string | null
        details_html?: string | null
        subscribe_complete_html?: string | null
        catalog_header?: string | null
        is_visible?: boolean | null
        giftable_cycles?: Array<number | null> | null
        subscription_plan: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        }
      } | null
    } | null
  } | null
}

export type SchoolGroupSubscriptionFragment = {
  __typename?: "SchoolGroupSubscription"
  id: number
  price: {
    __typename?: "StripePrice"
    id: number
    active?: boolean | null
    billing_scheme?: StripeBillingScheme | null
    currency?: string | null
    nickname?: string | null
    recurring_interval?: StripeRecurringInterval | null
    recurring_interval_count?: number | null
    stripe_price_id?: string | null
    stripe_connected_account_url?: string | null
    tiers_mode?: StripeTiersMode | null
    unit_amount_decimal?: number | null
    product?: {
      __typename?: "StripeProduct"
      id: number
      min_quantity?: number | null
      max_quantity?: number | null
      active?: boolean | null
      name?: string | null
      description?: string | null
      images?: Array<string | null> | null
      unit_label?: string | null
      stripe_product_id?: string | null
      stripe_connected_account_url?: string | null
    } | null
    tiers?: Array<{
      __typename?: "StripeTier"
      up_to?: number | null
      flat_amount?: number | null
      flat_amount_decimal?: string | null
      unit_amount?: number | null
      unit_amount_decimal?: string | null
    } | null> | null
  }
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
  subscription: {
    __typename?: "Subscription"
    id: number
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  }
  community_group: {
    __typename?: "MentorGroup"
    id: number
    type: number
    slug: string
    name: string
    description?: string | null
    created: any
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled: number
    seats_available?: number | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  }
}

export type SchoolGroupSubscriptionQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SchoolGroupSubscriptionQuery = {
  __typename?: "Query"
  schoolGroupSubscription?: {
    __typename?: "SchoolGroupSubscription"
    id: number
    price: {
      __typename?: "StripePrice"
      id: number
      active?: boolean | null
      billing_scheme?: StripeBillingScheme | null
      currency?: string | null
      nickname?: string | null
      recurring_interval?: StripeRecurringInterval | null
      recurring_interval_count?: number | null
      stripe_price_id?: string | null
      stripe_connected_account_url?: string | null
      tiers_mode?: StripeTiersMode | null
      unit_amount_decimal?: number | null
      product?: {
        __typename?: "StripeProduct"
        id: number
        min_quantity?: number | null
        max_quantity?: number | null
        active?: boolean | null
        name?: string | null
        description?: string | null
        images?: Array<string | null> | null
        unit_label?: string | null
        stripe_product_id?: string | null
        stripe_connected_account_url?: string | null
      } | null
      tiers?: Array<{
        __typename?: "StripeTier"
        up_to?: number | null
        flat_amount?: number | null
        flat_amount_decimal?: string | null
        unit_amount?: number | null
        unit_amount_decimal?: string | null
      } | null> | null
    }
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
    subscription: {
      __typename?: "Subscription"
      id: number
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    }
    community_group: {
      __typename?: "MentorGroup"
      id: number
      type: number
      slug: string
      name: string
      description?: string | null
      created: any
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled: number
      seats_available?: number | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    }
  } | null
}

export type SchoolGroupSubscriptionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  licenseOfferingId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SchoolGroupSubscriptionsQuery = {
  __typename?: "Query"
  schoolGroupSubscriptions?: {
    __typename?: "SchoolGroupSubscriptionConnection"
    edges: Array<{
      __typename?: "SchoolGroupSubscriptionEdge"
      node: {
        __typename?: "SchoolGroupSubscription"
        id: number
        price: {
          __typename?: "StripePrice"
          id: number
          active?: boolean | null
          billing_scheme?: StripeBillingScheme | null
          currency?: string | null
          nickname?: string | null
          recurring_interval?: StripeRecurringInterval | null
          recurring_interval_count?: number | null
          stripe_price_id?: string | null
          stripe_connected_account_url?: string | null
          tiers_mode?: StripeTiersMode | null
          unit_amount_decimal?: number | null
          product?: {
            __typename?: "StripeProduct"
            id: number
            min_quantity?: number | null
            max_quantity?: number | null
            active?: boolean | null
            name?: string | null
            description?: string | null
            images?: Array<string | null> | null
            unit_label?: string | null
            stripe_product_id?: string | null
            stripe_connected_account_url?: string | null
          } | null
          tiers?: Array<{
            __typename?: "StripeTier"
            up_to?: number | null
            flat_amount?: number | null
            flat_amount_decimal?: string | null
            unit_amount?: number | null
            unit_amount_decimal?: string | null
          } | null> | null
        }
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
        subscription: {
          __typename?: "Subscription"
          id: number
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id: number
            name: string
            amount?: number | null
            interval: number
            trial_period_days: number
            trial_type: SubscriptionTrialType
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        }
        community_group: {
          __typename?: "MentorGroup"
          id: number
          type: number
          slug: string
          name: string
          description?: string | null
          created: any
          modified?: any | null
          parent_id?: number | null
          has_child_groups?: boolean | null
          seat_limit?: number | null
          seats_filled: number
          seats_available?: number | null
          owner?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          permissions?: {
            __typename?: "MentorGroupPermissions"
            can_add_member?: boolean | null
            can_add_moderator?: boolean | null
            can_add_admin?: boolean | null
            can_add_group?: boolean | null
            can_edit_group?: boolean | null
            can_change_parent?: boolean | null
            can_edit_subscription?: boolean | null
            can_delete_group?: boolean | null
            can_update_member_review_permission?: boolean | null
            can_update_moderator_review_permission?: boolean | null
            can_update_admin_review_permission?: boolean | null
          } | null
        }
      }
    }>
  } | null
}

export type SchoolSubscriptionFragment = {
  __typename?: "SchoolSubscription"
  id: number
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
  subscription: {
    __typename?: "Subscription"
    id: number
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  }
  subscription_plan: {
    __typename?: "SubscriptionPlan"
    id: number
    name: string
    amount?: number | null
    interval: number
    trial_period_days: number
    trial_type: SubscriptionTrialType
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  }
  school_subscription_plan: {
    __typename?: "SchoolSubscriptionPlan"
    id: number
    image?: string | null
    details_html?: string | null
    subscribe_complete_html?: string | null
    catalog_header?: string | null
    is_visible?: boolean | null
    giftable_cycles?: Array<number | null> | null
    subscription_plan: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    }
  }
}

export type SchoolSubscriptionPlanFragment = {
  __typename?: "SchoolSubscriptionPlan"
  id: number
  image?: string | null
  details_html?: string | null
  subscribe_complete_html?: string | null
  catalog_header?: string | null
  is_visible?: boolean | null
  giftable_cycles?: Array<number | null> | null
  subscription_plan: {
    __typename?: "SubscriptionPlan"
    id: number
    name: string
    amount?: number | null
    interval: number
    trial_period_days: number
    trial_type: SubscriptionTrialType
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  }
}

export type SchoolSubscriptionPlansQueryVariables = Exact<{
  ids?: InputMaybe<IdFilter>
  visibility_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_code_filter?: InputMaybe<StringFilter>
  ignore_visibility?: InputMaybe<Scalars["Boolean"]["input"]>
  giftable?: InputMaybe<Scalars["Boolean"]["input"]>
  interval?: InputMaybe<SubscriptionInterval>
  intervalFilter?: InputMaybe<SubscriptionIntervalFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  orderBy?: InputMaybe<
    | Array<InputMaybe<SchoolSubscriptionPlanOrderByInput>>
    | InputMaybe<SchoolSubscriptionPlanOrderByInput>
  >
}>

export type SchoolSubscriptionPlansQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url: string
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    image_is_default: boolean
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    resource_licensing_enabled?: boolean | null
    subscription_plans?: {
      __typename?: "SchoolSubscriptionPlanConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: "SchoolSubscriptionPlanEdge"
        node: {
          __typename?: "SchoolSubscriptionPlan"
          position: string
          id: number
          image?: string | null
          details_html?: string | null
          subscribe_complete_html?: string | null
          catalog_header?: string | null
          is_visible?: boolean | null
          giftable_cycles?: Array<number | null> | null
          subscription_plan: {
            __typename?: "SubscriptionPlan"
            id: number
            name: string
            amount?: number | null
            interval: number
            trial_period_days: number
            trial_type: SubscriptionTrialType
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          }
        }
      }>
    } | null
  } | null
}

export type PositionedSchoolSubscriptionPlanFragment = {
  __typename?: "SchoolSubscriptionPlan"
  position: string
  id: number
  image?: string | null
  details_html?: string | null
  subscribe_complete_html?: string | null
  catalog_header?: string | null
  is_visible?: boolean | null
  giftable_cycles?: Array<number | null> | null
  subscription_plan: {
    __typename?: "SubscriptionPlan"
    id: number
    name: string
    amount?: number | null
    interval: number
    trial_period_days: number
    trial_type: SubscriptionTrialType
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  }
}

export type SendGiftSubscriptionEmailMutationVariables = Exact<{
  gift_id: Scalars["Int"]["input"]
  recipient_email: Scalars["String"]["input"]
}>

export type SendGiftSubscriptionEmailMutation = {
  __typename?: "Mutations"
  sendGiftSubscriptionEmail?: boolean | null
}

export type SubscriptionDiscountQueryVariables = Exact<{
  discount_code: Scalars["String"]["input"]
  school_plan_id: Scalars["Int"]["input"]
}>

export type SubscriptionDiscountQuery = {
  __typename?: "Query"
  schoolSubscriptionDiscount?: {
    __typename?: "SchoolSubscriptionDiscount"
    discount_percent?: number | null
    discounted_price?: number | null
    discounted_subscription_cycles?: number | null
    currency_display_discount_price?: string | null
    currency_display_discount_amount?: string | null
  } | null
}

export type SubscriptionFragment = {
  __typename?: "Subscription"
  id: number
  quantity?: number | null
  canceled_dtime?: any | null
  cancellation_reason?: number | null
  card_last_4?: string | null
  cycle_end_dtime?: any | null
  cycle_start_dtime?: any | null
  is_canceled_at_cycle_end?: boolean | null
  is_delinquent?: boolean | null
  paused_until_dtime?: any | null
  trial_type?: number | null
  trial_end_dtime?: any | null
  payment_intent_needing_action_id?: string | null
  subscription_plan?: {
    __typename?: "SubscriptionPlan"
    id: number
    name: string
    amount?: number | null
    interval: number
    trial_period_days: number
    trial_type: SubscriptionTrialType
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  } | null
  customer?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type SubscriptionPlanFragment = {
  __typename?: "SubscriptionPlan"
  id: number
  name: string
  amount?: number | null
  interval: number
  trial_period_days: number
  trial_type: SubscriptionTrialType
  plan_type?: string | null
  stripe_connected_account_url?: string | null
}

export type SubscriptionQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SubscriptionQuery = {
  __typename?: "Query"
  subscription?: {
    __typename?: "Subscription"
    payment_intent_client_secret?: string | null
    stripe_publishable_api_key?: string | null
    id: number
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id: number
      name: string
      amount?: number | null
      interval: number
      trial_period_days: number
      trial_type: SubscriptionTrialType
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type SubscriptionsQueryVariables = Exact<{
  paymentIntentNeedingActionIdFilter?: InputMaybe<IdFilter>
}>

export type SubscriptionsQuery = {
  __typename?: "Query"
  subscriptions?: {
    __typename?: "SubscriptionConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "SubscriptionEdge"
      node: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      }
    }>
  } | null
}

export type CreateTagAttachmentMutationVariables = Exact<{
  tagId: Scalars["Int"]["input"]
  context: TagAttachmentContextInput
  position?: InputMaybe<Scalars["String"]["input"]>
}>

export type CreateTagAttachmentMutation = {
  __typename?: "Mutations"
  createTagAttachment?: {
    __typename?: "TagAttachment"
    id?: number | null
    position?: string | null
    resource_id?: number | null
  } | null
}

export type CreateTagLinkMutationVariables = Exact<{
  tagId: Scalars["Int"]["input"]
  context: TagLinkContextInput
}>

export type CreateTagLinkMutation = {
  __typename?: "Mutations"
  createTagLink?: {
    __typename?: "TagLink"
    id?: number | null
    tag_id?: number | null
    discussion_context_id?: number | null
    tag?: {
      __typename?: "Tag"
      id: number
      name: string
      slug: string
      description?: string | null
      color?: string | null
    } | null
  } | null
}

export type CreateTagMutationVariables = Exact<{
  tag: TagCreateInput
}>

export type CreateTagMutation = {
  __typename?: "Mutations"
  createTag?: {
    __typename?: "Tag"
    id: number
    name: string
    description?: string | null
    color?: string | null
  } | null
}

export type DeleteTagAttachmentMutationVariables = Exact<{
  tagId: Scalars["Int"]["input"]
  context: TagAttachmentContextInput
}>

export type DeleteTagAttachmentMutation = {
  __typename?: "Mutations"
  deleteTagAttachment?: boolean | null
}

export type DeleteTagLinkMutationVariables = Exact<{
  tagId: Scalars["Int"]["input"]
  context: TagLinkContextInput
}>

export type DeleteTagLinkMutation = {
  __typename?: "Mutations"
  deleteTagLink?: boolean | null
}

export type DeleteTagMutationVariables = Exact<{
  tag: TagDeleteInput
}>

export type DeleteTagMutation = {
  __typename?: "Mutations"
  deleteTag?: boolean | null
}

export type TagAttachmentFragment = {
  __typename?: "TagAttachment"
  id?: number | null
  position?: string | null
  resource_id?: number | null
}

export type TagFragment = {
  __typename?: "Tag"
  id: number
  name: string
  slug: string
  description?: string | null
  color?: string | null
}

export type TagLinkFragment = {
  __typename?: "TagLink"
  id?: number | null
  tag_id?: number | null
  discussion_context_id?: number | null
}

export type TagsQueryVariables = Exact<{
  context?: InputMaybe<TagAttachmentContextInput>
  withContextualTagAttachment: Scalars["Boolean"]["input"]
}>

export type TagsQuery = {
  __typename?: "Query"
  tags?: {
    __typename?: "TagConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges: Array<{
      __typename?: "TagEdge"
      node: {
        __typename?: "Tag"
        id: number
        name: string
        slug: string
        description?: string | null
        color?: string | null
        tagAttachments?: {
          __typename?: "TagAttachmentConnection"
          total: number
          edges?: Array<{
            __typename?: "TagAttachmentEdge"
            node: {
              __typename?: "TagAttachment"
              id?: number | null
              position?: string | null
              resource_id?: number | null
            }
          }>
        } | null
      }
    }>
  } | null
}

export type UpdateTagAttachmentMutationVariables = Exact<{
  tagId: Scalars["Int"]["input"]
  context: TagAttachmentContextInput
  position?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateTagAttachmentMutation = {
  __typename?: "Mutations"
  updateTagAttachment?: {
    __typename?: "TagAttachment"
    id?: number | null
    position?: string | null
    resource_id?: number | null
  } | null
}

export type UpdateTagMutationVariables = Exact<{
  tag: TagUpdateInput
}>

export type UpdateTagMutation = {
  __typename?: "Mutations"
  updateTag?: {
    __typename?: "Tag"
    id: number
    name: string
    description?: string | null
    color?: string | null
  } | null
}

export type TranslationFragment = {
  __typename?: "Translation"
  id: number
  name?: string | null
  language: string
  translation: any
  master_translation?: any | null
  is_default: boolean
}

export type HomeCohortMembersFragment = {
  __typename?: "Group"
  id: number
  name: string
  user_registration?: {
    __typename?: "Registration"
    id: number
    user: {
      __typename?: "User"
      id: number
      first_name: string
      last_name: string
      full_name: string
      profile?: {
        __typename?: "Profile"
        id?: number | null
        image?: string | null
      } | null
    }
  } | null
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges: Array<{
      __typename?: "RegistrationEdge"
      node: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      }
    }>
  } | null
}

export type HomeCohortMembersQueryVariables = Exact<{
  groupId: Scalars["Int"]["input"]
}>

export type HomeCohortMembersQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    user_registration?: {
      __typename?: "Registration"
      id: number
      user: {
        __typename?: "User"
        id: number
        first_name: string
        last_name: string
        full_name: string
        profile?: {
          __typename?: "Profile"
          id?: number | null
          image?: string | null
        } | null
      }
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type HomeMentorGroupMembershipFragment = {
  __typename?: "MentorGroupMembership"
  id: number
  role: number
  created: any
  access_revoked_time?: any | null
  group_id: number
  send_mentor_digest?: boolean | null
  can_review: boolean
  group: {
    __typename?: "MentorGroup"
    id: number
    type: number
    slug: string
    name: string
    description?: string | null
    created: any
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled: number
    seats_available?: number | null
    memberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          created: any
          access_revoked_time?: any | null
          group_id: number
          send_mentor_digest?: boolean | null
          can_review: boolean
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  }
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type HomeMentorGroupMembershipsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  mentorGroupSeatLimitFilter?: InputMaybe<IntFilter>
}>

export type HomeMentorGroupMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          created: any
          access_revoked_time?: any | null
          group_id: number
          send_mentor_digest?: boolean | null
          can_review: boolean
          group: {
            __typename?: "MentorGroup"
            id: number
            type: number
            slug: string
            name: string
            description?: string | null
            created: any
            modified?: any | null
            parent_id?: number | null
            has_child_groups?: boolean | null
            seat_limit?: number | null
            seats_filled: number
            seats_available?: number | null
            memberships?: {
              __typename?: "MentorGroupMembershipConnection"
              total: number
              edges: Array<{
                __typename?: "MentorGroupMembershipEdge"
                node: {
                  __typename?: "MentorGroupMembership"
                  id: number
                  role: number
                  created: any
                  access_revoked_time?: any | null
                  group_id: number
                  send_mentor_digest?: boolean | null
                  can_review: boolean
                  user: {
                    __typename?: "User"
                    id: number
                    email?: string | null
                    first_name: string
                    last_name: string
                    full_name: string
                    display_name?: string | null
                    profile?: {
                      __typename?: "Profile"
                      id?: number | null
                      bio?: string | null
                      image?: string | null
                      imageRaw?: string | null
                      location?: string | null
                      last_activity?: any | null
                      rewardful_referral_id?: string | null
                    } | null
                  }
                }
              }>
            } | null
            owner?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            permissions?: {
              __typename?: "MentorGroupPermissions"
              can_add_member?: boolean | null
              can_add_moderator?: boolean | null
              can_add_admin?: boolean | null
              can_add_group?: boolean | null
              can_edit_group?: boolean | null
              can_change_parent?: boolean | null
              can_edit_subscription?: boolean | null
              can_delete_group?: boolean | null
              can_update_member_review_permission?: boolean | null
              can_update_moderator_review_permission?: boolean | null
              can_update_admin_review_permission?: boolean | null
            } | null
          }
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type HomeRegistrationsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  positioningContext: PositioningContextInput
  orderBy?: InputMaybe<
    | Array<InputMaybe<RegistrationOrderByInput>>
    | InputMaybe<RegistrationOrderByInput>
  >
  softArchived?: InputMaybe<DateFilter>
  progressFilter?: InputMaybe<ProgressFilter>
  lastSeen?: InputMaybe<DateFilter>
}>

export type HomeRegistrationsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    registrations?: {
      __typename?: "RegistrationConnection"
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          softArchivedTime?: any | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          position: string
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            groups?: { __typename?: "GroupConnection"; total: number } | null
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              path_id?: number | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
            user_source_registration?: {
              __typename?: "Registration"
              id: number
              role: number
            } | null
            registrations?: {
              __typename?: "RegistrationConnection"
              total: number
              edges: Array<{
                __typename?: "RegistrationEdge"
                node: {
                  __typename?: "Registration"
                  id: number
                  user: {
                    __typename?: "User"
                    id: number
                    first_name: string
                    last_name: string
                    full_name: string
                    profile?: {
                      __typename?: "Profile"
                      id?: number | null
                      image?: string | null
                    } | null
                  }
                }
              }>
            } | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
            next_step_id?: number | null
          } | null
        }
      }>
    } | null
  } | null
}

export type HomeResourceCopyConfigLinkConnectionsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  positioningContext: PositioningContextInput
  copiedTimeDateFilter?: InputMaybe<DateFilter>
  hideFromLocationsFilter?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocationFilter>>
    | InputMaybe<ResourceCopyConfigLinkLocationFilter>
  >
}>

export type HomeResourceCopyConfigLinkConnectionsQuery = {
  __typename?: "Query"
  resourceCopyConfigLinkConnections?: {
    __typename?: "ResourceCopyConfigLinkConnection"
    edges: Array<{
      __typename?: "ResourceCopyConfigLinkEdge"
      node: {
        __typename?: "ResourceCopyConfigLink"
        id: number
        createdTime: any
        copiedTime?: any | null
        resourceId?: number | null
        cohortId?: number | null
        copierRegistrationId?: number | null
        hideFromLocations?: any | null
        copierRegistration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          softArchivedTime?: any | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          position: string
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            groups?: { __typename?: "GroupConnection"; total: number } | null
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              path_id?: number | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
            user_source_registration?: {
              __typename?: "Registration"
              id: number
              role: number
            } | null
            registrations?: {
              __typename?: "RegistrationConnection"
              total: number
              edges: Array<{
                __typename?: "RegistrationEdge"
                node: {
                  __typename?: "Registration"
                  id: number
                  user: {
                    __typename?: "User"
                    id: number
                    first_name: string
                    last_name: string
                    full_name: string
                    profile?: {
                      __typename?: "Profile"
                      id?: number | null
                      image?: string | null
                    } | null
                  }
                }
              }>
            } | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
            next_step_id?: number | null
          } | null
        } | null
        resourceCopyConfig: {
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            children?: Array<{
              __typename?: "ResourceCopyConfig"
              id: number
              name?: string | null
              lookup_key: string
              copy_behavior: ResourceCopyConfigCopyBehavior
              allow_copy_via_link: boolean
              children?: Array<{
                __typename?: "ResourceCopyConfig"
                id: number
                name?: string | null
                lookup_key: string
                copy_behavior: ResourceCopyConfigCopyBehavior
                allow_copy_via_link: boolean
                resource?: {
                  __typename?: "ResourceCopyConfigResource"
                  id: number
                  meta: {
                    __typename?: "NodeMeta"
                    id: string
                    type: string
                    key: string
                    title?: string | null
                    image?: {
                      __typename?: "NodeImage"
                      src?: string | null
                    } | null
                  }
                } | null
              } | null> | null
              resource?: {
                __typename?: "ResourceCopyConfigResource"
                id: number
                meta: {
                  __typename?: "NodeMeta"
                  id: string
                  type: string
                  key: string
                  title?: string | null
                  image?: {
                    __typename?: "NodeImage"
                    src?: string | null
                  } | null
                }
              } | null
            } | null> | null
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        }
      }
    }>
  } | null
}

export type HomeResourceCopyConfigLinkRegistrationQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  positioningContext: PositioningContextInput
}>

export type HomeResourceCopyConfigLinkRegistrationQuery = {
  __typename?: "Query"
  resourceCopyConfigLink?: {
    __typename?: "ResourceCopyConfigLink"
    id: number
    createdTime: any
    copiedTime?: any | null
    resourceId?: number | null
    cohortId?: number | null
    copierRegistrationId?: number | null
    hideFromLocations?: any | null
    copierRegistration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      softArchivedTime?: any | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      position: string
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
      resource: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
        groups?: { __typename?: "GroupConnection"; total: number } | null
      }
      group: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        description?: string | null
        price?: number | null
        seats?: number | null
        seats_filled?: number | null
        seats_available?: number | null
        registration_ends?: any | null
        registration_starts?: any | null
        registration_started?: boolean | null
        registration_ended?: boolean | null
        access_ends?: any | null
        access_starts?: any | null
        is_master?: boolean | null
        is_source_cohort?: boolean | null
        source_cohort_id?: number | null
        parent_section_id?: number | null
        resource_id?: number | null
        visibility?: number | null
        is_collection_linked?: boolean | null
        is_subscription_only?: boolean | null
        status: GroupStatus
        analytics_disabled?: boolean | null
        created_by_id?: number | null
        user_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          path_id?: number | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
        user_source_registration?: {
          __typename?: "Registration"
          id: number
          role: number
        } | null
        registrations?: {
          __typename?: "RegistrationConnection"
          total: number
          edges: Array<{
            __typename?: "RegistrationEdge"
            node: {
              __typename?: "Registration"
              id: number
              user: {
                __typename?: "User"
                id: number
                first_name: string
                last_name: string
                full_name: string
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  image?: string | null
                } | null
              }
            }
          }>
        } | null
      }
      path?: {
        __typename?: "Path"
        id: number
        progress?: number | null
        completion_date?: any | null
        next_step_id?: number | null
      } | null
    } | null
    resourceCopyConfig: {
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    }
  } | null
}

export type HomeResourceGroupsQueryVariables = Exact<{
  resourceId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type HomeResourceGroupsQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    slug: string
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges: Array<{
        __typename?: "GroupEdge"
        group: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            path_id?: number | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
          user_source_registration?: {
            __typename?: "Registration"
            id: number
            role: number
          } | null
          registrations?: {
            __typename?: "RegistrationConnection"
            total: number
            edges: Array<{
              __typename?: "RegistrationEdge"
              node: {
                __typename?: "Registration"
                id: number
                user: {
                  __typename?: "User"
                  id: number
                  first_name: string
                  last_name: string
                  full_name: string
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    image?: string | null
                  } | null
                }
              }
            }>
          } | null
        }
      }>
    } | null
  } | null
}

export type InboxPendingReviewCountsQueryVariables = Exact<{
  targetIds: IntFilter
  targetType: InboxPendingReviewTarget
}>

export type InboxPendingReviewCountsQuery = {
  __typename?: "Query"
  inboxPendingReviewConnections?: {
    __typename?: "InboxPendingReviewConnection"
    edges: Array<{
      __typename?: "InboxPendingReviewEdge"
      node: {
        __typename?: "InboxPendingReview"
        id?: number | null
        count?: number | null
      }
    }>
  } | null
}

export type PathwrightIntercomGuidanceTeamMembersQueryVariables = Exact<{
  [key: string]: never
}>

export type PathwrightIntercomGuidanceTeamMembersQuery = {
  __typename?: "Query"
  integrations?: {
    __typename?: "Integrations"
    intercom?: {
      __typename?: "IntercomIntegration"
      team?: Array<{
        __typename?: "IntercomTeamMember"
        id: number
        name: string
        avatar?: string | null
      }> | null
    } | null
  } | null
}

export type SoftArchiveRegistrationMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  softArchive?: InputMaybe<Scalars["Boolean"]["input"]>
  positioningContext: PositioningContextInput
}>

export type SoftArchiveRegistrationMutation = {
  __typename?: "Mutations"
  softArchiveRegistration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    softArchivedTime?: any | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    position: string
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
    resource: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      groups?: { __typename?: "GroupConnection"; total: number } | null
    }
    group: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        path_id?: number | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
      user_source_registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
      registrations?: {
        __typename?: "RegistrationConnection"
        total: number
        edges: Array<{
          __typename?: "RegistrationEdge"
          node: {
            __typename?: "Registration"
            id: number
            user: {
              __typename?: "User"
              id: number
              first_name: string
              last_name: string
              full_name: string
              profile?: {
                __typename?: "Profile"
                id?: number | null
                image?: string | null
              } | null
            }
          }
        }>
      } | null
    }
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      completion_date?: any | null
      next_step_id?: number | null
    } | null
  } | null
}

export type UpdateUserMutationVariables = Exact<{
  user: UserInput
  profile: UserProfileInput
}>

export type UpdateUserMutation = {
  __typename?: "Mutations"
  updateUser?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type GroupListItemRegistrationFragment = {
  __typename?: "Registration"
  id: number
  user: {
    __typename?: "User"
    id: number
    first_name: string
    last_name: string
    full_name: string
    profile?: {
      __typename?: "Profile"
      id?: number | null
      image?: string | null
    } | null
  }
}

export type GroupListItemFragment = {
  __typename?: "Group"
  id: number
  name: string
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges: Array<{
      __typename?: "RegistrationEdge"
      node: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      }
    }>
  } | null
}

export type HomeGroupFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  description?: string | null
  price?: number | null
  seats?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  registration_ends?: any | null
  registration_starts?: any | null
  registration_started?: boolean | null
  registration_ended?: boolean | null
  access_ends?: any | null
  access_starts?: any | null
  is_master?: boolean | null
  is_source_cohort?: boolean | null
  source_cohort_id?: number | null
  parent_section_id?: number | null
  resource_id?: number | null
  visibility?: number | null
  is_collection_linked?: boolean | null
  is_subscription_only?: boolean | null
  status: GroupStatus
  analytics_disabled?: boolean | null
  created_by_id?: number | null
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    path_id?: number | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
  user_source_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges: Array<{
      __typename?: "RegistrationEdge"
      node: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      }
    }>
  } | null
}

export type HomeRegistrationFragment = {
  __typename?: "Registration"
  id: number
  role: number
  completion_state?: number | null
  send_due_notifications?: boolean | null
  send_discussion_notifications?: boolean | null
  softArchivedTime?: any | null
  last_activity_time?: any | null
  expiration_dtime?: any | null
  created?: any | null
  position: string
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
  resource: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    groups?: { __typename?: "GroupConnection"; total: number } | null
  }
  group: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      path_id?: number | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
    user_source_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges: Array<{
        __typename?: "RegistrationEdge"
        node: {
          __typename?: "Registration"
          id: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        }
      }>
    } | null
  }
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    completion_date?: any | null
    next_step_id?: number | null
  } | null
}

export type HomeResourceCopyConfigLinkFragment = {
  __typename?: "ResourceCopyConfigLink"
  id: number
  createdTime: any
  copiedTime?: any | null
  resourceId?: number | null
  cohortId?: number | null
  copierRegistrationId?: number | null
  hideFromLocations?: any | null
  copierRegistration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    softArchivedTime?: any | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    position: string
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
    resource: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      groups?: { __typename?: "GroupConnection"; total: number } | null
    }
    group: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        path_id?: number | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
      user_source_registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
      registrations?: {
        __typename?: "RegistrationConnection"
        total: number
        edges: Array<{
          __typename?: "RegistrationEdge"
          node: {
            __typename?: "Registration"
            id: number
            user: {
              __typename?: "User"
              id: number
              first_name: string
              last_name: string
              full_name: string
              profile?: {
                __typename?: "Profile"
                id?: number | null
                image?: string | null
              } | null
            }
          }
        }>
      } | null
    }
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      completion_date?: any | null
      next_step_id?: number | null
    } | null
  } | null
  resourceCopyConfig: {
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  }
}

export type HomeResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  cover_image: string
  groups?: { __typename?: "GroupConnection"; total: number } | null
}

export type RegistrationSoftArchivedFragment = {
  __typename?: "Registration"
  id: number
  softArchivedTime?: any | null
  send_discussion_notifications?: boolean | null
  send_due_notifications?: boolean | null
}

export type DeleteUserPreferenceMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteUserPreferenceMutation = {
  __typename?: "Mutations"
  deleteUserPreference: boolean
}

export type UpsertUserPreferenceMutationVariables = Exact<{
  key: Scalars["String"]["input"]
  scope: Scalars["String"]["input"]
  data: Scalars["JSON"]["input"]
}>

export type UpsertUserPreferenceMutation = {
  __typename?: "Mutations"
  upsertUserPreference: {
    __typename?: "UserPreference"
    id: number
    school_id: number
    user_id: number
    key: string
    scope: string
    data: any
    created: any
    modified: any
  }
}

export type UserPreferenceFragment = {
  __typename?: "UserPreference"
  id: number
  school_id: number
  user_id: number
  key: string
  scope: string
  data: any
  created: any
  modified: any
}

export type UserPreferenceQueryVariables = Exact<{
  key: Scalars["String"]["input"]
  scope: Scalars["String"]["input"]
}>

export type UserPreferenceQuery = {
  __typename?: "Query"
  userPreference?: {
    __typename?: "UserPreference"
    id: number
    school_id: number
    user_id: number
    key: string
    scope: string
    data: any
    created: any
    modified: any
  } | null
}

export type ProfileFragment = {
  __typename?: "Profile"
  id?: number | null
  bio?: string | null
  image?: string | null
  imageRaw?: string | null
  location?: string | null
  last_activity?: any | null
  rewardful_referral_id?: string | null
}

export type UserFragment = {
  __typename?: "User"
  id: number
  email?: string | null
  first_name: string
  last_name: string
  full_name: string
  display_name?: string | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    bio?: string | null
    image?: string | null
    imageRaw?: string | null
    location?: string | null
    last_activity?: any | null
    rewardful_referral_id?: string | null
  } | null
}

export type UserMentorGroupMembershipsQueryVariables = Exact<{
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  mentorGroupSeatLimit?: InputMaybe<Scalars["Int"]["input"]>
  mentorGroupSeatLimitFilter?: InputMaybe<IntFilter>
  mentorGroupSeatsFilled?: InputMaybe<Scalars["Int"]["input"]>
  mentorGroupSeatsFilledFilter?: InputMaybe<IntFilter>
  include_group: Scalars["Boolean"]["input"]
  or?: InputMaybe<MentorGroupMembershipOr>
}>

export type UserMentorGroupMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          created: any
          group_id: number
          group?: {
            __typename?: "MentorGroup"
            id: number
            type: number
            slug: string
            name: string
            description?: string | null
            created: any
            modified?: any | null
            parent_id?: number | null
            has_child_groups?: boolean | null
            seat_limit?: number | null
            seats_filled: number
            seats_available?: number | null
            memberships?: {
              __typename?: "MentorGroupMembershipConnection"
              total: number
              edges: Array<{
                __typename?: "MentorGroupMembershipEdge"
                node: {
                  __typename?: "MentorGroupMembership"
                  id: number
                  user: {
                    __typename?: "User"
                    id: number
                    email?: string | null
                    first_name: string
                    last_name: string
                    full_name: string
                    display_name?: string | null
                    profile?: {
                      __typename?: "Profile"
                      id?: number | null
                      bio?: string | null
                      image?: string | null
                      imageRaw?: string | null
                      location?: string | null
                      last_activity?: any | null
                      rewardful_referral_id?: string | null
                    } | null
                  }
                }
              }>
            } | null
            owner?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            permissions?: {
              __typename?: "MentorGroupPermissions"
              can_add_member?: boolean | null
              can_add_moderator?: boolean | null
              can_add_admin?: boolean | null
              can_add_group?: boolean | null
              can_edit_group?: boolean | null
              can_change_parent?: boolean | null
              can_edit_subscription?: boolean | null
              can_delete_group?: boolean | null
              can_update_member_review_permission?: boolean | null
              can_update_moderator_review_permission?: boolean | null
              can_update_admin_review_permission?: boolean | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type UserMentorGroupSubscriptionMembershipFragment = {
  __typename?: "MentorGroupMembership"
  id: number
  role: number
  created: any
  access_revoked_time?: any | null
  group_id: number
  send_mentor_digest?: boolean | null
  can_review: boolean
  group: {
    __typename?: "MentorGroup"
    id: number
    type: number
    slug: string
    name: string
    description?: string | null
    created: any
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled: number
    seats_available?: number | null
    memberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
    group_subscription?: {
      __typename?: "SchoolGroupSubscription"
      id: number
      price: {
        __typename?: "StripePrice"
        id: number
        active?: boolean | null
        billing_scheme?: StripeBillingScheme | null
        currency?: string | null
        nickname?: string | null
        recurring_interval?: StripeRecurringInterval | null
        recurring_interval_count?: number | null
        stripe_price_id?: string | null
        stripe_connected_account_url?: string | null
        tiers_mode?: StripeTiersMode | null
        unit_amount_decimal?: number | null
        product?: {
          __typename?: "StripeProduct"
          id: number
          min_quantity?: number | null
          max_quantity?: number | null
          active?: boolean | null
          name?: string | null
          description?: string | null
          images?: Array<string | null> | null
          unit_label?: string | null
          stripe_product_id?: string | null
          stripe_connected_account_url?: string | null
        } | null
        tiers?: Array<{
          __typename?: "StripeTier"
          up_to?: number | null
          flat_amount?: number | null
          flat_amount_decimal?: string | null
          unit_amount?: number | null
          unit_amount_decimal?: string | null
        } | null> | null
      }
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
      subscription: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      }
      community_group: {
        __typename?: "MentorGroup"
        id: number
        type: number
        slug: string
        name: string
        description?: string | null
        created: any
        modified?: any | null
        parent_id?: number | null
        has_child_groups?: boolean | null
        seat_limit?: number | null
        seats_filled: number
        seats_available?: number | null
        owner?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        permissions?: {
          __typename?: "MentorGroupPermissions"
          can_add_member?: boolean | null
          can_add_moderator?: boolean | null
          can_add_admin?: boolean | null
          can_add_group?: boolean | null
          can_edit_group?: boolean | null
          can_change_parent?: boolean | null
          can_edit_subscription?: boolean | null
          can_delete_group?: boolean | null
          can_update_member_review_permission?: boolean | null
          can_update_moderator_review_permission?: boolean | null
          can_update_admin_review_permission?: boolean | null
        } | null
      }
    } | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  }
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type UserMentorGroupSubscriptionsQueryVariables = Exact<{
  [key: string]: never
}>

export type UserMentorGroupSubscriptionsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      edges: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          created: any
          access_revoked_time?: any | null
          group_id: number
          send_mentor_digest?: boolean | null
          can_review: boolean
          group: {
            __typename?: "MentorGroup"
            id: number
            type: number
            slug: string
            name: string
            description?: string | null
            created: any
            modified?: any | null
            parent_id?: number | null
            has_child_groups?: boolean | null
            seat_limit?: number | null
            seats_filled: number
            seats_available?: number | null
            memberships?: {
              __typename?: "MentorGroupMembershipConnection"
              total: number
              edges: Array<{
                __typename?: "MentorGroupMembershipEdge"
                node: {
                  __typename?: "MentorGroupMembership"
                  id: number
                  user: {
                    __typename?: "User"
                    id: number
                    email?: string | null
                    first_name: string
                    last_name: string
                    full_name: string
                    display_name?: string | null
                    profile?: {
                      __typename?: "Profile"
                      id?: number | null
                      bio?: string | null
                      image?: string | null
                      imageRaw?: string | null
                      location?: string | null
                      last_activity?: any | null
                      rewardful_referral_id?: string | null
                    } | null
                  }
                }
              }>
            } | null
            group_subscription?: {
              __typename?: "SchoolGroupSubscription"
              id: number
              price: {
                __typename?: "StripePrice"
                id: number
                active?: boolean | null
                billing_scheme?: StripeBillingScheme | null
                currency?: string | null
                nickname?: string | null
                recurring_interval?: StripeRecurringInterval | null
                recurring_interval_count?: number | null
                stripe_price_id?: string | null
                stripe_connected_account_url?: string | null
                tiers_mode?: StripeTiersMode | null
                unit_amount_decimal?: number | null
                product?: {
                  __typename?: "StripeProduct"
                  id: number
                  min_quantity?: number | null
                  max_quantity?: number | null
                  active?: boolean | null
                  name?: string | null
                  description?: string | null
                  images?: Array<string | null> | null
                  unit_label?: string | null
                  stripe_product_id?: string | null
                  stripe_connected_account_url?: string | null
                } | null
                tiers?: Array<{
                  __typename?: "StripeTier"
                  up_to?: number | null
                  flat_amount?: number | null
                  flat_amount_decimal?: string | null
                  unit_amount?: number | null
                  unit_amount_decimal?: string | null
                } | null> | null
              }
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
              subscription: {
                __typename?: "Subscription"
                id: number
                quantity?: number | null
                canceled_dtime?: any | null
                cancellation_reason?: number | null
                card_last_4?: string | null
                cycle_end_dtime?: any | null
                cycle_start_dtime?: any | null
                is_canceled_at_cycle_end?: boolean | null
                is_delinquent?: boolean | null
                paused_until_dtime?: any | null
                trial_type?: number | null
                trial_end_dtime?: any | null
                payment_intent_needing_action_id?: string | null
                subscription_plan?: {
                  __typename?: "SubscriptionPlan"
                  id: number
                  name: string
                  amount?: number | null
                  interval: number
                  trial_period_days: number
                  trial_type: SubscriptionTrialType
                  plan_type?: string | null
                  stripe_connected_account_url?: string | null
                } | null
                customer?: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                } | null
              }
              community_group: {
                __typename?: "MentorGroup"
                id: number
                type: number
                slug: string
                name: string
                description?: string | null
                created: any
                modified?: any | null
                parent_id?: number | null
                has_child_groups?: boolean | null
                seat_limit?: number | null
                seats_filled: number
                seats_available?: number | null
                owner?: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                } | null
                permissions?: {
                  __typename?: "MentorGroupPermissions"
                  can_add_member?: boolean | null
                  can_add_moderator?: boolean | null
                  can_add_admin?: boolean | null
                  can_add_group?: boolean | null
                  can_edit_group?: boolean | null
                  can_change_parent?: boolean | null
                  can_edit_subscription?: boolean | null
                  can_delete_group?: boolean | null
                  can_update_member_review_permission?: boolean | null
                  can_update_moderator_review_permission?: boolean | null
                  can_update_admin_review_permission?: boolean | null
                } | null
              }
            } | null
            owner?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            permissions?: {
              __typename?: "MentorGroupPermissions"
              can_add_member?: boolean | null
              can_add_moderator?: boolean | null
              can_add_admin?: boolean | null
              can_add_group?: boolean | null
              can_edit_group?: boolean | null
              can_change_parent?: boolean | null
              can_edit_subscription?: boolean | null
              can_delete_group?: boolean | null
              can_update_member_review_permission?: boolean | null
              can_update_moderator_review_permission?: boolean | null
              can_update_admin_review_permission?: boolean | null
            } | null
          }
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type UserPaymentHistoryQueryVariables = Exact<{ [key: string]: never }>

export type UserPaymentHistoryQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    payment_history: {
      __typename?: "PaymentHistory"
      download_url: string
      payments: Array<{
        __typename?: "PaymentHistoryItem"
        item: string
        total: number
        currency_display: string
        date: any
        is_failed: string
      }>
    }
  } | null
}

export type UserQueryQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type UserQueryQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type UserSchoolSubscriptionQueryVariables = Exact<{
  [key: string]: never
}>

export type UserSchoolSubscriptionQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    school_subscription?: {
      __typename?: "SchoolSubscription"
      id: number
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
      subscription: {
        __typename?: "Subscription"
        id: number
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      }
      subscription_plan: {
        __typename?: "SubscriptionPlan"
        id: number
        name: string
        amount?: number | null
        interval: number
        trial_period_days: number
        trial_type: SubscriptionTrialType
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      }
      school_subscription_plan: {
        __typename?: "SchoolSubscriptionPlan"
        id: number
        image?: string | null
        details_html?: string | null
        subscribe_complete_html?: string | null
        catalog_header?: string | null
        is_visible?: boolean | null
        giftable_cycles?: Array<number | null> | null
        subscription_plan: {
          __typename?: "SubscriptionPlan"
          id: number
          name: string
          amount?: number | null
          interval: number
          trial_period_days: number
          trial_type: SubscriptionTrialType
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        }
      }
    } | null
  } | null
}

export type SandboxCanvasUserQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SandboxCanvasUserQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type SandboxSchoolMembersQueryVariables = Exact<{
  search: Scalars["String"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  roleFilter?: InputMaybe<
    Array<InputMaybe<MembershipRoleFilter>> | InputMaybe<MembershipRoleFilter>
  >
}>

export type SandboxSchoolMembersQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    members?: {
      __typename?: "MembershipConnection"
      pageInfo: {
        __typename?: "PageInfo"
        hasNextPage: boolean
        endCursor?: string | null
      }
      edges: Array<{
        __typename?: "MembershipEdge"
        node: {
          __typename?: "Membership"
          id: number
          role: number
          last_active?: any | null
          school: { __typename?: "School"; id: number; name: string }
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        }
      }>
    } | null
  } | null
}

export type SandboxLegacyPresetsQueryVariables = Exact<{ [key: string]: never }>

export type SandboxLegacyPresetsQuery = {
  __typename?: "Query"
  components: Array<{
    __typename?: "UserPreference"
    id: number
    scope: string
    data: any
    created: any
    modified: any
  }>
  blocks: Array<{
    __typename?: "UserPreference"
    id: number
    scope: string
    data: any
    created: any
    modified: any
  }>
}

export type SandboxSchoolsQueryVariables = Exact<{
  search: Scalars["String"]["input"]
  after?: InputMaybe<Scalars["String"]["input"]>
}>

export type SandboxSchoolsQuery = {
  __typename?: "Query"
  admin?: {
    __typename?: "SchoolConnection"
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      endCursor?: string | null
    }
    edges: Array<{
      __typename?: "SchoolEdge"
      node: {
        __typename?: "School"
        id: number
        name: string
        image?: string | null
        image_is_default: boolean
        theme?: {
          __typename?: "Theme"
          id?: number | null
          primary_color?: string | null
        } | null
      }
    }>
  } | null
}

export type SchoolContextQueryVariables = Exact<{ [key: string]: never }>

export type SchoolContextQuery = {
  __typename?: "Query"
  school?: { __typename?: "School"; id: number; url: string } | null
}

export type GroupNameFragment = {
  __typename?: "Group"
  id: number
  name: string
}

export type GroupStatusFragment = {
  __typename?: "Group"
  id: number
  status: GroupStatus
}

export type UserGroupSubscriptionsQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"]
}>

export type UserGroupSubscriptionsQueryQuery = {
  __typename?: "Query"
  schoolGroupSubscriptions?: {
    __typename?: "SchoolGroupSubscriptionConnection"
    edges: Array<{
      __typename?: "SchoolGroupSubscriptionEdge"
      node: {
        __typename?: "SchoolGroupSubscription"
        id: number
        community_group: {
          __typename?: "MentorGroup"
          id: number
          type: number
          slug: string
          name: string
          description?: string | null
          created: any
          modified?: any | null
          parent_id?: number | null
          has_child_groups?: boolean | null
          seat_limit?: number | null
          seats_filled: number
          seats_available?: number | null
          user_membership?: {
            __typename?: "MentorGroupMembership"
            id: number
            access_revoked_time?: any | null
          } | null
          owner?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          permissions?: {
            __typename?: "MentorGroupPermissions"
            can_add_member?: boolean | null
            can_add_moderator?: boolean | null
            can_add_admin?: boolean | null
            can_add_group?: boolean | null
            can_edit_group?: boolean | null
            can_change_parent?: boolean | null
            can_edit_subscription?: boolean | null
            can_delete_group?: boolean | null
            can_update_member_review_permission?: boolean | null
            can_update_moderator_review_permission?: boolean | null
            can_update_admin_review_permission?: boolean | null
          } | null
        }
        price: {
          __typename?: "StripePrice"
          id: number
          active?: boolean | null
          billing_scheme?: StripeBillingScheme | null
          currency?: string | null
          nickname?: string | null
          recurring_interval?: StripeRecurringInterval | null
          recurring_interval_count?: number | null
          stripe_price_id?: string | null
          stripe_connected_account_url?: string | null
          tiers_mode?: StripeTiersMode | null
          unit_amount_decimal?: number | null
          product?: {
            __typename?: "StripeProduct"
            id: number
            min_quantity?: number | null
            max_quantity?: number | null
            active?: boolean | null
            name?: string | null
            description?: string | null
            images?: Array<string | null> | null
            unit_label?: string | null
            stripe_product_id?: string | null
            stripe_connected_account_url?: string | null
          } | null
          tiers?: Array<{
            __typename?: "StripeTier"
            up_to?: number | null
            flat_amount?: number | null
            flat_amount_decimal?: string | null
            unit_amount?: number | null
            unit_amount_decimal?: string | null
          } | null> | null
        }
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
        subscription: {
          __typename?: "Subscription"
          id: number
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id: number
            name: string
            amount?: number | null
            interval: number
            trial_period_days: number
            trial_type: SubscriptionTrialType
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        }
      }
    }>
  } | null
}

export type SourePathQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SourePathQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      resource?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        source_cohort?: { __typename?: "Group"; id: number } | null
      } | null
    } | null
  } | null
}

export type AuthContextQueryVariables = Exact<{
  inviteToken?: InputMaybe<Scalars["String"]["input"]>
}>

export type AuthContextQuery = {
  __typename?: "Query"
  space: {
    __typename?: "Space"
    id: number
    consent_description?: string | null
    allow_signup: boolean
    always_prompt_for_password?: boolean | null
    authMethods: Array<{
      __typename?: "AuthMethod"
      id: string
      enabled: boolean
      meta: {
        __typename?: "NodeMeta"
        id: string
        key: string
        type: string
        url?: string | null
        title?: string | null
        icon?: string | null
      }
    }>
  }
}

export type AuthMethodsQueryVariables = Exact<{ [key: string]: never }>

export type AuthMethodsQuery = {
  __typename?: "Query"
  space: {
    __typename?: "Space"
    id: number
    authMethods: Array<{
      __typename?: "AuthMethod"
      id: string
      enabled: boolean
      meta: {
        __typename?: "NodeMeta"
        id: string
        key: string
        type: string
        url?: string | null
        title?: string | null
        icon?: string | null
      }
    }>
  }
}

export type MeQueryVariables = Exact<{ [key: string]: never }>

export type MeQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    is_finalized?: boolean | null
    no_password_set?: boolean | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      location?: string | null
      last_activity?: any | null
      notification_digest_interval?: NotificationDigestInterval | null
    } | null
    membership?: { __typename?: "Membership"; id: number; role: number } | null
  } | null
}

export type UserMembershipFragment = {
  __typename?: "Membership"
  id: number
  role: number
}

export type CurrentUserFragment = {
  __typename?: "User"
  id: number
  email?: string | null
  first_name: string
  last_name: string
  full_name: string
  display_name?: string | null
  is_finalized?: boolean | null
  no_password_set?: boolean | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    bio?: string | null
    image?: string | null
    location?: string | null
    last_activity?: any | null
    notification_digest_interval?: NotificationDigestInterval | null
  } | null
  membership?: { __typename?: "Membership"; id: number; role: number } | null
}

export type AuthRequestFragment = {
  __typename?: "AuthRequest"
  uuid: any
  request_method: AuthRequestMethod
  request_key?: string | null
  request_dtime: any
  confirmed_dtime?: any | null
  expiration_dtime?: any | null
  confirmation_attempts: number
  context?: any | null
  truncated_email?: string | null
  issued_auth_token?: { __typename?: "JSONWebToken"; token: string } | null
}

export type StartAuthRequestMutationVariables = Exact<{
  method: AuthRequestMethod
  email?: InputMaybe<Scalars["EmailAddress"]["input"]>
  username?: InputMaybe<Scalars["String"]["input"]>
  nextUrl?: InputMaybe<Scalars["String"]["input"]>
}>

export type StartAuthRequestMutation = {
  __typename?: "Mutations"
  startAuthRequest?: {
    __typename?: "AuthRequest"
    uuid: any
    request_method: AuthRequestMethod
    request_key?: string | null
    request_dtime: any
    confirmed_dtime?: any | null
    expiration_dtime?: any | null
    confirmation_attempts: number
    context?: any | null
    truncated_email?: string | null
    issued_auth_token?: { __typename?: "JSONWebToken"; token: string } | null
  } | null
}

export type AuthRequestQueryVariables = Exact<{
  uuid: Scalars["String"]["input"]
}>

export type AuthRequestQuery = {
  __typename?: "Query"
  authRequest?: {
    __typename?: "AuthRequest"
    uuid: any
    request_method: AuthRequestMethod
    request_key?: string | null
    request_dtime: any
    confirmed_dtime?: any | null
    expiration_dtime?: any | null
    confirmation_attempts: number
    context?: any | null
    truncated_email?: string | null
    issued_auth_token?: { __typename?: "JSONWebToken"; token: string } | null
  } | null
}

export type AuthRequestTokenQueryVariables = Exact<{
  uuid: Scalars["String"]["input"]
}>

export type AuthRequestTokenQuery = {
  __typename?: "Query"
  authRequestToken?: any | null
}

export type ConfirmAuthRequestMutationVariables = Exact<{
  uuid: Scalars["UUID"]["input"]
  key: Scalars["String"]["input"]
}>

export type ConfirmAuthRequestMutation = {
  __typename?: "Mutations"
  confirmAuthRequest?: {
    __typename?: "AuthRequest"
    uuid: any
    request_method: AuthRequestMethod
    request_key?: string | null
    request_dtime: any
    confirmed_dtime?: any | null
    expiration_dtime?: any | null
    confirmation_attempts: number
    context?: any | null
    truncated_email?: string | null
    issued_auth_token?: { __typename?: "JSONWebToken"; token: string } | null
  } | null
}

export type FinalizeExternalAccountLinkMutationVariables = Exact<{
  token: Scalars["String"]["input"]
}>

export type FinalizeExternalAccountLinkMutation = {
  __typename?: "Mutations"
  finalizeExternalAccountLink?: {
    __typename?: "ExternalAccountLink"
    id?: number | null
  } | null
}

export type JoinSpaceMutationVariables = Exact<{
  consent: Scalars["Boolean"]["input"]
  inviteToken?: InputMaybe<Scalars["String"]["input"]>
}>

export type JoinSpaceMutation = {
  __typename?: "Mutations"
  joinSpace?: {
    __typename?: "Membership"
    consent_snapshot?: string | null
    consent_dtime?: any | null
    id: number
    role: number
  } | null
}

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars["String"]["input"]
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
}>

export type ChangePasswordMutation = {
  __typename?: "Mutations"
  changePassword?: boolean | null
}

export type CreatePasswordMutationVariables = Exact<{
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
}>

export type CreatePasswordMutation = {
  __typename?: "Mutations"
  createPassword?: boolean | null
}

export type PassordResetConfirmMutationVariables = Exact<{
  resetHash: Scalars["String"]["input"]
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
}>

export type PassordResetConfirmMutation = {
  __typename?: "Mutations"
  resetPassword?: boolean | null
}

export type StartPasswordRetrievalMutationVariables = Exact<{
  email: Scalars["String"]["input"]
  nextUrl?: InputMaybe<Scalars["String"]["input"]>
}>

export type StartPasswordRetrievalMutation = {
  __typename?: "Mutations"
  startPasswordRetrieval?: boolean | null
}

export type UserStatusFragment = {
  __typename?: "UserStatus"
  input_type: UserStatusInputType
  user_exists: boolean
  email_verified: boolean
  no_password_set: boolean
  has_membership: boolean
}

export type UserStatusQueryVariables = Exact<{
  input?: InputMaybe<Scalars["String"]["input"]>
}>

export type UserStatusQuery = {
  __typename?: "Query"
  userStatus?: {
    __typename?: "UserStatus"
    input_type: UserStatusInputType
    user_exists: boolean
    email_verified: boolean
    no_password_set: boolean
    has_membership: boolean
  } | null
}

export type SignInPasswordMutationVariables = Exact<{
  email: Scalars["String"]["input"]
  password: Scalars["String"]["input"]
}>

export type SignInPasswordMutation = {
  __typename?: "Mutations"
  getToken?: {
    __typename?: "Token"
    token?: string | null
    user_id?: number | null
    created?: any | null
  } | null
}

export type SignOutMutationVariables = Exact<{ [key: string]: never }>

export type SignOutMutation = {
  __typename?: "Mutations"
  signOut?: boolean | null
}

export type SignUpMutationVariables = Exact<{
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  email: Scalars["String"]["input"]
  password?: InputMaybe<Scalars["String"]["input"]>
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  inviteToken?: InputMaybe<Scalars["String"]["input"]>
  createMembership?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type SignUpMutation = {
  __typename?: "Mutations"
  signUp?: {
    __typename?: "Token"
    token?: string | null
    user_id?: number | null
    created?: any | null
  } | null
}

export type TermsAgreementQueryVariables = Exact<{ [key: string]: never }>

export type TermsAgreementQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    page?: {
      __typename?: "Page"
      id: number
      name: string
      slug: string
      external_url?: string | null
    } | null
  } | null
}

export type SpaceContextQueryQueryVariables = Exact<{ [key: string]: never }>

export type SpaceContextQueryQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    is_finalized?: boolean | null
    no_password_set?: boolean | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      location?: string | null
      last_activity?: any | null
      notification_digest_interval?: NotificationDigestInterval | null
    } | null
    membership?: { __typename?: "Membership"; id: number; role: number } | null
  } | null
  space: {
    __typename?: "Space"
    id: number
    name: string
    subdomain: string
    created: string
    is_activated: boolean
    ietf_language_tag?: string | null
    is_owner: boolean
    image: string
    meta: {
      __typename?: "NodeMeta"
      id: string
      key: string
      type: string
      url?: string | null
      title?: string | null
      subtitle?: string | null
      description?: string | null
      image?: { __typename?: "NodeImage"; src?: string | null } | null
    }
    theme: {
      __typename?: "NodeTheme"
      color: string
      color_palette?: {
        __typename?: "NodeThemeColorPalette"
        _50?: string | null
        _100?: string | null
        _200?: string | null
        _300?: string | null
        _400?: string | null
        _500?: string | null
        _600?: string | null
        _700?: string | null
        _800?: string | null
        _900?: string | null
      } | null
      background?: {
        __typename?: "NodeThemeBackground"
        color?: string | null
        contrast_color?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
        image_blurred?: { __typename?: "NodeImage"; src?: string | null } | null
        image_blurred_dark?: {
          __typename?: "NodeImage"
          src?: string | null
        } | null
      } | null
    }
  }
}

export type NodeMetaFragment = {
  __typename?: "NodeMeta"
  id: string
  key: string
  type: string
  url?: string | null
  title?: string | null
  subtitle?: string | null
  description?: string | null
  image?: { __typename?: "NodeImage"; src?: string | null } | null
}

export type NodeThemeBackgroundFragment = {
  __typename?: "NodeThemeBackground"
  color?: string | null
  contrast_color?: string | null
  image?: { __typename?: "NodeImage"; src?: string | null } | null
  image_blurred?: { __typename?: "NodeImage"; src?: string | null } | null
  image_blurred_dark?: { __typename?: "NodeImage"; src?: string | null } | null
}

export type NodeThemeFragment = {
  __typename?: "NodeTheme"
  color: string
  color_palette?: {
    __typename?: "NodeThemeColorPalette"
    _50?: string | null
    _100?: string | null
    _200?: string | null
    _300?: string | null
    _400?: string | null
    _500?: string | null
    _600?: string | null
    _700?: string | null
    _800?: string | null
    _900?: string | null
  } | null
  background?: {
    __typename?: "NodeThemeBackground"
    color?: string | null
    contrast_color?: string | null
    image?: { __typename?: "NodeImage"; src?: string | null } | null
    image_blurred?: { __typename?: "NodeImage"; src?: string | null } | null
    image_blurred_dark?: {
      __typename?: "NodeImage"
      src?: string | null
    } | null
  } | null
}

export type SpaceFragment = {
  __typename?: "Space"
  id: number
  name: string
  subdomain: string
  created: string
  is_activated: boolean
  ietf_language_tag?: string | null
  is_owner: boolean
  image: string
  meta: {
    __typename?: "NodeMeta"
    id: string
    key: string
    type: string
    url?: string | null
    title?: string | null
    subtitle?: string | null
    description?: string | null
    image?: { __typename?: "NodeImage"; src?: string | null } | null
  }
  theme: {
    __typename?: "NodeTheme"
    color: string
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
    } | null
    background?: {
      __typename?: "NodeThemeBackground"
      color?: string | null
      contrast_color?: string | null
      image?: { __typename?: "NodeImage"; src?: string | null } | null
      image_blurred?: { __typename?: "NodeImage"; src?: string | null } | null
      image_blurred_dark?: {
        __typename?: "NodeImage"
        src?: string | null
      } | null
    } | null
  }
}

export const PageFragmentDoc = gql`
  fragment Page on Page {
    id
    name
    order
    page_type
    title
    description
    url
    external_url
    iframe_url
    template_content
    scripts
    slug
    show_in_nav
    mode
    is_live
    content_type
  }
`
export const ResourceThumbnailFragmentDoc = gql`
  fragment ResourceThumbnail on Resource {
    name
    slug
    image(width: 60, height: 45, fit: clamp)
  }
`
export const AuthMethodFragmentDoc = gql`
  fragment AuthMethod on AuthMethod {
    id
    enabled
    meta {
      id
      key
      type
      url
      title
      icon
    }
  }
`
export const HeartbeatFragmentDoc = gql`
  fragment Heartbeat on Heartbeat {
    success
    active_subscription_ids
    membership {
      archived_time
      access_revoked_time
    }
    deploy {
      id
      created
      build_id
      commit_hash
      built_at
      label
      notify
    }
  }
`
export const AuthorFragmentDoc = gql`
  fragment Author on Author {
    id
    order
    display_name
    full_name
    first_name
    last_name
    title
    image
    bio
    avatar
    salutation
    slug
  }
`
export const PositionedAuthorFragmentDoc = gql`
  fragment PositionedAuthor on Author {
    ...Author
    position(positioningContext: $positioningContext)
  }
  ${AuthorFragmentDoc}
`
export const BannerFragmentDoc = gql`
  fragment Banner on Banner {
    id
    order
    heading
    subhead
    font_color
    background_image_raw
    background_image(width: 1600, fit: crop)
    background_type
    background_overlay
    button_func
    button_url
    button_text
    is_visible
    hide_for_subscription_plans
    show_for_subscription_plans
    hide_for_products
    show_for_products
  }
`
export const BackgroundTaskFragmentDoc = gql`
  fragment BackgroundTask on BackgroundTask {
    id
    status
    result
  }
`
export const SchoolBillingInvoiceFragmentDoc = gql`
  fragment SchoolBillingInvoice on SchoolBillingInvoice {
    cycle_end
    cycle_start
    id
    invoice_json
    invoiced_date
    stripe_invoice_id
    stripe_invoice_status
    stripe_next_payment_attempt
    total_amount_billed
    url
  }
`
export const SchoolBillingPlanFeatureFragmentDoc = gql`
  fragment SchoolBillingPlanFeature on SchoolBillingPlanFeature {
    id
    name
    description
    link
    key
    icon
    feature_type
    order
    platform_version
  }
`
export const SchoolBillingBlockFragmentDoc = gql`
  fragment SchoolBillingBlock on SchoolBillingBlock {
    id
    block_type
    block_size
    price
  }
`
export const SchoolBillingPlanFragmentDoc = gql`
  fragment SchoolBillingPlan on SchoolBillingPlan {
    id
    name
    visibility
    amount
    description
    learner_counting_method
    fee_per_additional_learner
    learners_included
    staff_included
    color
    order
    should_contact_for_pricing
    features {
      ...SchoolBillingPlanFeature
    }
    billing_blocks(first: 50) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...SchoolBillingBlock
        }
      }
    }
    plan_derived_from {
      id
      name
      description
      amount
      order
    }
  }
  ${SchoolBillingPlanFeatureFragmentDoc}
  ${SchoolBillingBlockFragmentDoc}
`
export const SchoolBillingPlanSetFragmentDoc = gql`
  fragment SchoolBillingPlanSet on SchoolBillingPlanSet {
    id
    name
    is_default
    plans {
      ...SchoolBillingPlan
    }
  }
  ${SchoolBillingPlanFragmentDoc}
`
export const SubscriptionPlanFragmentDoc = gql`
  fragment SubscriptionPlan on SubscriptionPlan {
    id
    name
    amount
    interval
    trial_period_days
    trial_type
    plan_type
    stripe_connected_account_url
  }
`
export const ProfileFragmentDoc = gql`
  fragment Profile on Profile {
    id
    bio
    image(width: 250, height: 250, crop: faces)
    imageRaw
    location
    last_activity
    rewardful_referral_id
  }
`
export const UserFragmentDoc = gql`
  fragment User on User {
    id
    email
    first_name
    last_name
    full_name
    display_name
    profile {
      ...Profile
    }
  }
  ${ProfileFragmentDoc}
`
export const SubscriptionFragmentDoc = gql`
  fragment Subscription on Subscription {
    id
    quantity
    canceled_dtime
    cancellation_reason
    card_last_4
    cycle_end_dtime
    cycle_start_dtime
    is_canceled_at_cycle_end
    is_delinquent
    paused_until_dtime
    trial_type
    trial_end_dtime
    payment_intent_needing_action_id
    subscription_plan {
      ...SubscriptionPlan
    }
    customer {
      ...User
    }
  }
  ${SubscriptionPlanFragmentDoc}
  ${UserFragmentDoc}
`
export const SchoolFragmentDoc = gql`
  fragment School on School {
    id
    url
    name
    about
    email
    website
    subdomain
    created
    billing_model
    platform_version
    currency_code
    ietf_language_tag
    has_certificate
    is_activated
    is_curriculum_enabled
    is_curriculum_subscriber
    stripe_access_token
    stripe_publishable_api_key
    show_stripe_reconnect
    payment_requires_zip_code
    consent_description
    image(width: 150, height: 150)
    image_is_default
    grant_access_upon_authentication
    pathwright_login_enabled
    resource_licensing_enabled
  }
`
export const SchoolBillingSubscriptionFragmentDoc = gql`
  fragment SchoolBillingSubscription on SchoolBillingSubscription {
    id
    interval
    charge_type
    parent_subscription_id
    subscription {
      ...Subscription
    }
    plan {
      ...SchoolBillingPlan
    }
    school {
      ...School
    }
  }
  ${SubscriptionFragmentDoc}
  ${SchoolBillingPlanFragmentDoc}
  ${SchoolFragmentDoc}
`
export const CategoryFragmentDoc = gql`
  fragment Category on Category {
    id
    name
    slug
    order
    description
  }
`
export const PositionedCategoryFragmentDoc = gql`
  fragment PositionedCategory on Category {
    ...Category
    position(positioningContext: $positioningContext)
  }
  ${CategoryFragmentDoc}
`
export const CertificateFragmentDoc = gql`
  fragment Certificate on Certificate {
    id
    name
    template
    text_objects
  }
`
export const CohortFragmentDoc = gql`
  fragment Cohort on Group {
    id
    name
    created
    created_by_id
    status
    is_collection_linked
    is_master
    access_starts
    parent_section_id
    registration {
      id
      role
      send_due_notifications
      send_discussion_notifications
    }
    path(type: source) {
      id
    }
    access_ends
    resource {
      id
      name
      image
      slug
      background_image
      background_overlay
      resource_type
    }
    resource_license {
      id
      expiration_dtime
    }
  }
`
export const CohortPermissionsCohortFragmentDoc = gql`
  fragment CohortPermissionsCohort on Group {
    id
    is_source_cohort
    status
    user_registration {
      id
      role
      softArchivedTime
    }
  }
`
export const CohortPermissionsFragmentDoc = gql`
  fragment CohortPermissions on Group {
    ...CohortPermissionsCohort
    source {
      ...CohortPermissionsCohort
    }
  }
  ${CohortPermissionsCohortFragmentDoc}
`
export const PathItemContextFragmentDoc = gql`
  fragment PathItemContext on StepContext {
    school_id
    resource_id
    cohort_id
  }
`
export const CompletionFragmentDoc = gql`
  fragment Completion on Completion {
    id
    checked_date
    completion_attempts
    completion_comment
    completion_date
    completion_due
    last_completion_attempt_date
    has_failed_passing_attempt
    has_points
    is_late
    is_graded
    is_skipped
    is_complete
    is_auto_graded
    is_forced_completion
    needs_grading
    userpoints_earned
    userpoints_explanation
    userpoints_value
    minimum_passing_score
    grading_type
    requires_api_completion
    overridden_by_api
    overridden_by {
      ...User
    }
    checked_by {
      ...User
    }
    user {
      ...User
    }
    submission {
      id
      text
      file_url
      file_name
      file_image
    }
    feedback_discussion_context {
      id
      discussion_id
      num_responses
    }
  }
  ${UserFragmentDoc}
`
export const ResourceFragmentDoc = gql`
  fragment Resource on Resource {
    id
    name
    slug
    created
    resource_type
    visibility
    description
    short_description
    background_overlay
    background_image
    background_type
    image_raw
    has_certificate
    discussion_enabled
    lowest_public_offering_price
    highest_public_offering_price
    licensed_from_resource_id
    licensed_from_school_id
    created_by_id
    copied_with_copy_config_id
    image(width: 500, height: 375, fit: crop)
    cover_image: image(width: 240, height: 180, fit: crop)
  }
`
export const PathItemLinkedResourceFragmentDoc = gql`
  fragment PathItemLinkedResource on Resource {
    ...Resource
    curriculum_group {
      id
    }
  }
  ${ResourceFragmentDoc}
`
export const RegistrationFragmentDoc = gql`
  fragment Registration on Registration {
    id
    role
    completion_state
    send_due_notifications
    send_discussion_notifications
    last_activity_time
    expiration_dtime
    created
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const PathItemFragmentDoc = gql`
  fragment PathItem on PathItem {
    id
    order
    verb
    name
    type
    verb
    path_id
    source_id
    parent_id
    parent_source_id
    description
    curriculum_sync_opt_out_dtime
    assignment_type
    content_id
    content_type
    item_content_type_id
    is_required
    is_previewable
    due
    passive_due
    starts
    passive_starts
    has_started
    points
    item_needs_grading
    minimum_passing_score
    grading_type
    time_to_complete
    lock_password
    is_locked
    lock_unlocked_time
    allow_resets
    show_grading_feedback
    completion_comment_required_status
    last_published_dtime
    copied_from_id
    archived_time
    progress
    context {
      ...PathItemContext
    }
    blocks {
      content_last_modified
      last_published
    }
    permissions {
      can_complete
      can_discuss
      can_edit
      can_edit_content
      can_note
      can_view
      can_review
      can_view_content
    }
    completion {
      ...Completion
    }
    linked_resource {
      ...PathItemLinkedResource
    }
    linked_cohort {
      id
      user_registration {
        ...Registration
        path {
          id
        }
      }
    }
    linked_registration {
      ...Registration
      path {
        id
      }
    }
  }
  ${PathItemContextFragmentDoc}
  ${CompletionFragmentDoc}
  ${PathItemLinkedResourceFragmentDoc}
  ${RegistrationFragmentDoc}
`
export const CompletionsItemFragmentDoc = gql`
  fragment CompletionsItem on PathItem {
    ...PathItem
    cohort {
      id
      name
    }
    resource {
      id
      name
      image(width: 100, height: 100, fit: crop)
      blurred_background: background_image(blur: 500, width: 250, height: 250)
      background_overlay
      background_image
      image_raw
    }
    parent {
      id
      source_id
      order
      name
    }
    analytics {
      need_feedback
      total_users
    }
  }
  ${PathItemFragmentDoc}
`
export const CouponFragmentDoc = gql`
  fragment Coupon on CouponDiscount {
    id
    code
    amount
    discount_percent
    discount_amount
    discounted_total
    num_redemptions
    max_num_redemptions
    max_seat_discount
    discounted_subscription_cycles
    start_date
    end_date
    has_started
    has_ended
    is_one_per_user
    user_redeemed
    user_can_redeem
  }
`
export const CoverPageOfferFragmentDoc = gql`
  fragment CoverPageOffer on Offer {
    id
    school_id
    cover_page_id
    kind
    cohort_id
    cohort_name
    resource_license_offering_id
    scope
    visibility
    availability_starts
    availability_ends
    title
    description
    cta_label
    external_url
    position
    access {
      meta
      state
      conversion_date
    }
    price_options {
      option_label
      button_label
      price_description
      payment_type
    }
  }
`
export const CoverPageOfferableCohortFragmentDoc = gql`
  fragment CoverPageOfferableCohort on Group {
    id
    name
    visibility
    registration_starts
    registration_ends
    access_starts
    access_ends
    price
    is_subscription_only
  }
`
export const CoverPageContributorFragmentDoc = gql`
  fragment CoverPageContributor on Author {
    ...Author
    position(positioningContext: $contributorPositioningContext)
  }
  ${AuthorFragmentDoc}
`
export const CoverPageCategoryFragmentDoc = gql`
  fragment CoverPageCategory on Category {
    id
    name
    slug
    order
    position(positioningContext: $categoryPositioningContext)
    description
  }
`
export const CoverPagePathItemFragmentDoc = gql`
  fragment CoverPagePathItem on PathItem {
    id
    order
    name
    type
    path_id
    source_id
    parent_id
    description
    content_id
    assignment_type
    is_previewable
    item_content_type_id
    step_verb: verb
    verb
    userpoints_value: points
    points
    is_required
    time_to_complete
    context {
      ...PathItemContext
    }
  }
  ${PathItemContextFragmentDoc}
`
export const CoverPageResourceFragmentDoc = gql`
  fragment CoverPageResource on Resource {
    id
    name
    slug
    resource_type
    is_ambient_background
    created
    curriculum_group {
      id
    }
    contributors: authors(
      first: 20
      positioningContext: $contributorPositioningContext
    ) {
      total
      edges {
        node {
          ...CoverPageContributor
        }
      }
    }
    categories(first: 20, positioningContext: $categoryPositioningContext) {
      total
      edges {
        node {
          ...CoverPageCategory
        }
      }
    }
    visibility
    description
    short_description
    background_overlay
    background_type
    background_image_raw
    background_image(width: 1400, height: -1, fit: max)
    pristine_background: pristine_background_image(
      width: 1400
      height: -1
      fit: max
    )
    blurred_background: background_image(
      blur: 500
      width: 1400
      height: 780
      fit: max
    )
    image_raw
    has_certificate
    discussion_enabled
    lowest_public_offering_price
    highest_public_offering_price
    licensed_from_resource_id
    licensed_from_school_id
    created_by_id
    trailer_embed_code
    cover_image: image(width: 450, height: 350, fit: crop)
    image: image(width: 450, height: 350, fit: crop)
    preview_group {
      id
      path(type: source) {
        id
        items(first: 1000, flatten: true) {
          total
          edges {
            node {
              ...CoverPagePathItem
            }
          }
        }
      }
    }
  }
  ${CoverPageContributorFragmentDoc}
  ${CoverPageCategoryFragmentDoc}
  ${CoverPagePathItemFragmentDoc}
`
export const MembershipStatsFragmentDoc = gql`
  fragment MembershipStats on School {
    membershipStats: membership_stats {
      total
      active
    }
  }
`
export const MentorGroupsFragmentDoc = gql`
  fragment MentorGroups on School {
    mentorGroups: mentor_groups(first: 1) {
      total
    }
  }
`
export const PrivateResourcesFragmentDoc = gql`
  fragment PrivateResources on Query {
    privateResources: resources(
      first: 6
      visibility: { lt: members }
      resource_types: { eq: course }
    ) {
      total
      edges {
        node {
          id
          name
          slug
          image(width: 100, height: 75, fit: clamp)
        }
      }
    }
  }
`
export const RecentMembersFragmentDoc = gql`
  fragment RecentMembers on School {
    recentMembers: members(first: 32) {
      total
      edges {
        node {
          id
          user {
            id
            display_name
            first_name
            last_name
            profile {
              id
              image(width: 50, height: 50, fit: clamp)
              bio
              location
            }
            membership {
              id
              role
            }
          }
        }
      }
    }
  }
`
export const ResourceStatsFragmentDoc = gql`
  fragment ResourceStats on School {
    resourceStats: resource_stats {
      private
      public
    }
  }
`
export const TeacherRegistrationsFragmentDoc = gql`
  fragment TeacherRegistrations on User {
    registrations(first: 6, role_filter: { gt: student }) {
      total
      edges {
        node {
          group {
            id
            name
            seats_filled
            resource {
              id
              slug
            }
            path(type: source) {
              id
            }
          }
        }
      }
    }
  }
`
export const UserDisplayFragmentDoc = gql`
  fragment UserDisplay on User {
    id
    first_name
    last_name
    display_name
    profile {
      id
      image(width: 100, height: 100)
    }
  }
`
export const VisibleResourcesFragmentDoc = gql`
  fragment VisibleResources on Query {
    visibleResources: resources(
      first: 6
      visibility: { gte: members }
      resource_types: { eq: course }
    ) {
      total
      edges {
        node {
          id
          name
          slug
          image(width: 100, height: 75, fit: clamp)
        }
      }
    }
  }
`
export const DiscussionParticipantFragmentDoc = gql`
  fragment DiscussionParticipant on DiscussionParticipant {
    id
    email
    first_name
    last_name
    full_name
    display_name
    profile {
      id
      bio
      image(width: 250, height: 250, crop: faces)
      location
      last_activity
      rewardful_referral_id
    }
  }
`
export const GroupFragmentDoc = gql`
  fragment Group on Group {
    id
    name
    created
    description
    price
    seats
    seats_filled
    seats_available
    registration_ends
    registration_starts
    registration_started
    registration_ended
    access_ends
    access_starts
    is_master
    is_source_cohort
    source_cohort_id
    parent_section_id
    resource_id
    visibility
    is_collection_linked
    is_subscription_only
    status
    analytics_disabled
    created_by_id
  }
`
export const TagLinkFragmentDoc = gql`
  fragment TagLink on TagLink {
    id
    tag_id
    discussion_context_id
  }
`
export const TagFragmentDoc = gql`
  fragment Tag on Tag {
    id
    name
    slug
    description
    color
  }
`
export const DiscussionPostFragmentDoc = gql`
  fragment DiscussionPost on Discussion {
    id
    title
    body
    type
    likes
    total_responses
    created_time
    is_discussion_question
    allow_replies
    last_activity_time
    user_last_viewed_time
    user_last_responded_time
    user_has_viewed_recent
    user_is_subscribed
    user_liked
    context_id
    resource_id
    cohort_id
    step_id
    user {
      ...User
    }
    cohort {
      ...Group
    }
    resource {
      ...Resource
    }
    step {
      id
      name
      verb
    }
    tagLinks(first: 50) {
      edges {
        node {
          ...TagLink
          tag {
            ...Tag
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
  ${TagLinkFragmentDoc}
  ${TagFragmentDoc}
`
export const DiscussionResponseFragmentDoc = gql`
  fragment DiscussionResponse on Response {
    id
    parent_id
    discussion_id
    body
    depth
    attachments
    likes
    user_liked
    created_time
    archived_time
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const ContextualFeaturePermissionFragmentDoc = gql`
  fragment ContextualFeaturePermission on ContextualFeaturePermission {
    id
    feature_key
    feature_action
    permission_in_context
    school_id
    resource_id
    cohort_id
    user_id
  }
`
export const GroupContextFragmentDoc = gql`
  fragment GroupContext on Group {
    ...Group
    resource {
      ...Resource
      blurred_background: background_image(blur: 500, width: 250, height: 250)
    }
    user_registration {
      id
      role
    }
    user_source_registration {
      id
      role
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`
export const CreatedResourceFragmentDoc = gql`
  fragment CreatedResource on Resource {
    ...Resource
    blurred_background: background_image(blur: 500, width: 250, height: 250)
    curriculum: curriculum_group {
      id
    }
    cohort: group(is_source: false) {
      id
      source_cohort_id
    }
  }
  ${ResourceFragmentDoc}
`
export const InboxGroupConnectionFragmentDoc = gql`
  fragment InboxGroupConnection on InboxGroupConnection {
    mentor_group {
      id
      name
      memberships(first: 3, order_by: "-role") {
        edges {
          node {
            id
            role
            user {
              ...User
            }
          }
        }
      }
    }
    cohort {
      id
      name
      resource {
        id
        name
      }
      registrations(first: 3, orderBy: { role: DESC }) {
        edges {
          node {
            id
            role
            user {
              ...User
            }
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
`
export const InboxPeopleCompletionCountsFragmentDoc = gql`
  fragment InboxPeopleCompletionCounts on InboxPeopleCompletionCounts {
    id
    count
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const InboxReviewerFragmentDoc = gql`
  fragment InboxReviewer on InboxReviewer {
    id
    group_or_cohort_id
    group_role
    cohort_role
    can_review
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const InvitationFragmentDoc = gql`
  fragment Invitation on Invitation {
    id
    created_dtime
    invitation_role
    invitation_type
    invitation_subject
    invitation_status
    invitation_url
    invitation_message
    invitation_accepted_dtime
    invitation_hash
    to_email
    to_first_name
    to_last_name
    invitation_email {
      id
      created_dtime
      delivery_status
      delivery_status_updated
    }
  }
`
export const FeatureLockSchoolBillingPlanFragmentDoc = gql`
  fragment FeatureLockSchoolBillingPlan on SchoolBillingPlan {
    id
    order
    name
    features {
      id
      key
    }
    plan_derived_from {
      id
    }
  }
`
export const SchoolSubscriptionPlanFragmentDoc = gql`
  fragment SchoolSubscriptionPlan on SchoolSubscriptionPlan {
    id
    image
    details_html
    subscribe_complete_html
    catalog_header
    is_visible
    giftable_cycles
    subscription_plan {
      ...SubscriptionPlan
    }
  }
  ${SubscriptionPlanFragmentDoc}
`
export const SchoolSubscriptionFragmentDoc = gql`
  fragment SchoolSubscription on SchoolSubscription {
    id
    user {
      ...User
    }
    subscription {
      ...Subscription
    }
    subscription_plan {
      ...SubscriptionPlan
    }
    school_subscription_plan {
      ...SchoolSubscriptionPlan
    }
  }
  ${UserFragmentDoc}
  ${SubscriptionFragmentDoc}
  ${SubscriptionPlanFragmentDoc}
  ${SchoolSubscriptionPlanFragmentDoc}
`
export const MembershipFragmentDoc = gql`
  fragment Membership on Membership {
    id
    created
    last_seen
    last_active
    has_access
    access_revoked_time
    archived_time
    role
    consent_dtime
    consent_snapshot
    user {
      ...User
      school_subscription {
        ...SchoolSubscription
      }
    }
  }
  ${UserFragmentDoc}
  ${SchoolSubscriptionFragmentDoc}
`
export const MembershipMetaFragmentDoc = gql`
  fragment MembershipMeta on MembershipMeta {
    editor
    teacher
    moderator
    learner
    observer
    lead_mentor
    mentor
  }
`
export const NoteFragmentDoc = gql`
  fragment Note on Note {
    id
    title
    body
    visibility
    created_time
    modified_time
    context_id
    resource_id
    cohort_id
    created_from_cohort_id
    step_id
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const OrderFragmentDoc = gql`
  fragment Order on Order {
    id
    order_type
    order_status
    order_data
    checkout_session_id
    stripe_publishable_api_key
    fulfilled_object_id
    school_id
    processor_id
    user_id
  }
`
export const PackageFragmentDoc = gql`
  fragment Package on Package {
    id
    school_id
    key
    name
    display_name
    public_description
    pathicon
    color
    image
    is_active
    priority
    default_school_type
    default_school_theme
    billing_plan_set_id
    default_billing_plan_id
    coupon_id
    coupon_discount
    trial_behavior
    trial_days_override
    partner_school_id
    metadata
  }
`
export const ThemeFragmentDoc = gql`
  fragment Theme on Theme {
    id
    name
    theme_type
    background_image
    background_overlay
    background_type
    heading_font
    primary_color
    typekit_id
    custom_css
    processed_custom_css
    color_palette {
      _50
      _100
      _200
      _300
      _400
      _500
      _600
      _700
      _800
      _900
      _950
    }
  }
`
export const LicensorFragmentDoc = gql`
  fragment Licensor on School {
    ...School
    theme {
      ...Theme
    }
  }
  ${SchoolFragmentDoc}
  ${ThemeFragmentDoc}
`
export const PathCreatorResourceFragmentDoc = gql`
  fragment PathCreatorResource on Resource {
    id
    name
    background_image(
      width: 250
      height: 250
      blur: 500
      high: -80
      blend: 666666
      balph: 40
      fm: "jpg"
      q: 100
      bm: "screen"
    )
    image(width: 500, height: 375, fit: crop)
    source_cohort: curriculum_group {
      id
      registration {
        id
        role
      }
    }
  }
`
export const GroupListItemRegistrationFragmentDoc = gql`
  fragment GroupListItemRegistration on Registration {
    id
    user {
      id
      first_name
      last_name
      full_name
      profile {
        id
        image
      }
    }
  }
`
export const GroupListItemFragmentDoc = gql`
  fragment GroupListItem on Group {
    id
    name
    registrations(
      first: 4
      role_filter: { in: [teacher, moderator, student] }
      orderBy: [{ role: DESC }, { last_activity_time: DESC }]
    ) {
      total
      edges {
        node {
          ...GroupListItemRegistration
        }
      }
    }
  }
  ${GroupListItemRegistrationFragmentDoc}
`
export const PathCreatorCohortFragmentDoc = gql`
  fragment PathCreatorCohort on Group {
    ...GroupListItem
  }
  ${GroupListItemFragmentDoc}
`
export const PathCreatorCreatePathFragmentDoc = gql`
  fragment PathCreatorCreatePath on Resource {
    ...PathCreatorResource
    cohort: group(is_source: false) {
      ...PathCreatorCohort
    }
  }
  ${PathCreatorResourceFragmentDoc}
  ${PathCreatorCohortFragmentDoc}
`
export const PathCreatorCohortWithRegistrationFragmentDoc = gql`
  fragment PathCreatorCohortWithRegistration on Group {
    ...PathCreatorCohort
    user_registration(user_id: $targetUserId) {
      id
      role
    }
  }
  ${PathCreatorCohortFragmentDoc}
`
export const AddedPathItemFragmentDoc = gql`
  fragment AddedPathItem on PathItem {
    ...PathItem
    items(first: 1042) {
      edges {
        node {
          ...PathItem
        }
      }
    }
  }
  ${PathItemFragmentDoc}
`
export const CohortSyncPathCohortFragmentDoc = gql`
  fragment CohortSyncPathCohort on Group {
    id
    name
    is_master
    user_registration {
      id
      role
    }
    visibility
    path(type: source) {
      id
    }
    source {
      id
      name
      is_master
      user_registration {
        id
        role
      }
      path(type: source) {
        id
      }
    }
    resource {
      id
      slug
      background_overlay
      background_image
      blurred_background: background_image(blur: 500, width: 400, height: 500)
      cohorts: groups(first: 20, status: in_progress) {
        total
        edges {
          node {
            id
            name
            is_master
            path(type: source) {
              id
            }
          }
        }
      }
      license_offerings(first: 1) {
        total
      }
      description
      short_description
      name
      licensing_enabled
      resource_type
    }
    registrations(first: 1, role_filter: { eq: student }) {
      edges {
        node {
          id
          role
        }
      }
      total
    }
  }
`
export const PathSyncPlanChangeFragmentDoc = gql`
  fragment PathSyncPlanChange on PathSyncPlanChange {
    item_source_id
    parent_source_id
    item_name
    parent_name
    item_type
    assignment_type
    forced
    forced_reasons
    change_details
    last_changed
  }
`
export const SingleCohortPathFragmentDoc = gql`
  fragment SingleCohortPath on Path {
    id
    items(flatten: true, first: 10) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          type
          blocks {
            content_last_modified
            last_published
          }
        }
      }
    }
  }
`
export const PathSyncFragmentDoc = gql`
  fragment PathSync on PathSync {
    path_id
    synced
    last_synced_date
    sync_source_path_id
    user_id
  }
`
export const PathPublishFragmentDoc = gql`
  fragment PathPublish on PathPublish {
    path_id
    published
    last_published_date
  }
`
export const PathSyncPublishFragmentDoc = gql`
  fragment PathSyncPublish on Path {
    id
    sync {
      ...PathSync
    }
    publish {
      ...PathPublish
    }
  }
  ${PathSyncFragmentDoc}
  ${PathPublishFragmentDoc}
`
export const PathFragmentDoc = gql`
  fragment Path on Path {
    id
    progress
    points {
      path_id
      total
      earned
      total_points_possible
      percentage
      has_points
    }
    next_step_id
    completion_date
    created_date
    is_source_path
    user {
      ...User
    }
    ...PathSyncPublish
  }
  ${UserFragmentDoc}
  ${PathSyncPublishFragmentDoc}
`
export const PathItemsFragmentDoc = gql`
  fragment PathItems on Path {
    ...Path
    items(first: 1042, flatten: true) {
      edges {
        node {
          ...PathItem
        }
      }
    }
  }
  ${PathFragmentDoc}
  ${PathItemFragmentDoc}
`
export const PathPerformanceFragmentDoc = gql`
  fragment PathPerformance on PathPerformance {
    id
    points {
      total
      earned
      possible
      percentage
      applicable_score
      applicable_score_percentage
    }
    progress {
      steps_completed
      required_steps_completed
      total_steps
      total_required_steps
      percentage
    }
  }
`
export const UserPathReportCardFragmentDoc = gql`
  fragment UserPathReportCard on Path {
    ...PathItems
    performance {
      ...PathPerformance
    }
    user {
      ...User
    }
    cohort {
      id
      name
    }
  }
  ${PathItemsFragmentDoc}
  ${PathPerformanceFragmentDoc}
  ${UserFragmentDoc}
`
export const StepFragmentDoc = gql`
  fragment Step on PathItem {
    id
    name
    verb
    source_id
    description
    content_id
    assignment_type
    item_content_type_id
  }
`
export const MissingPathItemFragmentDoc = gql`
  fragment MissingPathItem on PathItem {
    id
    source_id
    name
    type
    archived_time
  }
`
export const MeFragmentDoc = gql`
  fragment Me on User {
    ...User
    username
    no_password_set
    group_role_stats {
      type
      total
      role
    }
    permissions {
      is_school_owner
      can_administrate
      can_edit_library
      has_member_access
      has_pathwright_staff_access
    }
    membership {
      id
      created
      last_seen
      last_active
      has_access
      role
      consent_snapshot
      consent_dtime
    }
    profile {
      id
      notification_digest_interval
    }
  }
  ${UserFragmentDoc}
`
export const TranslationFragmentDoc = gql`
  fragment Translation on Translation {
    id
    name
    language
    translation
    master_translation
    is_default
  }
`
export const ContextFragmentDoc = gql`
  fragment Context on Query {
    school {
      ...School
      theme {
        ...Theme
      }
      features {
        auth__platform
        media__downloadable_videos
        library__cover_pages
      }
    }
    me {
      ...Me
    }
    translation {
      ...Translation
    }
    platformConfig {
      id
      payments_maintenance_mode
    }
    integrations {
      firebase {
        auth_token
        url
        client_api_key
      }
      intercom {
        app_id
        pathwright_app_id
        school_app_id
        user_hash
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ThemeFragmentDoc}
  ${MeFragmentDoc}
  ${TranslationFragmentDoc}
`
export const PositioningContextFragmentDoc = gql`
  fragment PositioningContext on PositioningContext {
    id
    context_key
    context_type
  }
`
export const __TestRegistrationFragmentDoc = gql`
  fragment __TestRegistration on Registration {
    id
    position(positioningContext: $positioningContext)
  }
`
export const PublisherFragmentDoc = gql`
  fragment Publisher on Publisher {
    id
    name
    about
    website
    image(width: 150, height: 150)
  }
`
export const UserProfileRegistrationFragmentDoc = gql`
  fragment UserProfileRegistration on Registration {
    ...Registration
    resource {
      ...Resource
    }
    group {
      ...Group
    }
    path {
      id
      progress
      completion_date
    }
  }
  ${RegistrationFragmentDoc}
  ${ResourceFragmentDoc}
  ${GroupFragmentDoc}
`
export const LicenseOfferingFragmentDoc = gql`
  fragment LicenseOffering on LicenseOffering {
    id
    description
    cost_per_seat
    include_creator_seat
    register_creator_as
    minimum_seat_count
    minimum_license_duration
    licensing_mode
    included_in_user_subscription
    include_in_curriculum_plans(first: 50) {
      total
      edges {
        node {
          id
          plan_id
        }
      }
    }
    include_in_subscription_plans(first: 50) {
      total
      edges {
        node {
          id
        }
      }
    }
    include_with_products(first: 50) {
      total
      edges {
        node {
          id
        }
      }
    }
    licensor {
      ...School
    }
  }
  ${SchoolFragmentDoc}
`
export const ResourceLicenseFragmentDoc = gql`
  fragment ResourceLicense on ResourceLicense {
    id
    seat_count
    seats_filled
    seats_available
    expiration_dtime
    school {
      id
      name
    }
    license_offering {
      ...LicenseOffering
    }
    group {
      ...Group
      resource {
        ...Resource
      }
    }
  }
  ${LicenseOfferingFragmentDoc}
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`
export const ManageResourceFragmentDoc = gql`
  fragment ManageResource on Resource {
    ...Resource
    trailer_embed_code
    visibility_level_override
    certificate_generator_class
    certificate_json
    licensed_from_resource_id
    registration_meta {
      editor_registration_count
    }
    authors(first: 10) {
      total
      edges {
        node {
          ...Author
        }
      }
    }
    categories(first: 10) {
      total
      edges {
        node {
          ...Category
        }
      }
    }
    groups(first: 1) {
      total
      edges {
        node {
          id
          seats_filled
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${AuthorFragmentDoc}
  ${CategoryFragmentDoc}
`
export const SchoolCurriculumPlanFragmentDoc = gql`
  fragment SchoolCurriculumPlan on SchoolCurriculumPlan {
    id
    name
    amount
    fee_boundary
    fee_per_user
    is_visible
    lower_boundary
    plan_id
    transaction_fee_percent
    upper_boundary
    visibility_code
  }
`
export const CurriculumSubscriptionFragmentDoc = gql`
  fragment CurriculumSubscription on CurriculumSubscription {
    id
    licensor {
      ...School
    }
    licensee {
      ...School
    }
    curriculum_plan {
      ...SchoolCurriculumPlan
    }
    subscription {
      ...Subscription
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolCurriculumPlanFragmentDoc}
  ${SubscriptionFragmentDoc}
`
export const PeopleAndGroupConnectionFragmentDoc = gql`
  fragment PeopleAndGroupConnection on PeopleAndGroupConnection {
    id
    type
    role
    role_in
    membership_status
    people_count
    meta {
      key
      type
      image {
        src
      }
      title
      subtitle
      _search
    }
  }
`
export const CreatedSpaceFragmentDoc = gql`
  fragment CreatedSpace on School {
    id
    name
    profile {
      id
    }
  }
`
export const SpaceBillingPlanSetPlanFragmentDoc = gql`
  fragment SpaceBillingPlanSetPlan on SchoolBillingPlan {
    id
    name
  }
`
export const SpaceIdentityFragmentDoc = gql`
  fragment SpaceIdentity on School {
    id
    name
    image(width: 150, height: 150)
    image_is_default
    url
    theme {
      ...Theme
    }
  }
  ${ThemeFragmentDoc}
`
export const UserSpaceMembershipFragmentDoc = gql`
  fragment UserSpaceMembership on Membership {
    id
    role
    last_seen
    school {
      ...SpaceIdentity
    }
  }
  ${SpaceIdentityFragmentDoc}
`
export const MessageFragmentDoc = gql`
  fragment Message on Message {
    id
    subject
    body
    threshold_minutes
    type
    channels
    is_active
    send_date
    sent_date
    based_on_step_date
    recipient_filter
  }
`
export const StoreFragmentDoc = gql`
  fragment Store on Store {
    id
    licensor {
      ...School
    }
  }
  ${SchoolFragmentDoc}
`
export const StoreLinkFragmentDoc = gql`
  fragment StoreLink on StoreLink {
    id
    licensee {
      ...School
    }
    store {
      ...Store
    }
  }
  ${SchoolFragmentDoc}
  ${StoreFragmentDoc}
`
export const FeatureIncludedCountFragmentDoc = gql`
  fragment FeatureIncludedCount on SchoolAcount {
    id
    billing_model
    is_activated
    is_activated_via_override
    billing_subscription {
      id
      extra_cohorts
      extra_mentor_groups
      plan {
        id
        cohorts_included
        mentor_groups_included
      }
    }
  }
`
export const SchoolGiftSubscriptionFragmentDoc = gql`
  fragment SchoolGiftSubscription on SchoolGiftSubscription {
    id
    redeemed
    recipient_email
    recipient_email_sent_time
    recipient_first_name
    recipient_last_name
    gifted_subscription_cycles
    gift_message
    gift_code
    redemption_link
    sender {
      ...User
    }
    school_subscription_plan {
      ...SchoolSubscriptionPlan
    }
  }
  ${UserFragmentDoc}
  ${SchoolSubscriptionPlanFragmentDoc}
`
export const PositionedSchoolSubscriptionPlanFragmentDoc = gql`
  fragment PositionedSchoolSubscriptionPlan on SchoolSubscriptionPlan {
    ...SchoolSubscriptionPlan
    position
  }
  ${SchoolSubscriptionPlanFragmentDoc}
`
export const TagAttachmentFragmentDoc = gql`
  fragment TagAttachment on TagAttachment {
    id
    position
    resource_id
  }
`
export const HomeCohortMembersFragmentDoc = gql`
  fragment HomeCohortMembers on Group {
    ...GroupListItem
    user_registration {
      ...GroupListItemRegistration
    }
  }
  ${GroupListItemFragmentDoc}
  ${GroupListItemRegistrationFragmentDoc}
`
export const MentorGroupMembershipFragmentDoc = gql`
  fragment MentorGroupMembership on MentorGroupMembership {
    id
    role
    created
    access_revoked_time
    group_id
    send_mentor_digest
    can_review
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const MentorGroupFragmentDoc = gql`
  fragment MentorGroup on MentorGroup {
    id
    type
    slug
    name
    description
    created
    modified
    parent_id
    has_child_groups
    seat_limit
    seats_filled
    seats_available
    owner {
      ...User
    }
    permissions {
      can_add_member
      can_add_moderator
      can_add_admin
      can_add_group
      can_edit_group
      can_change_parent
      can_edit_subscription
      can_delete_group
      can_update_member_review_permission
      can_update_moderator_review_permission
      can_update_admin_review_permission
    }
  }
  ${UserFragmentDoc}
`
export const HomeMentorGroupMembershipFragmentDoc = gql`
  fragment HomeMentorGroupMembership on MentorGroupMembership {
    ...MentorGroupMembership
    group {
      ...MentorGroup
      memberships(
        first: 4
        order_by: ["-role", "-access_revoked_time", "-created_dtime"]
      ) {
        total
        edges {
          node {
            ...MentorGroupMembership
          }
        }
      }
    }
  }
  ${MentorGroupMembershipFragmentDoc}
  ${MentorGroupFragmentDoc}
`
export const ResourceCopyConfigPartialFragmentDoc = gql`
  fragment ResourceCopyConfigPartial on ResourceCopyConfig {
    id
    name
    lookup_key
    copy_behavior
    allow_copy_via_link
    resource {
      id
      meta {
        id
        type
        key
        title
        image(height: 150, width: 150, fit: fill) {
          src
        }
      }
    }
  }
`
export const ResourceCopyConfigFragmentDoc = gql`
  fragment ResourceCopyConfig on ResourceCopyConfig {
    ...ResourceCopyConfigPartial
    children {
      ...ResourceCopyConfigPartial
      children {
        ...ResourceCopyConfigPartial
        children {
          ...ResourceCopyConfigPartial
        }
      }
    }
  }
  ${ResourceCopyConfigPartialFragmentDoc}
`
export const ResourceCopyConfigLinkFragmentDoc = gql`
  fragment ResourceCopyConfigLink on ResourceCopyConfigLink {
    id
    createdTime
    copiedTime
    resourceId
    cohortId
    copierRegistrationId
    hideFromLocations
    resourceCopyConfig {
      ...ResourceCopyConfig
    }
  }
  ${ResourceCopyConfigFragmentDoc}
`
export const HomeResourceFragmentDoc = gql`
  fragment HomeResource on Resource {
    ...Resource
    groups(first: 1, status: in_progress) {
      total
    }
  }
  ${ResourceFragmentDoc}
`
export const HomeGroupFragmentDoc = gql`
  fragment HomeGroup on Group {
    ...Group
    user_registration {
      id
      role
      path_id
      user {
        ...User
      }
    }
    user_source_registration {
      id
      role
    }
    registrations(
      first: 4
      role_filter: { in: [teacher, moderator, student] }
      orderBy: [{ role: DESC }, { last_activity_time: DESC }]
    ) {
      total
      edges {
        node {
          ...GroupListItemRegistration
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${UserFragmentDoc}
  ${GroupListItemRegistrationFragmentDoc}
`
export const HomeRegistrationFragmentDoc = gql`
  fragment HomeRegistration on Registration {
    id
    role
    completion_state
    send_due_notifications
    send_discussion_notifications
    softArchivedTime
    last_activity_time
    expiration_dtime
    created
    position(positioningContext: $positioningContext)
    user {
      ...User
    }
    resource {
      ...HomeResource
    }
    group {
      ...HomeGroup
    }
    path {
      id
      progress
      completion_date
      next_step_id
    }
  }
  ${UserFragmentDoc}
  ${HomeResourceFragmentDoc}
  ${HomeGroupFragmentDoc}
`
export const HomeResourceCopyConfigLinkFragmentDoc = gql`
  fragment HomeResourceCopyConfigLink on ResourceCopyConfigLink {
    ...ResourceCopyConfigLink
    copierRegistration {
      ...HomeRegistration
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
  ${HomeRegistrationFragmentDoc}
`
export const RegistrationSoftArchivedFragmentDoc = gql`
  fragment RegistrationSoftArchived on Registration {
    id
    softArchivedTime
    send_discussion_notifications
    send_due_notifications
  }
`
export const UserPreferenceFragmentDoc = gql`
  fragment UserPreference on UserPreference {
    id
    school_id
    user_id
    key
    scope
    data
    created
    modified
  }
`
export const StripePriceFragmentDoc = gql`
  fragment StripePrice on StripePrice {
    id
    active
    billing_scheme
    currency
    nickname
    recurring_interval
    recurring_interval_count
    stripe_price_id
    stripe_connected_account_url
    tiers_mode
    unit_amount_decimal
    tiers {
      up_to
      flat_amount
      flat_amount_decimal
      unit_amount
      unit_amount_decimal
    }
    product {
      id
      min_quantity
      max_quantity
    }
  }
`
export const StripeProductFragmentDoc = gql`
  fragment StripeProduct on StripeProduct {
    id
    active
    name
    description
    images
    unit_label
    stripe_product_id
    stripe_connected_account_url
    min_quantity
    max_quantity
  }
`
export const SchoolGroupSubscriptionFragmentDoc = gql`
  fragment SchoolGroupSubscription on SchoolGroupSubscription {
    id
    price {
      ...StripePrice
      product {
        ...StripeProduct
      }
    }
    user {
      ...User
    }
    subscription {
      ...Subscription
    }
    community_group {
      ...MentorGroup
    }
  }
  ${StripePriceFragmentDoc}
  ${StripeProductFragmentDoc}
  ${UserFragmentDoc}
  ${SubscriptionFragmentDoc}
  ${MentorGroupFragmentDoc}
`
export const MentorGroupSubscriptionFragmentDoc = gql`
  fragment MentorGroupSubscription on MentorGroup {
    ...MentorGroup
    memberships(first: 5) {
      total
      edges {
        node {
          id
          user {
            ...User
          }
        }
      }
    }
    group_subscription {
      ...SchoolGroupSubscription
    }
  }
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
  ${SchoolGroupSubscriptionFragmentDoc}
`
export const UserMentorGroupSubscriptionMembershipFragmentDoc = gql`
  fragment UserMentorGroupSubscriptionMembership on MentorGroupMembership {
    ...MentorGroupMembership
    group {
      ...MentorGroupSubscription
    }
  }
  ${MentorGroupMembershipFragmentDoc}
  ${MentorGroupSubscriptionFragmentDoc}
`
export const GroupNameFragmentDoc = gql`
  fragment GroupName on Group {
    id
    name
  }
`
export const GroupStatusFragmentDoc = gql`
  fragment GroupStatus on Group {
    id
    status
  }
`
export const UserMembershipFragmentDoc = gql`
  fragment UserMembership on Membership {
    id
    role
  }
`
export const CurrentUserFragmentDoc = gql`
  fragment CurrentUser on User {
    id
    email
    first_name
    last_name
    full_name
    display_name
    is_finalized
    no_password_set
    profile {
      id
      bio
      image(width: 250, height: 250, crop: faces)
      location
      last_activity
      notification_digest_interval
    }
    membership {
      ...UserMembership
    }
  }
  ${UserMembershipFragmentDoc}
`
export const AuthRequestFragmentDoc = gql`
  fragment AuthRequest on AuthRequest {
    uuid
    request_method
    request_key
    request_dtime
    confirmed_dtime
    expiration_dtime
    confirmation_attempts
    context
    truncated_email
    issued_auth_token {
      token
    }
  }
`
export const UserStatusFragmentDoc = gql`
  fragment UserStatus on UserStatus {
    input_type
    user_exists
    email_verified
    no_password_set
    has_membership
  }
`
export const NodeMetaFragmentDoc = gql`
  fragment NodeMeta on NodeMeta {
    id
    key
    type
    url
    title
    subtitle
    description
    image {
      src
    }
  }
`
export const NodeThemeBackgroundFragmentDoc = gql`
  fragment NodeThemeBackground on NodeThemeBackground {
    image {
      src
    }
    image_blurred: image(blur: 320) {
      src
    }
    image_blurred_dark: image(blur: 320, brightness: -20) {
      src
    }
    color
    contrast_color
  }
`
export const NodeThemeFragmentDoc = gql`
  fragment NodeTheme on NodeTheme {
    color
    color_palette {
      _50
      _100
      _200
      _300
      _400
      _500
      _600
      _700
      _800
      _900
    }
    background {
      ...NodeThemeBackground
    }
  }
  ${NodeThemeBackgroundFragmentDoc}
`
export const SpaceFragmentDoc = gql`
  fragment Space on Space {
    id
    name
    subdomain
    created
    is_activated
    ietf_language_tag
    is_owner
    image(width: 150, height: 150)
    meta {
      ...NodeMeta
    }
    theme {
      ...NodeTheme
    }
  }
  ${NodeMetaFragmentDoc}
  ${NodeThemeFragmentDoc}
`
export const AccountDocument = gql`
  query Account($default_billing_plan_set: Boolean = true) {
    account {
      id
      is_activated
      is_activated_via_override
      is_on_legacy_plan
      billing_model
      billing_subscription {
        ...SchoolBillingSubscription
      }
      curriculum_subscription {
        ...CurriculumSubscription
      }
      billing_plan_set(default: $default_billing_plan_set) {
        ...SchoolBillingPlanSet
      }
      scholarship {
        id
        coupon {
          id
          percent_off
        }
        ends
        iterations
        order
        plan_id
        starts
      }
    }
  }
  ${SchoolBillingSubscriptionFragmentDoc}
  ${CurriculumSubscriptionFragmentDoc}
  ${SchoolBillingPlanSetFragmentDoc}
`

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      default_billing_plan_set: // value for 'default_billing_plan_set'
 *   },
 * });
 */
export function useAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options
  )
}
export function useAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options
  )
}
export function useAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options
  )
}
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>
export type AccountSuspenseQueryHookResult = ReturnType<
  typeof useAccountSuspenseQuery
>
export type AccountQueryResult = Apollo.QueryResult<
  AccountQuery,
  AccountQueryVariables
>
export const CreatePageDocument = gql`
  mutation CreatePage(
    $name: String!
    $title: String
    $page_type: Int
    $show_in_nav: Boolean = false
    $mode: String
  ) {
    createPage(
      name: $name
      title: $title
      page_type: $page_type
      show_in_nav: $show_in_nav
      mode: $mode
    ) {
      ...Page
    }
  }
  ${PageFragmentDoc}
`
export type CreatePageMutationFn = Apollo.MutationFunction<
  CreatePageMutation,
  CreatePageMutationVariables
>

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      name: // value for 'name'
 *      title: // value for 'title'
 *      page_type: // value for 'page_type'
 *      show_in_nav: // value for 'show_in_nav'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCreatePageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePageMutation,
    CreatePageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(
    CreatePageDocument,
    options
  )
}
export type CreatePageMutationHookResult = ReturnType<
  typeof useCreatePageMutation
>
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<
  CreatePageMutation,
  CreatePageMutationVariables
>
export const PageDocument = gql`
  query Page($id: Int, $page_type: Int, $slug: String, $is_live: Boolean) {
    school {
      ...School
      page(id: $id, page_type: $page_type, slug: $slug, is_live: $is_live) {
        ...Page
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PageFragmentDoc}
`

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page_type: // value for 'page_type'
 *      slug: // value for 'slug'
 *      is_live: // value for 'is_live'
 *   },
 * });
 */
export function usePageQuery(
  baseOptions?: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options)
}
export function usePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(
    PageDocument,
    options
  )
}
export function usePageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(
    PageDocument,
    options
  )
}
export type PageQueryHookResult = ReturnType<typeof usePageQuery>
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>
export type PageSuspenseQueryHookResult = ReturnType<
  typeof usePageSuspenseQuery
>
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>
export const PagesDocument = gql`
  query Pages($first: Int = 10, $isLive: Boolean, $showInNav: Boolean) {
    school {
      ...School
      pages(first: $first, is_live: $isLive, show_in_nav: $showInNav) {
        edges {
          node {
            ...Page
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PageFragmentDoc}
`

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      isLive: // value for 'isLive'
 *      showInNav: // value for 'showInNav'
 *   },
 * });
 */
export function usePagesQuery(
  baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  )
}
export function usePagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  )
}
export function usePagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  )
}
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>
export type PagesSuspenseQueryHookResult = ReturnType<
  typeof usePagesSuspenseQuery
>
export type PagesQueryResult = Apollo.QueryResult<
  PagesQuery,
  PagesQueryVariables
>
export const UpdatePageDocument = gql`
  mutation UpdatePage(
    $id: Int!
    $name: String
    $page_type: Int
    $title: String
    $description: String
    $slug: String
    $show_in_nav: Boolean
    $external_url: String
    $iframe_url: String
    $template_content: String
    $scripts: String
    $mode: String
    $is_live: Boolean
    $content_type: Int
  ) {
    updatePage(
      id: $id
      name: $name
      page_type: $page_type
      title: $title
      description: $description
      slug: $slug
      show_in_nav: $show_in_nav
      external_url: $external_url
      iframe_url: $iframe_url
      template_content: $template_content
      scripts: $scripts
      mode: $mode
      is_live: $is_live
      content_type: $content_type
    ) {
      ...Page
    }
  }
  ${PageFragmentDoc}
`
export type UpdatePageMutationFn = Apollo.MutationFunction<
  UpdatePageMutation,
  UpdatePageMutationVariables
>

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      page_type: // value for 'page_type'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      slug: // value for 'slug'
 *      show_in_nav: // value for 'show_in_nav'
 *      external_url: // value for 'external_url'
 *      iframe_url: // value for 'iframe_url'
 *      template_content: // value for 'template_content'
 *      scripts: // value for 'scripts'
 *      mode: // value for 'mode'
 *      is_live: // value for 'is_live'
 *      content_type: // value for 'content_type'
 *   },
 * });
 */
export function useUpdatePageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePageMutation,
    UpdatePageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(
    UpdatePageDocument,
    options
  )
}
export type UpdatePageMutationHookResult = ReturnType<
  typeof useUpdatePageMutation
>
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<
  UpdatePageMutation,
  UpdatePageMutationVariables
>
export const UpdatePageOrdersDocument = gql`
  mutation UpdatePageOrders($page_orders: [ListOrderInput!]!) {
    updatePageOrders(page_orders: $page_orders)
  }
`
export type UpdatePageOrdersMutationFn = Apollo.MutationFunction<
  UpdatePageOrdersMutation,
  UpdatePageOrdersMutationVariables
>

/**
 * __useUpdatePageOrdersMutation__
 *
 * To run a mutation, you first call `useUpdatePageOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageOrdersMutation, { data, loading, error }] = useUpdatePageOrdersMutation({
 *   variables: {
 *      page_orders: // value for 'page_orders'
 *   },
 * });
 */
export function useUpdatePageOrdersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePageOrdersMutation,
    UpdatePageOrdersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePageOrdersMutation,
    UpdatePageOrdersMutationVariables
  >(UpdatePageOrdersDocument, options)
}
export type UpdatePageOrdersMutationHookResult = ReturnType<
  typeof useUpdatePageOrdersMutation
>
export type UpdatePageOrdersMutationResult =
  Apollo.MutationResult<UpdatePageOrdersMutation>
export type UpdatePageOrdersMutationOptions = Apollo.BaseMutationOptions<
  UpdatePageOrdersMutation,
  UpdatePageOrdersMutationVariables
>
export const CreateSchoolThemeDocument = gql`
  mutation CreateSchoolTheme($theme: ThemeInput!) {
    createSchoolTheme(theme: $theme) {
      ...Theme
    }
  }
  ${ThemeFragmentDoc}
`
export type CreateSchoolThemeMutationFn = Apollo.MutationFunction<
  CreateSchoolThemeMutation,
  CreateSchoolThemeMutationVariables
>

/**
 * __useCreateSchoolThemeMutation__
 *
 * To run a mutation, you first call `useCreateSchoolThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolThemeMutation, { data, loading, error }] = useCreateSchoolThemeMutation({
 *   variables: {
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useCreateSchoolThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSchoolThemeMutation,
    CreateSchoolThemeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateSchoolThemeMutation,
    CreateSchoolThemeMutationVariables
  >(CreateSchoolThemeDocument, options)
}
export type CreateSchoolThemeMutationHookResult = ReturnType<
  typeof useCreateSchoolThemeMutation
>
export type CreateSchoolThemeMutationResult =
  Apollo.MutationResult<CreateSchoolThemeMutation>
export type CreateSchoolThemeMutationOptions = Apollo.BaseMutationOptions<
  CreateSchoolThemeMutation,
  CreateSchoolThemeMutationVariables
>
export const UpdateSchoolThemeDocument = gql`
  mutation UpdateSchoolTheme($id: Int!, $theme: ThemeInput!) {
    updateSchoolTheme(id: $id, theme: $theme) {
      ...Theme
    }
  }
  ${ThemeFragmentDoc}
`
export type UpdateSchoolThemeMutationFn = Apollo.MutationFunction<
  UpdateSchoolThemeMutation,
  UpdateSchoolThemeMutationVariables
>

/**
 * __useUpdateSchoolThemeMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolThemeMutation, { data, loading, error }] = useUpdateSchoolThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useUpdateSchoolThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchoolThemeMutation,
    UpdateSchoolThemeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSchoolThemeMutation,
    UpdateSchoolThemeMutationVariables
  >(UpdateSchoolThemeDocument, options)
}
export type UpdateSchoolThemeMutationHookResult = ReturnType<
  typeof useUpdateSchoolThemeMutation
>
export type UpdateSchoolThemeMutationResult =
  Apollo.MutationResult<UpdateSchoolThemeMutation>
export type UpdateSchoolThemeMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchoolThemeMutation,
  UpdateSchoolThemeMutationVariables
>
export const UpdateTranslationMutationDocument = gql`
  mutation UpdateTranslationMutation($id: Int!, $translation: JSON!) {
    updateTranslation(id: $id, translation: $translation) {
      id
      school_translation
    }
  }
`
export type UpdateTranslationMutationMutationFn = Apollo.MutationFunction<
  UpdateTranslationMutationMutation,
  UpdateTranslationMutationMutationVariables
>

/**
 * __useUpdateTranslationMutationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutationMutation, { data, loading, error }] = useUpdateTranslationMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      translation: // value for 'translation'
 *   },
 * });
 */
export function useUpdateTranslationMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTranslationMutationMutation,
    UpdateTranslationMutationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTranslationMutationMutation,
    UpdateTranslationMutationMutationVariables
  >(UpdateTranslationMutationDocument, options)
}
export type UpdateTranslationMutationMutationHookResult = ReturnType<
  typeof useUpdateTranslationMutationMutation
>
export type UpdateTranslationMutationMutationResult =
  Apollo.MutationResult<UpdateTranslationMutationMutation>
export type UpdateTranslationMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateTranslationMutationMutation,
    UpdateTranslationMutationMutationVariables
  >
export const ActivityDocument = gql`
  query Activity(
    $cursor: String
    $action_type: ActionTypeFilter
    $user_id: Int
    $resource_id: Int
    $group_id: Int
    $step_id: Int
    $include_user: Boolean!
  ) {
    activity_user: user(id: $user_id) @include(if: $include_user) {
      id
      first_name
    }
    activity(
      first: 26
      after: $cursor
      action_type: $action_type
      user_id: $user_id
      resource_id: $resource_id
      group_id: $group_id
      step_id: $step_id
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          action_type
          action_dtime
          resource {
            ...ResourceThumbnail
          }
          group {
            id
            name
            seats
          }
          user {
            ...User
          }
          triggered_by {
            ...User
          }
          step {
            id
            source_id
            name
            verb
            completion {
              id
              user {
                id
              }
            }
          }
          discussion {
            id
            title
            body
            type
            is_discussion_question
            user {
              id
              display_name
            }
          }
          discussion_response {
            ...DiscussionResponse
            parent_response {
              ...DiscussionResponse
            }
          }
        }
      }
    }
  }
  ${ResourceThumbnailFragmentDoc}
  ${UserFragmentDoc}
  ${DiscussionResponseFragmentDoc}
`

/**
 * __useActivityQuery__
 *
 * To run a query within a React component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      action_type: // value for 'action_type'
 *      user_id: // value for 'user_id'
 *      resource_id: // value for 'resource_id'
 *      group_id: // value for 'group_id'
 *      step_id: // value for 'step_id'
 *      include_user: // value for 'include_user'
 *   },
 * });
 */
export function useActivityQuery(
  baseOptions: Apollo.QueryHookOptions<ActivityQuery, ActivityQueryVariables> &
    ({ variables: ActivityQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ActivityQuery, ActivityQueryVariables>(
    ActivityDocument,
    options
  )
}
export function useActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityQuery,
    ActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ActivityQuery, ActivityQueryVariables>(
    ActivityDocument,
    options
  )
}
export function useActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActivityQuery, ActivityQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ActivityQuery, ActivityQueryVariables>(
    ActivityDocument,
    options
  )
}
export type ActivityQueryHookResult = ReturnType<typeof useActivityQuery>
export type ActivityLazyQueryHookResult = ReturnType<
  typeof useActivityLazyQuery
>
export type ActivitySuspenseQueryHookResult = ReturnType<
  typeof useActivitySuspenseQuery
>
export type ActivityQueryResult = Apollo.QueryResult<
  ActivityQuery,
  ActivityQueryVariables
>
export const ActivityStatsDocument = gql`
  query ActivityStats {
    activityStats {
      discussions
      discussion_responses
      registrations
      steps_completed
    }
  }
`

/**
 * __useActivityStatsQuery__
 *
 * To run a query within a React component, call `useActivityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityStatsQuery,
    ActivityStatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ActivityStatsQuery, ActivityStatsQueryVariables>(
    ActivityStatsDocument,
    options
  )
}
export function useActivityStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityStatsQuery,
    ActivityStatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ActivityStatsQuery, ActivityStatsQueryVariables>(
    ActivityStatsDocument,
    options
  )
}
export function useActivityStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityStatsQuery,
        ActivityStatsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ActivityStatsQuery,
    ActivityStatsQueryVariables
  >(ActivityStatsDocument, options)
}
export type ActivityStatsQueryHookResult = ReturnType<
  typeof useActivityStatsQuery
>
export type ActivityStatsLazyQueryHookResult = ReturnType<
  typeof useActivityStatsLazyQuery
>
export type ActivityStatsSuspenseQueryHookResult = ReturnType<
  typeof useActivityStatsSuspenseQuery
>
export type ActivityStatsQueryResult = Apollo.QueryResult<
  ActivityStatsQuery,
  ActivityStatsQueryVariables
>
export const AssignDocument = gql`
  mutation Assign(
    $offerings: [Int]!
    $assign_to_user: Int!
    $role: RegistrationRoleEnum!
    $send_notification: Boolean = true
    $assignment_message: String
  ) {
    assign(
      offerings: $offerings
      assign_to_user: $assign_to_user
      role: $role
      send_notification: $send_notification
      assignment_message: $assignment_message
    )
  }
`
export type AssignMutationFn = Apollo.MutationFunction<
  AssignMutation,
  AssignMutationVariables
>

/**
 * __useAssignMutation__
 *
 * To run a mutation, you first call `useAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMutation, { data, loading, error }] = useAssignMutation({
 *   variables: {
 *      offerings: // value for 'offerings'
 *      assign_to_user: // value for 'assign_to_user'
 *      role: // value for 'role'
 *      send_notification: // value for 'send_notification'
 *      assignment_message: // value for 'assignment_message'
 *   },
 * });
 */
export function useAssignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignMutation,
    AssignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AssignMutation, AssignMutationVariables>(
    AssignDocument,
    options
  )
}
export type AssignMutationHookResult = ReturnType<typeof useAssignMutation>
export type AssignMutationResult = Apollo.MutationResult<AssignMutation>
export type AssignMutationOptions = Apollo.BaseMutationOptions<
  AssignMutation,
  AssignMutationVariables
>
export const AssignResourceDocument = gql`
  query AssignResource(
    $id: Int
    $assignConfig: AssignConfig
    $search: String
    $cursor: String
  ) {
    resource(id: $id) {
      ...Resource
      cohorts: groups(
        first: 10
        assign_config: $assignConfig
        search: $search
        after: $cursor
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Group
          }
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${GroupFragmentDoc}
`

/**
 * __useAssignResourceQuery__
 *
 * To run a query within a React component, call `useAssignResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      assignConfig: // value for 'assignConfig'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAssignResourceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssignResourceQuery,
    AssignResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssignResourceQuery, AssignResourceQueryVariables>(
    AssignResourceDocument,
    options
  )
}
export function useAssignResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignResourceQuery,
    AssignResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssignResourceQuery, AssignResourceQueryVariables>(
    AssignResourceDocument,
    options
  )
}
export function useAssignResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignResourceQuery,
        AssignResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AssignResourceQuery,
    AssignResourceQueryVariables
  >(AssignResourceDocument, options)
}
export type AssignResourceQueryHookResult = ReturnType<
  typeof useAssignResourceQuery
>
export type AssignResourceLazyQueryHookResult = ReturnType<
  typeof useAssignResourceLazyQuery
>
export type AssignResourceSuspenseQueryHookResult = ReturnType<
  typeof useAssignResourceSuspenseQuery
>
export type AssignResourceQueryResult = Apollo.QueryResult<
  AssignResourceQuery,
  AssignResourceQueryVariables
>
export const AssignRolesQueryDocument = gql`
  query AssignRolesQuery {
    assignRoles
  }
`

/**
 * __useAssignRolesQueryQuery__
 *
 * To run a query within a React component, call `useAssignRolesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignRolesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignRolesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignRolesQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssignRolesQueryQuery,
    AssignRolesQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssignRolesQueryQuery, AssignRolesQueryQueryVariables>(
    AssignRolesQueryDocument,
    options
  )
}
export function useAssignRolesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignRolesQueryQuery,
    AssignRolesQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AssignRolesQueryQuery,
    AssignRolesQueryQueryVariables
  >(AssignRolesQueryDocument, options)
}
export function useAssignRolesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignRolesQueryQuery,
        AssignRolesQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AssignRolesQueryQuery,
    AssignRolesQueryQueryVariables
  >(AssignRolesQueryDocument, options)
}
export type AssignRolesQueryQueryHookResult = ReturnType<
  typeof useAssignRolesQueryQuery
>
export type AssignRolesQueryLazyQueryHookResult = ReturnType<
  typeof useAssignRolesQueryLazyQuery
>
export type AssignRolesQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignRolesQuerySuspenseQuery
>
export type AssignRolesQueryQueryResult = Apollo.QueryResult<
  AssignRolesQueryQuery,
  AssignRolesQueryQueryVariables
>
export const GetTokenViaSsoDocument = gql`
  mutation GetTokenViaSSO($ssoToken: String!) {
    getTokenViaSSO(sso_token: $ssoToken) {
      token
    }
  }
`
export type GetTokenViaSsoMutationFn = Apollo.MutationFunction<
  GetTokenViaSsoMutation,
  GetTokenViaSsoMutationVariables
>

/**
 * __useGetTokenViaSsoMutation__
 *
 * To run a mutation, you first call `useGetTokenViaSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTokenViaSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTokenViaSsoMutation, { data, loading, error }] = useGetTokenViaSsoMutation({
 *   variables: {
 *      ssoToken: // value for 'ssoToken'
 *   },
 * });
 */
export function useGetTokenViaSsoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetTokenViaSsoMutation,
    GetTokenViaSsoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GetTokenViaSsoMutation,
    GetTokenViaSsoMutationVariables
  >(GetTokenViaSsoDocument, options)
}
export type GetTokenViaSsoMutationHookResult = ReturnType<
  typeof useGetTokenViaSsoMutation
>
export type GetTokenViaSsoMutationResult =
  Apollo.MutationResult<GetTokenViaSsoMutation>
export type GetTokenViaSsoMutationOptions = Apollo.BaseMutationOptions<
  GetTokenViaSsoMutation,
  GetTokenViaSsoMutationVariables
>
export const HeartbeatDocument = gql`
  mutation Heartbeat {
    heartbeat {
      ...Heartbeat
    }
  }
  ${HeartbeatFragmentDoc}
`
export type HeartbeatMutationFn = Apollo.MutationFunction<
  HeartbeatMutation,
  HeartbeatMutationVariables
>

/**
 * __useHeartbeatMutation__
 *
 * To run a mutation, you first call `useHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heartbeatMutation, { data, loading, error }] = useHeartbeatMutation({
 *   variables: {
 *   },
 * });
 */
export function useHeartbeatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HeartbeatMutation,
    HeartbeatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<HeartbeatMutation, HeartbeatMutationVariables>(
    HeartbeatDocument,
    options
  )
}
export type HeartbeatMutationHookResult = ReturnType<
  typeof useHeartbeatMutation
>
export type HeartbeatMutationResult = Apollo.MutationResult<HeartbeatMutation>
export type HeartbeatMutationOptions = Apollo.BaseMutationOptions<
  HeartbeatMutation,
  HeartbeatMutationVariables
>
export const ProxyAuthTokenDocument = gql`
  mutation ProxyAuthToken($user_id: Int!, $school_id: Int) {
    proxyAuthToken(user_id: $user_id, school_id: $school_id)
  }
`
export type ProxyAuthTokenMutationFn = Apollo.MutationFunction<
  ProxyAuthTokenMutation,
  ProxyAuthTokenMutationVariables
>

/**
 * __useProxyAuthTokenMutation__
 *
 * To run a mutation, you first call `useProxyAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProxyAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proxyAuthTokenMutation, { data, loading, error }] = useProxyAuthTokenMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function useProxyAuthTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProxyAuthTokenMutation,
    ProxyAuthTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProxyAuthTokenMutation,
    ProxyAuthTokenMutationVariables
  >(ProxyAuthTokenDocument, options)
}
export type ProxyAuthTokenMutationHookResult = ReturnType<
  typeof useProxyAuthTokenMutation
>
export type ProxyAuthTokenMutationResult =
  Apollo.MutationResult<ProxyAuthTokenMutation>
export type ProxyAuthTokenMutationOptions = Apollo.BaseMutationOptions<
  ProxyAuthTokenMutation,
  ProxyAuthTokenMutationVariables
>
export const RefreshTokenDocument = gql`
  mutation RefreshToken($school_id: ID) {
    refreshToken(school_id: $school_id)
  }
`
export type RefreshTokenMutationFn = Apollo.MutationFunction<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function useRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshTokenMutation,
    RefreshTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RefreshTokenMutation,
    RefreshTokenMutationVariables
  >(RefreshTokenDocument, options)
}
export type RefreshTokenMutationHookResult = ReturnType<
  typeof useRefreshTokenMutation
>
export type RefreshTokenMutationResult =
  Apollo.MutationResult<RefreshTokenMutation>
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>
export const AuthorDocument = gql`
  query Author($id: Int, $slug: String) {
    school {
      ...School
      author(id: $id, slug: $slug) {
        ...Author
      }
    }
  }
  ${SchoolFragmentDoc}
  ${AuthorFragmentDoc}
`

/**
 * __useAuthorQuery__
 *
 * To run a query within a React component, call `useAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAuthorQuery(
  baseOptions?: Apollo.QueryHookOptions<AuthorQuery, AuthorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthorQuery, AuthorQueryVariables>(
    AuthorDocument,
    options
  )
}
export function useAuthorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AuthorQuery, AuthorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AuthorQuery, AuthorQueryVariables>(
    AuthorDocument,
    options
  )
}
export function useAuthorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AuthorQuery, AuthorQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AuthorQuery, AuthorQueryVariables>(
    AuthorDocument,
    options
  )
}
export type AuthorQueryHookResult = ReturnType<typeof useAuthorQuery>
export type AuthorLazyQueryHookResult = ReturnType<typeof useAuthorLazyQuery>
export type AuthorSuspenseQueryHookResult = ReturnType<
  typeof useAuthorSuspenseQuery
>
export type AuthorQueryResult = Apollo.QueryResult<
  AuthorQuery,
  AuthorQueryVariables
>
export const AuthorsDocument = gql`
  query Authors(
    $first: Int!
    $cursor: String
    $school_id: Int!
    $search: String
    $ids: IDFilter
    $manage: Boolean
    $positioningContext: PositioningContextInput
    $orderBy: [AuthorOrderByInput]
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        authors(
          first: $first
          after: $cursor
          search: $search
          ids: $ids
          manage: $manage
          positioningContext: $positioningContext
          orderBy: $orderBy
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...PositionedAuthor
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PositionedAuthorFragmentDoc}
`

/**
 * __useAuthorsQuery__
 *
 * To run a query within a React component, call `useAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *      manage: // value for 'manage'
 *      positioningContext: // value for 'positioningContext'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAuthorsQuery(
  baseOptions: Apollo.QueryHookOptions<AuthorsQuery, AuthorsQueryVariables> &
    ({ variables: AuthorsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthorsQuery, AuthorsQueryVariables>(
    AuthorsDocument,
    options
  )
}
export function useAuthorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AuthorsQuery, AuthorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AuthorsQuery, AuthorsQueryVariables>(
    AuthorsDocument,
    options
  )
}
export function useAuthorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AuthorsQuery, AuthorsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AuthorsQuery, AuthorsQueryVariables>(
    AuthorsDocument,
    options
  )
}
export type AuthorsQueryHookResult = ReturnType<typeof useAuthorsQuery>
export type AuthorsLazyQueryHookResult = ReturnType<typeof useAuthorsLazyQuery>
export type AuthorsSuspenseQueryHookResult = ReturnType<
  typeof useAuthorsSuspenseQuery
>
export type AuthorsQueryResult = Apollo.QueryResult<
  AuthorsQuery,
  AuthorsQueryVariables
>
export const CreateCoverPageAuthorDocument = gql`
  mutation CreateCoverPageAuthor(
    $avatar: String
    $bio: String!
    $contributorPositioningContext: PositioningContextInput
    $first_name: String!
    $last_name: String!
    $order: Int!
    $salutation: String!
    $title: String!
  ) {
    createAuthor(
      avatar: $avatar
      bio: $bio
      first_name: $first_name
      last_name: $last_name
      order: $order
      salutation: $salutation
      title: $title
    ) {
      ...CoverPageContributor
    }
  }
  ${CoverPageContributorFragmentDoc}
`
export type CreateCoverPageAuthorMutationFn = Apollo.MutationFunction<
  CreateCoverPageAuthorMutation,
  CreateCoverPageAuthorMutationVariables
>

/**
 * __useCreateCoverPageAuthorMutation__
 *
 * To run a mutation, you first call `useCreateCoverPageAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoverPageAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoverPageAuthorMutation, { data, loading, error }] = useCreateCoverPageAuthorMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *      bio: // value for 'bio'
 *      contributorPositioningContext: // value for 'contributorPositioningContext'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      order: // value for 'order'
 *      salutation: // value for 'salutation'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateCoverPageAuthorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoverPageAuthorMutation,
    CreateCoverPageAuthorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCoverPageAuthorMutation,
    CreateCoverPageAuthorMutationVariables
  >(CreateCoverPageAuthorDocument, options)
}
export type CreateCoverPageAuthorMutationHookResult = ReturnType<
  typeof useCreateCoverPageAuthorMutation
>
export type CreateCoverPageAuthorMutationResult =
  Apollo.MutationResult<CreateCoverPageAuthorMutation>
export type CreateCoverPageAuthorMutationOptions = Apollo.BaseMutationOptions<
  CreateCoverPageAuthorMutation,
  CreateCoverPageAuthorMutationVariables
>
export const UpdateCoverPageAuthorDocument = gql`
  mutation UpdateCoverPageAuthor(
    $avatar: String
    $bio: String
    $contributorPositioningContext: PositioningContextInput
    $first_name: String
    $id: Int!
    $last_name: String
    $salutation: String
    $title: String
  ) {
    updateAuthor(
      avatar: $avatar
      bio: $bio
      first_name: $first_name
      id: $id
      last_name: $last_name
      salutation: $salutation
      title: $title
    ) {
      ...CoverPageContributor
    }
  }
  ${CoverPageContributorFragmentDoc}
`
export type UpdateCoverPageAuthorMutationFn = Apollo.MutationFunction<
  UpdateCoverPageAuthorMutation,
  UpdateCoverPageAuthorMutationVariables
>

/**
 * __useUpdateCoverPageAuthorMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPageAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPageAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPageAuthorMutation, { data, loading, error }] = useUpdateCoverPageAuthorMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *      bio: // value for 'bio'
 *      contributorPositioningContext: // value for 'contributorPositioningContext'
 *      first_name: // value for 'first_name'
 *      id: // value for 'id'
 *      last_name: // value for 'last_name'
 *      salutation: // value for 'salutation'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateCoverPageAuthorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoverPageAuthorMutation,
    UpdateCoverPageAuthorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCoverPageAuthorMutation,
    UpdateCoverPageAuthorMutationVariables
  >(UpdateCoverPageAuthorDocument, options)
}
export type UpdateCoverPageAuthorMutationHookResult = ReturnType<
  typeof useUpdateCoverPageAuthorMutation
>
export type UpdateCoverPageAuthorMutationResult =
  Apollo.MutationResult<UpdateCoverPageAuthorMutation>
export type UpdateCoverPageAuthorMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoverPageAuthorMutation,
  UpdateCoverPageAuthorMutationVariables
>
export const BannerDocument = gql`
  query Banner($school_id: Int!, $id: Int!) {
    context(school_id: $school_id) {
      school {
        ...School
        banner(id: $id) {
          ...Banner
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${BannerFragmentDoc}
`

/**
 * __useBannerQuery__
 *
 * To run a query within a React component, call `useBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerQuery({
 *   variables: {
 *      school_id: // value for 'school_id'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBannerQuery(
  baseOptions: Apollo.QueryHookOptions<BannerQuery, BannerQueryVariables> &
    ({ variables: BannerQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BannerQuery, BannerQueryVariables>(
    BannerDocument,
    options
  )
}
export function useBannerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BannerQuery, BannerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<BannerQuery, BannerQueryVariables>(
    BannerDocument,
    options
  )
}
export function useBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BannerQuery, BannerQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<BannerQuery, BannerQueryVariables>(
    BannerDocument,
    options
  )
}
export type BannerQueryHookResult = ReturnType<typeof useBannerQuery>
export type BannerLazyQueryHookResult = ReturnType<typeof useBannerLazyQuery>
export type BannerSuspenseQueryHookResult = ReturnType<
  typeof useBannerSuspenseQuery
>
export type BannerQueryResult = Apollo.QueryResult<
  BannerQuery,
  BannerQueryVariables
>
export const BannersDocument = gql`
  query Banners(
    $cursor: String
    $school_id: Int!
    $first: Int!
    $manage: Boolean = false
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        banners(first: $first, after: $cursor, manage: $manage) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Banner
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${BannerFragmentDoc}
`

/**
 * __useBannersQuery__
 *
 * To run a query within a React component, call `useBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      first: // value for 'first'
 *      manage: // value for 'manage'
 *   },
 * });
 */
export function useBannersQuery(
  baseOptions: Apollo.QueryHookOptions<BannersQuery, BannersQueryVariables> &
    ({ variables: BannersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BannersQuery, BannersQueryVariables>(
    BannersDocument,
    options
  )
}
export function useBannersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BannersQuery, BannersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<BannersQuery, BannersQueryVariables>(
    BannersDocument,
    options
  )
}
export function useBannersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BannersQuery, BannersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<BannersQuery, BannersQueryVariables>(
    BannersDocument,
    options
  )
}
export type BannersQueryHookResult = ReturnType<typeof useBannersQuery>
export type BannersLazyQueryHookResult = ReturnType<typeof useBannersLazyQuery>
export type BannersSuspenseQueryHookResult = ReturnType<
  typeof useBannersSuspenseQuery
>
export type BannersQueryResult = Apollo.QueryResult<
  BannersQuery,
  BannersQueryVariables
>
export const CreateBannerDocument = gql`
  mutation CreateBanner(
    $heading: String
    $subhead: String
    $font_color: String
    $background_image: String
    $background_type: Int
    $background_overlay: String
    $button_func: String
    $button_url: String
    $button_text: String
    $is_visible: Boolean
    $hide_for_subscription_plans: [Int]
    $show_for_subscription_plans: [Int]
    $hide_for_products: [Int]
    $show_for_products: [Int]
  ) {
    createBanner(
      heading: $heading
      subhead: $subhead
      font_color: $font_color
      background_image: $background_image
      background_type: $background_type
      background_overlay: $background_overlay
      button_func: $button_func
      button_url: $button_url
      button_text: $button_text
      is_visible: $is_visible
      hide_for_subscription_plans: $hide_for_subscription_plans
      show_for_subscription_plans: $show_for_subscription_plans
      hide_for_products: $hide_for_products
      show_for_products: $show_for_products
    ) {
      ...Banner
    }
  }
  ${BannerFragmentDoc}
`
export type CreateBannerMutationFn = Apollo.MutationFunction<
  CreateBannerMutation,
  CreateBannerMutationVariables
>

/**
 * __useCreateBannerMutation__
 *
 * To run a mutation, you first call `useCreateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBannerMutation, { data, loading, error }] = useCreateBannerMutation({
 *   variables: {
 *      heading: // value for 'heading'
 *      subhead: // value for 'subhead'
 *      font_color: // value for 'font_color'
 *      background_image: // value for 'background_image'
 *      background_type: // value for 'background_type'
 *      background_overlay: // value for 'background_overlay'
 *      button_func: // value for 'button_func'
 *      button_url: // value for 'button_url'
 *      button_text: // value for 'button_text'
 *      is_visible: // value for 'is_visible'
 *      hide_for_subscription_plans: // value for 'hide_for_subscription_plans'
 *      show_for_subscription_plans: // value for 'show_for_subscription_plans'
 *      hide_for_products: // value for 'hide_for_products'
 *      show_for_products: // value for 'show_for_products'
 *   },
 * });
 */
export function useCreateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBannerMutation,
    CreateBannerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateBannerMutation,
    CreateBannerMutationVariables
  >(CreateBannerDocument, options)
}
export type CreateBannerMutationHookResult = ReturnType<
  typeof useCreateBannerMutation
>
export type CreateBannerMutationResult =
  Apollo.MutationResult<CreateBannerMutation>
export type CreateBannerMutationOptions = Apollo.BaseMutationOptions<
  CreateBannerMutation,
  CreateBannerMutationVariables
>
export const DeleteBannerDocument = gql`
  mutation DeleteBanner($id: Int!) {
    deleteBanner(id: $id)
  }
`
export type DeleteBannerMutationFn = Apollo.MutationFunction<
  DeleteBannerMutation,
  DeleteBannerMutationVariables
>

/**
 * __useDeleteBannerMutation__
 *
 * To run a mutation, you first call `useDeleteBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBannerMutation, { data, loading, error }] = useDeleteBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBannerMutation,
    DeleteBannerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteBannerMutation,
    DeleteBannerMutationVariables
  >(DeleteBannerDocument, options)
}
export type DeleteBannerMutationHookResult = ReturnType<
  typeof useDeleteBannerMutation
>
export type DeleteBannerMutationResult =
  Apollo.MutationResult<DeleteBannerMutation>
export type DeleteBannerMutationOptions = Apollo.BaseMutationOptions<
  DeleteBannerMutation,
  DeleteBannerMutationVariables
>
export const UpdateBannerDocument = gql`
  mutation UpdateBanner(
    $id: Int!
    $heading: String
    $subhead: String
    $font_color: String
    $background_image: String
    $background_type: Int
    $background_overlay: String
    $button_func: String
    $button_url: String
    $button_text: String
    $is_visible: Boolean
    $hide_for_subscription_plans: [Int]
    $show_for_subscription_plans: [Int]
    $hide_for_products: [Int]
    $show_for_products: [Int]
  ) {
    updateBanner(
      id: $id
      heading: $heading
      subhead: $subhead
      font_color: $font_color
      background_image: $background_image
      background_type: $background_type
      background_overlay: $background_overlay
      button_func: $button_func
      button_url: $button_url
      button_text: $button_text
      is_visible: $is_visible
      hide_for_subscription_plans: $hide_for_subscription_plans
      show_for_subscription_plans: $show_for_subscription_plans
      hide_for_products: $hide_for_products
      show_for_products: $show_for_products
    ) {
      ...Banner
    }
  }
  ${BannerFragmentDoc}
`
export type UpdateBannerMutationFn = Apollo.MutationFunction<
  UpdateBannerMutation,
  UpdateBannerMutationVariables
>

/**
 * __useUpdateBannerMutation__
 *
 * To run a mutation, you first call `useUpdateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerMutation, { data, loading, error }] = useUpdateBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      heading: // value for 'heading'
 *      subhead: // value for 'subhead'
 *      font_color: // value for 'font_color'
 *      background_image: // value for 'background_image'
 *      background_type: // value for 'background_type'
 *      background_overlay: // value for 'background_overlay'
 *      button_func: // value for 'button_func'
 *      button_url: // value for 'button_url'
 *      button_text: // value for 'button_text'
 *      is_visible: // value for 'is_visible'
 *      hide_for_subscription_plans: // value for 'hide_for_subscription_plans'
 *      show_for_subscription_plans: // value for 'show_for_subscription_plans'
 *      hide_for_products: // value for 'hide_for_products'
 *      show_for_products: // value for 'show_for_products'
 *   },
 * });
 */
export function useUpdateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBannerMutation,
    UpdateBannerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateBannerMutation,
    UpdateBannerMutationVariables
  >(UpdateBannerDocument, options)
}
export type UpdateBannerMutationHookResult = ReturnType<
  typeof useUpdateBannerMutation
>
export type UpdateBannerMutationResult =
  Apollo.MutationResult<UpdateBannerMutation>
export type UpdateBannerMutationOptions = Apollo.BaseMutationOptions<
  UpdateBannerMutation,
  UpdateBannerMutationVariables
>
export const UpdateBannerOrderDocument = gql`
  mutation UpdateBannerOrder($banner_orders: [ListOrderInput]!) {
    updateBannerOrder(banner_orders: $banner_orders)
  }
`
export type UpdateBannerOrderMutationFn = Apollo.MutationFunction<
  UpdateBannerOrderMutation,
  UpdateBannerOrderMutationVariables
>

/**
 * __useUpdateBannerOrderMutation__
 *
 * To run a mutation, you first call `useUpdateBannerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerOrderMutation, { data, loading, error }] = useUpdateBannerOrderMutation({
 *   variables: {
 *      banner_orders: // value for 'banner_orders'
 *   },
 * });
 */
export function useUpdateBannerOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBannerOrderMutation,
    UpdateBannerOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateBannerOrderMutation,
    UpdateBannerOrderMutationVariables
  >(UpdateBannerOrderDocument, options)
}
export type UpdateBannerOrderMutationHookResult = ReturnType<
  typeof useUpdateBannerOrderMutation
>
export type UpdateBannerOrderMutationResult =
  Apollo.MutationResult<UpdateBannerOrderMutation>
export type UpdateBannerOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateBannerOrderMutation,
  UpdateBannerOrderMutationVariables
>
export const BackgroundTaskDocument = gql`
  query BackgroundTask($id: String!) {
    backgroundTask(id: $id) {
      ...BackgroundTask
    }
  }
  ${BackgroundTaskFragmentDoc}
`

/**
 * __useBackgroundTaskQuery__
 *
 * To run a query within a React component, call `useBackgroundTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackgroundTaskQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackgroundTaskQuery,
    BackgroundTaskQueryVariables
  > &
    (
      | { variables: BackgroundTaskQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BackgroundTaskQuery, BackgroundTaskQueryVariables>(
    BackgroundTaskDocument,
    options
  )
}
export function useBackgroundTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackgroundTaskQuery,
    BackgroundTaskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<BackgroundTaskQuery, BackgroundTaskQueryVariables>(
    BackgroundTaskDocument,
    options
  )
}
export function useBackgroundTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackgroundTaskQuery,
        BackgroundTaskQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackgroundTaskQuery,
    BackgroundTaskQueryVariables
  >(BackgroundTaskDocument, options)
}
export type BackgroundTaskQueryHookResult = ReturnType<
  typeof useBackgroundTaskQuery
>
export type BackgroundTaskLazyQueryHookResult = ReturnType<
  typeof useBackgroundTaskLazyQuery
>
export type BackgroundTaskSuspenseQueryHookResult = ReturnType<
  typeof useBackgroundTaskSuspenseQuery
>
export type BackgroundTaskQueryResult = Apollo.QueryResult<
  BackgroundTaskQuery,
  BackgroundTaskQueryVariables
>
export const BackgroundTasksDocument = gql`
  query BackgroundTasks($ids: [String]!) {
    backgroundTasks(ids: $ids) {
      ...BackgroundTask
    }
  }
  ${BackgroundTaskFragmentDoc}
`

/**
 * __useBackgroundTasksQuery__
 *
 * To run a query within a React component, call `useBackgroundTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundTasksQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBackgroundTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  > &
    (
      | { variables: BackgroundTasksQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BackgroundTasksQuery, BackgroundTasksQueryVariables>(
    BackgroundTasksDocument,
    options
  )
}
export function useBackgroundTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  >(BackgroundTasksDocument, options)
}
export function useBackgroundTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackgroundTasksQuery,
        BackgroundTasksQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  >(BackgroundTasksDocument, options)
}
export type BackgroundTasksQueryHookResult = ReturnType<
  typeof useBackgroundTasksQuery
>
export type BackgroundTasksLazyQueryHookResult = ReturnType<
  typeof useBackgroundTasksLazyQuery
>
export type BackgroundTasksSuspenseQueryHookResult = ReturnType<
  typeof useBackgroundTasksSuspenseQuery
>
export type BackgroundTasksQueryResult = Apollo.QueryResult<
  BackgroundTasksQuery,
  BackgroundTasksQueryVariables
>
export const ChildSubscriptionsDocument = gql`
  query ChildSubscriptions {
    school {
      ...School
      billing_subscription {
        ...SchoolBillingSubscription
        child_subscriptions(first: 10) {
          edges {
            node {
              ...SchoolBillingSubscription
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolBillingSubscriptionFragmentDoc}
`

/**
 * __useChildSubscriptionsQuery__
 *
 * To run a query within a React component, call `useChildSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChildSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChildSubscriptionsQuery,
    ChildSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ChildSubscriptionsQuery,
    ChildSubscriptionsQueryVariables
  >(ChildSubscriptionsDocument, options)
}
export function useChildSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChildSubscriptionsQuery,
    ChildSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ChildSubscriptionsQuery,
    ChildSubscriptionsQueryVariables
  >(ChildSubscriptionsDocument, options)
}
export function useChildSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChildSubscriptionsQuery,
        ChildSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ChildSubscriptionsQuery,
    ChildSubscriptionsQueryVariables
  >(ChildSubscriptionsDocument, options)
}
export type ChildSubscriptionsQueryHookResult = ReturnType<
  typeof useChildSubscriptionsQuery
>
export type ChildSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useChildSubscriptionsLazyQuery
>
export type ChildSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useChildSubscriptionsSuspenseQuery
>
export type ChildSubscriptionsQueryResult = Apollo.QueryResult<
  ChildSubscriptionsQuery,
  ChildSubscriptionsQueryVariables
>
export const SchoolBillingInvoiceDocument = gql`
  query SchoolBillingInvoice($id: Int!) {
    school {
      ...School
      school_billing_invoice(id: $id) {
        ...SchoolBillingInvoice
        payment
      }
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolBillingInvoiceFragmentDoc}
`

/**
 * __useSchoolBillingInvoiceQuery__
 *
 * To run a query within a React component, call `useSchoolBillingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolBillingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolBillingInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolBillingInvoiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchoolBillingInvoiceQuery,
    SchoolBillingInvoiceQueryVariables
  > &
    (
      | { variables: SchoolBillingInvoiceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolBillingInvoiceQuery,
    SchoolBillingInvoiceQueryVariables
  >(SchoolBillingInvoiceDocument, options)
}
export function useSchoolBillingInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolBillingInvoiceQuery,
    SchoolBillingInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolBillingInvoiceQuery,
    SchoolBillingInvoiceQueryVariables
  >(SchoolBillingInvoiceDocument, options)
}
export function useSchoolBillingInvoiceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolBillingInvoiceQuery,
        SchoolBillingInvoiceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolBillingInvoiceQuery,
    SchoolBillingInvoiceQueryVariables
  >(SchoolBillingInvoiceDocument, options)
}
export type SchoolBillingInvoiceQueryHookResult = ReturnType<
  typeof useSchoolBillingInvoiceQuery
>
export type SchoolBillingInvoiceLazyQueryHookResult = ReturnType<
  typeof useSchoolBillingInvoiceLazyQuery
>
export type SchoolBillingInvoiceSuspenseQueryHookResult = ReturnType<
  typeof useSchoolBillingInvoiceSuspenseQuery
>
export type SchoolBillingInvoiceQueryResult = Apollo.QueryResult<
  SchoolBillingInvoiceQuery,
  SchoolBillingInvoiceQueryVariables
>
export const SchoolBillingInvoicesDocument = gql`
  query SchoolBillingInvoices($cursor: String) {
    school {
      ...School
      school_billing_invoices(first: 50, after: $cursor) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...SchoolBillingInvoice
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolBillingInvoiceFragmentDoc}
`

/**
 * __useSchoolBillingInvoicesQuery__
 *
 * To run a query within a React component, call `useSchoolBillingInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolBillingInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolBillingInvoicesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSchoolBillingInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolBillingInvoicesQuery,
    SchoolBillingInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolBillingInvoicesQuery,
    SchoolBillingInvoicesQueryVariables
  >(SchoolBillingInvoicesDocument, options)
}
export function useSchoolBillingInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolBillingInvoicesQuery,
    SchoolBillingInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolBillingInvoicesQuery,
    SchoolBillingInvoicesQueryVariables
  >(SchoolBillingInvoicesDocument, options)
}
export function useSchoolBillingInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolBillingInvoicesQuery,
        SchoolBillingInvoicesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolBillingInvoicesQuery,
    SchoolBillingInvoicesQueryVariables
  >(SchoolBillingInvoicesDocument, options)
}
export type SchoolBillingInvoicesQueryHookResult = ReturnType<
  typeof useSchoolBillingInvoicesQuery
>
export type SchoolBillingInvoicesLazyQueryHookResult = ReturnType<
  typeof useSchoolBillingInvoicesLazyQuery
>
export type SchoolBillingInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useSchoolBillingInvoicesSuspenseQuery
>
export type SchoolBillingInvoicesQueryResult = Apollo.QueryResult<
  SchoolBillingInvoicesQuery,
  SchoolBillingInvoicesQueryVariables
>
export const SchoolBillingSubscriptionDocument = gql`
  query SchoolBillingSubscription {
    school {
      ...School
      billing_subscription {
        ...SchoolBillingSubscription
      }
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolBillingSubscriptionFragmentDoc}
`

/**
 * __useSchoolBillingSubscriptionQuery__
 *
 * To run a query within a React component, call `useSchoolBillingSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolBillingSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolBillingSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolBillingSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolBillingSubscriptionQuery,
    SchoolBillingSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolBillingSubscriptionQuery,
    SchoolBillingSubscriptionQueryVariables
  >(SchoolBillingSubscriptionDocument, options)
}
export function useSchoolBillingSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolBillingSubscriptionQuery,
    SchoolBillingSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolBillingSubscriptionQuery,
    SchoolBillingSubscriptionQueryVariables
  >(SchoolBillingSubscriptionDocument, options)
}
export function useSchoolBillingSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolBillingSubscriptionQuery,
        SchoolBillingSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolBillingSubscriptionQuery,
    SchoolBillingSubscriptionQueryVariables
  >(SchoolBillingSubscriptionDocument, options)
}
export type SchoolBillingSubscriptionQueryHookResult = ReturnType<
  typeof useSchoolBillingSubscriptionQuery
>
export type SchoolBillingSubscriptionLazyQueryHookResult = ReturnType<
  typeof useSchoolBillingSubscriptionLazyQuery
>
export type SchoolBillingSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSchoolBillingSubscriptionSuspenseQuery
>
export type SchoolBillingSubscriptionQueryResult = Apollo.QueryResult<
  SchoolBillingSubscriptionQuery,
  SchoolBillingSubscriptionQueryVariables
>
export const UpcomingSchoolBillingInvoiceDocument = gql`
  query UpcomingSchoolBillingInvoice {
    school {
      ...School
      upcoming_school_billing_invoice {
        ...SchoolBillingInvoice
        parent_subscription
        child_subscriptions
      }
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolBillingInvoiceFragmentDoc}
`

/**
 * __useUpcomingSchoolBillingInvoiceQuery__
 *
 * To run a query within a React component, call `useUpcomingSchoolBillingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingSchoolBillingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingSchoolBillingInvoiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpcomingSchoolBillingInvoiceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UpcomingSchoolBillingInvoiceQuery,
    UpcomingSchoolBillingInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UpcomingSchoolBillingInvoiceQuery,
    UpcomingSchoolBillingInvoiceQueryVariables
  >(UpcomingSchoolBillingInvoiceDocument, options)
}
export function useUpcomingSchoolBillingInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpcomingSchoolBillingInvoiceQuery,
    UpcomingSchoolBillingInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UpcomingSchoolBillingInvoiceQuery,
    UpcomingSchoolBillingInvoiceQueryVariables
  >(UpcomingSchoolBillingInvoiceDocument, options)
}
export function useUpcomingSchoolBillingInvoiceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UpcomingSchoolBillingInvoiceQuery,
        UpcomingSchoolBillingInvoiceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UpcomingSchoolBillingInvoiceQuery,
    UpcomingSchoolBillingInvoiceQueryVariables
  >(UpcomingSchoolBillingInvoiceDocument, options)
}
export type UpcomingSchoolBillingInvoiceQueryHookResult = ReturnType<
  typeof useUpcomingSchoolBillingInvoiceQuery
>
export type UpcomingSchoolBillingInvoiceLazyQueryHookResult = ReturnType<
  typeof useUpcomingSchoolBillingInvoiceLazyQuery
>
export type UpcomingSchoolBillingInvoiceSuspenseQueryHookResult = ReturnType<
  typeof useUpcomingSchoolBillingInvoiceSuspenseQuery
>
export type UpcomingSchoolBillingInvoiceQueryResult = Apollo.QueryResult<
  UpcomingSchoolBillingInvoiceQuery,
  UpcomingSchoolBillingInvoiceQueryVariables
>
export const BlocksContainerContextDocument = gql`
  query BlocksContainerContext($cohortId: Int!, $isLearner: Boolean!) {
    group(id: $cohortId) {
      id
      name
      status
      is_master
      is_source_cohort
      resource {
        id
        name
        slug
      }
      user_registration {
        id
        role
        softArchivedTime @include(if: $isLearner)
      }
    }
  }
`

/**
 * __useBlocksContainerContextQuery__
 *
 * To run a query within a React component, call `useBlocksContainerContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksContainerContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksContainerContextQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      isLearner: // value for 'isLearner'
 *   },
 * });
 */
export function useBlocksContainerContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    BlocksContainerContextQuery,
    BlocksContainerContextQueryVariables
  > &
    (
      | { variables: BlocksContainerContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BlocksContainerContextQuery,
    BlocksContainerContextQueryVariables
  >(BlocksContainerContextDocument, options)
}
export function useBlocksContainerContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BlocksContainerContextQuery,
    BlocksContainerContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BlocksContainerContextQuery,
    BlocksContainerContextQueryVariables
  >(BlocksContainerContextDocument, options)
}
export function useBlocksContainerContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BlocksContainerContextQuery,
        BlocksContainerContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BlocksContainerContextQuery,
    BlocksContainerContextQueryVariables
  >(BlocksContainerContextDocument, options)
}
export type BlocksContainerContextQueryHookResult = ReturnType<
  typeof useBlocksContainerContextQuery
>
export type BlocksContainerContextLazyQueryHookResult = ReturnType<
  typeof useBlocksContainerContextLazyQuery
>
export type BlocksContainerContextSuspenseQueryHookResult = ReturnType<
  typeof useBlocksContainerContextSuspenseQuery
>
export type BlocksContainerContextQueryResult = Apollo.QueryResult<
  BlocksContainerContextQuery,
  BlocksContainerContextQueryVariables
>
export const BlocksResponseExportCohortsDocument = gql`
  query BlocksResponseExportCohorts(
    $resourceId: Int!
    $after: String
    $search: String
    $role: RoleFilter
  ) {
    cohorts: groups(
      first: 50
      after: $after
      search: $search
      resource_id: $resourceId
      role: $role
      sort: active_then_completed
    ) {
      edges {
        node {
          id
          name
          created
          access_ends
          access_starts
          seats_filled
          status
          path(type: source) {
            id
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`

/**
 * __useBlocksResponseExportCohortsQuery__
 *
 * To run a query within a React component, call `useBlocksResponseExportCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksResponseExportCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksResponseExportCohortsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useBlocksResponseExportCohortsQuery(
  baseOptions: Apollo.QueryHookOptions<
    BlocksResponseExportCohortsQuery,
    BlocksResponseExportCohortsQueryVariables
  > &
    (
      | { variables: BlocksResponseExportCohortsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BlocksResponseExportCohortsQuery,
    BlocksResponseExportCohortsQueryVariables
  >(BlocksResponseExportCohortsDocument, options)
}
export function useBlocksResponseExportCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BlocksResponseExportCohortsQuery,
    BlocksResponseExportCohortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BlocksResponseExportCohortsQuery,
    BlocksResponseExportCohortsQueryVariables
  >(BlocksResponseExportCohortsDocument, options)
}
export function useBlocksResponseExportCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BlocksResponseExportCohortsQuery,
        BlocksResponseExportCohortsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BlocksResponseExportCohortsQuery,
    BlocksResponseExportCohortsQueryVariables
  >(BlocksResponseExportCohortsDocument, options)
}
export type BlocksResponseExportCohortsQueryHookResult = ReturnType<
  typeof useBlocksResponseExportCohortsQuery
>
export type BlocksResponseExportCohortsLazyQueryHookResult = ReturnType<
  typeof useBlocksResponseExportCohortsLazyQuery
>
export type BlocksResponseExportCohortsSuspenseQueryHookResult = ReturnType<
  typeof useBlocksResponseExportCohortsSuspenseQuery
>
export type BlocksResponseExportCohortsQueryResult = Apollo.QueryResult<
  BlocksResponseExportCohortsQuery,
  BlocksResponseExportCohortsQueryVariables
>
export const BlocksResponseExportLearnersDocument = gql`
  query BlocksResponseExportLearners(
    $cohortId: Int!
    $searchTerm: String
    $after: String
  ) {
    group(id: $cohortId) {
      id
      registrations(
        first: 50
        after: $after
        search: $searchTerm
        role_filter: { in: [teacher, moderator, student] }
        orderBy: [{ role: DESC }, { last_activity_time: DESC }]
      ) {
        edges {
          node {
            id
            role
            user {
              id
              first_name
              last_name
              full_name
              email
              profile {
                id
                image
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`

/**
 * __useBlocksResponseExportLearnersQuery__
 *
 * To run a query within a React component, call `useBlocksResponseExportLearnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksResponseExportLearnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksResponseExportLearnersQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      searchTerm: // value for 'searchTerm'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBlocksResponseExportLearnersQuery(
  baseOptions: Apollo.QueryHookOptions<
    BlocksResponseExportLearnersQuery,
    BlocksResponseExportLearnersQueryVariables
  > &
    (
      | {
          variables: BlocksResponseExportLearnersQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BlocksResponseExportLearnersQuery,
    BlocksResponseExportLearnersQueryVariables
  >(BlocksResponseExportLearnersDocument, options)
}
export function useBlocksResponseExportLearnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BlocksResponseExportLearnersQuery,
    BlocksResponseExportLearnersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BlocksResponseExportLearnersQuery,
    BlocksResponseExportLearnersQueryVariables
  >(BlocksResponseExportLearnersDocument, options)
}
export function useBlocksResponseExportLearnersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BlocksResponseExportLearnersQuery,
        BlocksResponseExportLearnersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BlocksResponseExportLearnersQuery,
    BlocksResponseExportLearnersQueryVariables
  >(BlocksResponseExportLearnersDocument, options)
}
export type BlocksResponseExportLearnersQueryHookResult = ReturnType<
  typeof useBlocksResponseExportLearnersQuery
>
export type BlocksResponseExportLearnersLazyQueryHookResult = ReturnType<
  typeof useBlocksResponseExportLearnersLazyQuery
>
export type BlocksResponseExportLearnersSuspenseQueryHookResult = ReturnType<
  typeof useBlocksResponseExportLearnersSuspenseQuery
>
export type BlocksResponseExportLearnersQueryResult = Apollo.QueryResult<
  BlocksResponseExportLearnersQuery,
  BlocksResponseExportLearnersQueryVariables
>
export const BlocksResponseExportPeopleSearchDocument = gql`
  query BlocksResponseExportPeopleSearch(
    $resourceId: Int!
    $searchTerm: String!
    $after: String
  ) {
    resource(id: $resourceId) {
      id
      registrations(
        first: 50
        after: $after
        search: $searchTerm
        role_filter: { in: [teacher, moderator, student] }
        orderBy: [{ role: DESC }, { last_activity_time: DESC }]
      ) {
        edges {
          node {
            id
            role
            user {
              id
              first_name
              last_name
              full_name
              email
              profile {
                id
                image
              }
            }
            group {
              id
              name
              created
              access_ends
              access_starts
              seats_filled
              status
              is_source_cohort
              path(type: source) {
                id
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`

/**
 * __useBlocksResponseExportPeopleSearchQuery__
 *
 * To run a query within a React component, call `useBlocksResponseExportPeopleSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksResponseExportPeopleSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksResponseExportPeopleSearchQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      searchTerm: // value for 'searchTerm'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBlocksResponseExportPeopleSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    BlocksResponseExportPeopleSearchQuery,
    BlocksResponseExportPeopleSearchQueryVariables
  > &
    (
      | {
          variables: BlocksResponseExportPeopleSearchQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BlocksResponseExportPeopleSearchQuery,
    BlocksResponseExportPeopleSearchQueryVariables
  >(BlocksResponseExportPeopleSearchDocument, options)
}
export function useBlocksResponseExportPeopleSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BlocksResponseExportPeopleSearchQuery,
    BlocksResponseExportPeopleSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BlocksResponseExportPeopleSearchQuery,
    BlocksResponseExportPeopleSearchQueryVariables
  >(BlocksResponseExportPeopleSearchDocument, options)
}
export function useBlocksResponseExportPeopleSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BlocksResponseExportPeopleSearchQuery,
        BlocksResponseExportPeopleSearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BlocksResponseExportPeopleSearchQuery,
    BlocksResponseExportPeopleSearchQueryVariables
  >(BlocksResponseExportPeopleSearchDocument, options)
}
export type BlocksResponseExportPeopleSearchQueryHookResult = ReturnType<
  typeof useBlocksResponseExportPeopleSearchQuery
>
export type BlocksResponseExportPeopleSearchLazyQueryHookResult = ReturnType<
  typeof useBlocksResponseExportPeopleSearchLazyQuery
>
export type BlocksResponseExportPeopleSearchSuspenseQueryHookResult =
  ReturnType<typeof useBlocksResponseExportPeopleSearchSuspenseQuery>
export type BlocksResponseExportPeopleSearchQueryResult = Apollo.QueryResult<
  BlocksResponseExportPeopleSearchQuery,
  BlocksResponseExportPeopleSearchQueryVariables
>
export const CreateBlocksContentDocument = gql`
  mutation CreateBlocksContent($stepId: Int, $contentLastModified: DateTime) {
    createBlocksContent(
      step_id: $stepId
      content_last_modified: $contentLastModified
    ) {
      id
      method
      type
      data
      content_last_modified
      last_published
    }
  }
`
export type CreateBlocksContentMutationFn = Apollo.MutationFunction<
  CreateBlocksContentMutation,
  CreateBlocksContentMutationVariables
>

/**
 * __useCreateBlocksContentMutation__
 *
 * To run a mutation, you first call `useCreateBlocksContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlocksContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlocksContentMutation, { data, loading, error }] = useCreateBlocksContentMutation({
 *   variables: {
 *      stepId: // value for 'stepId'
 *      contentLastModified: // value for 'contentLastModified'
 *   },
 * });
 */
export function useCreateBlocksContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBlocksContentMutation,
    CreateBlocksContentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateBlocksContentMutation,
    CreateBlocksContentMutationVariables
  >(CreateBlocksContentDocument, options)
}
export type CreateBlocksContentMutationHookResult = ReturnType<
  typeof useCreateBlocksContentMutation
>
export type CreateBlocksContentMutationResult =
  Apollo.MutationResult<CreateBlocksContentMutation>
export type CreateBlocksContentMutationOptions = Apollo.BaseMutationOptions<
  CreateBlocksContentMutation,
  CreateBlocksContentMutationVariables
>
export const UpdateBlocksContentDocument = gql`
  mutation UpdateBlocksContent(
    $stepId: Int
    $id: Int
    $contentLastModified: DateTime
    $lastPublished: DateTime
  ) {
    updateBlocksContent(
      step_id: $stepId
      id: $id
      content_last_modified: $contentLastModified
      last_published: $lastPublished
    ) {
      id
      method
      type
      data
      content_last_modified
      last_published
    }
  }
`
export type UpdateBlocksContentMutationFn = Apollo.MutationFunction<
  UpdateBlocksContentMutation,
  UpdateBlocksContentMutationVariables
>

/**
 * __useUpdateBlocksContentMutation__
 *
 * To run a mutation, you first call `useUpdateBlocksContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlocksContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlocksContentMutation, { data, loading, error }] = useUpdateBlocksContentMutation({
 *   variables: {
 *      stepId: // value for 'stepId'
 *      id: // value for 'id'
 *      contentLastModified: // value for 'contentLastModified'
 *      lastPublished: // value for 'lastPublished'
 *   },
 * });
 */
export function useUpdateBlocksContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBlocksContentMutation,
    UpdateBlocksContentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateBlocksContentMutation,
    UpdateBlocksContentMutationVariables
  >(UpdateBlocksContentDocument, options)
}
export type UpdateBlocksContentMutationHookResult = ReturnType<
  typeof useUpdateBlocksContentMutation
>
export type UpdateBlocksContentMutationResult =
  Apollo.MutationResult<UpdateBlocksContentMutation>
export type UpdateBlocksContentMutationOptions = Apollo.BaseMutationOptions<
  UpdateBlocksContentMutation,
  UpdateBlocksContentMutationVariables
>
export const CalDocument = gql`
  query Cal {
    calendar {
      id
      name
      url
      events {
        id
        type
        description
        completion_status
        url
        relative_url
        summary
        start
        end
      }
    }
  }
`

/**
 * __useCalQuery__
 *
 * To run a query within a React component, call `useCalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalQuery(
  baseOptions?: Apollo.QueryHookOptions<CalQuery, CalQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CalQuery, CalQueryVariables>(CalDocument, options)
}
export function useCalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CalQuery, CalQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CalQuery, CalQueryVariables>(CalDocument, options)
}
export function useCalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CalQuery, CalQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CalQuery, CalQueryVariables>(
    CalDocument,
    options
  )
}
export type CalQueryHookResult = ReturnType<typeof useCalQuery>
export type CalLazyQueryHookResult = ReturnType<typeof useCalLazyQuery>
export type CalSuspenseQueryHookResult = ReturnType<typeof useCalSuspenseQuery>
export type CalQueryResult = Apollo.QueryResult<CalQuery, CalQueryVariables>
export const CalStatsDocument = gql`
  query CalStats($path_id: ID) {
    calendarStats(path_id: $path_id) {
      total
      upcoming
      due
      late
    }
  }
`

/**
 * __useCalStatsQuery__
 *
 * To run a query within a React component, call `useCalStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalStatsQuery({
 *   variables: {
 *      path_id: // value for 'path_id'
 *   },
 * });
 */
export function useCalStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<CalStatsQuery, CalStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CalStatsQuery, CalStatsQueryVariables>(
    CalStatsDocument,
    options
  )
}
export function useCalStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalStatsQuery,
    CalStatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CalStatsQuery, CalStatsQueryVariables>(
    CalStatsDocument,
    options
  )
}
export function useCalStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CalStatsQuery, CalStatsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CalStatsQuery, CalStatsQueryVariables>(
    CalStatsDocument,
    options
  )
}
export type CalStatsQueryHookResult = ReturnType<typeof useCalStatsQuery>
export type CalStatsLazyQueryHookResult = ReturnType<
  typeof useCalStatsLazyQuery
>
export type CalStatsSuspenseQueryHookResult = ReturnType<
  typeof useCalStatsSuspenseQuery
>
export type CalStatsQueryResult = Apollo.QueryResult<
  CalStatsQuery,
  CalStatsQueryVariables
>
export const CategoriesDocument = gql`
  query Categories(
    $first: Int!
    $cursor: String
    $school_id: Int!
    $search: String
    $ids: IDFilter
    $manage: Boolean
    $positioningContext: PositioningContextInput
    $orderBy: [CategoryOrderByInput]
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        categories(
          first: $first
          after: $cursor
          search: $search
          ids: $ids
          manage: $manage
          positioningContext: $positioningContext
          orderBy: $orderBy
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...PositionedCategory
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PositionedCategoryFragmentDoc}
`

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *      manage: // value for 'manage'
 *      positioningContext: // value for 'positioningContext'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoriesQuery,
    CategoriesQueryVariables
  > &
    (
      | { variables: CategoriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  )
}
export function useCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoriesQuery,
    CategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  )
}
export function useCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  )
}
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>
export type CategoriesLazyQueryHookResult = ReturnType<
  typeof useCategoriesLazyQuery
>
export type CategoriesSuspenseQueryHookResult = ReturnType<
  typeof useCategoriesSuspenseQuery
>
export type CategoriesQueryResult = Apollo.QueryResult<
  CategoriesQuery,
  CategoriesQueryVariables
>
export const CategoryDocument = gql`
  query Category($id: Int, $slug: String) {
    school {
      ...School
      category(id: $id, slug: $slug) {
        ...Category
      }
    }
  }
  ${SchoolFragmentDoc}
  ${CategoryFragmentDoc}
`

/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCategoryQuery(
  baseOptions?: Apollo.QueryHookOptions<CategoryQuery, CategoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options
  )
}
export function useCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryQuery,
    CategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options
  )
}
export function useCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CategoryQuery, CategoryQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options
  )
}
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>
export type CategoryLazyQueryHookResult = ReturnType<
  typeof useCategoryLazyQuery
>
export type CategorySuspenseQueryHookResult = ReturnType<
  typeof useCategorySuspenseQuery
>
export type CategoryQueryResult = Apollo.QueryResult<
  CategoryQuery,
  CategoryQueryVariables
>
export const CreateCoverPageCategoryDocument = gql`
  mutation CreateCoverPageCategory(
    $categoryPositioningContext: PositioningContextInput
    $description: String!
    $name: String!
    $order: Int!
  ) {
    createCategory(description: $description, name: $name, order: $order) {
      ...CoverPageCategory
    }
  }
  ${CoverPageCategoryFragmentDoc}
`
export type CreateCoverPageCategoryMutationFn = Apollo.MutationFunction<
  CreateCoverPageCategoryMutation,
  CreateCoverPageCategoryMutationVariables
>

/**
 * __useCreateCoverPageCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCoverPageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoverPageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoverPageCategoryMutation, { data, loading, error }] = useCreateCoverPageCategoryMutation({
 *   variables: {
 *      categoryPositioningContext: // value for 'categoryPositioningContext'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCreateCoverPageCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoverPageCategoryMutation,
    CreateCoverPageCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCoverPageCategoryMutation,
    CreateCoverPageCategoryMutationVariables
  >(CreateCoverPageCategoryDocument, options)
}
export type CreateCoverPageCategoryMutationHookResult = ReturnType<
  typeof useCreateCoverPageCategoryMutation
>
export type CreateCoverPageCategoryMutationResult =
  Apollo.MutationResult<CreateCoverPageCategoryMutation>
export type CreateCoverPageCategoryMutationOptions = Apollo.BaseMutationOptions<
  CreateCoverPageCategoryMutation,
  CreateCoverPageCategoryMutationVariables
>
export const UpdateCoverPageCategoryDocument = gql`
  mutation UpdateCoverPageCategory(
    $categoryPositioningContext: PositioningContextInput
    $description: String
    $id: Int!
    $name: String
  ) {
    updateCategory(description: $description, id: $id, name: $name) {
      ...CoverPageCategory
    }
  }
  ${CoverPageCategoryFragmentDoc}
`
export type UpdateCoverPageCategoryMutationFn = Apollo.MutationFunction<
  UpdateCoverPageCategoryMutation,
  UpdateCoverPageCategoryMutationVariables
>

/**
 * __useUpdateCoverPageCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPageCategoryMutation, { data, loading, error }] = useUpdateCoverPageCategoryMutation({
 *   variables: {
 *      categoryPositioningContext: // value for 'categoryPositioningContext'
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCoverPageCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoverPageCategoryMutation,
    UpdateCoverPageCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCoverPageCategoryMutation,
    UpdateCoverPageCategoryMutationVariables
  >(UpdateCoverPageCategoryDocument, options)
}
export type UpdateCoverPageCategoryMutationHookResult = ReturnType<
  typeof useUpdateCoverPageCategoryMutation
>
export type UpdateCoverPageCategoryMutationResult =
  Apollo.MutationResult<UpdateCoverPageCategoryMutation>
export type UpdateCoverPageCategoryMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoverPageCategoryMutation,
  UpdateCoverPageCategoryMutationVariables
>
export const CertificatePreviewDocument = gql`
  query CertificatePreview(
    $template: String!
    $textObjects: [TextObject]!
    $variables: JSON
  ) {
    certificatePreview(
      template: $template
      text_objects: $textObjects
      variables: $variables
    )
  }
`

/**
 * __useCertificatePreviewQuery__
 *
 * To run a query within a React component, call `useCertificatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificatePreviewQuery({
 *   variables: {
 *      template: // value for 'template'
 *      textObjects: // value for 'textObjects'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useCertificatePreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  > &
    (
      | { variables: CertificatePreviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >(CertificatePreviewDocument, options)
}
export function useCertificatePreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >(CertificatePreviewDocument, options)
}
export function useCertificatePreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificatePreviewQuery,
        CertificatePreviewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >(CertificatePreviewDocument, options)
}
export type CertificatePreviewQueryHookResult = ReturnType<
  typeof useCertificatePreviewQuery
>
export type CertificatePreviewLazyQueryHookResult = ReturnType<
  typeof useCertificatePreviewLazyQuery
>
export type CertificatePreviewSuspenseQueryHookResult = ReturnType<
  typeof useCertificatePreviewSuspenseQuery
>
export type CertificatePreviewQueryResult = Apollo.QueryResult<
  CertificatePreviewQuery,
  CertificatePreviewQueryVariables
>
export const CertificateDocument = gql`
  query Certificate {
    certificate {
      ...Certificate
    }
  }
  ${CertificateFragmentDoc}
`

/**
 * __useCertificateQuery__
 *
 * To run a query within a React component, call `useCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCertificateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CertificateQuery,
    CertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CertificateQuery, CertificateQueryVariables>(
    CertificateDocument,
    options
  )
}
export function useCertificateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateQuery,
    CertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CertificateQuery, CertificateQueryVariables>(
    CertificateDocument,
    options
  )
}
export function useCertificateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateQuery,
        CertificateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CertificateQuery, CertificateQueryVariables>(
    CertificateDocument,
    options
  )
}
export type CertificateQueryHookResult = ReturnType<typeof useCertificateQuery>
export type CertificateLazyQueryHookResult = ReturnType<
  typeof useCertificateLazyQuery
>
export type CertificateSuspenseQueryHookResult = ReturnType<
  typeof useCertificateSuspenseQuery
>
export type CertificateQueryResult = Apollo.QueryResult<
  CertificateQuery,
  CertificateQueryVariables
>
export const CertificateResourcesDocument = gql`
  query CertificateResources(
    $first: Int!
    $hasCertificate: Boolean
    $search: String
  ) {
    resources(
      first: $first
      has_certificate: $hasCertificate
      search: $search
    ) {
      total
      edges {
        node {
          ...ManageResource
        }
      }
    }
  }
  ${ManageResourceFragmentDoc}
`

/**
 * __useCertificateResourcesQuery__
 *
 * To run a query within a React component, call `useCertificateResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateResourcesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      hasCertificate: // value for 'hasCertificate'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCertificateResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  > &
    (
      | { variables: CertificateResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >(CertificateResourcesDocument, options)
}
export function useCertificateResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >(CertificateResourcesDocument, options)
}
export function useCertificateResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateResourcesQuery,
        CertificateResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >(CertificateResourcesDocument, options)
}
export type CertificateResourcesQueryHookResult = ReturnType<
  typeof useCertificateResourcesQuery
>
export type CertificateResourcesLazyQueryHookResult = ReturnType<
  typeof useCertificateResourcesLazyQuery
>
export type CertificateResourcesSuspenseQueryHookResult = ReturnType<
  typeof useCertificateResourcesSuspenseQuery
>
export type CertificateResourcesQueryResult = Apollo.QueryResult<
  CertificateResourcesQuery,
  CertificateResourcesQueryVariables
>
export const CertificateVariablesDocument = gql`
  query CertificateVariables($context: CertificateVariablesContextInput) {
    certificateVariables(context: $context) {
      id
      stats
      variables
    }
  }
`

/**
 * __useCertificateVariablesQuery__
 *
 * To run a query within a React component, call `useCertificateVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateVariablesQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCertificateVariablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >(CertificateVariablesDocument, options)
}
export function useCertificateVariablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >(CertificateVariablesDocument, options)
}
export function useCertificateVariablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateVariablesQuery,
        CertificateVariablesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >(CertificateVariablesDocument, options)
}
export type CertificateVariablesQueryHookResult = ReturnType<
  typeof useCertificateVariablesQuery
>
export type CertificateVariablesLazyQueryHookResult = ReturnType<
  typeof useCertificateVariablesLazyQuery
>
export type CertificateVariablesSuspenseQueryHookResult = ReturnType<
  typeof useCertificateVariablesSuspenseQuery
>
export type CertificateVariablesQueryResult = Apollo.QueryResult<
  CertificateVariablesQuery,
  CertificateVariablesQueryVariables
>
export const CreateCertificateDocument = gql`
  mutation CreateCertificate(
    $name: String
    $template: String!
    $textObjects: [TextObject]
    $isActive: Boolean = true
  ) {
    createCertificate(
      name: $name
      template: $template
      text_objects: $textObjects
      is_active: $isActive
    ) {
      ...Certificate
    }
  }
  ${CertificateFragmentDoc}
`
export type CreateCertificateMutationFn = Apollo.MutationFunction<
  CreateCertificateMutation,
  CreateCertificateMutationVariables
>

/**
 * __useCreateCertificateMutation__
 *
 * To run a mutation, you first call `useCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificateMutation, { data, loading, error }] = useCreateCertificateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      template: // value for 'template'
 *      textObjects: // value for 'textObjects'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCreateCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCertificateMutation,
    CreateCertificateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCertificateMutation,
    CreateCertificateMutationVariables
  >(CreateCertificateDocument, options)
}
export type CreateCertificateMutationHookResult = ReturnType<
  typeof useCreateCertificateMutation
>
export type CreateCertificateMutationResult =
  Apollo.MutationResult<CreateCertificateMutation>
export type CreateCertificateMutationOptions = Apollo.BaseMutationOptions<
  CreateCertificateMutation,
  CreateCertificateMutationVariables
>
export const DeleteCertificateDocument = gql`
  mutation DeleteCertificate($id: Int!) {
    deleteCertificate(id: $id)
  }
`
export type DeleteCertificateMutationFn = Apollo.MutationFunction<
  DeleteCertificateMutation,
  DeleteCertificateMutationVariables
>

/**
 * __useDeleteCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificateMutation, { data, loading, error }] = useDeleteCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCertificateMutation,
    DeleteCertificateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCertificateMutation,
    DeleteCertificateMutationVariables
  >(DeleteCertificateDocument, options)
}
export type DeleteCertificateMutationHookResult = ReturnType<
  typeof useDeleteCertificateMutation
>
export type DeleteCertificateMutationResult =
  Apollo.MutationResult<DeleteCertificateMutation>
export type DeleteCertificateMutationOptions = Apollo.BaseMutationOptions<
  DeleteCertificateMutation,
  DeleteCertificateMutationVariables
>
export const ResourceCertificateContextDocument = gql`
  query ResourceCertificateContext($id: Int!) {
    resource(id: $id) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`

/**
 * __useResourceCertificateContextQuery__
 *
 * To run a query within a React component, call `useResourceCertificateContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCertificateContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCertificateContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceCertificateContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  > &
    (
      | { variables: ResourceCertificateContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >(ResourceCertificateContextDocument, options)
}
export function useResourceCertificateContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >(ResourceCertificateContextDocument, options)
}
export function useResourceCertificateContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCertificateContextQuery,
        ResourceCertificateContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >(ResourceCertificateContextDocument, options)
}
export type ResourceCertificateContextQueryHookResult = ReturnType<
  typeof useResourceCertificateContextQuery
>
export type ResourceCertificateContextLazyQueryHookResult = ReturnType<
  typeof useResourceCertificateContextLazyQuery
>
export type ResourceCertificateContextSuspenseQueryHookResult = ReturnType<
  typeof useResourceCertificateContextSuspenseQuery
>
export type ResourceCertificateContextQueryResult = Apollo.QueryResult<
  ResourceCertificateContextQuery,
  ResourceCertificateContextQueryVariables
>
export const UpdateCertificateDocument = gql`
  mutation UpdateCertificate(
    $id: Int!
    $name: String
    $template: String
    $textObjects: [TextObject]
  ) {
    updateCertificate(
      id: $id
      name: $name
      template: $template
      text_objects: $textObjects
    ) {
      ...Certificate
    }
  }
  ${CertificateFragmentDoc}
`
export type UpdateCertificateMutationFn = Apollo.MutationFunction<
  UpdateCertificateMutation,
  UpdateCertificateMutationVariables
>

/**
 * __useUpdateCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificateMutation, { data, loading, error }] = useUpdateCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      template: // value for 'template'
 *      textObjects: // value for 'textObjects'
 *   },
 * });
 */
export function useUpdateCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCertificateMutation,
    UpdateCertificateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCertificateMutation,
    UpdateCertificateMutationVariables
  >(UpdateCertificateDocument, options)
}
export type UpdateCertificateMutationHookResult = ReturnType<
  typeof useUpdateCertificateMutation
>
export type UpdateCertificateMutationResult =
  Apollo.MutationResult<UpdateCertificateMutation>
export type UpdateCertificateMutationOptions = Apollo.BaseMutationOptions<
  UpdateCertificateMutation,
  UpdateCertificateMutationVariables
>
export const UpdateCertificateVariablesDocument = gql`
  mutation UpdateCertificateVariables(
    $merge: [CertificateVariablesMergeInput]!
    $context: CertificateVariablesContextInput
  ) {
    updateCertificateVariables(merge: $merge, context: $context) {
      id
      stats
      variables
    }
  }
`
export type UpdateCertificateVariablesMutationFn = Apollo.MutationFunction<
  UpdateCertificateVariablesMutation,
  UpdateCertificateVariablesMutationVariables
>

/**
 * __useUpdateCertificateVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateCertificateVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificateVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificateVariablesMutation, { data, loading, error }] = useUpdateCertificateVariablesMutation({
 *   variables: {
 *      merge: // value for 'merge'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useUpdateCertificateVariablesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCertificateVariablesMutation,
    UpdateCertificateVariablesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCertificateVariablesMutation,
    UpdateCertificateVariablesMutationVariables
  >(UpdateCertificateVariablesDocument, options)
}
export type UpdateCertificateVariablesMutationHookResult = ReturnType<
  typeof useUpdateCertificateVariablesMutation
>
export type UpdateCertificateVariablesMutationResult =
  Apollo.MutationResult<UpdateCertificateVariablesMutation>
export type UpdateCertificateVariablesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCertificateVariablesMutation,
    UpdateCertificateVariablesMutationVariables
  >
export const CohortMembersDocument = gql`
  query CohortMembers($id: Int!, $orderBy: [RegistrationOrderByInput]) {
    group(id: $id) {
      id
      registrations(
        first: 5
        orderBy: $orderBy
        role_filter: { in: [teacher, moderator, student] }
      ) {
        total
        edges {
          node {
            id
            role
            user {
              id
              first_name
              last_name
              email
              profile {
                id
                image
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCohortMembersQuery__
 *
 * To run a query within a React component, call `useCohortMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCohortMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortMembersQuery,
    CohortMembersQueryVariables
  > &
    (
      | { variables: CohortMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortMembersQuery, CohortMembersQueryVariables>(
    CohortMembersDocument,
    options
  )
}
export function useCohortMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortMembersQuery,
    CohortMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortMembersQuery, CohortMembersQueryVariables>(
    CohortMembersDocument,
    options
  )
}
export function useCohortMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortMembersQuery,
        CohortMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortMembersQuery,
    CohortMembersQueryVariables
  >(CohortMembersDocument, options)
}
export type CohortMembersQueryHookResult = ReturnType<
  typeof useCohortMembersQuery
>
export type CohortMembersLazyQueryHookResult = ReturnType<
  typeof useCohortMembersLazyQuery
>
export type CohortMembersSuspenseQueryHookResult = ReturnType<
  typeof useCohortMembersSuspenseQuery
>
export type CohortMembersQueryResult = Apollo.QueryResult<
  CohortMembersQuery,
  CohortMembersQueryVariables
>
export const CohortMembersStatsQueryDocument = gql`
  query CohortMembersStatsQuery($id: Int!) {
    cohort: group(id: $id) {
      id
      member_stats {
        total
        send_discussion_notifications
      }
    }
  }
`

/**
 * __useCohortMembersStatsQueryQuery__
 *
 * To run a query within a React component, call `useCohortMembersStatsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortMembersStatsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortMembersStatsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCohortMembersStatsQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortMembersStatsQueryQuery,
    CohortMembersStatsQueryQueryVariables
  > &
    (
      | { variables: CohortMembersStatsQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortMembersStatsQueryQuery,
    CohortMembersStatsQueryQueryVariables
  >(CohortMembersStatsQueryDocument, options)
}
export function useCohortMembersStatsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortMembersStatsQueryQuery,
    CohortMembersStatsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortMembersStatsQueryQuery,
    CohortMembersStatsQueryQueryVariables
  >(CohortMembersStatsQueryDocument, options)
}
export function useCohortMembersStatsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortMembersStatsQueryQuery,
        CohortMembersStatsQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortMembersStatsQueryQuery,
    CohortMembersStatsQueryQueryVariables
  >(CohortMembersStatsQueryDocument, options)
}
export type CohortMembersStatsQueryQueryHookResult = ReturnType<
  typeof useCohortMembersStatsQueryQuery
>
export type CohortMembersStatsQueryLazyQueryHookResult = ReturnType<
  typeof useCohortMembersStatsQueryLazyQuery
>
export type CohortMembersStatsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCohortMembersStatsQuerySuspenseQuery
>
export type CohortMembersStatsQueryQueryResult = Apollo.QueryResult<
  CohortMembersStatsQueryQuery,
  CohortMembersStatsQueryQueryVariables
>
export const CohortPermissionsDocument = gql`
  query CohortPermissions($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      ...CohortPermissions
    }
  }
  ${CohortPermissionsFragmentDoc}
`

/**
 * __useCohortPermissionsQuery__
 *
 * To run a query within a React component, call `useCohortPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortPermissionsQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useCohortPermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  > &
    (
      | { variables: CohortPermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >(CohortPermissionsDocument, options)
}
export function useCohortPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >(CohortPermissionsDocument, options)
}
export function useCohortPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortPermissionsQuery,
        CohortPermissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >(CohortPermissionsDocument, options)
}
export type CohortPermissionsQueryHookResult = ReturnType<
  typeof useCohortPermissionsQuery
>
export type CohortPermissionsLazyQueryHookResult = ReturnType<
  typeof useCohortPermissionsLazyQuery
>
export type CohortPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useCohortPermissionsSuspenseQuery
>
export type CohortPermissionsQueryResult = Apollo.QueryResult<
  CohortPermissionsQuery,
  CohortPermissionsQueryVariables
>
export const CohortDocument = gql`
  query Cohort($id: Int!) {
    cohort: group(id: $id) {
      ...Cohort
    }
  }
  ${CohortFragmentDoc}
`

/**
 * __useCohortQuery__
 *
 * To run a query within a React component, call `useCohortQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCohortQuery(
  baseOptions: Apollo.QueryHookOptions<CohortQuery, CohortQueryVariables> &
    ({ variables: CohortQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortQuery, CohortQueryVariables>(
    CohortDocument,
    options
  )
}
export function useCohortLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CohortQuery, CohortQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortQuery, CohortQueryVariables>(
    CohortDocument,
    options
  )
}
export function useCohortSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CohortQuery, CohortQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CohortQuery, CohortQueryVariables>(
    CohortDocument,
    options
  )
}
export type CohortQueryHookResult = ReturnType<typeof useCohortQuery>
export type CohortLazyQueryHookResult = ReturnType<typeof useCohortLazyQuery>
export type CohortSuspenseQueryHookResult = ReturnType<
  typeof useCohortSuspenseQuery
>
export type CohortQueryResult = Apollo.QueryResult<
  CohortQuery,
  CohortQueryVariables
>
export const CohortSwitcherCohortsDocument = gql`
  query CohortSwitcherCohorts(
    $first: Int = 25
    $cursor: String
    $resourceId: Int!
    $role: RoleFilter
    $search: String
  ) {
    cohorts: groups(
      first: $first
      after: $cursor
      resource_id: $resourceId
      role: $role
      search: $search
      include_curriculum: false
      status: in_progress
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Cohort
        }
      }
    }
  }
  ${CohortFragmentDoc}
`

/**
 * __useCohortSwitcherCohortsQuery__
 *
 * To run a query within a React component, call `useCohortSwitcherCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortSwitcherCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortSwitcherCohortsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      resourceId: // value for 'resourceId'
 *      role: // value for 'role'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCohortSwitcherCohortsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  > &
    (
      | { variables: CohortSwitcherCohortsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >(CohortSwitcherCohortsDocument, options)
}
export function useCohortSwitcherCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >(CohortSwitcherCohortsDocument, options)
}
export function useCohortSwitcherCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortSwitcherCohortsQuery,
        CohortSwitcherCohortsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >(CohortSwitcherCohortsDocument, options)
}
export type CohortSwitcherCohortsQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortsQuery
>
export type CohortSwitcherCohortsLazyQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortsLazyQuery
>
export type CohortSwitcherCohortsSuspenseQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortsSuspenseQuery
>
export type CohortSwitcherCohortsQueryResult = Apollo.QueryResult<
  CohortSwitcherCohortsQuery,
  CohortSwitcherCohortsQueryVariables
>
export const CohortsIncludedProductsQueryDocument = gql`
  query CohortsIncludedProductsQuery(
    $resourceId: Int
    $visibilityFilter: GroupVisibilityFilter
  ) {
    groups(
      resource_id: $resourceId
      visibility_filter: $visibilityFilter
      first: 50
    ) {
      edges {
        node {
          id
          include_with_products(first: 50) {
            edges {
              node {
                ...StripeProduct
                stripe_prices(first: 50) {
                  edges {
                    node {
                      ...StripePrice
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${StripeProductFragmentDoc}
  ${StripePriceFragmentDoc}
`

/**
 * __useCohortsIncludedProductsQueryQuery__
 *
 * To run a query within a React component, call `useCohortsIncludedProductsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortsIncludedProductsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortsIncludedProductsQueryQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      visibilityFilter: // value for 'visibilityFilter'
 *   },
 * });
 */
export function useCohortsIncludedProductsQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CohortsIncludedProductsQueryQuery,
    CohortsIncludedProductsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortsIncludedProductsQueryQuery,
    CohortsIncludedProductsQueryQueryVariables
  >(CohortsIncludedProductsQueryDocument, options)
}
export function useCohortsIncludedProductsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortsIncludedProductsQueryQuery,
    CohortsIncludedProductsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortsIncludedProductsQueryQuery,
    CohortsIncludedProductsQueryQueryVariables
  >(CohortsIncludedProductsQueryDocument, options)
}
export function useCohortsIncludedProductsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortsIncludedProductsQueryQuery,
        CohortsIncludedProductsQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortsIncludedProductsQueryQuery,
    CohortsIncludedProductsQueryQueryVariables
  >(CohortsIncludedProductsQueryDocument, options)
}
export type CohortsIncludedProductsQueryQueryHookResult = ReturnType<
  typeof useCohortsIncludedProductsQueryQuery
>
export type CohortsIncludedProductsQueryLazyQueryHookResult = ReturnType<
  typeof useCohortsIncludedProductsQueryLazyQuery
>
export type CohortsIncludedProductsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCohortsIncludedProductsQuerySuspenseQuery
>
export type CohortsIncludedProductsQueryQueryResult = Apollo.QueryResult<
  CohortsIncludedProductsQueryQuery,
  CohortsIncludedProductsQueryQueryVariables
>
export const CohortsDocument = gql`
  query Cohorts($cursor: String) {
    groups(
      first: 1042
      after: $cursor
      role: { in: [teacher, moderator] }
      include_curriculum: false
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Cohort
        }
      }
    }
  }
  ${CohortFragmentDoc}
`

/**
 * __useCohortsQuery__
 *
 * To run a query within a React component, call `useCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCohortsQuery(
  baseOptions?: Apollo.QueryHookOptions<CohortsQuery, CohortsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortsQuery, CohortsQueryVariables>(
    CohortsDocument,
    options
  )
}
export function useCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CohortsQuery, CohortsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortsQuery, CohortsQueryVariables>(
    CohortsDocument,
    options
  )
}
export function useCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CohortsQuery, CohortsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CohortsQuery, CohortsQueryVariables>(
    CohortsDocument,
    options
  )
}
export type CohortsQueryHookResult = ReturnType<typeof useCohortsQuery>
export type CohortsLazyQueryHookResult = ReturnType<typeof useCohortsLazyQuery>
export type CohortsSuspenseQueryHookResult = ReturnType<
  typeof useCohortsSuspenseQuery
>
export type CohortsQueryResult = Apollo.QueryResult<
  CohortsQuery,
  CohortsQueryVariables
>
export const CohortsStatusDocument = gql`
  query CohortsStatus($resourceId: Int!) {
    resource(id: $resourceId) {
      id
      licensed_from_school_id
      cohorts_status_meta {
        in_progress
      }
    }
  }
`

/**
 * __useCohortsStatusQuery__
 *
 * To run a query within a React component, call `useCohortsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortsStatusQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useCohortsStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortsStatusQuery,
    CohortsStatusQueryVariables
  > &
    (
      | { variables: CohortsStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortsStatusQuery, CohortsStatusQueryVariables>(
    CohortsStatusDocument,
    options
  )
}
export function useCohortsStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortsStatusQuery,
    CohortsStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortsStatusQuery, CohortsStatusQueryVariables>(
    CohortsStatusDocument,
    options
  )
}
export function useCohortsStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortsStatusQuery,
        CohortsStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortsStatusQuery,
    CohortsStatusQueryVariables
  >(CohortsStatusDocument, options)
}
export type CohortsStatusQueryHookResult = ReturnType<
  typeof useCohortsStatusQuery
>
export type CohortsStatusLazyQueryHookResult = ReturnType<
  typeof useCohortsStatusLazyQuery
>
export type CohortsStatusSuspenseQueryHookResult = ReturnType<
  typeof useCohortsStatusSuspenseQuery
>
export type CohortsStatusQueryResult = Apollo.QueryResult<
  CohortsStatusQuery,
  CohortsStatusQueryVariables
>
export const CreateCohortResourceDocument = gql`
  query CreateCohortResource($id: Int!) {
    resource(id: $id) {
      id
      name
      resource_type
      image(width: 100, height: 75, fit: crop)
      background_overlay
      background_image
      source_cohort: curriculum_group {
        id
        path(type: source) {
          id
          last_synced_dtime
        }
      }
      cohorts: groups(first: 1) {
        total
        edges {
          node {
            id
            path(type: source) {
              id
              last_synced_dtime
            }
          }
        }
      }
    }
  }
`

/**
 * __useCreateCohortResourceQuery__
 *
 * To run a query within a React component, call `useCreateCohortResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCohortResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCohortResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateCohortResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  > &
    (
      | { variables: CreateCohortResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >(CreateCohortResourceDocument, options)
}
export function useCreateCohortResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >(CreateCohortResourceDocument, options)
}
export function useCreateCohortResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreateCohortResourceQuery,
        CreateCohortResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >(CreateCohortResourceDocument, options)
}
export type CreateCohortResourceQueryHookResult = ReturnType<
  typeof useCreateCohortResourceQuery
>
export type CreateCohortResourceLazyQueryHookResult = ReturnType<
  typeof useCreateCohortResourceLazyQuery
>
export type CreateCohortResourceSuspenseQueryHookResult = ReturnType<
  typeof useCreateCohortResourceSuspenseQuery
>
export type CreateCohortResourceQueryResult = Apollo.QueryResult<
  CreateCohortResourceQuery,
  CreateCohortResourceQueryVariables
>
export const ResourcesDocument = gql`
  query Resources(
    $cursor: String
    $resourceTypes: ResourceTypeFilter
    $search: String
  ) {
    resources(
      first: 25
      after: $cursor
      resource_types: $resourceTypes
      search: $search
      licensed_from_school: { eq: null }
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Resource
        }
      }
    }
  }
  ${ResourceFragmentDoc}
`

/**
 * __useResourcesQuery__
 *
 * To run a query within a React component, call `useResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      resourceTypes: // value for 'resourceTypes'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useResourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourcesQuery, ResourcesQueryVariables>(
    ResourcesDocument,
    options
  )
}
export function useResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourcesQuery,
    ResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(
    ResourcesDocument,
    options
  )
}
export function useResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ResourcesQuery, ResourcesQueryVariables>(
    ResourcesDocument,
    options
  )
}
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>
export type ResourcesLazyQueryHookResult = ReturnType<
  typeof useResourcesLazyQuery
>
export type ResourcesSuspenseQueryHookResult = ReturnType<
  typeof useResourcesSuspenseQuery
>
export type ResourcesQueryResult = Apollo.QueryResult<
  ResourcesQuery,
  ResourcesQueryVariables
>
export const UpdateCohortStatusDocument = gql`
  mutation UpdateCohortStatus($id: Int!, $status: GroupStatus!) {
    updateGroupStatus(id: $id, status: $status) {
      id
      status
    }
  }
`
export type UpdateCohortStatusMutationFn = Apollo.MutationFunction<
  UpdateCohortStatusMutation,
  UpdateCohortStatusMutationVariables
>

/**
 * __useUpdateCohortStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCohortStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCohortStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCohortStatusMutation, { data, loading, error }] = useUpdateCohortStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCohortStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCohortStatusMutation,
    UpdateCohortStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCohortStatusMutation,
    UpdateCohortStatusMutationVariables
  >(UpdateCohortStatusDocument, options)
}
export type UpdateCohortStatusMutationHookResult = ReturnType<
  typeof useUpdateCohortStatusMutation
>
export type UpdateCohortStatusMutationResult =
  Apollo.MutationResult<UpdateCohortStatusMutation>
export type UpdateCohortStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateCohortStatusMutation,
  UpdateCohortStatusMutationVariables
>
export const CohortSwitcherCohortQueryDocument = gql`
  query CohortSwitcherCohortQuery($id: Int!) {
    cohort: group(id: $id) {
      id
      name
      is_source_cohort
      resource {
        id
        slug
        licensed_from_school_id
        licensed_from_resource_id
        background_overlay
        background_image
        name
        blurred_background: background_image(blur: 500, width: 250, height: 250)
        source_cohort: group(type: curriculum) {
          id
        }
        resource_type
      }
      user_registration {
        id
        role
      }
      user_source_registration {
        id
        role
      }
    }
  }
`

/**
 * __useCohortSwitcherCohortQueryQuery__
 *
 * To run a query within a React component, call `useCohortSwitcherCohortQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortSwitcherCohortQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortSwitcherCohortQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCohortSwitcherCohortQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortSwitcherCohortQueryQuery,
    CohortSwitcherCohortQueryQueryVariables
  > &
    (
      | { variables: CohortSwitcherCohortQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortSwitcherCohortQueryQuery,
    CohortSwitcherCohortQueryQueryVariables
  >(CohortSwitcherCohortQueryDocument, options)
}
export function useCohortSwitcherCohortQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortSwitcherCohortQueryQuery,
    CohortSwitcherCohortQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortSwitcherCohortQueryQuery,
    CohortSwitcherCohortQueryQueryVariables
  >(CohortSwitcherCohortQueryDocument, options)
}
export function useCohortSwitcherCohortQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortSwitcherCohortQueryQuery,
        CohortSwitcherCohortQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortSwitcherCohortQueryQuery,
    CohortSwitcherCohortQueryQueryVariables
  >(CohortSwitcherCohortQueryDocument, options)
}
export type CohortSwitcherCohortQueryQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortQueryQuery
>
export type CohortSwitcherCohortQueryLazyQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortQueryLazyQuery
>
export type CohortSwitcherCohortQuerySuspenseQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortQuerySuspenseQuery
>
export type CohortSwitcherCohortQueryQueryResult = Apollo.QueryResult<
  CohortSwitcherCohortQueryQuery,
  CohortSwitcherCohortQueryQueryVariables
>
export const CompletionDocument = gql`
  query Completion($id: Int) {
    pathItem(id: $id) {
      ...PathItem
      parent {
        id
        name
      }
      path {
        id
        progress
        points {
          path_id
          total
          earned
          percentage
          total_points_possible
          has_points
        }
      }
      resource {
        id
        name
        image(width: 150, height: 150)
      }
    }
  }
  ${PathItemFragmentDoc}
`

/**
 * __useCompletionQuery__
 *
 * To run a query within a React component, call `useCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompletionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompletionQuery,
    CompletionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompletionQuery, CompletionQueryVariables>(
    CompletionDocument,
    options
  )
}
export function useCompletionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompletionQuery,
    CompletionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompletionQuery, CompletionQueryVariables>(
    CompletionDocument,
    options
  )
}
export function useCompletionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CompletionQuery, CompletionQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CompletionQuery, CompletionQueryVariables>(
    CompletionDocument,
    options
  )
}
export type CompletionQueryHookResult = ReturnType<typeof useCompletionQuery>
export type CompletionLazyQueryHookResult = ReturnType<
  typeof useCompletionLazyQuery
>
export type CompletionSuspenseQueryHookResult = ReturnType<
  typeof useCompletionSuspenseQuery
>
export type CompletionQueryResult = Apollo.QueryResult<
  CompletionQuery,
  CompletionQueryVariables
>
export const CompletionsDocument = gql`
  query Completions(
    $first: Int = 50
    $user_id: Int
    $cohort_id: Int
    $group_id: Int
    $path_id: Int
    $step_id: Int
    $lesson_source_id: Int
    $source_id: Int
    $needs_review: Boolean
    $is_reviewed: Boolean
    $is_complete: Boolean
    $archivedDateFilter: [DateFilter]
    $order_by: [String]
    $cursor: String
  ) {
    completions(
      first: $first
      after: $cursor
      user_id: $user_id
      cohort_id: $cohort_id
      group_id: $group_id
      step_id: $step_id
      path_id: $path_id
      lesson_source_id: $lesson_source_id
      source_id: $source_id
      needs_review: $needs_review
      is_reviewed: $is_reviewed
      is_complete: $is_complete
      archivedDateFilter: $archivedDateFilter
      order_by: $order_by
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...CompletionsItem
        }
      }
    }
  }
  ${CompletionsItemFragmentDoc}
`

/**
 * __useCompletionsQuery__
 *
 * To run a query within a React component, call `useCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      user_id: // value for 'user_id'
 *      cohort_id: // value for 'cohort_id'
 *      group_id: // value for 'group_id'
 *      path_id: // value for 'path_id'
 *      step_id: // value for 'step_id'
 *      lesson_source_id: // value for 'lesson_source_id'
 *      source_id: // value for 'source_id'
 *      needs_review: // value for 'needs_review'
 *      is_reviewed: // value for 'is_reviewed'
 *      is_complete: // value for 'is_complete'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *      order_by: // value for 'order_by'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCompletionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompletionsQuery,
    CompletionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompletionsQuery, CompletionsQueryVariables>(
    CompletionsDocument,
    options
  )
}
export function useCompletionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompletionsQuery,
    CompletionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompletionsQuery, CompletionsQueryVariables>(
    CompletionsDocument,
    options
  )
}
export function useCompletionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CompletionsQuery,
        CompletionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CompletionsQuery, CompletionsQueryVariables>(
    CompletionsDocument,
    options
  )
}
export type CompletionsQueryHookResult = ReturnType<typeof useCompletionsQuery>
export type CompletionsLazyQueryHookResult = ReturnType<
  typeof useCompletionsLazyQuery
>
export type CompletionsSuspenseQueryHookResult = ReturnType<
  typeof useCompletionsSuspenseQuery
>
export type CompletionsQueryResult = Apollo.QueryResult<
  CompletionsQuery,
  CompletionsQueryVariables
>
export const ResetCompletionFeedbackDocument = gql`
  mutation ResetCompletionFeedback($id: Int!, $pathId: Int!) {
    resetCompletionFeedback(id: $id, path_id: $pathId) {
      ...Completion
    }
  }
  ${CompletionFragmentDoc}
`
export type ResetCompletionFeedbackMutationFn = Apollo.MutationFunction<
  ResetCompletionFeedbackMutation,
  ResetCompletionFeedbackMutationVariables
>

/**
 * __useResetCompletionFeedbackMutation__
 *
 * To run a mutation, you first call `useResetCompletionFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCompletionFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCompletionFeedbackMutation, { data, loading, error }] = useResetCompletionFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useResetCompletionFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetCompletionFeedbackMutation,
    ResetCompletionFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetCompletionFeedbackMutation,
    ResetCompletionFeedbackMutationVariables
  >(ResetCompletionFeedbackDocument, options)
}
export type ResetCompletionFeedbackMutationHookResult = ReturnType<
  typeof useResetCompletionFeedbackMutation
>
export type ResetCompletionFeedbackMutationResult =
  Apollo.MutationResult<ResetCompletionFeedbackMutation>
export type ResetCompletionFeedbackMutationOptions = Apollo.BaseMutationOptions<
  ResetCompletionFeedbackMutation,
  ResetCompletionFeedbackMutationVariables
>
export const SaveCompletionFeedbackDocument = gql`
  mutation SaveCompletionFeedback(
    $id: Int!
    $pathId: Int!
    $userpointsEarned: Int!
    $userpointsExplanation: String
    $notify: Boolean
  ) {
    saveCompletionFeedback(
      id: $id
      path_id: $pathId
      userpoints_earned: $userpointsEarned
      userpoints_explanation: $userpointsExplanation
      notify: $notify
    ) {
      ...Completion
    }
  }
  ${CompletionFragmentDoc}
`
export type SaveCompletionFeedbackMutationFn = Apollo.MutationFunction<
  SaveCompletionFeedbackMutation,
  SaveCompletionFeedbackMutationVariables
>

/**
 * __useSaveCompletionFeedbackMutation__
 *
 * To run a mutation, you first call `useSaveCompletionFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompletionFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCompletionFeedbackMutation, { data, loading, error }] = useSaveCompletionFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *      userpointsEarned: // value for 'userpointsEarned'
 *      userpointsExplanation: // value for 'userpointsExplanation'
 *      notify: // value for 'notify'
 *   },
 * });
 */
export function useSaveCompletionFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveCompletionFeedbackMutation,
    SaveCompletionFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SaveCompletionFeedbackMutation,
    SaveCompletionFeedbackMutationVariables
  >(SaveCompletionFeedbackDocument, options)
}
export type SaveCompletionFeedbackMutationHookResult = ReturnType<
  typeof useSaveCompletionFeedbackMutation
>
export type SaveCompletionFeedbackMutationResult =
  Apollo.MutationResult<SaveCompletionFeedbackMutation>
export type SaveCompletionFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SaveCompletionFeedbackMutation,
  SaveCompletionFeedbackMutationVariables
>
export const UserCompletionsNeedingReviewDocument = gql`
  query UserCompletionsNeedingReview($user_id: Int!) {
    pathItemStats(user_id: $user_id) {
      path_items_needing_review
    }
  }
`

/**
 * __useUserCompletionsNeedingReviewQuery__
 *
 * To run a query within a React component, call `useUserCompletionsNeedingReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompletionsNeedingReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompletionsNeedingReviewQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUserCompletionsNeedingReviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  > &
    (
      | {
          variables: UserCompletionsNeedingReviewQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >(UserCompletionsNeedingReviewDocument, options)
}
export function useUserCompletionsNeedingReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >(UserCompletionsNeedingReviewDocument, options)
}
export function useUserCompletionsNeedingReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserCompletionsNeedingReviewQuery,
        UserCompletionsNeedingReviewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >(UserCompletionsNeedingReviewDocument, options)
}
export type UserCompletionsNeedingReviewQueryHookResult = ReturnType<
  typeof useUserCompletionsNeedingReviewQuery
>
export type UserCompletionsNeedingReviewLazyQueryHookResult = ReturnType<
  typeof useUserCompletionsNeedingReviewLazyQuery
>
export type UserCompletionsNeedingReviewSuspenseQueryHookResult = ReturnType<
  typeof useUserCompletionsNeedingReviewSuspenseQuery
>
export type UserCompletionsNeedingReviewQueryResult = Apollo.QueryResult<
  UserCompletionsNeedingReviewQuery,
  UserCompletionsNeedingReviewQueryVariables
>
export const CouponQueryDocument = gql`
  query CouponQuery(
    $code: String!
    $seat_count: Int
    $cohort_id: Int
    $resource_id: Int
    $resource_license_offering_id: Int
    $school_subscription_plan_id: Int
  ) {
    school {
      ...School
      coupon: couponDiscount(
        code: $code
        seat_count: $seat_count
        cohort_id: $cohort_id
        resource_id: $resource_id
        resource_license_offering_id: $resource_license_offering_id
        school_subscription_plan_id: $school_subscription_plan_id
      ) {
        ...Coupon
      }
    }
  }
  ${SchoolFragmentDoc}
  ${CouponFragmentDoc}
`

/**
 * __useCouponQueryQuery__
 *
 * To run a query within a React component, call `useCouponQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *      seat_count: // value for 'seat_count'
 *      cohort_id: // value for 'cohort_id'
 *      resource_id: // value for 'resource_id'
 *      resource_license_offering_id: // value for 'resource_license_offering_id'
 *      school_subscription_plan_id: // value for 'school_subscription_plan_id'
 *   },
 * });
 */
export function useCouponQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CouponQueryQuery,
    CouponQueryQueryVariables
  > &
    (
      | { variables: CouponQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CouponQueryQuery, CouponQueryQueryVariables>(
    CouponQueryDocument,
    options
  )
}
export function useCouponQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CouponQueryQuery,
    CouponQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CouponQueryQuery, CouponQueryQueryVariables>(
    CouponQueryDocument,
    options
  )
}
export function useCouponQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CouponQueryQuery,
        CouponQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CouponQueryQuery, CouponQueryQueryVariables>(
    CouponQueryDocument,
    options
  )
}
export type CouponQueryQueryHookResult = ReturnType<typeof useCouponQueryQuery>
export type CouponQueryLazyQueryHookResult = ReturnType<
  typeof useCouponQueryLazyQuery
>
export type CouponQuerySuspenseQueryHookResult = ReturnType<
  typeof useCouponQuerySuspenseQuery
>
export type CouponQueryQueryResult = Apollo.QueryResult<
  CouponQueryQuery,
  CouponQueryQueryVariables
>
export const CoverPageLicensorRelatedResourcesDocument = gql`
  query CoverPageLicensorRelatedResources(
    $licensorSchoolId: Int!
    $idFilter: IDFilter
    $categoryIdFilter: IDFilter
    $resourceTypeFilter: ResourceTypeFilter
    $first: Int!
    $orderBy: String
    $cursor: String
  ) {
    context(school_id: $licensorSchoolId) {
      school {
        id
        resources(
          id: $idFilter
          category_ids: $categoryIdFilter
          resource_types: $resourceTypeFilter
          first: $first
          orderBy: $orderBy
          after: $cursor
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              name
              slug
              image: image(width: 450, height: 350, fit: crop)
              lowest_public_offering_price
              highest_public_offering_price
              licensing_enabled
              contributors: authors(first: 20) {
                total
                edges {
                  node {
                    id
                    full_name
                  }
                }
              }
              publisher {
                name
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCoverPageLicensorRelatedResourcesQuery__
 *
 * To run a query within a React component, call `useCoverPageLicensorRelatedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageLicensorRelatedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageLicensorRelatedResourcesQuery({
 *   variables: {
 *      licensorSchoolId: // value for 'licensorSchoolId'
 *      idFilter: // value for 'idFilter'
 *      categoryIdFilter: // value for 'categoryIdFilter'
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCoverPageLicensorRelatedResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageLicensorRelatedResourcesQuery,
    CoverPageLicensorRelatedResourcesQueryVariables
  > &
    (
      | {
          variables: CoverPageLicensorRelatedResourcesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPageLicensorRelatedResourcesQuery,
    CoverPageLicensorRelatedResourcesQueryVariables
  >(CoverPageLicensorRelatedResourcesDocument, options)
}
export function useCoverPageLicensorRelatedResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageLicensorRelatedResourcesQuery,
    CoverPageLicensorRelatedResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageLicensorRelatedResourcesQuery,
    CoverPageLicensorRelatedResourcesQueryVariables
  >(CoverPageLicensorRelatedResourcesDocument, options)
}
export function useCoverPageLicensorRelatedResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageLicensorRelatedResourcesQuery,
        CoverPageLicensorRelatedResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageLicensorRelatedResourcesQuery,
    CoverPageLicensorRelatedResourcesQueryVariables
  >(CoverPageLicensorRelatedResourcesDocument, options)
}
export type CoverPageLicensorRelatedResourcesQueryHookResult = ReturnType<
  typeof useCoverPageLicensorRelatedResourcesQuery
>
export type CoverPageLicensorRelatedResourcesLazyQueryHookResult = ReturnType<
  typeof useCoverPageLicensorRelatedResourcesLazyQuery
>
export type CoverPageLicensorRelatedResourcesSuspenseQueryHookResult =
  ReturnType<typeof useCoverPageLicensorRelatedResourcesSuspenseQuery>
export type CoverPageLicensorRelatedResourcesQueryResult = Apollo.QueryResult<
  CoverPageLicensorRelatedResourcesQuery,
  CoverPageLicensorRelatedResourcesQueryVariables
>
export const CoverPageLicensorResourceDocument = gql`
  query CoverPageLicensorResource(
    $id: Int
    $licensorSchoolId: Int!
    $contributorPositioningContext: PositioningContextInput!
    $categoryPositioningContext: PositioningContextInput!
  ) {
    context(school_id: $licensorSchoolId) {
      school {
        id
        resource(id: $id) {
          ...CoverPageResource
        }
      }
    }
  }
  ${CoverPageResourceFragmentDoc}
`

/**
 * __useCoverPageLicensorResourceQuery__
 *
 * To run a query within a React component, call `useCoverPageLicensorResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageLicensorResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageLicensorResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      licensorSchoolId: // value for 'licensorSchoolId'
 *      contributorPositioningContext: // value for 'contributorPositioningContext'
 *      categoryPositioningContext: // value for 'categoryPositioningContext'
 *   },
 * });
 */
export function useCoverPageLicensorResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageLicensorResourceQuery,
    CoverPageLicensorResourceQueryVariables
  > &
    (
      | { variables: CoverPageLicensorResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPageLicensorResourceQuery,
    CoverPageLicensorResourceQueryVariables
  >(CoverPageLicensorResourceDocument, options)
}
export function useCoverPageLicensorResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageLicensorResourceQuery,
    CoverPageLicensorResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageLicensorResourceQuery,
    CoverPageLicensorResourceQueryVariables
  >(CoverPageLicensorResourceDocument, options)
}
export function useCoverPageLicensorResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageLicensorResourceQuery,
        CoverPageLicensorResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageLicensorResourceQuery,
    CoverPageLicensorResourceQueryVariables
  >(CoverPageLicensorResourceDocument, options)
}
export type CoverPageLicensorResourceQueryHookResult = ReturnType<
  typeof useCoverPageLicensorResourceQuery
>
export type CoverPageLicensorResourceLazyQueryHookResult = ReturnType<
  typeof useCoverPageLicensorResourceLazyQuery
>
export type CoverPageLicensorResourceSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageLicensorResourceSuspenseQuery
>
export type CoverPageLicensorResourceQueryResult = Apollo.QueryResult<
  CoverPageLicensorResourceQuery,
  CoverPageLicensorResourceQueryVariables
>
export const CoverPageOfferableCohortsDocument = gql`
  query CoverPageOfferableCohorts($resourceId: Int!, $cursor: String) {
    groups(
      first: 50
      after: $cursor
      resource_id: $resourceId
      is_offerable: true
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...CoverPageOfferableCohort
        }
      }
    }
  }
  ${CoverPageOfferableCohortFragmentDoc}
`

/**
 * __useCoverPageOfferableCohortsQuery__
 *
 * To run a query within a React component, call `useCoverPageOfferableCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageOfferableCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageOfferableCohortsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCoverPageOfferableCohortsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageOfferableCohortsQuery,
    CoverPageOfferableCohortsQueryVariables
  > &
    (
      | { variables: CoverPageOfferableCohortsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPageOfferableCohortsQuery,
    CoverPageOfferableCohortsQueryVariables
  >(CoverPageOfferableCohortsDocument, options)
}
export function useCoverPageOfferableCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageOfferableCohortsQuery,
    CoverPageOfferableCohortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageOfferableCohortsQuery,
    CoverPageOfferableCohortsQueryVariables
  >(CoverPageOfferableCohortsDocument, options)
}
export function useCoverPageOfferableCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageOfferableCohortsQuery,
        CoverPageOfferableCohortsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageOfferableCohortsQuery,
    CoverPageOfferableCohortsQueryVariables
  >(CoverPageOfferableCohortsDocument, options)
}
export type CoverPageOfferableCohortsQueryHookResult = ReturnType<
  typeof useCoverPageOfferableCohortsQuery
>
export type CoverPageOfferableCohortsLazyQueryHookResult = ReturnType<
  typeof useCoverPageOfferableCohortsLazyQuery
>
export type CoverPageOfferableCohortsSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageOfferableCohortsSuspenseQuery
>
export type CoverPageOfferableCohortsQueryResult = Apollo.QueryResult<
  CoverPageOfferableCohortsQuery,
  CoverPageOfferableCohortsQueryVariables
>
export const CoverPageOffersDocument = gql`
  query CoverPageOffers($context: OfferContext!, $first: Int = 50) {
    offerConnections(context: $context, first: $first) {
      edges {
        node {
          ...CoverPageOffer
        }
      }
    }
  }
  ${CoverPageOfferFragmentDoc}
`

/**
 * __useCoverPageOffersQuery__
 *
 * To run a query within a React component, call `useCoverPageOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageOffersQuery({
 *   variables: {
 *      context: // value for 'context'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCoverPageOffersQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  > &
    (
      | { variables: CoverPageOffersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CoverPageOffersQuery, CoverPageOffersQueryVariables>(
    CoverPageOffersDocument,
    options
  )
}
export function useCoverPageOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  >(CoverPageOffersDocument, options)
}
export function useCoverPageOffersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageOffersQuery,
        CoverPageOffersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  >(CoverPageOffersDocument, options)
}
export type CoverPageOffersQueryHookResult = ReturnType<
  typeof useCoverPageOffersQuery
>
export type CoverPageOffersLazyQueryHookResult = ReturnType<
  typeof useCoverPageOffersLazyQuery
>
export type CoverPageOffersSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageOffersSuspenseQuery
>
export type CoverPageOffersQueryResult = Apollo.QueryResult<
  CoverPageOffersQuery,
  CoverPageOffersQueryVariables
>
export const CoverPagePrivateLicenseOfferingDocument = gql`
  query CoverPagePrivateLicenseOffering($resourceId: Int!) {
    resource(id: $resourceId) {
      id
      license_offerings(first: 1, licensing_mode: private_cohorts) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`

/**
 * __useCoverPagePrivateLicenseOfferingQuery__
 *
 * To run a query within a React component, call `useCoverPagePrivateLicenseOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPagePrivateLicenseOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPagePrivateLicenseOfferingQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useCoverPagePrivateLicenseOfferingQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPagePrivateLicenseOfferingQuery,
    CoverPagePrivateLicenseOfferingQueryVariables
  > &
    (
      | {
          variables: CoverPagePrivateLicenseOfferingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPagePrivateLicenseOfferingQuery,
    CoverPagePrivateLicenseOfferingQueryVariables
  >(CoverPagePrivateLicenseOfferingDocument, options)
}
export function useCoverPagePrivateLicenseOfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPagePrivateLicenseOfferingQuery,
    CoverPagePrivateLicenseOfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPagePrivateLicenseOfferingQuery,
    CoverPagePrivateLicenseOfferingQueryVariables
  >(CoverPagePrivateLicenseOfferingDocument, options)
}
export function useCoverPagePrivateLicenseOfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPagePrivateLicenseOfferingQuery,
        CoverPagePrivateLicenseOfferingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPagePrivateLicenseOfferingQuery,
    CoverPagePrivateLicenseOfferingQueryVariables
  >(CoverPagePrivateLicenseOfferingDocument, options)
}
export type CoverPagePrivateLicenseOfferingQueryHookResult = ReturnType<
  typeof useCoverPagePrivateLicenseOfferingQuery
>
export type CoverPagePrivateLicenseOfferingLazyQueryHookResult = ReturnType<
  typeof useCoverPagePrivateLicenseOfferingLazyQuery
>
export type CoverPagePrivateLicenseOfferingSuspenseQueryHookResult = ReturnType<
  typeof useCoverPagePrivateLicenseOfferingSuspenseQuery
>
export type CoverPagePrivateLicenseOfferingQueryResult = Apollo.QueryResult<
  CoverPagePrivateLicenseOfferingQuery,
  CoverPagePrivateLicenseOfferingQueryVariables
>
export const CoverPageRelatedResourcesDocument = gql`
  query CoverPageRelatedResources(
    $idFilter: IDFilter
    $categoryIdFilter: IDFilter
    $resourceTypeFilter: ResourceTypeFilter
    $first: Int!
    $orderBy: String
    $cursor: String
  ) {
    resources(
      id: $idFilter
      category_ids: $categoryIdFilter
      resource_types: $resourceTypeFilter
      first: $first
      orderBy: $orderBy
      after: $cursor
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
          slug
          image: image(width: 450, height: 350, fit: crop)
          lowest_public_offering_price
          highest_public_offering_price
          licensing_enabled
          contributors: authors(first: 20) {
            total
            edges {
              node {
                id
                full_name
              }
            }
          }
          publisher {
            name
          }
        }
      }
    }
  }
`

/**
 * __useCoverPageRelatedResourcesQuery__
 *
 * To run a query within a React component, call `useCoverPageRelatedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageRelatedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageRelatedResourcesQuery({
 *   variables: {
 *      idFilter: // value for 'idFilter'
 *      categoryIdFilter: // value for 'categoryIdFilter'
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCoverPageRelatedResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  > &
    (
      | { variables: CoverPageRelatedResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >(CoverPageRelatedResourcesDocument, options)
}
export function useCoverPageRelatedResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >(CoverPageRelatedResourcesDocument, options)
}
export function useCoverPageRelatedResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageRelatedResourcesQuery,
        CoverPageRelatedResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >(CoverPageRelatedResourcesDocument, options)
}
export type CoverPageRelatedResourcesQueryHookResult = ReturnType<
  typeof useCoverPageRelatedResourcesQuery
>
export type CoverPageRelatedResourcesLazyQueryHookResult = ReturnType<
  typeof useCoverPageRelatedResourcesLazyQuery
>
export type CoverPageRelatedResourcesSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageRelatedResourcesSuspenseQuery
>
export type CoverPageRelatedResourcesQueryResult = Apollo.QueryResult<
  CoverPageRelatedResourcesQuery,
  CoverPageRelatedResourcesQueryVariables
>
export const CoverPageResourceDocument = gql`
  query CoverPageResource(
    $id: Int
    $contributorPositioningContext: PositioningContextInput!
    $categoryPositioningContext: PositioningContextInput!
  ) {
    resource(id: $id) {
      ...CoverPageResource
    }
  }
  ${CoverPageResourceFragmentDoc}
`

/**
 * __useCoverPageResourceQuery__
 *
 * To run a query within a React component, call `useCoverPageResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contributorPositioningContext: // value for 'contributorPositioningContext'
 *      categoryPositioningContext: // value for 'categoryPositioningContext'
 *   },
 * });
 */
export function useCoverPageResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  > &
    (
      | { variables: CoverPageResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >(CoverPageResourceDocument, options)
}
export function useCoverPageResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >(CoverPageResourceDocument, options)
}
export function useCoverPageResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageResourceQuery,
        CoverPageResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >(CoverPageResourceDocument, options)
}
export type CoverPageResourceQueryHookResult = ReturnType<
  typeof useCoverPageResourceQuery
>
export type CoverPageResourceLazyQueryHookResult = ReturnType<
  typeof useCoverPageResourceLazyQuery
>
export type CoverPageResourceSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageResourceSuspenseQuery
>
export type CoverPageResourceQueryResult = Apollo.QueryResult<
  CoverPageResourceQuery,
  CoverPageResourceQueryVariables
>
export const CreateOfferDocument = gql`
  mutation CreateOffer($resourceId: Int!, $offer: StoreOfferInput!) {
    createOffer(resource_id: $resourceId, offer: $offer) {
      ...CoverPageOffer
    }
  }
  ${CoverPageOfferFragmentDoc}
`
export type CreateOfferMutationFn = Apollo.MutationFunction<
  CreateOfferMutation,
  CreateOfferMutationVariables
>

/**
 * __useCreateOfferMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferMutation, { data, loading, error }] = useCreateOfferMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      offer: // value for 'offer'
 *   },
 * });
 */
export function useCreateOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOfferMutation,
    CreateOfferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateOfferMutation, CreateOfferMutationVariables>(
    CreateOfferDocument,
    options
  )
}
export type CreateOfferMutationHookResult = ReturnType<
  typeof useCreateOfferMutation
>
export type CreateOfferMutationResult =
  Apollo.MutationResult<CreateOfferMutation>
export type CreateOfferMutationOptions = Apollo.BaseMutationOptions<
  CreateOfferMutation,
  CreateOfferMutationVariables
>
export const DeleteOfferDocument = gql`
  mutation DeleteOffer($resourceId: Int!, $id: Int!) {
    deleteOffer(resource_id: $resourceId, id: $id)
  }
`
export type DeleteOfferMutationFn = Apollo.MutationFunction<
  DeleteOfferMutation,
  DeleteOfferMutationVariables
>

/**
 * __useDeleteOfferMutation__
 *
 * To run a mutation, you first call `useDeleteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferMutation, { data, loading, error }] = useDeleteOfferMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOfferMutation,
    DeleteOfferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteOfferMutation, DeleteOfferMutationVariables>(
    DeleteOfferDocument,
    options
  )
}
export type DeleteOfferMutationHookResult = ReturnType<
  typeof useDeleteOfferMutation
>
export type DeleteOfferMutationResult =
  Apollo.MutationResult<DeleteOfferMutation>
export type DeleteOfferMutationOptions = Apollo.BaseMutationOptions<
  DeleteOfferMutation,
  DeleteOfferMutationVariables
>
export const ReorderOffersDocument = gql`
  mutation ReorderOffers($resourceId: Int!, $input: StoreOfferReorderInput!) {
    reorderOffers(resource_id: $resourceId, input: $input)
  }
`
export type ReorderOffersMutationFn = Apollo.MutationFunction<
  ReorderOffersMutation,
  ReorderOffersMutationVariables
>

/**
 * __useReorderOffersMutation__
 *
 * To run a mutation, you first call `useReorderOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderOffersMutation, { data, loading, error }] = useReorderOffersMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderOffersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderOffersMutation,
    ReorderOffersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReorderOffersMutation,
    ReorderOffersMutationVariables
  >(ReorderOffersDocument, options)
}
export type ReorderOffersMutationHookResult = ReturnType<
  typeof useReorderOffersMutation
>
export type ReorderOffersMutationResult =
  Apollo.MutationResult<ReorderOffersMutation>
export type ReorderOffersMutationOptions = Apollo.BaseMutationOptions<
  ReorderOffersMutation,
  ReorderOffersMutationVariables
>
export const UpdateCoverPageContributorBioDocument = gql`
  mutation UpdateCoverPageContributorBio($id: Int!, $bio: String) {
    updateAuthor(id: $id, bio: $bio) {
      id
      bio
    }
  }
`
export type UpdateCoverPageContributorBioMutationFn = Apollo.MutationFunction<
  UpdateCoverPageContributorBioMutation,
  UpdateCoverPageContributorBioMutationVariables
>

/**
 * __useUpdateCoverPageContributorBioMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPageContributorBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPageContributorBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPageContributorBioMutation, { data, loading, error }] = useUpdateCoverPageContributorBioMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bio: // value for 'bio'
 *   },
 * });
 */
export function useUpdateCoverPageContributorBioMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoverPageContributorBioMutation,
    UpdateCoverPageContributorBioMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCoverPageContributorBioMutation,
    UpdateCoverPageContributorBioMutationVariables
  >(UpdateCoverPageContributorBioDocument, options)
}
export type UpdateCoverPageContributorBioMutationHookResult = ReturnType<
  typeof useUpdateCoverPageContributorBioMutation
>
export type UpdateCoverPageContributorBioMutationResult =
  Apollo.MutationResult<UpdateCoverPageContributorBioMutation>
export type UpdateCoverPageContributorBioMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCoverPageContributorBioMutation,
    UpdateCoverPageContributorBioMutationVariables
  >
export const UpdateOfferDocument = gql`
  mutation UpdateOffer(
    $resourceId: Int!
    $id: Int!
    $offer: StoreOfferPatchInput!
  ) {
    updateOffer(resource_id: $resourceId, id: $id, offer: $offer) {
      ...CoverPageOffer
    }
  }
  ${CoverPageOfferFragmentDoc}
`
export type UpdateOfferMutationFn = Apollo.MutationFunction<
  UpdateOfferMutation,
  UpdateOfferMutationVariables
>

/**
 * __useUpdateOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferMutation, { data, loading, error }] = useUpdateOfferMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      id: // value for 'id'
 *      offer: // value for 'offer'
 *   },
 * });
 */
export function useUpdateOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOfferMutation,
    UpdateOfferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateOfferMutation, UpdateOfferMutationVariables>(
    UpdateOfferDocument,
    options
  )
}
export type UpdateOfferMutationHookResult = ReturnType<
  typeof useUpdateOfferMutation
>
export type UpdateOfferMutationResult =
  Apollo.MutationResult<UpdateOfferMutation>
export type UpdateOfferMutationOptions = Apollo.BaseMutationOptions<
  UpdateOfferMutation,
  UpdateOfferMutationVariables
>
export const UpdateCoverPagePathPreviewItemsDocument = gql`
  mutation UpdateCoverPagePathPreviewItems(
    $path_id: Int!
    $items: [PathItemBulkUpdateInput!]!
  ) {
    bulkUpdatePathItems(path_id: $path_id, items: $items) {
      source_id
      success
      previous_values
      error
    }
  }
`
export type UpdateCoverPagePathPreviewItemsMutationFn = Apollo.MutationFunction<
  UpdateCoverPagePathPreviewItemsMutation,
  UpdateCoverPagePathPreviewItemsMutationVariables
>

/**
 * __useUpdateCoverPagePathPreviewItemsMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPagePathPreviewItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPagePathPreviewItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPagePathPreviewItemsMutation, { data, loading, error }] = useUpdateCoverPagePathPreviewItemsMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateCoverPagePathPreviewItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoverPagePathPreviewItemsMutation,
    UpdateCoverPagePathPreviewItemsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCoverPagePathPreviewItemsMutation,
    UpdateCoverPagePathPreviewItemsMutationVariables
  >(UpdateCoverPagePathPreviewItemsDocument, options)
}
export type UpdateCoverPagePathPreviewItemsMutationHookResult = ReturnType<
  typeof useUpdateCoverPagePathPreviewItemsMutation
>
export type UpdateCoverPagePathPreviewItemsMutationResult =
  Apollo.MutationResult<UpdateCoverPagePathPreviewItemsMutation>
export type UpdateCoverPagePathPreviewItemsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCoverPagePathPreviewItemsMutation,
    UpdateCoverPagePathPreviewItemsMutationVariables
  >
export const UpdateCoverPageResourceDocument = gql`
  mutation UpdateCoverPageResource(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $cover_image: String
    $background_image: String
    $background_overlay: String
    $background_type: Int
    $description: String
    $short_description: String
    $authors: [Int]
    $categories: [Int]
    $trailer_embed_code: String
    $visibility_level_override: Int
    $contributorPositioningContext: PositioningContextInput!
    $categoryPositioningContext: PositioningContextInput!
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      cover_image: $cover_image
      background_image: $background_image
      background_overlay: $background_overlay
      background_type: $background_type
      description: $description
      short_description: $short_description
      authors: $authors
      categories: $categories
      trailer_embed_code: $trailer_embed_code
      visibility_level_override: $visibility_level_override
    ) {
      ...CoverPageResource
    }
  }
  ${CoverPageResourceFragmentDoc}
`
export type UpdateCoverPageResourceMutationFn = Apollo.MutationFunction<
  UpdateCoverPageResourceMutation,
  UpdateCoverPageResourceMutationVariables
>

/**
 * __useUpdateCoverPageResourceMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPageResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPageResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPageResourceMutation, { data, loading, error }] = useUpdateCoverPageResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      cover_image: // value for 'cover_image'
 *      background_image: // value for 'background_image'
 *      background_overlay: // value for 'background_overlay'
 *      background_type: // value for 'background_type'
 *      description: // value for 'description'
 *      short_description: // value for 'short_description'
 *      authors: // value for 'authors'
 *      categories: // value for 'categories'
 *      trailer_embed_code: // value for 'trailer_embed_code'
 *      visibility_level_override: // value for 'visibility_level_override'
 *      contributorPositioningContext: // value for 'contributorPositioningContext'
 *      categoryPositioningContext: // value for 'categoryPositioningContext'
 *   },
 * });
 */
export function useUpdateCoverPageResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoverPageResourceMutation,
    UpdateCoverPageResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCoverPageResourceMutation,
    UpdateCoverPageResourceMutationVariables
  >(UpdateCoverPageResourceDocument, options)
}
export type UpdateCoverPageResourceMutationHookResult = ReturnType<
  typeof useUpdateCoverPageResourceMutation
>
export type UpdateCoverPageResourceMutationResult =
  Apollo.MutationResult<UpdateCoverPageResourceMutation>
export type UpdateCoverPageResourceMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoverPageResourceMutation,
  UpdateCoverPageResourceMutationVariables
>
export const PlacesQueryDocument = gql`
  query PlacesQuery {
    me {
      ...UserDisplay
      ...TeacherRegistrations
    }
    school {
      ...School
      ...ResourceStats
      ...RecentMembers
      ...MembershipStats
      ...MentorGroups
    }
    ...VisibleResources
    ...PrivateResources
  }
  ${UserDisplayFragmentDoc}
  ${TeacherRegistrationsFragmentDoc}
  ${SchoolFragmentDoc}
  ${ResourceStatsFragmentDoc}
  ${RecentMembersFragmentDoc}
  ${MembershipStatsFragmentDoc}
  ${MentorGroupsFragmentDoc}
  ${VisibleResourcesFragmentDoc}
  ${PrivateResourcesFragmentDoc}
`

/**
 * __usePlacesQueryQuery__
 *
 * To run a query within a React component, call `usePlacesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlacesQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlacesQueryQuery,
    PlacesQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PlacesQueryQuery, PlacesQueryQueryVariables>(
    PlacesQueryDocument,
    options
  )
}
export function usePlacesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlacesQueryQuery,
    PlacesQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PlacesQueryQuery, PlacesQueryQueryVariables>(
    PlacesQueryDocument,
    options
  )
}
export function usePlacesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PlacesQueryQuery,
        PlacesQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PlacesQueryQuery, PlacesQueryQueryVariables>(
    PlacesQueryDocument,
    options
  )
}
export type PlacesQueryQueryHookResult = ReturnType<typeof usePlacesQueryQuery>
export type PlacesQueryLazyQueryHookResult = ReturnType<
  typeof usePlacesQueryLazyQuery
>
export type PlacesQuerySuspenseQueryHookResult = ReturnType<
  typeof usePlacesQuerySuspenseQuery
>
export type PlacesQueryQueryResult = Apollo.QueryResult<
  PlacesQueryQuery,
  PlacesQueryQueryVariables
>
export const PathItemPublishedQueryDocument = gql`
  query PathItemPublishedQuery($sourceId: Int!, $cohortId: Int!) {
    pathItem(source_id: $sourceId, cohort_id: $cohortId) {
      id
      source_id
      last_published_dtime
    }
  }
`

/**
 * __usePathItemPublishedQueryQuery__
 *
 * To run a query within a React component, call `usePathItemPublishedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathItemPublishedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathItemPublishedQueryQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function usePathItemPublishedQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathItemPublishedQueryQuery,
    PathItemPublishedQueryQueryVariables
  > &
    (
      | { variables: PathItemPublishedQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathItemPublishedQueryQuery,
    PathItemPublishedQueryQueryVariables
  >(PathItemPublishedQueryDocument, options)
}
export function usePathItemPublishedQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathItemPublishedQueryQuery,
    PathItemPublishedQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathItemPublishedQueryQuery,
    PathItemPublishedQueryQueryVariables
  >(PathItemPublishedQueryDocument, options)
}
export function usePathItemPublishedQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathItemPublishedQueryQuery,
        PathItemPublishedQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathItemPublishedQueryQuery,
    PathItemPublishedQueryQueryVariables
  >(PathItemPublishedQueryDocument, options)
}
export type PathItemPublishedQueryQueryHookResult = ReturnType<
  typeof usePathItemPublishedQueryQuery
>
export type PathItemPublishedQueryLazyQueryHookResult = ReturnType<
  typeof usePathItemPublishedQueryLazyQuery
>
export type PathItemPublishedQuerySuspenseQueryHookResult = ReturnType<
  typeof usePathItemPublishedQuerySuspenseQuery
>
export type PathItemPublishedQueryQueryResult = Apollo.QueryResult<
  PathItemPublishedQueryQuery,
  PathItemPublishedQueryQueryVariables
>
export const CreateDiscussionLikeDocument = gql`
  mutation CreateDiscussionLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    createDiscussionLike(context: $context, discussion_id: $discussion_id) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type CreateDiscussionLikeMutationFn = Apollo.MutationFunction<
  CreateDiscussionLikeMutation,
  CreateDiscussionLikeMutationVariables
>

/**
 * __useCreateDiscussionLikeMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionLikeMutation, { data, loading, error }] = useCreateDiscussionLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useCreateDiscussionLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionLikeMutation,
    CreateDiscussionLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionLikeMutation,
    CreateDiscussionLikeMutationVariables
  >(CreateDiscussionLikeDocument, options)
}
export type CreateDiscussionLikeMutationHookResult = ReturnType<
  typeof useCreateDiscussionLikeMutation
>
export type CreateDiscussionLikeMutationResult =
  Apollo.MutationResult<CreateDiscussionLikeMutation>
export type CreateDiscussionLikeMutationOptions = Apollo.BaseMutationOptions<
  CreateDiscussionLikeMutation,
  CreateDiscussionLikeMutationVariables
>
export const CreateDiscussionDocument = gql`
  mutation CreateDiscussion(
    $context: DiscussionContextInput!
    $post: DiscussionPostInput!
    $initialResponse: DiscussionResponseInput
    $notify: Boolean = false
  ) {
    createDiscussion(
      context: $context
      post: $post
      initialResponse: $initialResponse
      notify: $notify
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type CreateDiscussionMutationFn = Apollo.MutationFunction<
  CreateDiscussionMutation,
  CreateDiscussionMutationVariables
>

/**
 * __useCreateDiscussionMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionMutation, { data, loading, error }] = useCreateDiscussionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      post: // value for 'post'
 *      initialResponse: // value for 'initialResponse'
 *      notify: // value for 'notify'
 *   },
 * });
 */
export function useCreateDiscussionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionMutation,
    CreateDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionMutation,
    CreateDiscussionMutationVariables
  >(CreateDiscussionDocument, options)
}
export type CreateDiscussionMutationHookResult = ReturnType<
  typeof useCreateDiscussionMutation
>
export type CreateDiscussionMutationResult =
  Apollo.MutationResult<CreateDiscussionMutation>
export type CreateDiscussionMutationOptions = Apollo.BaseMutationOptions<
  CreateDiscussionMutation,
  CreateDiscussionMutationVariables
>
export const CreateDiscussionResponseLikeDocument = gql`
  mutation CreateDiscussionResponseLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
    $response_id: Int!
  ) {
    createDiscussionResponseLike(
      context: $context
      discussion_id: $discussion_id
      response_id: $response_id
    ) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type CreateDiscussionResponseLikeMutationFn = Apollo.MutationFunction<
  CreateDiscussionResponseLikeMutation,
  CreateDiscussionResponseLikeMutationVariables
>

/**
 * __useCreateDiscussionResponseLikeMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionResponseLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionResponseLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionResponseLikeMutation, { data, loading, error }] = useCreateDiscussionResponseLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useCreateDiscussionResponseLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionResponseLikeMutation,
    CreateDiscussionResponseLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionResponseLikeMutation,
    CreateDiscussionResponseLikeMutationVariables
  >(CreateDiscussionResponseLikeDocument, options)
}
export type CreateDiscussionResponseLikeMutationHookResult = ReturnType<
  typeof useCreateDiscussionResponseLikeMutation
>
export type CreateDiscussionResponseLikeMutationResult =
  Apollo.MutationResult<CreateDiscussionResponseLikeMutation>
export type CreateDiscussionResponseLikeMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDiscussionResponseLikeMutation,
    CreateDiscussionResponseLikeMutationVariables
  >
export const CreateDiscussionResponseDocument = gql`
  mutation CreateDiscussionResponse(
    $context: DiscussionContextInput!
    $response: DiscussionResponseInput!
  ) {
    createDiscussionResponse(context: $context, response: $response) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type CreateDiscussionResponseMutationFn = Apollo.MutationFunction<
  CreateDiscussionResponseMutation,
  CreateDiscussionResponseMutationVariables
>

/**
 * __useCreateDiscussionResponseMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionResponseMutation, { data, loading, error }] = useCreateDiscussionResponseMutation({
 *   variables: {
 *      context: // value for 'context'
 *      response: // value for 'response'
 *   },
 * });
 */
export function useCreateDiscussionResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionResponseMutation,
    CreateDiscussionResponseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionResponseMutation,
    CreateDiscussionResponseMutationVariables
  >(CreateDiscussionResponseDocument, options)
}
export type CreateDiscussionResponseMutationHookResult = ReturnType<
  typeof useCreateDiscussionResponseMutation
>
export type CreateDiscussionResponseMutationResult =
  Apollo.MutationResult<CreateDiscussionResponseMutation>
export type CreateDiscussionResponseMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDiscussionResponseMutation,
    CreateDiscussionResponseMutationVariables
  >
export const CreateDiscussionSubscriptionDocument = gql`
  mutation CreateDiscussionSubscription(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    createDiscussionSubscription(
      context: $context
      discussion_id: $discussion_id
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type CreateDiscussionSubscriptionMutationFn = Apollo.MutationFunction<
  CreateDiscussionSubscriptionMutation,
  CreateDiscussionSubscriptionMutationVariables
>

/**
 * __useCreateDiscussionSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionSubscriptionMutation, { data, loading, error }] = useCreateDiscussionSubscriptionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useCreateDiscussionSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionSubscriptionMutation,
    CreateDiscussionSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionSubscriptionMutation,
    CreateDiscussionSubscriptionMutationVariables
  >(CreateDiscussionSubscriptionDocument, options)
}
export type CreateDiscussionSubscriptionMutationHookResult = ReturnType<
  typeof useCreateDiscussionSubscriptionMutation
>
export type CreateDiscussionSubscriptionMutationResult =
  Apollo.MutationResult<CreateDiscussionSubscriptionMutation>
export type CreateDiscussionSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDiscussionSubscriptionMutation,
    CreateDiscussionSubscriptionMutationVariables
  >
export const DeleteDiscussionLikeDocument = gql`
  mutation DeleteDiscussionLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    deleteDiscussionLike(context: $context, discussion_id: $discussion_id) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type DeleteDiscussionLikeMutationFn = Apollo.MutationFunction<
  DeleteDiscussionLikeMutation,
  DeleteDiscussionLikeMutationVariables
>

/**
 * __useDeleteDiscussionLikeMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionLikeMutation, { data, loading, error }] = useDeleteDiscussionLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useDeleteDiscussionLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionLikeMutation,
    DeleteDiscussionLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionLikeMutation,
    DeleteDiscussionLikeMutationVariables
  >(DeleteDiscussionLikeDocument, options)
}
export type DeleteDiscussionLikeMutationHookResult = ReturnType<
  typeof useDeleteDiscussionLikeMutation
>
export type DeleteDiscussionLikeMutationResult =
  Apollo.MutationResult<DeleteDiscussionLikeMutation>
export type DeleteDiscussionLikeMutationOptions = Apollo.BaseMutationOptions<
  DeleteDiscussionLikeMutation,
  DeleteDiscussionLikeMutationVariables
>
export const DeleteDiscussionDocument = gql`
  mutation DeleteDiscussion($context: DiscussionContextInput!, $id: Int!) {
    deleteDiscussion(context: $context, id: $id)
  }
`
export type DeleteDiscussionMutationFn = Apollo.MutationFunction<
  DeleteDiscussionMutation,
  DeleteDiscussionMutationVariables
>

/**
 * __useDeleteDiscussionMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionMutation, { data, loading, error }] = useDeleteDiscussionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscussionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionMutation,
    DeleteDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionMutation,
    DeleteDiscussionMutationVariables
  >(DeleteDiscussionDocument, options)
}
export type DeleteDiscussionMutationHookResult = ReturnType<
  typeof useDeleteDiscussionMutation
>
export type DeleteDiscussionMutationResult =
  Apollo.MutationResult<DeleteDiscussionMutation>
export type DeleteDiscussionMutationOptions = Apollo.BaseMutationOptions<
  DeleteDiscussionMutation,
  DeleteDiscussionMutationVariables
>
export const DeleteDiscussionResponseLikeDocument = gql`
  mutation DeleteDiscussionResponseLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
    $response_id: Int!
  ) {
    deleteDiscussionResponseLike(
      context: $context
      discussion_id: $discussion_id
      response_id: $response_id
    ) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type DeleteDiscussionResponseLikeMutationFn = Apollo.MutationFunction<
  DeleteDiscussionResponseLikeMutation,
  DeleteDiscussionResponseLikeMutationVariables
>

/**
 * __useDeleteDiscussionResponseLikeMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionResponseLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionResponseLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionResponseLikeMutation, { data, loading, error }] = useDeleteDiscussionResponseLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useDeleteDiscussionResponseLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionResponseLikeMutation,
    DeleteDiscussionResponseLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionResponseLikeMutation,
    DeleteDiscussionResponseLikeMutationVariables
  >(DeleteDiscussionResponseLikeDocument, options)
}
export type DeleteDiscussionResponseLikeMutationHookResult = ReturnType<
  typeof useDeleteDiscussionResponseLikeMutation
>
export type DeleteDiscussionResponseLikeMutationResult =
  Apollo.MutationResult<DeleteDiscussionResponseLikeMutation>
export type DeleteDiscussionResponseLikeMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteDiscussionResponseLikeMutation,
    DeleteDiscussionResponseLikeMutationVariables
  >
export const DeleteDiscussionResponseDocument = gql`
  mutation DeleteDiscussionResponse(
    $context: DiscussionContextInput!
    $discussion_id: Int!
    $response_id: Int!
  ) {
    deleteDiscussionResponse(
      context: $context
      discussion_id: $discussion_id
      response_id: $response_id
    ) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type DeleteDiscussionResponseMutationFn = Apollo.MutationFunction<
  DeleteDiscussionResponseMutation,
  DeleteDiscussionResponseMutationVariables
>

/**
 * __useDeleteDiscussionResponseMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionResponseMutation, { data, loading, error }] = useDeleteDiscussionResponseMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useDeleteDiscussionResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionResponseMutation,
    DeleteDiscussionResponseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionResponseMutation,
    DeleteDiscussionResponseMutationVariables
  >(DeleteDiscussionResponseDocument, options)
}
export type DeleteDiscussionResponseMutationHookResult = ReturnType<
  typeof useDeleteDiscussionResponseMutation
>
export type DeleteDiscussionResponseMutationResult =
  Apollo.MutationResult<DeleteDiscussionResponseMutation>
export type DeleteDiscussionResponseMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteDiscussionResponseMutation,
    DeleteDiscussionResponseMutationVariables
  >
export const DeleteDiscussionSubscriptionDocument = gql`
  mutation DeleteDiscussionSubscription(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    deleteDiscussionSubscription(
      context: $context
      discussion_id: $discussion_id
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type DeleteDiscussionSubscriptionMutationFn = Apollo.MutationFunction<
  DeleteDiscussionSubscriptionMutation,
  DeleteDiscussionSubscriptionMutationVariables
>

/**
 * __useDeleteDiscussionSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionSubscriptionMutation, { data, loading, error }] = useDeleteDiscussionSubscriptionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useDeleteDiscussionSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionSubscriptionMutation,
    DeleteDiscussionSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionSubscriptionMutation,
    DeleteDiscussionSubscriptionMutationVariables
  >(DeleteDiscussionSubscriptionDocument, options)
}
export type DeleteDiscussionSubscriptionMutationHookResult = ReturnType<
  typeof useDeleteDiscussionSubscriptionMutation
>
export type DeleteDiscussionSubscriptionMutationResult =
  Apollo.MutationResult<DeleteDiscussionSubscriptionMutation>
export type DeleteDiscussionSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteDiscussionSubscriptionMutation,
    DeleteDiscussionSubscriptionMutationVariables
  >
export const DiscussionParticipantsDocument = gql`
  query DiscussionParticipants(
    $first: Int = 3
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    discussionParticipants(
      first: $first
      context: $context
      discussion_id: $discussion_id
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...DiscussionParticipant
        }
      }
    }
  }
  ${DiscussionParticipantFragmentDoc}
`

/**
 * __useDiscussionParticipantsQuery__
 *
 * To run a query within a React component, call `useDiscussionParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionParticipantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useDiscussionParticipantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  > &
    (
      | { variables: DiscussionParticipantsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >(DiscussionParticipantsDocument, options)
}
export function useDiscussionParticipantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >(DiscussionParticipantsDocument, options)
}
export function useDiscussionParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionParticipantsQuery,
        DiscussionParticipantsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >(DiscussionParticipantsDocument, options)
}
export type DiscussionParticipantsQueryHookResult = ReturnType<
  typeof useDiscussionParticipantsQuery
>
export type DiscussionParticipantsLazyQueryHookResult = ReturnType<
  typeof useDiscussionParticipantsLazyQuery
>
export type DiscussionParticipantsSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionParticipantsSuspenseQuery
>
export type DiscussionParticipantsQueryResult = Apollo.QueryResult<
  DiscussionParticipantsQuery,
  DiscussionParticipantsQueryVariables
>
export const DiscussionPostDocument = gql`
  query DiscussionPost($id: Int, $context: DiscussionContextInput!) {
    discussion(id: $id, context: $context) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`

/**
 * __useDiscussionPostQuery__
 *
 * To run a query within a React component, call `useDiscussionPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionPostQuery({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDiscussionPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionPostQuery,
    DiscussionPostQueryVariables
  > &
    (
      | { variables: DiscussionPostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DiscussionPostQuery, DiscussionPostQueryVariables>(
    DiscussionPostDocument,
    options
  )
}
export function useDiscussionPostLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionPostQuery,
    DiscussionPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DiscussionPostQuery, DiscussionPostQueryVariables>(
    DiscussionPostDocument,
    options
  )
}
export function useDiscussionPostSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionPostQuery,
        DiscussionPostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DiscussionPostQuery,
    DiscussionPostQueryVariables
  >(DiscussionPostDocument, options)
}
export type DiscussionPostQueryHookResult = ReturnType<
  typeof useDiscussionPostQuery
>
export type DiscussionPostLazyQueryHookResult = ReturnType<
  typeof useDiscussionPostLazyQuery
>
export type DiscussionPostSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionPostSuspenseQuery
>
export type DiscussionPostQueryResult = Apollo.QueryResult<
  DiscussionPostQuery,
  DiscussionPostQueryVariables
>
export const DiscussionDocument = gql`
  query Discussion($id: Int, $context: DiscussionContextInput!) {
    discussion(id: $id, context: $context) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`

/**
 * __useDiscussionQuery__
 *
 * To run a query within a React component, call `useDiscussionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDiscussionQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionQuery,
    DiscussionQueryVariables
  > &
    (
      | { variables: DiscussionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DiscussionQuery, DiscussionQueryVariables>(
    DiscussionDocument,
    options
  )
}
export function useDiscussionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionQuery,
    DiscussionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DiscussionQuery, DiscussionQueryVariables>(
    DiscussionDocument,
    options
  )
}
export function useDiscussionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DiscussionQuery, DiscussionQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DiscussionQuery, DiscussionQueryVariables>(
    DiscussionDocument,
    options
  )
}
export type DiscussionQueryHookResult = ReturnType<typeof useDiscussionQuery>
export type DiscussionLazyQueryHookResult = ReturnType<
  typeof useDiscussionLazyQuery
>
export type DiscussionSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionSuspenseQuery
>
export type DiscussionQueryResult = Apollo.QueryResult<
  DiscussionQuery,
  DiscussionQueryVariables
>
export const DiscussionResponseDocument = gql`
  query DiscussionResponse(
    $id: Int
    $context: DiscussionContextInput!
    $response_id: Int!
  ) {
    discussion(id: $id, context: $context) {
      ...DiscussionPost
      response(response_id: $response_id) {
        ...DiscussionResponse
      }
    }
  }
  ${DiscussionPostFragmentDoc}
  ${DiscussionResponseFragmentDoc}
`

/**
 * __useDiscussionResponseQuery__
 *
 * To run a query within a React component, call `useDiscussionResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionResponseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useDiscussionResponseQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  > &
    (
      | { variables: DiscussionResponseQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >(DiscussionResponseDocument, options)
}
export function useDiscussionResponseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >(DiscussionResponseDocument, options)
}
export function useDiscussionResponseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionResponseQuery,
        DiscussionResponseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >(DiscussionResponseDocument, options)
}
export type DiscussionResponseQueryHookResult = ReturnType<
  typeof useDiscussionResponseQuery
>
export type DiscussionResponseLazyQueryHookResult = ReturnType<
  typeof useDiscussionResponseLazyQuery
>
export type DiscussionResponseSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionResponseSuspenseQuery
>
export type DiscussionResponseQueryResult = Apollo.QueryResult<
  DiscussionResponseQuery,
  DiscussionResponseQueryVariables
>
export const DiscussionsDocument = gql`
  query Discussions(
    $context: DiscussionContextInput!
    $type: DiscussionTypeInput
    $is_discussion_question: Boolean
    $total_responses: IntFilter
    $tagIdFilter: IntFilter
    $order_by: [String]
    $first: Int = 15
    $cursor: String
  ) {
    discussions(
      context: $context
      type: $type
      is_discussion_question: $is_discussion_question
      total_responses: $total_responses
      tag_id_filter: $tagIdFilter
      order_by: $order_by
      first: $first
      after: $cursor
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...DiscussionPost
        }
      }
    }
  }
  ${DiscussionPostFragmentDoc}
`

/**
 * __useDiscussionsQuery__
 *
 * To run a query within a React component, call `useDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      type: // value for 'type'
 *      is_discussion_question: // value for 'is_discussion_question'
 *      total_responses: // value for 'total_responses'
 *      tagIdFilter: // value for 'tagIdFilter'
 *      order_by: // value for 'order_by'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useDiscussionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionsQuery,
    DiscussionsQueryVariables
  > &
    (
      | { variables: DiscussionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DiscussionsQuery, DiscussionsQueryVariables>(
    DiscussionsDocument,
    options
  )
}
export function useDiscussionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionsQuery,
    DiscussionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DiscussionsQuery, DiscussionsQueryVariables>(
    DiscussionsDocument,
    options
  )
}
export function useDiscussionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionsQuery,
        DiscussionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DiscussionsQuery, DiscussionsQueryVariables>(
    DiscussionsDocument,
    options
  )
}
export type DiscussionsQueryHookResult = ReturnType<typeof useDiscussionsQuery>
export type DiscussionsLazyQueryHookResult = ReturnType<
  typeof useDiscussionsLazyQuery
>
export type DiscussionsSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionsSuspenseQuery
>
export type DiscussionsQueryResult = Apollo.QueryResult<
  DiscussionsQuery,
  DiscussionsQueryVariables
>
export const ResponsesDocument = gql`
  query Responses(
    $context: DiscussionResponseContextInput!
    $rootResponseId: IntFilter
    $archivedTime: DateFilter
    $orderBy: [ResponseOrderBy] = [CREATION]
    $cursor: String
    $first: Int = 25
  ) {
    responses(
      first: $first
      after: $cursor
      context: $context
      root_response_id: $rootResponseId
      archived_time: $archivedTime
      order_by: $orderBy
    ) {
      total
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...DiscussionResponse
        }
      }
    }
  }
  ${DiscussionResponseFragmentDoc}
`

/**
 * __useResponsesQuery__
 *
 * To run a query within a React component, call `useResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponsesQuery({
 *   variables: {
 *      context: // value for 'context'
 *      rootResponseId: // value for 'rootResponseId'
 *      archivedTime: // value for 'archivedTime'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useResponsesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResponsesQuery,
    ResponsesQueryVariables
  > &
    ({ variables: ResponsesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResponsesQuery, ResponsesQueryVariables>(
    ResponsesDocument,
    options
  )
}
export function useResponsesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResponsesQuery,
    ResponsesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ResponsesQuery, ResponsesQueryVariables>(
    ResponsesDocument,
    options
  )
}
export function useResponsesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResponsesQuery, ResponsesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ResponsesQuery, ResponsesQueryVariables>(
    ResponsesDocument,
    options
  )
}
export type ResponsesQueryHookResult = ReturnType<typeof useResponsesQuery>
export type ResponsesLazyQueryHookResult = ReturnType<
  typeof useResponsesLazyQuery
>
export type ResponsesSuspenseQueryHookResult = ReturnType<
  typeof useResponsesSuspenseQuery
>
export type ResponsesQueryResult = Apollo.QueryResult<
  ResponsesQuery,
  ResponsesQueryVariables
>
export const UpdateDiscussionDocument = gql`
  mutation UpdateDiscussion(
    $id: Int!
    $context: DiscussionContextInput!
    $post: DiscussionPostInput!
  ) {
    updateDiscussion(id: $id, context: $context, post: $post) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type UpdateDiscussionMutationFn = Apollo.MutationFunction<
  UpdateDiscussionMutation,
  UpdateDiscussionMutationVariables
>

/**
 * __useUpdateDiscussionMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionMutation, { data, loading, error }] = useUpdateDiscussionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *      post: // value for 'post'
 *   },
 * });
 */
export function useUpdateDiscussionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDiscussionMutation,
    UpdateDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateDiscussionMutation,
    UpdateDiscussionMutationVariables
  >(UpdateDiscussionDocument, options)
}
export type UpdateDiscussionMutationHookResult = ReturnType<
  typeof useUpdateDiscussionMutation
>
export type UpdateDiscussionMutationResult =
  Apollo.MutationResult<UpdateDiscussionMutation>
export type UpdateDiscussionMutationOptions = Apollo.BaseMutationOptions<
  UpdateDiscussionMutation,
  UpdateDiscussionMutationVariables
>
export const UpdateDiscussionResponseDocument = gql`
  mutation UpdateDiscussionResponse(
    $context: DiscussionContextInput!
    $response: DiscussionResponseInput!
    $response_id: Int!
  ) {
    updateDiscussionResponse(
      context: $context
      response: $response
      response_id: $response_id
    ) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type UpdateDiscussionResponseMutationFn = Apollo.MutationFunction<
  UpdateDiscussionResponseMutation,
  UpdateDiscussionResponseMutationVariables
>

/**
 * __useUpdateDiscussionResponseMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionResponseMutation, { data, loading, error }] = useUpdateDiscussionResponseMutation({
 *   variables: {
 *      context: // value for 'context'
 *      response: // value for 'response'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useUpdateDiscussionResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDiscussionResponseMutation,
    UpdateDiscussionResponseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateDiscussionResponseMutation,
    UpdateDiscussionResponseMutationVariables
  >(UpdateDiscussionResponseDocument, options)
}
export type UpdateDiscussionResponseMutationHookResult = ReturnType<
  typeof useUpdateDiscussionResponseMutation
>
export type UpdateDiscussionResponseMutationResult =
  Apollo.MutationResult<UpdateDiscussionResponseMutation>
export type UpdateDiscussionResponseMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateDiscussionResponseMutation,
    UpdateDiscussionResponseMutationVariables
  >
export const UpdateUserDiscussionHistoryDocument = gql`
  mutation UpdateUserDiscussionHistory(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    updateUserDiscussionHistory(
      context: $context
      discussion_id: $discussion_id
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type UpdateUserDiscussionHistoryMutationFn = Apollo.MutationFunction<
  UpdateUserDiscussionHistoryMutation,
  UpdateUserDiscussionHistoryMutationVariables
>

/**
 * __useUpdateUserDiscussionHistoryMutation__
 *
 * To run a mutation, you first call `useUpdateUserDiscussionHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDiscussionHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDiscussionHistoryMutation, { data, loading, error }] = useUpdateUserDiscussionHistoryMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useUpdateUserDiscussionHistoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserDiscussionHistoryMutation,
    UpdateUserDiscussionHistoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateUserDiscussionHistoryMutation,
    UpdateUserDiscussionHistoryMutationVariables
  >(UpdateUserDiscussionHistoryDocument, options)
}
export type UpdateUserDiscussionHistoryMutationHookResult = ReturnType<
  typeof useUpdateUserDiscussionHistoryMutation
>
export type UpdateUserDiscussionHistoryMutationResult =
  Apollo.MutationResult<UpdateUserDiscussionHistoryMutation>
export type UpdateUserDiscussionHistoryMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUserDiscussionHistoryMutation,
    UpdateUserDiscussionHistoryMutationVariables
  >
export const CommunityEnableDocument = gql`
  mutation CommunityEnable($cohortId: Int!, $communityEnabled: Boolean!) {
    updateGroupDiscussionEnabled(
      id: $cohortId
      discussion_enabled: $communityEnabled
    ) {
      id
      discussion_enabled
    }
  }
`
export type CommunityEnableMutationFn = Apollo.MutationFunction<
  CommunityEnableMutation,
  CommunityEnableMutationVariables
>

/**
 * __useCommunityEnableMutation__
 *
 * To run a mutation, you first call `useCommunityEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityEnableMutation, { data, loading, error }] = useCommunityEnableMutation({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      communityEnabled: // value for 'communityEnabled'
 *   },
 * });
 */
export function useCommunityEnableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommunityEnableMutation,
    CommunityEnableMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CommunityEnableMutation,
    CommunityEnableMutationVariables
  >(CommunityEnableDocument, options)
}
export type CommunityEnableMutationHookResult = ReturnType<
  typeof useCommunityEnableMutation
>
export type CommunityEnableMutationResult =
  Apollo.MutationResult<CommunityEnableMutation>
export type CommunityEnableMutationOptions = Apollo.BaseMutationOptions<
  CommunityEnableMutation,
  CommunityEnableMutationVariables
>
export const ContextualFeaturePermissionDocument = gql`
  query ContextualFeaturePermission(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $context: FeatureContextInput
  ) {
    contextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`

/**
 * __useContextualFeaturePermissionQuery__
 *
 * To run a query within a React component, call `useContextualFeaturePermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextualFeaturePermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextualFeaturePermissionQuery({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useContextualFeaturePermissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  > &
    (
      | { variables: ContextualFeaturePermissionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >(ContextualFeaturePermissionDocument, options)
}
export function useContextualFeaturePermissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >(ContextualFeaturePermissionDocument, options)
}
export function useContextualFeaturePermissionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContextualFeaturePermissionQuery,
        ContextualFeaturePermissionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >(ContextualFeaturePermissionDocument, options)
}
export type ContextualFeaturePermissionQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionQuery
>
export type ContextualFeaturePermissionLazyQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionLazyQuery
>
export type ContextualFeaturePermissionSuspenseQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionSuspenseQuery
>
export type ContextualFeaturePermissionQueryResult = Apollo.QueryResult<
  ContextualFeaturePermissionQuery,
  ContextualFeaturePermissionQueryVariables
>
export const ContextualFeaturePermissionsDocument = gql`
  query ContextualFeaturePermissions(
    $featureKeys: FeatureKeyFilter
    $featureAction: FeatureAction
    $context: FeatureContextInput
  ) {
    contextualFeaturePermissions(
      feature_action: $featureAction
      feature_keys: $featureKeys
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`

/**
 * __useContextualFeaturePermissionsQuery__
 *
 * To run a query within a React component, call `useContextualFeaturePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextualFeaturePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextualFeaturePermissionsQuery({
 *   variables: {
 *      featureKeys: // value for 'featureKeys'
 *      featureAction: // value for 'featureAction'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useContextualFeaturePermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >(ContextualFeaturePermissionsDocument, options)
}
export function useContextualFeaturePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >(ContextualFeaturePermissionsDocument, options)
}
export function useContextualFeaturePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContextualFeaturePermissionsQuery,
        ContextualFeaturePermissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >(ContextualFeaturePermissionsDocument, options)
}
export type ContextualFeaturePermissionsQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionsQuery
>
export type ContextualFeaturePermissionsLazyQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionsLazyQuery
>
export type ContextualFeaturePermissionsSuspenseQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionsSuspenseQuery
>
export type ContextualFeaturePermissionsQueryResult = Apollo.QueryResult<
  ContextualFeaturePermissionsQuery,
  ContextualFeaturePermissionsQueryVariables
>
export const CreateContextualFeaturePermissionDocument = gql`
  mutation CreateContextualFeaturePermission(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $permissionInContext: FeaturePermission!
    $context: FeatureContextInput
  ) {
    createContextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      permission_in_context: $permissionInContext
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`
export type CreateContextualFeaturePermissionMutationFn =
  Apollo.MutationFunction<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >

/**
 * __useCreateContextualFeaturePermissionMutation__
 *
 * To run a mutation, you first call `useCreateContextualFeaturePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContextualFeaturePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContextualFeaturePermissionMutation, { data, loading, error }] = useCreateContextualFeaturePermissionMutation({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      permissionInContext: // value for 'permissionInContext'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCreateContextualFeaturePermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >(CreateContextualFeaturePermissionDocument, options)
}
export type CreateContextualFeaturePermissionMutationHookResult = ReturnType<
  typeof useCreateContextualFeaturePermissionMutation
>
export type CreateContextualFeaturePermissionMutationResult =
  Apollo.MutationResult<CreateContextualFeaturePermissionMutation>
export type CreateContextualFeaturePermissionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >
export const DeleteContextualFeaturePermissionMutationDocument = gql`
  mutation DeleteContextualFeaturePermissionMutation(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $context: FeatureContextInput
  ) {
    deleteContextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      context: $context
    )
  }
`
export type DeleteContextualFeaturePermissionMutationMutationFn =
  Apollo.MutationFunction<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >

/**
 * __useDeleteContextualFeaturePermissionMutationMutation__
 *
 * To run a mutation, you first call `useDeleteContextualFeaturePermissionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContextualFeaturePermissionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContextualFeaturePermissionMutationMutation, { data, loading, error }] = useDeleteContextualFeaturePermissionMutationMutation({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDeleteContextualFeaturePermissionMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >(DeleteContextualFeaturePermissionMutationDocument, options)
}
export type DeleteContextualFeaturePermissionMutationMutationHookResult =
  ReturnType<typeof useDeleteContextualFeaturePermissionMutationMutation>
export type DeleteContextualFeaturePermissionMutationMutationResult =
  Apollo.MutationResult<DeleteContextualFeaturePermissionMutationMutation>
export type DeleteContextualFeaturePermissionMutationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >
export const FeatureContextDocument = gql`
  query FeatureContext($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      id
      name
      discussion_enabled
      resource {
        id
        discussion_enabled
      }
    }
  }
`

/**
 * __useFeatureContextQuery__
 *
 * To run a query within a React component, call `useFeatureContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureContextQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useFeatureContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeatureContextQuery,
    FeatureContextQueryVariables
  > &
    (
      | { variables: FeatureContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FeatureContextQuery, FeatureContextQueryVariables>(
    FeatureContextDocument,
    options
  )
}
export function useFeatureContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureContextQuery,
    FeatureContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FeatureContextQuery, FeatureContextQueryVariables>(
    FeatureContextDocument,
    options
  )
}
export function useFeatureContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeatureContextQuery,
        FeatureContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FeatureContextQuery,
    FeatureContextQueryVariables
  >(FeatureContextDocument, options)
}
export type FeatureContextQueryHookResult = ReturnType<
  typeof useFeatureContextQuery
>
export type FeatureContextLazyQueryHookResult = ReturnType<
  typeof useFeatureContextLazyQuery
>
export type FeatureContextSuspenseQueryHookResult = ReturnType<
  typeof useFeatureContextSuspenseQuery
>
export type FeatureContextQueryResult = Apollo.QueryResult<
  FeatureContextQuery,
  FeatureContextQueryVariables
>
export const SpaceAuthSettingsDocument = gql`
  query SpaceAuthSettings {
    space {
      id
      pathwright_login_enabled
      allow_public_signup
      always_prompt_for_password
      authMethods {
        id
        enabled
        meta {
          id
          key
          type
          url
          title
          icon
        }
      }
    }
  }
`

/**
 * __useSpaceAuthSettingsQuery__
 *
 * To run a query within a React component, call `useSpaceAuthSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceAuthSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceAuthSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpaceAuthSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >(SpaceAuthSettingsDocument, options)
}
export function useSpaceAuthSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >(SpaceAuthSettingsDocument, options)
}
export function useSpaceAuthSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceAuthSettingsQuery,
        SpaceAuthSettingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >(SpaceAuthSettingsDocument, options)
}
export type SpaceAuthSettingsQueryHookResult = ReturnType<
  typeof useSpaceAuthSettingsQuery
>
export type SpaceAuthSettingsLazyQueryHookResult = ReturnType<
  typeof useSpaceAuthSettingsLazyQuery
>
export type SpaceAuthSettingsSuspenseQueryHookResult = ReturnType<
  typeof useSpaceAuthSettingsSuspenseQuery
>
export type SpaceAuthSettingsQueryResult = Apollo.QueryResult<
  SpaceAuthSettingsQuery,
  SpaceAuthSettingsQueryVariables
>
export const UpdateContextualFeaturePermissionDocument = gql`
  mutation UpdateContextualFeaturePermission(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $permissionInContext: FeaturePermission!
    $context: FeatureContextInput
  ) {
    updateContextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      permission_in_context: $permissionInContext
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`
export type UpdateContextualFeaturePermissionMutationFn =
  Apollo.MutationFunction<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >

/**
 * __useUpdateContextualFeaturePermissionMutation__
 *
 * To run a mutation, you first call `useUpdateContextualFeaturePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContextualFeaturePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContextualFeaturePermissionMutation, { data, loading, error }] = useUpdateContextualFeaturePermissionMutation({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      permissionInContext: // value for 'permissionInContext'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useUpdateContextualFeaturePermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >(UpdateContextualFeaturePermissionDocument, options)
}
export type UpdateContextualFeaturePermissionMutationHookResult = ReturnType<
  typeof useUpdateContextualFeaturePermissionMutation
>
export type UpdateContextualFeaturePermissionMutationResult =
  Apollo.MutationResult<UpdateContextualFeaturePermissionMutation>
export type UpdateContextualFeaturePermissionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >
export const UpdateSpaceAuthSettingsDocument = gql`
  mutation UpdateSpaceAuthSettings(
    $pathwrightLoginEnabled: Boolean!
    $allowPublicSignup: Boolean!
    $alwaysPromptForPassword: Boolean!
  ) {
    updatePathwrightAuth(
      pathwright_login_enabled: $pathwrightLoginEnabled
      allow_public_signup: $allowPublicSignup
      always_prompt_for_password: $alwaysPromptForPassword
    ) {
      id
      pathwright_login_enabled
      allow_public_signup
      always_prompt_for_password
    }
  }
`
export type UpdateSpaceAuthSettingsMutationFn = Apollo.MutationFunction<
  UpdateSpaceAuthSettingsMutation,
  UpdateSpaceAuthSettingsMutationVariables
>

/**
 * __useUpdateSpaceAuthSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceAuthSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceAuthSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceAuthSettingsMutation, { data, loading, error }] = useUpdateSpaceAuthSettingsMutation({
 *   variables: {
 *      pathwrightLoginEnabled: // value for 'pathwrightLoginEnabled'
 *      allowPublicSignup: // value for 'allowPublicSignup'
 *      alwaysPromptForPassword: // value for 'alwaysPromptForPassword'
 *   },
 * });
 */
export function useUpdateSpaceAuthSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSpaceAuthSettingsMutation,
    UpdateSpaceAuthSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSpaceAuthSettingsMutation,
    UpdateSpaceAuthSettingsMutationVariables
  >(UpdateSpaceAuthSettingsDocument, options)
}
export type UpdateSpaceAuthSettingsMutationHookResult = ReturnType<
  typeof useUpdateSpaceAuthSettingsMutation
>
export type UpdateSpaceAuthSettingsMutationResult =
  Apollo.MutationResult<UpdateSpaceAuthSettingsMutation>
export type UpdateSpaceAuthSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateSpaceAuthSettingsMutation,
  UpdateSpaceAuthSettingsMutationVariables
>
export const CreateGroupDocument = gql`
  mutation CreateGroup(
    $base_resource_id: Int!
    $parent_offering_id: Int
    $visibility: Int!
    $name: String!
    $role: RegistrationRoleEnum
  ) {
    createGroup(
      base_resource_id: $base_resource_id
      parent_offering_id: $parent_offering_id
      visibility: $visibility
      name: $name
      role: $role
    ) {
      ...Group
      resource {
        ...Resource
        blurred_background: background_image(blur: 500, width: 250, height: 250)
      }
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      base_resource_id: // value for 'base_resource_id'
 *      parent_offering_id: // value for 'parent_offering_id'
 *      visibility: // value for 'visibility'
 *      name: // value for 'name'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options
  )
}
export type CreateGroupMutationHookResult = ReturnType<
  typeof useCreateGroupMutation
>
export type CreateGroupMutationResult =
  Apollo.MutationResult<CreateGroupMutation>
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>
export const GroupDocument = gql`
  query Group($id: Int!) {
    group(id: $id) {
      ...GroupContext
    }
  }
  ${GroupContextFragmentDoc}
`

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> &
    ({ variables: GroupQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options
  )
}
export function useGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options
  )
}
export function useGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options
  )
}
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>
export type GroupSuspenseQueryHookResult = ReturnType<
  typeof useGroupSuspenseQuery
>
export type GroupQueryResult = Apollo.QueryResult<
  GroupQuery,
  GroupQueryVariables
>
export const GroupQueryResourcePathDocument = gql`
  query GroupQueryResourcePath($id: Int!) {
    group(id: $id) {
      ...Group
      resource {
        ...Resource
      }
      path(type: source) {
        id
        points {
          path_id
          has_points
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`

/**
 * __useGroupQueryResourcePathQuery__
 *
 * To run a query within a React component, call `useGroupQueryResourcePathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQueryResourcePathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQueryResourcePathQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupQueryResourcePathQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupQueryResourcePathQuery,
    GroupQueryResourcePathQueryVariables
  > &
    (
      | { variables: GroupQueryResourcePathQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GroupQueryResourcePathQuery,
    GroupQueryResourcePathQueryVariables
  >(GroupQueryResourcePathDocument, options)
}
export function useGroupQueryResourcePathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupQueryResourcePathQuery,
    GroupQueryResourcePathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GroupQueryResourcePathQuery,
    GroupQueryResourcePathQueryVariables
  >(GroupQueryResourcePathDocument, options)
}
export function useGroupQueryResourcePathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupQueryResourcePathQuery,
        GroupQueryResourcePathQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GroupQueryResourcePathQuery,
    GroupQueryResourcePathQueryVariables
  >(GroupQueryResourcePathDocument, options)
}
export type GroupQueryResourcePathQueryHookResult = ReturnType<
  typeof useGroupQueryResourcePathQuery
>
export type GroupQueryResourcePathLazyQueryHookResult = ReturnType<
  typeof useGroupQueryResourcePathLazyQuery
>
export type GroupQueryResourcePathSuspenseQueryHookResult = ReturnType<
  typeof useGroupQueryResourcePathSuspenseQuery
>
export type GroupQueryResourcePathQueryResult = Apollo.QueryResult<
  GroupQueryResourcePathQuery,
  GroupQueryResourcePathQueryVariables
>
export const GroupsQueryDocument = gql`
  query GroupsQuery(
    $first: Int!
    $cursor: String
    $resource_id: Int!
    $include_curriculum: Boolean = false
    $parentGroupIdFilter: IDFilter
    $search: String
  ) {
    groups(
      first: $first
      after: $cursor
      resource_id: $resource_id
      include_curriculum: $include_curriculum
      search: $search
      parent_group_id: $parentGroupIdFilter
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Group
        }
      }
    }
  }
  ${GroupFragmentDoc}
`

/**
 * __useGroupsQueryQuery__
 *
 * To run a query within a React component, call `useGroupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQueryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      resource_id: // value for 'resource_id'
 *      include_curriculum: // value for 'include_curriculum'
 *      parentGroupIdFilter: // value for 'parentGroupIdFilter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGroupsQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupsQueryQuery,
    GroupsQueryQueryVariables
  > &
    (
      | { variables: GroupsQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GroupsQueryQuery, GroupsQueryQueryVariables>(
    GroupsQueryDocument,
    options
  )
}
export function useGroupsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupsQueryQuery,
    GroupsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GroupsQueryQuery, GroupsQueryQueryVariables>(
    GroupsQueryDocument,
    options
  )
}
export function useGroupsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupsQueryQuery,
        GroupsQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GroupsQueryQuery, GroupsQueryQueryVariables>(
    GroupsQueryDocument,
    options
  )
}
export type GroupsQueryQueryHookResult = ReturnType<typeof useGroupsQueryQuery>
export type GroupsQueryLazyQueryHookResult = ReturnType<
  typeof useGroupsQueryLazyQuery
>
export type GroupsQuerySuspenseQueryHookResult = ReturnType<
  typeof useGroupsQuerySuspenseQuery
>
export type GroupsQueryQueryResult = Apollo.QueryResult<
  GroupsQueryQuery,
  GroupsQueryQueryVariables
>
export const CreateResourceDocument = gql`
  mutation CreateResource(
    $name: String!
    $cover_image: String!
    $resource_type: ResourceType
    $group_name: String
    $group_role: RegistrationRoleEnum
  ) {
    createResource(
      name: $name
      cover_image: $cover_image
      resource_type: $resource_type
      group_name: $group_name
      group_role: $group_role
    ) {
      ...CreatedResource
    }
  }
  ${CreatedResourceFragmentDoc}
`
export type CreateResourceMutationFn = Apollo.MutationFunction<
  CreateResourceMutation,
  CreateResourceMutationVariables
>

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      cover_image: // value for 'cover_image'
 *      resource_type: // value for 'resource_type'
 *      group_name: // value for 'group_name'
 *      group_role: // value for 'group_role'
 *   },
 * });
 */
export function useCreateResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateResourceMutation,
    CreateResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateResourceMutation,
    CreateResourceMutationVariables
  >(CreateResourceDocument, options)
}
export type CreateResourceMutationHookResult = ReturnType<
  typeof useCreateResourceMutation
>
export type CreateResourceMutationResult =
  Apollo.MutationResult<CreateResourceMutation>
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<
  CreateResourceMutation,
  CreateResourceMutationVariables
>
export const ManageMentorGroupMembershipsDocument = gql`
  query ManageMentorGroupMemberships {
    me {
      id
      mentorGroupMemberships(
        first: 1
        role: { gte: moderator }
        mentor_group_seat_limit_filter: { neq: 1 }
      ) {
        total
        edges {
          node {
            id
            role
            group_id
          }
        }
      }
    }
  }
`

/**
 * __useManageMentorGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useManageMentorGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageMentorGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageMentorGroupMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManageMentorGroupMembershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >(ManageMentorGroupMembershipsDocument, options)
}
export function useManageMentorGroupMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >(ManageMentorGroupMembershipsDocument, options)
}
export function useManageMentorGroupMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManageMentorGroupMembershipsQuery,
        ManageMentorGroupMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >(ManageMentorGroupMembershipsDocument, options)
}
export type ManageMentorGroupMembershipsQueryHookResult = ReturnType<
  typeof useManageMentorGroupMembershipsQuery
>
export type ManageMentorGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useManageMentorGroupMembershipsLazyQuery
>
export type ManageMentorGroupMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useManageMentorGroupMembershipsSuspenseQuery
>
export type ManageMentorGroupMembershipsQueryResult = Apollo.QueryResult<
  ManageMentorGroupMembershipsQuery,
  ManageMentorGroupMembershipsQueryVariables
>
export const UserRegistrationsDocument = gql`
  query UserRegistrations($first: Int = 1042, $cursor: String) {
    me {
      ...User
      registrations(
        first: $first
        after: $cursor
        role_filter: { lte: student }
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Registration
            resource {
              ...Resource
            }
            group {
              ...Group
            }
            path {
              id
              progress
              completion_date
            }
            school_sub_used {
              id
              subscription {
                id
                is_delinquent
                canceled_dtime
              }
            }
            group_sub_used {
              id
            }
            group_sub_community_membership {
              id
              access_revoked_time
            }
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${RegistrationFragmentDoc}
  ${ResourceFragmentDoc}
  ${GroupFragmentDoc}
`

/**
 * __useUserRegistrationsQuery__
 *
 * To run a query within a React component, call `useUserRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRegistrationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useUserRegistrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >(UserRegistrationsDocument, options)
}
export function useUserRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >(UserRegistrationsDocument, options)
}
export function useUserRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserRegistrationsQuery,
        UserRegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >(UserRegistrationsDocument, options)
}
export type UserRegistrationsQueryHookResult = ReturnType<
  typeof useUserRegistrationsQuery
>
export type UserRegistrationsLazyQueryHookResult = ReturnType<
  typeof useUserRegistrationsLazyQuery
>
export type UserRegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useUserRegistrationsSuspenseQuery
>
export type UserRegistrationsQueryResult = Apollo.QueryResult<
  UserRegistrationsQuery,
  UserRegistrationsQueryVariables
>
export const RandomResourceImageDocument = gql`
  query RandomResourceImage($themeType: ThemeType) {
    resourceImage(theme_type: $themeType)
  }
`

/**
 * __useRandomResourceImageQuery__
 *
 * To run a query within a React component, call `useRandomResourceImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomResourceImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRandomResourceImageQuery({
 *   variables: {
 *      themeType: // value for 'themeType'
 *   },
 * });
 */
export function useRandomResourceImageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >(RandomResourceImageDocument, options)
}
export function useRandomResourceImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >(RandomResourceImageDocument, options)
}
export function useRandomResourceImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RandomResourceImageQuery,
        RandomResourceImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >(RandomResourceImageDocument, options)
}
export type RandomResourceImageQueryHookResult = ReturnType<
  typeof useRandomResourceImageQuery
>
export type RandomResourceImageLazyQueryHookResult = ReturnType<
  typeof useRandomResourceImageLazyQuery
>
export type RandomResourceImageSuspenseQueryHookResult = ReturnType<
  typeof useRandomResourceImageSuspenseQuery
>
export type RandomResourceImageQueryResult = Apollo.QueryResult<
  RandomResourceImageQuery,
  RandomResourceImageQueryVariables
>
export const FeedbackReviewersDocument = gql`
  query FeedbackReviewers($completionId: Int!) {
    feedbackReviewers(completion_id: $completionId) {
      id
      reviewers
    }
  }
`

/**
 * __useFeedbackReviewersQuery__
 *
 * To run a query within a React component, call `useFeedbackReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackReviewersQuery({
 *   variables: {
 *      completionId: // value for 'completionId'
 *   },
 * });
 */
export function useFeedbackReviewersQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  > &
    (
      | { variables: FeedbackReviewersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >(FeedbackReviewersDocument, options)
}
export function useFeedbackReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >(FeedbackReviewersDocument, options)
}
export function useFeedbackReviewersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedbackReviewersQuery,
        FeedbackReviewersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >(FeedbackReviewersDocument, options)
}
export type FeedbackReviewersQueryHookResult = ReturnType<
  typeof useFeedbackReviewersQuery
>
export type FeedbackReviewersLazyQueryHookResult = ReturnType<
  typeof useFeedbackReviewersLazyQuery
>
export type FeedbackReviewersSuspenseQueryHookResult = ReturnType<
  typeof useFeedbackReviewersSuspenseQuery
>
export type FeedbackReviewersQueryResult = Apollo.QueryResult<
  FeedbackReviewersQuery,
  FeedbackReviewersQueryVariables
>
export const InboxContextDocument = gql`
  query InboxContext($cohort_id: Int, $group_id: Int) {
    inboxContext(cohort_id: $cohort_id, group_id: $group_id) {
      id
      cohort {
        id
        name
        resource {
          id
          name
        }
      }
      group {
        id
        name
      }
    }
  }
`

/**
 * __useInboxContextQuery__
 *
 * To run a query within a React component, call `useInboxContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxContextQuery({
 *   variables: {
 *      cohort_id: // value for 'cohort_id'
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useInboxContextQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxContextQuery,
    InboxContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InboxContextQuery, InboxContextQueryVariables>(
    InboxContextDocument,
    options
  )
}
export function useInboxContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxContextQuery,
    InboxContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InboxContextQuery, InboxContextQueryVariables>(
    InboxContextDocument,
    options
  )
}
export function useInboxContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxContextQuery,
        InboxContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<InboxContextQuery, InboxContextQueryVariables>(
    InboxContextDocument,
    options
  )
}
export type InboxContextQueryHookResult = ReturnType<
  typeof useInboxContextQuery
>
export type InboxContextLazyQueryHookResult = ReturnType<
  typeof useInboxContextLazyQuery
>
export type InboxContextSuspenseQueryHookResult = ReturnType<
  typeof useInboxContextSuspenseQuery
>
export type InboxContextQueryResult = Apollo.QueryResult<
  InboxContextQuery,
  InboxContextQueryVariables
>
export const InboxGroupConnectionsDocument = gql`
  query InboxGroupConnections($search: String, $cursor: String) {
    inboxGroupConnections(first: 10, after: $cursor, search: $search) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...InboxGroupConnection
        }
      }
    }
  }
  ${InboxGroupConnectionFragmentDoc}
`

/**
 * __useInboxGroupConnectionsQuery__
 *
 * To run a query within a React component, call `useInboxGroupConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxGroupConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxGroupConnectionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useInboxGroupConnectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >(InboxGroupConnectionsDocument, options)
}
export function useInboxGroupConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >(InboxGroupConnectionsDocument, options)
}
export function useInboxGroupConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxGroupConnectionsQuery,
        InboxGroupConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >(InboxGroupConnectionsDocument, options)
}
export type InboxGroupConnectionsQueryHookResult = ReturnType<
  typeof useInboxGroupConnectionsQuery
>
export type InboxGroupConnectionsLazyQueryHookResult = ReturnType<
  typeof useInboxGroupConnectionsLazyQuery
>
export type InboxGroupConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useInboxGroupConnectionsSuspenseQuery
>
export type InboxGroupConnectionsQueryResult = Apollo.QueryResult<
  InboxGroupConnectionsQuery,
  InboxGroupConnectionsQueryVariables
>
export const InboxPendingReviewCountDocument = gql`
  query InboxPendingReviewCount(
    $targetId: Int!
    $targetType: InboxPendingReviewTarget!
  ) {
    inboxPendingReview(target_id: $targetId, target_type: $targetType) {
      id
      count
    }
  }
`

/**
 * __useInboxPendingReviewCountQuery__
 *
 * To run a query within a React component, call `useInboxPendingReviewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPendingReviewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPendingReviewCountQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useInboxPendingReviewCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  > &
    (
      | { variables: InboxPendingReviewCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >(InboxPendingReviewCountDocument, options)
}
export function useInboxPendingReviewCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >(InboxPendingReviewCountDocument, options)
}
export function useInboxPendingReviewCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxPendingReviewCountQuery,
        InboxPendingReviewCountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >(InboxPendingReviewCountDocument, options)
}
export type InboxPendingReviewCountQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountQuery
>
export type InboxPendingReviewCountLazyQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountLazyQuery
>
export type InboxPendingReviewCountSuspenseQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountSuspenseQuery
>
export type InboxPendingReviewCountQueryResult = Apollo.QueryResult<
  InboxPendingReviewCountQuery,
  InboxPendingReviewCountQueryVariables
>
export const InboxPeopleCompletionCountsDocument = gql`
  query InboxPeopleCompletionCounts(
    $targetType: InboxPeopleCompletionCountsTarget!
    $targetId: Int!
    $first: Int!
    $cursor: String
    $isComplete: Boolean
    $needsReview: Boolean
    $stepSourceId: Int
    $parentSourceId: Int
    $archivedDateFilter: [DateFilter]
  ) {
    inboxPeopleCompletionCounts(
      target_type: $targetType
      target_id: $targetId
      first: $first
      after: $cursor
      is_complete: $isComplete
      needs_review: $needsReview
      step_source_id: $stepSourceId
      parent_source_id: $parentSourceId
      archivedDateFilter: $archivedDateFilter
    ) {
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...InboxPeopleCompletionCounts
        }
      }
    }
  }
  ${InboxPeopleCompletionCountsFragmentDoc}
`

/**
 * __useInboxPeopleCompletionCountsQuery__
 *
 * To run a query within a React component, call `useInboxPeopleCompletionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPeopleCompletionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPeopleCompletionCountsQuery({
 *   variables: {
 *      targetType: // value for 'targetType'
 *      targetId: // value for 'targetId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      isComplete: // value for 'isComplete'
 *      needsReview: // value for 'needsReview'
 *      stepSourceId: // value for 'stepSourceId'
 *      parentSourceId: // value for 'parentSourceId'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *   },
 * });
 */
export function useInboxPeopleCompletionCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  > &
    (
      | { variables: InboxPeopleCompletionCountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >(InboxPeopleCompletionCountsDocument, options)
}
export function useInboxPeopleCompletionCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >(InboxPeopleCompletionCountsDocument, options)
}
export function useInboxPeopleCompletionCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxPeopleCompletionCountsQuery,
        InboxPeopleCompletionCountsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >(InboxPeopleCompletionCountsDocument, options)
}
export type InboxPeopleCompletionCountsQueryHookResult = ReturnType<
  typeof useInboxPeopleCompletionCountsQuery
>
export type InboxPeopleCompletionCountsLazyQueryHookResult = ReturnType<
  typeof useInboxPeopleCompletionCountsLazyQuery
>
export type InboxPeopleCompletionCountsSuspenseQueryHookResult = ReturnType<
  typeof useInboxPeopleCompletionCountsSuspenseQuery
>
export type InboxPeopleCompletionCountsQueryResult = Apollo.QueryResult<
  InboxPeopleCompletionCountsQuery,
  InboxPeopleCompletionCountsQueryVariables
>
export const InboxReviewersDocument = gql`
  query InboxReviewers($pathId: Int!) {
    inboxReviewers(first: 50, path_id: $pathId) {
      edges {
        node {
          ...InboxReviewer
        }
      }
    }
  }
  ${InboxReviewerFragmentDoc}
`

/**
 * __useInboxReviewersQuery__
 *
 * To run a query within a React component, call `useInboxReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxReviewersQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useInboxReviewersQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxReviewersQuery,
    InboxReviewersQueryVariables
  > &
    (
      | { variables: InboxReviewersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InboxReviewersQuery, InboxReviewersQueryVariables>(
    InboxReviewersDocument,
    options
  )
}
export function useInboxReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxReviewersQuery,
    InboxReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InboxReviewersQuery, InboxReviewersQueryVariables>(
    InboxReviewersDocument,
    options
  )
}
export function useInboxReviewersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxReviewersQuery,
        InboxReviewersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxReviewersQuery,
    InboxReviewersQueryVariables
  >(InboxReviewersDocument, options)
}
export type InboxReviewersQueryHookResult = ReturnType<
  typeof useInboxReviewersQuery
>
export type InboxReviewersLazyQueryHookResult = ReturnType<
  typeof useInboxReviewersLazyQuery
>
export type InboxReviewersSuspenseQueryHookResult = ReturnType<
  typeof useInboxReviewersSuspenseQuery
>
export type InboxReviewersQueryResult = Apollo.QueryResult<
  InboxReviewersQuery,
  InboxReviewersQueryVariables
>
export const UserCanReviewForUserDocument = gql`
  query UserCanReviewForUser($forUserId: Int!) {
    canReview(for_user_id: $forUserId)
  }
`

/**
 * __useUserCanReviewForUserQuery__
 *
 * To run a query within a React component, call `useUserCanReviewForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCanReviewForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCanReviewForUserQuery({
 *   variables: {
 *      forUserId: // value for 'forUserId'
 *   },
 * });
 */
export function useUserCanReviewForUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserCanReviewForUserQuery,
    UserCanReviewForUserQueryVariables
  > &
    (
      | { variables: UserCanReviewForUserQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserCanReviewForUserQuery,
    UserCanReviewForUserQueryVariables
  >(UserCanReviewForUserDocument, options)
}
export function useUserCanReviewForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCanReviewForUserQuery,
    UserCanReviewForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserCanReviewForUserQuery,
    UserCanReviewForUserQueryVariables
  >(UserCanReviewForUserDocument, options)
}
export function useUserCanReviewForUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserCanReviewForUserQuery,
        UserCanReviewForUserQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserCanReviewForUserQuery,
    UserCanReviewForUserQueryVariables
  >(UserCanReviewForUserDocument, options)
}
export type UserCanReviewForUserQueryHookResult = ReturnType<
  typeof useUserCanReviewForUserQuery
>
export type UserCanReviewForUserLazyQueryHookResult = ReturnType<
  typeof useUserCanReviewForUserLazyQuery
>
export type UserCanReviewForUserSuspenseQueryHookResult = ReturnType<
  typeof useUserCanReviewForUserSuspenseQuery
>
export type UserCanReviewForUserQueryResult = Apollo.QueryResult<
  UserCanReviewForUserQuery,
  UserCanReviewForUserQueryVariables
>
export const IntercomIntegrationQueryDocument = gql`
  query IntercomIntegrationQuery {
    integrations {
      intercom {
        school_app_id
        school_secret_key
        school_access_token
      }
    }
  }
`

/**
 * __useIntercomIntegrationQueryQuery__
 *
 * To run a query within a React component, call `useIntercomIntegrationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntercomIntegrationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntercomIntegrationQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntercomIntegrationQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IntercomIntegrationQueryQuery,
    IntercomIntegrationQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IntercomIntegrationQueryQuery,
    IntercomIntegrationQueryQueryVariables
  >(IntercomIntegrationQueryDocument, options)
}
export function useIntercomIntegrationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IntercomIntegrationQueryQuery,
    IntercomIntegrationQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IntercomIntegrationQueryQuery,
    IntercomIntegrationQueryQueryVariables
  >(IntercomIntegrationQueryDocument, options)
}
export function useIntercomIntegrationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IntercomIntegrationQueryQuery,
        IntercomIntegrationQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IntercomIntegrationQueryQuery,
    IntercomIntegrationQueryQueryVariables
  >(IntercomIntegrationQueryDocument, options)
}
export type IntercomIntegrationQueryQueryHookResult = ReturnType<
  typeof useIntercomIntegrationQueryQuery
>
export type IntercomIntegrationQueryLazyQueryHookResult = ReturnType<
  typeof useIntercomIntegrationQueryLazyQuery
>
export type IntercomIntegrationQuerySuspenseQueryHookResult = ReturnType<
  typeof useIntercomIntegrationQuerySuspenseQuery
>
export type IntercomIntegrationQueryQueryResult = Apollo.QueryResult<
  IntercomIntegrationQueryQuery,
  IntercomIntegrationQueryQueryVariables
>
export const AcceptCommunityGroupInvitationDocument = gql`
  mutation AcceptCommunityGroupInvitation($token: String!) {
    acceptCommunityGroupInvitation(token: $token)
  }
`
export type AcceptCommunityGroupInvitationMutationFn = Apollo.MutationFunction<
  AcceptCommunityGroupInvitationMutation,
  AcceptCommunityGroupInvitationMutationVariables
>

/**
 * __useAcceptCommunityGroupInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptCommunityGroupInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCommunityGroupInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCommunityGroupInvitationMutation, { data, loading, error }] = useAcceptCommunityGroupInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptCommunityGroupInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptCommunityGroupInvitationMutation,
    AcceptCommunityGroupInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AcceptCommunityGroupInvitationMutation,
    AcceptCommunityGroupInvitationMutationVariables
  >(AcceptCommunityGroupInvitationDocument, options)
}
export type AcceptCommunityGroupInvitationMutationHookResult = ReturnType<
  typeof useAcceptCommunityGroupInvitationMutation
>
export type AcceptCommunityGroupInvitationMutationResult =
  Apollo.MutationResult<AcceptCommunityGroupInvitationMutation>
export type AcceptCommunityGroupInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptCommunityGroupInvitationMutation,
    AcceptCommunityGroupInvitationMutationVariables
  >
export const CreateInvitationsDocument = gql`
  mutation CreateInvitations(
    $context: InvitationContext
    $type: InvitationType
    $invite_emails: [String]!
    $invite_to_community_group_role: MentorGroupMembershipRole!
  ) {
    createInvitations(
      context: $context
      type: $type
      invite_emails: $invite_emails
      invite_to_community_group_role: $invite_to_community_group_role
    ) {
      invitations_attempted_count
      invitations_sent_count
      unsuccessful_invitations
    }
  }
`
export type CreateInvitationsMutationFn = Apollo.MutationFunction<
  CreateInvitationsMutation,
  CreateInvitationsMutationVariables
>

/**
 * __useCreateInvitationsMutation__
 *
 * To run a mutation, you first call `useCreateInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationsMutation, { data, loading, error }] = useCreateInvitationsMutation({
 *   variables: {
 *      context: // value for 'context'
 *      type: // value for 'type'
 *      invite_emails: // value for 'invite_emails'
 *      invite_to_community_group_role: // value for 'invite_to_community_group_role'
 *   },
 * });
 */
export function useCreateInvitationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInvitationsMutation,
    CreateInvitationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateInvitationsMutation,
    CreateInvitationsMutationVariables
  >(CreateInvitationsDocument, options)
}
export type CreateInvitationsMutationHookResult = ReturnType<
  typeof useCreateInvitationsMutation
>
export type CreateInvitationsMutationResult =
  Apollo.MutationResult<CreateInvitationsMutation>
export type CreateInvitationsMutationOptions = Apollo.BaseMutationOptions<
  CreateInvitationsMutation,
  CreateInvitationsMutationVariables
>
export const DeleteInvitationDocument = gql`
  mutation DeleteInvitation($deleteInvitationId: Int!) {
    deleteInvitation(id: $deleteInvitationId)
  }
`
export type DeleteInvitationMutationFn = Apollo.MutationFunction<
  DeleteInvitationMutation,
  DeleteInvitationMutationVariables
>

/**
 * __useDeleteInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationMutation, { data, loading, error }] = useDeleteInvitationMutation({
 *   variables: {
 *      deleteInvitationId: // value for 'deleteInvitationId'
 *   },
 * });
 */
export function useDeleteInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInvitationMutation,
    DeleteInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteInvitationMutation,
    DeleteInvitationMutationVariables
  >(DeleteInvitationDocument, options)
}
export type DeleteInvitationMutationHookResult = ReturnType<
  typeof useDeleteInvitationMutation
>
export type DeleteInvitationMutationResult =
  Apollo.MutationResult<DeleteInvitationMutation>
export type DeleteInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteInvitationMutation,
  DeleteInvitationMutationVariables
>
export const InvitationsDocument = gql`
  query Invitations(
    $first: Int!
    $cursor: String
    $context: InvitationContext
    $deliveryStatus: EmailDeliveryStatus
    $status: InvitationStatus
    $orderBy: [String]
  ) {
    invitations(
      first: $first
      after: $cursor
      context: $context
      delivery_status: $deliveryStatus
      status: $status
      order_by: $orderBy
    ) {
      edges {
        node {
          ...Invitation
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${InvitationFragmentDoc}
`

/**
 * __useInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      context: // value for 'context'
 *      deliveryStatus: // value for 'deliveryStatus'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvitationsQuery,
    InvitationsQueryVariables
  > &
    (
      | { variables: InvitationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options
  )
}
export function useInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitationsQuery,
    InvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options
  )
}
export function useInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationsQuery,
        InvitationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options
  )
}
export type InvitationsQueryHookResult = ReturnType<typeof useInvitationsQuery>
export type InvitationsLazyQueryHookResult = ReturnType<
  typeof useInvitationsLazyQuery
>
export type InvitationsSuspenseQueryHookResult = ReturnType<
  typeof useInvitationsSuspenseQuery
>
export type InvitationsQueryResult = Apollo.QueryResult<
  InvitationsQuery,
  InvitationsQueryVariables
>
export const ResendInvitationDocument = gql`
  mutation ResendInvitation($resendInvitationId: Int!) {
    resendInvitation(id: $resendInvitationId) {
      ...Invitation
    }
  }
  ${InvitationFragmentDoc}
`
export type ResendInvitationMutationFn = Apollo.MutationFunction<
  ResendInvitationMutation,
  ResendInvitationMutationVariables
>

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      resendInvitationId: // value for 'resendInvitationId'
 *   },
 * });
 */
export function useResendInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInvitationMutation,
    ResendInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResendInvitationMutation,
    ResendInvitationMutationVariables
  >(ResendInvitationDocument, options)
}
export type ResendInvitationMutationHookResult = ReturnType<
  typeof useResendInvitationMutation
>
export type ResendInvitationMutationResult =
  Apollo.MutationResult<ResendInvitationMutation>
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendInvitationMutation,
  ResendInvitationMutationVariables
>
export const FeatureLockDocument = gql`
  query FeatureLock($default_billing_plan_set: Boolean = true) {
    account {
      id
      is_activated
      is_activated_via_override
      is_on_legacy_plan
      billing_subscription {
        id
        plan {
          ...FeatureLockSchoolBillingPlan
        }
      }
      billing_plan_set(default: $default_billing_plan_set) {
        id
        plans {
          ...FeatureLockSchoolBillingPlan
        }
      }
    }
  }
  ${FeatureLockSchoolBillingPlanFragmentDoc}
`

/**
 * __useFeatureLockQuery__
 *
 * To run a query within a React component, call `useFeatureLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLockQuery({
 *   variables: {
 *      default_billing_plan_set: // value for 'default_billing_plan_set'
 *   },
 * });
 */
export function useFeatureLockQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FeatureLockQuery,
    FeatureLockQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FeatureLockQuery, FeatureLockQueryVariables>(
    FeatureLockDocument,
    options
  )
}
export function useFeatureLockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureLockQuery,
    FeatureLockQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FeatureLockQuery, FeatureLockQueryVariables>(
    FeatureLockDocument,
    options
  )
}
export function useFeatureLockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeatureLockQuery,
        FeatureLockQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FeatureLockQuery, FeatureLockQueryVariables>(
    FeatureLockDocument,
    options
  )
}
export type FeatureLockQueryHookResult = ReturnType<typeof useFeatureLockQuery>
export type FeatureLockLazyQueryHookResult = ReturnType<
  typeof useFeatureLockLazyQuery
>
export type FeatureLockSuspenseQueryHookResult = ReturnType<
  typeof useFeatureLockSuspenseQuery
>
export type FeatureLockQueryResult = Apollo.QueryResult<
  FeatureLockQuery,
  FeatureLockQueryVariables
>
export const MediaDocument = gql`
  query Media(
    $url: String!
    $width: Int
    $height: Int
    $blur: Int
    $dpr: Int
    $crop: crop
    $fit: fit
  ) {
    media {
      image(
        url: $url
        width: $width
        height: $height
        blur: $blur
        dpr: $dpr
        crop: $crop
        fit: $fit
      )
      filestack {
        api_key
        policy
        signature
      }
    }
  }
`

/**
 * __useMediaQuery__
 *
 * To run a query within a React component, call `useMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaQuery({
 *   variables: {
 *      url: // value for 'url'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      blur: // value for 'blur'
 *      dpr: // value for 'dpr'
 *      crop: // value for 'crop'
 *      fit: // value for 'fit'
 *   },
 * });
 */
export function useMediaQuery(
  baseOptions: Apollo.QueryHookOptions<MediaQuery, MediaQueryVariables> &
    ({ variables: MediaQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MediaQuery, MediaQueryVariables>(
    MediaDocument,
    options
  )
}
export function useMediaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MediaQuery, MediaQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MediaQuery, MediaQueryVariables>(
    MediaDocument,
    options
  )
}
export function useMediaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MediaQuery, MediaQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MediaQuery, MediaQueryVariables>(
    MediaDocument,
    options
  )
}
export type MediaQueryHookResult = ReturnType<typeof useMediaQuery>
export type MediaLazyQueryHookResult = ReturnType<typeof useMediaLazyQuery>
export type MediaSuspenseQueryHookResult = ReturnType<
  typeof useMediaSuspenseQuery
>
export type MediaQueryResult = Apollo.QueryResult<
  MediaQuery,
  MediaQueryVariables
>
export const LibraryAuthorsDocument = gql`
  query LibraryAuthors(
    $search: String
    $resourceSearch: String
    $resourceAuthorNameFilter: StringFilter
    $resourceCategoryNameFilter: StringFilter
    $cursor: String
  ) {
    authors(
      first: 15
      after: $cursor
      search: $search
      resource_search: $resourceSearch
      resource_author_names: $resourceAuthorNameFilter
      resource_category_names: $resourceCategoryNameFilter
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Author
        }
      }
    }
  }
  ${AuthorFragmentDoc}
`

/**
 * __useLibraryAuthorsQuery__
 *
 * To run a query within a React component, call `useLibraryAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryAuthorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      resourceSearch: // value for 'resourceSearch'
 *      resourceAuthorNameFilter: // value for 'resourceAuthorNameFilter'
 *      resourceCategoryNameFilter: // value for 'resourceCategoryNameFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useLibraryAuthorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LibraryAuthorsQuery,
    LibraryAuthorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LibraryAuthorsQuery, LibraryAuthorsQueryVariables>(
    LibraryAuthorsDocument,
    options
  )
}
export function useLibraryAuthorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LibraryAuthorsQuery,
    LibraryAuthorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LibraryAuthorsQuery, LibraryAuthorsQueryVariables>(
    LibraryAuthorsDocument,
    options
  )
}
export function useLibraryAuthorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LibraryAuthorsQuery,
        LibraryAuthorsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LibraryAuthorsQuery,
    LibraryAuthorsQueryVariables
  >(LibraryAuthorsDocument, options)
}
export type LibraryAuthorsQueryHookResult = ReturnType<
  typeof useLibraryAuthorsQuery
>
export type LibraryAuthorsLazyQueryHookResult = ReturnType<
  typeof useLibraryAuthorsLazyQuery
>
export type LibraryAuthorsSuspenseQueryHookResult = ReturnType<
  typeof useLibraryAuthorsSuspenseQuery
>
export type LibraryAuthorsQueryResult = Apollo.QueryResult<
  LibraryAuthorsQuery,
  LibraryAuthorsQueryVariables
>
export const LibraryCategoriesDocument = gql`
  query LibraryCategories(
    $search: String
    $resourceSearch: String
    $resourceCategoryNameFilter: StringFilter
    $resourceAuthorNameFilter: StringFilter
    $cursor: String
  ) {
    categories(
      first: 15
      after: $cursor
      search: $search
      resource_search: $resourceSearch
      resource_category_names: $resourceCategoryNameFilter
      resource_author_names: $resourceAuthorNameFilter
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Category
        }
      }
    }
  }
  ${CategoryFragmentDoc}
`

/**
 * __useLibraryCategoriesQuery__
 *
 * To run a query within a React component, call `useLibraryCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryCategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      resourceSearch: // value for 'resourceSearch'
 *      resourceCategoryNameFilter: // value for 'resourceCategoryNameFilter'
 *      resourceAuthorNameFilter: // value for 'resourceAuthorNameFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useLibraryCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >(LibraryCategoriesDocument, options)
}
export function useLibraryCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >(LibraryCategoriesDocument, options)
}
export function useLibraryCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LibraryCategoriesQuery,
        LibraryCategoriesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >(LibraryCategoriesDocument, options)
}
export type LibraryCategoriesQueryHookResult = ReturnType<
  typeof useLibraryCategoriesQuery
>
export type LibraryCategoriesLazyQueryHookResult = ReturnType<
  typeof useLibraryCategoriesLazyQuery
>
export type LibraryCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useLibraryCategoriesSuspenseQuery
>
export type LibraryCategoriesQueryResult = Apollo.QueryResult<
  LibraryCategoriesQuery,
  LibraryCategoriesQueryVariables
>
export const LibraryResourcesDocument = gql`
  query LibraryResources(
    $idFilter: IDFilter
    $categoryIdFilter: IDFilter
    $authorIdFilter: IDFilter
    $categoryNameFilter: StringFilter
    $authorNameFilter: StringFilter
    $resourceTypeFilter: ResourceTypeFilter
    $licensedFromSchoolIdFilter: IDFilter
    $roleFilter: RoleFilter
    $assignConfig: AssignConfig
    $search: String
    $categorySearch: String
    $authorSearch: String
    $first: Int!
    $cursor: String
    $orderBy: String
  ) {
    resources(
      id: $idFilter
      author_ids: $authorIdFilter
      category_ids: $categoryIdFilter
      author_names: $authorNameFilter
      category_names: $categoryNameFilter
      resource_types: $resourceTypeFilter
      licensed_from_school: $licensedFromSchoolIdFilter
      role: $roleFilter
      assign_config: $assignConfig
      search: $search
      category_search: $categorySearch
      author_search: $authorSearch
      first: $first
      after: $cursor
      orderBy: $orderBy
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Resource
          authors(first: 5) {
            edges {
              node {
                ...Author
              }
            }
          }
          groups(
            first: 1
            assign_config: $assignConfig
            include_curriculum: false
          ) {
            total
          }
          curriculum: group(type: curriculum) {
            id
          }
          license_offerings(first: 10, licensing_mode: private_cohorts) {
            edges {
              node {
                id
                cost_per_seat
              }
            }
          }
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${AuthorFragmentDoc}
`

/**
 * __useLibraryResourcesQuery__
 *
 * To run a query within a React component, call `useLibraryResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryResourcesQuery({
 *   variables: {
 *      idFilter: // value for 'idFilter'
 *      categoryIdFilter: // value for 'categoryIdFilter'
 *      authorIdFilter: // value for 'authorIdFilter'
 *      categoryNameFilter: // value for 'categoryNameFilter'
 *      authorNameFilter: // value for 'authorNameFilter'
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *      licensedFromSchoolIdFilter: // value for 'licensedFromSchoolIdFilter'
 *      roleFilter: // value for 'roleFilter'
 *      assignConfig: // value for 'assignConfig'
 *      search: // value for 'search'
 *      categorySearch: // value for 'categorySearch'
 *      authorSearch: // value for 'authorSearch'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLibraryResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  > &
    (
      | { variables: LibraryResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LibraryResourcesQuery, LibraryResourcesQueryVariables>(
    LibraryResourcesDocument,
    options
  )
}
export function useLibraryResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  >(LibraryResourcesDocument, options)
}
export function useLibraryResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LibraryResourcesQuery,
        LibraryResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  >(LibraryResourcesDocument, options)
}
export type LibraryResourcesQueryHookResult = ReturnType<
  typeof useLibraryResourcesQuery
>
export type LibraryResourcesLazyQueryHookResult = ReturnType<
  typeof useLibraryResourcesLazyQuery
>
export type LibraryResourcesSuspenseQueryHookResult = ReturnType<
  typeof useLibraryResourcesSuspenseQuery
>
export type LibraryResourcesQueryResult = Apollo.QueryResult<
  LibraryResourcesQuery,
  LibraryResourcesQueryVariables
>
export const ResourceLicensesDocument = gql`
  query ResourceLicenses($first: Int!, $cursor: String) {
    resource_licenses(first: $first, after: $cursor) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          seat_count
          seats_filled
          expiration_dtime
          group {
            id
            name
            resource {
              id
              name
              image(width: 300, height: 225, fit: crop)
            }
          }
        }
      }
    }
  }
`

/**
 * __useResourceLicensesQuery__
 *
 * To run a query within a React component, call `useResourceLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceLicensesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useResourceLicensesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceLicensesQuery,
    ResourceLicensesQueryVariables
  > &
    (
      | { variables: ResourceLicensesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceLicensesQuery, ResourceLicensesQueryVariables>(
    ResourceLicensesDocument,
    options
  )
}
export function useResourceLicensesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceLicensesQuery,
    ResourceLicensesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceLicensesQuery,
    ResourceLicensesQueryVariables
  >(ResourceLicensesDocument, options)
}
export function useResourceLicensesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceLicensesQuery,
        ResourceLicensesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceLicensesQuery,
    ResourceLicensesQueryVariables
  >(ResourceLicensesDocument, options)
}
export type ResourceLicensesQueryHookResult = ReturnType<
  typeof useResourceLicensesQuery
>
export type ResourceLicensesLazyQueryHookResult = ReturnType<
  typeof useResourceLicensesLazyQuery
>
export type ResourceLicensesSuspenseQueryHookResult = ReturnType<
  typeof useResourceLicensesSuspenseQuery
>
export type ResourceLicensesQueryResult = Apollo.QueryResult<
  ResourceLicensesQuery,
  ResourceLicensesQueryVariables
>
export const UpdateLocalTranslationDocument = gql`
  mutation UpdateLocalTranslation($translation: JSON!) {
    updateLocalTranslation(translation: $translation)
  }
`
export type UpdateLocalTranslationMutationFn = Apollo.MutationFunction<
  UpdateLocalTranslationMutation,
  UpdateLocalTranslationMutationVariables
>

/**
 * __useUpdateLocalTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateLocalTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalTranslationMutation, { data, loading, error }] = useUpdateLocalTranslationMutation({
 *   variables: {
 *      translation: // value for 'translation'
 *   },
 * });
 */
export function useUpdateLocalTranslationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocalTranslationMutation,
    UpdateLocalTranslationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateLocalTranslationMutation,
    UpdateLocalTranslationMutationVariables
  >(UpdateLocalTranslationDocument, options)
}
export type UpdateLocalTranslationMutationHookResult = ReturnType<
  typeof useUpdateLocalTranslationMutation
>
export type UpdateLocalTranslationMutationResult =
  Apollo.MutationResult<UpdateLocalTranslationMutation>
export type UpdateLocalTranslationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocalTranslationMutation,
  UpdateLocalTranslationMutationVariables
>
export const TranslationDocument = gql`
  query Translation($language: String, $isDefault: Boolean) {
    translation(language: $language, is_default: $isDefault) {
      id
      name
      language
      translation
      master_translation
      is_default
    }
  }
`

/**
 * __useTranslationQuery__
 *
 * To run a query within a React component, call `useTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationQuery({
 *   variables: {
 *      language: // value for 'language'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useTranslationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TranslationQuery,
    TranslationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TranslationQuery, TranslationQueryVariables>(
    TranslationDocument,
    options
  )
}
export function useTranslationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TranslationQuery,
    TranslationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TranslationQuery, TranslationQueryVariables>(
    TranslationDocument,
    options
  )
}
export function useTranslationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TranslationQuery,
        TranslationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TranslationQuery, TranslationQueryVariables>(
    TranslationDocument,
    options
  )
}
export type TranslationQueryHookResult = ReturnType<typeof useTranslationQuery>
export type TranslationLazyQueryHookResult = ReturnType<
  typeof useTranslationLazyQuery
>
export type TranslationSuspenseQueryHookResult = ReturnType<
  typeof useTranslationSuspenseQuery
>
export type TranslationQueryResult = Apollo.QueryResult<
  TranslationQuery,
  TranslationQueryVariables
>
export const MediaContextQueryDocument = gql`
  query MediaContextQuery {
    mediaContext {
      accountID
      user {
        id
        is_superuser
      }
      mediaStoragePath
    }
  }
`

/**
 * __useMediaContextQueryQuery__
 *
 * To run a query within a React component, call `useMediaContextQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaContextQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaContextQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMediaContextQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MediaContextQueryQuery,
    MediaContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MediaContextQueryQuery,
    MediaContextQueryQueryVariables
  >(MediaContextQueryDocument, options)
}
export function useMediaContextQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MediaContextQueryQuery,
    MediaContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MediaContextQueryQuery,
    MediaContextQueryQueryVariables
  >(MediaContextQueryDocument, options)
}
export function useMediaContextQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MediaContextQueryQuery,
        MediaContextQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MediaContextQueryQuery,
    MediaContextQueryQueryVariables
  >(MediaContextQueryDocument, options)
}
export type MediaContextQueryQueryHookResult = ReturnType<
  typeof useMediaContextQueryQuery
>
export type MediaContextQueryLazyQueryHookResult = ReturnType<
  typeof useMediaContextQueryLazyQuery
>
export type MediaContextQuerySuspenseQueryHookResult = ReturnType<
  typeof useMediaContextQuerySuspenseQuery
>
export type MediaContextQueryQueryResult = Apollo.QueryResult<
  MediaContextQueryQuery,
  MediaContextQueryQueryVariables
>
export const RemoveAccessForInactiveMembersDocument = gql`
  mutation RemoveAccessForInactiveMembers($daysInactive: Int!) {
    removeAccessForInactiveMembers(daysInactive: $daysInactive)
  }
`
export type RemoveAccessForInactiveMembersMutationFn = Apollo.MutationFunction<
  RemoveAccessForInactiveMembersMutation,
  RemoveAccessForInactiveMembersMutationVariables
>

/**
 * __useRemoveAccessForInactiveMembersMutation__
 *
 * To run a mutation, you first call `useRemoveAccessForInactiveMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccessForInactiveMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccessForInactiveMembersMutation, { data, loading, error }] = useRemoveAccessForInactiveMembersMutation({
 *   variables: {
 *      daysInactive: // value for 'daysInactive'
 *   },
 * });
 */
export function useRemoveAccessForInactiveMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAccessForInactiveMembersMutation,
    RemoveAccessForInactiveMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveAccessForInactiveMembersMutation,
    RemoveAccessForInactiveMembersMutationVariables
  >(RemoveAccessForInactiveMembersDocument, options)
}
export type RemoveAccessForInactiveMembersMutationHookResult = ReturnType<
  typeof useRemoveAccessForInactiveMembersMutation
>
export type RemoveAccessForInactiveMembersMutationResult =
  Apollo.MutationResult<RemoveAccessForInactiveMembersMutation>
export type RemoveAccessForInactiveMembersMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveAccessForInactiveMembersMutation,
    RemoveAccessForInactiveMembersMutationVariables
  >
export const RequestPasswordResetDocument = gql`
  mutation RequestPasswordReset($user_id: Int!) {
    requestPasswordReset(id: $user_id)
  }
`
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >(RequestPasswordResetDocument, options)
}
export type RequestPasswordResetMutationHookResult = ReturnType<
  typeof useRequestPasswordResetMutation
>
export type RequestPasswordResetMutationResult =
  Apollo.MutationResult<RequestPasswordResetMutation>
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>
export const SetMemberAccessDocument = gql`
  mutation SetMemberAccess($id: Int!, $has_access: Boolean!) {
    setMemberAccess(id: $id, has_access: $has_access) {
      id
      access_revoked_time
      has_access
    }
  }
`
export type SetMemberAccessMutationFn = Apollo.MutationFunction<
  SetMemberAccessMutation,
  SetMemberAccessMutationVariables
>

/**
 * __useSetMemberAccessMutation__
 *
 * To run a mutation, you first call `useSetMemberAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMemberAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMemberAccessMutation, { data, loading, error }] = useSetMemberAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      has_access: // value for 'has_access'
 *   },
 * });
 */
export function useSetMemberAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetMemberAccessMutation,
    SetMemberAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SetMemberAccessMutation,
    SetMemberAccessMutationVariables
  >(SetMemberAccessDocument, options)
}
export type SetMemberAccessMutationHookResult = ReturnType<
  typeof useSetMemberAccessMutation
>
export type SetMemberAccessMutationResult =
  Apollo.MutationResult<SetMemberAccessMutation>
export type SetMemberAccessMutationOptions = Apollo.BaseMutationOptions<
  SetMemberAccessMutation,
  SetMemberAccessMutationVariables
>
export const SetMemberArchivedDocument = gql`
  mutation SetMemberArchived($id: Int!, $is_archived: Boolean!) {
    setMemberArchived(id: $id, is_archived: $is_archived) {
      id
      archived_time
      has_access
    }
  }
`
export type SetMemberArchivedMutationFn = Apollo.MutationFunction<
  SetMemberArchivedMutation,
  SetMemberArchivedMutationVariables
>

/**
 * __useSetMemberArchivedMutation__
 *
 * To run a mutation, you first call `useSetMemberArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMemberArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMemberArchivedMutation, { data, loading, error }] = useSetMemberArchivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_archived: // value for 'is_archived'
 *   },
 * });
 */
export function useSetMemberArchivedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetMemberArchivedMutation,
    SetMemberArchivedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SetMemberArchivedMutation,
    SetMemberArchivedMutationVariables
  >(SetMemberArchivedDocument, options)
}
export type SetMemberArchivedMutationHookResult = ReturnType<
  typeof useSetMemberArchivedMutation
>
export type SetMemberArchivedMutationResult =
  Apollo.MutationResult<SetMemberArchivedMutation>
export type SetMemberArchivedMutationOptions = Apollo.BaseMutationOptions<
  SetMemberArchivedMutation,
  SetMemberArchivedMutationVariables
>
export const SetMemberRoleDocument = gql`
  mutation SetMemberRole($id: Int!, $role: MembershipRole!) {
    setMemberRole(id: $id, role: $role) {
      id
      role
    }
  }
`
export type SetMemberRoleMutationFn = Apollo.MutationFunction<
  SetMemberRoleMutation,
  SetMemberRoleMutationVariables
>

/**
 * __useSetMemberRoleMutation__
 *
 * To run a mutation, you first call `useSetMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMemberRoleMutation, { data, loading, error }] = useSetMemberRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetMemberRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetMemberRoleMutation,
    SetMemberRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SetMemberRoleMutation,
    SetMemberRoleMutationVariables
  >(SetMemberRoleDocument, options)
}
export type SetMemberRoleMutationHookResult = ReturnType<
  typeof useSetMemberRoleMutation
>
export type SetMemberRoleMutationResult =
  Apollo.MutationResult<SetMemberRoleMutation>
export type SetMemberRoleMutationOptions = Apollo.BaseMutationOptions<
  SetMemberRoleMutation,
  SetMemberRoleMutationVariables
>
export const TotalMembersWithFiltersDocument = gql`
  query TotalMembersWithFilters(
    $search: String
    $role_filter: [MembershipRoleFilter]
    $archived_date_filter: [DateFilter]
    $daysInactive: Int
    $hasAccess: Boolean
  ) {
    school {
      id
      members(
        search: $search
        role_filter: $role_filter
        archived_date_filter: $archived_date_filter
        first: 1
        daysInactive: $daysInactive
        hasAccess: $hasAccess
      ) {
        total
      }
    }
  }
`

/**
 * __useTotalMembersWithFiltersQuery__
 *
 * To run a query within a React component, call `useTotalMembersWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalMembersWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalMembersWithFiltersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      role_filter: // value for 'role_filter'
 *      archived_date_filter: // value for 'archived_date_filter'
 *      daysInactive: // value for 'daysInactive'
 *      hasAccess: // value for 'hasAccess'
 *   },
 * });
 */
export function useTotalMembersWithFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TotalMembersWithFiltersQuery,
    TotalMembersWithFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    TotalMembersWithFiltersQuery,
    TotalMembersWithFiltersQueryVariables
  >(TotalMembersWithFiltersDocument, options)
}
export function useTotalMembersWithFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalMembersWithFiltersQuery,
    TotalMembersWithFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    TotalMembersWithFiltersQuery,
    TotalMembersWithFiltersQueryVariables
  >(TotalMembersWithFiltersDocument, options)
}
export function useTotalMembersWithFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalMembersWithFiltersQuery,
        TotalMembersWithFiltersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    TotalMembersWithFiltersQuery,
    TotalMembersWithFiltersQueryVariables
  >(TotalMembersWithFiltersDocument, options)
}
export type TotalMembersWithFiltersQueryHookResult = ReturnType<
  typeof useTotalMembersWithFiltersQuery
>
export type TotalMembersWithFiltersLazyQueryHookResult = ReturnType<
  typeof useTotalMembersWithFiltersLazyQuery
>
export type TotalMembersWithFiltersSuspenseQueryHookResult = ReturnType<
  typeof useTotalMembersWithFiltersSuspenseQuery
>
export type TotalMembersWithFiltersQueryResult = Apollo.QueryResult<
  TotalMembersWithFiltersQuery,
  TotalMembersWithFiltersQueryVariables
>
export const BatchCreateMentorGroupMembershipDocument = gql`
  mutation BatchCreateMentorGroupMembership(
    $user_ids: [Int!]
    $group: Int!
    $role: MentorGroupMembershipRole!
  ) {
    batchCreateMentorGroupMembership(
      user_ids: $user_ids
      group: $group
      role: $role
    ) {
      success
      group_memberships_created_count
    }
  }
`
export type BatchCreateMentorGroupMembershipMutationFn =
  Apollo.MutationFunction<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >

/**
 * __useBatchCreateMentorGroupMembershipMutation__
 *
 * To run a mutation, you first call `useBatchCreateMentorGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateMentorGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateMentorGroupMembershipMutation, { data, loading, error }] = useBatchCreateMentorGroupMembershipMutation({
 *   variables: {
 *      user_ids: // value for 'user_ids'
 *      group: // value for 'group'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useBatchCreateMentorGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >(BatchCreateMentorGroupMembershipDocument, options)
}
export type BatchCreateMentorGroupMembershipMutationHookResult = ReturnType<
  typeof useBatchCreateMentorGroupMembershipMutation
>
export type BatchCreateMentorGroupMembershipMutationResult =
  Apollo.MutationResult<BatchCreateMentorGroupMembershipMutation>
export type BatchCreateMentorGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >
export const CreateMentorGroupDocument = gql`
  mutation CreateMentorGroup(
    $name: String!
    $parent: Int
    $type: MentorGroupType
  ) {
    createMentorGroup(name: $name, parent: $parent, type: $type) {
      ...MentorGroup
      memberships(first: 5) {
        total
        edges {
          node {
            id
            user {
              ...User
            }
          }
        }
      }
    }
  }
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
`
export type CreateMentorGroupMutationFn = Apollo.MutationFunction<
  CreateMentorGroupMutation,
  CreateMentorGroupMutationVariables
>

/**
 * __useCreateMentorGroupMutation__
 *
 * To run a mutation, you first call `useCreateMentorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMentorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMentorGroupMutation, { data, loading, error }] = useCreateMentorGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parent: // value for 'parent'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateMentorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMentorGroupMutation,
    CreateMentorGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateMentorGroupMutation,
    CreateMentorGroupMutationVariables
  >(CreateMentorGroupDocument, options)
}
export type CreateMentorGroupMutationHookResult = ReturnType<
  typeof useCreateMentorGroupMutation
>
export type CreateMentorGroupMutationResult =
  Apollo.MutationResult<CreateMentorGroupMutation>
export type CreateMentorGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateMentorGroupMutation,
  CreateMentorGroupMutationVariables
>
export const DeleteMentorGroupMembershipDocument = gql`
  mutation DeleteMentorGroupMembership($id: Int!, $group: Int!) {
    deleteMentorGroupMembership(id: $id, group: $group)
  }
`
export type DeleteMentorGroupMembershipMutationFn = Apollo.MutationFunction<
  DeleteMentorGroupMembershipMutation,
  DeleteMentorGroupMembershipMutationVariables
>

/**
 * __useDeleteMentorGroupMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMentorGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMentorGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMentorGroupMembershipMutation, { data, loading, error }] = useDeleteMentorGroupMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useDeleteMentorGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMentorGroupMembershipMutation,
    DeleteMentorGroupMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteMentorGroupMembershipMutation,
    DeleteMentorGroupMembershipMutationVariables
  >(DeleteMentorGroupMembershipDocument, options)
}
export type DeleteMentorGroupMembershipMutationHookResult = ReturnType<
  typeof useDeleteMentorGroupMembershipMutation
>
export type DeleteMentorGroupMembershipMutationResult =
  Apollo.MutationResult<DeleteMentorGroupMembershipMutation>
export type DeleteMentorGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteMentorGroupMembershipMutation,
    DeleteMentorGroupMembershipMutationVariables
  >
export const DeleteMentorGroupDocument = gql`
  mutation DeleteMentorGroup($id: Int!) {
    deleteMentorGroup(id: $id)
  }
`
export type DeleteMentorGroupMutationFn = Apollo.MutationFunction<
  DeleteMentorGroupMutation,
  DeleteMentorGroupMutationVariables
>

/**
 * __useDeleteMentorGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMentorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMentorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMentorGroupMutation, { data, loading, error }] = useDeleteMentorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMentorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMentorGroupMutation,
    DeleteMentorGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteMentorGroupMutation,
    DeleteMentorGroupMutationVariables
  >(DeleteMentorGroupDocument, options)
}
export type DeleteMentorGroupMutationHookResult = ReturnType<
  typeof useDeleteMentorGroupMutation
>
export type DeleteMentorGroupMutationResult =
  Apollo.MutationResult<DeleteMentorGroupMutation>
export type DeleteMentorGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteMentorGroupMutation,
  DeleteMentorGroupMutationVariables
>
export const MentorGroupInvitationsDocument = gql`
  query MentorGroupInvitations(
    $group_id: Int!
    $search: String
    $cursor: String
  ) {
    school {
      id
      mentor_group(id: $group_id) {
        id
        invitations(
          first: 50
          after: $cursor
          status: not_accepted
          search: $search
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Invitation
            }
          }
        }
      }
    }
  }
  ${InvitationFragmentDoc}
`

/**
 * __useMentorGroupInvitationsQuery__
 *
 * To run a query within a React component, call `useMentorGroupInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupInvitationsQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useMentorGroupInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  > &
    (
      | { variables: MentorGroupInvitationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >(MentorGroupInvitationsDocument, options)
}
export function useMentorGroupInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >(MentorGroupInvitationsDocument, options)
}
export function useMentorGroupInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupInvitationsQuery,
        MentorGroupInvitationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >(MentorGroupInvitationsDocument, options)
}
export type MentorGroupInvitationsQueryHookResult = ReturnType<
  typeof useMentorGroupInvitationsQuery
>
export type MentorGroupInvitationsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupInvitationsLazyQuery
>
export type MentorGroupInvitationsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupInvitationsSuspenseQuery
>
export type MentorGroupInvitationsQueryResult = Apollo.QueryResult<
  MentorGroupInvitationsQuery,
  MentorGroupInvitationsQueryVariables
>
export const MentorGroupMembershipDocument = gql`
  query MentorGroupMembership($id: Int!) {
    mentorGroupMembership(id: $id) {
      ...MentorGroupMembership
    }
  }
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupMembershipQuery__
 *
 * To run a query within a React component, call `useMentorGroupMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupMembershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMentorGroupMembershipQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  > &
    (
      | { variables: MentorGroupMembershipQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >(MentorGroupMembershipDocument, options)
}
export function useMentorGroupMembershipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >(MentorGroupMembershipDocument, options)
}
export function useMentorGroupMembershipSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupMembershipQuery,
        MentorGroupMembershipQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >(MentorGroupMembershipDocument, options)
}
export type MentorGroupMembershipQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipQuery
>
export type MentorGroupMembershipLazyQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipLazyQuery
>
export type MentorGroupMembershipSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipSuspenseQuery
>
export type MentorGroupMembershipQueryResult = Apollo.QueryResult<
  MentorGroupMembershipQuery,
  MentorGroupMembershipQueryVariables
>
export const MentorGroupMembershipsDocument = gql`
  query MentorGroupMemberships(
    $group_id: Int!
    $search: String
    $role: MentorGroupMembershipRoleFilter = { eq: member }
    $cursor: String
    $first: Int = 50
  ) {
    school {
      ...School
      mentor_group(id: $group_id) {
        id
        memberships(
          first: $first
          after: $cursor
          search: $search
          role: $role
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...MentorGroupMembership
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useMentorGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupMembershipsQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      search: // value for 'search'
 *      role: // value for 'role'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMentorGroupMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  > &
    (
      | { variables: MentorGroupMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >(MentorGroupMembershipsDocument, options)
}
export function useMentorGroupMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >(MentorGroupMembershipsDocument, options)
}
export function useMentorGroupMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupMembershipsQuery,
        MentorGroupMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >(MentorGroupMembershipsDocument, options)
}
export type MentorGroupMembershipsQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipsQuery
>
export type MentorGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipsLazyQuery
>
export type MentorGroupMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipsSuspenseQuery
>
export type MentorGroupMembershipsQueryResult = Apollo.QueryResult<
  MentorGroupMembershipsQuery,
  MentorGroupMembershipsQueryVariables
>
export const MentorGroupDocument = gql`
  query MentorGroup($id: Int!) {
    school {
      ...School
      mentor_group(id: $id) {
        ...MentorGroup
        user_membership {
          ...MentorGroupMembership
        }
        parent {
          ...MentorGroup
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupFragmentDoc}
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupQuery__
 *
 * To run a query within a React component, call `useMentorGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMentorGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupQuery,
    MentorGroupQueryVariables
  > &
    (
      | { variables: MentorGroupQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MentorGroupQuery, MentorGroupQueryVariables>(
    MentorGroupDocument,
    options
  )
}
export function useMentorGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupQuery,
    MentorGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MentorGroupQuery, MentorGroupQueryVariables>(
    MentorGroupDocument,
    options
  )
}
export function useMentorGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupQuery,
        MentorGroupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MentorGroupQuery, MentorGroupQueryVariables>(
    MentorGroupDocument,
    options
  )
}
export type MentorGroupQueryHookResult = ReturnType<typeof useMentorGroupQuery>
export type MentorGroupLazyQueryHookResult = ReturnType<
  typeof useMentorGroupLazyQuery
>
export type MentorGroupSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupSuspenseQuery
>
export type MentorGroupQueryResult = Apollo.QueryResult<
  MentorGroupQuery,
  MentorGroupQueryVariables
>
export const MentorGroupStaffMembershipsDocument = gql`
  query MentorGroupStaffMemberships($group_id: Int!) {
    school {
      ...School
      mentor_group(id: $group_id) {
        id
        memberships(first: 1042, role: { gte: moderator }, order_by: "-role") {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...MentorGroupMembership
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupStaffMembershipsQuery__
 *
 * To run a query within a React component, call `useMentorGroupStaffMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupStaffMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupStaffMembershipsQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useMentorGroupStaffMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  > &
    (
      | { variables: MentorGroupStaffMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >(MentorGroupStaffMembershipsDocument, options)
}
export function useMentorGroupStaffMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >(MentorGroupStaffMembershipsDocument, options)
}
export function useMentorGroupStaffMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupStaffMembershipsQuery,
        MentorGroupStaffMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >(MentorGroupStaffMembershipsDocument, options)
}
export type MentorGroupStaffMembershipsQueryHookResult = ReturnType<
  typeof useMentorGroupStaffMembershipsQuery
>
export type MentorGroupStaffMembershipsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupStaffMembershipsLazyQuery
>
export type MentorGroupStaffMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupStaffMembershipsSuspenseQuery
>
export type MentorGroupStaffMembershipsQueryResult = Apollo.QueryResult<
  MentorGroupStaffMembershipsQuery,
  MentorGroupStaffMembershipsQueryVariables
>
export const MentorGroupSubscriptionDocument = gql`
  query MentorGroupSubscription($group_id: Int!) {
    school {
      id
      mentor_group(id: $group_id) {
        ...MentorGroupSubscription
      }
    }
  }
  ${MentorGroupSubscriptionFragmentDoc}
`

/**
 * __useMentorGroupSubscriptionQuery__
 *
 * To run a query within a React component, call `useMentorGroupSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupSubscriptionQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useMentorGroupSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  > &
    (
      | { variables: MentorGroupSubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >(MentorGroupSubscriptionDocument, options)
}
export function useMentorGroupSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >(MentorGroupSubscriptionDocument, options)
}
export function useMentorGroupSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupSubscriptionQuery,
        MentorGroupSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >(MentorGroupSubscriptionDocument, options)
}
export type MentorGroupSubscriptionQueryHookResult = ReturnType<
  typeof useMentorGroupSubscriptionQuery
>
export type MentorGroupSubscriptionLazyQueryHookResult = ReturnType<
  typeof useMentorGroupSubscriptionLazyQuery
>
export type MentorGroupSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupSubscriptionSuspenseQuery
>
export type MentorGroupSubscriptionQueryResult = Apollo.QueryResult<
  MentorGroupSubscriptionQuery,
  MentorGroupSubscriptionQueryVariables
>
export const MentorGroupsDocument = gql`
  query MentorGroups(
    $cursor: String
    $first: Int = 25
    $id: IDFilter
    $topLevelOnly: Boolean
    $parentId: IDFilter
    $descendentOfParentId: EquivalenceIDFilter
    $seatLimitFilter: IntFilter
    $search: String
  ) {
    school {
      ...School
      mentor_groups(
        after: $cursor
        first: $first
        id: $id
        top_level_only: $topLevelOnly
        parent_id: $parentId
        descendant_of_parent_id: $descendentOfParentId
        seat_limit_filter: $seatLimitFilter
        search: $search
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...MentorGroup
            memberships(first: 5) {
              total
              edges {
                node {
                  id
                  user {
                    ...User
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useMentorGroupsQuery__
 *
 * To run a query within a React component, call `useMentorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      id: // value for 'id'
 *      topLevelOnly: // value for 'topLevelOnly'
 *      parentId: // value for 'parentId'
 *      descendentOfParentId: // value for 'descendentOfParentId'
 *      seatLimitFilter: // value for 'seatLimitFilter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMentorGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MentorGroupsQuery,
    MentorGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MentorGroupsQuery, MentorGroupsQueryVariables>(
    MentorGroupsDocument,
    options
  )
}
export function useMentorGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupsQuery,
    MentorGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MentorGroupsQuery, MentorGroupsQueryVariables>(
    MentorGroupsDocument,
    options
  )
}
export function useMentorGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupsQuery,
        MentorGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MentorGroupsQuery, MentorGroupsQueryVariables>(
    MentorGroupsDocument,
    options
  )
}
export type MentorGroupsQueryHookResult = ReturnType<
  typeof useMentorGroupsQuery
>
export type MentorGroupsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupsLazyQuery
>
export type MentorGroupsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupsSuspenseQuery
>
export type MentorGroupsQueryResult = Apollo.QueryResult<
  MentorGroupsQuery,
  MentorGroupsQueryVariables
>
export const UpdateMentorGroupMembershipDocument = gql`
  mutation UpdateMentorGroupMembership(
    $id: Int!
    $group: Int!
    $role: MentorGroupMembershipRole
    $canReview: Boolean
    $hasAccess: Boolean
    $sendMentorDigest: Boolean
  ) {
    updateMentorGroupMembership(
      id: $id
      group: $group
      role: $role
      can_review: $canReview
      has_access: $hasAccess
      send_mentor_digest: $sendMentorDigest
    ) {
      ...MentorGroupMembership
    }
  }
  ${MentorGroupMembershipFragmentDoc}
`
export type UpdateMentorGroupMembershipMutationFn = Apollo.MutationFunction<
  UpdateMentorGroupMembershipMutation,
  UpdateMentorGroupMembershipMutationVariables
>

/**
 * __useUpdateMentorGroupMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMentorGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorGroupMembershipMutation, { data, loading, error }] = useUpdateMentorGroupMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      group: // value for 'group'
 *      role: // value for 'role'
 *      canReview: // value for 'canReview'
 *      hasAccess: // value for 'hasAccess'
 *      sendMentorDigest: // value for 'sendMentorDigest'
 *   },
 * });
 */
export function useUpdateMentorGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMentorGroupMembershipMutation,
    UpdateMentorGroupMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateMentorGroupMembershipMutation,
    UpdateMentorGroupMembershipMutationVariables
  >(UpdateMentorGroupMembershipDocument, options)
}
export type UpdateMentorGroupMembershipMutationHookResult = ReturnType<
  typeof useUpdateMentorGroupMembershipMutation
>
export type UpdateMentorGroupMembershipMutationResult =
  Apollo.MutationResult<UpdateMentorGroupMembershipMutation>
export type UpdateMentorGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateMentorGroupMembershipMutation,
    UpdateMentorGroupMembershipMutationVariables
  >
export const UpdateMentorGroupDocument = gql`
  mutation UpdateMentorGroup(
    $id: Int!
    $name: String
    $parent: Int
    $description: String
    $type: MentorGroupType
  ) {
    updateMentorGroup(
      id: $id
      name: $name
      parent: $parent
      description: $description
      type: $type
    ) {
      ...MentorGroup
    }
  }
  ${MentorGroupFragmentDoc}
`
export type UpdateMentorGroupMutationFn = Apollo.MutationFunction<
  UpdateMentorGroupMutation,
  UpdateMentorGroupMutationVariables
>

/**
 * __useUpdateMentorGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMentorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorGroupMutation, { data, loading, error }] = useUpdateMentorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      parent: // value for 'parent'
 *      description: // value for 'description'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateMentorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMentorGroupMutation,
    UpdateMentorGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateMentorGroupMutation,
    UpdateMentorGroupMutationVariables
  >(UpdateMentorGroupDocument, options)
}
export type UpdateMentorGroupMutationHookResult = ReturnType<
  typeof useUpdateMentorGroupMutation
>
export type UpdateMentorGroupMutationResult =
  Apollo.MutationResult<UpdateMentorGroupMutation>
export type UpdateMentorGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateMentorGroupMutation,
  UpdateMentorGroupMutationVariables
>
export const MentorGroupsStatsQueryDocument = gql`
  query MentorGroupsStatsQuery {
    school {
      id
      mentor_group_stats {
        community
        personal
      }
    }
  }
`

/**
 * __useMentorGroupsStatsQueryQuery__
 *
 * To run a query within a React component, call `useMentorGroupsStatsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupsStatsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupsStatsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMentorGroupsStatsQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MentorGroupsStatsQueryQuery,
    MentorGroupsStatsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupsStatsQueryQuery,
    MentorGroupsStatsQueryQueryVariables
  >(MentorGroupsStatsQueryDocument, options)
}
export function useMentorGroupsStatsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupsStatsQueryQuery,
    MentorGroupsStatsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupsStatsQueryQuery,
    MentorGroupsStatsQueryQueryVariables
  >(MentorGroupsStatsQueryDocument, options)
}
export function useMentorGroupsStatsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupsStatsQueryQuery,
        MentorGroupsStatsQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupsStatsQueryQuery,
    MentorGroupsStatsQueryQueryVariables
  >(MentorGroupsStatsQueryDocument, options)
}
export type MentorGroupsStatsQueryQueryHookResult = ReturnType<
  typeof useMentorGroupsStatsQueryQuery
>
export type MentorGroupsStatsQueryLazyQueryHookResult = ReturnType<
  typeof useMentorGroupsStatsQueryLazyQuery
>
export type MentorGroupsStatsQuerySuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupsStatsQuerySuspenseQuery
>
export type MentorGroupsStatsQueryQueryResult = Apollo.QueryResult<
  MentorGroupsStatsQueryQuery,
  MentorGroupsStatsQueryQueryVariables
>
export const CreateNoteDocument = gql`
  mutation CreateNote($context: ContextModelInput!, $note: NoteInput!) {
    createNote(context: $context, note: $note) {
      ...Note
    }
  }
  ${NoteFragmentDoc}
`
export type CreateNoteMutationFn = Apollo.MutationFunction<
  CreateNoteMutation,
  CreateNoteMutationVariables
>

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      context: // value for 'context'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNoteMutation,
    CreateNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(
    CreateNoteDocument,
    options
  )
}
export type CreateNoteMutationHookResult = ReturnType<
  typeof useCreateNoteMutation
>
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<
  CreateNoteMutation,
  CreateNoteMutationVariables
>
export const DeleteNoteDocument = gql`
  mutation DeleteNote($context: ContextModelInput!, $id: Int!) {
    deleteNote(context: $context, id: $id)
  }
`
export type DeleteNoteMutationFn = Apollo.MutationFunction<
  DeleteNoteMutation,
  DeleteNoteMutationVariables
>

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      context: // value for 'context'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteNoteMutation,
    DeleteNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(
    DeleteNoteDocument,
    options
  )
}
export type DeleteNoteMutationHookResult = ReturnType<
  typeof useDeleteNoteMutation
>
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<
  DeleteNoteMutation,
  DeleteNoteMutationVariables
>
export const NotePermissionsDocument = gql`
  query NotePermissions($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      ...CohortPermissions
      resource_license {
        id
      }
    }
  }
  ${CohortPermissionsFragmentDoc}
`

/**
 * __useNotePermissionsQuery__
 *
 * To run a query within a React component, call `useNotePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotePermissionsQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useNotePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    NotePermissionsQuery,
    NotePermissionsQueryVariables
  > &
    (
      | { variables: NotePermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NotePermissionsQuery, NotePermissionsQueryVariables>(
    NotePermissionsDocument,
    options
  )
}
export function useNotePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotePermissionsQuery,
    NotePermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NotePermissionsQuery,
    NotePermissionsQueryVariables
  >(NotePermissionsDocument, options)
}
export function useNotePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotePermissionsQuery,
        NotePermissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    NotePermissionsQuery,
    NotePermissionsQueryVariables
  >(NotePermissionsDocument, options)
}
export type NotePermissionsQueryHookResult = ReturnType<
  typeof useNotePermissionsQuery
>
export type NotePermissionsLazyQueryHookResult = ReturnType<
  typeof useNotePermissionsLazyQuery
>
export type NotePermissionsSuspenseQueryHookResult = ReturnType<
  typeof useNotePermissionsSuspenseQuery
>
export type NotePermissionsQueryResult = Apollo.QueryResult<
  NotePermissionsQuery,
  NotePermissionsQueryVariables
>
export const NotesDocument = gql`
  query Notes(
    $first: Int = 50
    $cursor: String
    $context: ContextModelInput!
    $visibility: NoteVisibility
  ) {
    notes(
      first: $first
      after: $cursor
      context: $context
      visibility: $visibility
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Note
        }
      }
    }
  }
  ${NoteFragmentDoc}
`

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      context: // value for 'context'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useNotesQuery(
  baseOptions: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables> &
    ({ variables: NotesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NotesQuery, NotesQueryVariables>(
    NotesDocument,
    options
  )
}
export function useNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(
    NotesDocument,
    options
  )
}
export function useNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NotesQuery, NotesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<NotesQuery, NotesQueryVariables>(
    NotesDocument,
    options
  )
}
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>
export type NotesSuspenseQueryHookResult = ReturnType<
  typeof useNotesSuspenseQuery
>
export type NotesQueryResult = Apollo.QueryResult<
  NotesQuery,
  NotesQueryVariables
>
export const UpdateNoteDocument = gql`
  mutation UpdateNote(
    $context: ContextModelInput!
    $id: Int!
    $note: NoteInput!
  ) {
    updateNote(context: $context, id: $id, note: $note) {
      ...Note
    }
  }
  ${NoteFragmentDoc}
`
export type UpdateNoteMutationFn = Apollo.MutationFunction<
  UpdateNoteMutation,
  UpdateNoteMutationVariables
>

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      context: // value for 'context'
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNoteMutation,
    UpdateNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(
    UpdateNoteDocument,
    options
  )
}
export type UpdateNoteMutationHookResult = ReturnType<
  typeof useUpdateNoteMutation
>
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdateNoteMutation,
  UpdateNoteMutationVariables
>
export const CreateNotificationDocument = gql`
  mutation CreateNotification($input: NotificationInput!) {
    createNotification(input: $input)
  }
`
export type CreateNotificationMutationFn = Apollo.MutationFunction<
  CreateNotificationMutation,
  CreateNotificationMutationVariables
>

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNotificationMutation,
    CreateNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateNotificationMutation,
    CreateNotificationMutationVariables
  >(CreateNotificationDocument, options)
}
export type CreateNotificationMutationHookResult = ReturnType<
  typeof useCreateNotificationMutation
>
export type CreateNotificationMutationResult =
  Apollo.MutationResult<CreateNotificationMutation>
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<
  CreateNotificationMutation,
  CreateNotificationMutationVariables
>
export const UpdateNotificationDigestIntervalDocument = gql`
  mutation UpdateNotificationDigestInterval(
    $interval: NotificationDigestInterval
  ) {
    updateNotificationDigestInterval(interval: $interval) {
      id
      notification_digest_interval
    }
  }
`
export type UpdateNotificationDigestIntervalMutationFn =
  Apollo.MutationFunction<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >

/**
 * __useUpdateNotificationDigestIntervalMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationDigestIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationDigestIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationDigestIntervalMutation, { data, loading, error }] = useUpdateNotificationDigestIntervalMutation({
 *   variables: {
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useUpdateNotificationDigestIntervalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >(UpdateNotificationDigestIntervalDocument, options)
}
export type UpdateNotificationDigestIntervalMutationHookResult = ReturnType<
  typeof useUpdateNotificationDigestIntervalMutation
>
export type UpdateNotificationDigestIntervalMutationResult =
  Apollo.MutationResult<UpdateNotificationDigestIntervalMutation>
export type UpdateNotificationDigestIntervalMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >
export const CouponExistsDocument = gql`
  query CouponExists($input: CouponExistsInput) {
    couponExists(input: $input)
  }
`

/**
 * __useCouponExistsQuery__
 *
 * To run a query within a React component, call `useCouponExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponExistsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCouponExistsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CouponExistsQuery,
    CouponExistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CouponExistsQuery, CouponExistsQueryVariables>(
    CouponExistsDocument,
    options
  )
}
export function useCouponExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CouponExistsQuery,
    CouponExistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CouponExistsQuery, CouponExistsQueryVariables>(
    CouponExistsDocument,
    options
  )
}
export function useCouponExistsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CouponExistsQuery,
        CouponExistsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CouponExistsQuery, CouponExistsQueryVariables>(
    CouponExistsDocument,
    options
  )
}
export type CouponExistsQueryHookResult = ReturnType<
  typeof useCouponExistsQuery
>
export type CouponExistsLazyQueryHookResult = ReturnType<
  typeof useCouponExistsLazyQuery
>
export type CouponExistsSuspenseQueryHookResult = ReturnType<
  typeof useCouponExistsSuspenseQuery
>
export type CouponExistsQueryResult = Apollo.QueryResult<
  CouponExistsQuery,
  CouponExistsQueryVariables
>
export const CreateCurriculumLicenseOrderDocument = gql`
  mutation CreateCurriculumLicenseOrder(
    $license_offering_id: Int!
    $licensee_school_id: Int!
    $licensor_school_id: Int!
    $name: String!
    $seat_count: Int
    $role: RegistrationRoleEnum
    $coupon_code: String
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createCurriculumLicenseOrder(
      license_offering_id: $license_offering_id
      licensee_school_id: $licensee_school_id
      licensor_school_id: $licensor_school_id
      name: $name
      seat_count: $seat_count
      role: $role
      coupon_code: $coupon_code
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateCurriculumLicenseOrderMutationFn = Apollo.MutationFunction<
  CreateCurriculumLicenseOrderMutation,
  CreateCurriculumLicenseOrderMutationVariables
>

/**
 * __useCreateCurriculumLicenseOrderMutation__
 *
 * To run a mutation, you first call `useCreateCurriculumLicenseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurriculumLicenseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurriculumLicenseOrderMutation, { data, loading, error }] = useCreateCurriculumLicenseOrderMutation({
 *   variables: {
 *      license_offering_id: // value for 'license_offering_id'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      licensor_school_id: // value for 'licensor_school_id'
 *      name: // value for 'name'
 *      seat_count: // value for 'seat_count'
 *      role: // value for 'role'
 *      coupon_code: // value for 'coupon_code'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateCurriculumLicenseOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurriculumLicenseOrderMutation,
    CreateCurriculumLicenseOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCurriculumLicenseOrderMutation,
    CreateCurriculumLicenseOrderMutationVariables
  >(CreateCurriculumLicenseOrderDocument, options)
}
export type CreateCurriculumLicenseOrderMutationHookResult = ReturnType<
  typeof useCreateCurriculumLicenseOrderMutation
>
export type CreateCurriculumLicenseOrderMutationResult =
  Apollo.MutationResult<CreateCurriculumLicenseOrderMutation>
export type CreateCurriculumLicenseOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreateCurriculumLicenseOrderMutation,
    CreateCurriculumLicenseOrderMutationVariables
  >
export const CreateCurriculumSubscriptionOrderDocument = gql`
  mutation CreateCurriculumSubscriptionOrder(
    $curriculum_plan_id: Int!
    $plan_visibility_code: String
    $licensee_id: Int!
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createCurriculumSubscriptionOrder(
      curriculum_plan_id: $curriculum_plan_id
      plan_visibility_code: $plan_visibility_code
      licensee_id: $licensee_id
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateCurriculumSubscriptionOrderMutationFn =
  Apollo.MutationFunction<
    CreateCurriculumSubscriptionOrderMutation,
    CreateCurriculumSubscriptionOrderMutationVariables
  >

/**
 * __useCreateCurriculumSubscriptionOrderMutation__
 *
 * To run a mutation, you first call `useCreateCurriculumSubscriptionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurriculumSubscriptionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurriculumSubscriptionOrderMutation, { data, loading, error }] = useCreateCurriculumSubscriptionOrderMutation({
 *   variables: {
 *      curriculum_plan_id: // value for 'curriculum_plan_id'
 *      plan_visibility_code: // value for 'plan_visibility_code'
 *      licensee_id: // value for 'licensee_id'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateCurriculumSubscriptionOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurriculumSubscriptionOrderMutation,
    CreateCurriculumSubscriptionOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCurriculumSubscriptionOrderMutation,
    CreateCurriculumSubscriptionOrderMutationVariables
  >(CreateCurriculumSubscriptionOrderDocument, options)
}
export type CreateCurriculumSubscriptionOrderMutationHookResult = ReturnType<
  typeof useCreateCurriculumSubscriptionOrderMutation
>
export type CreateCurriculumSubscriptionOrderMutationResult =
  Apollo.MutationResult<CreateCurriculumSubscriptionOrderMutation>
export type CreateCurriculumSubscriptionOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreateCurriculumSubscriptionOrderMutation,
    CreateCurriculumSubscriptionOrderMutationVariables
  >
export const CreateGiftSubscriptionOrderDocument = gql`
  mutation CreateGiftSubscriptionOrder(
    $plan_id: Int!
    $plan_visibility_code: String
    $num_cycles: Int!
    $recipient_first_name: String!
    $recipient_last_name: String!
    $gift_message: String
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createGiftSubscriptionOrder(
      plan_id: $plan_id
      plan_visibility_code: $plan_visibility_code
      num_cycles: $num_cycles
      recipient_first_name: $recipient_first_name
      recipient_last_name: $recipient_last_name
      gift_message: $gift_message
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateGiftSubscriptionOrderMutationFn = Apollo.MutationFunction<
  CreateGiftSubscriptionOrderMutation,
  CreateGiftSubscriptionOrderMutationVariables
>

/**
 * __useCreateGiftSubscriptionOrderMutation__
 *
 * To run a mutation, you first call `useCreateGiftSubscriptionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftSubscriptionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftSubscriptionOrderMutation, { data, loading, error }] = useCreateGiftSubscriptionOrderMutation({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      plan_visibility_code: // value for 'plan_visibility_code'
 *      num_cycles: // value for 'num_cycles'
 *      recipient_first_name: // value for 'recipient_first_name'
 *      recipient_last_name: // value for 'recipient_last_name'
 *      gift_message: // value for 'gift_message'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateGiftSubscriptionOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGiftSubscriptionOrderMutation,
    CreateGiftSubscriptionOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateGiftSubscriptionOrderMutation,
    CreateGiftSubscriptionOrderMutationVariables
  >(CreateGiftSubscriptionOrderDocument, options)
}
export type CreateGiftSubscriptionOrderMutationHookResult = ReturnType<
  typeof useCreateGiftSubscriptionOrderMutation
>
export type CreateGiftSubscriptionOrderMutationResult =
  Apollo.MutationResult<CreateGiftSubscriptionOrderMutation>
export type CreateGiftSubscriptionOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreateGiftSubscriptionOrderMutation,
    CreateGiftSubscriptionOrderMutationVariables
  >
export const CreateGroupLicenseOrderDocument = gql`
  mutation CreateGroupLicenseOrder(
    $license_offering_id: Int!
    $name: String!
    $seat_count: Int
    $role: RegistrationRoleEnum
    $coupon_code: String
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createGroupLicenseOrder(
      license_offering_id: $license_offering_id
      name: $name
      seat_count: $seat_count
      role: $role
      coupon_code: $coupon_code
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateGroupLicenseOrderMutationFn = Apollo.MutationFunction<
  CreateGroupLicenseOrderMutation,
  CreateGroupLicenseOrderMutationVariables
>

/**
 * __useCreateGroupLicenseOrderMutation__
 *
 * To run a mutation, you first call `useCreateGroupLicenseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupLicenseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupLicenseOrderMutation, { data, loading, error }] = useCreateGroupLicenseOrderMutation({
 *   variables: {
 *      license_offering_id: // value for 'license_offering_id'
 *      name: // value for 'name'
 *      seat_count: // value for 'seat_count'
 *      role: // value for 'role'
 *      coupon_code: // value for 'coupon_code'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateGroupLicenseOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupLicenseOrderMutation,
    CreateGroupLicenseOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateGroupLicenseOrderMutation,
    CreateGroupLicenseOrderMutationVariables
  >(CreateGroupLicenseOrderDocument, options)
}
export type CreateGroupLicenseOrderMutationHookResult = ReturnType<
  typeof useCreateGroupLicenseOrderMutation
>
export type CreateGroupLicenseOrderMutationResult =
  Apollo.MutationResult<CreateGroupLicenseOrderMutation>
export type CreateGroupLicenseOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupLicenseOrderMutation,
  CreateGroupLicenseOrderMutationVariables
>
export const CreateGroupSubscriptionOrderDocument = gql`
  mutation CreateGroupSubscriptionOrder(
    $price_id: Int!
    $quantity: Int!
    $group_name: String!
    $reactivate_group_subscription_id: Int
    $redirect_to: String
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createGroupSubscriptionOrder(
      price_id: $price_id
      quantity: $quantity
      group_name: $group_name
      reactivate_group_subscription_id: $reactivate_group_subscription_id
      redirect_to: $redirect_to
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateGroupSubscriptionOrderMutationFn = Apollo.MutationFunction<
  CreateGroupSubscriptionOrderMutation,
  CreateGroupSubscriptionOrderMutationVariables
>

/**
 * __useCreateGroupSubscriptionOrderMutation__
 *
 * To run a mutation, you first call `useCreateGroupSubscriptionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupSubscriptionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupSubscriptionOrderMutation, { data, loading, error }] = useCreateGroupSubscriptionOrderMutation({
 *   variables: {
 *      price_id: // value for 'price_id'
 *      quantity: // value for 'quantity'
 *      group_name: // value for 'group_name'
 *      reactivate_group_subscription_id: // value for 'reactivate_group_subscription_id'
 *      redirect_to: // value for 'redirect_to'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateGroupSubscriptionOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupSubscriptionOrderMutation,
    CreateGroupSubscriptionOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateGroupSubscriptionOrderMutation,
    CreateGroupSubscriptionOrderMutationVariables
  >(CreateGroupSubscriptionOrderDocument, options)
}
export type CreateGroupSubscriptionOrderMutationHookResult = ReturnType<
  typeof useCreateGroupSubscriptionOrderMutation
>
export type CreateGroupSubscriptionOrderMutationResult =
  Apollo.MutationResult<CreateGroupSubscriptionOrderMutation>
export type CreateGroupSubscriptionOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreateGroupSubscriptionOrderMutation,
    CreateGroupSubscriptionOrderMutationVariables
  >
export const CreateLifetimeSchoolSubscriptionOrderDocument = gql`
  mutation CreateLifetimeSchoolSubscriptionOrder(
    $plan_id: Int!
    $plan_visibility_code: String
    $coupon_code: String
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createLifetimeSchoolSubscriptionOrder(
      plan_id: $plan_id
      plan_visibility_code: $plan_visibility_code
      coupon_code: $coupon_code
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateLifetimeSchoolSubscriptionOrderMutationFn =
  Apollo.MutationFunction<
    CreateLifetimeSchoolSubscriptionOrderMutation,
    CreateLifetimeSchoolSubscriptionOrderMutationVariables
  >

/**
 * __useCreateLifetimeSchoolSubscriptionOrderMutation__
 *
 * To run a mutation, you first call `useCreateLifetimeSchoolSubscriptionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLifetimeSchoolSubscriptionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLifetimeSchoolSubscriptionOrderMutation, { data, loading, error }] = useCreateLifetimeSchoolSubscriptionOrderMutation({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      plan_visibility_code: // value for 'plan_visibility_code'
 *      coupon_code: // value for 'coupon_code'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateLifetimeSchoolSubscriptionOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLifetimeSchoolSubscriptionOrderMutation,
    CreateLifetimeSchoolSubscriptionOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateLifetimeSchoolSubscriptionOrderMutation,
    CreateLifetimeSchoolSubscriptionOrderMutationVariables
  >(CreateLifetimeSchoolSubscriptionOrderDocument, options)
}
export type CreateLifetimeSchoolSubscriptionOrderMutationHookResult =
  ReturnType<typeof useCreateLifetimeSchoolSubscriptionOrderMutation>
export type CreateLifetimeSchoolSubscriptionOrderMutationResult =
  Apollo.MutationResult<CreateLifetimeSchoolSubscriptionOrderMutation>
export type CreateLifetimeSchoolSubscriptionOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreateLifetimeSchoolSubscriptionOrderMutation,
    CreateLifetimeSchoolSubscriptionOrderMutationVariables
  >
export const CreatePlatformSubscriptionOrderDocument = gql`
  mutation CreatePlatformSubscriptionOrder(
    $billing_plan_id: Int!
    $interval: Int!
    $schoolId: Int
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createPlatformSubscriptionOrder(
      billing_plan_id: $billing_plan_id
      interval: $interval
      school_id: $schoolId
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreatePlatformSubscriptionOrderMutationFn = Apollo.MutationFunction<
  CreatePlatformSubscriptionOrderMutation,
  CreatePlatformSubscriptionOrderMutationVariables
>

/**
 * __useCreatePlatformSubscriptionOrderMutation__
 *
 * To run a mutation, you first call `useCreatePlatformSubscriptionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformSubscriptionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlatformSubscriptionOrderMutation, { data, loading, error }] = useCreatePlatformSubscriptionOrderMutation({
 *   variables: {
 *      billing_plan_id: // value for 'billing_plan_id'
 *      interval: // value for 'interval'
 *      schoolId: // value for 'schoolId'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreatePlatformSubscriptionOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlatformSubscriptionOrderMutation,
    CreatePlatformSubscriptionOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreatePlatformSubscriptionOrderMutation,
    CreatePlatformSubscriptionOrderMutationVariables
  >(CreatePlatformSubscriptionOrderDocument, options)
}
export type CreatePlatformSubscriptionOrderMutationHookResult = ReturnType<
  typeof useCreatePlatformSubscriptionOrderMutation
>
export type CreatePlatformSubscriptionOrderMutationResult =
  Apollo.MutationResult<CreatePlatformSubscriptionOrderMutation>
export type CreatePlatformSubscriptionOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreatePlatformSubscriptionOrderMutation,
    CreatePlatformSubscriptionOrderMutationVariables
  >
export const CreateRegistrationOrderDocument = gql`
  mutation CreateRegistrationOrder(
    $offering_id: Int!
    $coupon_code: String
    $invitation_code: String
    $use_subscription_plan_id: Int
    $use_group_subscription_id: Int
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createRegistrationOrder(
      offering_id: $offering_id
      coupon_code: $coupon_code
      invitation_code: $invitation_code
      use_subscription_plan_id: $use_subscription_plan_id
      use_group_subscription_id: $use_group_subscription_id
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateRegistrationOrderMutationFn = Apollo.MutationFunction<
  CreateRegistrationOrderMutation,
  CreateRegistrationOrderMutationVariables
>

/**
 * __useCreateRegistrationOrderMutation__
 *
 * To run a mutation, you first call `useCreateRegistrationOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistrationOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistrationOrderMutation, { data, loading, error }] = useCreateRegistrationOrderMutation({
 *   variables: {
 *      offering_id: // value for 'offering_id'
 *      coupon_code: // value for 'coupon_code'
 *      invitation_code: // value for 'invitation_code'
 *      use_subscription_plan_id: // value for 'use_subscription_plan_id'
 *      use_group_subscription_id: // value for 'use_group_subscription_id'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateRegistrationOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRegistrationOrderMutation,
    CreateRegistrationOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateRegistrationOrderMutation,
    CreateRegistrationOrderMutationVariables
  >(CreateRegistrationOrderDocument, options)
}
export type CreateRegistrationOrderMutationHookResult = ReturnType<
  typeof useCreateRegistrationOrderMutation
>
export type CreateRegistrationOrderMutationResult =
  Apollo.MutationResult<CreateRegistrationOrderMutation>
export type CreateRegistrationOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateRegistrationOrderMutation,
  CreateRegistrationOrderMutationVariables
>
export const CreateSchoolSubscriptionOrderDocument = gql`
  mutation CreateSchoolSubscriptionOrder(
    $plan_id: Int!
    $plan_visibility_code: String
    $start_free_trial: Boolean
    $coupon_code: String
    $redirect_to: String
    $stripe_checkout_redirects: OrderStripeCheckoutRedirects
  ) {
    createSchoolSubscriptionOrder(
      plan_id: $plan_id
      plan_visibility_code: $plan_visibility_code
      start_free_trial: $start_free_trial
      coupon_code: $coupon_code
      redirect_to: $redirect_to
      stripe_checkout_redirects: $stripe_checkout_redirects
    ) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`
export type CreateSchoolSubscriptionOrderMutationFn = Apollo.MutationFunction<
  CreateSchoolSubscriptionOrderMutation,
  CreateSchoolSubscriptionOrderMutationVariables
>

/**
 * __useCreateSchoolSubscriptionOrderMutation__
 *
 * To run a mutation, you first call `useCreateSchoolSubscriptionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolSubscriptionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolSubscriptionOrderMutation, { data, loading, error }] = useCreateSchoolSubscriptionOrderMutation({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      plan_visibility_code: // value for 'plan_visibility_code'
 *      start_free_trial: // value for 'start_free_trial'
 *      coupon_code: // value for 'coupon_code'
 *      redirect_to: // value for 'redirect_to'
 *      stripe_checkout_redirects: // value for 'stripe_checkout_redirects'
 *   },
 * });
 */
export function useCreateSchoolSubscriptionOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSchoolSubscriptionOrderMutation,
    CreateSchoolSubscriptionOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateSchoolSubscriptionOrderMutation,
    CreateSchoolSubscriptionOrderMutationVariables
  >(CreateSchoolSubscriptionOrderDocument, options)
}
export type CreateSchoolSubscriptionOrderMutationHookResult = ReturnType<
  typeof useCreateSchoolSubscriptionOrderMutation
>
export type CreateSchoolSubscriptionOrderMutationResult =
  Apollo.MutationResult<CreateSchoolSubscriptionOrderMutation>
export type CreateSchoolSubscriptionOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSchoolSubscriptionOrderMutation,
    CreateSchoolSubscriptionOrderMutationVariables
  >
export const OrderDocument = gql`
  query Order($id: Int!) {
    order(id: $id) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(
  baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables> &
    ({ variables: OrderQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrderQuery, OrderQueryVariables>(
    OrderDocument,
    options
  )
}
export function useOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(
    OrderDocument,
    options
  )
}
export function useOrderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrderQuery, OrderQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OrderQuery, OrderQueryVariables>(
    OrderDocument,
    options
  )
}
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>
export type OrderSuspenseQueryHookResult = ReturnType<
  typeof useOrderSuspenseQuery
>
export type OrderQueryResult = Apollo.QueryResult<
  OrderQuery,
  OrderQueryVariables
>
export const PackageAssignmentDocument = gql`
  query PackageAssignment {
    packageAssignment {
      id
      school_id
      school_signup_config_id
      selected_by_user
      rewardful_referral_id
      utm_source
      utm_medium
      utm_campaign
      assignment_rule {
        id
        assignment_type
        explicit_key
        store_id
        rewardful_referral_id
        utm_source
        utm_medium
        utm_campaign
      }
      package {
        ...Package
      }
    }
  }
  ${PackageFragmentDoc}
`

/**
 * __usePackageAssignmentQuery__
 *
 * To run a query within a React component, call `usePackageAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageAssignmentQuery({
 *   variables: {
 *   },
 * });
 */
export function usePackageAssignmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PackageAssignmentQuery,
    PackageAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PackageAssignmentQuery,
    PackageAssignmentQueryVariables
  >(PackageAssignmentDocument, options)
}
export function usePackageAssignmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PackageAssignmentQuery,
    PackageAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PackageAssignmentQuery,
    PackageAssignmentQueryVariables
  >(PackageAssignmentDocument, options)
}
export function usePackageAssignmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PackageAssignmentQuery,
        PackageAssignmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PackageAssignmentQuery,
    PackageAssignmentQueryVariables
  >(PackageAssignmentDocument, options)
}
export type PackageAssignmentQueryHookResult = ReturnType<
  typeof usePackageAssignmentQuery
>
export type PackageAssignmentLazyQueryHookResult = ReturnType<
  typeof usePackageAssignmentLazyQuery
>
export type PackageAssignmentSuspenseQueryHookResult = ReturnType<
  typeof usePackageAssignmentSuspenseQuery
>
export type PackageAssignmentQueryResult = Apollo.QueryResult<
  PackageAssignmentQuery,
  PackageAssignmentQueryVariables
>
export const PackageDocument = gql`
  query Package(
    $signup_config_key: String
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
    $rewardful_referral_id: String
  ) {
    package(
      signup_config_key: $signup_config_key
      utm_source: $utm_source
      utm_medium: $utm_medium
      utm_campaign: $utm_campaign
      rewardful_referral_id: $rewardful_referral_id
    ) {
      ...Package
    }
  }
  ${PackageFragmentDoc}
`

/**
 * __usePackageQuery__
 *
 * To run a query within a React component, call `usePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageQuery({
 *   variables: {
 *      signup_config_key: // value for 'signup_config_key'
 *      utm_source: // value for 'utm_source'
 *      utm_medium: // value for 'utm_medium'
 *      utm_campaign: // value for 'utm_campaign'
 *      rewardful_referral_id: // value for 'rewardful_referral_id'
 *   },
 * });
 */
export function usePackageQuery(
  baseOptions?: Apollo.QueryHookOptions<PackageQuery, PackageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PackageQuery, PackageQueryVariables>(
    PackageDocument,
    options
  )
}
export function usePackageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PackageQuery, PackageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PackageQuery, PackageQueryVariables>(
    PackageDocument,
    options
  )
}
export function usePackageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PackageQuery, PackageQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PackageQuery, PackageQueryVariables>(
    PackageDocument,
    options
  )
}
export type PackageQueryHookResult = ReturnType<typeof usePackageQuery>
export type PackageLazyQueryHookResult = ReturnType<typeof usePackageLazyQuery>
export type PackageSuspenseQueryHookResult = ReturnType<
  typeof usePackageSuspenseQuery
>
export type PackageQueryResult = Apollo.QueryResult<
  PackageQuery,
  PackageQueryVariables
>
export const PackagesForAdminDocument = gql`
  query PackagesForAdmin {
    packages {
      id
      key
      name
      display_name
      assignment_rules {
        id
        assignment_type
        explicit_key
        store_id
        rewardful_referral_id
        utm_source
        utm_medium
        utm_campaign
      }
    }
  }
`

/**
 * __usePackagesForAdminQuery__
 *
 * To run a query within a React component, call `usePackagesForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesForAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function usePackagesForAdminQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PackagesForAdminQuery,
    PackagesForAdminQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PackagesForAdminQuery, PackagesForAdminQueryVariables>(
    PackagesForAdminDocument,
    options
  )
}
export function usePackagesForAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PackagesForAdminQuery,
    PackagesForAdminQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PackagesForAdminQuery,
    PackagesForAdminQueryVariables
  >(PackagesForAdminDocument, options)
}
export function usePackagesForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PackagesForAdminQuery,
        PackagesForAdminQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PackagesForAdminQuery,
    PackagesForAdminQueryVariables
  >(PackagesForAdminDocument, options)
}
export type PackagesForAdminQueryHookResult = ReturnType<
  typeof usePackagesForAdminQuery
>
export type PackagesForAdminLazyQueryHookResult = ReturnType<
  typeof usePackagesForAdminLazyQuery
>
export type PackagesForAdminSuspenseQueryHookResult = ReturnType<
  typeof usePackagesForAdminSuspenseQuery
>
export type PackagesForAdminQueryResult = Apollo.QueryResult<
  PackagesForAdminQuery,
  PackagesForAdminQueryVariables
>
export const LicensorsDocument = gql`
  query Licensors {
    storeLinks(first: 1042) {
      edges {
        node {
          ...StoreLink
          store {
            licensor {
              ...Licensor
            }
          }
        }
      }
    }
    school {
      ...School
      curriculum_subscriptions(first: 1042) {
        edges {
          node {
            ...CurriculumSubscription
            licensor {
              ...Licensor
            }
          }
        }
      }
    }
  }
  ${StoreLinkFragmentDoc}
  ${LicensorFragmentDoc}
  ${SchoolFragmentDoc}
  ${CurriculumSubscriptionFragmentDoc}
`

/**
 * __useLicensorsQuery__
 *
 * To run a query within a React component, call `useLicensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicensorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicensorsQuery(
  baseOptions?: Apollo.QueryHookOptions<LicensorsQuery, LicensorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LicensorsQuery, LicensorsQueryVariables>(
    LicensorsDocument,
    options
  )
}
export function useLicensorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LicensorsQuery,
    LicensorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LicensorsQuery, LicensorsQueryVariables>(
    LicensorsDocument,
    options
  )
}
export function useLicensorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LicensorsQuery, LicensorsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<LicensorsQuery, LicensorsQueryVariables>(
    LicensorsDocument,
    options
  )
}
export type LicensorsQueryHookResult = ReturnType<typeof useLicensorsQuery>
export type LicensorsLazyQueryHookResult = ReturnType<
  typeof useLicensorsLazyQuery
>
export type LicensorsSuspenseQueryHookResult = ReturnType<
  typeof useLicensorsSuspenseQuery
>
export type LicensorsQueryResult = Apollo.QueryResult<
  LicensorsQuery,
  LicensorsQueryVariables
>
export const PathCreatorAssignRoleDocument = gql`
  mutation PathCreatorAssignRole(
    $cohorts: [Int]!
    $user: Int!
    $role: RegistrationRoleEnum!
    $sendNotification: Boolean = false
    $message: String
  ) {
    assign(
      offerings: $cohorts
      assign_to_user: $user
      role: $role
      send_notification: $sendNotification
      assignment_message: $message
    )
  }
`
export type PathCreatorAssignRoleMutationFn = Apollo.MutationFunction<
  PathCreatorAssignRoleMutation,
  PathCreatorAssignRoleMutationVariables
>

/**
 * __usePathCreatorAssignRoleMutation__
 *
 * To run a mutation, you first call `usePathCreatorAssignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorAssignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathCreatorAssignRoleMutation, { data, loading, error }] = usePathCreatorAssignRoleMutation({
 *   variables: {
 *      cohorts: // value for 'cohorts'
 *      user: // value for 'user'
 *      role: // value for 'role'
 *      sendNotification: // value for 'sendNotification'
 *      message: // value for 'message'
 *   },
 * });
 */
export function usePathCreatorAssignRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PathCreatorAssignRoleMutation,
    PathCreatorAssignRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PathCreatorAssignRoleMutation,
    PathCreatorAssignRoleMutationVariables
  >(PathCreatorAssignRoleDocument, options)
}
export type PathCreatorAssignRoleMutationHookResult = ReturnType<
  typeof usePathCreatorAssignRoleMutation
>
export type PathCreatorAssignRoleMutationResult =
  Apollo.MutationResult<PathCreatorAssignRoleMutation>
export type PathCreatorAssignRoleMutationOptions = Apollo.BaseMutationOptions<
  PathCreatorAssignRoleMutation,
  PathCreatorAssignRoleMutationVariables
>
export const PathCreatorCohortsDocument = gql`
  query PathCreatorCohorts($resourceId: Int!, $targetUserId: Int!) {
    cohorts: groups(first: 1042, resource_id: $resourceId) {
      edges {
        node {
          ...PathCreatorCohortWithRegistration
        }
      }
    }
  }
  ${PathCreatorCohortWithRegistrationFragmentDoc}
`

/**
 * __usePathCreatorCohortsQuery__
 *
 * To run a query within a React component, call `usePathCreatorCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathCreatorCohortsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function usePathCreatorCohortsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  > &
    (
      | { variables: PathCreatorCohortsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >(PathCreatorCohortsDocument, options)
}
export function usePathCreatorCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >(PathCreatorCohortsDocument, options)
}
export function usePathCreatorCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathCreatorCohortsQuery,
        PathCreatorCohortsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >(PathCreatorCohortsDocument, options)
}
export type PathCreatorCohortsQueryHookResult = ReturnType<
  typeof usePathCreatorCohortsQuery
>
export type PathCreatorCohortsLazyQueryHookResult = ReturnType<
  typeof usePathCreatorCohortsLazyQuery
>
export type PathCreatorCohortsSuspenseQueryHookResult = ReturnType<
  typeof usePathCreatorCohortsSuspenseQuery
>
export type PathCreatorCohortsQueryResult = Apollo.QueryResult<
  PathCreatorCohortsQuery,
  PathCreatorCohortsQueryVariables
>
export const PathCreatorCreateCohortDocument = gql`
  mutation PathCreatorCreateCohort($resourceId: Int!, $name: String!) {
    createCohort: createGroup(
      base_resource_id: $resourceId
      visibility: 5
      name: $name
    ) {
      ...PathCreatorCohort
    }
  }
  ${PathCreatorCohortFragmentDoc}
`
export type PathCreatorCreateCohortMutationFn = Apollo.MutationFunction<
  PathCreatorCreateCohortMutation,
  PathCreatorCreateCohortMutationVariables
>

/**
 * __usePathCreatorCreateCohortMutation__
 *
 * To run a mutation, you first call `usePathCreatorCreateCohortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorCreateCohortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathCreatorCreateCohortMutation, { data, loading, error }] = usePathCreatorCreateCohortMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePathCreatorCreateCohortMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PathCreatorCreateCohortMutation,
    PathCreatorCreateCohortMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PathCreatorCreateCohortMutation,
    PathCreatorCreateCohortMutationVariables
  >(PathCreatorCreateCohortDocument, options)
}
export type PathCreatorCreateCohortMutationHookResult = ReturnType<
  typeof usePathCreatorCreateCohortMutation
>
export type PathCreatorCreateCohortMutationResult =
  Apollo.MutationResult<PathCreatorCreateCohortMutation>
export type PathCreatorCreateCohortMutationOptions = Apollo.BaseMutationOptions<
  PathCreatorCreateCohortMutation,
  PathCreatorCreateCohortMutationVariables
>
export const PathCreatorCreatePathDocument = gql`
  mutation PathCreatorCreatePath(
    $name: String!
    $image: String!
    $resourceType: ResourceType
    $cohortName: String
  ) {
    createResource(
      name: $name
      cover_image: $image
      resource_type: $resourceType
      group_name: $cohortName
    ) {
      ...PathCreatorCreatePath
    }
  }
  ${PathCreatorCreatePathFragmentDoc}
`
export type PathCreatorCreatePathMutationFn = Apollo.MutationFunction<
  PathCreatorCreatePathMutation,
  PathCreatorCreatePathMutationVariables
>

/**
 * __usePathCreatorCreatePathMutation__
 *
 * To run a mutation, you first call `usePathCreatorCreatePathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorCreatePathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathCreatorCreatePathMutation, { data, loading, error }] = usePathCreatorCreatePathMutation({
 *   variables: {
 *      name: // value for 'name'
 *      image: // value for 'image'
 *      resourceType: // value for 'resourceType'
 *      cohortName: // value for 'cohortName'
 *   },
 * });
 */
export function usePathCreatorCreatePathMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PathCreatorCreatePathMutation,
    PathCreatorCreatePathMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PathCreatorCreatePathMutation,
    PathCreatorCreatePathMutationVariables
  >(PathCreatorCreatePathDocument, options)
}
export type PathCreatorCreatePathMutationHookResult = ReturnType<
  typeof usePathCreatorCreatePathMutation
>
export type PathCreatorCreatePathMutationResult =
  Apollo.MutationResult<PathCreatorCreatePathMutation>
export type PathCreatorCreatePathMutationOptions = Apollo.BaseMutationOptions<
  PathCreatorCreatePathMutation,
  PathCreatorCreatePathMutationVariables
>
export const PathCreatorRandomResourceImageDocument = gql`
  query PathCreatorRandomResourceImage($themeType: ThemeType) {
    resourceImage(
      theme_type: $themeType
      image: [
        { width: 240, height: 180, fit: crop }
        {
          width: 250
          height: 250
          blur: 500
          high: -80
          blend: 666666
          balph: 40
          fm: "jpg"
          q: 100
          bm: "screen"
        }
      ]
    )
  }
`

/**
 * __usePathCreatorRandomResourceImageQuery__
 *
 * To run a query within a React component, call `usePathCreatorRandomResourceImageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorRandomResourceImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathCreatorRandomResourceImageQuery({
 *   variables: {
 *      themeType: // value for 'themeType'
 *   },
 * });
 */
export function usePathCreatorRandomResourceImageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >(PathCreatorRandomResourceImageDocument, options)
}
export function usePathCreatorRandomResourceImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >(PathCreatorRandomResourceImageDocument, options)
}
export function usePathCreatorRandomResourceImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathCreatorRandomResourceImageQuery,
        PathCreatorRandomResourceImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >(PathCreatorRandomResourceImageDocument, options)
}
export type PathCreatorRandomResourceImageQueryHookResult = ReturnType<
  typeof usePathCreatorRandomResourceImageQuery
>
export type PathCreatorRandomResourceImageLazyQueryHookResult = ReturnType<
  typeof usePathCreatorRandomResourceImageLazyQuery
>
export type PathCreatorRandomResourceImageSuspenseQueryHookResult = ReturnType<
  typeof usePathCreatorRandomResourceImageSuspenseQuery
>
export type PathCreatorRandomResourceImageQueryResult = Apollo.QueryResult<
  PathCreatorRandomResourceImageQuery,
  PathCreatorRandomResourceImageQueryVariables
>
export const PathCreatorResourcesDocument = gql`
  query PathCreatorResources {
    resources(first: 1042) {
      edges {
        node {
          ...PathCreatorResource
        }
      }
    }
  }
  ${PathCreatorResourceFragmentDoc}
`

/**
 * __usePathCreatorResourcesQuery__
 *
 * To run a query within a React component, call `usePathCreatorResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathCreatorResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathCreatorResourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >(PathCreatorResourcesDocument, options)
}
export function usePathCreatorResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >(PathCreatorResourcesDocument, options)
}
export function usePathCreatorResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathCreatorResourcesQuery,
        PathCreatorResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >(PathCreatorResourcesDocument, options)
}
export type PathCreatorResourcesQueryHookResult = ReturnType<
  typeof usePathCreatorResourcesQuery
>
export type PathCreatorResourcesLazyQueryHookResult = ReturnType<
  typeof usePathCreatorResourcesLazyQuery
>
export type PathCreatorResourcesSuspenseQueryHookResult = ReturnType<
  typeof usePathCreatorResourcesSuspenseQuery
>
export type PathCreatorResourcesQueryResult = Apollo.QueryResult<
  PathCreatorResourcesQuery,
  PathCreatorResourcesQueryVariables
>
export const CohortSyncPathDocument = gql`
  query CohortSyncPath($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      ...CohortSyncPathCohort
    }
  }
  ${CohortSyncPathCohortFragmentDoc}
`

/**
 * __useCohortSyncPathQuery__
 *
 * To run a query within a React component, call `useCohortSyncPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortSyncPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortSyncPathQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useCohortSyncPathQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortSyncPathQuery,
    CohortSyncPathQueryVariables
  > &
    (
      | { variables: CohortSyncPathQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortSyncPathQuery, CohortSyncPathQueryVariables>(
    CohortSyncPathDocument,
    options
  )
}
export function useCohortSyncPathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortSyncPathQuery,
    CohortSyncPathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortSyncPathQuery, CohortSyncPathQueryVariables>(
    CohortSyncPathDocument,
    options
  )
}
export function useCohortSyncPathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortSyncPathQuery,
        CohortSyncPathQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortSyncPathQuery,
    CohortSyncPathQueryVariables
  >(CohortSyncPathDocument, options)
}
export type CohortSyncPathQueryHookResult = ReturnType<
  typeof useCohortSyncPathQuery
>
export type CohortSyncPathLazyQueryHookResult = ReturnType<
  typeof useCohortSyncPathLazyQuery
>
export type CohortSyncPathSuspenseQueryHookResult = ReturnType<
  typeof useCohortSyncPathSuspenseQuery
>
export type CohortSyncPathQueryResult = Apollo.QueryResult<
  CohortSyncPathQuery,
  CohortSyncPathQueryVariables
>
export const CompletePathItemDocument = gql`
  mutation CompletePathItem(
    $id: Int!
    $path_id: Int!
    $skip: Boolean
    $completion_data: JSON
  ) {
    completePathItem(
      id: $id
      path_id: $path_id
      skip: $skip
      completion_data: $completion_data
    ) {
      ...PathItem
      path {
        id
        progress
        points {
          path_id
          total
          earned
          total_points_possible
          percentage
          has_points
        }
        next_step_id
        completion_date
      }
    }
  }
  ${PathItemFragmentDoc}
`
export type CompletePathItemMutationFn = Apollo.MutationFunction<
  CompletePathItemMutation,
  CompletePathItemMutationVariables
>

/**
 * __useCompletePathItemMutation__
 *
 * To run a mutation, you first call `useCompletePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePathItemMutation, { data, loading, error }] = useCompletePathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *      skip: // value for 'skip'
 *      completion_data: // value for 'completion_data'
 *   },
 * });
 */
export function useCompletePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletePathItemMutation,
    CompletePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CompletePathItemMutation,
    CompletePathItemMutationVariables
  >(CompletePathItemDocument, options)
}
export type CompletePathItemMutationHookResult = ReturnType<
  typeof useCompletePathItemMutation
>
export type CompletePathItemMutationResult =
  Apollo.MutationResult<CompletePathItemMutation>
export type CompletePathItemMutationOptions = Apollo.BaseMutationOptions<
  CompletePathItemMutation,
  CompletePathItemMutationVariables
>
export const CreatePathItemDocument = gql`
  mutation CreatePathItem(
    $path_id: Int!
    $order: Int!
    $name: String!
    $type: PathItemType!
    $assignment_type: PathItemAssignmentType
    $parent: Int
    $description: String
    $content_type: String
    $content_resource: Int
  ) {
    createPathItem(
      path_id: $path_id
      order: $order
      name: $name
      type: $type
      assignment_type: $assignment_type
      parent: $parent
      description: $description
      content_type: $content_type
      content_resource: $content_resource
    ) {
      ...AddedPathItem
    }
  }
  ${AddedPathItemFragmentDoc}
`
export type CreatePathItemMutationFn = Apollo.MutationFunction<
  CreatePathItemMutation,
  CreatePathItemMutationVariables
>

/**
 * __useCreatePathItemMutation__
 *
 * To run a mutation, you first call `useCreatePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathItemMutation, { data, loading, error }] = useCreatePathItemMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      order: // value for 'order'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      assignment_type: // value for 'assignment_type'
 *      parent: // value for 'parent'
 *      description: // value for 'description'
 *      content_type: // value for 'content_type'
 *      content_resource: // value for 'content_resource'
 *   },
 * });
 */
export function useCreatePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePathItemMutation,
    CreatePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreatePathItemMutation,
    CreatePathItemMutationVariables
  >(CreatePathItemDocument, options)
}
export type CreatePathItemMutationHookResult = ReturnType<
  typeof useCreatePathItemMutation
>
export type CreatePathItemMutationResult =
  Apollo.MutationResult<CreatePathItemMutation>
export type CreatePathItemMutationOptions = Apollo.BaseMutationOptions<
  CreatePathItemMutation,
  CreatePathItemMutationVariables
>
export const CreateRegistrationUpsertGroupDocument = gql`
  mutation CreateRegistrationUpsertGroup(
    $resource_id: Int!
    $parent_offering_id: Int!
    $step_source_id: Int!
    $createrRegistration: Boolean = false
  ) {
    createRegistrationUpsertGroup(
      resource_id: $resource_id
      parent_offering_id: $parent_offering_id
      step_source_id: $step_source_id
      create_registration: $createrRegistration
    ) {
      ...Group
      user_registration {
        ...Registration
        path {
          id
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${RegistrationFragmentDoc}
`
export type CreateRegistrationUpsertGroupMutationFn = Apollo.MutationFunction<
  CreateRegistrationUpsertGroupMutation,
  CreateRegistrationUpsertGroupMutationVariables
>

/**
 * __useCreateRegistrationUpsertGroupMutation__
 *
 * To run a mutation, you first call `useCreateRegistrationUpsertGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistrationUpsertGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistrationUpsertGroupMutation, { data, loading, error }] = useCreateRegistrationUpsertGroupMutation({
 *   variables: {
 *      resource_id: // value for 'resource_id'
 *      parent_offering_id: // value for 'parent_offering_id'
 *      step_source_id: // value for 'step_source_id'
 *      createrRegistration: // value for 'createrRegistration'
 *   },
 * });
 */
export function useCreateRegistrationUpsertGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRegistrationUpsertGroupMutation,
    CreateRegistrationUpsertGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateRegistrationUpsertGroupMutation,
    CreateRegistrationUpsertGroupMutationVariables
  >(CreateRegistrationUpsertGroupDocument, options)
}
export type CreateRegistrationUpsertGroupMutationHookResult = ReturnType<
  typeof useCreateRegistrationUpsertGroupMutation
>
export type CreateRegistrationUpsertGroupMutationResult =
  Apollo.MutationResult<CreateRegistrationUpsertGroupMutation>
export type CreateRegistrationUpsertGroupMutationOptions =
  Apollo.BaseMutationOptions<
    CreateRegistrationUpsertGroupMutation,
    CreateRegistrationUpsertGroupMutationVariables
  >
export const DeletePathItemDocument = gql`
  mutation DeletePathItem($path_id: Int!, $id: Int!) {
    deletePathItem(path_id: $path_id, id: $id) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type DeletePathItemMutationFn = Apollo.MutationFunction<
  DeletePathItemMutation,
  DeletePathItemMutationVariables
>

/**
 * __useDeletePathItemMutation__
 *
 * To run a mutation, you first call `useDeletePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePathItemMutation, { data, loading, error }] = useDeletePathItemMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePathItemMutation,
    DeletePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeletePathItemMutation,
    DeletePathItemMutationVariables
  >(DeletePathItemDocument, options)
}
export type DeletePathItemMutationHookResult = ReturnType<
  typeof useDeletePathItemMutation
>
export type DeletePathItemMutationResult =
  Apollo.MutationResult<DeletePathItemMutation>
export type DeletePathItemMutationOptions = Apollo.BaseMutationOptions<
  DeletePathItemMutation,
  DeletePathItemMutationVariables
>
export const ExecuteSyncPlanDocument = gql`
  mutation ExecuteSyncPlan($sync_plan: PathSyncPlanInput!) {
    executePathSyncPlan(sync_plan: $sync_plan)
  }
`
export type ExecuteSyncPlanMutationFn = Apollo.MutationFunction<
  ExecuteSyncPlanMutation,
  ExecuteSyncPlanMutationVariables
>

/**
 * __useExecuteSyncPlanMutation__
 *
 * To run a mutation, you first call `useExecuteSyncPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteSyncPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeSyncPlanMutation, { data, loading, error }] = useExecuteSyncPlanMutation({
 *   variables: {
 *      sync_plan: // value for 'sync_plan'
 *   },
 * });
 */
export function useExecuteSyncPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteSyncPlanMutation,
    ExecuteSyncPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExecuteSyncPlanMutation,
    ExecuteSyncPlanMutationVariables
  >(ExecuteSyncPlanDocument, options)
}
export type ExecuteSyncPlanMutationHookResult = ReturnType<
  typeof useExecuteSyncPlanMutation
>
export type ExecuteSyncPlanMutationResult =
  Apollo.MutationResult<ExecuteSyncPlanMutation>
export type ExecuteSyncPlanMutationOptions = Apollo.BaseMutationOptions<
  ExecuteSyncPlanMutation,
  ExecuteSyncPlanMutationVariables
>
export const PastePathItemDocument = gql`
  mutation PastePathItem(
    $pathId: Int!
    $itemId: Int!
    $parentId: Int
    $order: Int!
  ) {
    pastePathItem(
      path_id: $pathId
      item_id: $itemId
      parent_id: $parentId
      order: $order
    ) {
      ...AddedPathItem
    }
  }
  ${AddedPathItemFragmentDoc}
`
export type PastePathItemMutationFn = Apollo.MutationFunction<
  PastePathItemMutation,
  PastePathItemMutationVariables
>

/**
 * __usePastePathItemMutation__
 *
 * To run a mutation, you first call `usePastePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePastePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pastePathItemMutation, { data, loading, error }] = usePastePathItemMutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      itemId: // value for 'itemId'
 *      parentId: // value for 'parentId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePastePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PastePathItemMutation,
    PastePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PastePathItemMutation,
    PastePathItemMutationVariables
  >(PastePathItemDocument, options)
}
export type PastePathItemMutationHookResult = ReturnType<
  typeof usePastePathItemMutation
>
export type PastePathItemMutationResult =
  Apollo.MutationResult<PastePathItemMutation>
export type PastePathItemMutationOptions = Apollo.BaseMutationOptions<
  PastePathItemMutation,
  PastePathItemMutationVariables
>
export const PathItemDocument = gql`
  query PathItem(
    $id: Int
    $path_id: Int
    $cohort_id: Int
    $user_id: Int
    $source_id: Int
    $archivedDateFilter: [DateFilter]
  ) {
    pathItem(
      id: $id
      path_id: $path_id
      cohort_id: $cohort_id
      user_id: $user_id
      source_id: $source_id
      archivedDateFilter: $archivedDateFilter
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`

/**
 * __usePathItemQuery__
 *
 * To run a query within a React component, call `usePathItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *      cohort_id: // value for 'cohort_id'
 *      user_id: // value for 'user_id'
 *      source_id: // value for 'source_id'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *   },
 * });
 */
export function usePathItemQuery(
  baseOptions?: Apollo.QueryHookOptions<PathItemQuery, PathItemQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathItemQuery, PathItemQueryVariables>(
    PathItemDocument,
    options
  )
}
export function usePathItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathItemQuery,
    PathItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathItemQuery, PathItemQueryVariables>(
    PathItemDocument,
    options
  )
}
export function usePathItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PathItemQuery, PathItemQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathItemQuery, PathItemQueryVariables>(
    PathItemDocument,
    options
  )
}
export type PathItemQueryHookResult = ReturnType<typeof usePathItemQuery>
export type PathItemLazyQueryHookResult = ReturnType<
  typeof usePathItemLazyQuery
>
export type PathItemSuspenseQueryHookResult = ReturnType<
  typeof usePathItemSuspenseQuery
>
export type PathItemQueryResult = Apollo.QueryResult<
  PathItemQuery,
  PathItemQueryVariables
>
export const PathItemsDocument = gql`
  query PathItems(
    $pathId: Int
    $cohortId: Int
    $sourceId: Int
    $lessonSourceId: Int
    $archivedDateFilter: [DateFilter]
    $cursor: String
  ) {
    pathItems(
      path_id: $pathId
      cohort_id: $cohortId
      source_id: $sourceId
      lesson_source_id: $lessonSourceId
      archivedDateFilter: $archivedDateFilter
      first: 1042
      after: $cursor
    ) {
      edges {
        node {
          ...PathItem
        }
      }
    }
  }
  ${PathItemFragmentDoc}
`

/**
 * __usePathItemsQuery__
 *
 * To run a query within a React component, call `usePathItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathItemsQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      cohortId: // value for 'cohortId'
 *      sourceId: // value for 'sourceId'
 *      lessonSourceId: // value for 'lessonSourceId'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePathItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<PathItemsQuery, PathItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathItemsQuery, PathItemsQueryVariables>(
    PathItemsDocument,
    options
  )
}
export function usePathItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathItemsQuery,
    PathItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathItemsQuery, PathItemsQueryVariables>(
    PathItemsDocument,
    options
  )
}
export function usePathItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PathItemsQuery, PathItemsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathItemsQuery, PathItemsQueryVariables>(
    PathItemsDocument,
    options
  )
}
export type PathItemsQueryHookResult = ReturnType<typeof usePathItemsQuery>
export type PathItemsLazyQueryHookResult = ReturnType<
  typeof usePathItemsLazyQuery
>
export type PathItemsSuspenseQueryHookResult = ReturnType<
  typeof usePathItemsSuspenseQuery
>
export type PathItemsQueryResult = Apollo.QueryResult<
  PathItemsQuery,
  PathItemsQueryVariables
>
export const PathPerformanceDocument = gql`
  query PathPerformance($id: Int!) {
    path(id: $id) {
      id
      performance {
        ...PathPerformance
      }
    }
  }
  ${PathPerformanceFragmentDoc}
`

/**
 * __usePathPerformanceQuery__
 *
 * To run a query within a React component, call `usePathPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathPerformanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePathPerformanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  > &
    (
      | { variables: PathPerformanceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathPerformanceQuery, PathPerformanceQueryVariables>(
    PathPerformanceDocument,
    options
  )
}
export function usePathPerformanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  >(PathPerformanceDocument, options)
}
export function usePathPerformanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathPerformanceQuery,
        PathPerformanceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  >(PathPerformanceDocument, options)
}
export type PathPerformanceQueryHookResult = ReturnType<
  typeof usePathPerformanceQuery
>
export type PathPerformanceLazyQueryHookResult = ReturnType<
  typeof usePathPerformanceLazyQuery
>
export type PathPerformanceSuspenseQueryHookResult = ReturnType<
  typeof usePathPerformanceSuspenseQuery
>
export type PathPerformanceQueryResult = Apollo.QueryResult<
  PathPerformanceQuery,
  PathPerformanceQueryVariables
>
export const PathPublishDocument = gql`
  query PathPublish($cohort_id: Int) {
    path(cohort_id: $cohort_id) {
      id
      publish {
        path_id
        published
        last_published_date
      }
    }
  }
`

/**
 * __usePathPublishQuery__
 *
 * To run a query within a React component, call `usePathPublishQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathPublishQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathPublishQuery({
 *   variables: {
 *      cohort_id: // value for 'cohort_id'
 *   },
 * });
 */
export function usePathPublishQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathPublishQuery,
    PathPublishQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathPublishQuery, PathPublishQueryVariables>(
    PathPublishDocument,
    options
  )
}
export function usePathPublishLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathPublishQuery,
    PathPublishQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathPublishQuery, PathPublishQueryVariables>(
    PathPublishDocument,
    options
  )
}
export function usePathPublishSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathPublishQuery,
        PathPublishQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathPublishQuery, PathPublishQueryVariables>(
    PathPublishDocument,
    options
  )
}
export type PathPublishQueryHookResult = ReturnType<typeof usePathPublishQuery>
export type PathPublishLazyQueryHookResult = ReturnType<
  typeof usePathPublishLazyQuery
>
export type PathPublishSuspenseQueryHookResult = ReturnType<
  typeof usePathPublishSuspenseQuery
>
export type PathPublishQueryResult = Apollo.QueryResult<
  PathPublishQuery,
  PathPublishQueryVariables
>
export const PathDocument = gql`
  query Path(
    $id: Int
    $cohort_id: Int
    $user_id: Int
    $archivedDateFilter: [DateFilter]
  ) {
    path(id: $id, cohort_id: $cohort_id, user_id: $user_id) {
      ...Path
      items(
        first: 1042
        flatten: true
        archivedDateFilter: $archivedDateFilter
      ) {
        edges {
          node {
            ...PathItem
          }
        }
      }
      schedule {
        start {
          behavior
          date
        }
        end {
          behavior
          date
        }
      }
    }
  }
  ${PathFragmentDoc}
  ${PathItemFragmentDoc}
`

/**
 * __usePathQuery__
 *
 * To run a query within a React component, call `usePathQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cohort_id: // value for 'cohort_id'
 *      user_id: // value for 'user_id'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *   },
 * });
 */
export function usePathQuery(
  baseOptions?: Apollo.QueryHookOptions<PathQuery, PathQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathQuery, PathQueryVariables>(PathDocument, options)
}
export function usePathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PathQuery, PathQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathQuery, PathQueryVariables>(
    PathDocument,
    options
  )
}
export function usePathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PathQuery, PathQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathQuery, PathQueryVariables>(
    PathDocument,
    options
  )
}
export type PathQueryHookResult = ReturnType<typeof usePathQuery>
export type PathLazyQueryHookResult = ReturnType<typeof usePathLazyQuery>
export type PathSuspenseQueryHookResult = ReturnType<
  typeof usePathSuspenseQuery
>
export type PathQueryResult = Apollo.QueryResult<PathQuery, PathQueryVariables>
export const SyncPathDocument = gql`
  mutation SyncPath($id: Int!) {
    syncPath(id: $id) {
      ...PathItems
    }
  }
  ${PathItemsFragmentDoc}
`
export type SyncPathMutationFn = Apollo.MutationFunction<
  SyncPathMutation,
  SyncPathMutationVariables
>

/**
 * __useSyncPathMutation__
 *
 * To run a mutation, you first call `useSyncPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPathMutation, { data, loading, error }] = useSyncPathMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncPathMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncPathMutation,
    SyncPathMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SyncPathMutation, SyncPathMutationVariables>(
    SyncPathDocument,
    options
  )
}
export type SyncPathMutationHookResult = ReturnType<typeof useSyncPathMutation>
export type SyncPathMutationResult = Apollo.MutationResult<SyncPathMutation>
export type SyncPathMutationOptions = Apollo.BaseMutationOptions<
  SyncPathMutation,
  SyncPathMutationVariables
>
export const PathSyncPlanDocument = gql`
  query PathSyncPlan($sync_plan: PathSyncPlanInput!) {
    pathSyncPlan(sync_plan: $sync_plan) {
      from_path_id
      to_path_id
      included_changes {
        ...PathSyncPlanChange
      }
      excluded_changes {
        ...PathSyncPlanChange
      }
      hash
    }
  }
  ${PathSyncPlanChangeFragmentDoc}
`

/**
 * __usePathSyncPlanQuery__
 *
 * To run a query within a React component, call `usePathSyncPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathSyncPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathSyncPlanQuery({
 *   variables: {
 *      sync_plan: // value for 'sync_plan'
 *   },
 * });
 */
export function usePathSyncPlanQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathSyncPlanQuery,
    PathSyncPlanQueryVariables
  > &
    (
      | { variables: PathSyncPlanQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathSyncPlanQuery, PathSyncPlanQueryVariables>(
    PathSyncPlanDocument,
    options
  )
}
export function usePathSyncPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathSyncPlanQuery,
    PathSyncPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathSyncPlanQuery, PathSyncPlanQueryVariables>(
    PathSyncPlanDocument,
    options
  )
}
export function usePathSyncPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathSyncPlanQuery,
        PathSyncPlanQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathSyncPlanQuery, PathSyncPlanQueryVariables>(
    PathSyncPlanDocument,
    options
  )
}
export type PathSyncPlanQueryHookResult = ReturnType<
  typeof usePathSyncPlanQuery
>
export type PathSyncPlanLazyQueryHookResult = ReturnType<
  typeof usePathSyncPlanLazyQuery
>
export type PathSyncPlanSuspenseQueryHookResult = ReturnType<
  typeof usePathSyncPlanSuspenseQuery
>
export type PathSyncPlanQueryResult = Apollo.QueryResult<
  PathSyncPlanQuery,
  PathSyncPlanQueryVariables
>
export const ReorderPathItemsDocument = gql`
  mutation ReorderPathItems($path_id: Int!, $items: [PathItemOrder]!) {
    reorderPathItems(path_id: $path_id, items: $items)
  }
`
export type ReorderPathItemsMutationFn = Apollo.MutationFunction<
  ReorderPathItemsMutation,
  ReorderPathItemsMutationVariables
>

/**
 * __useReorderPathItemsMutation__
 *
 * To run a mutation, you first call `useReorderPathItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPathItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPathItemsMutation, { data, loading, error }] = useReorderPathItemsMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useReorderPathItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderPathItemsMutation,
    ReorderPathItemsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReorderPathItemsMutation,
    ReorderPathItemsMutationVariables
  >(ReorderPathItemsDocument, options)
}
export type ReorderPathItemsMutationHookResult = ReturnType<
  typeof useReorderPathItemsMutation
>
export type ReorderPathItemsMutationResult =
  Apollo.MutationResult<ReorderPathItemsMutation>
export type ReorderPathItemsMutationOptions = Apollo.BaseMutationOptions<
  ReorderPathItemsMutation,
  ReorderPathItemsMutationVariables
>
export const ResetPathItemForUserDocument = gql`
  mutation ResetPathItemForUser($id: Int!, $path_id: Int!) {
    resetPathItemForUser(id: $id, path_id: $path_id) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type ResetPathItemForUserMutationFn = Apollo.MutationFunction<
  ResetPathItemForUserMutation,
  ResetPathItemForUserMutationVariables
>

/**
 * __useResetPathItemForUserMutation__
 *
 * To run a mutation, you first call `useResetPathItemForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPathItemForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPathItemForUserMutation, { data, loading, error }] = useResetPathItemForUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *   },
 * });
 */
export function useResetPathItemForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPathItemForUserMutation,
    ResetPathItemForUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetPathItemForUserMutation,
    ResetPathItemForUserMutationVariables
  >(ResetPathItemForUserDocument, options)
}
export type ResetPathItemForUserMutationHookResult = ReturnType<
  typeof useResetPathItemForUserMutation
>
export type ResetPathItemForUserMutationResult =
  Apollo.MutationResult<ResetPathItemForUserMutation>
export type ResetPathItemForUserMutationOptions = Apollo.BaseMutationOptions<
  ResetPathItemForUserMutation,
  ResetPathItemForUserMutationVariables
>
export const ResetPathItemDocument = gql`
  mutation ResetPathItem($id: Int!, $path_id: Int!) {
    resetPathItem(id: $id, path_id: $path_id) {
      ...PathItem
      path {
        id
        progress
        points {
          path_id
          total
          earned
          total_points_possible
          percentage
          has_points
        }
        next_step_id
        completion_date
      }
    }
  }
  ${PathItemFragmentDoc}
`
export type ResetPathItemMutationFn = Apollo.MutationFunction<
  ResetPathItemMutation,
  ResetPathItemMutationVariables
>

/**
 * __useResetPathItemMutation__
 *
 * To run a mutation, you first call `useResetPathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPathItemMutation, { data, loading, error }] = useResetPathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *   },
 * });
 */
export function useResetPathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPathItemMutation,
    ResetPathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetPathItemMutation,
    ResetPathItemMutationVariables
  >(ResetPathItemDocument, options)
}
export type ResetPathItemMutationHookResult = ReturnType<
  typeof useResetPathItemMutation
>
export type ResetPathItemMutationResult =
  Apollo.MutationResult<ResetPathItemMutation>
export type ResetPathItemMutationOptions = Apollo.BaseMutationOptions<
  ResetPathItemMutation,
  ResetPathItemMutationVariables
>
export const SingleCohortPathDocument = gql`
  query SingleCohortPath($cohort_id: Int!) {
    path(cohort_id: $cohort_id) {
      ...SingleCohortPath
    }
  }
  ${SingleCohortPathFragmentDoc}
`

/**
 * __useSingleCohortPathQuery__
 *
 * To run a query within a React component, call `useSingleCohortPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCohortPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCohortPathQuery({
 *   variables: {
 *      cohort_id: // value for 'cohort_id'
 *   },
 * });
 */
export function useSingleCohortPathQuery(
  baseOptions: Apollo.QueryHookOptions<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  > &
    (
      | { variables: SingleCohortPathQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SingleCohortPathQuery, SingleCohortPathQueryVariables>(
    SingleCohortPathDocument,
    options
  )
}
export function useSingleCohortPathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  >(SingleCohortPathDocument, options)
}
export function useSingleCohortPathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SingleCohortPathQuery,
        SingleCohortPathQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  >(SingleCohortPathDocument, options)
}
export type SingleCohortPathQueryHookResult = ReturnType<
  typeof useSingleCohortPathQuery
>
export type SingleCohortPathLazyQueryHookResult = ReturnType<
  typeof useSingleCohortPathLazyQuery
>
export type SingleCohortPathSuspenseQueryHookResult = ReturnType<
  typeof useSingleCohortPathSuspenseQuery
>
export type SingleCohortPathQueryResult = Apollo.QueryResult<
  SingleCohortPathQuery,
  SingleCohortPathQueryVariables
>
export const SkipPathItemForUserDocument = gql`
  mutation SkipPathItemForUser($id: Int!, $path_id: Int!) {
    skipPathItemForUser(id: $id, path_id: $path_id) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type SkipPathItemForUserMutationFn = Apollo.MutationFunction<
  SkipPathItemForUserMutation,
  SkipPathItemForUserMutationVariables
>

/**
 * __useSkipPathItemForUserMutation__
 *
 * To run a mutation, you first call `useSkipPathItemForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipPathItemForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipPathItemForUserMutation, { data, loading, error }] = useSkipPathItemForUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *   },
 * });
 */
export function useSkipPathItemForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SkipPathItemForUserMutation,
    SkipPathItemForUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SkipPathItemForUserMutation,
    SkipPathItemForUserMutationVariables
  >(SkipPathItemForUserDocument, options)
}
export type SkipPathItemForUserMutationHookResult = ReturnType<
  typeof useSkipPathItemForUserMutation
>
export type SkipPathItemForUserMutationResult =
  Apollo.MutationResult<SkipPathItemForUserMutation>
export type SkipPathItemForUserMutationOptions = Apollo.BaseMutationOptions<
  SkipPathItemForUserMutation,
  SkipPathItemForUserMutationVariables
>
export const UnarchivePathItemDocument = gql`
  mutation UnarchivePathItem($id: Int!, $pathId: Int!) {
    unarchivePathItem(id: $id, path_id: $pathId) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type UnarchivePathItemMutationFn = Apollo.MutationFunction<
  UnarchivePathItemMutation,
  UnarchivePathItemMutationVariables
>

/**
 * __useUnarchivePathItemMutation__
 *
 * To run a mutation, you first call `useUnarchivePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchivePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchivePathItemMutation, { data, loading, error }] = useUnarchivePathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useUnarchivePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchivePathItemMutation,
    UnarchivePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnarchivePathItemMutation,
    UnarchivePathItemMutationVariables
  >(UnarchivePathItemDocument, options)
}
export type UnarchivePathItemMutationHookResult = ReturnType<
  typeof useUnarchivePathItemMutation
>
export type UnarchivePathItemMutationResult =
  Apollo.MutationResult<UnarchivePathItemMutation>
export type UnarchivePathItemMutationOptions = Apollo.BaseMutationOptions<
  UnarchivePathItemMutation,
  UnarchivePathItemMutationVariables
>
export const UnlockPathItemDocument = gql`
  mutation UnlockPathItem(
    $id: Int!
    $path_id: Int!
    $step_lock_password: String!
  ) {
    unlockPathItem(
      id: $id
      path_id: $path_id
      step_lock_password: $step_lock_password
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type UnlockPathItemMutationFn = Apollo.MutationFunction<
  UnlockPathItemMutation,
  UnlockPathItemMutationVariables
>

/**
 * __useUnlockPathItemMutation__
 *
 * To run a mutation, you first call `useUnlockPathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockPathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockPathItemMutation, { data, loading, error }] = useUnlockPathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *      step_lock_password: // value for 'step_lock_password'
 *   },
 * });
 */
export function useUnlockPathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlockPathItemMutation,
    UnlockPathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnlockPathItemMutation,
    UnlockPathItemMutationVariables
  >(UnlockPathItemDocument, options)
}
export type UnlockPathItemMutationHookResult = ReturnType<
  typeof useUnlockPathItemMutation
>
export type UnlockPathItemMutationResult =
  Apollo.MutationResult<UnlockPathItemMutation>
export type UnlockPathItemMutationOptions = Apollo.BaseMutationOptions<
  UnlockPathItemMutation,
  UnlockPathItemMutationVariables
>
export const UpdatePathItemDocument = gql`
  mutation UpdatePathItem(
    $path_id: Int!
    $source_id: Int!
    $order: Int!
    $type: PathItemType!
    $name: String!
    $description: String
    $assignment_type: PathItemAssignmentType
    $is_required: Boolean
    $allow_resets: Int
    $show_grading_feedback: Int
    $completion_comment_required_status: String
    $points: Int
    $minimum_passing_score: Int
    $grading_type: String
    $is_previewable: Boolean
    $lock_password: String
    $time_to_complete: Int
    $requires_api_completion: Boolean
  ) {
    updatePathItem(
      path_id: $path_id
      source_id: $source_id
      type: $type
      name: $name
      order: $order
      description: $description
      assignment_type: $assignment_type
      is_required: $is_required
      allow_resets: $allow_resets
      show_grading_feedback: $show_grading_feedback
      completion_comment_required_status: $completion_comment_required_status
      points: $points
      minimum_passing_score: $minimum_passing_score
      grading_type: $grading_type
      is_previewable: $is_previewable
      lock_password: $lock_password
      time_to_complete: $time_to_complete
      requires_api_completion: $requires_api_completion
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type UpdatePathItemMutationFn = Apollo.MutationFunction<
  UpdatePathItemMutation,
  UpdatePathItemMutationVariables
>

/**
 * __useUpdatePathItemMutation__
 *
 * To run a mutation, you first call `useUpdatePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePathItemMutation, { data, loading, error }] = useUpdatePathItemMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      source_id: // value for 'source_id'
 *      order: // value for 'order'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      assignment_type: // value for 'assignment_type'
 *      is_required: // value for 'is_required'
 *      allow_resets: // value for 'allow_resets'
 *      show_grading_feedback: // value for 'show_grading_feedback'
 *      completion_comment_required_status: // value for 'completion_comment_required_status'
 *      points: // value for 'points'
 *      minimum_passing_score: // value for 'minimum_passing_score'
 *      grading_type: // value for 'grading_type'
 *      is_previewable: // value for 'is_previewable'
 *      lock_password: // value for 'lock_password'
 *      time_to_complete: // value for 'time_to_complete'
 *      requires_api_completion: // value for 'requires_api_completion'
 *   },
 * });
 */
export function useUpdatePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePathItemMutation,
    UpdatePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePathItemMutation,
    UpdatePathItemMutationVariables
  >(UpdatePathItemDocument, options)
}
export type UpdatePathItemMutationHookResult = ReturnType<
  typeof useUpdatePathItemMutation
>
export type UpdatePathItemMutationResult =
  Apollo.MutationResult<UpdatePathItemMutation>
export type UpdatePathItemMutationOptions = Apollo.BaseMutationOptions<
  UpdatePathItemMutation,
  UpdatePathItemMutationVariables
>
export const UserPathReportCardDocument = gql`
  query UserPathReportCard($id: Int) {
    path(id: $id) {
      ...UserPathReportCard
    }
  }
  ${UserPathReportCardFragmentDoc}
`

/**
 * __useUserPathReportCardQuery__
 *
 * To run a query within a React component, call `useUserPathReportCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPathReportCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPathReportCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserPathReportCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >(UserPathReportCardDocument, options)
}
export function useUserPathReportCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >(UserPathReportCardDocument, options)
}
export function useUserPathReportCardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserPathReportCardQuery,
        UserPathReportCardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >(UserPathReportCardDocument, options)
}
export type UserPathReportCardQueryHookResult = ReturnType<
  typeof useUserPathReportCardQuery
>
export type UserPathReportCardLazyQueryHookResult = ReturnType<
  typeof useUserPathReportCardLazyQuery
>
export type UserPathReportCardSuspenseQueryHookResult = ReturnType<
  typeof useUserPathReportCardSuspenseQuery
>
export type UserPathReportCardQueryResult = Apollo.QueryResult<
  UserPathReportCardQuery,
  UserPathReportCardQueryVariables
>
export const PathItemsQueryDocument = gql`
  query PathItemsQuery($id: Int!, $school_id: Int!, $cursor: String) {
    context(school_id: $school_id) {
      school {
        ...School
        pathItems(path_id: $id, first: 1000, after: $cursor) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              order
              name
              type
              path_id
              source_id
              parent_id
              description
              content_id
              assignment_type
              item_content_type_id
              verb
              step_verb: verb
              points
              userpoints_value: points
              is_previewable
              is_required
              time_to_complete
              context {
                school_id
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
`

/**
 * __usePathItemsQueryQuery__
 *
 * To run a query within a React component, call `usePathItemsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathItemsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathItemsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      school_id: // value for 'school_id'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePathItemsQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathItemsQueryQuery,
    PathItemsQueryQueryVariables
  > &
    (
      | { variables: PathItemsQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathItemsQueryQuery, PathItemsQueryQueryVariables>(
    PathItemsQueryDocument,
    options
  )
}
export function usePathItemsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathItemsQueryQuery,
    PathItemsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathItemsQueryQuery, PathItemsQueryQueryVariables>(
    PathItemsQueryDocument,
    options
  )
}
export function usePathItemsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathItemsQueryQuery,
        PathItemsQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathItemsQueryQuery,
    PathItemsQueryQueryVariables
  >(PathItemsQueryDocument, options)
}
export type PathItemsQueryQueryHookResult = ReturnType<
  typeof usePathItemsQueryQuery
>
export type PathItemsQueryLazyQueryHookResult = ReturnType<
  typeof usePathItemsQueryLazyQuery
>
export type PathItemsQuerySuspenseQueryHookResult = ReturnType<
  typeof usePathItemsQuerySuspenseQuery
>
export type PathItemsQueryQueryResult = Apollo.QueryResult<
  PathItemsQueryQuery,
  PathItemsQueryQueryVariables
>
export const MissingPathItemDocument = gql`
  query MissingPathItem($id: Int, $pathId: Int) {
    missingPathItem: pathItem(
      id: $id
      path_id: $pathId
      archivedDateFilter: [{ eq: null }, { op: "or" }, { neq: null }]
    ) {
      ...MissingPathItem
    }
    missingSourcePathItem: pathItem(
      source_id: $id
      path_id: $pathId
      archivedDateFilter: [{ eq: null }, { op: "or" }, { neq: null }]
    ) {
      ...MissingPathItem
    }
  }
  ${MissingPathItemFragmentDoc}
`

/**
 * __useMissingPathItemQuery__
 *
 * To run a query within a React component, call `useMissingPathItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissingPathItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissingPathItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useMissingPathItemQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MissingPathItemQuery, MissingPathItemQueryVariables>(
    MissingPathItemDocument,
    options
  )
}
export function useMissingPathItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >(MissingPathItemDocument, options)
}
export function useMissingPathItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MissingPathItemQuery,
        MissingPathItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >(MissingPathItemDocument, options)
}
export type MissingPathItemQueryHookResult = ReturnType<
  typeof useMissingPathItemQuery
>
export type MissingPathItemLazyQueryHookResult = ReturnType<
  typeof useMissingPathItemLazyQuery
>
export type MissingPathItemSuspenseQueryHookResult = ReturnType<
  typeof useMissingPathItemSuspenseQuery
>
export type MissingPathItemQueryResult = Apollo.QueryResult<
  MissingPathItemQuery,
  MissingPathItemQueryVariables
>
export const ContextDocument = gql`
  query Context {
    ...Context
  }
  ${ContextFragmentDoc}
`

/**
 * __useContextQuery__
 *
 * To run a query within a React component, call `useContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useContextQuery(
  baseOptions?: Apollo.QueryHookOptions<ContextQuery, ContextQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContextQuery, ContextQueryVariables>(
    ContextDocument,
    options
  )
}
export function useContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContextQuery, ContextQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContextQuery, ContextQueryVariables>(
    ContextDocument,
    options
  )
}
export function useContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContextQuery, ContextQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ContextQuery, ContextQueryVariables>(
    ContextDocument,
    options
  )
}
export type ContextQueryHookResult = ReturnType<typeof useContextQuery>
export type ContextLazyQueryHookResult = ReturnType<typeof useContextLazyQuery>
export type ContextSuspenseQueryHookResult = ReturnType<
  typeof useContextSuspenseQuery
>
export type ContextQueryResult = Apollo.QueryResult<
  ContextQuery,
  ContextQueryVariables
>
export const PlatformConfigDocument = gql`
  query PlatformConfig {
    platformConfig {
      id
      payments_maintenance_mode
    }
  }
`

/**
 * __usePlatformConfigQuery__
 *
 * To run a query within a React component, call `usePlatformConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlatformConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlatformConfigQuery,
    PlatformConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PlatformConfigQuery, PlatformConfigQueryVariables>(
    PlatformConfigDocument,
    options
  )
}
export function usePlatformConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlatformConfigQuery,
    PlatformConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PlatformConfigQuery, PlatformConfigQueryVariables>(
    PlatformConfigDocument,
    options
  )
}
export function usePlatformConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PlatformConfigQuery,
        PlatformConfigQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PlatformConfigQuery,
    PlatformConfigQueryVariables
  >(PlatformConfigDocument, options)
}
export type PlatformConfigQueryHookResult = ReturnType<
  typeof usePlatformConfigQuery
>
export type PlatformConfigLazyQueryHookResult = ReturnType<
  typeof usePlatformConfigLazyQuery
>
export type PlatformConfigSuspenseQueryHookResult = ReturnType<
  typeof usePlatformConfigSuspenseQuery
>
export type PlatformConfigQueryResult = Apollo.QueryResult<
  PlatformConfigQuery,
  PlatformConfigQueryVariables
>
export const ThemeQueryDocument = gql`
  query ThemeQuery($school_id: Int!) {
    context(school_id: $school_id) {
      theme {
        ...Theme
      }
    }
  }
  ${ThemeFragmentDoc}
`

/**
 * __useThemeQueryQuery__
 *
 * To run a query within a React component, call `useThemeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemeQueryQuery({
 *   variables: {
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function useThemeQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThemeQueryQuery,
    ThemeQueryQueryVariables
  > &
    (
      | { variables: ThemeQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ThemeQueryQuery, ThemeQueryQueryVariables>(
    ThemeQueryDocument,
    options
  )
}
export function useThemeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThemeQueryQuery,
    ThemeQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ThemeQueryQuery, ThemeQueryQueryVariables>(
    ThemeQueryDocument,
    options
  )
}
export function useThemeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThemeQueryQuery, ThemeQueryQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ThemeQueryQuery, ThemeQueryQueryVariables>(
    ThemeQueryDocument,
    options
  )
}
export type ThemeQueryQueryHookResult = ReturnType<typeof useThemeQueryQuery>
export type ThemeQueryLazyQueryHookResult = ReturnType<
  typeof useThemeQueryLazyQuery
>
export type ThemeQuerySuspenseQueryHookResult = ReturnType<
  typeof useThemeQuerySuspenseQuery
>
export type ThemeQueryQueryResult = Apollo.QueryResult<
  ThemeQueryQuery,
  ThemeQueryQueryVariables
>
export const DeletePositioningContextDocument = gql`
  mutation DeletePositioningContext($context: PositioningContextInput!) {
    deletePositioningContext(context: $context)
  }
`
export type DeletePositioningContextMutationFn = Apollo.MutationFunction<
  DeletePositioningContextMutation,
  DeletePositioningContextMutationVariables
>

/**
 * __useDeletePositioningContextMutation__
 *
 * To run a mutation, you first call `useDeletePositioningContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePositioningContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePositioningContextMutation, { data, loading, error }] = useDeletePositioningContextMutation({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDeletePositioningContextMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePositioningContextMutation,
    DeletePositioningContextMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeletePositioningContextMutation,
    DeletePositioningContextMutationVariables
  >(DeletePositioningContextDocument, options)
}
export type DeletePositioningContextMutationHookResult = ReturnType<
  typeof useDeletePositioningContextMutation
>
export type DeletePositioningContextMutationResult =
  Apollo.MutationResult<DeletePositioningContextMutation>
export type DeletePositioningContextMutationOptions =
  Apollo.BaseMutationOptions<
    DeletePositioningContextMutation,
    DeletePositioningContextMutationVariables
  >
export const PositioningContextDocument = gql`
  query PositioningContext($input: PositioningContextInput!) {
    positioningContext(input: $input) {
      ...PositioningContext
    }
  }
  ${PositioningContextFragmentDoc}
`

/**
 * __usePositioningContextQuery__
 *
 * To run a query within a React component, call `usePositioningContextQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositioningContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositioningContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePositioningContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    PositioningContextQuery,
    PositioningContextQueryVariables
  > &
    (
      | { variables: PositioningContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >(PositioningContextDocument, options)
}
export function usePositioningContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >(PositioningContextDocument, options)
}
export function usePositioningContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PositioningContextQuery,
        PositioningContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >(PositioningContextDocument, options)
}
export type PositioningContextQueryHookResult = ReturnType<
  typeof usePositioningContextQuery
>
export type PositioningContextLazyQueryHookResult = ReturnType<
  typeof usePositioningContextLazyQuery
>
export type PositioningContextSuspenseQueryHookResult = ReturnType<
  typeof usePositioningContextSuspenseQuery
>
export type PositioningContextQueryResult = Apollo.QueryResult<
  PositioningContextQuery,
  PositioningContextQueryVariables
>
export const UpdatePositionedObjectsDocument = gql`
  mutation UpdatePositionedObjects(
    $context: PositioningContextInput!
    $positions: [PositionedObjectPositionInput]!
  ) {
    updatePositionedObjects(context: $context, positions: $positions)
  }
`
export type UpdatePositionedObjectsMutationFn = Apollo.MutationFunction<
  UpdatePositionedObjectsMutation,
  UpdatePositionedObjectsMutationVariables
>

/**
 * __useUpdatePositionedObjectsMutation__
 *
 * To run a mutation, you first call `useUpdatePositionedObjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionedObjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionedObjectsMutation, { data, loading, error }] = useUpdatePositionedObjectsMutation({
 *   variables: {
 *      context: // value for 'context'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useUpdatePositionedObjectsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePositionedObjectsMutation,
    UpdatePositionedObjectsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePositionedObjectsMutation,
    UpdatePositionedObjectsMutationVariables
  >(UpdatePositionedObjectsDocument, options)
}
export type UpdatePositionedObjectsMutationHookResult = ReturnType<
  typeof useUpdatePositionedObjectsMutation
>
export type UpdatePositionedObjectsMutationResult =
  Apollo.MutationResult<UpdatePositionedObjectsMutation>
export type UpdatePositionedObjectsMutationOptions = Apollo.BaseMutationOptions<
  UpdatePositionedObjectsMutation,
  UpdatePositionedObjectsMutationVariables
>
export const __TestRegistrationPositioningDocument = gql`
  query __TestRegistrationPositioning(
    $first: Int!
    $positioningContext: PositioningContextInput
  ) {
    me {
      id
      registrations(first: $first, positioningContext: $positioningContext) {
        edges {
          node {
            ...__TestRegistration
          }
        }
      }
    }
  }
  ${__TestRegistrationFragmentDoc}
`

/**
 * __use__TestRegistrationPositioningQuery__
 *
 * To run a query within a React component, call `use__TestRegistrationPositioningQuery` and pass it any options that fit your needs.
 * When your component renders, `use__TestRegistrationPositioningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = use__TestRegistrationPositioningQuery({
 *   variables: {
 *      first: // value for 'first'
 *      positioningContext: // value for 'positioningContext'
 *   },
 * });
 */
export function use__TestRegistrationPositioningQuery(
  baseOptions: Apollo.QueryHookOptions<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  > &
    (
      | {
          variables: __TestRegistrationPositioningQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >(__TestRegistrationPositioningDocument, options)
}
export function use__TestRegistrationPositioningLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >(__TestRegistrationPositioningDocument, options)
}
export function use__TestRegistrationPositioningSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        __TestRegistrationPositioningQuery,
        __TestRegistrationPositioningQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >(__TestRegistrationPositioningDocument, options)
}
export type __TestRegistrationPositioningQueryHookResult = ReturnType<
  typeof use__TestRegistrationPositioningQuery
>
export type __TestRegistrationPositioningLazyQueryHookResult = ReturnType<
  typeof use__TestRegistrationPositioningLazyQuery
>
export type __TestRegistrationPositioningSuspenseQueryHookResult = ReturnType<
  typeof use__TestRegistrationPositioningSuspenseQuery
>
export type __TestRegistrationPositioningQueryResult = Apollo.QueryResult<
  __TestRegistrationPositioningQuery,
  __TestRegistrationPositioningQueryVariables
>
export const PricingDocument = gql`
  query Pricing {
    packageAssignment {
      package {
        coupon_discount
      }
    }
    account {
      id
      scholarship {
        id
        coupon {
          id
          percent_off
        }
        ends
        iterations
        order
        plan_id
        starts
        interval
      }
      billing_plan_set {
        plans {
          ...SchoolBillingPlan
        }
      }
      billing_subscription {
        id
        plan {
          id
          name
          description
          amount
          plan_derived_from {
            id
            name
            description
            amount
          }
        }
        interval
      }
    }
  }
  ${SchoolBillingPlanFragmentDoc}
`

/**
 * __usePricingQuery__
 *
 * To run a query within a React component, call `usePricingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePricingQuery(
  baseOptions?: Apollo.QueryHookOptions<PricingQuery, PricingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PricingQuery, PricingQueryVariables>(
    PricingDocument,
    options
  )
}
export function usePricingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PricingQuery, PricingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PricingQuery, PricingQueryVariables>(
    PricingDocument,
    options
  )
}
export function usePricingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PricingQuery, PricingQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PricingQuery, PricingQueryVariables>(
    PricingDocument,
    options
  )
}
export type PricingQueryHookResult = ReturnType<typeof usePricingQuery>
export type PricingLazyQueryHookResult = ReturnType<typeof usePricingLazyQuery>
export type PricingSuspenseQueryHookResult = ReturnType<
  typeof usePricingSuspenseQuery
>
export type PricingQueryResult = Apollo.QueryResult<
  PricingQuery,
  PricingQueryVariables
>
export const ActiveCertificateDocument = gql`
  query ActiveCertificate {
    certificate {
      id
    }
  }
`

/**
 * __useActiveCertificateQuery__
 *
 * To run a query within a React component, call `useActiveCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCertificateQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveCertificateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >(ActiveCertificateDocument, options)
}
export function useActiveCertificateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >(ActiveCertificateDocument, options)
}
export function useActiveCertificateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActiveCertificateQuery,
        ActiveCertificateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >(ActiveCertificateDocument, options)
}
export type ActiveCertificateQueryHookResult = ReturnType<
  typeof useActiveCertificateQuery
>
export type ActiveCertificateLazyQueryHookResult = ReturnType<
  typeof useActiveCertificateLazyQuery
>
export type ActiveCertificateSuspenseQueryHookResult = ReturnType<
  typeof useActiveCertificateSuspenseQuery
>
export type ActiveCertificateQueryResult = Apollo.QueryResult<
  ActiveCertificateQuery,
  ActiveCertificateQueryVariables
>
export const CertificateDownloadUrlDocument = gql`
  query CertificateDownloadUrl($pathId: Int) {
    certificate {
      id
      download_url(path_id: $pathId)
    }
  }
`

/**
 * __useCertificateDownloadUrlQuery__
 *
 * To run a query within a React component, call `useCertificateDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateDownloadUrlQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useCertificateDownloadUrlQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >(CertificateDownloadUrlDocument, options)
}
export function useCertificateDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >(CertificateDownloadUrlDocument, options)
}
export function useCertificateDownloadUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateDownloadUrlQuery,
        CertificateDownloadUrlQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >(CertificateDownloadUrlDocument, options)
}
export type CertificateDownloadUrlQueryHookResult = ReturnType<
  typeof useCertificateDownloadUrlQuery
>
export type CertificateDownloadUrlLazyQueryHookResult = ReturnType<
  typeof useCertificateDownloadUrlLazyQuery
>
export type CertificateDownloadUrlSuspenseQueryHookResult = ReturnType<
  typeof useCertificateDownloadUrlSuspenseQuery
>
export type CertificateDownloadUrlQueryResult = Apollo.QueryResult<
  CertificateDownloadUrlQuery,
  CertificateDownloadUrlQueryVariables
>
export const UpdateUserMembershipDocument = gql`
  mutation UpdateUserMembership($consents: Boolean) {
    updateMemberConsent(consents: $consents) {
      id
      consent_snapshot
      consent_dtime
    }
  }
`
export type UpdateUserMembershipMutationFn = Apollo.MutationFunction<
  UpdateUserMembershipMutation,
  UpdateUserMembershipMutationVariables
>

/**
 * __useUpdateUserMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateUserMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMembershipMutation, { data, loading, error }] = useUpdateUserMembershipMutation({
 *   variables: {
 *      consents: // value for 'consents'
 *   },
 * });
 */
export function useUpdateUserMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMembershipMutation,
    UpdateUserMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateUserMembershipMutation,
    UpdateUserMembershipMutationVariables
  >(UpdateUserMembershipDocument, options)
}
export type UpdateUserMembershipMutationHookResult = ReturnType<
  typeof useUpdateUserMembershipMutation
>
export type UpdateUserMembershipMutationResult =
  Apollo.MutationResult<UpdateUserMembershipMutation>
export type UpdateUserMembershipMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMembershipMutation,
  UpdateUserMembershipMutationVariables
>
export const UserProfileDocument = gql`
  query UserProfile($id: Int!) {
    user(id: $id) {
      ...User
      membership {
        id
        role
        last_active
        last_seen
      }
    }
  }
  ${UserFragmentDoc}
`

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  > &
    (
      | { variables: UserProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  )
}
export function useUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  )
}
export function useUserProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserProfileQuery,
        UserProfileQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  )
}
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>
export type UserProfileLazyQueryHookResult = ReturnType<
  typeof useUserProfileLazyQuery
>
export type UserProfileSuspenseQueryHookResult = ReturnType<
  typeof useUserProfileSuspenseQuery
>
export type UserProfileQueryResult = Apollo.QueryResult<
  UserProfileQuery,
  UserProfileQueryVariables
>
export const PublishersDocument = gql`
  query Publishers($first: Int!, $cursor: String, $school_id: Int!) {
    context(school_id: $school_id) {
      school {
        ...School
        publishers(first: $first, after: $cursor) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Publisher
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PublisherFragmentDoc}
`

/**
 * __usePublishersQuery__
 *
 * To run a query within a React component, call `usePublishersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function usePublishersQuery(
  baseOptions: Apollo.QueryHookOptions<
    PublishersQuery,
    PublishersQueryVariables
  > &
    (
      | { variables: PublishersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PublishersQuery, PublishersQueryVariables>(
    PublishersDocument,
    options
  )
}
export function usePublishersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublishersQuery,
    PublishersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PublishersQuery, PublishersQueryVariables>(
    PublishersDocument,
    options
  )
}
export function usePublishersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PublishersQuery, PublishersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PublishersQuery, PublishersQueryVariables>(
    PublishersDocument,
    options
  )
}
export type PublishersQueryHookResult = ReturnType<typeof usePublishersQuery>
export type PublishersLazyQueryHookResult = ReturnType<
  typeof usePublishersLazyQuery
>
export type PublishersSuspenseQueryHookResult = ReturnType<
  typeof usePublishersSuspenseQuery
>
export type PublishersQueryResult = Apollo.QueryResult<
  PublishersQuery,
  PublishersQueryVariables
>
export const UpdateReferralDocument = gql`
  mutation UpdateReferral($referral: String!) {
    updateReferral(referral: $referral) {
      referral
    }
  }
`
export type UpdateReferralMutationFn = Apollo.MutationFunction<
  UpdateReferralMutation,
  UpdateReferralMutationVariables
>

/**
 * __useUpdateReferralMutation__
 *
 * To run a mutation, you first call `useUpdateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferralMutation, { data, loading, error }] = useUpdateReferralMutation({
 *   variables: {
 *      referral: // value for 'referral'
 *   },
 * });
 */
export function useUpdateReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateReferralMutation,
    UpdateReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateReferralMutation,
    UpdateReferralMutationVariables
  >(UpdateReferralDocument, options)
}
export type UpdateReferralMutationHookResult = ReturnType<
  typeof useUpdateReferralMutation
>
export type UpdateReferralMutationResult =
  Apollo.MutationResult<UpdateReferralMutation>
export type UpdateReferralMutationOptions = Apollo.BaseMutationOptions<
  UpdateReferralMutation,
  UpdateReferralMutationVariables
>
export const DeleteRegistrationDocument = gql`
  mutation DeleteRegistration($group_id: Int!, $registration_id: Int!) {
    deleteRegistration(group_id: $group_id, registration_id: $registration_id)
  }
`
export type DeleteRegistrationMutationFn = Apollo.MutationFunction<
  DeleteRegistrationMutation,
  DeleteRegistrationMutationVariables
>

/**
 * __useDeleteRegistrationMutation__
 *
 * To run a mutation, you first call `useDeleteRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistrationMutation, { data, loading, error }] = useDeleteRegistrationMutation({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      registration_id: // value for 'registration_id'
 *   },
 * });
 */
export function useDeleteRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRegistrationMutation,
    DeleteRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteRegistrationMutation,
    DeleteRegistrationMutationVariables
  >(DeleteRegistrationDocument, options)
}
export type DeleteRegistrationMutationHookResult = ReturnType<
  typeof useDeleteRegistrationMutation
>
export type DeleteRegistrationMutationResult =
  Apollo.MutationResult<DeleteRegistrationMutation>
export type DeleteRegistrationMutationOptions = Apollo.BaseMutationOptions<
  DeleteRegistrationMutation,
  DeleteRegistrationMutationVariables
>
export const RegistrationExpirationDocument = gql`
  query RegistrationExpiration($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      id
      name
      price
      is_subscription_only
      access_starts
      access_ends
      resource {
        id
        name
      }
      resource_license {
        id
      }
      include_in_plans(first: 25) {
        total
        edges {
          node {
            id
          }
        }
      }
      include_with_products(first: 25) {
        total
        edges {
          node {
            id
          }
        }
      }
      user_registration {
        id
        expiration_dtime
        school_sub_used {
          id
          school_subscription_plan {
            id
          }
          subscription_plan {
            id
            name
          }
          subscription {
            ...Subscription
          }
        }
        group_sub_used {
          id
          price {
            id
            product {
              id
              name
            }
          }
          community_group {
            id
            name
            seat_limit
          }
          subscription {
            ...Subscription
          }
        }
        group_sub_community_membership {
          id
          access_revoked_time
        }
      }
    }
  }
  ${SubscriptionFragmentDoc}
`

/**
 * __useRegistrationExpirationQuery__
 *
 * To run a query within a React component, call `useRegistrationExpirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationExpirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationExpirationQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useRegistrationExpirationQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  > &
    (
      | { variables: RegistrationExpirationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >(RegistrationExpirationDocument, options)
}
export function useRegistrationExpirationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >(RegistrationExpirationDocument, options)
}
export function useRegistrationExpirationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegistrationExpirationQuery,
        RegistrationExpirationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >(RegistrationExpirationDocument, options)
}
export type RegistrationExpirationQueryHookResult = ReturnType<
  typeof useRegistrationExpirationQuery
>
export type RegistrationExpirationLazyQueryHookResult = ReturnType<
  typeof useRegistrationExpirationLazyQuery
>
export type RegistrationExpirationSuspenseQueryHookResult = ReturnType<
  typeof useRegistrationExpirationSuspenseQuery
>
export type RegistrationExpirationQueryResult = Apollo.QueryResult<
  RegistrationExpirationQuery,
  RegistrationExpirationQueryVariables
>
export const RegistrationDocument = gql`
  query Registration($group_id: Int!, $registration_id: Int) {
    group(id: $group_id) {
      ...Group
      permissions {
        can_invite_observer
        can_invite_student
        can_invite_moderator
        can_invite_teacher
        can_invite_editor
      }
      registration(id: $registration_id) {
        ...Registration
        user {
          ...User
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${RegistrationFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useRegistrationQuery__
 *
 * To run a query within a React component, call `useRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      registration_id: // value for 'registration_id'
 *   },
 * });
 */
export function useRegistrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegistrationQuery,
    RegistrationQueryVariables
  > &
    (
      | { variables: RegistrationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RegistrationQuery, RegistrationQueryVariables>(
    RegistrationDocument,
    options
  )
}
export function useRegistrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegistrationQuery,
    RegistrationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RegistrationQuery, RegistrationQueryVariables>(
    RegistrationDocument,
    options
  )
}
export function useRegistrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegistrationQuery,
        RegistrationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RegistrationQuery, RegistrationQueryVariables>(
    RegistrationDocument,
    options
  )
}
export type RegistrationQueryHookResult = ReturnType<
  typeof useRegistrationQuery
>
export type RegistrationLazyQueryHookResult = ReturnType<
  typeof useRegistrationLazyQuery
>
export type RegistrationSuspenseQueryHookResult = ReturnType<
  typeof useRegistrationSuspenseQuery
>
export type RegistrationQueryResult = Apollo.QueryResult<
  RegistrationQuery,
  RegistrationQueryVariables
>
export const RegistrationsDocument = gql`
  query Registrations(
    $groupId: Int!
    $roleFilter: RoleFilter
    $dateLastActive: DateFilter
    $dateJoined: DateFilter
    $softArchived: DateFilter
    $orderBy: [RegistrationOrderByInput]
    $cursor: String
  ) {
    group(id: $groupId) {
      ...Group
      resource {
        ...Resource
      }
      registrations(
        first: 50
        role_filter: $roleFilter
        last_active: $dateLastActive
        created: $dateJoined
        softArchived: $softArchived
        orderBy: $orderBy
        after: $cursor
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Registration
          }
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
  ${RegistrationFragmentDoc}
`

/**
 * __useRegistrationsQuery__
 *
 * To run a query within a React component, call `useRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      roleFilter: // value for 'roleFilter'
 *      dateLastActive: // value for 'dateLastActive'
 *      dateJoined: // value for 'dateJoined'
 *      softArchived: // value for 'softArchived'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useRegistrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegistrationsQuery,
    RegistrationsQueryVariables
  > &
    (
      | { variables: RegistrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RegistrationsQuery, RegistrationsQueryVariables>(
    RegistrationsDocument,
    options
  )
}
export function useRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegistrationsQuery,
    RegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RegistrationsQuery, RegistrationsQueryVariables>(
    RegistrationsDocument,
    options
  )
}
export function useRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegistrationsQuery,
        RegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RegistrationsQuery,
    RegistrationsQueryVariables
  >(RegistrationsDocument, options)
}
export type RegistrationsQueryHookResult = ReturnType<
  typeof useRegistrationsQuery
>
export type RegistrationsLazyQueryHookResult = ReturnType<
  typeof useRegistrationsLazyQuery
>
export type RegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useRegistrationsSuspenseQuery
>
export type RegistrationsQueryResult = Apollo.QueryResult<
  RegistrationsQuery,
  RegistrationsQueryVariables
>
export const UpdateRegistrationDocument = gql`
  mutation UpdateRegistration(
    $id: Int!
    $send_due_notifications: Boolean
    $send_discussion_notifications: Boolean
  ) {
    updateRegistration(
      id: $id
      send_due_notifications: $send_due_notifications
      send_discussion_notifications: $send_discussion_notifications
    ) {
      id
      send_due_notifications
      send_discussion_notifications
    }
  }
`
export type UpdateRegistrationMutationFn = Apollo.MutationFunction<
  UpdateRegistrationMutation,
  UpdateRegistrationMutationVariables
>

/**
 * __useUpdateRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistrationMutation, { data, loading, error }] = useUpdateRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      send_due_notifications: // value for 'send_due_notifications'
 *      send_discussion_notifications: // value for 'send_discussion_notifications'
 *   },
 * });
 */
export function useUpdateRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRegistrationMutation,
    UpdateRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateRegistrationMutation,
    UpdateRegistrationMutationVariables
  >(UpdateRegistrationDocument, options)
}
export type UpdateRegistrationMutationHookResult = ReturnType<
  typeof useUpdateRegistrationMutation
>
export type UpdateRegistrationMutationResult =
  Apollo.MutationResult<UpdateRegistrationMutation>
export type UpdateRegistrationMutationOptions = Apollo.BaseMutationOptions<
  UpdateRegistrationMutation,
  UpdateRegistrationMutationVariables
>
export const UpdateUserRegistrationDocument = gql`
  mutation UpdateUserRegistration(
    $id: Int!
    $role: RegistrationRoleEnum
    $expiration_dtime: DateTime
  ) {
    updateRegistration(
      id: $id
      role: $role
      expiration_dtime: $expiration_dtime
    ) {
      id
      role
      expiration_dtime
    }
  }
`
export type UpdateUserRegistrationMutationFn = Apollo.MutationFunction<
  UpdateUserRegistrationMutation,
  UpdateUserRegistrationMutationVariables
>

/**
 * __useUpdateUserRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateUserRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRegistrationMutation, { data, loading, error }] = useUpdateUserRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *      expiration_dtime: // value for 'expiration_dtime'
 *   },
 * });
 */
export function useUpdateUserRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserRegistrationMutation,
    UpdateUserRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateUserRegistrationMutation,
    UpdateUserRegistrationMutationVariables
  >(UpdateUserRegistrationDocument, options)
}
export type UpdateUserRegistrationMutationHookResult = ReturnType<
  typeof useUpdateUserRegistrationMutation
>
export type UpdateUserRegistrationMutationResult =
  Apollo.MutationResult<UpdateUserRegistrationMutation>
export type UpdateUserRegistrationMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserRegistrationMutation,
  UpdateUserRegistrationMutationVariables
>
export const UserProfileRegistrationsDocument = gql`
  query UserProfileRegistrations(
    $cursor: String
    $first: Int = 50
    $id: Int
    $role_filter: RoleFilter
    $progress_filter: ProgressFilter
    $id_filter: IntFilter
    $parent_cohort_filter: IDFilter
    $hasParentRegistration: Boolean
    $orderBy: [RegistrationOrderByInput]
  ) {
    user(id: $id) {
      ...User
      registrations(
        first: $first
        after: $cursor
        role_filter: $role_filter
        progress_filter: $progress_filter
        id_filter: $id_filter
        parent_cohort_filter: $parent_cohort_filter
        has_parent_registration: $hasParentRegistration
        orderBy: $orderBy
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...UserProfileRegistration
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${UserProfileRegistrationFragmentDoc}
`

/**
 * __useUserProfileRegistrationsQuery__
 *
 * To run a query within a React component, call `useUserProfileRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileRegistrationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      id: // value for 'id'
 *      role_filter: // value for 'role_filter'
 *      progress_filter: // value for 'progress_filter'
 *      id_filter: // value for 'id_filter'
 *      parent_cohort_filter: // value for 'parent_cohort_filter'
 *      hasParentRegistration: // value for 'hasParentRegistration'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserProfileRegistrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >(UserProfileRegistrationsDocument, options)
}
export function useUserProfileRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >(UserProfileRegistrationsDocument, options)
}
export function useUserProfileRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserProfileRegistrationsQuery,
        UserProfileRegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >(UserProfileRegistrationsDocument, options)
}
export type UserProfileRegistrationsQueryHookResult = ReturnType<
  typeof useUserProfileRegistrationsQuery
>
export type UserProfileRegistrationsLazyQueryHookResult = ReturnType<
  typeof useUserProfileRegistrationsLazyQuery
>
export type UserProfileRegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useUserProfileRegistrationsSuspenseQuery
>
export type UserProfileRegistrationsQueryResult = Apollo.QueryResult<
  UserProfileRegistrationsQuery,
  UserProfileRegistrationsQueryVariables
>
export const ReportQueryDocument = gql`
  query ReportQuery(
    $community_groups: [ReportInput]
    $community_memberships: [ReportInput]
    $group_registrations: [ReportInput]
    $group_performance_points: [ReportInput]
    $group_performance_completion: [ReportInput]
    $school_resources: [ReportInput]
    $school_cohorts: [ReportInput]
    $school_members: [ReportInput]
    $school_member_progress: [ReportInput]
    $school_registrations: [ReportInput]
    $school_coupon_summary: [ReportInput]
    $school_coupon_redemptions: [ReportInput]
    $licensing_store_connected_accounts: [ReportInput]
    $licensing_store_resource_usage: [ReportInput]
    $licensing_store_member_progress: [ReportInput]
    $licensing_member_created_cohorts: [ReportInput]
  ) {
    report(
      community_groups: $community_groups
      community_memberships: $community_memberships
      group_registrations: $group_registrations
      group_performance_points: $group_performance_points
      group_performance_completion: $group_performance_completion
      school_resources: $school_resources
      school_cohorts: $school_cohorts
      school_members: $school_members
      school_member_progress: $school_member_progress
      school_registrations: $school_registrations
      school_coupon_summary: $school_coupon_summary
      school_coupon_redemptions: $school_coupon_redemptions
      licensing_store_connected_accounts: $licensing_store_connected_accounts
      licensing_store_resource_usage: $licensing_store_resource_usage
      licensing_store_member_progress: $licensing_store_member_progress
      licensing_member_created_cohorts: $licensing_member_created_cohorts
    )
  }
`

/**
 * __useReportQueryQuery__
 *
 * To run a query within a React component, call `useReportQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQueryQuery({
 *   variables: {
 *      community_groups: // value for 'community_groups'
 *      community_memberships: // value for 'community_memberships'
 *      group_registrations: // value for 'group_registrations'
 *      group_performance_points: // value for 'group_performance_points'
 *      group_performance_completion: // value for 'group_performance_completion'
 *      school_resources: // value for 'school_resources'
 *      school_cohorts: // value for 'school_cohorts'
 *      school_members: // value for 'school_members'
 *      school_member_progress: // value for 'school_member_progress'
 *      school_registrations: // value for 'school_registrations'
 *      school_coupon_summary: // value for 'school_coupon_summary'
 *      school_coupon_redemptions: // value for 'school_coupon_redemptions'
 *      licensing_store_connected_accounts: // value for 'licensing_store_connected_accounts'
 *      licensing_store_resource_usage: // value for 'licensing_store_resource_usage'
 *      licensing_store_member_progress: // value for 'licensing_store_member_progress'
 *      licensing_member_created_cohorts: // value for 'licensing_member_created_cohorts'
 *   },
 * });
 */
export function useReportQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReportQueryQuery,
    ReportQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReportQueryQuery, ReportQueryQueryVariables>(
    ReportQueryDocument,
    options
  )
}
export function useReportQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportQueryQuery,
    ReportQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ReportQueryQuery, ReportQueryQueryVariables>(
    ReportQueryDocument,
    options
  )
}
export function useReportQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReportQueryQuery,
        ReportQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ReportQueryQuery, ReportQueryQueryVariables>(
    ReportQueryDocument,
    options
  )
}
export type ReportQueryQueryHookResult = ReturnType<typeof useReportQueryQuery>
export type ReportQueryLazyQueryHookResult = ReturnType<
  typeof useReportQueryLazyQuery
>
export type ReportQuerySuspenseQueryHookResult = ReturnType<
  typeof useReportQuerySuspenseQuery
>
export type ReportQueryQueryResult = Apollo.QueryResult<
  ReportQueryQuery,
  ReportQueryQueryVariables
>
export const DeferOrExecuteResourceCopyConfigDocument = gql`
  mutation DeferOrExecuteResourceCopyConfig(
    $copyCode: String!
    $targetSchoolId: Int!
  ) {
    deferOrExecuteResourceCopyConfig(
      copy_code: $copyCode
      target_school_id: $targetSchoolId
    ) {
      defer
      execute
    }
  }
`
export type DeferOrExecuteResourceCopyConfigMutationFn =
  Apollo.MutationFunction<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >

/**
 * __useDeferOrExecuteResourceCopyConfigMutation__
 *
 * To run a mutation, you first call `useDeferOrExecuteResourceCopyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeferOrExecuteResourceCopyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deferOrExecuteResourceCopyConfigMutation, { data, loading, error }] = useDeferOrExecuteResourceCopyConfigMutation({
 *   variables: {
 *      copyCode: // value for 'copyCode'
 *      targetSchoolId: // value for 'targetSchoolId'
 *   },
 * });
 */
export function useDeferOrExecuteResourceCopyConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >(DeferOrExecuteResourceCopyConfigDocument, options)
}
export type DeferOrExecuteResourceCopyConfigMutationHookResult = ReturnType<
  typeof useDeferOrExecuteResourceCopyConfigMutation
>
export type DeferOrExecuteResourceCopyConfigMutationResult =
  Apollo.MutationResult<DeferOrExecuteResourceCopyConfigMutation>
export type DeferOrExecuteResourceCopyConfigMutationOptions =
  Apollo.BaseMutationOptions<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >
export const DeleteResourceCopyConfigLinkDocument = gql`
  mutation DeleteResourceCopyConfigLink($id: Int!) {
    deleteResourceCopyConfigLink(id: $id)
  }
`
export type DeleteResourceCopyConfigLinkMutationFn = Apollo.MutationFunction<
  DeleteResourceCopyConfigLinkMutation,
  DeleteResourceCopyConfigLinkMutationVariables
>

/**
 * __useDeleteResourceCopyConfigLinkMutation__
 *
 * To run a mutation, you first call `useDeleteResourceCopyConfigLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceCopyConfigLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceCopyConfigLinkMutation, { data, loading, error }] = useDeleteResourceCopyConfigLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceCopyConfigLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteResourceCopyConfigLinkMutation,
    DeleteResourceCopyConfigLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteResourceCopyConfigLinkMutation,
    DeleteResourceCopyConfigLinkMutationVariables
  >(DeleteResourceCopyConfigLinkDocument, options)
}
export type DeleteResourceCopyConfigLinkMutationHookResult = ReturnType<
  typeof useDeleteResourceCopyConfigLinkMutation
>
export type DeleteResourceCopyConfigLinkMutationResult =
  Apollo.MutationResult<DeleteResourceCopyConfigLinkMutation>
export type DeleteResourceCopyConfigLinkMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteResourceCopyConfigLinkMutation,
    DeleteResourceCopyConfigLinkMutationVariables
  >
export const ExecuteDeferredResourceCopyConfigDocument = gql`
  mutation ExecuteDeferredResourceCopyConfig($linkId: Int!) {
    executeDeferredResourceCopyConfig(link_id: $linkId) {
      defer
      execute
    }
  }
`
export type ExecuteDeferredResourceCopyConfigMutationFn =
  Apollo.MutationFunction<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >

/**
 * __useExecuteDeferredResourceCopyConfigMutation__
 *
 * To run a mutation, you first call `useExecuteDeferredResourceCopyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteDeferredResourceCopyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeDeferredResourceCopyConfigMutation, { data, loading, error }] = useExecuteDeferredResourceCopyConfigMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useExecuteDeferredResourceCopyConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >(ExecuteDeferredResourceCopyConfigDocument, options)
}
export type ExecuteDeferredResourceCopyConfigMutationHookResult = ReturnType<
  typeof useExecuteDeferredResourceCopyConfigMutation
>
export type ExecuteDeferredResourceCopyConfigMutationResult =
  Apollo.MutationResult<ExecuteDeferredResourceCopyConfigMutation>
export type ExecuteDeferredResourceCopyConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >
export const ResourceCopyConfigDocument = gql`
  query ResourceCopyConfig($key: String!) {
    resourceCopyConfig(key: $key) {
      ...ResourceCopyConfig
    }
  }
  ${ResourceCopyConfigFragmentDoc}
`

/**
 * __useResourceCopyConfigQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useResourceCopyConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  > &
    (
      | { variables: ResourceCopyConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >(ResourceCopyConfigDocument, options)
}
export function useResourceCopyConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >(ResourceCopyConfigDocument, options)
}
export function useResourceCopyConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigQuery,
        ResourceCopyConfigQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >(ResourceCopyConfigDocument, options)
}
export type ResourceCopyConfigQueryHookResult = ReturnType<
  typeof useResourceCopyConfigQuery
>
export type ResourceCopyConfigLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLazyQuery
>
export type ResourceCopyConfigSuspenseQueryHookResult = ReturnType<
  typeof useResourceCopyConfigSuspenseQuery
>
export type ResourceCopyConfigQueryResult = Apollo.QueryResult<
  ResourceCopyConfigQuery,
  ResourceCopyConfigQueryVariables
>
export const ResourceCopyConfigConnectionsDocument = gql`
  query ResourceCopyConfigConnections(
    $first: Int!
    $keys: [String]
    $fromSpaceId: Int
  ) {
    resourceCopyConfigConnections(
      first: $first
      keys: $keys
      fromSpaceId: $fromSpaceId
    ) {
      edges {
        node {
          ...ResourceCopyConfig
        }
      }
    }
  }
  ${ResourceCopyConfigFragmentDoc}
`

/**
 * __useResourceCopyConfigConnectionsQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigConnectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      keys: // value for 'keys'
 *      fromSpaceId: // value for 'fromSpaceId'
 *   },
 * });
 */
export function useResourceCopyConfigConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  > &
    (
      | {
          variables: ResourceCopyConfigConnectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >(ResourceCopyConfigConnectionsDocument, options)
}
export function useResourceCopyConfigConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >(ResourceCopyConfigConnectionsDocument, options)
}
export function useResourceCopyConfigConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigConnectionsQuery,
        ResourceCopyConfigConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >(ResourceCopyConfigConnectionsDocument, options)
}
export type ResourceCopyConfigConnectionsQueryHookResult = ReturnType<
  typeof useResourceCopyConfigConnectionsQuery
>
export type ResourceCopyConfigConnectionsLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigConnectionsLazyQuery
>
export type ResourceCopyConfigConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useResourceCopyConfigConnectionsSuspenseQuery
>
export type ResourceCopyConfigConnectionsQueryResult = Apollo.QueryResult<
  ResourceCopyConfigConnectionsQuery,
  ResourceCopyConfigConnectionsQueryVariables
>
export const ResourceCopyConfigLinkConnectionsDocument = gql`
  query ResourceCopyConfigLinkConnections(
    $first: Int!
    $copiedTimeDateFilter: DateFilter
    $hideFromLocationsFilter: [ResourceCopyConfigLinkLocationFilter]
  ) {
    resourceCopyConfigLinkConnections(
      first: $first
      copiedTimeDateFilter: $copiedTimeDateFilter
      hideFromLocationsFilter: $hideFromLocationsFilter
    ) {
      edges {
        node {
          ...ResourceCopyConfigLink
        }
      }
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useResourceCopyConfigLinkConnectionsQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigLinkConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigLinkConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigLinkConnectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      copiedTimeDateFilter: // value for 'copiedTimeDateFilter'
 *      hideFromLocationsFilter: // value for 'hideFromLocationsFilter'
 *   },
 * });
 */
export function useResourceCopyConfigLinkConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  > &
    (
      | {
          variables: ResourceCopyConfigLinkConnectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >(ResourceCopyConfigLinkConnectionsDocument, options)
}
export function useResourceCopyConfigLinkConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >(ResourceCopyConfigLinkConnectionsDocument, options)
}
export function useResourceCopyConfigLinkConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigLinkConnectionsQuery,
        ResourceCopyConfigLinkConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >(ResourceCopyConfigLinkConnectionsDocument, options)
}
export type ResourceCopyConfigLinkConnectionsQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkConnectionsQuery
>
export type ResourceCopyConfigLinkConnectionsLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkConnectionsLazyQuery
>
export type ResourceCopyConfigLinkConnectionsSuspenseQueryHookResult =
  ReturnType<typeof useResourceCopyConfigLinkConnectionsSuspenseQuery>
export type ResourceCopyConfigLinkConnectionsQueryResult = Apollo.QueryResult<
  ResourceCopyConfigLinkConnectionsQuery,
  ResourceCopyConfigLinkConnectionsQueryVariables
>
export const ResourceCopyConfigLinkDocument = gql`
  query ResourceCopyConfigLink($id: Int!) {
    resourceCopyConfigLink(id: $id) {
      ...ResourceCopyConfigLink
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useResourceCopyConfigLinkQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceCopyConfigLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  > &
    (
      | { variables: ResourceCopyConfigLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >(ResourceCopyConfigLinkDocument, options)
}
export function useResourceCopyConfigLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >(ResourceCopyConfigLinkDocument, options)
}
export function useResourceCopyConfigLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigLinkQuery,
        ResourceCopyConfigLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >(ResourceCopyConfigLinkDocument, options)
}
export type ResourceCopyConfigLinkQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkQuery
>
export type ResourceCopyConfigLinkLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkLazyQuery
>
export type ResourceCopyConfigLinkSuspenseQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkSuspenseQuery
>
export type ResourceCopyConfigLinkQueryResult = Apollo.QueryResult<
  ResourceCopyConfigLinkQuery,
  ResourceCopyConfigLinkQueryVariables
>
export const ResourcePublisherDocument = gql`
  query ResourcePublisher($id: Int) {
    resource(id: $id) {
      id
      publisher {
        ...Publisher
      }
    }
  }
  ${PublisherFragmentDoc}
`

/**
 * __useResourcePublisherQuery__
 *
 * To run a query within a React component, call `useResourcePublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePublisherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourcePublisherQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >(ResourcePublisherDocument, options)
}
export function useResourcePublisherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >(ResourcePublisherDocument, options)
}
export function useResourcePublisherSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcePublisherQuery,
        ResourcePublisherQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >(ResourcePublisherDocument, options)
}
export type ResourcePublisherQueryHookResult = ReturnType<
  typeof useResourcePublisherQuery
>
export type ResourcePublisherLazyQueryHookResult = ReturnType<
  typeof useResourcePublisherLazyQuery
>
export type ResourcePublisherSuspenseQueryHookResult = ReturnType<
  typeof useResourcePublisherSuspenseQuery
>
export type ResourcePublisherQueryResult = Apollo.QueryResult<
  ResourcePublisherQuery,
  ResourcePublisherQueryVariables
>
export const ResourceDocument = gql`
  query Resource($id: Int!) {
    resource(id: $id) {
      ...Resource
    }
  }
  ${ResourceFragmentDoc}
`

/**
 * __useResourceQuery__
 *
 * To run a query within a React component, call `useResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceQuery(
  baseOptions: Apollo.QueryHookOptions<ResourceQuery, ResourceQueryVariables> &
    ({ variables: ResourceQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceQuery, ResourceQueryVariables>(
    ResourceDocument,
    options
  )
}
export function useResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceQuery,
    ResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ResourceQuery, ResourceQueryVariables>(
    ResourceDocument,
    options
  )
}
export function useResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResourceQuery, ResourceQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ResourceQuery, ResourceQueryVariables>(
    ResourceDocument,
    options
  )
}
export type ResourceQueryHookResult = ReturnType<typeof useResourceQuery>
export type ResourceLazyQueryHookResult = ReturnType<
  typeof useResourceLazyQuery
>
export type ResourceSuspenseQueryHookResult = ReturnType<
  typeof useResourceSuspenseQuery
>
export type ResourceQueryResult = Apollo.QueryResult<
  ResourceQuery,
  ResourceQueryVariables
>
export const ShowHideResourceCopyConfigLinkDocument = gql`
  mutation ShowHideResourceCopyConfigLink(
    $id: Int!
    $show: [ResourceCopyConfigLinkLocation]
    $hide: [ResourceCopyConfigLinkLocation]
  ) {
    showHideResourceCopyConfigLink(id: $id, show: $show, hide: $hide) {
      ...ResourceCopyConfigLink
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
`
export type ShowHideResourceCopyConfigLinkMutationFn = Apollo.MutationFunction<
  ShowHideResourceCopyConfigLinkMutation,
  ShowHideResourceCopyConfigLinkMutationVariables
>

/**
 * __useShowHideResourceCopyConfigLinkMutation__
 *
 * To run a mutation, you first call `useShowHideResourceCopyConfigLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShowHideResourceCopyConfigLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [showHideResourceCopyConfigLinkMutation, { data, loading, error }] = useShowHideResourceCopyConfigLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      show: // value for 'show'
 *      hide: // value for 'hide'
 *   },
 * });
 */
export function useShowHideResourceCopyConfigLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShowHideResourceCopyConfigLinkMutation,
    ShowHideResourceCopyConfigLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ShowHideResourceCopyConfigLinkMutation,
    ShowHideResourceCopyConfigLinkMutationVariables
  >(ShowHideResourceCopyConfigLinkDocument, options)
}
export type ShowHideResourceCopyConfigLinkMutationHookResult = ReturnType<
  typeof useShowHideResourceCopyConfigLinkMutation
>
export type ShowHideResourceCopyConfigLinkMutationResult =
  Apollo.MutationResult<ShowHideResourceCopyConfigLinkMutation>
export type ShowHideResourceCopyConfigLinkMutationOptions =
  Apollo.BaseMutationOptions<
    ShowHideResourceCopyConfigLinkMutation,
    ShowHideResourceCopyConfigLinkMutationVariables
  >
export const ComputedDiscountQueryDocument = gql`
  query ComputedDiscountQuery(
    $discount_code: String!
    $resource_id: Int!
    $license_offering_id: Int
    $offering_id: Int
    $seat_count: Int
  ) {
    computedDiscount(
      discount_code: $discount_code
      resource_id: $resource_id
      license_offering_id: $license_offering_id
      offering_id: $offering_id
      seat_count: $seat_count
    ) {
      id
      max_seat_discount
      discount_percent
      discount_amount
      discounted_total
    }
  }
`

/**
 * __useComputedDiscountQueryQuery__
 *
 * To run a query within a React component, call `useComputedDiscountQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputedDiscountQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputedDiscountQueryQuery({
 *   variables: {
 *      discount_code: // value for 'discount_code'
 *      resource_id: // value for 'resource_id'
 *      license_offering_id: // value for 'license_offering_id'
 *      offering_id: // value for 'offering_id'
 *      seat_count: // value for 'seat_count'
 *   },
 * });
 */
export function useComputedDiscountQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ComputedDiscountQueryQuery,
    ComputedDiscountQueryQueryVariables
  > &
    (
      | { variables: ComputedDiscountQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ComputedDiscountQueryQuery,
    ComputedDiscountQueryQueryVariables
  >(ComputedDiscountQueryDocument, options)
}
export function useComputedDiscountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ComputedDiscountQueryQuery,
    ComputedDiscountQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ComputedDiscountQueryQuery,
    ComputedDiscountQueryQueryVariables
  >(ComputedDiscountQueryDocument, options)
}
export function useComputedDiscountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ComputedDiscountQueryQuery,
        ComputedDiscountQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ComputedDiscountQueryQuery,
    ComputedDiscountQueryQueryVariables
  >(ComputedDiscountQueryDocument, options)
}
export type ComputedDiscountQueryQueryHookResult = ReturnType<
  typeof useComputedDiscountQueryQuery
>
export type ComputedDiscountQueryLazyQueryHookResult = ReturnType<
  typeof useComputedDiscountQueryLazyQuery
>
export type ComputedDiscountQuerySuspenseQueryHookResult = ReturnType<
  typeof useComputedDiscountQuerySuspenseQuery
>
export type ComputedDiscountQueryQueryResult = Apollo.QueryResult<
  ComputedDiscountQueryQuery,
  ComputedDiscountQueryQueryVariables
>
export const LicenseOfferingDocument = gql`
  query LicenseOffering($id: Int!, $school_id: Int!) {
    context(school_id: $school_id) {
      school {
        ...School
        license_offering(id: $id) {
          ...LicenseOffering
          resource {
            ...Resource
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${LicenseOfferingFragmentDoc}
  ${ResourceFragmentDoc}
`

/**
 * __useLicenseOfferingQuery__
 *
 * To run a query within a React component, call `useLicenseOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseOfferingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function useLicenseOfferingQuery(
  baseOptions: Apollo.QueryHookOptions<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  > &
    (
      | { variables: LicenseOfferingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LicenseOfferingQuery, LicenseOfferingQueryVariables>(
    LicenseOfferingDocument,
    options
  )
}
export function useLicenseOfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  >(LicenseOfferingDocument, options)
}
export function useLicenseOfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LicenseOfferingQuery,
        LicenseOfferingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  >(LicenseOfferingDocument, options)
}
export type LicenseOfferingQueryHookResult = ReturnType<
  typeof useLicenseOfferingQuery
>
export type LicenseOfferingLazyQueryHookResult = ReturnType<
  typeof useLicenseOfferingLazyQuery
>
export type LicenseOfferingSuspenseQueryHookResult = ReturnType<
  typeof useLicenseOfferingSuspenseQuery
>
export type LicenseOfferingQueryResult = Apollo.QueryResult<
  LicenseOfferingQuery,
  LicenseOfferingQueryVariables
>
export const LicenseResourceDocument = gql`
  mutation LicenseResource(
    $resource_id: Int!
    $license_offering_id: Int!
    $licensee_school_id: Int
    $use_group_subscription_id: Int
    $name: String
    $seat_count: Int
    $role: LicenseRoleEnum
    $payment_token: String
    $coupon_code: String
  ) {
    licenseResource(
      resource_id: $resource_id
      license_offering_id: $license_offering_id
      licensee_school_id: $licensee_school_id
      use_group_subscription_id: $use_group_subscription_id
      name: $name
      seat_count: $seat_count
      role: $role
      payment_token: $payment_token
      coupon_code: $coupon_code
    ) {
      ...ResourceLicense
    }
  }
  ${ResourceLicenseFragmentDoc}
`
export type LicenseResourceMutationFn = Apollo.MutationFunction<
  LicenseResourceMutation,
  LicenseResourceMutationVariables
>

/**
 * __useLicenseResourceMutation__
 *
 * To run a mutation, you first call `useLicenseResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLicenseResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [licenseResourceMutation, { data, loading, error }] = useLicenseResourceMutation({
 *   variables: {
 *      resource_id: // value for 'resource_id'
 *      license_offering_id: // value for 'license_offering_id'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      use_group_subscription_id: // value for 'use_group_subscription_id'
 *      name: // value for 'name'
 *      seat_count: // value for 'seat_count'
 *      role: // value for 'role'
 *      payment_token: // value for 'payment_token'
 *      coupon_code: // value for 'coupon_code'
 *   },
 * });
 */
export function useLicenseResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LicenseResourceMutation,
    LicenseResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    LicenseResourceMutation,
    LicenseResourceMutationVariables
  >(LicenseResourceDocument, options)
}
export type LicenseResourceMutationHookResult = ReturnType<
  typeof useLicenseResourceMutation
>
export type LicenseResourceMutationResult =
  Apollo.MutationResult<LicenseResourceMutation>
export type LicenseResourceMutationOptions = Apollo.BaseMutationOptions<
  LicenseResourceMutation,
  LicenseResourceMutationVariables
>
export const ResourceLicenseDocument = gql`
  query ResourceLicense($id: Int) {
    resource_license(id: $id) {
      ...ResourceLicense
    }
  }
  ${ResourceLicenseFragmentDoc}
`

/**
 * __useResourceLicenseQuery__
 *
 * To run a query within a React component, call `useResourceLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceLicenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceLicenseQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceLicenseQuery, ResourceLicenseQueryVariables>(
    ResourceLicenseDocument,
    options
  )
}
export function useResourceLicenseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >(ResourceLicenseDocument, options)
}
export function useResourceLicenseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceLicenseQuery,
        ResourceLicenseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >(ResourceLicenseDocument, options)
}
export type ResourceLicenseQueryHookResult = ReturnType<
  typeof useResourceLicenseQuery
>
export type ResourceLicenseLazyQueryHookResult = ReturnType<
  typeof useResourceLicenseLazyQuery
>
export type ResourceLicenseSuspenseQueryHookResult = ReturnType<
  typeof useResourceLicenseSuspenseQuery
>
export type ResourceLicenseQueryResult = Apollo.QueryResult<
  ResourceLicenseQuery,
  ResourceLicenseQueryVariables
>
export const ScopedResourceLicenseDocument = gql`
  query ScopedResourceLicense($schoolId: Int!, $resourceLicenseId: Int!) {
    context(school_id: $schoolId) {
      school {
        id
        resource_license(id: $resourceLicenseId) {
          ...ResourceLicense
        }
      }
    }
  }
  ${ResourceLicenseFragmentDoc}
`

/**
 * __useScopedResourceLicenseQuery__
 *
 * To run a query within a React component, call `useScopedResourceLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopedResourceLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopedResourceLicenseQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      resourceLicenseId: // value for 'resourceLicenseId'
 *   },
 * });
 */
export function useScopedResourceLicenseQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  > &
    (
      | { variables: ScopedResourceLicenseQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >(ScopedResourceLicenseDocument, options)
}
export function useScopedResourceLicenseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >(ScopedResourceLicenseDocument, options)
}
export function useScopedResourceLicenseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScopedResourceLicenseQuery,
        ScopedResourceLicenseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >(ScopedResourceLicenseDocument, options)
}
export type ScopedResourceLicenseQueryHookResult = ReturnType<
  typeof useScopedResourceLicenseQuery
>
export type ScopedResourceLicenseLazyQueryHookResult = ReturnType<
  typeof useScopedResourceLicenseLazyQuery
>
export type ScopedResourceLicenseSuspenseQueryHookResult = ReturnType<
  typeof useScopedResourceLicenseSuspenseQuery
>
export type ScopedResourceLicenseQueryResult = Apollo.QueryResult<
  ScopedResourceLicenseQuery,
  ScopedResourceLicenseQueryVariables
>
export const CopyResourceDocument = gql`
  mutation CopyResource(
    $id: Int!
    $to_school: Int
    $create_offering: Boolean
    $create_registration_with_role: RegistrationRoleEnum
  ) {
    copyResource(
      id: $id
      to_school: $to_school
      create_offering: $create_offering
      create_registration_with_role: $create_registration_with_role
    ) {
      ...Resource
      source_cohort: group(is_source: true) {
        id
      }
    }
  }
  ${ResourceFragmentDoc}
`
export type CopyResourceMutationFn = Apollo.MutationFunction<
  CopyResourceMutation,
  CopyResourceMutationVariables
>

/**
 * __useCopyResourceMutation__
 *
 * To run a mutation, you first call `useCopyResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyResourceMutation, { data, loading, error }] = useCopyResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      to_school: // value for 'to_school'
 *      create_offering: // value for 'create_offering'
 *      create_registration_with_role: // value for 'create_registration_with_role'
 *   },
 * });
 */
export function useCopyResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CopyResourceMutation,
    CopyResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CopyResourceMutation,
    CopyResourceMutationVariables
  >(CopyResourceDocument, options)
}
export type CopyResourceMutationHookResult = ReturnType<
  typeof useCopyResourceMutation
>
export type CopyResourceMutationResult =
  Apollo.MutationResult<CopyResourceMutation>
export type CopyResourceMutationOptions = Apollo.BaseMutationOptions<
  CopyResourceMutation,
  CopyResourceMutationVariables
>
export const ManageResourceDocument = gql`
  query ManageResource($id: Int) {
    resource(id: $id) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`

/**
 * __useManageResourceQuery__
 *
 * To run a query within a React component, call `useManageResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManageResourceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManageResourceQuery,
    ManageResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ManageResourceQuery, ManageResourceQueryVariables>(
    ManageResourceDocument,
    options
  )
}
export function useManageResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManageResourceQuery,
    ManageResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ManageResourceQuery, ManageResourceQueryVariables>(
    ManageResourceDocument,
    options
  )
}
export function useManageResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManageResourceQuery,
        ManageResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ManageResourceQuery,
    ManageResourceQueryVariables
  >(ManageResourceDocument, options)
}
export type ManageResourceQueryHookResult = ReturnType<
  typeof useManageResourceQuery
>
export type ManageResourceLazyQueryHookResult = ReturnType<
  typeof useManageResourceLazyQuery
>
export type ManageResourceSuspenseQueryHookResult = ReturnType<
  typeof useManageResourceSuspenseQuery
>
export type ManageResourceQueryResult = Apollo.QueryResult<
  ManageResourceQuery,
  ManageResourceQueryVariables
>
export const ResourceEditorsDocument = gql`
  query ResourceEditors($id: Int, $cursor: String) {
    resource(id: $id) {
      ...Resource
      registration_meta {
        editor_registration_count
      }
      group(type: curriculum) {
        id
        registrations(first: 10, role_filter: { eq: editor }, after: $cursor) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              role
              softArchivedTime
              user {
                ...User
              }
            }
          }
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useResourceEditorsQuery__
 *
 * To run a query within a React component, call `useResourceEditorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceEditorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceEditorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useResourceEditorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceEditorsQuery, ResourceEditorsQueryVariables>(
    ResourceEditorsDocument,
    options
  )
}
export function useResourceEditorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >(ResourceEditorsDocument, options)
}
export function useResourceEditorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceEditorsQuery,
        ResourceEditorsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >(ResourceEditorsDocument, options)
}
export type ResourceEditorsQueryHookResult = ReturnType<
  typeof useResourceEditorsQuery
>
export type ResourceEditorsLazyQueryHookResult = ReturnType<
  typeof useResourceEditorsLazyQuery
>
export type ResourceEditorsSuspenseQueryHookResult = ReturnType<
  typeof useResourceEditorsSuspenseQuery
>
export type ResourceEditorsQueryResult = Apollo.QueryResult<
  ResourceEditorsQuery,
  ResourceEditorsQueryVariables
>
export const ResourceQueryDocument = gql`
  query ResourceQuery($id: Int!) {
    resource(id: $id) {
      id
      name
      resource_type
    }
  }
`

/**
 * __useResourceQueryQuery__
 *
 * To run a query within a React component, call `useResourceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceQueryQuery,
    ResourceQueryQueryVariables
  > &
    (
      | { variables: ResourceQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceQueryQuery, ResourceQueryQueryVariables>(
    ResourceQueryDocument,
    options
  )
}
export function useResourceQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceQueryQuery,
    ResourceQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ResourceQueryQuery, ResourceQueryQueryVariables>(
    ResourceQueryDocument,
    options
  )
}
export function useResourceQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceQueryQuery,
        ResourceQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceQueryQuery,
    ResourceQueryQueryVariables
  >(ResourceQueryDocument, options)
}
export type ResourceQueryQueryHookResult = ReturnType<
  typeof useResourceQueryQuery
>
export type ResourceQueryLazyQueryHookResult = ReturnType<
  typeof useResourceQueryLazyQuery
>
export type ResourceQuerySuspenseQueryHookResult = ReturnType<
  typeof useResourceQuerySuspenseQuery
>
export type ResourceQueryQueryResult = Apollo.QueryResult<
  ResourceQueryQuery,
  ResourceQueryQueryVariables
>
export const UpdateResourceAdvancedDocument = gql`
  mutation UpdateResourceAdvanced(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $trailer_embed_code: String
    $visibility_level_override: Int
    $certificate_generator_class: String
    $discussion_enabled: Boolean
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      trailer_embed_code: $trailer_embed_code
      visibility_level_override: $visibility_level_override
      certificate_generator_class: $certificate_generator_class
      discussion_enabled: $discussion_enabled
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceAdvancedMutationFn = Apollo.MutationFunction<
  UpdateResourceAdvancedMutation,
  UpdateResourceAdvancedMutationVariables
>

/**
 * __useUpdateResourceAdvancedMutation__
 *
 * To run a mutation, you first call `useUpdateResourceAdvancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceAdvancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceAdvancedMutation, { data, loading, error }] = useUpdateResourceAdvancedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      trailer_embed_code: // value for 'trailer_embed_code'
 *      visibility_level_override: // value for 'visibility_level_override'
 *      certificate_generator_class: // value for 'certificate_generator_class'
 *      discussion_enabled: // value for 'discussion_enabled'
 *   },
 * });
 */
export function useUpdateResourceAdvancedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceAdvancedMutation,
    UpdateResourceAdvancedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceAdvancedMutation,
    UpdateResourceAdvancedMutationVariables
  >(UpdateResourceAdvancedDocument, options)
}
export type UpdateResourceAdvancedMutationHookResult = ReturnType<
  typeof useUpdateResourceAdvancedMutation
>
export type UpdateResourceAdvancedMutationResult =
  Apollo.MutationResult<UpdateResourceAdvancedMutation>
export type UpdateResourceAdvancedMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceAdvancedMutation,
  UpdateResourceAdvancedMutationVariables
>
export const UpdateResourceDetailsDocument = gql`
  mutation UpdateResourceDetails(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $description: String
    $short_description: String
    $trailer_embed_code: String
    $authors: [Int]
    $categories: [Int]
    $visibility_level_override: Int
    $cover_image: String
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      description: $description
      short_description: $short_description
      trailer_embed_code: $trailer_embed_code
      authors: $authors
      categories: $categories
      visibility_level_override: $visibility_level_override
      cover_image: $cover_image
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceDetailsMutationFn = Apollo.MutationFunction<
  UpdateResourceDetailsMutation,
  UpdateResourceDetailsMutationVariables
>

/**
 * __useUpdateResourceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateResourceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceDetailsMutation, { data, loading, error }] = useUpdateResourceDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      description: // value for 'description'
 *      short_description: // value for 'short_description'
 *      trailer_embed_code: // value for 'trailer_embed_code'
 *      authors: // value for 'authors'
 *      categories: // value for 'categories'
 *      visibility_level_override: // value for 'visibility_level_override'
 *      cover_image: // value for 'cover_image'
 *   },
 * });
 */
export function useUpdateResourceDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceDetailsMutation,
    UpdateResourceDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceDetailsMutation,
    UpdateResourceDetailsMutationVariables
  >(UpdateResourceDetailsDocument, options)
}
export type UpdateResourceDetailsMutationHookResult = ReturnType<
  typeof useUpdateResourceDetailsMutation
>
export type UpdateResourceDetailsMutationResult =
  Apollo.MutationResult<UpdateResourceDetailsMutation>
export type UpdateResourceDetailsMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceDetailsMutation,
  UpdateResourceDetailsMutationVariables
>
export const UpdateResourceMenuDocument = gql`
  mutation UpdateResourceMenu(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $cover_image: String
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      cover_image: $cover_image
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceMenuMutationFn = Apollo.MutationFunction<
  UpdateResourceMenuMutation,
  UpdateResourceMenuMutationVariables
>

/**
 * __useUpdateResourceMenuMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMenuMutation, { data, loading, error }] = useUpdateResourceMenuMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      cover_image: // value for 'cover_image'
 *   },
 * });
 */
export function useUpdateResourceMenuMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceMenuMutation,
    UpdateResourceMenuMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceMenuMutation,
    UpdateResourceMenuMutationVariables
  >(UpdateResourceMenuDocument, options)
}
export type UpdateResourceMenuMutationHookResult = ReturnType<
  typeof useUpdateResourceMenuMutation
>
export type UpdateResourceMenuMutationResult =
  Apollo.MutationResult<UpdateResourceMenuMutation>
export type UpdateResourceMenuMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceMenuMutation,
  UpdateResourceMenuMutationVariables
>
export const UpdateResourceDocument = gql`
  mutation UpdateResource(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $cover_image: String
    $background_image: String
    $background_overlay: String
    $background_type: Int
    $description: String
    $short_description: String
    $authors: [Int]
    $categories: [Int]
    $trailer_embed_code: String
    $visibility_level_override: Int
    $certificate_generator_class: String
    $discussion_enabled: Boolean
    $certificateJSON: JSON
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      cover_image: $cover_image
      background_image: $background_image
      background_overlay: $background_overlay
      background_type: $background_type
      description: $description
      short_description: $short_description
      authors: $authors
      categories: $categories
      trailer_embed_code: $trailer_embed_code
      visibility_level_override: $visibility_level_override
      certificate_generator_class: $certificate_generator_class
      discussion_enabled: $discussion_enabled
      certificate_json: $certificateJSON
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceMutationFn = Apollo.MutationFunction<
  UpdateResourceMutation,
  UpdateResourceMutationVariables
>

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      cover_image: // value for 'cover_image'
 *      background_image: // value for 'background_image'
 *      background_overlay: // value for 'background_overlay'
 *      background_type: // value for 'background_type'
 *      description: // value for 'description'
 *      short_description: // value for 'short_description'
 *      authors: // value for 'authors'
 *      categories: // value for 'categories'
 *      trailer_embed_code: // value for 'trailer_embed_code'
 *      visibility_level_override: // value for 'visibility_level_override'
 *      certificate_generator_class: // value for 'certificate_generator_class'
 *      discussion_enabled: // value for 'discussion_enabled'
 *      certificateJSON: // value for 'certificateJSON'
 *   },
 * });
 */
export function useUpdateResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceMutation,
    UpdateResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceMutation,
    UpdateResourceMutationVariables
  >(UpdateResourceDocument, options)
}
export type UpdateResourceMutationHookResult = ReturnType<
  typeof useUpdateResourceMutation
>
export type UpdateResourceMutationResult =
  Apollo.MutationResult<UpdateResourceMutation>
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceMutation,
  UpdateResourceMutationVariables
>
export const RestApiGetDocument = gql`
  query RestAPIGet($endpoint: String!) {
    restAPIGet(endpoint: $endpoint)
  }
`

/**
 * __useRestApiGetQuery__
 *
 * To run a query within a React component, call `useRestApiGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestApiGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestApiGetQuery({
 *   variables: {
 *      endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useRestApiGetQuery(
  baseOptions: Apollo.QueryHookOptions<
    RestApiGetQuery,
    RestApiGetQueryVariables
  > &
    (
      | { variables: RestApiGetQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RestApiGetQuery, RestApiGetQueryVariables>(
    RestApiGetDocument,
    options
  )
}
export function useRestApiGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RestApiGetQuery,
    RestApiGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RestApiGetQuery, RestApiGetQueryVariables>(
    RestApiGetDocument,
    options
  )
}
export function useRestApiGetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RestApiGetQuery, RestApiGetQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RestApiGetQuery, RestApiGetQueryVariables>(
    RestApiGetDocument,
    options
  )
}
export type RestApiGetQueryHookResult = ReturnType<typeof useRestApiGetQuery>
export type RestApiGetLazyQueryHookResult = ReturnType<
  typeof useRestApiGetLazyQuery
>
export type RestApiGetSuspenseQueryHookResult = ReturnType<
  typeof useRestApiGetSuspenseQuery
>
export type RestApiGetQueryResult = Apollo.QueryResult<
  RestApiGetQuery,
  RestApiGetQueryVariables
>
export const CurriculumSubscriptionPlansDocument = gql`
  query CurriculumSubscriptionPlans(
    $visibilityCode: String
    $visibilityCodeFilter: StringFilter
  ) {
    school {
      id
      curriculum_plans(
        first: 50
        visibility_code: $visibilityCode
        visibility_code_filter: $visibilityCodeFilter
      ) {
        edges {
          node {
            ...SchoolCurriculumPlan
          }
        }
      }
    }
  }
  ${SchoolCurriculumPlanFragmentDoc}
`

/**
 * __useCurriculumSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useCurriculumSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumSubscriptionPlansQuery({
 *   variables: {
 *      visibilityCode: // value for 'visibilityCode'
 *      visibilityCodeFilter: // value for 'visibilityCodeFilter'
 *   },
 * });
 */
export function useCurriculumSubscriptionPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >(CurriculumSubscriptionPlansDocument, options)
}
export function useCurriculumSubscriptionPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >(CurriculumSubscriptionPlansDocument, options)
}
export function useCurriculumSubscriptionPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurriculumSubscriptionPlansQuery,
        CurriculumSubscriptionPlansQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >(CurriculumSubscriptionPlansDocument, options)
}
export type CurriculumSubscriptionPlansQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionPlansQuery
>
export type CurriculumSubscriptionPlansLazyQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionPlansLazyQuery
>
export type CurriculumSubscriptionPlansSuspenseQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionPlansSuspenseQuery
>
export type CurriculumSubscriptionPlansQueryResult = Apollo.QueryResult<
  CurriculumSubscriptionPlansQuery,
  CurriculumSubscriptionPlansQueryVariables
>
export const CurriculumSubscriptionDocument = gql`
  query CurriculumSubscription(
    $schoolId: Int!
    $curriculumSubscriptionId: Int!
  ) {
    context(school_id: $schoolId) {
      school {
        curriculum_subscription(id: $curriculumSubscriptionId) {
          ...CurriculumSubscription
        }
      }
    }
  }
  ${CurriculumSubscriptionFragmentDoc}
`

/**
 * __useCurriculumSubscriptionQuery__
 *
 * To run a query within a React component, call `useCurriculumSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumSubscriptionQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      curriculumSubscriptionId: // value for 'curriculumSubscriptionId'
 *   },
 * });
 */
export function useCurriculumSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  > &
    (
      | { variables: CurriculumSubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >(CurriculumSubscriptionDocument, options)
}
export function useCurriculumSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >(CurriculumSubscriptionDocument, options)
}
export function useCurriculumSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurriculumSubscriptionQuery,
        CurriculumSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >(CurriculumSubscriptionDocument, options)
}
export type CurriculumSubscriptionQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionQuery
>
export type CurriculumSubscriptionLazyQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionLazyQuery
>
export type CurriculumSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionSuspenseQuery
>
export type CurriculumSubscriptionQueryResult = Apollo.QueryResult<
  CurriculumSubscriptionQuery,
  CurriculumSubscriptionQueryVariables
>
export const CurriculumSubscriptionsDocument = gql`
  query CurriculumSubscriptions {
    school {
      ...School
      curriculum_subscriptions(first: 50) {
        edges {
          node {
            ...CurriculumSubscription
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${CurriculumSubscriptionFragmentDoc}
`

/**
 * __useCurriculumSubscriptionsQuery__
 *
 * To run a query within a React component, call `useCurriculumSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurriculumSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >(CurriculumSubscriptionsDocument, options)
}
export function useCurriculumSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >(CurriculumSubscriptionsDocument, options)
}
export function useCurriculumSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurriculumSubscriptionsQuery,
        CurriculumSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >(CurriculumSubscriptionsDocument, options)
}
export type CurriculumSubscriptionsQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionsQuery
>
export type CurriculumSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionsLazyQuery
>
export type CurriculumSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionsSuspenseQuery
>
export type CurriculumSubscriptionsQueryResult = Apollo.QueryResult<
  CurriculumSubscriptionsQuery,
  CurriculumSubscriptionsQueryVariables
>
export const SchoolQueryDocument = gql`
  query SchoolQuery($id: Int!) {
    context(school_id: $id) {
      school {
        ...School
        theme {
          ...Theme
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ThemeFragmentDoc}
`

/**
 * __useSchoolQueryQuery__
 *
 * To run a query within a React component, call `useSchoolQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchoolQueryQuery,
    SchoolQueryQueryVariables
  > &
    (
      | { variables: SchoolQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchoolQueryQuery, SchoolQueryQueryVariables>(
    SchoolQueryDocument,
    options
  )
}
export function useSchoolQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolQueryQuery,
    SchoolQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SchoolQueryQuery, SchoolQueryQueryVariables>(
    SchoolQueryDocument,
    options
  )
}
export function useSchoolQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolQueryQuery,
        SchoolQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SchoolQueryQuery, SchoolQueryQueryVariables>(
    SchoolQueryDocument,
    options
  )
}
export type SchoolQueryQueryHookResult = ReturnType<typeof useSchoolQueryQuery>
export type SchoolQueryLazyQueryHookResult = ReturnType<
  typeof useSchoolQueryLazyQuery
>
export type SchoolQuerySuspenseQueryHookResult = ReturnType<
  typeof useSchoolQuerySuspenseQuery
>
export type SchoolQueryQueryResult = Apollo.QueryResult<
  SchoolQueryQuery,
  SchoolQueryQueryVariables
>
export const UpdateSchoolCustomCssDocument = gql`
  mutation UpdateSchoolCustomCss(
    $id: Int!
    $customCss: String!
    $name: String!
  ) {
    updateSchoolCustomCSS(id: $id, custom_css: $customCss, name: $name) {
      ...Theme
    }
  }
  ${ThemeFragmentDoc}
`
export type UpdateSchoolCustomCssMutationFn = Apollo.MutationFunction<
  UpdateSchoolCustomCssMutation,
  UpdateSchoolCustomCssMutationVariables
>

/**
 * __useUpdateSchoolCustomCssMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolCustomCssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolCustomCssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolCustomCssMutation, { data, loading, error }] = useUpdateSchoolCustomCssMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customCss: // value for 'customCss'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateSchoolCustomCssMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchoolCustomCssMutation,
    UpdateSchoolCustomCssMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSchoolCustomCssMutation,
    UpdateSchoolCustomCssMutationVariables
  >(UpdateSchoolCustomCssDocument, options)
}
export type UpdateSchoolCustomCssMutationHookResult = ReturnType<
  typeof useUpdateSchoolCustomCssMutation
>
export type UpdateSchoolCustomCssMutationResult =
  Apollo.MutationResult<UpdateSchoolCustomCssMutation>
export type UpdateSchoolCustomCssMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchoolCustomCssMutation,
  UpdateSchoolCustomCssMutationVariables
>
export const AddPeopleToMutationDocument = gql`
  mutation AddPeopleToMutation(
    $selection: [AddPeopleSelection]!
    $notificationMessage: String
    $sendFromSchool: Boolean
    $sendNotification: Boolean
  ) {
    addPeopleTo(
      selection: $selection
      notification_message: $notificationMessage
      send_from_school: $sendFromSchool
      send_notification: $sendNotification
    ) {
      id
      result
    }
  }
`
export type AddPeopleToMutationMutationFn = Apollo.MutationFunction<
  AddPeopleToMutationMutation,
  AddPeopleToMutationMutationVariables
>

/**
 * __useAddPeopleToMutationMutation__
 *
 * To run a mutation, you first call `useAddPeopleToMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPeopleToMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPeopleToMutationMutation, { data, loading, error }] = useAddPeopleToMutationMutation({
 *   variables: {
 *      selection: // value for 'selection'
 *      notificationMessage: // value for 'notificationMessage'
 *      sendFromSchool: // value for 'sendFromSchool'
 *      sendNotification: // value for 'sendNotification'
 *   },
 * });
 */
export function useAddPeopleToMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPeopleToMutationMutation,
    AddPeopleToMutationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AddPeopleToMutationMutation,
    AddPeopleToMutationMutationVariables
  >(AddPeopleToMutationDocument, options)
}
export type AddPeopleToMutationMutationHookResult = ReturnType<
  typeof useAddPeopleToMutationMutation
>
export type AddPeopleToMutationMutationResult =
  Apollo.MutationResult<AddPeopleToMutationMutation>
export type AddPeopleToMutationMutationOptions = Apollo.BaseMutationOptions<
  AddPeopleToMutationMutation,
  AddPeopleToMutationMutationVariables
>
export const CohortShareContextQueryDocument = gql`
  query CohortShareContextQuery($type: ShareContextType!, $typeId: Int!) {
    cohort: group(id: $typeId) {
      id
      visibility
      access_ends
      registration_ends
      status
      seats_available
      resource {
        id
        name
        short_description
        image_raw
      }
    }
    sharePermissions(context: { type: $type, type_id: $typeId }) {
      ... on ShareCohortPermissions {
        type
        type_id
        add_limit
        allow_manage
        manage_url
        allow_activate
        activate_contact_email
        share_access {
          access
          gated_reason
        }
        share_link_access {
          access
          gated_reason
        }
        share_add_access {
          access
          gated_reason
        }
        share_track_access {
          access
          gated_reason
        }
        invite_roles {
          cohort_viewer: viewer {
            url
            role
            gate_reason
          }
          cohort_observer: observer {
            url
            role
            gate_reason
          }
          cohort_learner: learner {
            url
            role
            gate_reason
          }
          cohort_moderator: moderator {
            url
            role
            gate_reason
          }
          cohort_teacher: teacher {
            url
            role
            gate_reason
          }
          cohort_course_editor: course_editor {
            url
            role
            gate_reason
          }
        }
        __typename
      }
    }
  }
`

/**
 * __useCohortShareContextQueryQuery__
 *
 * To run a query within a React component, call `useCohortShareContextQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortShareContextQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortShareContextQueryQuery({
 *   variables: {
 *      type: // value for 'type'
 *      typeId: // value for 'typeId'
 *   },
 * });
 */
export function useCohortShareContextQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortShareContextQueryQuery,
    CohortShareContextQueryQueryVariables
  > &
    (
      | { variables: CohortShareContextQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortShareContextQueryQuery,
    CohortShareContextQueryQueryVariables
  >(CohortShareContextQueryDocument, options)
}
export function useCohortShareContextQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortShareContextQueryQuery,
    CohortShareContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortShareContextQueryQuery,
    CohortShareContextQueryQueryVariables
  >(CohortShareContextQueryDocument, options)
}
export function useCohortShareContextQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortShareContextQueryQuery,
        CohortShareContextQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortShareContextQueryQuery,
    CohortShareContextQueryQueryVariables
  >(CohortShareContextQueryDocument, options)
}
export type CohortShareContextQueryQueryHookResult = ReturnType<
  typeof useCohortShareContextQueryQuery
>
export type CohortShareContextQueryLazyQueryHookResult = ReturnType<
  typeof useCohortShareContextQueryLazyQuery
>
export type CohortShareContextQuerySuspenseQueryHookResult = ReturnType<
  typeof useCohortShareContextQuerySuspenseQuery
>
export type CohortShareContextQueryQueryResult = Apollo.QueryResult<
  CohortShareContextQueryQuery,
  CohortShareContextQueryQueryVariables
>
export const GroupShareContextQueryDocument = gql`
  query GroupShareContextQuery($type: ShareContextType!, $typeId: Int!) {
    school {
      id
      group: mentor_group(id: $typeId) {
        id
        name
        description
        type
        seat_limit
        seats_available
        seats_filled
        group_subscription {
          id
          subscription {
            id
            canceled_dtime
          }
        }
      }
    }
    sharePermissions(context: { type: $type, type_id: $typeId }) {
      ... on ShareGroupPermissions {
        type
        type_id
        add_limit
        allow_manage
        manage_url
        allow_activate
        activate_contact_email
        share_access {
          access
          gated_reason
        }
        share_link_access {
          access
          gated_reason
        }
        share_add_access {
          access
          gated_reason
        }
        share_track_access {
          access
          gated_reason
        }
        invite_roles {
          group_member: member {
            url
            role
            gate_reason
          }
          group_moderator: moderator {
            url
            role
            gate_reason
          }
          group_admin: admin {
            url
            role
            gate_reason
          }
        }
        __typename
      }
    }
  }
`

/**
 * __useGroupShareContextQueryQuery__
 *
 * To run a query within a React component, call `useGroupShareContextQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupShareContextQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupShareContextQueryQuery({
 *   variables: {
 *      type: // value for 'type'
 *      typeId: // value for 'typeId'
 *   },
 * });
 */
export function useGroupShareContextQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupShareContextQueryQuery,
    GroupShareContextQueryQueryVariables
  > &
    (
      | { variables: GroupShareContextQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GroupShareContextQueryQuery,
    GroupShareContextQueryQueryVariables
  >(GroupShareContextQueryDocument, options)
}
export function useGroupShareContextQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupShareContextQueryQuery,
    GroupShareContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GroupShareContextQueryQuery,
    GroupShareContextQueryQueryVariables
  >(GroupShareContextQueryDocument, options)
}
export function useGroupShareContextQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupShareContextQueryQuery,
        GroupShareContextQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GroupShareContextQueryQuery,
    GroupShareContextQueryQueryVariables
  >(GroupShareContextQueryDocument, options)
}
export type GroupShareContextQueryQueryHookResult = ReturnType<
  typeof useGroupShareContextQueryQuery
>
export type GroupShareContextQueryLazyQueryHookResult = ReturnType<
  typeof useGroupShareContextQueryLazyQuery
>
export type GroupShareContextQuerySuspenseQueryHookResult = ReturnType<
  typeof useGroupShareContextQuerySuspenseQuery
>
export type GroupShareContextQueryQueryResult = Apollo.QueryResult<
  GroupShareContextQueryQuery,
  GroupShareContextQueryQueryVariables
>
export const PeopleAndGroupConnectionQueryDocument = gql`
  query PeopleAndGroupConnectionQuery(
    $userId: Int
    $groupId: Int
    $cohortId: Int
  ) {
    peopleAndGroupConnection(
      user_id: $userId
      group_id: $groupId
      cohort_id: $cohortId
    ) {
      ...PeopleAndGroupConnection
    }
  }
  ${PeopleAndGroupConnectionFragmentDoc}
`

/**
 * __usePeopleAndGroupConnectionQueryQuery__
 *
 * To run a query within a React component, call `usePeopleAndGroupConnectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleAndGroupConnectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleAndGroupConnectionQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function usePeopleAndGroupConnectionQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PeopleAndGroupConnectionQueryQuery,
    PeopleAndGroupConnectionQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PeopleAndGroupConnectionQueryQuery,
    PeopleAndGroupConnectionQueryQueryVariables
  >(PeopleAndGroupConnectionQueryDocument, options)
}
export function usePeopleAndGroupConnectionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeopleAndGroupConnectionQueryQuery,
    PeopleAndGroupConnectionQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PeopleAndGroupConnectionQueryQuery,
    PeopleAndGroupConnectionQueryQueryVariables
  >(PeopleAndGroupConnectionQueryDocument, options)
}
export function usePeopleAndGroupConnectionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeopleAndGroupConnectionQueryQuery,
        PeopleAndGroupConnectionQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PeopleAndGroupConnectionQueryQuery,
    PeopleAndGroupConnectionQueryQueryVariables
  >(PeopleAndGroupConnectionQueryDocument, options)
}
export type PeopleAndGroupConnectionQueryQueryHookResult = ReturnType<
  typeof usePeopleAndGroupConnectionQueryQuery
>
export type PeopleAndGroupConnectionQueryLazyQueryHookResult = ReturnType<
  typeof usePeopleAndGroupConnectionQueryLazyQuery
>
export type PeopleAndGroupConnectionQuerySuspenseQueryHookResult = ReturnType<
  typeof usePeopleAndGroupConnectionQuerySuspenseQuery
>
export type PeopleAndGroupConnectionQueryQueryResult = Apollo.QueryResult<
  PeopleAndGroupConnectionQueryQuery,
  PeopleAndGroupConnectionQueryQueryVariables
>
export const PeopleAndGroupConnectionsQueryDocument = gql`
  query PeopleAndGroupConnectionsQuery(
    $first: Int!
    $cursor: String
    $context: PeopleAndGroupConnectionContext
    $roleInContext: RoleInContext
    $type: PeopleAndGroupConnectionType
    $searchTerm: [String]
  ) {
    peopleAndGroupConnections(
      first: $first
      after: $cursor
      context: $context
      role_in_context: $roleInContext
      type: $type
      search_term: $searchTerm
      people_count_filter: { gt: 0 }
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...PeopleAndGroupConnection
        }
      }
    }
  }
  ${PeopleAndGroupConnectionFragmentDoc}
`

/**
 * __usePeopleAndGroupConnectionsQueryQuery__
 *
 * To run a query within a React component, call `usePeopleAndGroupConnectionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleAndGroupConnectionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleAndGroupConnectionsQueryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      context: // value for 'context'
 *      roleInContext: // value for 'roleInContext'
 *      type: // value for 'type'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function usePeopleAndGroupConnectionsQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PeopleAndGroupConnectionsQueryQuery,
    PeopleAndGroupConnectionsQueryQueryVariables
  > &
    (
      | {
          variables: PeopleAndGroupConnectionsQueryQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PeopleAndGroupConnectionsQueryQuery,
    PeopleAndGroupConnectionsQueryQueryVariables
  >(PeopleAndGroupConnectionsQueryDocument, options)
}
export function usePeopleAndGroupConnectionsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeopleAndGroupConnectionsQueryQuery,
    PeopleAndGroupConnectionsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PeopleAndGroupConnectionsQueryQuery,
    PeopleAndGroupConnectionsQueryQueryVariables
  >(PeopleAndGroupConnectionsQueryDocument, options)
}
export function usePeopleAndGroupConnectionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeopleAndGroupConnectionsQueryQuery,
        PeopleAndGroupConnectionsQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PeopleAndGroupConnectionsQueryQuery,
    PeopleAndGroupConnectionsQueryQueryVariables
  >(PeopleAndGroupConnectionsQueryDocument, options)
}
export type PeopleAndGroupConnectionsQueryQueryHookResult = ReturnType<
  typeof usePeopleAndGroupConnectionsQueryQuery
>
export type PeopleAndGroupConnectionsQueryLazyQueryHookResult = ReturnType<
  typeof usePeopleAndGroupConnectionsQueryLazyQuery
>
export type PeopleAndGroupConnectionsQuerySuspenseQueryHookResult = ReturnType<
  typeof usePeopleAndGroupConnectionsQuerySuspenseQuery
>
export type PeopleAndGroupConnectionsQueryQueryResult = Apollo.QueryResult<
  PeopleAndGroupConnectionsQueryQuery,
  PeopleAndGroupConnectionsQueryQueryVariables
>
export const CohortShareLimitQueryDocument = gql`
  query CohortShareLimitQuery($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      id
      resource_license {
        id
      }
    }
  }
`

/**
 * __useCohortShareLimitQueryQuery__
 *
 * To run a query within a React component, call `useCohortShareLimitQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortShareLimitQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortShareLimitQueryQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useCohortShareLimitQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortShareLimitQueryQuery,
    CohortShareLimitQueryQueryVariables
  > &
    (
      | { variables: CohortShareLimitQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortShareLimitQueryQuery,
    CohortShareLimitQueryQueryVariables
  >(CohortShareLimitQueryDocument, options)
}
export function useCohortShareLimitQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortShareLimitQueryQuery,
    CohortShareLimitQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortShareLimitQueryQuery,
    CohortShareLimitQueryQueryVariables
  >(CohortShareLimitQueryDocument, options)
}
export function useCohortShareLimitQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortShareLimitQueryQuery,
        CohortShareLimitQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortShareLimitQueryQuery,
    CohortShareLimitQueryQueryVariables
  >(CohortShareLimitQueryDocument, options)
}
export type CohortShareLimitQueryQueryHookResult = ReturnType<
  typeof useCohortShareLimitQueryQuery
>
export type CohortShareLimitQueryLazyQueryHookResult = ReturnType<
  typeof useCohortShareLimitQueryLazyQuery
>
export type CohortShareLimitQuerySuspenseQueryHookResult = ReturnType<
  typeof useCohortShareLimitQuerySuspenseQuery
>
export type CohortShareLimitQueryQueryResult = Apollo.QueryResult<
  CohortShareLimitQueryQuery,
  CohortShareLimitQueryQueryVariables
>
export const CreateSchoolDocument = gql`
  mutation CreateSchool(
    $name: String!
    $subdomain: String!
    $licensor_id: Int
    $copy: [String]
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
  ) {
    createSchool(
      name: $name
      subdomain: $subdomain
      licensor_id: $licensor_id
      copy: $copy
      utm_source: $utm_source
      utm_medium: $utm_medium
      utm_campaign: $utm_campaign
    ) {
      id
      name
      profile {
        id
      }
    }
  }
`
export type CreateSchoolMutationFn = Apollo.MutationFunction<
  CreateSchoolMutation,
  CreateSchoolMutationVariables
>

/**
 * __useCreateSchoolMutation__
 *
 * To run a mutation, you first call `useCreateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolMutation, { data, loading, error }] = useCreateSchoolMutation({
 *   variables: {
 *      name: // value for 'name'
 *      subdomain: // value for 'subdomain'
 *      licensor_id: // value for 'licensor_id'
 *      copy: // value for 'copy'
 *      utm_source: // value for 'utm_source'
 *      utm_medium: // value for 'utm_medium'
 *      utm_campaign: // value for 'utm_campaign'
 *   },
 * });
 */
export function useCreateSchoolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSchoolMutation,
    CreateSchoolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateSchoolMutation,
    CreateSchoolMutationVariables
  >(CreateSchoolDocument, options)
}
export type CreateSchoolMutationHookResult = ReturnType<
  typeof useCreateSchoolMutation
>
export type CreateSchoolMutationResult =
  Apollo.MutationResult<CreateSchoolMutation>
export type CreateSchoolMutationOptions = Apollo.BaseMutationOptions<
  CreateSchoolMutation,
  CreateSchoolMutationVariables
>
export const UpdateSchoolProfileDocument = gql`
  mutation UpdateSchoolProfile(
    $id: Int!
    $school_type: SchoolType
    $plan_to_sell: Boolean
  ) {
    updateSchoolProfile(
      id: $id
      school_type: $school_type
      plan_to_sell: $plan_to_sell
    ) {
      id
      school_type
      plan_to_sell
    }
  }
`
export type UpdateSchoolProfileMutationFn = Apollo.MutationFunction<
  UpdateSchoolProfileMutation,
  UpdateSchoolProfileMutationVariables
>

/**
 * __useUpdateSchoolProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolProfileMutation, { data, loading, error }] = useUpdateSchoolProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      school_type: // value for 'school_type'
 *      plan_to_sell: // value for 'plan_to_sell'
 *   },
 * });
 */
export function useUpdateSchoolProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchoolProfileMutation,
    UpdateSchoolProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSchoolProfileMutation,
    UpdateSchoolProfileMutationVariables
  >(UpdateSchoolProfileDocument, options)
}
export type UpdateSchoolProfileMutationHookResult = ReturnType<
  typeof useUpdateSchoolProfileMutation
>
export type UpdateSchoolProfileMutationResult =
  Apollo.MutationResult<UpdateSchoolProfileMutation>
export type UpdateSchoolProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchoolProfileMutation,
  UpdateSchoolProfileMutationVariables
>
export const UserSchoolLicenseQueryDocument = gql`
  query UserSchoolLicenseQuery($cursor: String, $licensorId: IDFilter) {
    me {
      ...User
      memberships(
        first: 50
        after: $cursor
        role_filter: { eq: administrator }
        global: true
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            role
            school {
              ...School
              storeLinks(first: 10, licensor_id: $licensorId) {
                total
                pageInfo {
                  endCursor
                  hasNextPage
                }
                edges {
                  node {
                    ...StoreLink
                  }
                }
              }
              curriculum_subscriptions(first: 10, licensor_id: $licensorId) {
                total
                pageInfo {
                  endCursor
                  hasNextPage
                }
                edges {
                  node {
                    id
                    licensor {
                      ...School
                    }
                    curriculum_plan {
                      id
                      plan_id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${SchoolFragmentDoc}
  ${StoreLinkFragmentDoc}
`

/**
 * __useUserSchoolLicenseQueryQuery__
 *
 * To run a query within a React component, call `useUserSchoolLicenseQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSchoolLicenseQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSchoolLicenseQueryQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      licensorId: // value for 'licensorId'
 *   },
 * });
 */
export function useUserSchoolLicenseQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserSchoolLicenseQueryQuery,
    UserSchoolLicenseQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserSchoolLicenseQueryQuery,
    UserSchoolLicenseQueryQueryVariables
  >(UserSchoolLicenseQueryDocument, options)
}
export function useUserSchoolLicenseQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSchoolLicenseQueryQuery,
    UserSchoolLicenseQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserSchoolLicenseQueryQuery,
    UserSchoolLicenseQueryQueryVariables
  >(UserSchoolLicenseQueryDocument, options)
}
export function useUserSchoolLicenseQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSchoolLicenseQueryQuery,
        UserSchoolLicenseQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserSchoolLicenseQueryQuery,
    UserSchoolLicenseQueryQueryVariables
  >(UserSchoolLicenseQueryDocument, options)
}
export type UserSchoolLicenseQueryQueryHookResult = ReturnType<
  typeof useUserSchoolLicenseQueryQuery
>
export type UserSchoolLicenseQueryLazyQueryHookResult = ReturnType<
  typeof useUserSchoolLicenseQueryLazyQuery
>
export type UserSchoolLicenseQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserSchoolLicenseQuerySuspenseQuery
>
export type UserSchoolLicenseQueryQueryResult = Apollo.QueryResult<
  UserSchoolLicenseQueryQuery,
  UserSchoolLicenseQueryQueryVariables
>
export const BlurredThemeBackgroundImageDocument = gql`
  query BlurredThemeBackgroundImage(
    $url: String!
    $width: Int
    $height: Int
    $blur: Int
    $high: Int
    $blend: Int
    $balph: Int
    $fm: String
    $q: Int
    $bm: String
  ) {
    media {
      image(
        url: $url
        width: $width
        height: $height
        blur: $blur
        high: $high
        blend: $blend
        balph: $balph
        fm: $fm
        q: $q
        bm: $bm
      )
    }
  }
`

/**
 * __useBlurredThemeBackgroundImageQuery__
 *
 * To run a query within a React component, call `useBlurredThemeBackgroundImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlurredThemeBackgroundImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlurredThemeBackgroundImageQuery({
 *   variables: {
 *      url: // value for 'url'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      blur: // value for 'blur'
 *      high: // value for 'high'
 *      blend: // value for 'blend'
 *      balph: // value for 'balph'
 *      fm: // value for 'fm'
 *      q: // value for 'q'
 *      bm: // value for 'bm'
 *   },
 * });
 */
export function useBlurredThemeBackgroundImageQuery(
  baseOptions: Apollo.QueryHookOptions<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  > &
    (
      | { variables: BlurredThemeBackgroundImageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >(BlurredThemeBackgroundImageDocument, options)
}
export function useBlurredThemeBackgroundImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >(BlurredThemeBackgroundImageDocument, options)
}
export function useBlurredThemeBackgroundImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BlurredThemeBackgroundImageQuery,
        BlurredThemeBackgroundImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >(BlurredThemeBackgroundImageDocument, options)
}
export type BlurredThemeBackgroundImageQueryHookResult = ReturnType<
  typeof useBlurredThemeBackgroundImageQuery
>
export type BlurredThemeBackgroundImageLazyQueryHookResult = ReturnType<
  typeof useBlurredThemeBackgroundImageLazyQuery
>
export type BlurredThemeBackgroundImageSuspenseQueryHookResult = ReturnType<
  typeof useBlurredThemeBackgroundImageSuspenseQuery
>
export type BlurredThemeBackgroundImageQueryResult = Apollo.QueryResult<
  BlurredThemeBackgroundImageQuery,
  BlurredThemeBackgroundImageQueryVariables
>
export const CreateSpaceDocument = gql`
  mutation CreateSpace(
    $name: String!
    $subdomain: String!
    $copy: [String]
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
    $signup_config_key: String
    $rewardful_referral_id: String
    $theme: ThemeInput
  ) {
    createSchool(
      name: $name
      subdomain: $subdomain
      copy: $copy
      utm_source: $utm_source
      utm_medium: $utm_medium
      utm_campaign: $utm_campaign
      signup_config_key: $signup_config_key
      rewardful_referral_id: $rewardful_referral_id
      theme: $theme
    ) {
      ...CreatedSpace
    }
  }
  ${CreatedSpaceFragmentDoc}
`
export type CreateSpaceMutationFn = Apollo.MutationFunction<
  CreateSpaceMutation,
  CreateSpaceMutationVariables
>

/**
 * __useCreateSpaceMutation__
 *
 * To run a mutation, you first call `useCreateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpaceMutation, { data, loading, error }] = useCreateSpaceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      subdomain: // value for 'subdomain'
 *      copy: // value for 'copy'
 *      utm_source: // value for 'utm_source'
 *      utm_medium: // value for 'utm_medium'
 *      utm_campaign: // value for 'utm_campaign'
 *      signup_config_key: // value for 'signup_config_key'
 *      rewardful_referral_id: // value for 'rewardful_referral_id'
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useCreateSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSpaceMutation,
    CreateSpaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSpaceMutation, CreateSpaceMutationVariables>(
    CreateSpaceDocument,
    options
  )
}
export type CreateSpaceMutationHookResult = ReturnType<
  typeof useCreateSpaceMutation
>
export type CreateSpaceMutationResult =
  Apollo.MutationResult<CreateSpaceMutation>
export type CreateSpaceMutationOptions = Apollo.BaseMutationOptions<
  CreateSpaceMutation,
  CreateSpaceMutationVariables
>
export const SpaceBillingPlanSetDocument = gql`
  query SpaceBillingPlanSet {
    account {
      id
      billing_plan_set {
        id
        name
        is_default
        plans {
          ...SpaceBillingPlanSetPlan
        }
      }
    }
  }
  ${SpaceBillingPlanSetPlanFragmentDoc}
`

/**
 * __useSpaceBillingPlanSetQuery__
 *
 * To run a query within a React component, call `useSpaceBillingPlanSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceBillingPlanSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceBillingPlanSetQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpaceBillingPlanSetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >(SpaceBillingPlanSetDocument, options)
}
export function useSpaceBillingPlanSetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >(SpaceBillingPlanSetDocument, options)
}
export function useSpaceBillingPlanSetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceBillingPlanSetQuery,
        SpaceBillingPlanSetQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >(SpaceBillingPlanSetDocument, options)
}
export type SpaceBillingPlanSetQueryHookResult = ReturnType<
  typeof useSpaceBillingPlanSetQuery
>
export type SpaceBillingPlanSetLazyQueryHookResult = ReturnType<
  typeof useSpaceBillingPlanSetLazyQuery
>
export type SpaceBillingPlanSetSuspenseQueryHookResult = ReturnType<
  typeof useSpaceBillingPlanSetSuspenseQuery
>
export type SpaceBillingPlanSetQueryResult = Apollo.QueryResult<
  SpaceBillingPlanSetQuery,
  SpaceBillingPlanSetQueryVariables
>
export const SubdomainDocument = gql`
  query Subdomain($subdomain: String) {
    subdomain(subdomain: $subdomain) {
      id
      subdomain
    }
  }
`

/**
 * __useSubdomainQuery__
 *
 * To run a query within a React component, call `useSubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubdomainQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useSubdomainQuery(
  baseOptions?: Apollo.QueryHookOptions<SubdomainQuery, SubdomainQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SubdomainQuery, SubdomainQueryVariables>(
    SubdomainDocument,
    options
  )
}
export function useSubdomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubdomainQuery,
    SubdomainQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SubdomainQuery, SubdomainQueryVariables>(
    SubdomainDocument,
    options
  )
}
export function useSubdomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SubdomainQuery, SubdomainQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SubdomainQuery, SubdomainQueryVariables>(
    SubdomainDocument,
    options
  )
}
export type SubdomainQueryHookResult = ReturnType<typeof useSubdomainQuery>
export type SubdomainLazyQueryHookResult = ReturnType<
  typeof useSubdomainLazyQuery
>
export type SubdomainSuspenseQueryHookResult = ReturnType<
  typeof useSubdomainSuspenseQuery
>
export type SubdomainQueryResult = Apollo.QueryResult<
  SubdomainQuery,
  SubdomainQueryVariables
>
export const UpdateSpaceProfileDocument = gql`
  mutation UpdateSpaceProfile(
    $id: Int!
    $school_type: SchoolType
    $plan_to_sell: Boolean
  ) {
    updateSchoolProfile(
      id: $id
      school_type: $school_type
      plan_to_sell: $plan_to_sell
    ) {
      id
      school_type
      plan_to_sell
    }
  }
`
export type UpdateSpaceProfileMutationFn = Apollo.MutationFunction<
  UpdateSpaceProfileMutation,
  UpdateSpaceProfileMutationVariables
>

/**
 * __useUpdateSpaceProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceProfileMutation, { data, loading, error }] = useUpdateSpaceProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      school_type: // value for 'school_type'
 *      plan_to_sell: // value for 'plan_to_sell'
 *   },
 * });
 */
export function useUpdateSpaceProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSpaceProfileMutation,
    UpdateSpaceProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSpaceProfileMutation,
    UpdateSpaceProfileMutationVariables
  >(UpdateSpaceProfileDocument, options)
}
export type UpdateSpaceProfileMutationHookResult = ReturnType<
  typeof useUpdateSpaceProfileMutation
>
export type UpdateSpaceProfileMutationResult =
  Apollo.MutationResult<UpdateSpaceProfileMutation>
export type UpdateSpaceProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateSpaceProfileMutation,
  UpdateSpaceProfileMutationVariables
>
export const UserCreatedSpaceMembershipsDocument = gql`
  query UserCreatedSpaceMemberships {
    me {
      id
      memberships(first: 1, role_filter: { eq: administrator }, global: true) {
        edges {
          node {
            id
            school {
              subdomain
              ...CreatedSpace
            }
          }
        }
      }
    }
  }
  ${CreatedSpaceFragmentDoc}
`

/**
 * __useUserCreatedSpaceMembershipsQuery__
 *
 * To run a query within a React component, call `useUserCreatedSpaceMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreatedSpaceMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreatedSpaceMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCreatedSpaceMembershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >(UserCreatedSpaceMembershipsDocument, options)
}
export function useUserCreatedSpaceMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >(UserCreatedSpaceMembershipsDocument, options)
}
export function useUserCreatedSpaceMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserCreatedSpaceMembershipsQuery,
        UserCreatedSpaceMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >(UserCreatedSpaceMembershipsDocument, options)
}
export type UserCreatedSpaceMembershipsQueryHookResult = ReturnType<
  typeof useUserCreatedSpaceMembershipsQuery
>
export type UserCreatedSpaceMembershipsLazyQueryHookResult = ReturnType<
  typeof useUserCreatedSpaceMembershipsLazyQuery
>
export type UserCreatedSpaceMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useUserCreatedSpaceMembershipsSuspenseQuery
>
export type UserCreatedSpaceMembershipsQueryResult = Apollo.QueryResult<
  UserCreatedSpaceMembershipsQuery,
  UserCreatedSpaceMembershipsQueryVariables
>
export const UserSpaceMembershipsDocument = gql`
  query UserSpaceMemberships {
    me {
      id
      memberships(first: 1042, global: true) {
        edges {
          node {
            ...UserSpaceMembership
          }
        }
      }
    }
  }
  ${UserSpaceMembershipFragmentDoc}
`

/**
 * __useUserSpaceMembershipsQuery__
 *
 * To run a query within a React component, call `useUserSpaceMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSpaceMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSpaceMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSpaceMembershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >(UserSpaceMembershipsDocument, options)
}
export function useUserSpaceMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >(UserSpaceMembershipsDocument, options)
}
export function useUserSpaceMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSpaceMembershipsQuery,
        UserSpaceMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >(UserSpaceMembershipsDocument, options)
}
export type UserSpaceMembershipsQueryHookResult = ReturnType<
  typeof useUserSpaceMembershipsQuery
>
export type UserSpaceMembershipsLazyQueryHookResult = ReturnType<
  typeof useUserSpaceMembershipsLazyQuery
>
export type UserSpaceMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useUserSpaceMembershipsSuspenseQuery
>
export type UserSpaceMembershipsQueryResult = Apollo.QueryResult<
  UserSpaceMembershipsQuery,
  UserSpaceMembershipsQueryVariables
>
export const CreateMessageDocument = gql`
  mutation CreateMessage(
    $message_context: MessageContext!
    $message: MessageInput!
  ) {
    createMessage(message_context: $message_context, message: $message) {
      ...Message
    }
  }
  ${MessageFragmentDoc}
`
export type CreateMessageMutationFn = Apollo.MutationFunction<
  CreateMessageMutation,
  CreateMessageMutationVariables
>

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      message_context: // value for 'message_context'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMessageMutation,
    CreateMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateMessageMutation,
    CreateMessageMutationVariables
  >(CreateMessageDocument, options)
}
export type CreateMessageMutationHookResult = ReturnType<
  typeof useCreateMessageMutation
>
export type CreateMessageMutationResult =
  Apollo.MutationResult<CreateMessageMutation>
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<
  CreateMessageMutation,
  CreateMessageMutationVariables
>
export const DeleteMessageDocument = gql`
  mutation DeleteMessage($id: Int!, $message_context: MessageContext!) {
    deleteMessage(id: $id, message_context: $message_context)
  }
`
export type DeleteMessageMutationFn = Apollo.MutationFunction<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
>

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message_context: // value for 'message_context'
 *   },
 * });
 */
export function useDeleteMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMessageMutation,
    DeleteMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteMessageMutation,
    DeleteMessageMutationVariables
  >(DeleteMessageDocument, options)
}
export type DeleteMessageMutationHookResult = ReturnType<
  typeof useDeleteMessageMutation
>
export type DeleteMessageMutationResult =
  Apollo.MutationResult<DeleteMessageMutation>
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
>
export const MessageDocument = gql`
  query Message($message_context: MessageContext!, $id: Int!) {
    message(message_context: $message_context, id: $id) {
      ...Message
    }
  }
  ${MessageFragmentDoc}
`

/**
 * __useMessageQuery__
 *
 * To run a query within a React component, call `useMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageQuery({
 *   variables: {
 *      message_context: // value for 'message_context'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageQuery(
  baseOptions: Apollo.QueryHookOptions<MessageQuery, MessageQueryVariables> &
    ({ variables: MessageQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MessageQuery, MessageQueryVariables>(
    MessageDocument,
    options
  )
}
export function useMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MessageQuery, MessageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MessageQuery, MessageQueryVariables>(
    MessageDocument,
    options
  )
}
export function useMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessageQuery, MessageQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MessageQuery, MessageQueryVariables>(
    MessageDocument,
    options
  )
}
export type MessageQueryHookResult = ReturnType<typeof useMessageQuery>
export type MessageLazyQueryHookResult = ReturnType<typeof useMessageLazyQuery>
export type MessageSuspenseQueryHookResult = ReturnType<
  typeof useMessageSuspenseQuery
>
export type MessageQueryResult = Apollo.QueryResult<
  MessageQuery,
  MessageQueryVariables
>
export const MessagesDocument = gql`
  query Messages($message_context: MessageContext!, $type: MessageTypeFilter) {
    messages(first: 20, message_context: $message_context, type: $type) {
      edges {
        node {
          ...Message
        }
      }
    }
  }
  ${MessageFragmentDoc}
`

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      message_context: // value for 'message_context'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables> &
    ({ variables: MessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(
    MessagesDocument,
    options
  )
}
export function useMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MessagesQuery,
    MessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(
    MessagesDocument,
    options
  )
}
export function useMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessagesQuery, MessagesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MessagesQuery, MessagesQueryVariables>(
    MessagesDocument,
    options
  )
}
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>
export type MessagesLazyQueryHookResult = ReturnType<
  typeof useMessagesLazyQuery
>
export type MessagesSuspenseQueryHookResult = ReturnType<
  typeof useMessagesSuspenseQuery
>
export type MessagesQueryResult = Apollo.QueryResult<
  MessagesQuery,
  MessagesQueryVariables
>
export const PathItemRemindersDocument = gql`
  query PathItemReminders(
    $id: Int
    $path_id: Int
    $cohort_id: Int
    $user_id: Int
    $source_id: Int
  ) {
    pathItem(
      id: $id
      path_id: $path_id
      cohort_id: $cohort_id
      user_id: $user_id
      source_id: $source_id
    ) {
      id
      reminders(first: 20) {
        edges {
          node {
            ...Message
          }
        }
      }
    }
  }
  ${MessageFragmentDoc}
`

/**
 * __usePathItemRemindersQuery__
 *
 * To run a query within a React component, call `usePathItemRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathItemRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathItemRemindersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *      cohort_id: // value for 'cohort_id'
 *      user_id: // value for 'user_id'
 *      source_id: // value for 'source_id'
 *   },
 * });
 */
export function usePathItemRemindersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathItemRemindersQuery,
    PathItemRemindersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathItemRemindersQuery,
    PathItemRemindersQueryVariables
  >(PathItemRemindersDocument, options)
}
export function usePathItemRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathItemRemindersQuery,
    PathItemRemindersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathItemRemindersQuery,
    PathItemRemindersQueryVariables
  >(PathItemRemindersDocument, options)
}
export function usePathItemRemindersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathItemRemindersQuery,
        PathItemRemindersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathItemRemindersQuery,
    PathItemRemindersQueryVariables
  >(PathItemRemindersDocument, options)
}
export type PathItemRemindersQueryHookResult = ReturnType<
  typeof usePathItemRemindersQuery
>
export type PathItemRemindersLazyQueryHookResult = ReturnType<
  typeof usePathItemRemindersLazyQuery
>
export type PathItemRemindersSuspenseQueryHookResult = ReturnType<
  typeof usePathItemRemindersSuspenseQuery
>
export type PathItemRemindersQueryResult = Apollo.QueryResult<
  PathItemRemindersQuery,
  PathItemRemindersQueryVariables
>
export const ScheduleItemDocument = gql`
  mutation ScheduleItem(
    $schedule_context: ScheduleItemContext!
    $starts: DateTime
    $due: DateTime
    $passive_starts: Boolean
    $passive_due: Boolean
  ) {
    scheduleItem(
      schedule_context: $schedule_context
      starts: $starts
      due: $due
      passive_starts: $passive_starts
      passive_due: $passive_due
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type ScheduleItemMutationFn = Apollo.MutationFunction<
  ScheduleItemMutation,
  ScheduleItemMutationVariables
>

/**
 * __useScheduleItemMutation__
 *
 * To run a mutation, you first call `useScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleItemMutation, { data, loading, error }] = useScheduleItemMutation({
 *   variables: {
 *      schedule_context: // value for 'schedule_context'
 *      starts: // value for 'starts'
 *      due: // value for 'due'
 *      passive_starts: // value for 'passive_starts'
 *      passive_due: // value for 'passive_due'
 *   },
 * });
 */
export function useScheduleItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ScheduleItemMutation,
    ScheduleItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ScheduleItemMutation,
    ScheduleItemMutationVariables
  >(ScheduleItemDocument, options)
}
export type ScheduleItemMutationHookResult = ReturnType<
  typeof useScheduleItemMutation
>
export type ScheduleItemMutationResult =
  Apollo.MutationResult<ScheduleItemMutation>
export type ScheduleItemMutationOptions = Apollo.BaseMutationOptions<
  ScheduleItemMutation,
  ScheduleItemMutationVariables
>
export const UpdateMessageDocument = gql`
  mutation UpdateMessage(
    $id: Int!
    $message_context: MessageContext!
    $message: MessageInput!
  ) {
    updateMessage(
      id: $id
      message_context: $message_context
      message: $message
    ) {
      ...Message
    }
  }
  ${MessageFragmentDoc}
`
export type UpdateMessageMutationFn = Apollo.MutationFunction<
  UpdateMessageMutation,
  UpdateMessageMutationVariables
>

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message_context: // value for 'message_context'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUpdateMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMessageMutation,
    UpdateMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateMessageMutation,
    UpdateMessageMutationVariables
  >(UpdateMessageDocument, options)
}
export type UpdateMessageMutationHookResult = ReturnType<
  typeof useUpdateMessageMutation
>
export type UpdateMessageMutationResult =
  Apollo.MutationResult<UpdateMessageMutation>
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<
  UpdateMessageMutation,
  UpdateMessageMutationVariables
>
export const CreateStoreLinkDocument = gql`
  mutation CreateStoreLink($schoolId: Int!, $copy: [String]) {
    createStoreLink(school_id: $schoolId, copy: $copy) {
      id
      licensee {
        ...School
      }
      store {
        ...Store
      }
    }
  }
  ${SchoolFragmentDoc}
  ${StoreFragmentDoc}
`
export type CreateStoreLinkMutationFn = Apollo.MutationFunction<
  CreateStoreLinkMutation,
  CreateStoreLinkMutationVariables
>

/**
 * __useCreateStoreLinkMutation__
 *
 * To run a mutation, you first call `useCreateStoreLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoreLinkMutation, { data, loading, error }] = useCreateStoreLinkMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      copy: // value for 'copy'
 *   },
 * });
 */
export function useCreateStoreLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStoreLinkMutation,
    CreateStoreLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateStoreLinkMutation,
    CreateStoreLinkMutationVariables
  >(CreateStoreLinkDocument, options)
}
export type CreateStoreLinkMutationHookResult = ReturnType<
  typeof useCreateStoreLinkMutation
>
export type CreateStoreLinkMutationResult =
  Apollo.MutationResult<CreateStoreLinkMutation>
export type CreateStoreLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateStoreLinkMutation,
  CreateStoreLinkMutationVariables
>
export const ResourceOfferingsDocument = gql`
  query ResourceOfferings(
    $id: Int
    $cursor: String
    $school_id: Int!
    $licensee_school_id: Int!
    $licenseeIdFilter: IDFilter
    $include_school_license: Boolean!
    $skip_group_offerings: Boolean!
    $skip_license_offerings: Boolean!
    $licensing_mode: LicenseOfferingLicensingMode
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        resource(id: $id) {
          id
          license_offerings(first: 50, licensing_mode: $licensing_mode)
            @skip(if: $skip_license_offerings) {
            total
            edges {
              node {
                ...LicenseOffering
                school_license(licensee_school_id: $licensee_school_id)
                  @include(if: $include_school_license) {
                  id
                }
                include_in_school_curriculum_subscriptions(
                  first: 1
                  licensee_id: $licenseeIdFilter
                ) {
                  total
                }
              }
            }
          }
          group_offerings: groups(
            first: 50
            after: $cursor
            visibility_filter: { gte: members_only }
          ) @skip(if: $skip_group_offerings) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Group
                include_in_plans(first: 10) {
                  edges {
                    node {
                      ...SchoolSubscriptionPlan
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${LicenseOfferingFragmentDoc}
  ${GroupFragmentDoc}
  ${SchoolSubscriptionPlanFragmentDoc}
`

/**
 * __useResourceOfferingsQuery__
 *
 * To run a query within a React component, call `useResourceOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceOfferingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      licenseeIdFilter: // value for 'licenseeIdFilter'
 *      include_school_license: // value for 'include_school_license'
 *      skip_group_offerings: // value for 'skip_group_offerings'
 *      skip_license_offerings: // value for 'skip_license_offerings'
 *      licensing_mode: // value for 'licensing_mode'
 *   },
 * });
 */
export function useResourceOfferingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  > &
    (
      | { variables: ResourceOfferingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >(ResourceOfferingsDocument, options)
}
export function useResourceOfferingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >(ResourceOfferingsDocument, options)
}
export function useResourceOfferingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceOfferingsQuery,
        ResourceOfferingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >(ResourceOfferingsDocument, options)
}
export type ResourceOfferingsQueryHookResult = ReturnType<
  typeof useResourceOfferingsQuery
>
export type ResourceOfferingsLazyQueryHookResult = ReturnType<
  typeof useResourceOfferingsLazyQuery
>
export type ResourceOfferingsSuspenseQueryHookResult = ReturnType<
  typeof useResourceOfferingsSuspenseQuery
>
export type ResourceOfferingsQueryResult = Apollo.QueryResult<
  ResourceOfferingsQuery,
  ResourceOfferingsQueryVariables
>
export const StoreLinkDocument = gql`
  query StoreLink($licensorId: IntFilter) {
    storeLink(licensor_id: $licensorId) {
      ...StoreLink
    }
  }
  ${StoreLinkFragmentDoc}
`

/**
 * __useStoreLinkQuery__
 *
 * To run a query within a React component, call `useStoreLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreLinkQuery({
 *   variables: {
 *      licensorId: // value for 'licensorId'
 *   },
 * });
 */
export function useStoreLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<StoreLinkQuery, StoreLinkQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreLinkQuery, StoreLinkQueryVariables>(
    StoreLinkDocument,
    options
  )
}
export function useStoreLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreLinkQuery,
    StoreLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreLinkQuery, StoreLinkQueryVariables>(
    StoreLinkDocument,
    options
  )
}
export function useStoreLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreLinkQuery, StoreLinkQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<StoreLinkQuery, StoreLinkQueryVariables>(
    StoreLinkDocument,
    options
  )
}
export type StoreLinkQueryHookResult = ReturnType<typeof useStoreLinkQuery>
export type StoreLinkLazyQueryHookResult = ReturnType<
  typeof useStoreLinkLazyQuery
>
export type StoreLinkSuspenseQueryHookResult = ReturnType<
  typeof useStoreLinkSuspenseQuery
>
export type StoreLinkQueryResult = Apollo.QueryResult<
  StoreLinkQuery,
  StoreLinkQueryVariables
>
export const StoreLinksDocument = gql`
  query StoreLinks($licensorId: IDFilter) {
    storeLinks(first: 10, licensor_id: $licensorId) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...StoreLink
        }
      }
    }
  }
  ${StoreLinkFragmentDoc}
`

/**
 * __useStoreLinksQuery__
 *
 * To run a query within a React component, call `useStoreLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreLinksQuery({
 *   variables: {
 *      licensorId: // value for 'licensorId'
 *   },
 * });
 */
export function useStoreLinksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StoreLinksQuery,
    StoreLinksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreLinksQuery, StoreLinksQueryVariables>(
    StoreLinksDocument,
    options
  )
}
export function useStoreLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreLinksQuery,
    StoreLinksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreLinksQuery, StoreLinksQueryVariables>(
    StoreLinksDocument,
    options
  )
}
export function useStoreLinksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreLinksQuery, StoreLinksQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<StoreLinksQuery, StoreLinksQueryVariables>(
    StoreLinksDocument,
    options
  )
}
export type StoreLinksQueryHookResult = ReturnType<typeof useStoreLinksQuery>
export type StoreLinksLazyQueryHookResult = ReturnType<
  typeof useStoreLinksLazyQuery
>
export type StoreLinksSuspenseQueryHookResult = ReturnType<
  typeof useStoreLinksSuspenseQuery
>
export type StoreLinksQueryResult = Apollo.QueryResult<
  StoreLinksQuery,
  StoreLinksQueryVariables
>
export const StoreDocument = gql`
  query Store {
    store {
      ...Store
    }
  }
  ${StoreFragmentDoc}
`

/**
 * __useStoreQuery__
 *
 * To run a query within a React component, call `useStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreQuery(
  baseOptions?: Apollo.QueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreQuery, StoreQueryVariables>(
    StoreDocument,
    options
  )
}
export function useStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreQuery, StoreQueryVariables>(
    StoreDocument,
    options
  )
}
export function useStoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<StoreQuery, StoreQueryVariables>(
    StoreDocument,
    options
  )
}
export type StoreQueryHookResult = ReturnType<typeof useStoreQuery>
export type StoreLazyQueryHookResult = ReturnType<typeof useStoreLazyQuery>
export type StoreSuspenseQueryHookResult = ReturnType<
  typeof useStoreSuspenseQuery
>
export type StoreQueryResult = Apollo.QueryResult<
  StoreQuery,
  StoreQueryVariables
>
export const StoreResourceDocument = gql`
  query StoreResource(
    $id: Int
    $school_id: Int!
    $include_publisher: Boolean!
    $include_school_license: Boolean!
    $include_license_offerings: Boolean!
    $licensee_school_id: Int!
    $licenseeIdFilter: IDFilter
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        resource(id: $id) {
          ...Resource
          blurred_background: background_image(blur: 500, width: 250)
          school {
            ...School
          }
          publisher @include(if: $include_publisher) {
            ...Publisher
            theme {
              ...Theme
            }
          }
          registration_meta {
            editor_registration_count
          }
          trailer_embed_code
          visibility_level_override
          certificate_generator_class
          licensed_from_resource_id
          school_licenses(first: 1, licensee_school_id: $licensee_school_id)
            @include(if: $include_school_license) {
            edges {
              node {
                id
                group {
                  id
                  resource_id
                }
              }
            }
          }
          authors(first: 50) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Author
              }
            }
          }
          categories(first: 50) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Category
              }
            }
          }
          groups(first: 10) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Group
                path(type: source) {
                  id
                  items(first: 1) {
                    total
                  }
                }
              }
            }
          }
          license_offerings(first: 1, licensing_mode: school_licensing)
            @include(if: $include_license_offerings) {
            total
            edges {
              node {
                ...LicenseOffering
                include_in_school_curriculum_subscriptions(
                  first: 1
                  licensee_id: $licenseeIdFilter
                ) {
                  total
                }
              }
            }
          }
          group(type: curriculum) {
            id
            path(type: source) {
              id
              items(first: 1) {
                total
              }
              previewable_steps(first: 3) {
                edges {
                  node {
                    id
                    source_id
                    name
                    assignment_type
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ResourceFragmentDoc}
  ${PublisherFragmentDoc}
  ${ThemeFragmentDoc}
  ${AuthorFragmentDoc}
  ${CategoryFragmentDoc}
  ${GroupFragmentDoc}
  ${LicenseOfferingFragmentDoc}
`

/**
 * __useStoreResourceQuery__
 *
 * To run a query within a React component, call `useStoreResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      school_id: // value for 'school_id'
 *      include_publisher: // value for 'include_publisher'
 *      include_school_license: // value for 'include_school_license'
 *      include_license_offerings: // value for 'include_license_offerings'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      licenseeIdFilter: // value for 'licenseeIdFilter'
 *   },
 * });
 */
export function useStoreResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    StoreResourceQuery,
    StoreResourceQueryVariables
  > &
    (
      | { variables: StoreResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreResourceQuery, StoreResourceQueryVariables>(
    StoreResourceDocument,
    options
  )
}
export function useStoreResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreResourceQuery,
    StoreResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreResourceQuery, StoreResourceQueryVariables>(
    StoreResourceDocument,
    options
  )
}
export function useStoreResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StoreResourceQuery,
        StoreResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    StoreResourceQuery,
    StoreResourceQueryVariables
  >(StoreResourceDocument, options)
}
export type StoreResourceQueryHookResult = ReturnType<
  typeof useStoreResourceQuery
>
export type StoreResourceLazyQueryHookResult = ReturnType<
  typeof useStoreResourceLazyQuery
>
export type StoreResourceSuspenseQueryHookResult = ReturnType<
  typeof useStoreResourceSuspenseQuery
>
export type StoreResourceQueryResult = Apollo.QueryResult<
  StoreResourceQuery,
  StoreResourceQueryVariables
>
export const StoreResourcesDocument = gql`
  query StoreResources(
    $cursor: String
    $first: Int!
    $role: RoleFilter
    $search: String
    $author_ids: IDFilter
    $category_ids: IDFilter
    $publisher_ids: IDFilter
    $resource_types: ResourceTypeFilter
    $visibility: ResourceVisibility
    $school_id: Int!
    $licensee_school_id: Int!
    $include_school_license: Boolean!
    $user_registered: IDFilter
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        resources(
          first: $first
          after: $cursor
          role: $role
          search: $search
          visibility: $visibility
          author_ids: $author_ids
          category_ids: $category_ids
          publisher_ids: $publisher_ids
          resource_types: $resource_types
          user_registered: $user_registered
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Resource
              curriculum: group(type: curriculum) {
                id
              }
              publisher {
                ...Publisher
              }
              authors(first: 2) {
                total
                edges {
                  node {
                    ...Author
                  }
                }
              }
              school_licenses(
                first: 1
                licensee_school_id: $licensee_school_id
              ) @include(if: $include_school_license) {
                edges {
                  node {
                    id
                  }
                }
              }
              license_offerings(first: 1, licensing_mode: school_licensing) {
                total
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ResourceFragmentDoc}
  ${PublisherFragmentDoc}
  ${AuthorFragmentDoc}
`

/**
 * __useStoreResourcesQuery__
 *
 * To run a query within a React component, call `useStoreResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreResourcesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      role: // value for 'role'
 *      search: // value for 'search'
 *      author_ids: // value for 'author_ids'
 *      category_ids: // value for 'category_ids'
 *      publisher_ids: // value for 'publisher_ids'
 *      resource_types: // value for 'resource_types'
 *      visibility: // value for 'visibility'
 *      school_id: // value for 'school_id'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      include_school_license: // value for 'include_school_license'
 *      user_registered: // value for 'user_registered'
 *   },
 * });
 */
export function useStoreResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    StoreResourcesQuery,
    StoreResourcesQueryVariables
  > &
    (
      | { variables: StoreResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreResourcesQuery, StoreResourcesQueryVariables>(
    StoreResourcesDocument,
    options
  )
}
export function useStoreResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreResourcesQuery,
    StoreResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreResourcesQuery, StoreResourcesQueryVariables>(
    StoreResourcesDocument,
    options
  )
}
export function useStoreResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StoreResourcesQuery,
        StoreResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    StoreResourcesQuery,
    StoreResourcesQueryVariables
  >(StoreResourcesDocument, options)
}
export type StoreResourcesQueryHookResult = ReturnType<
  typeof useStoreResourcesQuery
>
export type StoreResourcesLazyQueryHookResult = ReturnType<
  typeof useStoreResourcesLazyQuery
>
export type StoreResourcesSuspenseQueryHookResult = ReturnType<
  typeof useStoreResourcesSuspenseQuery
>
export type StoreResourcesQueryResult = Apollo.QueryResult<
  StoreResourcesQuery,
  StoreResourcesQueryVariables
>
export const ResourceTrailerDocument = gql`
  query ResourceTrailer($id: Int, $school_id: Int!) {
    context(school_id: $school_id) {
      school {
        ...School
        resource(id: $id) {
          id
          trailer_embed_code
        }
      }
    }
  }
  ${SchoolFragmentDoc}
`

/**
 * __useResourceTrailerQuery__
 *
 * To run a query within a React component, call `useResourceTrailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTrailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTrailerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function useResourceTrailerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceTrailerQuery,
    ResourceTrailerQueryVariables
  > &
    (
      | { variables: ResourceTrailerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceTrailerQuery, ResourceTrailerQueryVariables>(
    ResourceTrailerDocument,
    options
  )
}
export function useResourceTrailerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceTrailerQuery,
    ResourceTrailerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceTrailerQuery,
    ResourceTrailerQueryVariables
  >(ResourceTrailerDocument, options)
}
export function useResourceTrailerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceTrailerQuery,
        ResourceTrailerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceTrailerQuery,
    ResourceTrailerQueryVariables
  >(ResourceTrailerDocument, options)
}
export type ResourceTrailerQueryHookResult = ReturnType<
  typeof useResourceTrailerQuery
>
export type ResourceTrailerLazyQueryHookResult = ReturnType<
  typeof useResourceTrailerLazyQuery
>
export type ResourceTrailerSuspenseQueryHookResult = ReturnType<
  typeof useResourceTrailerSuspenseQuery
>
export type ResourceTrailerQueryResult = Apollo.QueryResult<
  ResourceTrailerQuery,
  ResourceTrailerQueryVariables
>
export const StripeProductsDocument = gql`
  query StripeProducts(
    $first: Int!
    $after: String
    $ids: IDFilter
    $includeInactive: Boolean
  ) {
    stripeProducts(
      first: $first
      after: $after
      ids: $ids
      include_inactive: $includeInactive
    ) {
      edges {
        node {
          ...StripeProduct
          stripe_prices(first: 50) {
            edges {
              node {
                ...StripePrice
              }
            }
          }
        }
      }
    }
  }
  ${StripeProductFragmentDoc}
  ${StripePriceFragmentDoc}
`

/**
 * __useStripeProductsQuery__
 *
 * To run a query within a React component, call `useStripeProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      ids: // value for 'ids'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useStripeProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    StripeProductsQuery,
    StripeProductsQueryVariables
  > &
    (
      | { variables: StripeProductsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StripeProductsQuery, StripeProductsQueryVariables>(
    StripeProductsDocument,
    options
  )
}
export function useStripeProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StripeProductsQuery,
    StripeProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StripeProductsQuery, StripeProductsQueryVariables>(
    StripeProductsDocument,
    options
  )
}
export function useStripeProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeProductsQuery,
        StripeProductsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    StripeProductsQuery,
    StripeProductsQueryVariables
  >(StripeProductsDocument, options)
}
export type StripeProductsQueryHookResult = ReturnType<
  typeof useStripeProductsQuery
>
export type StripeProductsLazyQueryHookResult = ReturnType<
  typeof useStripeProductsLazyQuery
>
export type StripeProductsSuspenseQueryHookResult = ReturnType<
  typeof useStripeProductsSuspenseQuery
>
export type StripeProductsQueryResult = Apollo.QueryResult<
  StripeProductsQuery,
  StripeProductsQueryVariables
>
export const CancelSchoolSubscriptionDocument = gql`
  mutation CancelSchoolSubscription(
    $for_user: Int
    $cancel_immediately: Boolean
  ) {
    cancelSchoolSubscription(
      for_user: $for_user
      cancel_immediately: $cancel_immediately
    ) {
      ...SchoolSubscription
    }
  }
  ${SchoolSubscriptionFragmentDoc}
`
export type CancelSchoolSubscriptionMutationFn = Apollo.MutationFunction<
  CancelSchoolSubscriptionMutation,
  CancelSchoolSubscriptionMutationVariables
>

/**
 * __useCancelSchoolSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSchoolSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSchoolSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSchoolSubscriptionMutation, { data, loading, error }] = useCancelSchoolSubscriptionMutation({
 *   variables: {
 *      for_user: // value for 'for_user'
 *      cancel_immediately: // value for 'cancel_immediately'
 *   },
 * });
 */
export function useCancelSchoolSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelSchoolSubscriptionMutation,
    CancelSchoolSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CancelSchoolSubscriptionMutation,
    CancelSchoolSubscriptionMutationVariables
  >(CancelSchoolSubscriptionDocument, options)
}
export type CancelSchoolSubscriptionMutationHookResult = ReturnType<
  typeof useCancelSchoolSubscriptionMutation
>
export type CancelSchoolSubscriptionMutationResult =
  Apollo.MutationResult<CancelSchoolSubscriptionMutation>
export type CancelSchoolSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    CancelSchoolSubscriptionMutation,
    CancelSchoolSubscriptionMutationVariables
  >
export const FeatureIncludedCountDocument = gql`
  query FeatureIncludedCount {
    account {
      ...FeatureIncludedCount
    }
  }
  ${FeatureIncludedCountFragmentDoc}
`

/**
 * __useFeatureIncludedCountQuery__
 *
 * To run a query within a React component, call `useFeatureIncludedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureIncludedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureIncludedCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureIncludedCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >(FeatureIncludedCountDocument, options)
}
export function useFeatureIncludedCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >(FeatureIncludedCountDocument, options)
}
export function useFeatureIncludedCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeatureIncludedCountQuery,
        FeatureIncludedCountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >(FeatureIncludedCountDocument, options)
}
export type FeatureIncludedCountQueryHookResult = ReturnType<
  typeof useFeatureIncludedCountQuery
>
export type FeatureIncludedCountLazyQueryHookResult = ReturnType<
  typeof useFeatureIncludedCountLazyQuery
>
export type FeatureIncludedCountSuspenseQueryHookResult = ReturnType<
  typeof useFeatureIncludedCountSuspenseQuery
>
export type FeatureIncludedCountQueryResult = Apollo.QueryResult<
  FeatureIncludedCountQuery,
  FeatureIncludedCountQueryVariables
>
export const RedeemSchoolGiftSubscriptionDocument = gql`
  mutation RedeemSchoolGiftSubscription(
    $school_subscription_plan_id: Int!
    $code: String!
  ) {
    redeemSchoolGiftSubscription(
      school_subscription_plan_id: $school_subscription_plan_id
      code: $code
    ) {
      ...SchoolSubscription
    }
  }
  ${SchoolSubscriptionFragmentDoc}
`
export type RedeemSchoolGiftSubscriptionMutationFn = Apollo.MutationFunction<
  RedeemSchoolGiftSubscriptionMutation,
  RedeemSchoolGiftSubscriptionMutationVariables
>

/**
 * __useRedeemSchoolGiftSubscriptionMutation__
 *
 * To run a mutation, you first call `useRedeemSchoolGiftSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemSchoolGiftSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemSchoolGiftSubscriptionMutation, { data, loading, error }] = useRedeemSchoolGiftSubscriptionMutation({
 *   variables: {
 *      school_subscription_plan_id: // value for 'school_subscription_plan_id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRedeemSchoolGiftSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RedeemSchoolGiftSubscriptionMutation,
    RedeemSchoolGiftSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RedeemSchoolGiftSubscriptionMutation,
    RedeemSchoolGiftSubscriptionMutationVariables
  >(RedeemSchoolGiftSubscriptionDocument, options)
}
export type RedeemSchoolGiftSubscriptionMutationHookResult = ReturnType<
  typeof useRedeemSchoolGiftSubscriptionMutation
>
export type RedeemSchoolGiftSubscriptionMutationResult =
  Apollo.MutationResult<RedeemSchoolGiftSubscriptionMutation>
export type RedeemSchoolGiftSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    RedeemSchoolGiftSubscriptionMutation,
    RedeemSchoolGiftSubscriptionMutationVariables
  >
export const SchoolGiftSubscriptionDocument = gql`
  query SchoolGiftSubscription($code: String, $id: Int) {
    school {
      ...School
      gift_subscription(code: $code, id: $id) {
        ...SchoolGiftSubscription
      }
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolGiftSubscriptionFragmentDoc}
`

/**
 * __useSchoolGiftSubscriptionQuery__
 *
 * To run a query within a React component, call `useSchoolGiftSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolGiftSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolGiftSubscriptionQuery({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolGiftSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >(SchoolGiftSubscriptionDocument, options)
}
export function useSchoolGiftSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >(SchoolGiftSubscriptionDocument, options)
}
export function useSchoolGiftSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolGiftSubscriptionQuery,
        SchoolGiftSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >(SchoolGiftSubscriptionDocument, options)
}
export type SchoolGiftSubscriptionQueryHookResult = ReturnType<
  typeof useSchoolGiftSubscriptionQuery
>
export type SchoolGiftSubscriptionLazyQueryHookResult = ReturnType<
  typeof useSchoolGiftSubscriptionLazyQuery
>
export type SchoolGiftSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSchoolGiftSubscriptionSuspenseQuery
>
export type SchoolGiftSubscriptionQueryResult = Apollo.QueryResult<
  SchoolGiftSubscriptionQuery,
  SchoolGiftSubscriptionQueryVariables
>
export const SchoolGroupSubscriptionDocument = gql`
  query SchoolGroupSubscription($id: Int!) {
    schoolGroupSubscription(id: $id) {
      ...SchoolGroupSubscription
    }
  }
  ${SchoolGroupSubscriptionFragmentDoc}
`

/**
 * __useSchoolGroupSubscriptionQuery__
 *
 * To run a query within a React component, call `useSchoolGroupSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolGroupSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolGroupSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolGroupSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  > &
    (
      | { variables: SchoolGroupSubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >(SchoolGroupSubscriptionDocument, options)
}
export function useSchoolGroupSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >(SchoolGroupSubscriptionDocument, options)
}
export function useSchoolGroupSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolGroupSubscriptionQuery,
        SchoolGroupSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >(SchoolGroupSubscriptionDocument, options)
}
export type SchoolGroupSubscriptionQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionQuery
>
export type SchoolGroupSubscriptionLazyQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionLazyQuery
>
export type SchoolGroupSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionSuspenseQuery
>
export type SchoolGroupSubscriptionQueryResult = Apollo.QueryResult<
  SchoolGroupSubscriptionQuery,
  SchoolGroupSubscriptionQueryVariables
>
export const SchoolGroupSubscriptionsDocument = gql`
  query SchoolGroupSubscriptions($first: Int = 10, $licenseOfferingId: Int) {
    schoolGroupSubscriptions(
      first: $first
      license_offering_id: $licenseOfferingId
    ) {
      edges {
        node {
          ...SchoolGroupSubscription
        }
      }
    }
  }
  ${SchoolGroupSubscriptionFragmentDoc}
`

/**
 * __useSchoolGroupSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSchoolGroupSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolGroupSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolGroupSubscriptionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      licenseOfferingId: // value for 'licenseOfferingId'
 *   },
 * });
 */
export function useSchoolGroupSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >(SchoolGroupSubscriptionsDocument, options)
}
export function useSchoolGroupSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >(SchoolGroupSubscriptionsDocument, options)
}
export function useSchoolGroupSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolGroupSubscriptionsQuery,
        SchoolGroupSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >(SchoolGroupSubscriptionsDocument, options)
}
export type SchoolGroupSubscriptionsQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionsQuery
>
export type SchoolGroupSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionsLazyQuery
>
export type SchoolGroupSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionsSuspenseQuery
>
export type SchoolGroupSubscriptionsQueryResult = Apollo.QueryResult<
  SchoolGroupSubscriptionsQuery,
  SchoolGroupSubscriptionsQueryVariables
>
export const SchoolSubscriptionPlansDocument = gql`
  query SchoolSubscriptionPlans(
    $ids: IDFilter
    $visibility_code: String
    $visibility_code_filter: StringFilter
    $ignore_visibility: Boolean
    $giftable: Boolean
    $interval: SubscriptionInterval
    $intervalFilter: SubscriptionIntervalFilter
    $positioningContext: PositioningContextInput
    $orderBy: [SchoolSubscriptionPlanOrderByInput]
  ) {
    school {
      ...School
      subscription_plans(
        first: 50
        ids: $ids
        visibility_code: $visibility_code
        visibility_code_filter: $visibility_code_filter
        ignore_visibility: $ignore_visibility
        giftable: $giftable
        interval: $interval
        interval_filter: $intervalFilter
        positioningContext: $positioningContext
        orderBy: $orderBy
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...PositionedSchoolSubscriptionPlan
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PositionedSchoolSubscriptionPlanFragmentDoc}
`

/**
 * __useSchoolSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSchoolSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolSubscriptionPlansQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      visibility_code: // value for 'visibility_code'
 *      visibility_code_filter: // value for 'visibility_code_filter'
 *      ignore_visibility: // value for 'ignore_visibility'
 *      giftable: // value for 'giftable'
 *      interval: // value for 'interval'
 *      intervalFilter: // value for 'intervalFilter'
 *      positioningContext: // value for 'positioningContext'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSchoolSubscriptionPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >(SchoolSubscriptionPlansDocument, options)
}
export function useSchoolSubscriptionPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >(SchoolSubscriptionPlansDocument, options)
}
export function useSchoolSubscriptionPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolSubscriptionPlansQuery,
        SchoolSubscriptionPlansQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >(SchoolSubscriptionPlansDocument, options)
}
export type SchoolSubscriptionPlansQueryHookResult = ReturnType<
  typeof useSchoolSubscriptionPlansQuery
>
export type SchoolSubscriptionPlansLazyQueryHookResult = ReturnType<
  typeof useSchoolSubscriptionPlansLazyQuery
>
export type SchoolSubscriptionPlansSuspenseQueryHookResult = ReturnType<
  typeof useSchoolSubscriptionPlansSuspenseQuery
>
export type SchoolSubscriptionPlansQueryResult = Apollo.QueryResult<
  SchoolSubscriptionPlansQuery,
  SchoolSubscriptionPlansQueryVariables
>
export const SendGiftSubscriptionEmailDocument = gql`
  mutation SendGiftSubscriptionEmail(
    $gift_id: Int!
    $recipient_email: String!
  ) {
    sendGiftSubscriptionEmail(
      gift_id: $gift_id
      recipient_email: $recipient_email
    )
  }
`
export type SendGiftSubscriptionEmailMutationFn = Apollo.MutationFunction<
  SendGiftSubscriptionEmailMutation,
  SendGiftSubscriptionEmailMutationVariables
>

/**
 * __useSendGiftSubscriptionEmailMutation__
 *
 * To run a mutation, you first call `useSendGiftSubscriptionEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGiftSubscriptionEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGiftSubscriptionEmailMutation, { data, loading, error }] = useSendGiftSubscriptionEmailMutation({
 *   variables: {
 *      gift_id: // value for 'gift_id'
 *      recipient_email: // value for 'recipient_email'
 *   },
 * });
 */
export function useSendGiftSubscriptionEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendGiftSubscriptionEmailMutation,
    SendGiftSubscriptionEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SendGiftSubscriptionEmailMutation,
    SendGiftSubscriptionEmailMutationVariables
  >(SendGiftSubscriptionEmailDocument, options)
}
export type SendGiftSubscriptionEmailMutationHookResult = ReturnType<
  typeof useSendGiftSubscriptionEmailMutation
>
export type SendGiftSubscriptionEmailMutationResult =
  Apollo.MutationResult<SendGiftSubscriptionEmailMutation>
export type SendGiftSubscriptionEmailMutationOptions =
  Apollo.BaseMutationOptions<
    SendGiftSubscriptionEmailMutation,
    SendGiftSubscriptionEmailMutationVariables
  >
export const SubscriptionDiscountDocument = gql`
  query SubscriptionDiscount($discount_code: String!, $school_plan_id: Int!) {
    schoolSubscriptionDiscount(
      discount_code: $discount_code
      school_plan_id: $school_plan_id
    ) {
      discount_percent
      discounted_price
      discounted_subscription_cycles
      currency_display_discount_price
      currency_display_discount_amount
    }
  }
`

/**
 * __useSubscriptionDiscountQuery__
 *
 * To run a query within a React component, call `useSubscriptionDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionDiscountQuery({
 *   variables: {
 *      discount_code: // value for 'discount_code'
 *      school_plan_id: // value for 'school_plan_id'
 *   },
 * });
 */
export function useSubscriptionDiscountQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  > &
    (
      | { variables: SubscriptionDiscountQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >(SubscriptionDiscountDocument, options)
}
export function useSubscriptionDiscountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >(SubscriptionDiscountDocument, options)
}
export function useSubscriptionDiscountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionDiscountQuery,
        SubscriptionDiscountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >(SubscriptionDiscountDocument, options)
}
export type SubscriptionDiscountQueryHookResult = ReturnType<
  typeof useSubscriptionDiscountQuery
>
export type SubscriptionDiscountLazyQueryHookResult = ReturnType<
  typeof useSubscriptionDiscountLazyQuery
>
export type SubscriptionDiscountSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionDiscountSuspenseQuery
>
export type SubscriptionDiscountQueryResult = Apollo.QueryResult<
  SubscriptionDiscountQuery,
  SubscriptionDiscountQueryVariables
>
export const SubscriptionDocument = gql`
  query Subscription($id: Int!) {
    subscription(id: $id) {
      ...Subscription
      payment_intent_client_secret
      stripe_publishable_api_key
    }
  }
  ${SubscriptionFragmentDoc}
`

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubscriptionQuery,
    SubscriptionQueryVariables
  > &
    (
      | { variables: SubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  )
}
export function useSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubscriptionQuery,
    SubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  )
}
export function useSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionQuery,
        SubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  )
}
export type SubscriptionQueryHookResult = ReturnType<
  typeof useSubscriptionQuery
>
export type SubscriptionLazyQueryHookResult = ReturnType<
  typeof useSubscriptionLazyQuery
>
export type SubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionSuspenseQuery
>
export type SubscriptionQueryResult = Apollo.QueryResult<
  SubscriptionQuery,
  SubscriptionQueryVariables
>
export const SubscriptionsDocument = gql`
  query Subscriptions($paymentIntentNeedingActionIdFilter: IDFilter) {
    subscriptions(
      first: 10
      payment_intent_needing_action_id: $paymentIntentNeedingActionIdFilter
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Subscription
        }
      }
    }
  }
  ${SubscriptionFragmentDoc}
`

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      paymentIntentNeedingActionIdFilter: // value for 'paymentIntentNeedingActionIdFilter'
 *   },
 * });
 */
export function useSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(
    SubscriptionsDocument,
    options
  )
}
export function useSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(
    SubscriptionsDocument,
    options
  )
}
export function useSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionsQuery,
        SubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >(SubscriptionsDocument, options)
}
export type SubscriptionsQueryHookResult = ReturnType<
  typeof useSubscriptionsQuery
>
export type SubscriptionsLazyQueryHookResult = ReturnType<
  typeof useSubscriptionsLazyQuery
>
export type SubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionsSuspenseQuery
>
export type SubscriptionsQueryResult = Apollo.QueryResult<
  SubscriptionsQuery,
  SubscriptionsQueryVariables
>
export const CreateTagAttachmentDocument = gql`
  mutation CreateTagAttachment(
    $tagId: Int!
    $context: TagAttachmentContextInput!
    $position: String
  ) {
    createTagAttachment(
      tag_id: $tagId
      context: $context
      position: $position
    ) {
      ...TagAttachment
    }
  }
  ${TagAttachmentFragmentDoc}
`
export type CreateTagAttachmentMutationFn = Apollo.MutationFunction<
  CreateTagAttachmentMutation,
  CreateTagAttachmentMutationVariables
>

/**
 * __useCreateTagAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateTagAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagAttachmentMutation, { data, loading, error }] = useCreateTagAttachmentMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      context: // value for 'context'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useCreateTagAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTagAttachmentMutation,
    CreateTagAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateTagAttachmentMutation,
    CreateTagAttachmentMutationVariables
  >(CreateTagAttachmentDocument, options)
}
export type CreateTagAttachmentMutationHookResult = ReturnType<
  typeof useCreateTagAttachmentMutation
>
export type CreateTagAttachmentMutationResult =
  Apollo.MutationResult<CreateTagAttachmentMutation>
export type CreateTagAttachmentMutationOptions = Apollo.BaseMutationOptions<
  CreateTagAttachmentMutation,
  CreateTagAttachmentMutationVariables
>
export const CreateTagLinkDocument = gql`
  mutation CreateTagLink($tagId: Int!, $context: TagLinkContextInput!) {
    createTagLink(tag_id: $tagId, context: $context) {
      ...TagLink
      tag {
        ...Tag
      }
    }
  }
  ${TagLinkFragmentDoc}
  ${TagFragmentDoc}
`
export type CreateTagLinkMutationFn = Apollo.MutationFunction<
  CreateTagLinkMutation,
  CreateTagLinkMutationVariables
>

/**
 * __useCreateTagLinkMutation__
 *
 * To run a mutation, you first call `useCreateTagLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagLinkMutation, { data, loading, error }] = useCreateTagLinkMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCreateTagLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTagLinkMutation,
    CreateTagLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateTagLinkMutation,
    CreateTagLinkMutationVariables
  >(CreateTagLinkDocument, options)
}
export type CreateTagLinkMutationHookResult = ReturnType<
  typeof useCreateTagLinkMutation
>
export type CreateTagLinkMutationResult =
  Apollo.MutationResult<CreateTagLinkMutation>
export type CreateTagLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateTagLinkMutation,
  CreateTagLinkMutationVariables
>
export const CreateTagDocument = gql`
  mutation CreateTag($tag: TagCreateInput!) {
    createTag(tag: $tag) {
      id
      name
      description
      color
    }
  }
`
export type CreateTagMutationFn = Apollo.MutationFunction<
  CreateTagMutation,
  CreateTagMutationVariables
>

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTagMutation,
    CreateTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(
    CreateTagDocument,
    options
  )
}
export type CreateTagMutationHookResult = ReturnType<
  typeof useCreateTagMutation
>
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<
  CreateTagMutation,
  CreateTagMutationVariables
>
export const DeleteTagAttachmentDocument = gql`
  mutation DeleteTagAttachment(
    $tagId: Int!
    $context: TagAttachmentContextInput!
  ) {
    deleteTagAttachment(tag_id: $tagId, context: $context)
  }
`
export type DeleteTagAttachmentMutationFn = Apollo.MutationFunction<
  DeleteTagAttachmentMutation,
  DeleteTagAttachmentMutationVariables
>

/**
 * __useDeleteTagAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteTagAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagAttachmentMutation, { data, loading, error }] = useDeleteTagAttachmentMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDeleteTagAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTagAttachmentMutation,
    DeleteTagAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTagAttachmentMutation,
    DeleteTagAttachmentMutationVariables
  >(DeleteTagAttachmentDocument, options)
}
export type DeleteTagAttachmentMutationHookResult = ReturnType<
  typeof useDeleteTagAttachmentMutation
>
export type DeleteTagAttachmentMutationResult =
  Apollo.MutationResult<DeleteTagAttachmentMutation>
export type DeleteTagAttachmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteTagAttachmentMutation,
  DeleteTagAttachmentMutationVariables
>
export const DeleteTagLinkDocument = gql`
  mutation DeleteTagLink($tagId: Int!, $context: TagLinkContextInput!) {
    deleteTagLink(tag_id: $tagId, context: $context)
  }
`
export type DeleteTagLinkMutationFn = Apollo.MutationFunction<
  DeleteTagLinkMutation,
  DeleteTagLinkMutationVariables
>

/**
 * __useDeleteTagLinkMutation__
 *
 * To run a mutation, you first call `useDeleteTagLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagLinkMutation, { data, loading, error }] = useDeleteTagLinkMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDeleteTagLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTagLinkMutation,
    DeleteTagLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTagLinkMutation,
    DeleteTagLinkMutationVariables
  >(DeleteTagLinkDocument, options)
}
export type DeleteTagLinkMutationHookResult = ReturnType<
  typeof useDeleteTagLinkMutation
>
export type DeleteTagLinkMutationResult =
  Apollo.MutationResult<DeleteTagLinkMutation>
export type DeleteTagLinkMutationOptions = Apollo.BaseMutationOptions<
  DeleteTagLinkMutation,
  DeleteTagLinkMutationVariables
>
export const DeleteTagDocument = gql`
  mutation DeleteTag($tag: TagDeleteInput!) {
    deleteTag(tag: $tag)
  }
`
export type DeleteTagMutationFn = Apollo.MutationFunction<
  DeleteTagMutation,
  DeleteTagMutationVariables
>

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useDeleteTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTagMutation,
    DeleteTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(
    DeleteTagDocument,
    options
  )
}
export type DeleteTagMutationHookResult = ReturnType<
  typeof useDeleteTagMutation
>
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<
  DeleteTagMutation,
  DeleteTagMutationVariables
>
export const TagsDocument = gql`
  query Tags(
    $context: TagAttachmentContextInput
    $withContextualTagAttachment: Boolean!
  ) {
    tags(first: 1042) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Tag
          tagAttachments(first: 1, context: $context) {
            total
            edges @include(if: $withContextualTagAttachment) {
              node {
                ...TagAttachment
              }
            }
          }
        }
      }
    }
  }
  ${TagFragmentDoc}
  ${TagAttachmentFragmentDoc}
`

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      withContextualTagAttachment: // value for 'withContextualTagAttachment'
 *   },
 * });
 */
export function useTagsQuery(
  baseOptions: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables> &
    ({ variables: TagsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options)
}
export function useTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(
    TagsDocument,
    options
  )
}
export function useTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(
    TagsDocument,
    options
  )
}
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>
export type TagsSuspenseQueryHookResult = ReturnType<
  typeof useTagsSuspenseQuery
>
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>
export const UpdateTagAttachmentDocument = gql`
  mutation UpdateTagAttachment(
    $tagId: Int!
    $context: TagAttachmentContextInput!
    $position: String
  ) {
    updateTagAttachment(
      tag_id: $tagId
      context: $context
      position: $position
    ) {
      ...TagAttachment
    }
  }
  ${TagAttachmentFragmentDoc}
`
export type UpdateTagAttachmentMutationFn = Apollo.MutationFunction<
  UpdateTagAttachmentMutation,
  UpdateTagAttachmentMutationVariables
>

/**
 * __useUpdateTagAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateTagAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagAttachmentMutation, { data, loading, error }] = useUpdateTagAttachmentMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      context: // value for 'context'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useUpdateTagAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTagAttachmentMutation,
    UpdateTagAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTagAttachmentMutation,
    UpdateTagAttachmentMutationVariables
  >(UpdateTagAttachmentDocument, options)
}
export type UpdateTagAttachmentMutationHookResult = ReturnType<
  typeof useUpdateTagAttachmentMutation
>
export type UpdateTagAttachmentMutationResult =
  Apollo.MutationResult<UpdateTagAttachmentMutation>
export type UpdateTagAttachmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateTagAttachmentMutation,
  UpdateTagAttachmentMutationVariables
>
export const UpdateTagDocument = gql`
  mutation UpdateTag($tag: TagUpdateInput!) {
    updateTag(tag: $tag) {
      id
      name
      description
      color
    }
  }
`
export type UpdateTagMutationFn = Apollo.MutationFunction<
  UpdateTagMutation,
  UpdateTagMutationVariables
>

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useUpdateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTagMutation,
    UpdateTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(
    UpdateTagDocument,
    options
  )
}
export type UpdateTagMutationHookResult = ReturnType<
  typeof useUpdateTagMutation
>
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<
  UpdateTagMutation,
  UpdateTagMutationVariables
>
export const HomeCohortMembersDocument = gql`
  query HomeCohortMembers($groupId: Int!) {
    group(id: $groupId) {
      ...HomeCohortMembers
    }
  }
  ${HomeCohortMembersFragmentDoc}
`

/**
 * __useHomeCohortMembersQuery__
 *
 * To run a query within a React component, call `useHomeCohortMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeCohortMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeCohortMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useHomeCohortMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  > &
    (
      | { variables: HomeCohortMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >(HomeCohortMembersDocument, options)
}
export function useHomeCohortMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >(HomeCohortMembersDocument, options)
}
export function useHomeCohortMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeCohortMembersQuery,
        HomeCohortMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >(HomeCohortMembersDocument, options)
}
export type HomeCohortMembersQueryHookResult = ReturnType<
  typeof useHomeCohortMembersQuery
>
export type HomeCohortMembersLazyQueryHookResult = ReturnType<
  typeof useHomeCohortMembersLazyQuery
>
export type HomeCohortMembersSuspenseQueryHookResult = ReturnType<
  typeof useHomeCohortMembersSuspenseQuery
>
export type HomeCohortMembersQueryResult = Apollo.QueryResult<
  HomeCohortMembersQuery,
  HomeCohortMembersQueryVariables
>
export const HomeMentorGroupMembershipsDocument = gql`
  query HomeMentorGroupMemberships(
    $first: Int!
    $role: MentorGroupMembershipRoleFilter
    $mentorGroupSeatLimitFilter: IntFilter
  ) {
    me {
      id
      mentorGroupMemberships(
        first: $first
        role: $role
        mentor_group_seat_limit_filter: $mentorGroupSeatLimitFilter
      ) {
        total
        edges {
          node {
            ...HomeMentorGroupMembership
          }
        }
      }
    }
  }
  ${HomeMentorGroupMembershipFragmentDoc}
`

/**
 * __useHomeMentorGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useHomeMentorGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeMentorGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeMentorGroupMembershipsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      role: // value for 'role'
 *      mentorGroupSeatLimitFilter: // value for 'mentorGroupSeatLimitFilter'
 *   },
 * });
 */
export function useHomeMentorGroupMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeMentorGroupMembershipsQuery,
    HomeMentorGroupMembershipsQueryVariables
  > &
    (
      | { variables: HomeMentorGroupMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeMentorGroupMembershipsQuery,
    HomeMentorGroupMembershipsQueryVariables
  >(HomeMentorGroupMembershipsDocument, options)
}
export function useHomeMentorGroupMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeMentorGroupMembershipsQuery,
    HomeMentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeMentorGroupMembershipsQuery,
    HomeMentorGroupMembershipsQueryVariables
  >(HomeMentorGroupMembershipsDocument, options)
}
export function useHomeMentorGroupMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeMentorGroupMembershipsQuery,
        HomeMentorGroupMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeMentorGroupMembershipsQuery,
    HomeMentorGroupMembershipsQueryVariables
  >(HomeMentorGroupMembershipsDocument, options)
}
export type HomeMentorGroupMembershipsQueryHookResult = ReturnType<
  typeof useHomeMentorGroupMembershipsQuery
>
export type HomeMentorGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useHomeMentorGroupMembershipsLazyQuery
>
export type HomeMentorGroupMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useHomeMentorGroupMembershipsSuspenseQuery
>
export type HomeMentorGroupMembershipsQueryResult = Apollo.QueryResult<
  HomeMentorGroupMembershipsQuery,
  HomeMentorGroupMembershipsQueryVariables
>
export const HomeRegistrationsDocument = gql`
  query HomeRegistrations(
    $first: Int!
    $positioningContext: PositioningContextInput!
    $orderBy: [RegistrationOrderByInput]
    $softArchived: DateFilter
    $progressFilter: ProgressFilter
    $lastSeen: DateFilter
  ) {
    me {
      id
      registrations(
        first: $first
        positioningContext: $positioningContext
        orderBy: $orderBy
        softArchived: $softArchived
        lastSeen: $lastSeen
        progress_filter: $progressFilter
      ) {
        edges {
          node {
            ...HomeRegistration
          }
        }
      }
    }
  }
  ${HomeRegistrationFragmentDoc}
`

/**
 * __useHomeRegistrationsQuery__
 *
 * To run a query within a React component, call `useHomeRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRegistrationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      positioningContext: // value for 'positioningContext'
 *      orderBy: // value for 'orderBy'
 *      softArchived: // value for 'softArchived'
 *      progressFilter: // value for 'progressFilter'
 *      lastSeen: // value for 'lastSeen'
 *   },
 * });
 */
export function useHomeRegistrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  > &
    (
      | { variables: HomeRegistrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >(HomeRegistrationsDocument, options)
}
export function useHomeRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >(HomeRegistrationsDocument, options)
}
export function useHomeRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeRegistrationsQuery,
        HomeRegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >(HomeRegistrationsDocument, options)
}
export type HomeRegistrationsQueryHookResult = ReturnType<
  typeof useHomeRegistrationsQuery
>
export type HomeRegistrationsLazyQueryHookResult = ReturnType<
  typeof useHomeRegistrationsLazyQuery
>
export type HomeRegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useHomeRegistrationsSuspenseQuery
>
export type HomeRegistrationsQueryResult = Apollo.QueryResult<
  HomeRegistrationsQuery,
  HomeRegistrationsQueryVariables
>
export const HomeResourceCopyConfigLinkConnectionsDocument = gql`
  query HomeResourceCopyConfigLinkConnections(
    $first: Int!
    $positioningContext: PositioningContextInput!
    $copiedTimeDateFilter: DateFilter
    $hideFromLocationsFilter: [ResourceCopyConfigLinkLocationFilter]
  ) {
    resourceCopyConfigLinkConnections(
      first: $first
      copiedTimeDateFilter: $copiedTimeDateFilter
      hideFromLocationsFilter: $hideFromLocationsFilter
    ) {
      edges {
        node {
          ...HomeResourceCopyConfigLink
        }
      }
    }
  }
  ${HomeResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useHomeResourceCopyConfigLinkConnectionsQuery__
 *
 * To run a query within a React component, call `useHomeResourceCopyConfigLinkConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeResourceCopyConfigLinkConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeResourceCopyConfigLinkConnectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      positioningContext: // value for 'positioningContext'
 *      copiedTimeDateFilter: // value for 'copiedTimeDateFilter'
 *      hideFromLocationsFilter: // value for 'hideFromLocationsFilter'
 *   },
 * });
 */
export function useHomeResourceCopyConfigLinkConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  > &
    (
      | {
          variables: HomeResourceCopyConfigLinkConnectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >(HomeResourceCopyConfigLinkConnectionsDocument, options)
}
export function useHomeResourceCopyConfigLinkConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >(HomeResourceCopyConfigLinkConnectionsDocument, options)
}
export function useHomeResourceCopyConfigLinkConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeResourceCopyConfigLinkConnectionsQuery,
        HomeResourceCopyConfigLinkConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >(HomeResourceCopyConfigLinkConnectionsDocument, options)
}
export type HomeResourceCopyConfigLinkConnectionsQueryHookResult = ReturnType<
  typeof useHomeResourceCopyConfigLinkConnectionsQuery
>
export type HomeResourceCopyConfigLinkConnectionsLazyQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkConnectionsLazyQuery>
export type HomeResourceCopyConfigLinkConnectionsSuspenseQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkConnectionsSuspenseQuery>
export type HomeResourceCopyConfigLinkConnectionsQueryResult =
  Apollo.QueryResult<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >
export const HomeResourceCopyConfigLinkRegistrationDocument = gql`
  query HomeResourceCopyConfigLinkRegistration(
    $id: Int!
    $positioningContext: PositioningContextInput!
  ) {
    resourceCopyConfigLink(id: $id) {
      ...HomeResourceCopyConfigLink
    }
  }
  ${HomeResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useHomeResourceCopyConfigLinkRegistrationQuery__
 *
 * To run a query within a React component, call `useHomeResourceCopyConfigLinkRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeResourceCopyConfigLinkRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeResourceCopyConfigLinkRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      positioningContext: // value for 'positioningContext'
 *   },
 * });
 */
export function useHomeResourceCopyConfigLinkRegistrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  > &
    (
      | {
          variables: HomeResourceCopyConfigLinkRegistrationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >(HomeResourceCopyConfigLinkRegistrationDocument, options)
}
export function useHomeResourceCopyConfigLinkRegistrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >(HomeResourceCopyConfigLinkRegistrationDocument, options)
}
export function useHomeResourceCopyConfigLinkRegistrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeResourceCopyConfigLinkRegistrationQuery,
        HomeResourceCopyConfigLinkRegistrationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >(HomeResourceCopyConfigLinkRegistrationDocument, options)
}
export type HomeResourceCopyConfigLinkRegistrationQueryHookResult = ReturnType<
  typeof useHomeResourceCopyConfigLinkRegistrationQuery
>
export type HomeResourceCopyConfigLinkRegistrationLazyQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkRegistrationLazyQuery>
export type HomeResourceCopyConfigLinkRegistrationSuspenseQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkRegistrationSuspenseQuery>
export type HomeResourceCopyConfigLinkRegistrationQueryResult =
  Apollo.QueryResult<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >
export const HomeResourceGroupsDocument = gql`
  query HomeResourceGroups($resourceId: Int) {
    resource(id: $resourceId) {
      id
      slug
      groups(first: 50) {
        total
        edges {
          group: node {
            ...HomeGroup
          }
        }
      }
    }
  }
  ${HomeGroupFragmentDoc}
`

/**
 * __useHomeResourceGroupsQuery__
 *
 * To run a query within a React component, call `useHomeResourceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeResourceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeResourceGroupsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useHomeResourceGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >(HomeResourceGroupsDocument, options)
}
export function useHomeResourceGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >(HomeResourceGroupsDocument, options)
}
export function useHomeResourceGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeResourceGroupsQuery,
        HomeResourceGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >(HomeResourceGroupsDocument, options)
}
export type HomeResourceGroupsQueryHookResult = ReturnType<
  typeof useHomeResourceGroupsQuery
>
export type HomeResourceGroupsLazyQueryHookResult = ReturnType<
  typeof useHomeResourceGroupsLazyQuery
>
export type HomeResourceGroupsSuspenseQueryHookResult = ReturnType<
  typeof useHomeResourceGroupsSuspenseQuery
>
export type HomeResourceGroupsQueryResult = Apollo.QueryResult<
  HomeResourceGroupsQuery,
  HomeResourceGroupsQueryVariables
>
export const InboxPendingReviewCountsDocument = gql`
  query InboxPendingReviewCounts(
    $targetIds: IntFilter!
    $targetType: InboxPendingReviewTarget!
  ) {
    inboxPendingReviewConnections(
      first: 1042
      target_ids: $targetIds
      target_type: $targetType
    ) {
      edges {
        node {
          id
          count
        }
      }
    }
  }
`

/**
 * __useInboxPendingReviewCountsQuery__
 *
 * To run a query within a React component, call `useInboxPendingReviewCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPendingReviewCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPendingReviewCountsQuery({
 *   variables: {
 *      targetIds: // value for 'targetIds'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useInboxPendingReviewCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  > &
    (
      | { variables: InboxPendingReviewCountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >(InboxPendingReviewCountsDocument, options)
}
export function useInboxPendingReviewCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >(InboxPendingReviewCountsDocument, options)
}
export function useInboxPendingReviewCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxPendingReviewCountsQuery,
        InboxPendingReviewCountsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >(InboxPendingReviewCountsDocument, options)
}
export type InboxPendingReviewCountsQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountsQuery
>
export type InboxPendingReviewCountsLazyQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountsLazyQuery
>
export type InboxPendingReviewCountsSuspenseQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountsSuspenseQuery
>
export type InboxPendingReviewCountsQueryResult = Apollo.QueryResult<
  InboxPendingReviewCountsQuery,
  InboxPendingReviewCountsQueryVariables
>
export const PathwrightIntercomGuidanceTeamMembersDocument = gql`
  query PathwrightIntercomGuidanceTeamMembers {
    integrations {
      intercom {
        team {
          id
          name
          avatar
        }
      }
    }
  }
`

/**
 * __usePathwrightIntercomGuidanceTeamMembersQuery__
 *
 * To run a query within a React component, call `usePathwrightIntercomGuidanceTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwrightIntercomGuidanceTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwrightIntercomGuidanceTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathwrightIntercomGuidanceTeamMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >(PathwrightIntercomGuidanceTeamMembersDocument, options)
}
export function usePathwrightIntercomGuidanceTeamMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >(PathwrightIntercomGuidanceTeamMembersDocument, options)
}
export function usePathwrightIntercomGuidanceTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathwrightIntercomGuidanceTeamMembersQuery,
        PathwrightIntercomGuidanceTeamMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >(PathwrightIntercomGuidanceTeamMembersDocument, options)
}
export type PathwrightIntercomGuidanceTeamMembersQueryHookResult = ReturnType<
  typeof usePathwrightIntercomGuidanceTeamMembersQuery
>
export type PathwrightIntercomGuidanceTeamMembersLazyQueryHookResult =
  ReturnType<typeof usePathwrightIntercomGuidanceTeamMembersLazyQuery>
export type PathwrightIntercomGuidanceTeamMembersSuspenseQueryHookResult =
  ReturnType<typeof usePathwrightIntercomGuidanceTeamMembersSuspenseQuery>
export type PathwrightIntercomGuidanceTeamMembersQueryResult =
  Apollo.QueryResult<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >
export const SoftArchiveRegistrationDocument = gql`
  mutation SoftArchiveRegistration(
    $id: Int!
    $softArchive: Boolean
    $positioningContext: PositioningContextInput!
  ) {
    softArchiveRegistration(id: $id, softArchive: $softArchive) {
      ...HomeRegistration
    }
  }
  ${HomeRegistrationFragmentDoc}
`
export type SoftArchiveRegistrationMutationFn = Apollo.MutationFunction<
  SoftArchiveRegistrationMutation,
  SoftArchiveRegistrationMutationVariables
>

/**
 * __useSoftArchiveRegistrationMutation__
 *
 * To run a mutation, you first call `useSoftArchiveRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftArchiveRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softArchiveRegistrationMutation, { data, loading, error }] = useSoftArchiveRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      softArchive: // value for 'softArchive'
 *      positioningContext: // value for 'positioningContext'
 *   },
 * });
 */
export function useSoftArchiveRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SoftArchiveRegistrationMutation,
    SoftArchiveRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SoftArchiveRegistrationMutation,
    SoftArchiveRegistrationMutationVariables
  >(SoftArchiveRegistrationDocument, options)
}
export type SoftArchiveRegistrationMutationHookResult = ReturnType<
  typeof useSoftArchiveRegistrationMutation
>
export type SoftArchiveRegistrationMutationResult =
  Apollo.MutationResult<SoftArchiveRegistrationMutation>
export type SoftArchiveRegistrationMutationOptions = Apollo.BaseMutationOptions<
  SoftArchiveRegistrationMutation,
  SoftArchiveRegistrationMutationVariables
>
export const UpdateUserDocument = gql`
  mutation UpdateUser($user: UserInput!, $profile: UserProfileInput!) {
    updateUser(user: $user, profile: $profile) {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  )
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>
export const DeleteUserPreferenceDocument = gql`
  mutation DeleteUserPreference($id: Int!) {
    deleteUserPreference(id: $id)
  }
`
export type DeleteUserPreferenceMutationFn = Apollo.MutationFunction<
  DeleteUserPreferenceMutation,
  DeleteUserPreferenceMutationVariables
>

/**
 * __useDeleteUserPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPreferenceMutation, { data, loading, error }] = useDeleteUserPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserPreferenceMutation,
    DeleteUserPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteUserPreferenceMutation,
    DeleteUserPreferenceMutationVariables
  >(DeleteUserPreferenceDocument, options)
}
export type DeleteUserPreferenceMutationHookResult = ReturnType<
  typeof useDeleteUserPreferenceMutation
>
export type DeleteUserPreferenceMutationResult =
  Apollo.MutationResult<DeleteUserPreferenceMutation>
export type DeleteUserPreferenceMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserPreferenceMutation,
  DeleteUserPreferenceMutationVariables
>
export const UpsertUserPreferenceDocument = gql`
  mutation UpsertUserPreference($key: String!, $scope: String!, $data: JSON!) {
    upsertUserPreference(key: $key, scope: $scope, data: $data) {
      ...UserPreference
    }
  }
  ${UserPreferenceFragmentDoc}
`
export type UpsertUserPreferenceMutationFn = Apollo.MutationFunction<
  UpsertUserPreferenceMutation,
  UpsertUserPreferenceMutationVariables
>

/**
 * __useUpsertUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpsertUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserPreferenceMutation, { data, loading, error }] = useUpsertUserPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      scope: // value for 'scope'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertUserPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertUserPreferenceMutation,
    UpsertUserPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpsertUserPreferenceMutation,
    UpsertUserPreferenceMutationVariables
  >(UpsertUserPreferenceDocument, options)
}
export type UpsertUserPreferenceMutationHookResult = ReturnType<
  typeof useUpsertUserPreferenceMutation
>
export type UpsertUserPreferenceMutationResult =
  Apollo.MutationResult<UpsertUserPreferenceMutation>
export type UpsertUserPreferenceMutationOptions = Apollo.BaseMutationOptions<
  UpsertUserPreferenceMutation,
  UpsertUserPreferenceMutationVariables
>
export const UserPreferenceDocument = gql`
  query UserPreference($key: String!, $scope: String!) {
    userPreference(key: $key, scope: $scope) {
      ...UserPreference
    }
  }
  ${UserPreferenceFragmentDoc}
`

/**
 * __useUserPreferenceQuery__
 *
 * To run a query within a React component, call `useUserPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPreferenceQuery({
 *   variables: {
 *      key: // value for 'key'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useUserPreferenceQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserPreferenceQuery,
    UserPreferenceQueryVariables
  > &
    (
      | { variables: UserPreferenceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserPreferenceQuery, UserPreferenceQueryVariables>(
    UserPreferenceDocument,
    options
  )
}
export function useUserPreferenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserPreferenceQuery,
    UserPreferenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserPreferenceQuery, UserPreferenceQueryVariables>(
    UserPreferenceDocument,
    options
  )
}
export function useUserPreferenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserPreferenceQuery,
        UserPreferenceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserPreferenceQuery,
    UserPreferenceQueryVariables
  >(UserPreferenceDocument, options)
}
export type UserPreferenceQueryHookResult = ReturnType<
  typeof useUserPreferenceQuery
>
export type UserPreferenceLazyQueryHookResult = ReturnType<
  typeof useUserPreferenceLazyQuery
>
export type UserPreferenceSuspenseQueryHookResult = ReturnType<
  typeof useUserPreferenceSuspenseQuery
>
export type UserPreferenceQueryResult = Apollo.QueryResult<
  UserPreferenceQuery,
  UserPreferenceQueryVariables
>
export const UserMentorGroupMembershipsDocument = gql`
  query UserMentorGroupMemberships(
    $role: MentorGroupMembershipRoleFilter
    $mentorGroupSeatLimit: Int
    $mentorGroupSeatLimitFilter: IntFilter
    $mentorGroupSeatsFilled: Int
    $mentorGroupSeatsFilledFilter: IntFilter
    $include_group: Boolean!
    $or: MentorGroupMembershipOr
  ) {
    me {
      id
      mentorGroupMemberships(
        first: 50
        role: $role
        mentor_group_seat_limit: $mentorGroupSeatLimit
        mentor_group_seat_limit_filter: $mentorGroupSeatLimitFilter
        mentor_group_seats_filled: $mentorGroupSeatsFilled
        mentor_group_seats_filled_filter: $mentorGroupSeatsFilledFilter
        _or: $or
      ) {
        edges {
          node {
            id
            role
            created
            group_id
            group @include(if: $include_group) {
              ...MentorGroup
              memberships(first: 5) {
                total
                edges {
                  node {
                    id
                    user {
                      ...User
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useUserMentorGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useUserMentorGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMentorGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMentorGroupMembershipsQuery({
 *   variables: {
 *      role: // value for 'role'
 *      mentorGroupSeatLimit: // value for 'mentorGroupSeatLimit'
 *      mentorGroupSeatLimitFilter: // value for 'mentorGroupSeatLimitFilter'
 *      mentorGroupSeatsFilled: // value for 'mentorGroupSeatsFilled'
 *      mentorGroupSeatsFilledFilter: // value for 'mentorGroupSeatsFilledFilter'
 *      include_group: // value for 'include_group'
 *      or: // value for 'or'
 *   },
 * });
 */
export function useUserMentorGroupMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  > &
    (
      | { variables: UserMentorGroupMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >(UserMentorGroupMembershipsDocument, options)
}
export function useUserMentorGroupMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >(UserMentorGroupMembershipsDocument, options)
}
export function useUserMentorGroupMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserMentorGroupMembershipsQuery,
        UserMentorGroupMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >(UserMentorGroupMembershipsDocument, options)
}
export type UserMentorGroupMembershipsQueryHookResult = ReturnType<
  typeof useUserMentorGroupMembershipsQuery
>
export type UserMentorGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useUserMentorGroupMembershipsLazyQuery
>
export type UserMentorGroupMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useUserMentorGroupMembershipsSuspenseQuery
>
export type UserMentorGroupMembershipsQueryResult = Apollo.QueryResult<
  UserMentorGroupMembershipsQuery,
  UserMentorGroupMembershipsQueryVariables
>
export const UserMentorGroupSubscriptionsDocument = gql`
  query UserMentorGroupSubscriptions {
    me {
      id
      mentorGroupMemberships(first: 50, group_type: group_subscription) {
        edges {
          node {
            ...UserMentorGroupSubscriptionMembership
          }
        }
      }
    }
  }
  ${UserMentorGroupSubscriptionMembershipFragmentDoc}
`

/**
 * __useUserMentorGroupSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserMentorGroupSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMentorGroupSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMentorGroupSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMentorGroupSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >(UserMentorGroupSubscriptionsDocument, options)
}
export function useUserMentorGroupSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >(UserMentorGroupSubscriptionsDocument, options)
}
export function useUserMentorGroupSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserMentorGroupSubscriptionsQuery,
        UserMentorGroupSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >(UserMentorGroupSubscriptionsDocument, options)
}
export type UserMentorGroupSubscriptionsQueryHookResult = ReturnType<
  typeof useUserMentorGroupSubscriptionsQuery
>
export type UserMentorGroupSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useUserMentorGroupSubscriptionsLazyQuery
>
export type UserMentorGroupSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useUserMentorGroupSubscriptionsSuspenseQuery
>
export type UserMentorGroupSubscriptionsQueryResult = Apollo.QueryResult<
  UserMentorGroupSubscriptionsQuery,
  UserMentorGroupSubscriptionsQueryVariables
>
export const UserPaymentHistoryDocument = gql`
  query UserPaymentHistory {
    me {
      id
      payment_history {
        download_url
        payments {
          item
          total
          currency_display
          date
          is_failed
        }
      }
    }
  }
`

/**
 * __useUserPaymentHistoryQuery__
 *
 * To run a query within a React component, call `useUserPaymentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPaymentHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >(UserPaymentHistoryDocument, options)
}
export function useUserPaymentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >(UserPaymentHistoryDocument, options)
}
export function useUserPaymentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserPaymentHistoryQuery,
        UserPaymentHistoryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >(UserPaymentHistoryDocument, options)
}
export type UserPaymentHistoryQueryHookResult = ReturnType<
  typeof useUserPaymentHistoryQuery
>
export type UserPaymentHistoryLazyQueryHookResult = ReturnType<
  typeof useUserPaymentHistoryLazyQuery
>
export type UserPaymentHistorySuspenseQueryHookResult = ReturnType<
  typeof useUserPaymentHistorySuspenseQuery
>
export type UserPaymentHistoryQueryResult = Apollo.QueryResult<
  UserPaymentHistoryQuery,
  UserPaymentHistoryQueryVariables
>
export const UserQueryDocument = gql`
  query UserQuery($id: Int!) {
    user(id: $id) {
      ...User
    }
  }
  ${UserFragmentDoc}
`

/**
 * __useUserQueryQuery__
 *
 * To run a query within a React component, call `useUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserQueryQuery,
    UserQueryQueryVariables
  > &
    ({ variables: UserQueryQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserQueryQuery, UserQueryQueryVariables>(
    UserQueryDocument,
    options
  )
}
export function useUserQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserQueryQuery,
    UserQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserQueryQuery, UserQueryQueryVariables>(
    UserQueryDocument,
    options
  )
}
export function useUserQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserQueryQuery, UserQueryQueryVariables>(
    UserQueryDocument,
    options
  )
}
export type UserQueryQueryHookResult = ReturnType<typeof useUserQueryQuery>
export type UserQueryLazyQueryHookResult = ReturnType<
  typeof useUserQueryLazyQuery
>
export type UserQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserQuerySuspenseQuery
>
export type UserQueryQueryResult = Apollo.QueryResult<
  UserQueryQuery,
  UserQueryQueryVariables
>
export const UserSchoolSubscriptionDocument = gql`
  query UserSchoolSubscription {
    me {
      id
      school_subscription {
        ...SchoolSubscription
      }
    }
  }
  ${SchoolSubscriptionFragmentDoc}
`

/**
 * __useUserSchoolSubscriptionQuery__
 *
 * To run a query within a React component, call `useUserSchoolSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSchoolSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSchoolSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSchoolSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserSchoolSubscriptionQuery,
    UserSchoolSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserSchoolSubscriptionQuery,
    UserSchoolSubscriptionQueryVariables
  >(UserSchoolSubscriptionDocument, options)
}
export function useUserSchoolSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSchoolSubscriptionQuery,
    UserSchoolSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserSchoolSubscriptionQuery,
    UserSchoolSubscriptionQueryVariables
  >(UserSchoolSubscriptionDocument, options)
}
export function useUserSchoolSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSchoolSubscriptionQuery,
        UserSchoolSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserSchoolSubscriptionQuery,
    UserSchoolSubscriptionQueryVariables
  >(UserSchoolSubscriptionDocument, options)
}
export type UserSchoolSubscriptionQueryHookResult = ReturnType<
  typeof useUserSchoolSubscriptionQuery
>
export type UserSchoolSubscriptionLazyQueryHookResult = ReturnType<
  typeof useUserSchoolSubscriptionLazyQuery
>
export type UserSchoolSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useUserSchoolSubscriptionSuspenseQuery
>
export type UserSchoolSubscriptionQueryResult = Apollo.QueryResult<
  UserSchoolSubscriptionQuery,
  UserSchoolSubscriptionQueryVariables
>
export const SandboxCanvasUserDocument = gql`
  query SandboxCanvasUser($id: Int!) {
    user(id: $id) {
      ...User
    }
  }
  ${UserFragmentDoc}
`

/**
 * __useSandboxCanvasUserQuery__
 *
 * To run a query within a React component, call `useSandboxCanvasUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxCanvasUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxCanvasUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSandboxCanvasUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    SandboxCanvasUserQuery,
    SandboxCanvasUserQueryVariables
  > &
    (
      | { variables: SandboxCanvasUserQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SandboxCanvasUserQuery,
    SandboxCanvasUserQueryVariables
  >(SandboxCanvasUserDocument, options)
}
export function useSandboxCanvasUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SandboxCanvasUserQuery,
    SandboxCanvasUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SandboxCanvasUserQuery,
    SandboxCanvasUserQueryVariables
  >(SandboxCanvasUserDocument, options)
}
export function useSandboxCanvasUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SandboxCanvasUserQuery,
        SandboxCanvasUserQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SandboxCanvasUserQuery,
    SandboxCanvasUserQueryVariables
  >(SandboxCanvasUserDocument, options)
}
export type SandboxCanvasUserQueryHookResult = ReturnType<
  typeof useSandboxCanvasUserQuery
>
export type SandboxCanvasUserLazyQueryHookResult = ReturnType<
  typeof useSandboxCanvasUserLazyQuery
>
export type SandboxCanvasUserSuspenseQueryHookResult = ReturnType<
  typeof useSandboxCanvasUserSuspenseQuery
>
export type SandboxCanvasUserQueryResult = Apollo.QueryResult<
  SandboxCanvasUserQuery,
  SandboxCanvasUserQueryVariables
>
export const SandboxSchoolMembersDocument = gql`
  query SandboxSchoolMembers(
    $search: String!
    $cursor: String
    $global: Boolean
    $roleFilter: [MembershipRoleFilter]
  ) {
    school {
      id
      members(
        first: 25
        after: $cursor
        search: $search
        global: $global
        role_filter: $roleFilter
        hasAccess: true
        orderBy: "last_active"
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            role
            last_active
            school {
              id
              name
            }
            user {
              ...User
            }
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
`

/**
 * __useSandboxSchoolMembersQuery__
 *
 * To run a query within a React component, call `useSandboxSchoolMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxSchoolMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxSchoolMembersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      global: // value for 'global'
 *      roleFilter: // value for 'roleFilter'
 *   },
 * });
 */
export function useSandboxSchoolMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    SandboxSchoolMembersQuery,
    SandboxSchoolMembersQueryVariables
  > &
    (
      | { variables: SandboxSchoolMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SandboxSchoolMembersQuery,
    SandboxSchoolMembersQueryVariables
  >(SandboxSchoolMembersDocument, options)
}
export function useSandboxSchoolMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SandboxSchoolMembersQuery,
    SandboxSchoolMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SandboxSchoolMembersQuery,
    SandboxSchoolMembersQueryVariables
  >(SandboxSchoolMembersDocument, options)
}
export function useSandboxSchoolMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SandboxSchoolMembersQuery,
        SandboxSchoolMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SandboxSchoolMembersQuery,
    SandboxSchoolMembersQueryVariables
  >(SandboxSchoolMembersDocument, options)
}
export type SandboxSchoolMembersQueryHookResult = ReturnType<
  typeof useSandboxSchoolMembersQuery
>
export type SandboxSchoolMembersLazyQueryHookResult = ReturnType<
  typeof useSandboxSchoolMembersLazyQuery
>
export type SandboxSchoolMembersSuspenseQueryHookResult = ReturnType<
  typeof useSandboxSchoolMembersSuspenseQuery
>
export type SandboxSchoolMembersQueryResult = Apollo.QueryResult<
  SandboxSchoolMembersQuery,
  SandboxSchoolMembersQueryVariables
>
export const SandboxLegacyPresetsDocument = gql`
  query SandboxLegacyPresets {
    components: userPreferences(key: "sandbox:components") {
      id
      scope
      data
      created
      modified
    }
    blocks: userPreferences(key: "sandbox:blocks") {
      id
      scope
      data
      created
      modified
    }
  }
`

/**
 * __useSandboxLegacyPresetsQuery__
 *
 * To run a query within a React component, call `useSandboxLegacyPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxLegacyPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxLegacyPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSandboxLegacyPresetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SandboxLegacyPresetsQuery,
    SandboxLegacyPresetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SandboxLegacyPresetsQuery,
    SandboxLegacyPresetsQueryVariables
  >(SandboxLegacyPresetsDocument, options)
}
export function useSandboxLegacyPresetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SandboxLegacyPresetsQuery,
    SandboxLegacyPresetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SandboxLegacyPresetsQuery,
    SandboxLegacyPresetsQueryVariables
  >(SandboxLegacyPresetsDocument, options)
}
export function useSandboxLegacyPresetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SandboxLegacyPresetsQuery,
        SandboxLegacyPresetsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SandboxLegacyPresetsQuery,
    SandboxLegacyPresetsQueryVariables
  >(SandboxLegacyPresetsDocument, options)
}
export type SandboxLegacyPresetsQueryHookResult = ReturnType<
  typeof useSandboxLegacyPresetsQuery
>
export type SandboxLegacyPresetsLazyQueryHookResult = ReturnType<
  typeof useSandboxLegacyPresetsLazyQuery
>
export type SandboxLegacyPresetsSuspenseQueryHookResult = ReturnType<
  typeof useSandboxLegacyPresetsSuspenseQuery
>
export type SandboxLegacyPresetsQueryResult = Apollo.QueryResult<
  SandboxLegacyPresetsQuery,
  SandboxLegacyPresetsQueryVariables
>
export const SandboxSchoolsDocument = gql`
  query SandboxSchools($search: String!, $after: String) {
    admin(first: 25, after: $after, search: $search, is_activated: true) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          image
          image_is_default
          theme {
            id
            primary_color
          }
        }
      }
    }
  }
`

/**
 * __useSandboxSchoolsQuery__
 *
 * To run a query within a React component, call `useSandboxSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxSchoolsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSandboxSchoolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SandboxSchoolsQuery,
    SandboxSchoolsQueryVariables
  > &
    (
      | { variables: SandboxSchoolsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SandboxSchoolsQuery, SandboxSchoolsQueryVariables>(
    SandboxSchoolsDocument,
    options
  )
}
export function useSandboxSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SandboxSchoolsQuery,
    SandboxSchoolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SandboxSchoolsQuery, SandboxSchoolsQueryVariables>(
    SandboxSchoolsDocument,
    options
  )
}
export function useSandboxSchoolsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SandboxSchoolsQuery,
        SandboxSchoolsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SandboxSchoolsQuery,
    SandboxSchoolsQueryVariables
  >(SandboxSchoolsDocument, options)
}
export type SandboxSchoolsQueryHookResult = ReturnType<
  typeof useSandboxSchoolsQuery
>
export type SandboxSchoolsLazyQueryHookResult = ReturnType<
  typeof useSandboxSchoolsLazyQuery
>
export type SandboxSchoolsSuspenseQueryHookResult = ReturnType<
  typeof useSandboxSchoolsSuspenseQuery
>
export type SandboxSchoolsQueryResult = Apollo.QueryResult<
  SandboxSchoolsQuery,
  SandboxSchoolsQueryVariables
>
export const SchoolContextDocument = gql`
  query SchoolContext {
    school {
      id
      url
    }
  }
`

/**
 * __useSchoolContextQuery__
 *
 * To run a query within a React component, call `useSchoolContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolContextQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolContextQuery,
    SchoolContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchoolContextQuery, SchoolContextQueryVariables>(
    SchoolContextDocument,
    options
  )
}
export function useSchoolContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolContextQuery,
    SchoolContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SchoolContextQuery, SchoolContextQueryVariables>(
    SchoolContextDocument,
    options
  )
}
export function useSchoolContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolContextQuery,
        SchoolContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolContextQuery,
    SchoolContextQueryVariables
  >(SchoolContextDocument, options)
}
export type SchoolContextQueryHookResult = ReturnType<
  typeof useSchoolContextQuery
>
export type SchoolContextLazyQueryHookResult = ReturnType<
  typeof useSchoolContextLazyQuery
>
export type SchoolContextSuspenseQueryHookResult = ReturnType<
  typeof useSchoolContextSuspenseQuery
>
export type SchoolContextQueryResult = Apollo.QueryResult<
  SchoolContextQuery,
  SchoolContextQueryVariables
>
export const UserGroupSubscriptionsQueryDocument = gql`
  query UserGroupSubscriptionsQuery($userId: Int!) {
    schoolGroupSubscriptions(first: 10, user_id: $userId) {
      edges {
        node {
          ...SchoolGroupSubscription
          community_group {
            ...MentorGroup
            user_membership {
              id
              access_revoked_time
            }
          }
        }
      }
    }
  }
  ${SchoolGroupSubscriptionFragmentDoc}
  ${MentorGroupFragmentDoc}
`

/**
 * __useUserGroupSubscriptionsQueryQuery__
 *
 * To run a query within a React component, call `useUserGroupSubscriptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupSubscriptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupSubscriptionsQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserGroupSubscriptionsQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserGroupSubscriptionsQueryQuery,
    UserGroupSubscriptionsQueryQueryVariables
  > &
    (
      | { variables: UserGroupSubscriptionsQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserGroupSubscriptionsQueryQuery,
    UserGroupSubscriptionsQueryQueryVariables
  >(UserGroupSubscriptionsQueryDocument, options)
}
export function useUserGroupSubscriptionsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserGroupSubscriptionsQueryQuery,
    UserGroupSubscriptionsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserGroupSubscriptionsQueryQuery,
    UserGroupSubscriptionsQueryQueryVariables
  >(UserGroupSubscriptionsQueryDocument, options)
}
export function useUserGroupSubscriptionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserGroupSubscriptionsQueryQuery,
        UserGroupSubscriptionsQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserGroupSubscriptionsQueryQuery,
    UserGroupSubscriptionsQueryQueryVariables
  >(UserGroupSubscriptionsQueryDocument, options)
}
export type UserGroupSubscriptionsQueryQueryHookResult = ReturnType<
  typeof useUserGroupSubscriptionsQueryQuery
>
export type UserGroupSubscriptionsQueryLazyQueryHookResult = ReturnType<
  typeof useUserGroupSubscriptionsQueryLazyQuery
>
export type UserGroupSubscriptionsQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserGroupSubscriptionsQuerySuspenseQuery
>
export type UserGroupSubscriptionsQueryQueryResult = Apollo.QueryResult<
  UserGroupSubscriptionsQueryQuery,
  UserGroupSubscriptionsQueryQueryVariables
>
export const SourePathDocument = gql`
  query SourePath($id: Int!) {
    path(id: $id) {
      id
      publish {
        ...PathPublish
      }
      cohort {
        id
        resource {
          id
          name
          slug
          source_cohort: group(type: curriculum) {
            id
          }
        }
      }
    }
  }
  ${PathPublishFragmentDoc}
`

/**
 * __useSourePathQuery__
 *
 * To run a query within a React component, call `useSourePathQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourePathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourePathQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSourePathQuery(
  baseOptions: Apollo.QueryHookOptions<
    SourePathQuery,
    SourePathQueryVariables
  > &
    ({ variables: SourePathQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SourePathQuery, SourePathQueryVariables>(
    SourePathDocument,
    options
  )
}
export function useSourePathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SourePathQuery,
    SourePathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SourePathQuery, SourePathQueryVariables>(
    SourePathDocument,
    options
  )
}
export function useSourePathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SourePathQuery, SourePathQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SourePathQuery, SourePathQueryVariables>(
    SourePathDocument,
    options
  )
}
export type SourePathQueryHookResult = ReturnType<typeof useSourePathQuery>
export type SourePathLazyQueryHookResult = ReturnType<
  typeof useSourePathLazyQuery
>
export type SourePathSuspenseQueryHookResult = ReturnType<
  typeof useSourePathSuspenseQuery
>
export type SourePathQueryResult = Apollo.QueryResult<
  SourePathQuery,
  SourePathQueryVariables
>
export const AuthContextDocument = gql`
  query AuthContext($inviteToken: String) {
    space {
      id
      consent_description
      allow_signup(invite_token: $inviteToken)
      always_prompt_for_password
      authMethods {
        ...AuthMethod
      }
    }
  }
  ${AuthMethodFragmentDoc}
`

/**
 * __useAuthContextQuery__
 *
 * To run a query within a React component, call `useAuthContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthContextQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useAuthContextQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthContextQuery,
    AuthContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthContextQuery, AuthContextQueryVariables>(
    AuthContextDocument,
    options
  )
}
export function useAuthContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthContextQuery,
    AuthContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AuthContextQuery, AuthContextQueryVariables>(
    AuthContextDocument,
    options
  )
}
export function useAuthContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuthContextQuery,
        AuthContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AuthContextQuery, AuthContextQueryVariables>(
    AuthContextDocument,
    options
  )
}
export type AuthContextQueryHookResult = ReturnType<typeof useAuthContextQuery>
export type AuthContextLazyQueryHookResult = ReturnType<
  typeof useAuthContextLazyQuery
>
export type AuthContextSuspenseQueryHookResult = ReturnType<
  typeof useAuthContextSuspenseQuery
>
export type AuthContextQueryResult = Apollo.QueryResult<
  AuthContextQuery,
  AuthContextQueryVariables
>
export const AuthMethodsDocument = gql`
  query AuthMethods {
    space {
      id
      authMethods {
        ...AuthMethod
      }
    }
  }
  ${AuthMethodFragmentDoc}
`

/**
 * __useAuthMethodsQuery__
 *
 * To run a query within a React component, call `useAuthMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthMethodsQuery,
    AuthMethodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthMethodsQuery, AuthMethodsQueryVariables>(
    AuthMethodsDocument,
    options
  )
}
export function useAuthMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthMethodsQuery,
    AuthMethodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AuthMethodsQuery, AuthMethodsQueryVariables>(
    AuthMethodsDocument,
    options
  )
}
export function useAuthMethodsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuthMethodsQuery,
        AuthMethodsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AuthMethodsQuery, AuthMethodsQueryVariables>(
    AuthMethodsDocument,
    options
  )
}
export type AuthMethodsQueryHookResult = ReturnType<typeof useAuthMethodsQuery>
export type AuthMethodsLazyQueryHookResult = ReturnType<
  typeof useAuthMethodsLazyQuery
>
export type AuthMethodsSuspenseQueryHookResult = ReturnType<
  typeof useAuthMethodsSuspenseQuery
>
export type AuthMethodsQueryResult = Apollo.QueryResult<
  AuthMethodsQuery,
  AuthMethodsQueryVariables
>
export const MeDocument = gql`
  query Me {
    me {
      ...CurrentUser
    }
  }
  ${CurrentUserFragmentDoc}
`

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(
  baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export function useMeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>
export const StartAuthRequestDocument = gql`
  mutation StartAuthRequest(
    $method: AuthRequestMethod!
    $email: EmailAddress
    $username: String
    $nextUrl: String
  ) {
    startAuthRequest(
      method: $method
      email: $email
      username: $username
      next_url: $nextUrl
    ) {
      ...AuthRequest
    }
  }
  ${AuthRequestFragmentDoc}
`
export type StartAuthRequestMutationFn = Apollo.MutationFunction<
  StartAuthRequestMutation,
  StartAuthRequestMutationVariables
>

/**
 * __useStartAuthRequestMutation__
 *
 * To run a mutation, you first call `useStartAuthRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAuthRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAuthRequestMutation, { data, loading, error }] = useStartAuthRequestMutation({
 *   variables: {
 *      method: // value for 'method'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      nextUrl: // value for 'nextUrl'
 *   },
 * });
 */
export function useStartAuthRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartAuthRequestMutation,
    StartAuthRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StartAuthRequestMutation,
    StartAuthRequestMutationVariables
  >(StartAuthRequestDocument, options)
}
export type StartAuthRequestMutationHookResult = ReturnType<
  typeof useStartAuthRequestMutation
>
export type StartAuthRequestMutationResult =
  Apollo.MutationResult<StartAuthRequestMutation>
export type StartAuthRequestMutationOptions = Apollo.BaseMutationOptions<
  StartAuthRequestMutation,
  StartAuthRequestMutationVariables
>
export const AuthRequestDocument = gql`
  query AuthRequest($uuid: String!) {
    authRequest(uuid: $uuid) {
      ...AuthRequest
    }
  }
  ${AuthRequestFragmentDoc}
`

/**
 * __useAuthRequestQuery__
 *
 * To run a query within a React component, call `useAuthRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthRequestQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAuthRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    AuthRequestQuery,
    AuthRequestQueryVariables
  > &
    (
      | { variables: AuthRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthRequestQuery, AuthRequestQueryVariables>(
    AuthRequestDocument,
    options
  )
}
export function useAuthRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthRequestQuery,
    AuthRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AuthRequestQuery, AuthRequestQueryVariables>(
    AuthRequestDocument,
    options
  )
}
export function useAuthRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuthRequestQuery,
        AuthRequestQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AuthRequestQuery, AuthRequestQueryVariables>(
    AuthRequestDocument,
    options
  )
}
export type AuthRequestQueryHookResult = ReturnType<typeof useAuthRequestQuery>
export type AuthRequestLazyQueryHookResult = ReturnType<
  typeof useAuthRequestLazyQuery
>
export type AuthRequestSuspenseQueryHookResult = ReturnType<
  typeof useAuthRequestSuspenseQuery
>
export type AuthRequestQueryResult = Apollo.QueryResult<
  AuthRequestQuery,
  AuthRequestQueryVariables
>
export const AuthRequestTokenDocument = gql`
  query AuthRequestToken($uuid: String!) {
    authRequestToken(uuid: $uuid)
  }
`

/**
 * __useAuthRequestTokenQuery__
 *
 * To run a query within a React component, call `useAuthRequestTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthRequestTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthRequestTokenQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAuthRequestTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    AuthRequestTokenQuery,
    AuthRequestTokenQueryVariables
  > &
    (
      | { variables: AuthRequestTokenQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthRequestTokenQuery, AuthRequestTokenQueryVariables>(
    AuthRequestTokenDocument,
    options
  )
}
export function useAuthRequestTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthRequestTokenQuery,
    AuthRequestTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AuthRequestTokenQuery,
    AuthRequestTokenQueryVariables
  >(AuthRequestTokenDocument, options)
}
export function useAuthRequestTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuthRequestTokenQuery,
        AuthRequestTokenQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AuthRequestTokenQuery,
    AuthRequestTokenQueryVariables
  >(AuthRequestTokenDocument, options)
}
export type AuthRequestTokenQueryHookResult = ReturnType<
  typeof useAuthRequestTokenQuery
>
export type AuthRequestTokenLazyQueryHookResult = ReturnType<
  typeof useAuthRequestTokenLazyQuery
>
export type AuthRequestTokenSuspenseQueryHookResult = ReturnType<
  typeof useAuthRequestTokenSuspenseQuery
>
export type AuthRequestTokenQueryResult = Apollo.QueryResult<
  AuthRequestTokenQuery,
  AuthRequestTokenQueryVariables
>
export const ConfirmAuthRequestDocument = gql`
  mutation ConfirmAuthRequest($uuid: UUID!, $key: String!) {
    confirmAuthRequest(uuid: $uuid, key: $key) {
      ...AuthRequest
    }
  }
  ${AuthRequestFragmentDoc}
`
export type ConfirmAuthRequestMutationFn = Apollo.MutationFunction<
  ConfirmAuthRequestMutation,
  ConfirmAuthRequestMutationVariables
>

/**
 * __useConfirmAuthRequestMutation__
 *
 * To run a mutation, you first call `useConfirmAuthRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAuthRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAuthRequestMutation, { data, loading, error }] = useConfirmAuthRequestMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useConfirmAuthRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmAuthRequestMutation,
    ConfirmAuthRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ConfirmAuthRequestMutation,
    ConfirmAuthRequestMutationVariables
  >(ConfirmAuthRequestDocument, options)
}
export type ConfirmAuthRequestMutationHookResult = ReturnType<
  typeof useConfirmAuthRequestMutation
>
export type ConfirmAuthRequestMutationResult =
  Apollo.MutationResult<ConfirmAuthRequestMutation>
export type ConfirmAuthRequestMutationOptions = Apollo.BaseMutationOptions<
  ConfirmAuthRequestMutation,
  ConfirmAuthRequestMutationVariables
>
export const FinalizeExternalAccountLinkDocument = gql`
  mutation FinalizeExternalAccountLink($token: String!) {
    finalizeExternalAccountLink(token: $token) {
      id
    }
  }
`
export type FinalizeExternalAccountLinkMutationFn = Apollo.MutationFunction<
  FinalizeExternalAccountLinkMutation,
  FinalizeExternalAccountLinkMutationVariables
>

/**
 * __useFinalizeExternalAccountLinkMutation__
 *
 * To run a mutation, you first call `useFinalizeExternalAccountLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeExternalAccountLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeExternalAccountLinkMutation, { data, loading, error }] = useFinalizeExternalAccountLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFinalizeExternalAccountLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinalizeExternalAccountLinkMutation,
    FinalizeExternalAccountLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FinalizeExternalAccountLinkMutation,
    FinalizeExternalAccountLinkMutationVariables
  >(FinalizeExternalAccountLinkDocument, options)
}
export type FinalizeExternalAccountLinkMutationHookResult = ReturnType<
  typeof useFinalizeExternalAccountLinkMutation
>
export type FinalizeExternalAccountLinkMutationResult =
  Apollo.MutationResult<FinalizeExternalAccountLinkMutation>
export type FinalizeExternalAccountLinkMutationOptions =
  Apollo.BaseMutationOptions<
    FinalizeExternalAccountLinkMutation,
    FinalizeExternalAccountLinkMutationVariables
  >
export const JoinSpaceDocument = gql`
  mutation JoinSpace($consent: Boolean!, $inviteToken: String) {
    joinSpace(consent: $consent, invite_token: $inviteToken) {
      ...UserMembership
      consent_snapshot
      consent_dtime
    }
  }
  ${UserMembershipFragmentDoc}
`
export type JoinSpaceMutationFn = Apollo.MutationFunction<
  JoinSpaceMutation,
  JoinSpaceMutationVariables
>

/**
 * __useJoinSpaceMutation__
 *
 * To run a mutation, you first call `useJoinSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinSpaceMutation, { data, loading, error }] = useJoinSpaceMutation({
 *   variables: {
 *      consent: // value for 'consent'
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useJoinSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinSpaceMutation,
    JoinSpaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<JoinSpaceMutation, JoinSpaceMutationVariables>(
    JoinSpaceDocument,
    options
  )
}
export type JoinSpaceMutationHookResult = ReturnType<
  typeof useJoinSpaceMutation
>
export type JoinSpaceMutationResult = Apollo.MutationResult<JoinSpaceMutation>
export type JoinSpaceMutationOptions = Apollo.BaseMutationOptions<
  JoinSpaceMutation,
  JoinSpaceMutationVariables
>
export const ChangePasswordDocument = gql`
  mutation ChangePassword(
    $currentPassword: String!
    $password1: String!
    $password2: String!
  ) {
    changePassword(
      current_password: $currentPassword
      password1: $password1
      password2: $password2
    )
  }
`
export type ChangePasswordMutationFn = Apollo.MutationFunction<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >(ChangePasswordDocument, options)
}
export type ChangePasswordMutationHookResult = ReturnType<
  typeof useChangePasswordMutation
>
export type ChangePasswordMutationResult =
  Apollo.MutationResult<ChangePasswordMutation>
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>
export const CreatePasswordDocument = gql`
  mutation CreatePassword($password1: String!, $password2: String!) {
    createPassword(password1: $password1, password2: $password2)
  }
`
export type CreatePasswordMutationFn = Apollo.MutationFunction<
  CreatePasswordMutation,
  CreatePasswordMutationVariables
>

/**
 * __useCreatePasswordMutation__
 *
 * To run a mutation, you first call `useCreatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPasswordMutation, { data, loading, error }] = useCreatePasswordMutation({
 *   variables: {
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *   },
 * });
 */
export function useCreatePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePasswordMutation,
    CreatePasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreatePasswordMutation,
    CreatePasswordMutationVariables
  >(CreatePasswordDocument, options)
}
export type CreatePasswordMutationHookResult = ReturnType<
  typeof useCreatePasswordMutation
>
export type CreatePasswordMutationResult =
  Apollo.MutationResult<CreatePasswordMutation>
export type CreatePasswordMutationOptions = Apollo.BaseMutationOptions<
  CreatePasswordMutation,
  CreatePasswordMutationVariables
>
export const PassordResetConfirmDocument = gql`
  mutation PassordResetConfirm(
    $resetHash: String!
    $password1: String!
    $password2: String!
  ) {
    resetPassword(
      reset_hash: $resetHash
      password1: $password1
      password2: $password2
    )
  }
`
export type PassordResetConfirmMutationFn = Apollo.MutationFunction<
  PassordResetConfirmMutation,
  PassordResetConfirmMutationVariables
>

/**
 * __usePassordResetConfirmMutation__
 *
 * To run a mutation, you first call `usePassordResetConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassordResetConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passordResetConfirmMutation, { data, loading, error }] = usePassordResetConfirmMutation({
 *   variables: {
 *      resetHash: // value for 'resetHash'
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *   },
 * });
 */
export function usePassordResetConfirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PassordResetConfirmMutation,
    PassordResetConfirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PassordResetConfirmMutation,
    PassordResetConfirmMutationVariables
  >(PassordResetConfirmDocument, options)
}
export type PassordResetConfirmMutationHookResult = ReturnType<
  typeof usePassordResetConfirmMutation
>
export type PassordResetConfirmMutationResult =
  Apollo.MutationResult<PassordResetConfirmMutation>
export type PassordResetConfirmMutationOptions = Apollo.BaseMutationOptions<
  PassordResetConfirmMutation,
  PassordResetConfirmMutationVariables
>
export const StartPasswordRetrievalDocument = gql`
  mutation StartPasswordRetrieval($email: String!, $nextUrl: String) {
    startPasswordRetrieval(email: $email, next_url: $nextUrl)
  }
`
export type StartPasswordRetrievalMutationFn = Apollo.MutationFunction<
  StartPasswordRetrievalMutation,
  StartPasswordRetrievalMutationVariables
>

/**
 * __useStartPasswordRetrievalMutation__
 *
 * To run a mutation, you first call `useStartPasswordRetrievalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPasswordRetrievalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPasswordRetrievalMutation, { data, loading, error }] = useStartPasswordRetrievalMutation({
 *   variables: {
 *      email: // value for 'email'
 *      nextUrl: // value for 'nextUrl'
 *   },
 * });
 */
export function useStartPasswordRetrievalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartPasswordRetrievalMutation,
    StartPasswordRetrievalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StartPasswordRetrievalMutation,
    StartPasswordRetrievalMutationVariables
  >(StartPasswordRetrievalDocument, options)
}
export type StartPasswordRetrievalMutationHookResult = ReturnType<
  typeof useStartPasswordRetrievalMutation
>
export type StartPasswordRetrievalMutationResult =
  Apollo.MutationResult<StartPasswordRetrievalMutation>
export type StartPasswordRetrievalMutationOptions = Apollo.BaseMutationOptions<
  StartPasswordRetrievalMutation,
  StartPasswordRetrievalMutationVariables
>
export const UserStatusDocument = gql`
  query UserStatus($input: String) {
    userStatus(input: $input) {
      ...UserStatus
    }
  }
  ${UserStatusFragmentDoc}
`

/**
 * __useUserStatusQuery__
 *
 * To run a query within a React component, call `useUserStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserStatusQuery,
    UserStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserStatusQuery, UserStatusQueryVariables>(
    UserStatusDocument,
    options
  )
}
export function useUserStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserStatusQuery,
    UserStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserStatusQuery, UserStatusQueryVariables>(
    UserStatusDocument,
    options
  )
}
export function useUserStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserStatusQuery, UserStatusQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserStatusQuery, UserStatusQueryVariables>(
    UserStatusDocument,
    options
  )
}
export type UserStatusQueryHookResult = ReturnType<typeof useUserStatusQuery>
export type UserStatusLazyQueryHookResult = ReturnType<
  typeof useUserStatusLazyQuery
>
export type UserStatusSuspenseQueryHookResult = ReturnType<
  typeof useUserStatusSuspenseQuery
>
export type UserStatusQueryResult = Apollo.QueryResult<
  UserStatusQuery,
  UserStatusQueryVariables
>
export const SignInPasswordDocument = gql`
  mutation SignInPassword($email: String!, $password: String!) {
    getToken(username: $email, password: $password) {
      token
      user_id
      created
    }
  }
`
export type SignInPasswordMutationFn = Apollo.MutationFunction<
  SignInPasswordMutation,
  SignInPasswordMutationVariables
>

/**
 * __useSignInPasswordMutation__
 *
 * To run a mutation, you first call `useSignInPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInPasswordMutation, { data, loading, error }] = useSignInPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignInPasswordMutation,
    SignInPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SignInPasswordMutation,
    SignInPasswordMutationVariables
  >(SignInPasswordDocument, options)
}
export type SignInPasswordMutationHookResult = ReturnType<
  typeof useSignInPasswordMutation
>
export type SignInPasswordMutationResult =
  Apollo.MutationResult<SignInPasswordMutation>
export type SignInPasswordMutationOptions = Apollo.BaseMutationOptions<
  SignInPasswordMutation,
  SignInPasswordMutationVariables
>
export const SignOutDocument = gql`
  mutation SignOut {
    signOut
  }
`
export type SignOutMutationFn = Apollo.MutationFunction<
  SignOutMutation,
  SignOutMutationVariables
>

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignOutMutation,
    SignOutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(
    SignOutDocument,
    options
  )
}
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>
export type SignOutMutationOptions = Apollo.BaseMutationOptions<
  SignOutMutation,
  SignOutMutationVariables
>
export const SignUpDocument = gql`
  mutation SignUp(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String
    $consent: Boolean
    $inviteToken: String
    $createMembership: Boolean
  ) {
    signUp(
      first_name: $firstName
      last_name: $lastName
      email: $email
      password: $password
      consent: $consent
      invite_token: $inviteToken
      create_membership: $createMembership
    ) {
      token
      user_id
      created
    }
  }
`
export type SignUpMutationFn = Apollo.MutationFunction<
  SignUpMutation,
  SignUpMutationVariables
>

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      consent: // value for 'consent'
 *      inviteToken: // value for 'inviteToken'
 *      createMembership: // value for 'createMembership'
 *   },
 * });
 */
export function useSignUpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignUpMutation,
    SignUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(
    SignUpDocument,
    options
  )
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>
export type SignUpMutationOptions = Apollo.BaseMutationOptions<
  SignUpMutation,
  SignUpMutationVariables
>
export const TermsAgreementDocument = gql`
  query TermsAgreement {
    school {
      page(page_type: 5, is_live: true) {
        id
        name
        slug
        external_url
      }
    }
  }
`

/**
 * __useTermsAgreementQuery__
 *
 * To run a query within a React component, call `useTermsAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsAgreementQuery({
 *   variables: {
 *   },
 * });
 */
export function useTermsAgreementQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TermsAgreementQuery,
    TermsAgreementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TermsAgreementQuery, TermsAgreementQueryVariables>(
    TermsAgreementDocument,
    options
  )
}
export function useTermsAgreementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TermsAgreementQuery,
    TermsAgreementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TermsAgreementQuery, TermsAgreementQueryVariables>(
    TermsAgreementDocument,
    options
  )
}
export function useTermsAgreementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TermsAgreementQuery,
        TermsAgreementQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    TermsAgreementQuery,
    TermsAgreementQueryVariables
  >(TermsAgreementDocument, options)
}
export type TermsAgreementQueryHookResult = ReturnType<
  typeof useTermsAgreementQuery
>
export type TermsAgreementLazyQueryHookResult = ReturnType<
  typeof useTermsAgreementLazyQuery
>
export type TermsAgreementSuspenseQueryHookResult = ReturnType<
  typeof useTermsAgreementSuspenseQuery
>
export type TermsAgreementQueryResult = Apollo.QueryResult<
  TermsAgreementQuery,
  TermsAgreementQueryVariables
>
export const SpaceContextQueryDocument = gql`
  query SpaceContextQuery {
    user: me {
      ...CurrentUser
    }
    space {
      ...Space
    }
  }
  ${CurrentUserFragmentDoc}
  ${SpaceFragmentDoc}
`

/**
 * __useSpaceContextQueryQuery__
 *
 * To run a query within a React component, call `useSpaceContextQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceContextQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceContextQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpaceContextQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SpaceContextQueryQuery,
    SpaceContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SpaceContextQueryQuery,
    SpaceContextQueryQueryVariables
  >(SpaceContextQueryDocument, options)
}
export function useSpaceContextQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceContextQueryQuery,
    SpaceContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SpaceContextQueryQuery,
    SpaceContextQueryQueryVariables
  >(SpaceContextQueryDocument, options)
}
export function useSpaceContextQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceContextQueryQuery,
        SpaceContextQueryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SpaceContextQueryQuery,
    SpaceContextQueryQueryVariables
  >(SpaceContextQueryDocument, options)
}
export type SpaceContextQueryQueryHookResult = ReturnType<
  typeof useSpaceContextQueryQuery
>
export type SpaceContextQueryLazyQueryHookResult = ReturnType<
  typeof useSpaceContextQueryLazyQuery
>
export type SpaceContextQuerySuspenseQueryHookResult = ReturnType<
  typeof useSpaceContextQuerySuspenseQuery
>
export type SpaceContextQueryQueryResult = Apollo.QueryResult<
  SpaceContextQueryQuery,
  SpaceContextQueryQueryVariables
>
